import { jsx as b, jsxs as Z, Fragment as bn } from "react/jsx-runtime";
import uS, { useContext as we, useReducer as P0, useEffect as ye, createContext as Le, useCallback as pt, useRef as Se, useSyncExternalStore as is, forwardRef as se, useState as ue, useLayoutEffect as $t, useMemo as Gt, isValidElement as dS, cloneElement as hS, createElement as ku, memo as fS, version as pS, useId as E0, Fragment as nr, useInsertionEffect as T0, Component as mS } from "react";
import { createPortal as C0 } from "react-dom";
function Vt(t) {
  return typeof t == "string" ? t : t.text;
}
const A0 = "airplay.", gS = {
  key: `${A0}start`,
  text: "Start AirPlay"
}, vS = {
  key: `${A0}stop`,
  text: "Stop AirPlay"
}, lh = "cast.", yS = {
  key: `${lh}start`,
  text: "Start casting"
}, bS = {
  key: `${lh}stop`,
  text: "Stop casting"
}, $0 = {
  key: `${lh}connecting`,
  text: "Connecting"
};
function R0(t) {
  return typeof t == "string";
}
function Vn(t) {
  return typeof t == "number";
}
function ke(t) {
  return typeof t == "function";
}
function Fi(t) {
  return t === null;
}
function Ce(t) {
  return typeof t > "u";
}
function ch(t) {
  return t == null;
}
function M0(t) {
  return t instanceof Promise;
}
function Je(t) {
  return t !== null && typeof t == "object";
}
function _S(t) {
  if (!Je(t)) return !1;
  const e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
function Lt(t, e) {
  return ke(t) ? t(e) || void 0 : t || void 0;
}
function wS(t) {
  if ("any" in AbortSignal) return AbortSignal.any(t);
  const e = new AbortController();
  for (const n of t) {
    if (n.aborted)
      return e.abort(n.reason), e.signal;
    n.addEventListener("abort", () => e.abort(n.reason), { signal: e.signal });
  }
  return e.signal;
}
var O0 = class {
  #e;
  #t = /* @__PURE__ */ new Map();
  /** The attach-scoped signal. Aborts on detach or reattach. */
  get base() {
    return (this.#e ??= new AbortController()).signal;
  }
  /** Clears all keyed signals, leaving base intact. */
  clear() {
    for (const t of this.#t.values()) t.abort();
    this.#t.clear();
  }
  /** Resets base and clears all keyed signals. */
  reset() {
    this.clear(), this.#e?.abort(), this.#e = void 0;
  }
  /** Creates a new signal for the key, superseding any previous signal. */
  supersede(t) {
    this.#t.get(t)?.abort();
    const e = new AbortController();
    return this.#t.set(t, e), wS([this.base, e.signal]);
  }
};
function kS(...t) {
  const e = t.map((n) => n.derived ?? {});
  return {
    state: (n) => {
      const i = t.map((r) => r.state(n));
      return Object.assign({}, ...i);
    },
    preserve: Array.from(new Set(t.flatMap((n) => n.preserve ?? []))),
    derived: Object.assign({}, ...e),
    attach: (n) => {
      for (const i of t) try {
        i.attach?.(n);
      } catch (r) {
        n.reportError(r);
      }
    }
  };
}
var I0 = class extends Error {
  code;
  cause;
  constructor(t, e) {
    super(e?.message ?? t), this.name = "StoreError", this.code = t, this.cause = e?.cause;
  }
};
function pa() {
  throw new I0("NO_TARGET");
}
function Qf() {
  throw new I0("DESTROYED");
}
function nt(t, e) {
  const n = { ...e };
  for (const i of Object.keys(e)) {
    const r = t[i];
    Ce(r) || (n[i] = r);
  }
  return n;
}
function D0(t, e) {
  const n = {};
  for (const i of e) Object.hasOwn(t, i) && (n[i] = t[i]);
  return n;
}
const xS = Object.prototype.hasOwnProperty;
function F0(t, e) {
  if (Object.is(t, e)) return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null) return !1;
  const n = Reflect.ownKeys(t), i = Reflect.ownKeys(e);
  if (n.length !== i.length) return !1;
  for (const r of n) if (!xS.call(e, r) || !Object.is(t[r], e[r])) return !1;
  return !0;
}
const SS = {
  target: pa,
  signals: new O0(),
  get: pa,
  set: pa
};
function bt(t) {
  const e = t.state(SS), n = [...Object.keys(e), ...Object.keys(t.derived ?? {})], i = n[0];
  return i ? Object.assign((r) => {
    if (i in r)
      return D0(r, n);
  }, { displayName: t.name }) : Object.assign(() => {
  }, { displayName: t.name });
}
function pn(...t) {
}
function L0(t) {
  return t;
}
function PS(t, e, n) {
  let i = null, r, s = !1;
  function o() {
    i = setTimeout(() => {
      i = null, s && (s = !1, t(...r), o());
    }, e);
  }
  const a = (...l) => {
    r = l, i === null ? (t(...r), o()) : s = !0;
  };
  return a.cancel = () => {
    i !== null && (clearTimeout(i), i = null), s = !1;
  }, a;
}
let xu = !1;
function ES() {
  xu || (xu = !0, queueMicrotask(TS));
}
const Su = /* @__PURE__ */ new Set();
function TS() {
  xu = !1;
  for (const t of Su) t.flush();
  Su.clear();
}
const CS = Object.prototype.hasOwnProperty;
var AS = class {
  #e;
  #t = /* @__PURE__ */ new Set();
  #i = !1;
  constructor(t) {
    this.#e = Object.freeze({ ...t });
  }
  get current() {
    return this.#e;
  }
  patch(t) {
    const e = { ...this.#e };
    let n = !1;
    for (const i of Reflect.ownKeys(t)) {
      if (!CS.call(t, i)) continue;
      const r = t[i];
      Object.is(this.#e[i], r) || (e[i] = r, n = !0);
    }
    n && (this.#e = Object.freeze(e), this.#n());
  }
  replace(t) {
    F0(this.#e, t) || (this.#e = Object.freeze({ ...t }), this.#n());
  }
  subscribe(t, e) {
    const n = e?.signal;
    if (n?.aborted) return pn;
    if (this.#t.add(t), !n) return () => this.#t.delete(t);
    const i = () => this.#t.delete(t);
    return n.addEventListener("abort", i, { once: !0 }), () => {
      n.removeEventListener("abort", i), this.#t.delete(t);
    };
  }
  flush() {
    if (this.#i) {
      this.#i = !1;
      for (const t of this.#t) t();
    }
  }
  #n() {
    this.#i = !0, Su.add(this), ES();
  }
};
function at(t) {
  return new AS(t);
}
const $S = /* @__PURE__ */ Symbol.for("@videojs/store"), RS = Object.prototype.hasOwnProperty;
function MS() {
  return ((t, e = {}) => {
    let n = null, i = !1;
    const r = new AbortController(), s = new O0(), o = /* @__PURE__ */ new WeakMap(), a = /* @__PURE__ */ new WeakSet();
    let l, c;
    function u() {
      i && Qf(), n || pa();
    }
    const d = OS(t.state({
      target: () => (u(), n),
      signals: s,
      get: () => l,
      set: (E) => m(E)
    }));
    l = d;
    const h = p(l);
    c = at(v(l, h));
    const f = {
      [$S]: !0,
      get $state() {
        return c;
      },
      get target() {
        return n;
      },
      get destroyed() {
        return i;
      },
      get state() {
        return c.current;
      },
      attach: y,
      destroy: _,
      subscribe: w
    };
    for (const E of Object.keys(c.current)) Object.defineProperty(f, E, {
      get: () => c.current[E],
      enumerable: !0
    });
    for (const E of Object.getOwnPropertySymbols(l))
      typeof l[E] == "function" && Object.defineProperty(f, E, { get: () => l[E] });
    try {
      e.onSetup?.({
        store: f,
        signal: r.signal
      });
    } catch (E) {
      T(E);
    }
    return f;
    function p(E) {
      const S = {}, P = t.derived;
      if (!P) return S;
      const C = { get: () => E };
      for (const M of Object.keys(P)) S[M] = P[M](C);
      return S;
    }
    function v(E, S) {
      const P = {};
      for (const C of Object.keys(E)) P[C] = E[C];
      Object.assign(P, S);
      for (const C of Object.keys(P)) {
        const M = P[C];
        ke(M) && (P[C] = g(M));
      }
      return P;
    }
    function g(E) {
      const S = o.get(E);
      if (S) return S;
      const P = function(...C) {
        try {
          const M = E.apply(this, C);
          return e.onError && M0(M) && M.catch(T), M;
        } catch (M) {
          throw e.onError && T(M), M;
        }
      };
      return o.set(E, P), P;
    }
    function m(E) {
      const S = IS(l, E);
      if (!S) return;
      const P = p(S.next);
      l = S.next, c.replace(v(l, P));
    }
    function y(E) {
      i && Qf(), s.reset(), n = E;
      const S = {
        target: E,
        signal: s.base,
        get: () => l,
        set: (P) => {
          try {
            m(P);
          } catch (C) {
            T(C);
          }
        },
        reportError: T,
        store: {
          get state() {
            return c.current;
          },
          subscribe: w
        }
      };
      try {
        t.attach?.(S);
      } catch (P) {
        T(P);
      }
      try {
        e.onAttach?.({
          store: f,
          target: E,
          signal: s.base
        });
      } catch (P) {
        T(P);
      }
      return k;
    }
    function k() {
      if (Fi(n)) return;
      s.reset(), n = null;
      const E = { ...d };
      for (const S of t.preserve ?? []) E[S] = l[S];
      m(E);
    }
    function _() {
      i || (i = !0, k(), r.abort());
    }
    function w(E, S) {
      return c.subscribe(E, S);
    }
    function T(E) {
      if (Je(E)) {
        if (a.has(E)) return;
        a.add(E);
      }
      e.onError ? e.onError({
        store: f,
        error: E
      }) : console.error("[vjs-store]", E);
    }
  });
}
function OS(t) {
  return Object.freeze({ ...t });
}
function IS(t, e) {
  const n = { ...t };
  let i = !1;
  for (const r of Reflect.ownKeys(e)) {
    if (!RS.call(e, r)) continue;
    const s = e[r];
    Object.is(t[r], s) || (n[r] = s, i = !0);
  }
  return i ? { next: Object.freeze(n) } : null;
}
function DS(t, e) {
  return [...e].map((n) => ({
    name: n,
    value: t.getAttribute(n)
  }));
}
function oc(t, e) {
  for (const { name: n, value: i } of e) i === null ? t.removeAttribute(n) : t.setAttribute(n, i);
}
function FS(t, e) {
  const n = [];
  for (let i = 0; i < t.children.length; i++) {
    const r = t.children.item(i);
    r && e(r, i) && n.push(r);
  }
  return n;
}
function Q(t, e, n, i) {
  return t.addEventListener(e, n, i), () => t.removeEventListener(e, n, i);
}
function LS(t) {
  const e = t.closest("[dir]")?.getAttribute("dir")?.toLowerCase();
  return e === "rtl" || e === "ltr" ? e === "rtl" : getComputedStyle(t).direction === "rtl";
}
function uh(t) {
  const e = t.composedPath();
  return e.length > 0 ? e[0] : t.target;
}
function ep(t, e, n) {
  return new Promise((i, r) => {
    const s = () => {
      r(n?.signal?.reason ?? "Aborted");
    };
    if (n?.signal?.aborted) {
      s();
      return;
    }
    n?.signal?.addEventListener("abort", s, { once: !0 }), t.addEventListener(e, (o) => {
      n?.signal?.removeEventListener("abort", s), i(o);
    }, {
      ...n,
      once: !0
    });
  });
}
function tp(t) {
  return t instanceof Node && t.nodeType === 9;
}
function N0(t) {
  return t instanceof Node && t.nodeType === 11 && "host" in t;
}
function dh(t, e, n = {}) {
  if (!t || typeof document > "u") return;
  let i = t;
  for (; i; ) {
    const r = e(i);
    if (!Ce(r)) return r;
    i = n.composed ? NS(i) : i.parentElement;
  }
}
function NS(t) {
  if (t.assignedSlot) return t.assignedSlot;
  if (t.parentElement) return t.parentElement;
  const e = t.getRootNode();
  return N0(e) ? e.host : null;
}
const VS = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "audio[controls]",
  "video[controls]",
  "iframe",
  '[contenteditable]:not([contenteditable="false"])',
  '[tabindex]:not([tabindex="-1"])'
].join(",");
function si(t = document) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement; ) e = e.shadowRoot.activeElement;
  return e;
}
function ac(t) {
  const e = [], n = /* @__PURE__ */ new Set();
  return i(t), e;
  function i(s) {
    for (const o of s.children) r(o);
  }
  function r(s) {
    if (!n.has(s)) {
      if (n.add(s), s instanceof HTMLElement && jS(s) && e.push(s), s instanceof HTMLSlotElement) {
        const o = s.assignedElements({ flatten: !0 });
        if (o.length > 0) for (const a of o) r(a);
        else i(s);
        return;
      }
      s.shadowRoot ? i(s.shadowRoot) : i(s);
    }
  }
}
function jS(t) {
  return !t.matches(VS) || t.tabIndex < 0 || t.matches(":disabled") ? !1 : !dh(t, (e) => {
    if (e instanceof HTMLElement && (e.hidden || e.hasAttribute("inert") || e.getAttribute("aria-hidden") === "true")) return !0;
  }, { composed: !0 });
}
function Pu() {
  return typeof CSS < "u" && CSS.supports("anchor-name: --a");
}
function zS() {
  return typeof HTMLElement < "u" && "popover" in HTMLElement.prototype;
}
const BS = [
  "button",
  "input",
  "select",
  "textarea",
  "a[href]",
  '[role="button"]',
  '[role="menu"]',
  '[role="menuitem"]',
  '[role="menuitemcheckbox"]',
  '[role="menuitemradio"]',
  '[role="slider"]',
  "[data-interactive]"
].join(","), HS = [
  "textarea",
  "select",
  "input:not([type])",
  ...[
    "text",
    "search",
    "url",
    "tel",
    "email",
    "password",
    "number"
  ].map((t) => `input[type="${t}"]`),
  '[contenteditable]:not([contenteditable="false"])'
].join(",");
function US(t) {
  return t.matches(HS);
}
function WS(t) {
  const e = uh(t);
  return e instanceof Element && US(e);
}
function ip(t) {
  const e = uh(t);
  return e instanceof Element ? e.closest(BS) !== null : !1;
}
const qS = /* @__PURE__ */ new Set([" ", "Enter"]), GS = 'button,a[href],[role="slider"],[role="button"]';
function hh(t) {
  if (!qS.has(t.key)) return !1;
  const e = uh(t);
  return e instanceof Element && e.matches(GS);
}
function Eu(t) {
  return t.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
function fh(t) {
  return t.startsWith("--") ? t : Eu(t);
}
function np(t) {
  const e = t.style.getPropertyValue("anchor-name").trim();
  return !e || e === "none" ? [] : e.split(",").map((n) => n.trim()).filter(Boolean);
}
function za(t, e) {
  for (const [n, i] of Object.entries(e)) typeof i == "string" && t.style.setProperty(fh(n), i);
}
function V0(t, e) {
  return [...e].map((n) => {
    const i = fh(n);
    return {
      property: i,
      value: t.style.getPropertyValue(i),
      priority: t.style.getPropertyPriority(i)
    };
  });
}
function j0(t, e) {
  for (const { property: n, value: i, priority: r } of e) i ? t.style.setProperty(n, i, r) : t.style.removeProperty(n);
}
function KS(t, e, n) {
  const i = V0(t, Object.keys(e));
  try {
    return za(t, e), n();
  } finally {
    j0(t, i);
  }
}
function YS(t, e, { source: n = "inline-or-computed" } = {}) {
  const i = fh(e);
  let r = n !== "computed" && t instanceof HTMLElement ? t.style.getPropertyValue(i) : "";
  return !r && n !== "inline" && (r = getComputedStyle(t).getPropertyValue(i)), r.trim() ? ma(t, r) : null;
}
function ma(t, e) {
  const n = e.trim();
  if (!n) return 0;
  const i = Number.parseFloat(n);
  if (!Number.isNaN(i) && (/^-?\d*\.?\d+$/.test(n) || n.endsWith("px"))) return i;
  const r = t.ownerDocument, s = r?.documentElement;
  if (!Number.isNaN(i) && n.endsWith("rem")) return i * (s && Number.parseFloat(getComputedStyle(s).fontSize) || 16);
  if (!Number.isNaN(i) && n.endsWith("em")) return i * (t instanceof HTMLElement && Number.parseFloat(getComputedStyle(t).fontSize) || 16);
  if (!r) return Number.isNaN(i) ? 0 : i;
  const o = r.createElement("div");
  if (o.style.position = "absolute", o.style.visibility = "hidden", o.style.pointerEvents = "none", o.style.inlineSize = n, !o.style.inlineSize) return 0;
  o.style.blockSize = "0", o.style.padding = "0", o.style.border = "0", o.style.inset = "0";
  const a = getComputedStyle(t);
  o.style.fontSize = a.fontSize;
  for (let u = 0; u < a.length; u++) {
    const d = a.item(u);
    d.startsWith("--") && o.style.setProperty(d, a.getPropertyValue(d));
  }
  const l = r.body ?? r.documentElement;
  if (!l) return Number.isNaN(i) ? 0 : i;
  if (l.appendChild(o), getComputedStyle(o).inlineSize === "auto")
    return o.remove(), 0;
  const c = o.getBoundingClientRect().width;
  return o.remove(), Number.isFinite(c) ? c : Number.isNaN(i) ? 0 : i;
}
function z0(t, { box: e = "bounding", overflow: n = "none" } = {}) {
  const i = t.getBoundingClientRect();
  let r = e === "layout" && t.offsetWidth || i.width, s = e === "layout" && t.offsetHeight || i.height;
  return (n === "width" || n === "both") && (r = Math.max(r, t.scrollWidth)), (n === "height" || n === "both") && (s = Math.max(s, t.scrollHeight)), {
    width: r,
    height: s
  };
}
function B0(t, e) {
  const n = t.getBoundingClientRect();
  return n.width > 0 && n.height > 0 && e.clientX >= n.left && e.clientX < n.right && e.clientY >= n.top && e.clientY < n.bottom;
}
function Tu(t, e = {}) {
  const { styles: n, ...i } = e, r = () => z0(t, i);
  return n ? KS(t, n, r) : r();
}
function H0(t) {
  const e = getComputedStyle(t);
  return {
    inlineStart: Number.parseFloat(e.paddingInlineStart) || 0,
    inlineEnd: Number.parseFloat(e.paddingInlineEnd) || 0,
    blockStart: Number.parseFloat(e.paddingBlockStart) || 0,
    blockEnd: Number.parseFloat(e.paddingBlockEnd) || 0
  };
}
function U0(t) {
  return t.inlineStart + t.inlineEnd;
}
function W0(t) {
  return t.blockStart + t.blockEnd;
}
function XS(t) {
  const e = getComputedStyle(t);
  return {
    x: Number.parseFloat(e.paddingLeft) || 0,
    y: Number.parseFloat(e.paddingTop) || 0
  };
}
function JS(t) {
  if (t.length === 0) return {
    width: 0,
    height: 0
  };
  const e = Math.max(...t.map(({ offsetLeft: i, size: r }) => i + r.width)), n = t[0].offsetTop;
  return {
    width: e,
    height: t.some(({ offsetTop: i }) => i !== n) ? Math.max(...t.map(({ offsetTop: i, size: r }) => i + r.height)) : t.reduce((i, { size: r }) => i + r.height, 0)
  };
}
function ZS(t, { children: e, includePadding: n = !1, maxWidth: i = null, measure: r = (o, a) => Tu(o, a === void 0 ? void 0 : { styles: { width: `${a}px` } }), resolveSize: s = JS } = {}) {
  const o = [...e ?? Array.from(t.children).filter((v) => v instanceof HTMLElement)].filter((v) => !v.hidden), a = n ? H0(t) : {
    inlineStart: 0,
    inlineEnd: 0,
    blockStart: 0,
    blockEnd: 0
  }, l = U0(a), c = W0(a), u = n ? XS(t) : {
    x: 0,
    y: 0
  };
  if (o.length === 0) return {
    width: l,
    height: c
  };
  const d = (v) => o.map((g) => ({
    element: g,
    size: r(g, v),
    offsetLeft: g.offsetLeft - u.x,
    offsetTop: g.offsetTop - u.y
  }));
  let h = d();
  const f = s(h).width + l, p = i === null ? f : Math.min(f, Math.max(0, i));
  return p < f && (h = d(Math.max(0, p - l))), {
    width: p,
    height: s(h).height + c
  };
}
const QS = /* @__PURE__ */ new Set([
  "Adlm",
  "Arab",
  "Hebr",
  "Mand",
  "Mend",
  "Nkoo",
  "Rohg",
  "Samr",
  "Syrc",
  "Thaa",
  "Yezi"
]);
function eP(t) {
  try {
    const e = new Intl.Locale(t).maximize().script;
    return e && QS.has(e) ? "rtl" : "ltr";
  } catch {
    return "ltr";
  }
}
const zi = "en";
function q0(t) {
  const e = Array.isArray(t) ? t[0] : t;
  return e ? e === "en" || e.startsWith("en-") : !0;
}
function fo(t, e) {
  if (typeof ResizeObserver > "u") return pn;
  const n = new ResizeObserver(e), i = Symbol.iterator in Object(t) ? t : [t];
  for (const r of i) n.observe(r);
  return () => n.disconnect();
}
function tP({ getElements: t, onChange: e, root: n, mutations: i }) {
  let r = pn;
  const s = () => {
    r(), r = fo(t(), e);
  };
  s();
  let o = null;
  return n && i !== !1 && typeof MutationObserver < "u" && (o = new MutationObserver(() => {
    s(), e();
  }), o.observe(n, i ?? { childList: !0 })), () => {
    o?.disconnect(), r();
  };
}
function iP() {
  return typeof navigator < "u" && /mac/i.test(navigator.userAgent);
}
const nP = {
  sideOffset: 0,
  boundaryOffset: 0
}, rP = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function rp(t, e, n, i) {
  const r = i.boundaryOffset ?? 0;
  switch (n) {
    case "top":
      return t.top - e.top - r - i.sideOffset;
    case "bottom":
      return e.bottom - t.bottom - r - i.sideOffset;
    case "left":
      return t.left - e.left - r - i.sideOffset;
    case "right":
      return e.right - t.right - r - i.sideOffset;
  }
}
function sP(t, e, n, i, r = nP) {
  const s = i.side, o = rP[s], a = s === "top" || s === "bottom" ? e.height : e.width, l = rp(t, n, s, r);
  return l >= a ? s : rp(t, n, o, r) > l ? o : s;
}
function sp(t) {
  try {
    t?.showPopover?.();
  } catch {
  }
}
function op(t) {
  try {
    t?.hidePopover?.();
  } catch {
  }
}
function oP(t) {
  let e = null, n;
  const i = (...r) => {
    n = r, e === null && (e = requestAnimationFrame(() => {
      e = null, t(...n);
    }));
  };
  return i.cancel = () => {
    e !== null && (cancelAnimationFrame(e), e = null);
  }, i;
}
function po(t) {
  return t.kind === "captions" || t.kind === "subtitles";
}
function Cu(t) {
  return Array.from(t).filter(po).sort(lP);
}
function aP(t, e) {
  if (!(t instanceof HTMLElement)) return null;
  for (const n of t.querySelectorAll("track")) if (n.track === e) return n;
  return null;
}
function lP(t, e) {
  return t.kind > e.kind ? 1 : t.kind < e.kind ? -1 : 0;
}
function ap(t) {
  const e = [];
  for (let n = 0; n < t.length; n++) e.push([t.start(n), t.end(n)]);
  return e;
}
function Wt(t, e) {
  let n = e;
  for (; n; ) {
    if (n === t || t.contains(n)) return !0;
    const i = n.getRootNode();
    n = n.assignedSlot ?? n.parentElement ?? (N0(i) ? i.host : null);
  }
  return !1;
}
function G0() {
  return "WebKitPlaybackTargetAvailabilityEvent" in globalThis;
}
function cP(t) {
  return G0() && "webkitCurrentPlaybackTargetIsWireless" in t;
}
var uP = class Au {
  static defaultProps = {
    label: "",
    disabled: !1
  };
  state = at({
    state: "disconnected",
    availability: "unsupported",
    disabled: !0,
    hidden: !0,
    label: ""
  });
  #e = { ...Au.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Au.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.state === "connected" ? vS : e.state === "connecting" ? $0 : gS);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = G0() ? e.remotePlaybackAvailability : "unsupported";
    return this.state.patch({
      state: e.remotePlaybackState,
      availability: n,
      disabled: this.#e.disabled || n !== "available",
      hidden: n !== "available"
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  async toggle(e) {
    if (this.setMedia(e), !this.getState().disabled)
      try {
        await e.promptRemotePlayback();
      } catch {
      }
  }
};
const dP = {
  /**
  * Current AirPlay connection state.
  *
  * @see https://developer.mozilla.org/en-US/docs/Web/API/RemotePlayback/state
  */
  state: "data-airplay-state",
  /**
  * Whether AirPlay is available on the active platform and media.
  *
  * @see https://developer.mozilla.org/en-US/docs/Web/API/RemotePlayback
  */
  availability: "data-availability",
  /** Present when the button is non-interactive (mirrors `aria-disabled`). */
  disabled: "data-disabled",
  /** Present when the button is hidden because AirPlay is unavailable. */
  hidden: "data-hidden"
}, Cl = {
  /** Present during the open transition. */
  transitionStarting: "data-starting-style",
  /** Present during the close transition. */
  transitionEnding: "data-ending-style"
};
function mo(t) {
  return {
    transitionStarting: t === "starting",
    transitionEnding: t === "ending"
  };
}
var Ba = class {
  static defaultProps = {
    open: !1,
    defaultOpen: !1,
    closeOnEscape: !0
  };
  #e;
  #t = null;
  #i = void 0;
  #n = void 0;
  #r = !0;
  constructor(t = "dialog") {
    this.#e = t;
  }
  /** Accept props for API consistency. Props are consumed by platform layers. */
  setProps(t) {
  }
  setInput(t) {
    this.#t = t;
  }
  setTitleId(t) {
    this.#i = t;
  }
  setDescriptionId(t) {
    this.#n = t;
  }
  setDocumentModal(t) {
    this.#r = t;
  }
  getState() {
    const t = this.#t;
    return {
      open: t.active,
      status: t.status,
      titleId: this.#i,
      descriptionId: this.#n,
      ...mo(t.status)
    };
  }
  getTriggerAttrs(t, e) {
    return {
      "aria-expanded": t.open && t.status !== "ending" ? "true" : "false",
      "aria-haspopup": "dialog",
      "aria-controls": e
    };
  }
  getPopupAttrs(t) {
    return {
      role: this.#e,
      "aria-modal": this.#r ? "true" : void 0,
      "aria-labelledby": t.titleId,
      "aria-describedby": t.descriptionId
    };
  }
}, hP = class extends Ba {
  constructor() {
    super("alertdialog");
  }
};
const K0 = {
  /** Present when the dialog is open. */
  open: "data-open",
  /** Present during the open transition. */
  transitionStarting: "data-starting-style",
  /** Present during the close transition. */
  transitionEnding: "data-ending-style"
}, Pi = "menu.", Lo = {
  key: `${Pi}settings`,
  text: "Settings"
}, br = {
  key: `${Pi}quality`,
  text: "Quality"
}, _r = {
  key: `${Pi}audio`,
  text: "Audio"
}, No = {
  key: `${Pi}speed`,
  text: "Speed"
}, wr = {
  key: `${Pi}captions`,
  text: "Captions"
}, fP = {
  key: `${Pi}playbackRate`,
  text: "Playback rate"
}, lp = {
  key: `${Pi}off`,
  text: "Off"
}, cp = {
  key: `${Pi}auto`,
  text: "Auto"
}, pP = {
  key: `${Pi}autoWithLabel`,
  text: "Auto ({label})"
}, mP = {
  key: `${Pi}subtitles`,
  text: "Subtitles"
};
function gP(t) {
  return t.label ? t.label : t.language ? t.language : t.kind ? t.kind : _r;
}
var vP = class $u {
  static defaultProps = {
    label: "",
    formatTrack: gP,
    disabled: !1
  };
  state = at({
    options: [],
    value: "",
    disabled: !0,
    hidden: !0,
    availability: "unavailable",
    label: ""
  });
  #e = { ...$u.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, $u.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || _r;
  }
  getTrackLabel(e) {
    return this.#e.formatTrack(e);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.audioTrackList.findIndex((s) => s.enabled), i = e.audioTrackList.map((s) => ({
      value: s.id,
      label: this.getTrackLabel(s),
      disabled: !1
    })), r = i.length > 1 ? "available" : "unavailable";
    return this.state.patch({
      options: i,
      value: n === -1 ? "" : e.audioTrackList[n].id,
      disabled: this.#e.disabled || r === "unavailable",
      hidden: r === "unavailable",
      availability: r
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  select(e, n) {
    this.#e.disabled || e.audioTrackList.some((i) => i.id === n) && e.selectAudioTrack(n);
  }
  selectValue(e, n) {
    this.select(e, n);
  }
};
const yP = {
  /** Current audio track value. */
  value: "data-audio-track",
  /** Present when audio track selection is disabled. */
  disabled: "data-disabled",
  /** Present when audio track selection is unavailable. */
  hidden: "data-hidden",
  /** Indicates audio track availability (`available` or `unavailable`). */
  availability: "data-availability"
};
var bP = class Ru {
  static defaultProps = { delay: 500 };
  state = at({ visible: !1 });
  #e = { ...Ru.defaultProps };
  #t = null;
  setProps(e) {
    this.#e = nt(e, Ru.defaultProps);
  }
  destroy() {
    this.#i();
  }
  update(e) {
    const n = e.waiting && !e.paused;
    n && !this.state.current.visible && !this.#t ? this.#t = setTimeout(() => {
      this.#t = null, this.state.patch({ visible: !0 });
    }, this.#e.delay) : n || (this.#i(), this.state.patch({ visible: !1 }));
  }
  #i() {
    this.#t !== null && (clearTimeout(this.#t), this.#t = null);
  }
};
const _P = {
  /** Present when the buffering indicator is visible (after delay). */
  visible: "data-visible"
}, Y0 = "captions.", wP = {
  key: `${Y0}enable`,
  text: "Enable captions"
}, kP = {
  key: `${Y0}disable`,
  text: "Disable captions"
};
var xP = class Mu {
  static defaultProps = {
    label: "",
    disabled: !1,
    menuTrigger: !1
  };
  state = at({
    subtitlesShowing: !1,
    availability: "unavailable",
    disabled: !0,
    hidden: !0,
    label: ""
  });
  #e = { ...Mu.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Mu.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.subtitlesShowing ? kP : wP);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.textTrackList.some(po) ? "available" : "unavailable";
    return this.state.patch({
      subtitlesShowing: e.subtitlesShowing,
      availability: n,
      disabled: this.#e.disabled || n !== "available",
      hidden: n === "unavailable"
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  toggle(e) {
    this.setMedia(e), !this.getState().disabled && (this.#e.menuTrigger && SP(e) > 1 || e.toggleSubtitles());
  }
};
function SP(t) {
  return t.textTrackList.filter(po).length;
}
const PP = {
  /** Present when captions are enabled. */
  subtitlesShowing: "data-active",
  /** Indicates captions availability (`available` or `unavailable`). */
  availability: "data-availability",
  /** Present when the button is non-interactive (mirrors `aria-disabled`). */
  disabled: "data-disabled",
  /** Present when the button is hidden because no caption tracks are present. */
  hidden: "data-hidden"
};
function EP(t) {
  return t.label ? t.label : t.language ? t.language : t.kind === "captions" ? wr : mP;
}
var TP = class Ou {
  static defaultProps = {
    label: "",
    formatTrack: EP,
    disabled: !1
  };
  state = at({
    options: [{
      value: "off",
      label: lp,
      disabled: !1
    }],
    value: "off",
    subtitlesShowing: !1,
    disabled: !0,
    hidden: !0,
    availability: "unavailable",
    label: ""
  });
  #e = { ...Ou.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Ou.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || wr;
  }
  getTrackLabel(e) {
    return this.#e.formatTrack(e);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = Cu(e.textTrackList), i = n.findIndex((o) => o.mode === "showing"), r = [{
      value: "off",
      label: lp,
      disabled: !1
    }, ...n.map((o) => ({
      value: o.id,
      label: this.getTrackLabel(o),
      disabled: !1
    }))], s = n.length > 0 ? "available" : "unavailable";
    return this.state.patch({
      options: r,
      value: i === -1 ? "off" : n[i].id,
      subtitlesShowing: e.subtitlesShowing,
      disabled: this.#e.disabled || n.length === 0,
      hidden: s === "unavailable",
      availability: s
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  select(e, n) {
    if (this.#e.disabled) return;
    const i = Cu(e.textTrackList);
    if (i.length) {
      if (n === "off") {
        e.selectSubtitlesTrack(null);
        return;
      }
      i.some((r) => r.id === n) && e.selectSubtitlesTrack(n);
    }
  }
  selectValue(e, n) {
    this.select(e, n);
  }
};
const CP = {
  /** Present when captions are enabled. */
  subtitlesShowing: "data-active",
  /** Present when track selection is disabled. */
  disabled: "data-disabled",
  /** Present when track selection is unavailable. */
  hidden: "data-hidden",
  /** Indicates captions availability (`available` or `unavailable`). */
  availability: "data-availability"
};
var AP = class Iu {
  static defaultProps = {
    label: "",
    disabled: !1
  };
  state = at({
    connection: "disconnected",
    availability: "unsupported",
    disabled: !0,
    hidden: !0,
    label: ""
  });
  #e = { ...Iu.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Iu.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.connection === "connected" ? bS : e.connection === "connecting" ? $0 : yS);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = globalThis.chrome ? e.remotePlaybackAvailability : "unsupported";
    return this.state.patch({
      connection: e.remotePlaybackState,
      availability: n,
      disabled: this.#e.disabled || n !== "available",
      hidden: n === "unsupported"
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  async toggle(e) {
    if (this.setMedia(e), !this.getState().disabled)
      return e.promptRemotePlayback();
  }
};
const $P = {
  /**
  * Current remote playback connection state.
  *
  * @see https://developer.mozilla.org/en-US/docs/Web/API/RemotePlayback/state
  */
  connection: "data-cast-state",
  /**
  * Whether remote playback can be requested on this platform.
  *
  * @see https://developer.mozilla.org/en-US/docs/Web/API/RemotePlayback
  */
  availability: "data-availability",
  /** Present when the button is non-interactive (mirrors `aria-disabled`). */
  disabled: "data-disabled",
  /** Present when the button is hidden because the feature is unsupported. */
  hidden: "data-hidden"
};
var RP = class {
  #e = null;
  setMedia(t) {
    this.#e = t;
  }
  getState() {
    return { controlsVisible: this.#e.controlsVisible };
  }
};
const MP = {
  /** Present when player controls are visible. */
  controlsVisible: "data-controls-visible"
};
var up = class Du {
  static defaultProps = { visibility: "auto" };
  #e = { ...Du.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Du.defaultProps);
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t;
    return e ? {
      visible: this.#e.visibility === "always" || e.controlsVisible,
      userActive: e.userActive
    } : this.#e.visibility === "always" ? {
      visible: !0,
      userActive: !0
    } : null;
  }
};
const OP = {
  /** Present when controls are visible. */
  visible: "data-visible",
  /** Present when the user has recently interacted. */
  userActive: "data-user-active"
}, IP = "https://videojs.org/about-this-player", DP = "About this Video.js player";
var FP = class extends hP {
  setProps() {
  }
};
const LP = { ...K0 }, X0 = "common.", NP = {
  key: `${X0}empty`,
  text: ""
}, VP = {
  key: `${X0}ok`,
  text: "OK"
}, _n = "errors.", jP = {
  key: `${_n}aborted`,
  text: "You stopped media playback before it finished."
}, zP = {
  key: `${_n}network`,
  text: "This media could not be loaded due to a network or server issue."
}, BP = {
  key: `${_n}decode`,
  text: "This media could not be played. It may be corrupted, or your browser may not support its format."
}, HP = {
  key: `${_n}source`,
  text: "This media could not be loaded. It may be unavailable, or your browser may not support its format."
}, UP = {
  key: `${_n}encrypted`,
  text: "This media could not be played because it could not be decrypted."
}, WP = {
  key: `${_n}unplayable`,
  text: "This media is unsupported by the player."
}, qP = {
  key: `${_n}title`,
  text: "Something went wrong."
}, GP = {
  key: `${_n}unexpected`,
  text: "An unexpected error occurred."
}, dp = Object.freeze({
  length: 0,
  start: () => 0,
  end: () => 0
}), KP = Object.assign(new EventTarget(), {
  length: 0,
  *[Symbol.iterator]() {
  },
  getTrackById: () => null
}), YP = new EventTarget();
var pi = class Ps extends Error {
  static MEDIA_ERR_ABORTED = 1;
  static MEDIA_ERR_NETWORK = 2;
  static MEDIA_ERR_DECODE = 3;
  static MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
  static MEDIA_ERR_ENCRYPTED = 5;
  static MEDIA_ERR_CUSTOM = 100;
  static defaultMessages = {
    1: "You stopped media playback before it finished.",
    2: "This media could not be loaded due to a network or server issue.",
    3: "This media could not be played. It may be corrupted, or your browser may not support its format.",
    4: "This media could not be loaded. It may be unavailable, or your browser may not support its format.",
    5: "This media could not be played because it could not be decrypted."
  };
  name;
  code;
  context;
  fatal;
  data;
  constructor(e, n = Ps.MEDIA_ERR_CUSTOM, i, r) {
    super(e), this.name = "MediaError", this.code = n, this.context = r, this.fatal = i ?? (n >= Ps.MEDIA_ERR_NETWORK && n <= Ps.MEDIA_ERR_ENCRYPTED), this.message || (this.message = Ps.defaultMessages[this.code] ?? "");
  }
};
const J0 = /* @__PURE__ */ Symbol.for("@videojs/media/registered");
function ph(t) {
  return t?.[J0] ?? t;
}
const Z0 = {
  HAVE_METADATA: 1,
  HAVE_FUTURE_DATA: 3
}, Vo = {
  ON_DEMAND: "on-demand",
  LIVE: "live",
  UNKNOWN: "unknown"
};
function Fu(t) {
  return t.readyState >= Z0.HAVE_METADATA;
}
function Gs(t) {
  if (Number.isFinite(t.duration) && t.duration > 0) return t.duration;
  const e = t.seekable.at(-1)?.[1];
  return e === void 0 || !Number.isFinite(e) || e <= 0 ? 0 : e;
}
function mh(t) {
  return Gs(t) > 0;
}
function ga(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.paused) && !Ce(e.ended) && ke(e.pause);
}
function Ks(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.currentTime) && !Ce(e.duration) && !Ce(e.seeking);
}
function Hr(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.src) && !Ce(e.currentSrc) && !Ce(e.readyState) && ke(e.load);
}
function lc(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.volume) && !Ce(e.muted);
}
function hp(t) {
  return Je(t) ? !Ce(t.muted) : !1;
}
function fp(t) {
  return Je(t) ? !Ce(t.playbackRate) : !1;
}
function XP(t) {
  return Je(t) ? ke(t.requestPictureInPicture) : !1;
}
function gh(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.buffered) && e.buffered !== dp && !Ce(e.seekable) && e.seekable !== dp;
}
function JP(t) {
  return Je(t) ? !Ce(t.error) : !1;
}
function cc(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.textTracks) && e.textTracks !== KP;
}
function pp(t) {
  return Je(t) ? !Ce(t.videoRenditions) : !1;
}
function mp(t) {
  return Je(t) ? !Ce(t.audioTracks) : !1;
}
function ZP(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.videoWidth) && !Ce(e.videoHeight);
}
function Q0(t) {
  if (!Je(t)) return !1;
  const e = t;
  return Je(e.remote) && e.remote !== YP;
}
function QP(t) {
  return Je(t) ? !Ce(t.streamType) : !1;
}
function gp(t) {
  return Je(t) ? !Ce(t.contentData) : !1;
}
function e2(t) {
  if (!Je(t)) return !1;
  const e = t;
  return !Ce(e.liveEdgeStart) && !Ce(e.targetLiveWindow);
}
function t2(t) {
  return Je(t) && "querySelectorAll" in t && ke(t.querySelectorAll);
}
const i2 = 99001, n2 = {
  [pi.MEDIA_ERR_ABORTED]: jP,
  [pi.MEDIA_ERR_NETWORK]: zP,
  [pi.MEDIA_ERR_DECODE]: BP,
  [pi.MEDIA_ERR_SRC_NOT_SUPPORTED]: HP,
  [pi.MEDIA_ERR_ENCRYPTED]: UP,
  [pi.MEDIA_ERR_CUSTOM]: NP,
  [i2]: WP
}, r2 = { [pi.MEDIA_ERR_SRC_NOT_SUPPORTED]: ["Failed to open media"] };
function s2(t) {
  return t >= pi.MEDIA_ERR_ABORTED && t <= pi.MEDIA_ERR_ENCRYPTED;
}
function o2() {
  return qP;
}
function a2() {
  return VP;
}
function l2(t, e) {
  if (t) {
    const n = n2[t.code], i = t.message?.trim();
    if (i) {
      const r = pi.defaultMessages[t.code];
      if (n && r && i === r) return n;
      const s = r2[t.code];
      return n && s2(t.code) && !t.context && s?.includes(i) ? n : i;
    }
    if (n) return n;
  }
  return GP;
}
const ey = "fullscreen.", c2 = {
  key: `${ey}enter`,
  text: "Enter fullscreen"
}, vh = {
  key: `${ey}exit`,
  text: "Exit fullscreen"
};
var u2 = class Lu {
  static defaultProps = {
    label: "",
    disabled: !1
  };
  state = at({
    fullscreen: !1,
    availability: "unavailable",
    disabled: !0,
    hidden: !0,
    label: ""
  });
  #e = { ...Lu.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Lu.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.fullscreen ? vh : c2);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.fullscreenAvailability;
    return this.state.patch({
      fullscreen: e.isFullscreen,
      availability: n,
      disabled: this.#e.disabled || n !== "available",
      hidden: n !== "available"
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  async toggle(e) {
    if (this.setMedia(e), !this.getState().disabled)
      return e.isFullscreen ? e.exitFullscreen() : e.requestFullscreen();
  }
};
const d2 = {
  /** Present when fullscreen mode is active. */
  fullscreen: "data-fullscreen",
  /** Indicates fullscreen availability (`available`, `unavailable`, `unsupported`). */
  availability: "data-availability",
  /** Present when the button is non-interactive (mirrors `aria-disabled`). */
  disabled: "data-disabled",
  /** Present when the button is hidden because fullscreen is not available. */
  hidden: "data-hidden"
}, h2 = /\{([^{}]+)\}/g;
function ty(t, e) {
  return e ? t.replace(h2, (n, i) => Object.hasOwn(e, i) ? String(e[i]) : n) : t;
}
function Be(t, e, n) {
  return typeof t == "string" ? t : typeof e == "function" ? e(t, n) : ty(Vt(t), e ?? n);
}
const wn = "status.", iy = {
  key: `${wn}captionsOn`,
  text: "Captions on"
}, ny = {
  key: `${wn}captionsOff`,
  text: "Captions off"
}, ry = {
  key: `${wn}paused`,
  text: "Paused"
}, sy = {
  key: `${wn}playing`,
  text: "Playing"
}, oy = {
  key: `${wn}fullscreen`,
  text: "Fullscreen"
}, ay = {
  key: `${wn}pip`,
  text: "Picture in picture"
}, ly = {
  key: `${wn}exitPip`,
  text: "Exit picture in picture"
}, cy = {
  key: `${wn}seekedTo`,
  text: "Seeked to {time}"
}, Al = "volume.", f2 = {
  key: `${Al}mutedValue`,
  text: "{percent}, muted"
}, uy = {
  key: `${Al}muted`,
  text: "Muted"
}, yh = {
  key: `${Al}label`,
  text: "Volume"
}, dy = {
  key: `${Al}value`,
  text: "Volume {value}"
}, go = {
  muted: Be(uy),
  volume: Be(yh),
  captionsOn: Be(iy),
  captionsOff: Be(ny),
  paused: Be(ry),
  playing: Be(sy),
  fullscreen: Be(oy),
  exitFullscreen: Be(vh),
  pictureInPicture: Be(ay),
  exitPictureInPicture: Be(ly)
};
function bh(t) {
  return {
    muted: t(uy),
    volume: t(yh),
    captionsOn: t(iy),
    captionsOff: t(ny),
    paused: t(ry),
    playing: t(sy),
    fullscreen: t(oy),
    exitFullscreen: t(vh),
    pictureInPicture: t(ay),
    exitPictureInPicture: t(ly)
  };
}
var $l = class {
  #e = null;
  #t;
  #i;
  constructor(t, e) {
    this.#t = t, this.#i = e;
  }
  arm() {
    this.clear(), this.#e = setTimeout(() => {
      this.#e = null, this.#t();
    }, this.#i());
  }
  clear() {
    this.#e !== null && (clearTimeout(this.#e), this.#e = null);
  }
  close() {
    this.clear(), this.#t();
  }
  destroy() {
    this.clear();
  }
}, p2 = class {
  #e = /* @__PURE__ */ new Set();
  register(t) {
    return this.#e.add(t), () => this.#e.delete(t);
  }
  show(t) {
    for (const e of this.#e) e !== t && e.close();
  }
};
function Rl(t) {
  return t.closeDelay ?? 800;
}
function m2(t, e) {
  return t.open || e.active;
}
function g2(t, e, n) {
  const i = t.open ? t : e;
  return {
    ...i,
    open: t.open && n.active,
    generation: t.open ? t.generation : i.generation,
    ...mo(n.status)
  };
}
function v2(t, e) {
  return t ? !e || e.includes(t) : !1;
}
function y2(t) {
  const e = [...t];
  if (e.length === 0) return null;
  const n = e.filter((r) => !r.hidden), i = n.filter((r) => r.availability === "available").length > 0 ? "available" : e.every((r) => r.availability === "unsupported") ? "unsupported" : "unavailable";
  return {
    value: e.length === 1 ? e[0].value : "",
    disabled: n.length === 0 || n.every((r) => r.disabled),
    hidden: n.length === 0,
    availability: i
  };
}
var jo = class Nu {
  static defaultProps = {
    side: "bottom",
    align: "start",
    open: !1,
    defaultOpen: !1,
    closeOnEscape: !0,
    closeOnOutsideClick: !0
  };
  #e = { ...Nu.defaultProps };
  #t = null;
  get props() {
    return this.#e;
  }
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Nu.defaultProps);
  }
  setInput(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.isSubmenu;
    return {
      open: e.active,
      status: e.status,
      side: n ? void 0 : this.#e.side,
      align: n ? void 0 : this.#e.align,
      isSubmenu: n,
      ...mo(e.status)
    };
  }
  getTriggerAttrs(e, n) {
    return {
      ...!e.isSubmenu && { tabIndex: 0 },
      "aria-haspopup": "menu",
      "aria-expanded": e.open && e.status !== "ending" ? "true" : "false",
      "aria-controls": n
    };
  }
  getContentAttrs() {
    return {
      role: "menu",
      tabIndex: -1
    };
  }
  getPopupAttrs() {
    return { popover: "manual" };
  }
};
const hy = {
  /** Present when the menu is open. */
  open: "data-open",
  /** Rendered positioning side after collision handling. Absent on submenus. */
  side: "data-side",
  /** Popover positioning alignment. Absent on submenus. */
  align: "data-align",
  ...Cl
}, Qi = {
  /** Present while this Content is active or transitioning out. */
  open: "data-open",
  /** Present on Content when this menu is nested inside a parent menu. */
  isSubmenu: "data-submenu",
  /** Present when this Content has an open logical child. */
  childOpen: "data-child-open",
  ...Cl
};
({
  ...hy,
  ...Qi
});
const ar = {
  /**
  * Present on all navigable item types: Item, RadioItem, CheckboxItem, and the Trigger when acting as a submenu
  * trigger inside a parent menu. Use `[data-item]` as a shared selector to target all item types at once.
  */
  item: "data-item",
  /** Present when the item is highlighted. Set to `pointer` when pointer movement caused the highlight; otherwise empty. */
  highlighted: "data-highlighted"
}, kr = {
  /** Width of the active menu panel (px). */
  width: "--media-menu-width",
  /** Height of the active menu panel (px). */
  height: "--media-menu-height",
  /** Width available within the positioning boundary (px). */
  availableWidth: "--media-menu-available-width",
  /** Height available within the positioning boundary (px). */
  availableHeight: "--media-menu-available-height"
}, vo = "buttons.", b2 = {
  key: `${vo}play`,
  text: "Play"
}, _2 = {
  key: `${vo}pause`,
  text: "Pause"
}, w2 = {
  key: `${vo}replay`,
  text: "Replay"
}, k2 = {
  key: `${vo}mute`,
  text: "Mute"
}, x2 = {
  key: `${vo}unmute`,
  text: "Unmute"
};
var S2 = class Vu {
  static defaultProps = {
    label: "",
    disabled: !1
  };
  state = at({
    muted: !1,
    volumeLevel: "off",
    availability: "unavailable",
    hidden: !0,
    label: ""
  });
  #e = { ...Vu.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Vu.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.muted ? x2 : k2);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": this.#e.disabled ? "true" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.mutedAvailability;
    return this.state.patch({
      muted: e.muted || e.volume === 0,
      volumeLevel: P2(e),
      availability: n,
      hidden: n !== "available"
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  toggle(e) {
    this.#e.disabled || e.mutedAvailability !== "available" || e.setMuted(!(e.muted || e.volume === 0));
  }
};
function P2(t) {
  return t.muted || t.volume === 0 ? "off" : t.volume < 0.5 ? "low" : t.volume < 0.75 ? "medium" : "high";
}
const E2 = {
  /** Present when the media is muted. */
  muted: "data-muted",
  /** Indicates the volume level. */
  volumeLevel: "data-volume-level",
  /** Indicates mute availability (`available`, `unavailable`, `unsupported`). */
  availability: "data-availability",
  /** Present when the button is hidden because the media has no mute to toggle. */
  hidden: "data-hidden"
}, fy = "pip.", T2 = {
  key: `${fy}enter`,
  text: "Enter picture-in-picture"
}, C2 = {
  key: `${fy}exit`,
  text: "Exit picture-in-picture"
};
var A2 = class ju {
  static defaultProps = {
    label: "",
    disabled: !1
  };
  state = at({
    pip: !1,
    availability: "unavailable",
    disabled: !0,
    hidden: !0,
    label: ""
  });
  #e = { ...ju.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, ju.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.pip ? C2 : T2);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.pictureInPictureAvailability, i = e.isPictureInPicture || n === "available";
    return this.state.patch({
      pip: e.isPictureInPicture,
      availability: n,
      disabled: this.#e.disabled || !i,
      hidden: !i
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  async toggle(e) {
    if (this.setMedia(e), !this.getState().disabled)
      return e.isPictureInPicture ? e.exitPictureInPicture() : e.requestPictureInPicture();
  }
};
const $2 = {
  /** Present when picture-in-picture mode is active. */
  pip: "data-pip",
  /** Indicates picture-in-picture availability (`available`, `unavailable`, `unsupported`). */
  availability: "data-availability",
  /** Present when the button is non-interactive (mirrors `aria-disabled`). */
  disabled: "data-disabled",
  /** Present when the button is hidden because picture-in-picture is not available. */
  hidden: "data-hidden"
};
var R2 = class zu {
  static defaultProps = {
    label: "",
    disabled: !1
  };
  state = at({
    paused: !0,
    ended: !1,
    started: !1,
    label: ""
  });
  #e = { ...zu.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, zu.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || (e.ended ? w2 : e.paused ? b2 : _2);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": this.#e.disabled ? "true" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t;
    return this.state.patch({
      paused: e.paused,
      ended: e.ended,
      started: e.started
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  async toggle(e) {
    if (!this.#e.disabled) {
      if (e.paused || e.ended) return e.play();
      e.pause();
    }
  }
};
const M2 = {
  /** Present when the media is paused. */
  paused: "data-paused",
  /** Present when the media has ended. */
  ended: "data-ended",
  /** Present when playback has started. */
  started: "data-started"
}, py = {
  key: "playback.rate",
  text: "Playback rate {rate}"
};
function O2(t) {
  return `${t}×`;
}
var I2 = class Bu {
  static defaultProps = {
    label: "",
    formatRate: O2,
    disabled: !1
  };
  state = at({
    rate: 1,
    value: "1",
    options: [],
    disabled: !0,
    hidden: !0,
    availability: "unavailable",
    label: ""
  });
  #e = { ...Bu.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Bu.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n !== void 0 ? n : fP;
  }
  getLabelParams(e) {
  }
  getRateLabel(e) {
    return this.#e.formatRate(e);
  }
  getRateValue(e) {
    return String(e);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.playbackRates.length > 0 ? "available" : "unavailable";
    return this.state.patch({
      rate: e.playbackRate,
      value: this.getRateValue(e.playbackRate),
      options: e.playbackRates.map((i) => ({
        rate: i,
        value: this.getRateValue(i),
        label: this.getRateLabel(i),
        disabled: !1
      })),
      disabled: this.#e.disabled || e.playbackRates.length === 0,
      hidden: n === "unavailable",
      availability: n
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  select(e, n) {
    this.#e.disabled || e.playbackRates.includes(n) && e.setPlaybackRate(n);
  }
  selectValue(e, n) {
    const i = e.playbackRates.find((r) => this.getRateValue(r) === n);
    Ce(i) || this.select(e, i);
  }
};
const D2 = {
  /** Current playback rate. */
  rate: "data-rate",
  /** Present when playback rate selection is disabled. */
  disabled: "data-disabled",
  /** Present when playback rate selection is unavailable. */
  hidden: "data-hidden",
  /** Indicates playback rate availability (`available` or `unavailable`). */
  availability: "data-availability"
};
var Di = class Hu {
  static defaultProps = {
    side: "top",
    align: "center",
    modal: !1,
    closeOnEscape: !0,
    closeOnOutsideClick: !0,
    open: !1,
    defaultOpen: !1,
    openOnHover: !1,
    delay: 300,
    closeDelay: 0
  };
  #e = { ...Hu.defaultProps };
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Hu.defaultProps);
  }
  #t = null;
  setInput(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t;
    return {
      open: e.active,
      status: e.status,
      side: this.#e.side,
      align: this.#e.align,
      modal: this.#e.modal,
      ...mo(e.status)
    };
  }
  getTriggerAttrs(e, n) {
    return {
      "aria-expanded": e.open && e.status !== "ending" ? "true" : "false",
      "aria-haspopup": "dialog",
      "aria-controls": n
    };
  }
  getPopupAttrs(e) {
    return {
      popover: "manual",
      role: "dialog",
      "aria-modal": e.modal === !0 ? "true" : void 0
    };
  }
};
const F2 = {
  /** Present when the popover is open. */
  open: "data-open",
  /** Indicates the rendered side of the popover after collision handling. */
  side: "data-side",
  /** Indicates how the popover is aligned relative to the specified side. */
  align: "data-align",
  ...Cl
}, cn = {
  /** Distance between the popup and the trigger along the side axis. */
  sideOffset: "--media-popover-side-offset",
  /** Distance between the popup and the trigger along the alignment axis. */
  alignOffset: "--media-popover-align-offset",
  /** Minimum distance between the popup and the positioning boundary. */
  boundaryOffset: "--media-popover-boundary-offset",
  /** The anchor element's width. */
  anchorWidth: "--media-popover-anchor-width",
  /** The anchor element's height. */
  anchorHeight: "--media-popover-anchor-height",
  /** Available width between the trigger and the boundary edge. */
  availableWidth: "--media-popover-available-width",
  /** Available height between the trigger and the boundary edge. */
  availableHeight: "--media-popover-available-height"
};
var L2 = class {
  #e = null;
  #t = "none";
  /** Supply the latest player state. Call before reading {@link PosterCore.getState}. */
  setMedia(t) {
    this.#e = t;
  }
  /** Supply how the binding's image is faring. */
  setImageLoadState(t) {
    this.#t = t;
  }
  /** Derive the presentation state to paint. */
  getState() {
    const t = this.#e;
    return {
      visible: !t.started,
      src: t.poster,
      loading: this.#t === "loading",
      loaded: this.#t === "loaded",
      error: this.#t === "error"
    };
  }
};
const N2 = {
  /** Present until playback starts. */
  visible: "data-visible",
  /** Present while the poster image is fetching. */
  loading: "data-loading",
  /** Present once the poster image has decoded. */
  loaded: "data-loaded",
  /** Present when the poster image failed. */
  error: "data-error"
}, zo = "auto", V2 = [
  4320,
  2160,
  1440,
  1080,
  720,
  480,
  360,
  240
];
function my(t) {
  return t >= 1e6 ? `${Math.round(t / 1e5) / 10} Mbps` : `${Math.round(t / 1e3)} kbps`;
}
function vp(t) {
  const e = Math.round(t * 9 / 16);
  return V2.includes(e) ? e : void 0;
}
function Ys(t) {
  const { width: e, height: n } = t;
  if (e && n)
    return e > n && e * 9 > n * 16 ? vp(e) ?? n : Math.min(e, n);
  if (n) return n;
  if (e) return vp(e) ?? e;
}
function j2(t, e) {
  const n = Ys(t);
  return !!(n && e.some((i) => i !== t && Ys(i) === n));
}
function yp(t) {
  const e = Ys(t);
  return e ? `${e}p` : t.bitrate ? my(t.bitrate) : br;
}
function z2(t, e = []) {
  if (!(!Ys(t) || !t.bitrate || !j2(t, e)))
    return my(t.bitrate);
}
function B2(t) {
  const e = Ys(t);
  if (e) {
    if (e >= 4320) return "8K";
    if (e >= 2160) return "4K";
    if (e >= 1080) return "HD";
  }
}
var H2 = class mr {
  static defaultProps = {
    label: "",
    formatRendition: yp,
    disabled: !1
  };
  state = at({
    options: [{
      value: zo,
      label: cp,
      disabled: !1
    }],
    value: zo,
    disabled: !0,
    hidden: !0,
    availability: "unavailable",
    label: ""
  });
  #e = { ...mr.defaultProps };
  #t = null;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, mr.defaultProps);
  }
  getLabel(e) {
    const n = Lt(this.#e.label, e);
    return n || br;
  }
  getRenditionLabel(e) {
    return this.#e.formatRendition !== mr.defaultProps.formatRendition ? this.#e.formatRendition(e) : yp(e);
  }
  getRenditionBadge(e, n = []) {
    if (this.#e.formatRendition === mr.defaultProps.formatRendition)
      return z2(e, n);
  }
  getRenditionTier(e) {
    if (this.#e.formatRendition === mr.defaultProps.formatRendition)
      return B2(e);
  }
  getAttrs(e) {
    return {
      "aria-label": this.getLabel(e),
      "aria-disabled": e.disabled ? "true" : void 0,
      hidden: e.hidden ? "" : void 0
    };
  }
  setMedia(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t, n = e.videoRenditionList.findIndex((l) => l.selected), i = e.videoRenditionList.length > 1 ? "available" : "unavailable", r = (l) => {
      const c = this.getRenditionTier(l), u = this.getRenditionBadge(l, e.videoRenditionList);
      return {
        value: l.id,
        label: this.getRenditionLabel(l),
        disabled: !1,
        ...c && { tier: c },
        ...u && { badge: u }
      };
    }, { activeVideoRendition: s } = e, o = s && e.videoRenditionList.some((l) => l.id === s.id) ? r(s) : void 0, a = {
      value: zo,
      label: n === -1 && o ? pP : cp,
      disabled: !1,
      ...n === -1 && o && { labelParams: { label: Vt(o.label) } }
    };
    return this.state.patch({
      options: [a, ...e.videoRenditionList.map(r)],
      value: n === -1 ? zo : e.videoRenditionList[n].id,
      disabled: this.#e.disabled || i === "unavailable",
      hidden: i === "unavailable",
      availability: i
    }), this.state.patch({ label: Vt(this.getLabel(this.state.current)) }), this.state.current;
  }
  select(e, n) {
    if (!this.#e.disabled) {
      if (n === "auto") {
        e.selectVideoRendition(n);
        return;
      }
      e.videoRenditionList.some((i) => i.id === n) && e.selectVideoRendition(n);
    }
  }
  selectValue(e, n) {
    this.select(e, n);
  }
};
const U2 = {
  /** Current quality value. */
  value: "data-quality",
  /** Present when quality selection is disabled. */
  disabled: "data-disabled",
  /** Present when quality selection is unavailable. */
  hidden: "data-hidden",
  /** Indicates quality availability (`available` or `unavailable`). */
  availability: "data-availability"
};
function li(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function Ml(t, e, n) {
  const i = n - e;
  return !Number.isFinite(i) || i <= 0 ? 0 : li((t - e) / i * 100, 0, 100);
}
function gy(t, e, n) {
  const i = Math.round((t - n) / e) * e + n, r = `${e}`.indexOf(".");
  return r === -1 ? i : Number(i.toFixed(`${e}`.length - r - 1));
}
const bp = /* @__PURE__ */ new Map();
function W2(t, e, n) {
  if (t === "digital") {
    const s = new Intl.NumberFormat(n, { useGrouping: !1 }), o = new Intl.NumberFormat(n, {
      minimumIntegerDigits: 2,
      useGrouping: !1
    });
    return { format: (a) => {
      const l = `${o.format(a.minutes ?? 0)}:${o.format(a.seconds ?? 0)}`;
      return e === "always" || a.hours !== void 0 ? `${s.format(a.hours ?? 0)}:${l}` : l;
    } };
  }
  const i = [
    ["hours", new Intl.NumberFormat(n, {
      style: "unit",
      unit: "hour",
      unitDisplay: t
    })],
    ["minutes", new Intl.NumberFormat(n, {
      style: "unit",
      unit: "minute",
      unitDisplay: t
    })],
    ["seconds", new Intl.NumberFormat(n, {
      style: "unit",
      unit: "second",
      unitDisplay: t
    })]
  ], r = typeof Intl.ListFormat == "function" ? new Intl.ListFormat(n, {
    type: "unit",
    style: t
  }) : { format: (s) => [...s].join(t === "narrow" ? " " : ", ") };
  return { format: (s) => r.format(i.filter(([o]) => s[o] !== void 0).map(([o, a]) => a.format(s[o] ?? 0))) };
}
function q2(t) {
  return t === void 0 ? "" : Array.isArray(t) ? t.join(":") : t;
}
function vy(t, e = "long", n) {
  const i = `${q2(t)}:${e}:${n ?? ""}`;
  let r = bp.get(i);
  return r || (r = W2(e, n, t), bp.set(i, r)), r;
}
function Ha(t) {
  return Vn(t) && Number.isFinite(t);
}
function _h(t, e, n) {
  if (!Ha(t)) return "0:00";
  const i = t < 0, r = Math.floor(Math.abs(t)), s = Math.floor(r / 3600), o = Math.floor(r % 3600 / 60), a = r % 60, l = Ha(e ?? 0) ? Math.abs(e ?? 0) : 0, c = Math.floor(l / 3600), u = Math.floor(l / 60 % 60), d = s > 0 || c > 0, h = d || u >= 10, f = d ? {
    hours: s,
    minutes: o,
    seconds: a
  } : {
    minutes: o,
    seconds: a
  }, { locale: p = "en" } = n ?? {};
  let v = vy(p, "digital", d ? "always" : "auto").format(f);
  if (!h) {
    const g = new Intl.NumberFormat(p, { useGrouping: !1 }).format(0);
    v = v.replace(new RegExp(`^${g}(?=\\p{Nd}\\D)`, "u"), "");
  }
  return `${i ? "-" : ""}${v}`;
}
function G2(t) {
  if (!Ha(t)) return "PT0S";
  const e = Math.abs(t), n = Math.floor(e / 3600), i = Math.floor(e / 60 % 60), r = Math.floor(e % 60);
  let s = "PT";
  return n > 0 && (s += `${n}H`), i > 0 && (s += `${i}M`), (r > 0 || s === "PT") && (s += `${r}S`), s;
}
function un(t, e) {
  if (!Ha(t)) return "";
  const { locale: n = "en", style: i = "long", formatRemaining: r } = e ?? {}, s = t < 0, o = Math.floor(Math.abs(t)), a = Math.floor(o / 3600), l = Math.floor(o % 3600 / 60), c = o % 60, u = {};
  a > 0 && (u.hours = a), l > 0 && (u.minutes = l), (c > 0 || a === 0 && l === 0) && (u.seconds = c);
  const d = vy(n, i).format(u);
  return s ? r ? r(d) : q0(n) ? `${d} remaining` : d : d;
}
function K2(t) {
  return t === "seekStep" || t === "seekToPercent";
}
function Y2(t, e) {
  const n = e === void 0 ? void 0 : { locale: e };
  return _h(t.currentTime ?? 0, t.duration, n);
}
function X2(t) {
  return t.value ?? t.currentTime;
}
function J2(t) {
  return t.value !== void 0 ? li(t.value, 0, 100) : !t.key || t.key < "0" || t.key > "9" ? null : Number(t.key) * 10;
}
function Z2(t, e) {
  if (t.action === "seekStep" && t.value !== void 0) {
    if (t.value > 0) return "forward";
    if (t.value < 0) return "backward";
  }
  if (t.action === "seekToPercent") {
    const n = J2(t);
    if (n === null || e.duration === void 0 || e.duration <= 0) return null;
    const i = n / 100 * e.duration, r = e.currentTime ?? 0;
    if (i > r) return "forward";
    if (i < r) return "backward";
  }
  return null;
}
const Q2 = {
  open: !1,
  generation: 0,
  direction: null,
  count: 0,
  seekTotal: 0,
  value: null,
  currentTime: "0:00",
  transitionStarting: !1,
  transitionEnding: !1
};
var eE = class {
  state = at({ ...Q2 });
  #e = {};
  #t = null;
  #i = new $l(() => {
    this.#t = null, this.state.patch({
      open: !1,
      direction: null,
      count: 0,
      seekTotal: 0,
      value: null
    });
  }, () => Rl(this.#e));
  setProps(t) {
    this.#e = t;
  }
  destroy() {
    this.#i.destroy();
  }
  close() {
    this.#i.close();
  }
  processEvent(t, e) {
    if (!K2(t.action)) return !1;
    const n = this.state.current, i = Z2(t, e), r = n.open && t.action === "seekStep" && n.direction === i;
    r || (this.#t = e.currentTime ?? null);
    const s = this.#n(t, e, r), o = r ? n.seekTotal + Math.abs(s) : Math.abs(s), a = t.action === "seekStep" && o > 0 ? new Intl.NumberFormat(this.#e.locale ?? zi, {
      style: "unit",
      unit: "second",
      unitDisplay: q0(this.#e.locale) ? "narrow" : "short",
      useGrouping: !1
    }).format(o) : null;
    return this.state.patch({
      open: !0,
      generation: n.generation + 1,
      direction: i,
      count: r ? n.count + 1 : 1,
      seekTotal: o,
      value: a,
      currentTime: Y2(e, this.#e.locale)
    }), this.#i.arm(), !0;
  }
  #n(t, e, n) {
    if (t.action !== "seekStep" || t.value === void 0) return 0;
    if (!n || this.#t === null) return t.value;
    const i = this.#t, r = e.duration ?? 1 / 0, s = this.state.current.seekTotal, o = Math.abs(t.value);
    return (t.value < 0 ? Math.max(0, i - s) : Math.max(0, r - i - s)) >= o ? t.value : 0;
  }
};
const tE = {
  /** Present while the indicator is open. */
  open: "data-open",
  /** Direction of the seek as `"forward"` or `"backward"`. */
  direction: "data-direction",
  /** Present during the open transition. */
  transitionStarting: "data-starting-style",
  /** Present during the close transition. */
  transitionEnding: "data-ending-style"
};
var Ua = class va {
  static defaultProps = {
    label: "",
    step: 1,
    largeStep: 10,
    orientation: "horizontal",
    disabled: !1,
    thumbAlignment: "center",
    value: 0,
    min: 0,
    max: 100
  };
  static defaultInput = {
    pointerPercent: 0,
    dragPercent: 0,
    dragging: !1,
    pointing: !1,
    focused: !1
  };
  #e = { ...va.defaultProps };
  #t = { ...va.defaultInput };
  get props() {
    return this.#e;
  }
  get input() {
    return this.#t;
  }
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, va.defaultProps);
  }
  setInput(e) {
    this.#t = e;
  }
  getSliderState(e) {
    const { orientation: n, disabled: i, thumbAlignment: r } = this.#e, { pointerPercent: s, dragging: o, pointing: a, focused: l } = this.#t;
    return {
      value: e,
      fillPercent: this.percentFromValue(e),
      pointerPercent: s,
      dragging: o,
      pointing: a,
      interactive: o || a || l,
      orientation: n,
      disabled: i,
      thumbAlignment: r
    };
  }
  getLabel(e) {
    return Lt(this.#e.label, e) || "";
  }
  getAttrs(e) {
    return {
      role: "slider",
      tabIndex: e.disabled ? -1 : 0,
      autoComplete: "off",
      "aria-label": this.getLabel(e),
      "aria-valuemin": this.#e.min,
      "aria-valuemax": this.#e.max,
      "aria-valuenow": e.value,
      "aria-orientation": e.orientation,
      "aria-disabled": e.disabled ? "true" : void 0
    };
  }
  valueFromPercent(e) {
    const { min: n, max: i, step: r } = this.#e, s = n + e / 100 * (i - n);
    return gy(li(s, n, i), r, n);
  }
  /** Convert percent to a clamped value without applying step rounding. */
  rawValueFromPercent(e) {
    const { min: n, max: i } = this.#e;
    return li(n + e / 100 * (i - n), n, i);
  }
  percentFromValue(e) {
    const { min: n, max: i } = this.#e;
    return Ml(e, n, i);
  }
  /** Step as a percentage of the slider range. */
  getStepPercent() {
    const { step: e, min: n, max: i } = this.#e, r = i - n;
    return r > 0 ? e / r * 100 : 0;
  }
  /** Large step as a percentage of the slider range. */
  getLargeStepPercent() {
    const { largeStep: e, min: n, max: i } = this.#e, r = i - n;
    return r > 0 ? e / r * 100 : 0;
  }
  adjustPercentForAlignment(e, n, i) {
    if (this.#e.thumbAlignment === "center" || i === 0) return e;
    const r = n / i * 100 / 2, s = r, o = 100 - r;
    return s + e / 100 * (o - s);
  }
};
const yy = {
  /** Present when the user is actively dragging. */
  dragging: "data-dragging",
  /** Present when the pointer is over the slider. */
  pointing: "data-pointing",
  /** Present when dragging, pointing, or focus is active. */
  interactive: "data-interactive",
  /** Current axis of slider movement (`horizontal` or `vertical`). */
  orientation: "data-orientation",
  /** Present when the slider is non-interactive. */
  disabled: "data-disabled"
};
var iE = class {
  getGeometry(t) {
    const { ranges: e, min: n, max: i, orientation: r } = t, s = i - n;
    if (!Number.isFinite(s) || s <= 0) return [];
    const o = e.filter((a) => {
      const l = (a.end - a.start) / s, c = (a.start - n) / s;
      return Number.isFinite(l) && Number.isFinite(c) && l > 0;
    });
    return o.map((a, l) => {
      const c = (a.start - n) / s, u = (a.end - a.start) / s, d = `${u * 100}%`;
      return {
        ...a,
        index: l,
        last: l === o.length - 1,
        orientation: r,
        width: r === "horizontal" ? d : void 0,
        height: r === "vertical" ? d : void 0,
        startPercent: `${c * 100}%`,
        endPercent: `${(c + u) * 100}%`
      };
    });
  }
  getState(t, e, n) {
    const { last: i, ...r } = t, s = (u) => u >= t.start && (u < t.end || i && u === t.end), o = s(e.value), a = e.pointing && s(n), l = e.dragging && s(n), c = e.interactive && !e.pointing && !e.dragging;
    return {
      ...r,
      fillPercent: Ml(e.value, t.start, t.end),
      active: o,
      pointing: a,
      dragging: l,
      highlighted: t.highlight !== !1 && a,
      interactive: a || l || c && o
    };
  }
};
const Xs = {
  /** Fill level percentage (0–100). */
  fill: "--media-slider-fill",
  /** Pointer position percentage (0–100). */
  pointer: "--media-slider-pointer",
  /** Buffer level percentage (0–100). */
  buffer: "--media-slider-buffer"
}, wh = {
  ...go,
  volumeWithValue: (t) => Be(dy, { value: t }),
  seekedTo: (t) => Be(cy, { time: un(t) }),
  playbackRate: (t) => Be(py, { rate: t })
};
function nE(t, e = zi) {
  return {
    ...bh(t),
    volumeWithValue: (n) => t(dy, { value: n }),
    seekedTo: (n) => t(cy, { time: un(n, { locale: e }) }),
    playbackRate: (n) => t(py, { rate: n })
  };
}
function rE(t) {
  return t === "toggleMuted" || t === "volumeStep";
}
function sE(t) {
  return t <= 0 ? "off" : t <= 0.5 ? "low" : "high";
}
function by(t) {
  return `${Math.round(li(t, 0, 1) * 100)}%`;
}
function oE(t) {
  return t.value ?? "";
}
function _y(t, e) {
  const n = e.muted === !0, i = e.volume ?? 0;
  if (t.action === "toggleMuted") return {
    snapshotVolume: i,
    nextMuted: !n,
    nextVolume: i
  };
  if (t.action === "volumeStep") {
    const r = li(i + (t.value ?? 0), 0, 1);
    return {
      snapshotVolume: i,
      nextMuted: n && r <= 0,
      nextVolume: r
    };
  }
  return {
    snapshotVolume: i,
    nextMuted: n,
    nextVolume: i
  };
}
function wy(t, e, n = go, i) {
  const r = i ?? _y(t, e), s = r.nextMuted ? "off" : sE(r.nextVolume), o = r.nextMuted ? "0%" : by(r.nextVolume);
  return {
    status: s === "off" ? "volume-off" : s === "low" ? "volume-low" : "volume-high",
    label: s === "off" ? n.muted : n.volume,
    value: o,
    volumeLevel: s
  };
}
function aE(t, e, n = wh) {
  const i = [];
  return jn(t.paused, e.paused) && i.push(e.paused ? n.paused : n.playing), jn(t.subtitlesShowing, e.subtitlesShowing) && e.subtitlesAvailable !== !1 && i.push(e.subtitlesShowing ? n.captionsOn : n.captionsOff), jn(t.isFullscreen, e.isFullscreen) && i.push(e.isFullscreen ? n.fullscreen : n.exitFullscreen), jn(t.isPictureInPicture, e.isPictureInPicture) && i.push(e.isPictureInPicture ? n.pictureInPicture : n.exitPictureInPicture), jn(t.playbackRate, e.playbackRate) && i.push(n.playbackRate(`${e.playbackRate}×`)), i.length > 0 ? i.join(". ") : null;
}
function lE(t, e, n = wh) {
  if (!jn(t.volume, e.volume) && !jn(t.muted, e.muted)) return null;
  const i = e.volume ?? t.volume, r = e.muted ?? t.muted;
  return i === void 0 && r === void 0 ? null : r || (i ?? 0) <= 0 ? n.muted : n.volumeWithValue(by(i ?? 0));
}
function jn(t, e) {
  return t !== void 0 && e !== void 0 && !Object.is(t, e);
}
const cE = 200;
var uE = class {
  state = at({
    generation: 0,
    label: null
  });
  #e = {};
  #t = null;
  #i = null;
  #n = null;
  #r = null;
  #s = new $l(() => this.state.patch({ label: null }), () => Rl(this.#e));
  setProps(t) {
    this.#e = t;
  }
  resetSnapshot() {
    this.#t = null, this.#i = null, this.#n = null, this.#l(), this.#s.close();
  }
  destroy() {
    this.#l(), this.#s.destroy();
  }
  processSnapshot(t) {
    const e = this.#t;
    if (this.#t = t, !e) return !1;
    const n = this.#o(), i = aE(e, t, n), r = i !== null && this.#a(i), s = this.#h(e, t, n, r), o = this.#d(e, t, n, r || s);
    return r || s || o;
  }
  #o() {
    return {
      ...wh,
      ...this.#e.labels
    };
  }
  #a(t) {
    return this.#l(), this.state.patch({
      generation: this.state.current.generation + 1,
      label: t
    }), this.#s.arm(), !0;
  }
  #d(t, e, n, i) {
    const r = lE(t, e, n);
    return r === null || i || !this.#c() ? !1 : (this.#u(r), !0);
  }
  #h(t, e, n, i) {
    if (t.seeking !== !0 && e.seeking === !0)
      return this.#i = t.currentTime ?? null, this.#n = e.currentTime ?? null, this.#l(), !1;
    if (e.seeking === !0)
      return this.#n = e.currentTime ?? this.#n, !1;
    if (t.seeking !== !0 || e.seeking !== !1) return !1;
    const r = e.currentTime ?? this.#n, s = this.#i;
    return this.#i = null, this.#n = null, r == null || Object.is(r, s) || i || !this.#c() ? !1 : (this.#u(n.seekedTo(r)), !0);
  }
  #u(t) {
    this.#l(), this.#r = setTimeout(() => {
      this.#r = null, this.#c() && this.#a(t);
    }, cE);
  }
  #c() {
    return this.#e.shouldAnnounce?.() !== !1;
  }
  #l() {
    this.#r !== null && (clearTimeout(this.#r), this.#r = null);
  }
};
function dE(t, e, n = go) {
  switch (t.action) {
    case "togglePaused": {
      const i = e.paused !== void 0 ? !e.paused : !0;
      return {
        status: i ? "pause" : "play",
        label: i ? n.paused : n.playing,
        value: null
      };
    }
    case "toggleMuted":
    case "volumeStep":
      return wy(t, e, n);
    case "toggleSubtitles": {
      if (e.subtitlesAvailable === !1) return null;
      const i = e.subtitlesShowing !== void 0 ? !e.subtitlesShowing : !0;
      return {
        status: i ? "captions-on" : "captions-off",
        label: i ? n.captionsOn : n.captionsOff,
        value: null
      };
    }
    case "toggleFullscreen": {
      const i = e.isFullscreen !== void 0 ? !e.isFullscreen : !0;
      return {
        status: i ? "fullscreen" : "exit-fullscreen",
        label: i ? n.fullscreen : n.exitFullscreen,
        value: null
      };
    }
    case "togglePictureInPicture": {
      const i = e.isPictureInPicture !== void 0 ? !e.isPictureInPicture : !0;
      return {
        status: i ? "pip" : "exit-pip",
        label: i ? n.pictureInPicture : n.exitPictureInPicture,
        value: null
      };
    }
    default:
      return null;
  }
}
function hE(t) {
  return t.value ?? t.label ?? "";
}
const fE = {
  open: !1,
  generation: 0,
  status: null,
  label: null,
  value: null,
  transitionStarting: !1,
  transitionEnding: !1
};
var pE = class {
  state = at({ ...fE });
  #e = {};
  #t = new $l(() => this.state.patch({
    open: !1,
    status: null,
    label: null,
    value: null
  }), () => Rl(this.#e));
  setProps(t) {
    this.#e = t;
  }
  destroy() {
    this.#t.destroy();
  }
  close() {
    this.#t.close();
  }
  processEvent(t, e) {
    if (!v2(t.action, this.#e.actions)) return !1;
    const n = dE(t, e, {
      ...go,
      ...this.#e.labels
    }) ?? this.#e.deriveCustomStatus?.(t, e);
    return n ? (this.state.patch({
      open: !0,
      generation: this.state.current.generation + 1,
      status: n.status,
      label: n.label,
      value: n.value
    }), this.#t.arm(), !0) : !1;
  }
};
const mE = {
  /** Present while the indicator is open. */
  open: "data-open",
  /** Predicted visual status for the handled input action. */
  status: "data-status",
  /** Present during the open transition. */
  transitionStarting: "data-starting-style",
  /** Present during the close transition. */
  transitionEnding: "data-ending-style"
};
function ky(t, e, n) {
  let i = 0, r = t.length - 1, s = -1;
  for (; i <= r; ) {
    const o = i + r >>> 1;
    n(t[o]) <= e ? (s = o, i = o + 1) : r = o - 1;
  }
  return s;
}
function gE(t, e, n) {
  const i = ky(t, e, n);
  return i < 0 ? void 0 : t[i];
}
function vE(t, e, n, i) {
  const r = ky(t, e, n);
  if (r < 0) return;
  const s = t[r], o = i(s), a = r === t.length - 1;
  return e < o || a && e === o ? s : void 0;
}
var xy = class {
  findActiveThumbnail(t, e) {
    return gE(t, e, (n) => n.startTime);
  }
  /**
  * Parse CSS constraint strings into numeric `ThumbnailConstraints`.
  *
  * Accepts any object with string `minWidth`/`maxWidth`/`minHeight`/`maxHeight` properties — `CSSStyleDeclaration`
  * satisfies this structurally.
  */
  parseConstraints(t) {
    const e = parseFloat(t.minWidth), n = parseFloat(t.maxWidth), i = parseFloat(t.minHeight), r = parseFloat(t.maxHeight);
    return {
      minWidth: Number.isFinite(e) ? e : 0,
      maxWidth: Number.isFinite(n) ? n : 1 / 0,
      minHeight: Number.isFinite(i) ? i : 0,
      maxHeight: Number.isFinite(r) ? r : 1 / 0
    };
  }
  /**
  * Calculate a uniform scale factor that sizes `tileWidth × tileHeight` to the given CSS min/max constraints while
  * preserving aspect ratio.
  *
  * - Fills the max constraints, scaling the tile up as readily as down. A box that grows — entering fullscreen widens it
  *   through a container query — has to take the tile with it rather than leave it at its native size.
  * - Raises that to meet min constraints, which win over max as they do in CSS.
  * - Returns `1` when unconstrained.
  */
  calculateScale(t, e, n) {
    const { minWidth: i, maxWidth: r, minHeight: s, maxHeight: o } = n, a = Math.min(r / t, o / e), l = Math.max(i / t, s / e), c = Number.isFinite(a) ? a : 1;
    return Number.isFinite(l) && l > c ? l : c;
  }
  /**
  * Compute container and image dimensions for the current thumbnail, scaled to the element's CSS min/max constraints.
  *
  * The container clips the sprite sheet via `overflow: hidden`, and the image is positioned with `transform:
  * translate()` to show the correct tile.
  */
  resize(t, e, n, i) {
    const r = t.width ?? e, s = t.height ?? n;
    if (!r || !s) return;
    const o = this.calculateScale(r, s, i), a = t.coords?.x ?? 0, l = t.coords?.y ?? 0, c = o !== 1 ? 1 : 0;
    return {
      scale: o,
      containerWidth: Math.max(0, Math.floor(r * o) - c * 2),
      containerHeight: Math.max(0, Math.floor(s * o) - c * 2),
      imageWidth: Math.ceil(e * o),
      imageHeight: Math.ceil(n * o),
      offsetX: Math.ceil(a * o) + c,
      offsetY: Math.ceil(l * o) + c
    };
  }
  /**
  * Resolve the CORS mode the image should request with.
  *
  * `null` opts out and drops the attribute. Any other explicit value wins, including `''`, which the CORS-settings
  * attribute reads as Anonymous. Otherwise the inherited mode applies, which renderers supply only for
  * `<track>`-sourced thumbnails since a list set directly may point at a host unrelated to the media component.
  */
  resolveCrossOrigin(t, e) {
    if (!Fi(t))
      return Ce(t) ? e ?? void 0 : t;
  }
  getState(t, e, n) {
    return {
      loading: t,
      error: e,
      hidden: !t && !n
    };
  }
  getAttrs(t) {
    return {
      dir: "ltr",
      role: "img",
      "aria-hidden": "true"
    };
  }
};
const yE = {
  loading: "data-loading",
  error: "data-error",
  hidden: "data-hidden"
};
function bE(t, e) {
  const n = t.trim().split("#"), i = n[0] ?? "", r = n[1], s = e ? new URL(i, e).href : i;
  if (!r) return { url: s };
  const o = r.indexOf("=");
  if (o === -1) return { url: s };
  const a = r.slice(0, o), l = r.slice(o + 1).split(",").map(Number), c = {};
  for (let d = 0; d < a.length; d++) {
    const h = a[d], f = l[d];
    h && Vn(f) && !Number.isNaN(f) && (c[h] = f);
  }
  const u = { url: s };
  return Vn(c.w) && (u.width = c.w), Vn(c.h) && (u.height = c.h), Vn(c.x) && Vn(c.y) && (u.coords = {
    x: c.x,
    y: c.y
  }), u;
}
function _E(t, e) {
  const n = [];
  for (const i of t) {
    const r = bE(i.text, e), s = {
      url: r.url,
      startTime: i.startTime,
      endTime: i.endTime
    };
    r.width && (s.width = r.width), r.height && (s.height = r.height), r.coords && (s.coords = r.coords), n.push(s);
  }
  return n;
}
const jt = "time.", wE = {
  key: `${jt}current`,
  text: "Current time"
}, kE = {
  key: `${jt}duration`,
  text: "Duration"
}, xE = {
  key: `${jt}remaining`,
  text: "Remaining"
}, SE = {
  key: `${jt}elapsedSuffix`,
  text: "{duration} elapsed"
}, PE = {
  key: `${jt}durationSuffix`,
  text: "{duration} duration"
}, EE = {
  key: `${jt}remainingSuffix`,
  text: "{duration} remaining"
}, TE = {
  key: `${jt}showElapsed`,
  text: "Show elapsed time, {duration}."
}, CE = {
  key: `${jt}showDuration`,
  text: "Show duration, {duration}."
}, AE = {
  key: `${jt}showRemaining`,
  text: "Show remaining time, {duration}."
}, $E = {
  key: `${jt}toggleElapsed`,
  text: "Toggle between elapsed and remaining time."
}, _p = {
  key: `${jt}toggleDuration`,
  text: "Toggle between duration and remaining time."
}, RE = {
  key: `${jt}position`,
  text: "{current} of {duration}"
}, Sy = {
  key: `${jt}unknown`,
  text: "Media not loaded, unknown time."
}, ME = {
  current: TE,
  duration: CE,
  remaining: AE
}, OE = {
  current: wE,
  duration: kE,
  remaining: xE
}, IE = {
  current: $E,
  duration: _p,
  remaining: _p
};
var uc = class Uu {
  static defaultProps = {
    type: "current",
    negativeSign: "-",
    label: "",
    toggle: !1
  };
  #e = { ...Uu.defaultProps };
  #t = null;
  #i;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Uu.defaultProps);
  }
  setMedia(e) {
    this.#t = e;
  }
  /** @internal Platform adapters set the active i18n locale for digital time formatting. */
  setFormatLocale(e) {
    this.#i = e;
  }
  #n() {
    const e = this.#t, n = Gs(e), { type: i } = this.#e;
    switch (i) {
      case "current":
        return e.currentTime;
      case "duration":
        return n;
      case "remaining":
        return e.currentTime - n;
      default:
        return 0;
    }
  }
  #r() {
    const e = this.#t, n = this.#n(), i = Gs(e), r = this.#i === void 0 ? void 0 : { locale: this.#i };
    return _h(Math.abs(n), i, r);
  }
  #s() {
    const { type: e } = this.#e, n = this.#n();
    return un(e === "remaining" ? n < 0 ? n : -Math.abs(n) : n);
  }
  #o() {
    const e = this.#n();
    return G2(Math.abs(e));
  }
  #a(e, n) {
    return e === "current" ? n === "remaining" ? "current" : "remaining" : n === "duration" ? "remaining" : "duration";
  }
  getLabel(e, n = this.#e.type) {
    const i = Lt(this.#e.label, e);
    if (i !== void 0) return i;
    if (e.disabled || e.unavailable) return Sy;
    if (!this.#e.toggle) return OE[this.#e.type];
    const r = this.#a(n, e.type);
    return ME[r];
  }
  getLabelParams(e) {
    if (Lt(this.#e.label, e) !== void 0 || e.disabled || !this.#e.toggle) return;
    const n = this.#i === void 0 ? void 0 : { locale: this.#i }, i = un(Math.abs(e.seconds), n);
    switch (e.type) {
      case "current":
        return { duration: `${i} elapsed` };
      case "duration":
        return { duration: `${i} duration` };
      case "remaining":
        return { duration: `${i} remaining` };
    }
  }
  getDescription(e, n = this.#e.type) {
    return this.#e.toggle && !e.disabled ? IE[n] : void 0;
  }
  getAttrs(e, n = this.#e.type) {
    return {
      "aria-label": this.getLabel(e, n),
      "aria-description": this.getDescription(e, n),
      "aria-disabled": this.#e.toggle && e.disabled ? "true" : void 0,
      role: this.#e.toggle ? "button" : void 0,
      tabIndex: this.#e.toggle ? e.disabled ? -1 : 0 : void 0
    };
  }
  getState() {
    const e = this.#n(), n = !mh(this.#t);
    return {
      type: this.#e.type,
      disabled: this.#e.toggle && n,
      unavailable: !this.#e.toggle && n,
      seconds: e,
      negative: this.#e.type === "remaining" && e < 0,
      text: this.#r(),
      phrase: this.#s(),
      datetime: this.#o()
    };
  }
};
const DE = {
  /** The type of time being displayed. */
  type: "data-type",
  /** Present when the time toggle is disabled. */
  disabled: "data-disabled",
  /** Present when the non-interactive time value is unavailable. */
  unavailable: "data-unavailable"
}, FE = {
  key: "slider.seek",
  text: "Seek"
};
var ya = class Wu extends Ua {
  static defaultProps = {
    ...Ua.defaultProps,
    label: "",
    changeThrottle: 100,
    pauseOnDrag: !1
  };
  #e = { ...Wu.defaultProps };
  #t = null;
  #i;
  #n = !1;
  constructor(e) {
    super(), e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Wu.defaultProps), super.setProps({
      ...e,
      min: 0
    });
  }
  setMedia(e) {
    this.#t = e;
  }
  /** @internal Platform adapters set the active i18n locale for `aria-valuetext` time formatting. */
  setFormatLocale(e) {
    this.#i = e;
  }
  getState() {
    const e = this.#t, { currentTime: n, seeking: i, buffered: r } = e, s = Gs(e);
    super.setProps({
      ...this.#e,
      disabled: this.#e.disabled || !mh(e),
      min: 0,
      max: s
    });
    const o = super.getSliderState(n), a = r.length > 0 ? r[r.length - 1][1] : 0, l = Ml(a, 0, s);
    return {
      ...o,
      currentTime: n,
      duration: s,
      seeking: i,
      bufferPercent: l
    };
  }
  getLabel(e) {
    return super.getLabel(e) || FE;
  }
  #r(e) {
    return e.dragging ? this.rawValueFromPercent(e.pointerPercent) : e.value;
  }
  #s(e) {
    return this.#i === void 0 ? un(e) : un(e, { locale: this.#i });
  }
  getValueText(e) {
    return e.duration <= 0 ? Sy : Number.isFinite(e.duration) ? RE : this.getValueTextParams(e).current;
  }
  getValueTextParams(e) {
    const n = this.#s(this.#r(e));
    return Number.isFinite(e.duration) ? {
      current: n,
      duration: this.#s(e.duration)
    } : { current: n };
  }
  /**
  * Pause playback when a drag begins if `pauseOnDrag` is enabled, remembering whether media was playing so `endDrag`
  * can resume it.
  */
  startDrag(e) {
    this.#n = !1, this.#e.pauseOnDrag && e && !e.paused && (this.#n = !0, e.pause());
  }
  /**
  * Resume playback if `startDrag` paused it. Resume depends only on the intent captured at drag start, so it survives
  * `pauseOnDrag` being toggled mid-drag. Safe to call on teardown — a no-op unless a drag paused playback.
  */
  endDrag(e) {
    this.#n && e?.play().catch(() => {
    }), this.#n = !1;
  }
  getAttrs(e) {
    const n = super.getAttrs(e), i = this.#r(e);
    return {
      ...n,
      "aria-valuenow": i,
      "aria-valuetext": this.getValueText(e)
    };
  }
};
const wp = {
  ...yy,
  /** Present when a seek operation is in progress. */
  seeking: "data-seeking"
};
function LE(t, e) {
  const n = t.id, i = `cue-${typeof n == "string" && n ? `${n}-` : ""}${t.startTime}-${t.text}`, r = e.get(i) ?? 0;
  return e.set(i, r + 1), r ? `${i}-${r}` : i;
}
function NE(t, e, n) {
  if (!Number.isFinite(e) || !Number.isFinite(n) || n <= e) return [];
  const i = /* @__PURE__ */ new Map(), r = t.map((l, c) => ({
    cue: l,
    index: c,
    key: LE(l, i)
  })).filter(({ cue: l }) => Number.isFinite(l.startTime) && Number.isFinite(l.endTime)).sort((l, c) => l.cue.startTime - c.cue.startTime || l.index - c.index), s = [];
  let o = e, a = "start";
  for (const { cue: l, key: c } of r) {
    const u = Math.max(e, l.startTime), d = Math.min(n, l.endTime);
    if (d <= u) continue;
    u > o && s.push({
      key: `gap-${a}-${c}`,
      start: o,
      end: u,
      cue: null
    });
    const h = Math.max(u, o);
    d <= h || (s.push({
      key: c,
      start: h,
      end: d,
      cue: l
    }), o = d, a = c);
  }
  return s.length === 0 ? [{
    key: "gap-start-end",
    start: e,
    end: n,
    cue: null
  }] : (o < n && s.push({
    key: `gap-${a}-end`,
    start: o,
    end: n,
    cue: null
  }), s);
}
var Py = class {
  #e = null;
  #t = 0;
  #i = 0;
  #n = null;
  getRanges(t, e, n) {
    if (this.#n && (this.#e === t || this.#e?.length === 0 && t.length === 0) && this.#t === e && this.#i === n) return this.#n;
    const i = n > e, r = i ? n : e + 1, s = NE(i ? t : [], e, r), o = s.map(({ key: a, start: l, end: c, cue: u }) => ({
      key: a,
      start: l,
      end: c,
      highlight: u !== null
    }));
    return this.#e = t, this.#t = e, this.#i = n, this.#n = {
      chapters: s,
      ranges: o,
      max: r
    }, this.#n;
  }
  findChapter(t, e) {
    return vE(t, e, (n) => n.start, (n) => n.end);
  }
  getState(t, e, n) {
    return {
      ...t,
      cue: e[t.index]?.cue ?? null,
      bufferPercent: Ml(n, t.start, t.end)
    };
  }
};
const VE = {
  /** Present when playback is within the chapter. */
  active: "data-active",
  /** Present when pointer interaction highlights the chapter. */
  highlighted: "data-highlighted"
}, Es = {
  start: "--media-slider-chapter-start",
  end: "--media-slider-chapter-end",
  width: "--media-slider-chapter-width",
  fill: "--media-slider-chapter-fill",
  buffer: "--media-slider-chapter-buffer"
};
var jE = class {
  getState(t, e) {
    const { title: n } = t;
    return {
      title: n,
      hidden: n.length === 0,
      visible: e?.controlsVisible ?? !1
    };
  }
};
const zE = {
  /** Present when the element is hidden because no title is available. */
  hidden: "data-hidden",
  /** Present while the player controls are visible. */
  visible: "data-visible"
};
var Tn = class qu {
  static defaultProps = {
    side: "top",
    align: "center",
    open: !1,
    defaultOpen: !1,
    delay: 600,
    closeDelay: 0,
    disableHoverablePopup: !0,
    disabled: !1,
    sticky: !1
  };
  #e = { ...qu.defaultProps };
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, qu.defaultProps);
  }
  #t = null;
  setInput(e) {
    this.#t = e;
  }
  getState() {
    const e = this.#t;
    return {
      open: e.active,
      status: e.status,
      side: this.#e.side,
      align: this.#e.align,
      ...mo(e.status)
    };
  }
  getPopupAttrs(e) {
    return {
      popover: "manual",
      role: "presentation"
    };
  }
};
const BE = {
  /** Present when the tooltip is open. */
  open: "data-open",
  /** Indicates the rendered side of the tooltip after collision handling. */
  side: "data-side",
  /** Indicates how the tooltip is aligned relative to the specified side. */
  align: "data-align",
  ...Cl
};
var HE = class Gu {
  static defaultProps = {
    delay: 600,
    closeDelay: 0,
    timeout: 400
  };
  #e = { ...Gu.defaultProps };
  #t = 0;
  #i = !1;
  constructor(e) {
    e && this.setProps(e);
  }
  setProps(e) {
    this.#e = nt(e, Gu.defaultProps);
  }
  get delay() {
    return this.#e.delay;
  }
  get closeDelay() {
    return this.#e.closeDelay;
  }
  shouldSkipDelay() {
    return this.#i ? !0 : Date.now() - this.#t < this.#e.timeout;
  }
  notifyOpen() {
    this.#i = !0;
  }
  notifyClose() {
    this.#i = !1, this.#t = Date.now();
  }
};
const UE = {
  /** Distance between the popup and the trigger along the side axis. */
  sideOffset: "--media-tooltip-side-offset",
  /** Distance between the popup and the trigger along the alignment axis. */
  alignOffset: "--media-tooltip-align-offset",
  /** Minimum distance between the popup and the positioning boundary. */
  boundaryOffset: "--media-tooltip-boundary-offset",
  /** The anchor element's width. */
  anchorWidth: "--media-tooltip-anchor-width",
  /** The anchor element's height. */
  anchorHeight: "--media-tooltip-anchor-height",
  /** Available width between the trigger and the boundary edge. */
  availableWidth: "--media-tooltip-available-width",
  /** Available height between the trigger and the boundary edge. */
  availableHeight: "--media-tooltip-available-height"
}, WE = 300, qE = {
  open: !1,
  generation: 0,
  level: null,
  value: null,
  fill: null,
  min: !1,
  max: !1,
  transitionStarting: !1,
  transitionEnding: !1
};
var GE = class {
  state = at({ ...qE });
  #e = {};
  #t = null;
  #i = new $l(() => this.state.patch({
    open: !1,
    level: null,
    value: null,
    fill: null,
    min: !1,
    max: !1
  }), () => Rl(this.#e));
  setProps(t) {
    this.#e = t;
  }
  destroy() {
    this.#i.destroy(), this.#s();
  }
  close() {
    this.#s(), this.#i.close();
  }
  processEvent(t, e) {
    if (!rE(t.action)) return !1;
    const n = this.state.current, i = _y(t, e), r = wy(t, e, {
      ...go,
      ...this.#e.labels
    }, i), s = KE(t, i.snapshotVolume, i.nextVolume), o = s !== null && !t.repeat;
    return s || this.#s(), this.state.patch({
      open: !0,
      generation: n.generation + 1,
      level: r.volumeLevel,
      value: r.value,
      fill: r.value,
      min: s && t.repeat ? n.min : o && s === "min",
      max: s && t.repeat ? n.max : o && s === "max"
    }), o && this.#n(), this.#i.arm(), !0;
  }
  #n() {
    this.#r(), this.#t = setTimeout(() => {
      this.#t = null, this.state.patch({
        min: !1,
        max: !1
      });
    }, WE);
  }
  #r() {
    this.#t !== null && (clearTimeout(this.#t), this.#t = null);
  }
  #s() {
    this.#r();
  }
};
function KE(t, e, n) {
  return t.action !== "volumeStep" || t.value === void 0 || t.value === 0 || n !== e ? null : t.value < 0 ? "min" : "max";
}
const YE = {
  /** Present while the indicator is open. */
  open: "data-open",
  /** Predicted volume level as `"off"`, `"low"`, or `"high"`. */
  level: "data-level",
  /** Present briefly when a downward step cannot lower the volume further. */
  min: "data-min",
  /** Present briefly when an upward step cannot raise the volume further. */
  max: "data-max",
  /** Present during the open transition. */
  transitionStarting: "data-starting-style",
  /** Present during the close transition. */
  transitionEnding: "data-ending-style"
}, XE = {
  /** Current predicted volume percentage, set on the Fill part. */
  fill: "--media-volume-fill"
};
var JE = class extends Di {
  static defaultProps = Di.defaultProps;
  #e = null;
  setMedia(t) {
    this.#e = t;
  }
  getState() {
    const t = this.#e.volumeAvailability;
    return {
      ...super.getState(),
      availability: t,
      hidden: t !== "available"
    };
  }
};
const ZE = {
  /** Present when the popover is open. */
  open: "data-open",
  /** Indicates the rendered side after collision handling. */
  side: "data-side",
  /** Indicates how the popup is aligned relative to its side. */
  align: "data-align",
  /** Present during the open transition. */
  transitionStarting: "data-starting-style",
  /** Present during the close transition. */
  transitionEnding: "data-ending-style",
  /** Indicates volume control availability (`available`, `unavailable`, or `unsupported`). */
  availability: "data-availability",
  /** Present when volume level controls are unavailable. */
  hidden: "data-hidden"
}, kp = /* @__PURE__ */ new Map();
function QE(t) {
  return t === void 0 ? "" : Array.isArray(t) ? t.join(":") : t;
}
function xp(t) {
  const e = QE(t);
  let n = kp.get(e);
  if (!n) try {
    n = new Intl.NumberFormat(t, {
      style: "percent",
      maximumFractionDigits: 0
    }), kp.set(e, n);
  } catch {
    return;
  }
  return n;
}
function eT(t) {
  return `${Math.round(Math.min(1, Math.max(0, t)) * 100)}%`;
}
function tT(t, e) {
  const n = !Vn(t) || !Number.isFinite(t) ? 0 : Math.min(1, Math.max(0, t));
  try {
    const i = xp(e) ?? xp(void 0);
    if (i) return i.format(n);
  } catch {
  }
  return eT(n);
}
var Bo = class Ku extends Ua {
  static defaultProps = {
    ...Ua.defaultProps,
    label: "",
    step: 5,
    wheelStep: 5
  };
  #e = Ku.defaultProps.wheelStep;
  #t = null;
  #i;
  constructor(e) {
    super(), e && this.setProps(e);
  }
  setProps(e) {
    const n = nt(e, Ku.defaultProps);
    this.#e = n.wheelStep, super.setProps(n);
  }
  setMedia(e) {
    this.#t = e;
  }
  /** @internal Platform adapters set the active i18n locale for `aria-valuetext` percent formatting. */
  setFormatLocale(e) {
    this.#i = e;
  }
  getState() {
    const e = this.#t, { volume: n, muted: i } = e, r = i || n === 0, { dragging: s, dragPercent: o } = this.input, a = n * 100, l = s ? this.valueFromPercent(o) : a, c = super.getSliderState(l), u = e.volumeAvailability;
    return {
      ...c,
      disabled: c.disabled || u !== "available",
      fillPercent: r ? 0 : c.fillPercent,
      volume: n,
      muted: r,
      availability: u,
      hidden: u !== "available"
    };
  }
  /** Wheel step as a percentage of the slider range. */
  getWheelStepPercent() {
    const { min: e, max: n } = this.props, i = n - e;
    return i > 0 ? this.#e / i * 100 : 0;
  }
  getLabel(e) {
    return super.getLabel(e) || yh;
  }
  getValueText(e) {
    return e.muted ? f2 : this.getValueTextParams(e).percent;
  }
  getValueTextParams(e) {
    return { percent: tT(e.value / 100, this.#i) };
  }
  getAttrs(e) {
    return {
      ...super.getAttrs(e),
      "aria-valuetext": this.getValueText(e)
    };
  }
};
const Sp = {
  ...yy,
  availability: "data-availability",
  hidden: "data-hidden"
}, Pp = /* @__PURE__ */ Symbol.for("@videojs/i18n-registry");
function Ey() {
  const t = globalThis, e = t[Pp];
  if (e) return e;
  const n = {
    layers: /* @__PURE__ */ new Map(),
    subscribers: /* @__PURE__ */ new Set()
  };
  return t[Pp] = n, n;
}
function iT(t) {
  return t.trim().replaceAll("_", "-").toLowerCase();
}
function nT(t) {
  const e = t.indexOf("-x-"), n = (e === -1 ? t : t.slice(0, e)).indexOf("-u-");
  return n === -1 ? t : t.slice(0, n) + (e === -1 ? "" : t.slice(e));
}
function rT(t) {
  if (t[0] !== "zh") return;
  const e = t.find((n) => n === "hant" || n === "hans");
  return e === "hant" ? "zh-tw" : e === "hans" ? "zh-cn" : void 0;
}
function ba(t) {
  return nT(iT(t));
}
function Ty(t) {
  const e = ba(t);
  if (!e) return [zi];
  const n = e.split("-").filter(Boolean), i = [];
  for (let l = n.length; l >= 1; l--) i.push(n.slice(0, l).join("-"));
  const r = rT(n), s = i.indexOf("zh");
  r && s !== -1 && i.splice(s, 0, r);
  const o = [], a = /* @__PURE__ */ new Set();
  for (const l of i) a.has(l) || (a.add(l), o.push(l));
  return a.has(zi) || o.push(zi), o;
}
function sT(t) {
  const { layers: e } = Ey(), n = {};
  for (let i = t.length - 1; i >= 0; i--) {
    const r = t[i], s = e.get(r);
    s && Object.assign(n, s);
  }
  return n;
}
function oT(t) {
  return sT(Ty(t));
}
function aT(t) {
  const { subscribers: e } = Ey();
  return e.add(t), () => {
    e.delete(t);
  };
}
function lT(t) {
  return Je(t) && "key" in t && "text" in t;
}
function cT(t, e) {
  return (i, r) => {
    const s = r, o = typeof i != "string", a = o ? i.key : i, l = t[a], c = s?.default, u = s ? { ...s } : void 0;
    u && delete u.default;
    const d = l ?? (o ? i.text : c) ?? String(a);
    return ty(d, u);
  };
}
function uT(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function dT(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function i() {
      var r = !1;
      try {
        r = this instanceof i;
      } catch {
      }
      return r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(i) {
    var r = Object.getOwnPropertyDescriptor(t, i);
    Object.defineProperty(n, i, r.get ? r : {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  }), n;
}
var dc, Ep;
function hT() {
  if (Ep) return dc;
  Ep = 1;
  var t = Object.create, e = Object.defineProperty, n = Object.getOwnPropertyDescriptor, i = Object.getOwnPropertyNames, r = Object.getPrototypeOf, s = Object.prototype.hasOwnProperty, o = (B, $) => {
    for (var I in $)
      e(B, I, { get: $[I], enumerable: !0 });
  }, a = (B, $, I, q) => {
    if ($ && typeof $ == "object" || typeof $ == "function")
      for (let J of i($))
        !s.call(B, J) && J !== I && e(B, J, { get: () => $[J], enumerable: !(q = n($, J)) || q.enumerable });
    return B;
  }, l = (B, $, I) => (I = B != null ? t(r(B)) : {}, a(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !B || !B.__esModule ? e(I, "default", { value: B, enumerable: !0 }) : I,
    B
  )), c = (B) => a(e({}, "__esModule", { value: !0 }), B), u = {};
  o(u, {
    $dispatcherGuard: () => S,
    $makeReadOnly: () => C,
    $reset: () => P,
    $structuralCheck: () => K,
    c: () => k,
    clearRenderCounterRegistry: () => O,
    renderCounterRegistry: () => M,
    useRenderCounter: () => z
  }), dc = c(u);
  var d = l(uS), { useRef: h, useEffect: f, isValidElement: p } = d, v, g = (
    //@ts-ignore
    (v = d.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE) != null ? v : d.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  ), m = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), y, k = (
    // @ts-expect-error
    typeof ((y = d.__COMPILER_RUNTIME) == null ? void 0 : y.c) == "function" ? (
      // @ts-expect-error
      d.__COMPILER_RUNTIME.c
    ) : function($) {
      return d.useMemo(() => {
        const I = new Array($);
        for (let q = 0; q < $; q++)
          I[q] = m;
        return I[m] = !0, I;
      }, []);
    }
  ), _ = {};
  [
    "readContext",
    "useCallback",
    "useContext",
    "useEffect",
    "useImperativeHandle",
    "useInsertionEffect",
    "useLayoutEffect",
    "useMemo",
    "useReducer",
    "useRef",
    "useState",
    "useDebugValue",
    "useDeferredValue",
    "useTransition",
    "useMutableSource",
    "useSyncExternalStore",
    "useId",
    "unstable_isNewReconciler",
    "getCacheSignal",
    "getCacheForType",
    "useCacheRefresh"
  ].forEach((B) => {
    _[B] = () => {
      throw new Error(
        `[React] Unexpected React hook call (${B}) from a React compiled function. Check that all hooks are called directly and named according to convention ('use[A-Z]') `
      );
    };
  });
  var w = null;
  _.useMemoCache = (B) => {
    if (w == null)
      throw new Error(
        "React Compiler internal invariant violation: unexpected null dispatcher"
      );
    return w.useMemoCache(B);
  };
  function T(B) {
    return g.ReactCurrentDispatcher.current = B, g.ReactCurrentDispatcher.current;
  }
  var E = [];
  function S(B) {
    const $ = g.ReactCurrentDispatcher.current;
    if (B === 0) {
      if (E.push($), E.length === 1 && (w = $), $ === _)
        throw new Error(
          "[React] Unexpected call to custom hook or component from a React compiled function. Check that (1) all hooks are called directly and named according to convention ('use[A-Z]') and (2) components are returned as JSX instead of being directly invoked."
        );
      T(_);
    } else if (B === 1) {
      const I = E.pop();
      if (I == null)
        throw new Error(
          "React Compiler internal error: unexpected null in guard stack"
        );
      E.length === 0 && (w = null), T(I);
    } else if (B === 2)
      E.push($), T(w);
    else if (B === 3) {
      const I = E.pop();
      if (I == null)
        throw new Error(
          "React Compiler internal error: unexpected null in guard stack"
        );
      T(I);
    } else
      throw new Error("React Compiler internal error: unreachable block" + B);
  }
  function P(B) {
    for (let $ = 0; $ < B.length; $++)
      B[$] = m;
  }
  function C() {
    throw new Error("TODO: implement $makeReadOnly in react-compiler-runtime");
  }
  var M = /* @__PURE__ */ new Map();
  function O() {
    for (const B of M.values())
      B.forEach(($) => {
        $.count = 0;
      });
  }
  function W(B, $) {
    let I = M.get(B);
    I == null && (I = /* @__PURE__ */ new Set(), M.set(B, I)), I.add($);
  }
  function H(B, $) {
    const I = M.get(B);
    I?.delete($);
  }
  function z(B) {
    const $ = h(null);
    $.current != null && ($.current.count += 1), f(() => {
      if ($.current == null) {
        const I = { count: 0 };
        W(B, I), $.current = I;
      }
      return () => {
        $.current !== null && H(B, $.current);
      };
    });
  }
  var F = /* @__PURE__ */ new Set();
  function K(B, $, I, q, J, D) {
    function A(U, j, ie, oe) {
      const Oe = `${q}:${D} [${J}] ${I}${ie} changed from ${U} to ${j} at depth ${oe}`;
      F.has(Oe) || (F.add(Oe), console.error(Oe));
    }
    const N = 2;
    function X(U, j, ie, oe) {
      if (!(oe > N)) {
        if (U === j)
          return;
        if (typeof U != typeof j)
          A(`type ${typeof U}`, `type ${typeof j}`, ie, oe);
        else if (typeof U == "object") {
          const Oe = Array.isArray(U), $e = Array.isArray(j);
          if (U === null && j !== null)
            A("null", `type ${typeof j}`, ie, oe);
          else if (j === null)
            A(`type ${typeof U}`, "null", ie, oe);
          else if (U instanceof Map)
            if (!(j instanceof Map))
              A("Map instance", "other value", ie, oe);
            else if (U.size !== j.size)
              A(
                `Map instance with size ${U.size}`,
                `Map instance with size ${j.size}`,
                ie,
                oe
              );
            else
              for (const [Ae, Bt] of U)
                j.has(Ae) ? X(Bt, j.get(Ae), `${ie}.get(${Ae})`, oe + 1) : A(
                  `Map instance with key ${Ae}`,
                  `Map instance without key ${Ae}`,
                  ie,
                  oe
                );
          else if (j instanceof Map)
            A("other value", "Map instance", ie, oe);
          else if (U instanceof Set)
            if (!(j instanceof Set))
              A("Set instance", "other value", ie, oe);
            else if (U.size !== j.size)
              A(
                `Set instance with size ${U.size}`,
                `Set instance with size ${j.size}`,
                ie,
                oe
              );
            else
              for (const Ae of j)
                U.has(Ae) || A(
                  `Set instance without element ${Ae}`,
                  `Set instance with element ${Ae}`,
                  ie,
                  oe
                );
          else if (j instanceof Set)
            A("other value", "Set instance", ie, oe);
          else if (Oe || $e)
            if (Oe !== $e)
              A(
                `type ${Oe ? "array" : "object"}`,
                `type ${$e ? "array" : "object"}`,
                ie,
                oe
              );
            else if (U.length !== j.length)
              A(
                `array with length ${U.length}`,
                `array with length ${j.length}`,
                ie,
                oe
              );
            else
              for (let Ae = 0; Ae < U.length; Ae++)
                X(U[Ae], j[Ae], `${ie}[${Ae}]`, oe + 1);
          else if (p(U) || p(j))
            p(U) !== p(j) ? A(
              `type ${p(U) ? "React element" : "object"}`,
              `type ${p(j) ? "React element" : "object"}`,
              ie,
              oe
            ) : U.type !== j.type ? A(
              `React element of type ${U.type}`,
              `React element of type ${j.type}`,
              ie,
              oe
            ) : X(
              U.props,
              j.props,
              `[props of ${ie}]`,
              oe + 1
            );
          else {
            for (const Ae in j)
              Ae in U || A(
                `object without key ${Ae}`,
                `object with key ${Ae}`,
                ie,
                oe
              );
            for (const Ae in U)
              Ae in j ? X(U[Ae], j[Ae], `${ie}.${Ae}`, oe + 1) : A(
                `object with key ${Ae}`,
                `object without key ${Ae}`,
                ie,
                oe
              );
          }
        } else {
          if (typeof U == "function")
            return;
          isNaN(U) || isNaN(j) ? isNaN(U) !== isNaN(j) && A(
            `${isNaN(U) ? "NaN" : "non-NaN value"}`,
            `${isNaN(j) ? "NaN" : "non-NaN value"}`,
            ie,
            oe
          ) : U !== j && A(U, j, ie, oe);
        }
      }
    }
    X(B, $, "", 0);
  }
  return dc;
}
var te = hT();
const kh = Le(null);
Le(void 0);
function zt() {
  const t = te.c(3), e = we(kh), [n, i] = P0(fT, 0);
  let r, s;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = () => aT(() => i()), s = [], t[0] = r, t[1] = s) : (r = t[0], s = t[1]), ye(r, s);
  let o;
  t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = cT(oT(zi)), t[2] = o) : o = t[2];
  const a = o;
  return e ? e.translator : a;
}
function fT(t) {
  return t + 1;
}
function yo() {
  return we(kh)?.locale ?? zi;
}
function wi(t) {
  const e = te.c(12);
  let n, i, r;
  e[0] !== t ? ({ children: n, token: r, ...i } = t, e[0] = t, e[1] = n, e[2] = i, e[3] = r) : (n = e[1], i = e[2], r = e[3]);
  const s = zt(), o = typeof n == "string" || typeof n == "number" ? String(n) : void 0;
  let a;
  e[4] !== n || e[5] !== o || e[6] !== s || e[7] !== r ? (a = r ? s({
    key: r,
    text: o ?? r
  }) : n, e[4] = n, e[5] = o, e[6] = s, e[7] = r, e[8] = a) : a = e[8];
  let l;
  return e[9] !== i || e[10] !== a ? (l = /* @__PURE__ */ b("span", {
    ...i,
    children: a
  }), e[9] = i, e[10] = a, e[11] = l) : l = e[11], l;
}
function Tp(t, e) {
  if (ke(t)) return t(e);
  t != null && (t.current = e);
}
function Cy(...t) {
  const e = t.flat();
  return (n) => {
    const i = e.map((r) => Tp(r, n));
    if (i.some(ke)) return () => {
      for (let r = 0; r < i.length; r++) {
        const s = i[r];
        ke(s) ? s() : Tp(e[r], null);
      }
    };
  };
}
function kn(...t) {
  return pt(Cy(...t), [...t]);
}
function Ay(t, e, n, i) {
  const r = te.c(4), s = F0, o = Se(void 0);
  let a;
  r[0] !== e || r[1] !== s || r[2] !== n ? (a = () => {
    const c = n(e());
    return o.current !== void 0 && s(o.current, c) ? o.current : (o.current = c, c);
  }, r[0] = e, r[1] = s, r[2] = n, r[3] = a) : a = r[3];
  const l = a;
  return is(t, l, l);
}
function Ur(t, e, n) {
  "use no memo";
  return Ay((i) => t.subscribe(i), () => t.current, e ?? L0);
}
const pT = () => pn;
function xh(t, e, n) {
  const i = te.c(6);
  let r;
  i[0] !== e || i[1] !== t ? (r = e ? (a) => t.subscribe(a) : pT, i[0] = e, i[1] = t, i[2] = r) : r = i[2];
  const s = r;
  let o;
  return i[3] !== e || i[4] !== t ? (o = e ? () => t.state : () => t, i[3] = e, i[4] = t, i[5] = o) : o = i[5], Ay(s, o, e ?? L0);
}
const ns = Le(null), mT = () => {
}, gT = {
  state: {},
  subscribe: () => mT
};
function vT(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b(ns.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function Ol() {
  const t = we(ns);
  if (!t) throw new Error("usePlayerContext must be used within a Player");
  return t;
}
function qe(t) {
  const { store: e } = Ol();
  return xh(e, t);
}
function Wa(t) {
  const e = we(ns), n = e?.store ?? gT, i = xh(n, e ? t : void 0);
  return e ? i : void 0;
}
function yT() {
  const { media: t } = Ol();
  return t;
}
function xn() {
  const { container: t } = Ol();
  return t;
}
function Sh() {
  return we(ns)?.container ?? null;
}
function bT() {
  return we(ns)?.setMedia;
}
function _T() {
  return we(ns)?.setContainer;
}
const $y = Le(void 0);
function wT(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b($y.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function Ph() {
  return we($y);
}
function kT(t, e) {
  return new Proxy(t, {
    get(n, i) {
      if (i === J0) return n;
      const r = hc(e, i) ?? n, s = r[i];
      return ke(s) && i !== "constructor" ? s.bind(r) : s;
    },
    set(n, i, r) {
      const s = hc(e, i) ?? n;
      return Reflect.set(s, i, r);
    },
    has(n, i) {
      return !ch(hc(e, i)) || i in n;
    }
  });
}
function hc(t, e) {
  if (Object.hasOwn(Object.prototype, e)) return null;
  for (const { mediaOverride: n } of t()) if (!ch(n) && !Ce(n[e])) return n;
  return null;
}
function Ho(t) {
  return !!t && "mediaOverride" in t;
}
var xT = class {
  #e = /* @__PURE__ */ new Map();
  #t = /* @__PURE__ */ new WeakMap();
  #i = { initTime: Date.now() };
  #n;
  #r = null;
  /** @param onChange - Called after an extension that overrides media members is registered or released. */
  constructor(t) {
    this.#n = t;
  }
  get size() {
    return this.#e.size;
  }
  get(t) {
    return this.#e.get(t);
  }
  /**
  * Register `extension`, replacing any earlier instance of the same class: connect it to the player and attach it to
  * the current target. Returns a release callback that only removes this exact instance.
  */
  register(t) {
    const e = t.constructor, n = this.#e.get(e);
    return n !== t && (n && this.#a(n), this.#e.set(e, t), t.connect?.(this.#i), this.#r && t.attach?.(this.#r), (Ho(n) || Ho(t)) && this.#n()), () => this.#o(t);
  }
  /**
  * Attach every extension to `target`. Extensions follow the media: a target with the same media is recorded without
  * re-attaching them, so a container change never restarts an extension's session.
  */
  attach(t) {
    if (this.#r?.media === t.media) {
      this.#r = t;
      return;
    }
    this.detach(), this.#r = t;
    for (const e of this.#e.values()) e.attach?.(t);
  }
  detach() {
    if (this.#r) {
      for (const t of this.#e.values()) t.detach?.();
      this.#r = null;
    }
  }
  /** Detach, disconnect, and drop every registration. Extensions are destroyed by their owners, not here. */
  destroy() {
    this.detach();
    for (const t of this.#e.values()) t.disconnect?.();
    this.#e.clear();
  }
  /**
  * The media as the store should see it: `media` itself unless a registered extension can override media members,
  * otherwise a facade that routes each member through the extensions' overrides first.
  */
  getStoreMedia(t) {
    if (!this.#s()) return t;
    let e = this.#t.get(t);
    return e || (e = kT(t, () => this.#e.values()), this.#t.set(t, e)), e;
  }
  #s() {
    for (const t of this.#e.values()) if (Ho(t)) return !0;
    return !1;
  }
  #o(t) {
    const e = t.constructor;
    this.#e.get(e) === t && (this.#e.delete(e), this.#a(t), Ho(t) && this.#n());
  }
  /** Undo `register` for an extension that is no longer registered: detach it from the media, then disconnect it. */
  #a(t) {
    this.#r && t.detach?.(), t.disconnect?.();
  }
};
function _t(t) {
  const e = Object.values(t.config ?? {}).map((n) => n.state);
  return {
    ...t,
    ...e.length > 0 ? { preserve: e } : {}
  };
}
function ST(t) {
  const e = t.map((n) => n.config ?? {});
  return Object.assign({}, ...e);
}
function Ry(t, e, n) {
  const i = t[e.action];
  if (typeof i != "function") throw new TypeError(`Missing config action "${String(e.action)}"`);
  i(n);
}
function qa(t, e, n) {
  if (!Ce(n)) return n;
  const i = e?.toLowerCase();
  if (t === "seekStep") return i === "arrowleft" || i === "j" ? -10 : 10;
  if (t === "volumeStep") return i === "arrowdown" ? -0.05 : 5 / 100;
}
function My(t, e, n) {
  return t === "seekStep" && Ce(n) && e === "left" ? -10 : qa(t, void 0, n);
}
function Oy(t, e) {
  return t.id || String(e);
}
function PT(t, e) {
  return {
    id: Oy(t, e),
    ...t.kind !== void 0 && { kind: t.kind },
    label: t.label,
    language: t.language,
    enabled: t.enabled
  };
}
const Iy = _t({
  name: "audioTrack",
  state: ({ target: t }) => ({
    audioTrackList: [],
    selectAudioTrack(e) {
      const { media: n } = t();
      if (!mp(n)) return;
      const i = [...n.audioTracks], r = i.find((s, o) => Oy(s, o) === e);
      if (r)
        for (const s of i) s.enabled = s === r;
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    let r = null, s = null;
    const o = () => mp(i) ? i.audioTracks : null, a = (c = o()) => {
      n({ audioTrackList: c ? [...c].map(PT) : [] });
    }, l = () => {
      const c = o();
      if (c === r) {
        a(c);
        return;
      }
      s?.abort(), s = new AbortController(), r = c, r && (Q(r, "addtrack", () => a(r), { signal: s.signal }), Q(r, "removetrack", () => a(r), { signal: s.signal }), Q(r, "change", () => a(r), { signal: s.signal })), a(r);
    };
    l(), Q(i, "loadstart", l, { signal: e }), e.addEventListener("abort", () => s?.abort(), { once: !0 });
  }
}), Dy = _t({
  name: "buffer",
  state: () => ({
    buffered: [],
    seekable: []
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!gh(i)) return;
    const r = () => n({
      buffered: ap(i.buffered),
      seekable: ap(i.seekable)
    });
    r(), Q(i, "loadedmetadata", r, { signal: e }), Q(i, "durationchange", r, { signal: e }), Q(i, "progress", r, { signal: e }), Q(i, "emptied", r, { signal: e });
  }
}), gr = /* @__PURE__ */ new WeakMap();
function ET(t) {
  gr.set(t, (gr.get(t) ?? 0) + 1);
  let e = !1;
  return () => {
    if (e) return;
    e = !0;
    const n = gr.get(t) ?? 0;
    n <= 1 ? gr.delete(t) : gr.set(t, n - 1);
  };
}
function _a(t) {
  return (gr.get(t) ?? 0) > 0;
}
function TT(t, e, n) {
  const i = t - e.left, r = e.width;
  if (r === 0) return null;
  const s = i / r;
  return n.size === 2 && n.has("left") && n.has("right") ? s < 0.5 ? "left" : "right" : n.size === 3 ? s < 1 / 3 ? "left" : s < 2 / 3 ? "center" : "right" : n.has("left") && s < 0.5 ? "left" : n.has("right") && s >= 0.5 ? "right" : n.has("center") && (n.size === 1 || s >= 1 / 3 && s < 2 / 3) ? "center" : null;
}
const CT = 250;
var AT = class {
  #e;
  #t = [];
  #i = /* @__PURE__ */ new Set();
  #n = null;
  #r = /* @__PURE__ */ new Set();
  constructor(t) {
    this.#e = t;
  }
  get bindings() {
    return this.#t;
  }
  subscribe(t) {
    return this.#r.add(t), () => this.#r.delete(t);
  }
  /**
  * Whether a registered binding claims this tap for the given action. A claimed tap belongs to the gesture layer, so
  * callers should leave it alone. Taps on interactive targets (buttons, sliders) are never claimed — the same
  * filtering the pointerup listener applies. A disabled binding still claims: disabling a gesture opts out of the
  * action, it doesn't hand the tap back to a fallback handler.
  */
  claimsTap(t, e) {
    return _a(this.#e) ? !0 : ip(t) ? !1 : this.#t.some((n) => n.type === "tap" && n.action === e && (!n.pointer || n.pointer === t.pointerType));
  }
  add(t) {
    const e = My(t.action ?? "", t.region, t.value), n = {
      ...t,
      value: e,
      onActivate: (r) => {
        if (this.#r.size > 0) {
          const s = {
            type: t.type,
            source: "gesture",
            action: t.action,
            value: e,
            region: t.region,
            pointer: t.pointer,
            event: r
          };
          for (const o of this.#r) try {
            o(s);
          } catch {
          }
        }
        t.onActivate(r);
      }
    };
    this.#t.push(n), this.#i.add(n.recognizer), this.#s();
    let i = !1;
    return () => {
      if (i) return;
      i = !0;
      const r = this.#t.indexOf(n);
      r !== -1 && this.#t.splice(r, 1), this.#o();
    };
  }
  #s() {
    if (this.#n) return;
    this.#n = new AbortController();
    const { signal: t } = this.#n;
    let e = 0;
    Q(this.#e, "pointerdown", (n) => {
      if (_a(this.#e)) {
        e = 0;
        return;
      }
      n.button === 0 && (e = Date.now());
    }, { signal: t }), Q(this.#e, "pointerup", (n) => {
      if (_a(this.#e)) {
        e = 0;
        return;
      }
      if (n.button !== 0 || Date.now() - e > CT || ip(n)) return;
      const i = n.pointerType, r = n.clientX, s = this.#e, o = this.#t, a = { resolve: (l) => RT(o, l, i, r, s) };
      for (const l of this.#i) l.handleUp(a, n);
    }, { signal: t });
  }
  #o() {
    if (!(this.#t.length > 0)) {
      for (const t of this.#i) t.reset();
      this.#i.clear(), this.#n?.abort(), this.#n = null;
    }
  }
};
const Yu = /* @__PURE__ */ new WeakMap();
function $T(t) {
  return Yu.get(t);
}
function Eh(t) {
  let e = Yu.get(t);
  return e || (e = new AT(t), Yu.set(t, e)), e;
}
function RT(t, e, n, i, r) {
  const s = r.getBoundingClientRect(), o = MT(t, e, n), a = o.size > 0 ? TT(i, s, o) : null, l = [];
  for (const c of t)
    if (!c.disabled && c.type === e && !(c.pointer && c.pointer !== n)) {
      if (c.region) {
        if (c.region !== a) continue;
      } else if (a !== null) continue;
      l.push(c);
    }
  return l;
}
function MT(t, e, n) {
  const i = /* @__PURE__ */ new Set();
  for (const r of t)
    r.disabled || r.type === e && (r.pointer && r.pointer !== n || r.region && i.add(r.region));
  return i;
}
function Th(t) {
  const e = t;
  if (Je(e.remote) && "state" in e.remote && "prompt" in e.remote) return e.remote;
}
function Fy(t) {
  return Th(t)?.state === "connected";
}
function OT(t) {
  return Th(t)?.state === "connecting";
}
async function Cp(t) {
  const e = Th(t);
  if (!e) throw new DOMException("Remote playback not supported", "NotSupportedError");
  return e.prompt();
}
const IT = 2e3, DT = 250, FT = 500, LT = 100, Ap = /* @__PURE__ */ new WeakMap(), Ly = _t({
  name: "controls",
  state: ({ get: t, set: e }) => {
    const r = NT(() => (e({ controlsVisible: !0 }), () => {
    }), (s) => {
      const o = s ?? !t().userActive;
      return e({
        userActive: o,
        controlsVisible: o
      }), o;
    });
    return Ap.set(r.requestControlsLock, r), {
      userActive: !0,
      controlsVisible: !0,
      requestControlsLock: r.requestControlsLock,
      toggleControls: r.toggleControls
    };
  },
  attach({ target: t, signal: e, get: n, set: i }) {
    const { media: r, container: s } = t;
    if (!ga(r) || Fi(s)) return;
    let o, a = 0;
    const l = (P) => a > 0 || P || r.paused || Fy(r) || OT(r);
    function c() {
      clearTimeout(o), o = void 0;
    }
    function u() {
      c(), !(a > 0) && (o = setTimeout(h, IT));
    }
    function d() {
      n().userActive || i({
        userActive: !0,
        controlsVisible: !0
      }), u();
    }
    function h() {
      c(), i({
        userActive: !1,
        controlsVisible: l(!1)
      });
    }
    function f() {
      a++, c(), n().controlsVisible || i({ controlsVisible: !0 });
      let P = !1;
      return () => {
        P || e.aborted || (P = !0, a--, a === 0 && d());
      };
    }
    function p(P) {
      return P ?? !n().controlsVisible ? d() : h(), n().controlsVisible;
    }
    const v = Ap.get(n().requestControlsLock);
    v.setDelegates(f, p);
    let g = 0, m = 0;
    const y = () => m > 0 && Date.now() - m < FT;
    let k = 0;
    const _ = () => k > 0 && Date.now() - k < LT;
    function w(P) {
      g = Date.now(), P.pointerType === "touch" && (m = g);
    }
    function T(P) {
      if (P.pointerType === "touch" && (m = Date.now()), P.pointerType === "touch" && Date.now() - g < DT) {
        if ($T(s)?.claimsTap(P, "toggleControls")) return;
        const C = [ph(r), s].includes(P.target);
        n().controlsVisible && C ? h() : d();
      } else d();
    }
    const E = () => {
      const { userActive: P } = n();
      i({ controlsVisible: l(P) }), !r.paused && P && u();
    };
    function S(P) {
      if (P.pointerType === "touch") {
        n().userActive && u();
        return;
      }
      d();
    }
    if (Q(s, "pointermove", S, { signal: e }), Q(s, "pointerdown", w, { signal: e }), Q(s, "pointerup", T, { signal: e }), Q(s, "lostpointercapture", () => {
      k = Date.now();
    }, { signal: e }), Q(s, "keydown", d, { signal: e }), Q(s, "keyup", d, { signal: e }), Q(s, "focusin", () => {
      y() || d();
    }, { signal: e }), Q(s, "mouseleave", (P) => {
      y() || _() && P instanceof MouseEvent && B0(s, P) || h();
    }, { signal: e }), Q(r, "play", E, { signal: e }), Q(r, "pause", E, { signal: e }), Q(r, "ended", E, { signal: e }), Q0(r)) {
      const P = () => {
        const { userActive: C } = n();
        i({ controlsVisible: l(C) });
      };
      Q(r.remote, "connect", P, { signal: e }), Q(r.remote, "connecting", P, { signal: e }), Q(r.remote, "disconnect", P, { signal: e });
    }
    e.addEventListener("abort", () => {
      v.reset(), a = 0, c();
    }, { once: !0 }), u();
  }
});
function NT(t, e) {
  let n = t, i = e;
  const r = /* @__PURE__ */ new Set(), a = {
    requestControlsLock: () => {
      const l = { release: n() };
      let c = !1;
      return r.add(l), () => {
        c || (c = !0, r.delete(l), l.release());
      };
    },
    toggleControls: (l) => i(l),
    setDelegates(l, c) {
      if (l !== n) {
        n = l;
        for (const u of r)
          u.release(), u.release = l();
      }
      i = c;
    },
    reset() {
      a.setDelegates(t, e);
    }
  };
  return a;
}
const Ny = _t({
  name: "error",
  state: ({ set: t }) => ({
    error: null,
    dismissError() {
      t({ error: null });
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!JP(i)) return;
    Q(i, "error", () => n({ error: i.error }), { signal: e }), Q(i, "emptied", () => n({ error: null }), { signal: e });
  }
});
function VT() {
  const t = document;
  if (t.fullscreenEnabled || t.webkitFullscreenEnabled) return !0;
  const e = document.createElement("video");
  return ke(e.webkitSetPresentationMode);
}
function jT() {
  const t = document;
  return t.fullscreenElement ?? t.webkitFullscreenElement ?? null;
}
function $p(t) {
  if (!(t instanceof Element)) return !1;
  try {
    return t.matches(":fullscreen");
  } catch {
    return !1;
  }
}
function Ch(t, e) {
  if (e.webkitPresentationMode === "fullscreen") return !0;
  const n = jT();
  return n && (n === t || n === ph(e)) || $p(t) || $p(e) ? !0 : e.isFullscreen ?? !1;
}
async function zT(t, e) {
  const n = document;
  if (t && (n.fullscreenEnabled || n.webkitFullscreenEnabled)) {
    const s = t;
    if (ke(s.requestFullscreen)) return s.requestFullscreen();
    if (ke(s.webkitRequestFullscreen)) return s.webkitRequestFullscreen();
  }
  const i = e;
  if (ke(i.webkitSetPresentationMode)) {
    i.webkitSetPresentationMode("fullscreen");
    return;
  }
  const r = e;
  if (ke(r.requestFullscreen)) return r.requestFullscreen();
}
async function Ah(t) {
  const e = document, n = t;
  if (n.webkitPresentationMode === "fullscreen" && ke(n.webkitSetPresentationMode)) {
    n.webkitSetPresentationMode("inline");
    return;
  }
  if (ke(e.exitFullscreen)) return e.exitFullscreen();
  if (ke(e.webkitExitFullscreen)) return e.webkitExitFullscreen();
  const i = t;
  if (ke(i.exitFullscreen)) return i.exitFullscreen();
}
function BT() {
  if (document.pictureInPictureEnabled) {
    const e = /.*Version\/.*Safari\/.*/.test(navigator.userAgent), n = typeof matchMedia == "function" && matchMedia("(display-mode: standalone)").matches;
    return !e || !n;
  }
  const t = document.createElement("video");
  return ke(t.webkitSetPresentationMode);
}
function Rp(t) {
  return ke(t.webkitSetPresentationMode) ? !0 : XP(t);
}
function Vy(t) {
  return t.webkitPresentationMode === "picture-in-picture" || document.pictureInPictureElement === ph(t) ? !0 : t.isPictureInPicture ?? !1;
}
async function HT(t) {
  const e = t;
  if (ke(e.webkitSetPresentationMode)) {
    e.webkitSetPresentationMode("picture-in-picture");
    return;
  }
  const n = t;
  if (ke(n.requestPictureInPicture)) return n.requestPictureInPicture();
}
async function jy(t) {
  const e = t;
  if (e.webkitPresentationMode === "picture-in-picture" && ke(e.webkitSetPresentationMode)) {
    e.webkitSetPresentationMode("inline");
    return;
  }
  if (ke(document.exitPictureInPicture)) return document.exitPictureInPicture();
  const n = t;
  if (ke(n.exitPictureInPicture)) return n.exitPictureInPicture();
}
const zy = _t({
  name: "fullscreen",
  state: ({ target: t }) => ({
    isFullscreen: !1,
    fullscreenAvailability: "unavailable",
    async requestFullscreen() {
      const { media: e, container: n } = t();
      return Vy(e) && await jy(e), zT(n, e);
    },
    async exitFullscreen() {
      const { media: e } = t();
      return Ah(e);
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i, container: r } = t;
    n({ fullscreenAvailability: VT() ? "available" : "unsupported" });
    const s = () => n({ isFullscreen: Ch(r, i) });
    s(), Q(document, "fullscreenchange", s, { signal: e }), Q(document, "webkitfullscreenchange", s, { signal: e }), "webkitPresentationMode" in i && Q(i, "webkitpresentationmodechanged", s, { signal: e });
  }
}), UT = _t({
  name: "live",
  state: () => ({
    liveEdgeStart: NaN,
    targetLiveWindow: NaN
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!e2(i)) return;
    const r = () => n({
      liveEdgeStart: i.liveEdgeStart,
      targetLiveWindow: i.targetLiveWindow
    });
    r(), Q(i, "targetlivewindowchange", r, { signal: e }), Q(i, "streamtypechange", r, { signal: e }), Q(i, "loadedmetadata", r, { signal: e }), Q(i, "canplay", r, { signal: e }), Q(i, "progress", r, { signal: e }), Q(i, "durationchange", r, { signal: e }), Q(i, "timeupdate", r, { signal: e }), Q(i, "emptied", r, { signal: e });
  }
}), fc = /* @__PURE__ */ Symbol("@videojs/media-title"), Uo = /* @__PURE__ */ Symbol("@videojs/user-title"), Mp = /* @__PURE__ */ Symbol("@videojs/set-user-title"), WT = "", pc = /* @__PURE__ */ Symbol("@videojs/media-poster"), Wo = /* @__PURE__ */ Symbol("@videojs/user-poster"), Op = /* @__PURE__ */ Symbol("@videojs/set-user-poster"), qT = "", By = _t({
  name: "metadata",
  config: {
    /** The title to display. Takes precedence over the title the media carries. */
    title: {
      action: Mp,
      state: Uo,
      html: { attribute: "content-title" }
    },
    /** The poster to display. Takes precedence over the poster the media carries. */
    poster: {
      action: Op,
      state: Wo
    }
  },
  state: ({ set: t }) => ({
    [fc]: void 0,
    [Uo]: void 0,
    [Mp]: (e) => t({ [Uo]: e }),
    [pc]: void 0,
    [Wo]: void 0,
    [Op]: (e) => t({ [Wo]: e })
  }),
  derived: {
    /** The resolved content title. Set it through the player, not through the store. */
    title: ({ get: t }) => t()[Uo] ?? t()[fc] ?? WT,
    /**
    * The resolved poster URL, independent of the media component's own `poster`. Set it through the player, not
    * through the store.
    */
    poster: ({ get: t }) => t()[Wo] ?? t()[pc] ?? qT
  },
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t, r = () => {
      const o = gp(i) ? i.contentData : void 0;
      n({
        [fc]: o?.title,
        [pc]: o?.poster
      });
    }, s = () => {
      r(), gp(i) && Q(i, "contentdatachange", r, { signal: e });
    };
    s(), Q(i, "loadstart", s, { signal: e });
  }
}), Hy = _t({
  name: "pip",
  state: ({ target: t }) => ({
    isPictureInPicture: !1,
    pictureInPictureAvailability: "unavailable",
    async requestPictureInPicture() {
      const { media: e, container: n } = t();
      if (Rp(e)) {
        if (!Hr(e) || !Fu(e)) throw new DOMException("The media has no video data yet.", "InvalidStateError");
        return Ch(n, e) && await Ah(e), HT(e);
      }
    },
    async exitPictureInPicture() {
      const { media: e } = t();
      return jy(e);
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t, r = BT() && Rp(i), s = () => n({
      isPictureInPicture: Vy(i),
      pictureInPictureAvailability: r ? Hr(i) && Fu(i) ? "available" : "unavailable" : "unsupported"
    });
    s(), Q(i, "enterpictureinpicture", s, { signal: e }), Q(i, "leavepictureinpicture", s, { signal: e }), Q(i, "loadstart", s, { signal: e }), Q(i, "loadedmetadata", s, { signal: e }), Q(i, "emptied", s, { signal: e }), "webkitPresentationMode" in i && Q(i, "webkitpresentationmodechanged", s, { signal: e });
  }
}), Uy = _t({
  name: "playback",
  state: ({ target: t, set: e }) => ({
    paused: !0,
    ended: !1,
    started: !1,
    waiting: !1,
    play() {
      const { media: n } = t(), i = n.play();
      return ga(n) && !n.paused && e({
        paused: !1,
        ended: !1,
        started: !0
      }), i;
    },
    pause() {
      const { media: n } = t();
      ga(n) && (n.pause(), e({ paused: n.paused }));
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!ga(i) || !Ks(i) || !Hr(i)) return;
    let r = null;
    const s = () => {
      const a = i.readyState < HTMLMediaElement.HAVE_FUTURE_DATA && !i.paused;
      a ? r ??= i.currentTime : r = null, n({
        paused: i.paused,
        ended: i.ended,
        started: !i.paused || i.currentTime > 0,
        waiting: a && r === i.currentTime
      });
    }, o = () => {
      r = i.currentTime, s();
    };
    s(), Q(i, "emptied", o, { signal: e }), Q(i, "play", o, { signal: e }), Q(i, "pause", s, { signal: e }), Q(i, "ended", s, { signal: e }), Q(i, "playing", s, { signal: e }), Q(i, "waiting", o, { signal: e }), Q(i, "seeking", o, { signal: e }), Q(i, "seeked", s, { signal: e }), Q(i, "canplay", s, { signal: e }), Q(i, "timeupdate", s, { signal: e });
  }
}), GT = [
  0.2,
  0.5,
  0.7,
  1,
  1.2,
  1.5,
  1.7,
  2
], Wy = _t({
  name: "playbackRate",
  state: ({ target: t }) => ({
    playbackRates: GT,
    playbackRate: 1,
    setPlaybackRate(e) {
      const { media: n } = t();
      fp(n) && (n.playbackRate = e);
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!fp(i)) return;
    const r = () => n({ playbackRate: i.playbackRate });
    r(), Q(i, "ratechange", r, { signal: e });
  }
}), KT = "auto";
function qy(t, e) {
  return t.id || String(e);
}
function Ip(t, e) {
  return {
    id: qy(t, e),
    ...t.width !== void 0 && { width: t.width },
    ...t.height !== void 0 && { height: t.height },
    ...t.bitrate !== void 0 && { bitrate: t.bitrate },
    ...t.frameRate !== void 0 && { frameRate: t.frameRate },
    ...t.codec !== void 0 && { codec: t.codec },
    selected: t.selected
  };
}
function Dp(t) {
  return t.width && t.height ? Math.min(t.width, t.height) : t.height ?? t.width;
}
const Gy = _t({
  name: "quality",
  state: ({ target: t }) => ({
    videoRenditionList: [],
    activeVideoRendition: null,
    selectVideoRendition(e) {
      const { media: n } = t();
      if (!pp(n)) return;
      if (e === KT) {
        n.videoRenditions.selectedIndex = -1;
        return;
      }
      const i = [...n.videoRenditions].findIndex((r, s) => qy(r, s) === e);
      i !== -1 && (n.videoRenditions.selectedIndex = i);
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    let r = null, s = null;
    const o = () => pp(i) ? i.videoRenditions : null, a = (u) => {
      if (!u) return null;
      const d = [...u], h = d.find((v) => v.active);
      if (h) return h;
      if (!ZP(i) || !i.videoWidth && !i.videoHeight) return null;
      const f = Dp({
        width: i.videoWidth || void 0,
        height: i.videoHeight || void 0
      }), p = d.filter((v) => Dp(v) === f);
      return p.length === 1 ? p[0] : null;
    }, l = (u = o()) => {
      const d = u ? [...u] : [], h = a(u);
      n({
        videoRenditionList: d.map(Ip),
        activeVideoRendition: h ? Ip(h, d.indexOf(h)) : null
      });
    }, c = () => {
      const u = o();
      if (u === r) {
        l(u);
        return;
      }
      s?.abort(), s = new AbortController(), r = u, r && (Q(r, "addrendition", () => l(r), { signal: s.signal }), Q(r, "removerendition", () => l(r), { signal: s.signal }), Q(r, "change", () => l(r), { signal: s.signal }), Q(r, "activechange", () => l(r), { signal: s.signal })), l(r);
    };
    c(), Q(i, "loadstart", c, { signal: e }), Q(i, "resize", () => l(r), { signal: e }), e.addEventListener("abort", () => s?.abort(), { once: !0 });
  }
}), Ky = _t({
  name: "remotePlayback",
  state: ({ target: t }) => ({
    remotePlaybackState: "disconnected",
    remotePlaybackAvailability: "unsupported",
    async promptRemotePlayback() {
      const { media: e, container: n } = t();
      return Fy(e) ? Cp(e) : (Ch(n, e) && await Ah(e), await Cp(e));
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!Q0(i)) return;
    if (cP(i)) {
      const s = () => {
        n({ remotePlaybackState: i.webkitCurrentPlaybackTargetIsWireless ? "connected" : "disconnected" });
      };
      Q(i, "webkitplaybacktargetavailabilitychanged", (a) => {
        const { availability: l } = a;
        n({ remotePlaybackAvailability: l === "available" ? "available" : "unavailable" });
      }, { signal: e }), Q(i, "webkitcurrentplaybacktargetiswirelesschanged", s, { signal: e }), s();
      return;
    }
    const r = () => n({ remotePlaybackState: i.remote.state });
    r(), Q(i.remote, "connect", r, { signal: e }), Q(i.remote, "connecting", r, { signal: e }), Q(i.remote, "disconnect", r, { signal: e }), i.remote.watchAvailability((s) => {
      n({ remotePlaybackAvailability: s ? "available" : "unavailable" });
    }).catch(() => {
      n({ remotePlaybackAvailability: "unsupported" });
    }), e.addEventListener("abort", () => {
      i.remote?.cancelWatchAvailability?.().catch(() => {
      });
    });
  }
}), Yy = _t({
  name: "source",
  state: () => ({
    currentSrc: "",
    canPlay: !1
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!Hr(i)) return;
    const r = () => n({
      currentSrc: i.currentSrc,
      canPlay: i.readyState >= Z0.HAVE_FUTURE_DATA
    });
    r(), Q(i, "canplay", r, { signal: e }), Q(i, "canplaythrough", r, { signal: e }), Q(i, "loadstart", r, { signal: e }), Q(i, "emptied", r, { signal: e });
  }
}), YT = _t({
  name: "streamType",
  state: () => ({ streamType: Vo.UNKNOWN }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (QP(i)) {
      const o = () => n({ streamType: i.streamType });
      o(), Q(i, "streamtypechange", o, { signal: e });
      return;
    }
    if (!Ks(i)) return;
    const r = () => {
      const { duration: o } = i;
      return o === Number.POSITIVE_INFINITY ? Vo.LIVE : Number.isFinite(o) && o > 0 ? Vo.ON_DEMAND : Vo.UNKNOWN;
    }, s = () => n({ streamType: r() });
    s(), Q(i, "durationchange", s, { signal: e }), Q(i, "loadedmetadata", s, { signal: e }), Q(i, "emptied", s, { signal: e }), gh(i) && Q(i, "progress", s, { signal: e });
  }
});
function XT(t, e) {
  if (!t) return [];
  const n = Number.isFinite(e) && e > 0 ? e : Number.POSITIVE_INFINITY;
  return Array.from(t, (i) => ({
    startTime: i.startTime,
    endTime: Math.min(i.endTime, n),
    text: i.text ?? ""
  }));
}
function Xy(t, e) {
  return t.id || `track:${e}:${t.kind}:${t.language}:${t.label}`;
}
function Fp(t) {
  return Cu(Array.from(t.textTracks, (e, n) => ({
    id: Xy(e, n),
    kind: e.kind,
    track: e
  })));
}
function qo(t, e) {
  for (const { track: n } of t) {
    const i = n === e ? "showing" : "disabled";
    n.mode !== i && (n.mode = i);
  }
}
function JT(t) {
  return ch(t) ? null : t.toLowerCase() === "use-credentials" ? "use-credentials" : "anonymous";
}
function ZT(t, e) {
  const n = ba(e), i = Ty(e);
  n !== zi && !n.startsWith(`${zi}-`) && i.pop();
  for (const r of i) {
    const s = t.find(({ track: a }) => ba(a.language) === r);
    if (s) return s;
    const o = t.find(({ track: a }) => ba(a.language).startsWith(`${r}-`));
    if (o) return o;
  }
}
const Jy = _t({
  name: "textTrack",
  state: ({ target: t }) => {
    let e = null;
    return {
      textTrackList: [],
      subtitlesShowing: !1,
      toggleSubtitles(n) {
        const { media: i } = t();
        if (!cc(i)) return !1;
        const r = Fp(i);
        if (!r.length) return !1;
        const s = r.find(({ track: l }) => l.mode === "showing"), o = n ?? !s;
        if (s && (e = s.id), !o)
          return qo(r, null), !1;
        const a = s ?? r.find(({ id: l }) => l === e) ?? ZT(r, globalThis.navigator?.language ?? "") ?? r[0];
        return e = a.id, qo(r, a.track), !0;
      },
      selectSubtitlesTrack(n) {
        const { media: i } = t();
        if (!cc(i)) return;
        const r = Fp(i);
        if (!r.length) return;
        if (Fi(n)) {
          const o = r.find(({ track: a }) => a.mode === "showing");
          o && (e = o.id), qo(r, null);
          return;
        }
        const s = r.find((o) => o.id === n);
        s && (e = s.id, qo(r, s.track));
      },
      chaptersCues: [],
      thumbnailsTrack: null
    };
  },
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t;
    if (!cc(i)) return;
    let r = null;
    const s = () => {
      r?.abort(), r = new AbortController();
      let a = null, l = null;
      const c = [];
      let u = !1;
      for (let v = 0; v < i.textTracks.length; v++) {
        const g = i.textTracks[v];
        !a && g.kind === "chapters" && (a = g), !l && g.kind === "metadata" && g.label === "thumbnails" && (l = g), c.push({
          id: Xy(g, v),
          kind: g.kind,
          label: g.label,
          language: g.language,
          mode: g.mode
        }), po(g) && g.mode === "showing" && (u = !0);
      }
      const d = XT(a?.cues, Ks(i) ? i.duration : NaN);
      let h = null;
      l && (h = {
        cues: l.cues ? Array.from(l.cues) : [],
        src: aP(i, l)?.src ?? null,
        crossOrigin: Hr(i) ? JT(i.crossOrigin) : null
      });
      const f = t2(i) && i.querySelectorAll("track") || [], p = i instanceof HTMLElement && i.shadowRoot?.querySelectorAll("track") || [];
      for (const v of [...f, ...p]) v.track?.cues?.length || Q(v, "load", s, { signal: r.signal });
      n({
        textTrackList: c,
        subtitlesShowing: u,
        chaptersCues: d,
        thumbnailsTrack: h
      });
    };
    s();
    const o = i.textTracks;
    o instanceof EventTarget && (Q(o, "addtrack", s, { signal: e }), Q(o, "removetrack", s, { signal: e }), Q(o, "change", s, { signal: e })), Q(i, "loadstart", s, { signal: e }), Q(i, "durationchange", s, { signal: e }), e.addEventListener("abort", () => r?.abort(), { once: !0 });
  }
}), Lp = { seek: /* @__PURE__ */ Symbol.for("@videojs/seek") }, Zy = _t({
  name: "time",
  state: ({ target: t, signals: e, set: n }) => ({
    currentTime: 0,
    duration: 0,
    seeking: !1,
    async seek(i) {
      const { media: r } = t(), s = e.supersede(Lp.seek);
      if (!Ks(r) || !Hr(r)) return 0;
      if (Q(r, "emptied", () => e.supersede(Lp.seek), {
        signal: s,
        once: !0
      }), !Fu(r) && !await ep(r, "loadedmetadata", { signal: s }).catch(() => !1))
        return r.currentTime;
      const o = Math.max(0, Math.min(i, r.duration || 1 / 0));
      return n({
        currentTime: o,
        seeking: !0
      }), r.currentTime = o, await ep(r, "seeked", { signal: s }).catch(pn), r.currentTime;
    }
  }),
  attach({ target: t, signal: e, set: n, get: i }) {
    const { media: r } = t;
    if (!Ks(r)) return;
    const s = () => {
      const { duration: l } = r;
      if (l === Number.POSITIVE_INFINITY && gh(r)) {
        const { seekable: c } = r;
        return c.length > 0 ? c.end(c.length - 1) : 0;
      }
      return Number.isFinite(l) ? l : 0;
    }, o = () => n({
      currentTime: r.currentTime,
      duration: s(),
      seeking: r.seeking
    }), a = () => {
      i().seeking || o();
    };
    o(), Q(r, "timeupdate", a, { signal: e }), Q(r, "durationchange", o, { signal: e }), Q(r, "seeking", o, { signal: e }), Q(r, "seeked", o, { signal: e }), Q(r, "loadedmetadata", o, { signal: e }), Q(r, "emptied", o, { signal: e }), Q(r, "progress", a, { signal: e });
  }
}), QT = 0.25, Qy = _t({
  name: "volume",
  state: ({ target: t, set: e }) => ({
    volume: 1,
    muted: !1,
    volumeAvailability: "unavailable",
    mutedAvailability: "unavailable",
    setVolume(n) {
      const { media: i } = t();
      if (!lc(i)) return 0;
      const r = Math.max(0, Math.min(1, n));
      return r > 0 && i.muted && (i.muted = !1), i.volume = r, e({
        volume: i.volume,
        muted: i.muted
      }), i.volume;
    },
    setMuted(n) {
      const { media: i } = t();
      if (!hp(i)) return !1;
      i.muted = n;
      const r = lc(i);
      return !n && r && i.volume === 0 && (i.volume = QT), e({
        volume: r ? i.volume : 1,
        muted: i.muted
      }), i.muted;
    }
  }),
  attach({ target: t, signal: e, set: n }) {
    const { media: i } = t, r = lc(i), s = hp(i);
    if (!r && !s) return;
    n({
      volumeAvailability: r ? e5() : "unavailable",
      mutedAvailability: s ? "available" : "unavailable"
    });
    const o = () => n({
      volume: r ? i.volume : 1,
      muted: s ? i.muted : !1
    });
    o(), Q(i, "volumechange", o, { signal: e });
  }
});
function e5() {
  const t = document.createElement("video");
  try {
    return t.volume = 0.5, t.volume === 0.5 ? "available" : "unsupported";
  } catch {
    return "unsupported";
  }
}
const t5 = bt(Iy), Il = bt(Dy), Ei = bt(Ly), i5 = bt(Ny), Dl = bt(zy);
bt(UT);
const eb = bt(By), $h = bt(Hy), rs = bt(Uy), Ga = bt(Wy), n5 = bt(Gy), tb = bt(Ky);
bt(Yy);
bt(YT);
const rr = bt(Jy), sr = bt(Zy), Zn = bt(Qy);
function wa(t) {
  M0(t) && t.catch(pn);
}
const wt = {
  togglePaused({ store: t }) {
    const e = rs(t.state);
    e && wa(e.paused ? e.play() : e.pause());
  },
  toggleMuted({ store: t }) {
    const e = Zn(t.state);
    e && e.setMuted(!(e.muted || e.volume === 0));
  },
  toggleFullscreen({ store: t }) {
    const e = Dl(t.state);
    e && wa(e.isFullscreen ? e.exitFullscreen() : e.requestFullscreen());
  },
  togglePictureInPicture({ store: t }) {
    const e = $h(t.state);
    e && wa(e.isPictureInPicture ? e.exitPictureInPicture() : e.requestPictureInPicture());
  },
  seekStep({ store: t, value: e, key: n }) {
    const i = qa("seekStep", n, e), r = sr(t.state);
    r && r.seek(r.currentTime + i);
  },
  volumeStep({ store: t, value: e, key: n }) {
    const i = qa("volumeStep", n, e), r = Zn(t.state);
    r && r.setVolume(r.volume + i);
  },
  speedUp({ store: t }) {
    const e = Ga(t.state);
    if (!e) return;
    const { playbackRates: n, playbackRate: i } = e, r = n.indexOf(i), s = r < 0 || r >= n.length - 1 ? 0 : r + 1;
    e.setPlaybackRate(n[s]);
  },
  speedDown({ store: t }) {
    const e = Ga(t.state);
    if (!e) return;
    const { playbackRates: n, playbackRate: i } = e, r = n.indexOf(i), s = r <= 0 ? n.length - 1 : r - 1;
    e.setPlaybackRate(n[s]);
  }
}, r5 = {
  togglePaused: wt.togglePaused,
  toggleMuted: wt.toggleMuted,
  toggleFullscreen: wt.toggleFullscreen,
  togglePictureInPicture: wt.togglePictureInPicture,
  seekStep: wt.seekStep,
  volumeStep: wt.volumeStep,
  speedUp: wt.speedUp,
  speedDown: wt.speedDown
};
function s5(t) {
  const e = r5[t];
  return e || (({ store: n }) => {
    const i = n.state[t];
    ke(i) && wa(i());
  });
}
const Np = 200;
var o5 = class {
  #e = 0;
  #t = null;
  handleUp(t, e) {
    if (t.resolve("doubletap").length > 0) {
      const n = Date.now();
      if (n - this.#e < Np) {
        this.#i(), this.#e = 0, t.resolve("doubletap")[0]?.onActivate(e);
        return;
      }
      this.#e = n, this.#i(), this.#t = setTimeout(() => {
        this.#t = null, this.#e = 0, t.resolve("tap")[0]?.onActivate(e);
      }, Np);
      return;
    }
    t.resolve("tap")[0]?.onActivate(e);
  }
  #i() {
    this.#t !== null && (clearTimeout(this.#t), this.#t = null);
  }
  reset() {
    this.#i(), this.#e = 0;
  }
};
const Vp = /* @__PURE__ */ new WeakMap();
function ib(t) {
  let e = Vp.get(t);
  return e || (e = new o5(), Vp.set(t, e), e);
}
function a5(t, e, n) {
  return Eh(t).add({
    type: "tap",
    recognizer: ib(t),
    onActivate: e,
    pointer: n?.pointer,
    region: n?.region,
    disabled: n?.disabled,
    action: n?.action,
    value: n?.value
  });
}
function l5(t, e, n) {
  return Eh(t).add({
    type: "doubletap",
    recognizer: ib(t),
    onActivate: e,
    pointer: n?.pointer,
    region: n?.region,
    disabled: n?.disabled,
    action: n?.action,
    value: n?.value
  });
}
function c5(t) {
  return t.startsWith("toggle");
}
const u5 = {
  togglePaused: wt.togglePaused,
  toggleMuted: wt.toggleMuted,
  toggleFullscreen: wt.toggleFullscreen,
  toggleSubtitles({ store: t }) {
    rr(t.state)?.toggleSubtitles();
  },
  togglePictureInPicture: wt.togglePictureInPicture,
  seekStep: wt.seekStep,
  volumeStep: wt.volumeStep,
  speedUp: wt.speedUp,
  speedDown: wt.speedDown,
  seekToPercent({ store: t, value: e, key: n }) {
    const i = sr(t.state);
    if (!i) return;
    const r = Il(t.state), s = Gs({
      duration: i.duration,
      seekable: r?.seekable ?? []
    });
    if (s <= 0) return;
    let o;
    if (!Ce(e)) o = e;
    else if (n >= "0" && n <= "9") o = Number(n) * 10;
    else return;
    i.seek(o / 100 * s);
  }
};
function d5(t) {
  return u5[t];
}
const h5 = {
  shift: "Shift",
  ctrl: "Control",
  alt: "Alt",
  meta: "Meta"
}, f5 = {
  shift: "Shift",
  ctrl: "Ctrl",
  alt: "Alt",
  meta: "Meta"
}, nb = [
  "ctrl",
  "shift",
  "alt",
  "meta"
];
function p5(t) {
  return t.map((e) => {
    const n = [];
    for (const i of nb) e.modifiers.has(i) && n.push(h5[i]);
    return n.push(e.originalKey), n.join("+");
  }).join(" ");
}
function m5(t) {
  const e = [];
  for (const n of nb) t.modifiers.has(n) && e.push(f5[n]);
  return e.push(g5(t.originalKey)), e.join("+");
}
function g5(t) {
  return t.length === 1 ? t.toUpperCase() : t;
}
var v5 = class {
  #e;
  #t = [];
  #i = 0;
  #n = null;
  #r = null;
  #s = /* @__PURE__ */ new Set();
  #o = /* @__PURE__ */ new Set();
  #a = !1;
  constructor(t) {
    this.#e = t;
  }
  subscribe(t) {
    return this.#s.add(t), () => this.#s.delete(t);
  }
  subscribeShortcutChanges(t) {
    return this.#o.add(t), () => this.#o.delete(t);
  }
  add(t) {
    const e = {
      parsed: rb(t.keys),
      options: t,
      id: this.#i++
    };
    this.#t.push(e), this.#d(), t.target === "document" ? this.#u() : this.#h(), this.#f();
    let n = !1;
    return () => {
      if (n) return;
      n = !0;
      const i = this.#t.indexOf(e);
      i !== -1 && this.#t.splice(i, 1), this.#c(), this.#f();
    };
  }
  getAriaKeys(t) {
    return this.getShortcut(t).aria;
  }
  getShortcut(t, e) {
    const n = this.#m(t, e);
    if (!n.length) return {};
    const i = n.flatMap((s) => s.parsed), r = n[n.length - 1];
    return {
      aria: p5(i),
      shortcut: this.#p(r)
    };
  }
  destroy() {
    this.#a || (this.#a = !0, this.#n?.abort(), this.#n = null, this.#r?.abort(), this.#r = null, this.#t = [], this.#f(), this.#s.clear(), this.#o.clear());
  }
  #d() {
    this.#t.sort((t, e) => {
      const n = e.parsed[0].modifiers.size - t.parsed[0].modifiers.size;
      return n !== 0 ? n : t.id - e.id;
    });
  }
  #h() {
    this.#n || (this.#n = new AbortController(), Q(this.#e, "keydown", this.#l, { signal: this.#n.signal }));
  }
  #u() {
    this.#r || (this.#r = new AbortController(), Q(document, "keydown", this.#l, { signal: this.#r.signal }));
  }
  #c() {
    const t = this.#t.some((n) => n.options.target !== "document"), e = this.#t.some((n) => n.options.target === "document");
    t || (this.#n?.abort(), this.#n = null), e || (this.#r?.abort(), this.#r = null);
  }
  #l = (t) => {
    if (_a(this.#e) || t.key === "Unidentified" || hh(t) || t.defaultPrevented) return;
    const e = WS(t);
    for (const n of this.#t) {
      const { options: i, parsed: r } = n;
      if (!i.disabled && !(t.repeat && i.repeatable === !1) && i.target === "document" == (t.currentTarget === document)) {
        for (const s of r)
          if (_5(s, t) && !(e && s.modifiers.size === 0)) {
            if (this.#s.size > 0) {
              const o = {
                source: "hotkey",
                action: i.action,
                value: i.value,
                event: t
              };
              for (const a of this.#s) try {
                a(o);
              } catch {
              }
            }
            t.preventDefault(), i.onActivate(t, s.originalKey);
            return;
          }
      }
    }
  };
  #m(t, e) {
    return this.#t.filter((n) => n.options.disabled || n.options.action !== t ? !1 : Ce(e) ? !0 : n.options.value === e).sort((n, i) => n.id - i.id);
  }
  #p(t) {
    return t.options.keys === "0-9" ? t.options.keys : m5(t.parsed[0]);
  }
  #f() {
    for (const t of this.#o) t();
  }
};
const y5 = /* @__PURE__ */ new Set([
  "shift",
  "ctrl",
  "alt",
  "meta"
]);
function rb(t) {
  if (t === "0-9") return Array.from({ length: 10 }, (r, s) => ({
    modifiers: /* @__PURE__ */ new Set(),
    key: String(s),
    originalKey: String(s)
  }));
  const e = t.split("+"), n = e.pop(), i = /* @__PURE__ */ new Set();
  for (const r of e) {
    const s = r.toLowerCase();
    s === "mod" ? i.add(iP() ? "meta" : "ctrl") : y5.has(s) && i.add(s);
  }
  return [{
    modifiers: i,
    key: n === "Space" ? " " : n.toLowerCase(),
    originalKey: n
  }];
}
function b5(t) {
  return t.length === 1 && !/[a-z]/i.test(t);
}
function _5(t, e) {
  if (e.key === "Unidentified" || e.key.toLowerCase() !== t.key) return !1;
  const n = b5(e.key), i = n ? e.shiftKey && t.modifiers.has("shift") : e.shiftKey, r = n ? e.altKey && t.modifiers.has("alt") : e.altKey;
  return !(i !== t.modifiers.has("shift") || e.ctrlKey !== t.modifiers.has("ctrl") || r !== t.modifiers.has("alt") || e.metaKey !== t.modifiers.has("meta"));
}
const jp = /* @__PURE__ */ new WeakMap();
function Rh(t) {
  let e = jp.get(t);
  return e || (e = new v5(t), jp.set(t, e)), e;
}
function w5(t, e) {
  const n = Rh(t), i = rb(e.keys)[0]?.originalKey;
  return n.add({
    ...e,
    value: qa(e.action ?? "", i, e.value)
  });
}
const k5 = [
  Uy,
  Wy,
  Gy,
  Iy,
  Qy,
  Zy,
  Yy,
  Dy,
  zy,
  Hy,
  Ky,
  Ly,
  Jy,
  Ny,
  By
];
function x5(t) {
  const { onActivate: e, isDisabled: n } = t;
  return {
    role: "button",
    tabIndex: 0,
    onClick(i) {
      if (n()) {
        i.preventDefault();
        return;
      }
      e(i, (i.detail ?? 0) > 0 ? "pointer" : "virtual");
    },
    onPointerDown(i) {
      n() && i.preventDefault();
    },
    onMouseDown(i) {
      n() && i.preventDefault();
    },
    onKeyDown(i) {
      if (i.target === i.currentTarget) {
        if (n()) {
          i.key !== "Tab" && i.preventDefault();
          return;
        }
        i.key === "Enter" ? (i.preventDefault(), e(i, "keyboard")) : i.key === " " && i.preventDefault();
      }
    },
    onKeyUp(i) {
      i.target === i.currentTarget && (n() || i.key === " " && e(i, "keyboard"));
    }
  };
}
const S5 = "group", P5 = 0;
function E5(t) {
  const e = si(t.ownerDocument);
  (!e || e === t.ownerDocument.body || !Wt(t, e)) && t.focus({ preventScroll: !0 });
}
function sb(t) {
  const { transition: e } = t, n = e.state, i = new AbortController();
  let r = null;
  function s(h) {
    if (i.signal.aborted) return null;
    const { active: f, status: p } = n.current;
    return f && p !== "ending" ? null : (p === "ending" && e.cancel(), e.open(h));
  }
  function o(h) {
    const { active: f, status: p } = n.current;
    return i.signal.aborted || !f || p === "ending" ? null : e.close(h);
  }
  function a() {
    if (l(), typeof document > "u") return;
    r = new AbortController();
    const { signal: h } = r;
    Q(document, "keydown", c, { signal: h }), t.onDocumentActive?.(h);
  }
  function l() {
    r?.abort(), r = null;
  }
  function c(h) {
    h.key === "Escape" && (h.defaultPrevented || n.current.active && (t.closeOnEscape?.() ?? !0) && t.onEscapeDismiss(h));
  }
  const u = n.subscribe(() => {
    n.current.active && n.current.status !== "ending" ? a() : l();
  });
  i.signal.addEventListener("abort", () => {
    u(), e.destroy(), l();
  });
  function d() {
    i.signal.aborted || i.abort();
  }
  return {
    input: n,
    open: s,
    close: o,
    signal: i.signal,
    destroy: d
  };
}
function T5(t) {
  let e = null, n = null, i = null, r = null, s = null, o = null, a = 0;
  const l = /* @__PURE__ */ new Map(), c = at({ documentModal: !0 }), u = sb({
    transition: t.transition,
    closeOnEscape: t.closeOnEscape,
    onEscapeDismiss(P) {
      S(P) && (P.preventDefault(), P.stopPropagation(), f());
    },
    onDocumentActive(P) {
      Q(document, "keydown", v, {
        capture: !0,
        signal: P
      }), Q(document, "focusin", g, { signal: P });
    }
  }), d = u.input;
  function h() {
    i = si();
    const P = u.open(() => e);
    P && (E(), _(), t.onOpenChange(!0), p(), P.then(() => {
      u.signal.aborted || !d.current.active || d.current.status !== "idle" || t.onOpenChangeComplete?.(!0);
    }));
  }
  function f() {
    const P = u.close(e);
    P && (cancelAnimationFrame(a), a = 0, t.onOpenChange(!1), P.then(() => {
      if (u.signal.aborted || d.current.active) return;
      const C = si(), M = s && C instanceof Element && !Wt(s, C);
      T();
      const O = n?.isConnected ? n : i;
      !M && O?.isConnected && O.focus(), i = null, t.onOpenChangeComplete?.(!1);
    }));
  }
  function p() {
    cancelAnimationFrame(a), a = requestAnimationFrame(() => {
      a = 0, !(u.signal.aborted || !d.current.active || !e) && (e.querySelector("[autofocus]") ?? ac(e)[0] ?? e).focus();
    });
  }
  function v(P) {
    if (P.key !== "Tab" || !d.current.active || !e || !c.current.documentModal) return;
    const C = ac(e);
    if (C.length === 0) {
      P.preventDefault(), e.focus();
      return;
    }
    const M = si(), O = C[0], W = C[C.length - 1];
    P.shiftKey && (M === O || !M || !Wt(e, M)) ? (P.preventDefault(), W.focus()) : !P.shiftKey && (M === W || !M || !Wt(e, M)) && (P.preventDefault(), O.focus());
  }
  function g(P) {
    !d.current.active || !e || P.target instanceof Element && Wt(e, P.target) || s && P.target instanceof Element && !Wt(s, P.target) || (ac(e)[0] ?? e).focus();
  }
  function m(P) {
    n = P;
  }
  function y(P) {
    e !== P && T(), e = P, E(), P && d.current.active && _();
    const C = si();
    P && d.current.active && (!C || !Wt(P, C)) && p();
  }
  function k(P) {
    r !== P && (T(), r = P, E(), e && d.current.active && _());
  }
  return u.signal.addEventListener("abort", () => {
    cancelAnimationFrame(a), a = 0, T(), e = null, n = null, i = null, r = null, s = null;
  }), {
    input: d,
    modality: c,
    triggerProps: { onClick() {
      h();
    } },
    open: h,
    close: f,
    setTriggerElement: m,
    setPopupElement: y,
    setInteractionRoot: k,
    destroy: u.destroy
  };
  function _() {
    !e?.isConnected || l.size > 0 || o || (E(), dh(e, (P) => {
      if (P === s || P === e?.ownerDocument.body) return !0;
      if (P.assignedSlot) {
        for (const O of P.assignedSlot.assignedElements({ flatten: !0 })) O !== P && O instanceof HTMLElement && w(O);
        return;
      }
      const C = P.parentElement;
      if (C) {
        for (const O of C.children) O !== P && O instanceof HTMLElement && w(O);
        return;
      }
      const M = P.getRootNode();
      if (M instanceof ShadowRoot)
        for (const O of M.children) O !== P && O instanceof HTMLElement && w(O);
    }, { composed: !0 }), s && (o = ET(s)));
  }
  function w(P) {
    l.set(P, P.hasAttribute("inert")), P.setAttribute("inert", "");
  }
  function T() {
    for (const [P, C] of l) C || P.removeAttribute("inert");
    l.clear(), o?.(), o = null;
  }
  function E() {
    s = r && e && Wt(r, e) ? r : null, c.patch({ documentModal: !s });
  }
  function S(P) {
    if (!s) return !0;
    const C = P.target instanceof Element ? P.target : si();
    return C instanceof Element && Wt(s, C);
  }
}
function C5(t) {
  return {
    action: t.action,
    value: t.value,
    source: t.source,
    key: "key" in t.event ? t.event.key : void 0,
    repeat: "repeat" in t.event ? t.event.repeat : void 0
  };
}
function Xu(t) {
  if (!t) return {};
  const e = t.state, n = sr(e), i = rr(e);
  return {
    paused: rs(e)?.paused,
    volume: Zn(e)?.volume,
    muted: Zn(e)?.muted,
    playbackRate: Ga(e)?.playbackRate,
    isFullscreen: Dl(e)?.isFullscreen,
    subtitlesShowing: i?.subtitlesShowing,
    subtitlesAvailable: i ? (i.textTrackList ?? []).some(po) : void 0,
    isPictureInPicture: $h(e)?.isPictureInPicture,
    currentTime: n?.currentTime,
    duration: n?.duration,
    seeking: n?.seeking
  };
}
function A5(t, e) {
  const n = (s) => e(C5(s)), i = Eh(t).subscribe(n), r = Rh(t).subscribe(n);
  return () => {
    i(), r();
  };
}
const zp = /* @__PURE__ */ new WeakMap();
function $5(t) {
  let e = zp.get(t);
  return e || (e = new p2(), zp.set(t, e)), e;
}
function R5(t) {
  t?.getBoundingClientRect();
}
function Mh(t, e, n, i) {
  const r = t + n, s = e + i;
  return {
    x: t,
    y: e,
    width: n,
    height: i,
    top: e,
    right: r,
    bottom: s,
    left: t,
    toJSON() {
      return {
        x: t,
        y: e,
        width: n,
        height: i,
        top: e,
        right: r,
        bottom: s,
        left: t
      };
    }
  };
}
function M5(t, e) {
  const n = Math.max(t.left, e.left), i = Math.max(t.top, e.top), r = Math.min(t.right, e.right), s = Math.min(t.bottom, e.bottom);
  return Mh(n, i, Math.max(0, r - n), Math.max(0, s - i));
}
function O5(t) {
  const e = document.documentElement.getBoundingClientRect();
  return t ? M5(e, t.getBoundingClientRect()) : e;
}
function I5(t, e = {}) {
  if (!t) return null;
  if (!R0(t)) return t;
  if (t === "viewport") return null;
  if (t === "container") return e.container ?? null;
  try {
    return (e.root ?? document).querySelector(t);
  } catch {
    return null;
  }
}
function Oh(t) {
  const { onOpenChange: e, closeOnOutsideClick: n } = t;
  let i = null, r = null, s = null;
  const o = /* @__PURE__ */ new Set();
  let a = !1, l = null;
  const c = sb({
    transition: t.transition,
    closeOnEscape: t.closeOnEscape,
    onEscapeDismiss(F) {
      F.preventDefault(), E("escape", F);
    },
    onDocumentActive(F) {
      Q(document, "pointerdown", M, {
        capture: !0,
        signal: F
      });
    }
  }), u = c.input, d = {
    close(F) {
      E(F);
    },
    get triggerElement() {
      return i;
    }
  };
  function h() {
    s !== null && (clearTimeout(s), s = null);
  }
  function f() {
    return globalThis.matchMedia?.("(hover: hover)")?.matches ?? !1;
  }
  function p() {
    return f() ? globalThis.matchMedia?.("(pointer: fine)")?.matches ?? !1 : !1;
  }
  function v() {
    return t.openOnHover?.() ? f() : !0;
  }
  function g() {
    a = !1, l !== null && (clearTimeout(l), l = null);
  }
  function m() {
    a = !0, l !== null && clearTimeout(l), l = setTimeout(g, 500);
  }
  function y() {
    return a ? (g(), !0) : !1;
  }
  function k() {
    return i ? i.hasAttribute("disabled") ? !0 : i.getAttribute("aria-disabled") === "true" : !1;
  }
  function _() {
    const F = c.open(() => r);
    F && (queueMicrotask(() => {
      c.signal.aborted || !u.current.active || u.current.status === "ending" || sp(r);
    }), t.group?.()?.open(d), F.then(() => {
      c.signal.aborted || !u.current.active || u.current.status !== "idle" || t.onOpenChangeComplete?.(!0);
    }));
  }
  function w() {
    const F = c.close(r);
    F && (t.group?.()?.close(d), F.then(() => {
      c.signal.aborted || u.current.active || (op(r), t.onOpenChangeComplete?.(!1));
    }));
  }
  function T(F, K) {
    if (c.signal.aborted) return;
    const { active: B, status: $ } = u.current;
    B && $ !== "ending" || (e(!0, K ? {
      reason: F,
      event: K
    } : { reason: F }), t.deferOpenChanges || _());
  }
  function E(F, K) {
    if (c.signal.aborted) return;
    const { active: B, status: $ } = u.current;
    !B || $ === "ending" || (e(!1, K ? {
      reason: F,
      event: K
    } : { reason: F }), t.deferOpenChanges || w());
  }
  function S(F = "click") {
    T(F);
  }
  function P(F = "click") {
    h(), E(F);
  }
  function C(F) {
    t.deferOpenChanges && (F ? _() : w());
  }
  function M(F) {
    if (!n() || !u.current.active) return;
    const K = F.composedPath();
    if (i && K.includes(i) || r && K.includes(r)) {
      m();
      return;
    }
    g(), E("outside-click", F);
  }
  c.signal.addEventListener("abort", () => {
    t.group?.()?.close(d), h(), g(), o.clear(), i = null, r = null;
  });
  const O = {
    onClick(F) {
      v() && (k() || (u.current.active && u.current.status !== "ending" ? E("click", F) : T("click", F)));
    },
    onPointerEnter(F) {
      if (!t.openOnHover?.() || !f() || (h(), u.current.active)) return;
      const K = t.delay?.() ?? 300;
      s = setTimeout(() => T("hover"), K);
    },
    onPointerLeave(F) {
      if (!t.openOnHover?.() || !f() || (h(), !u.current.active)) return;
      const K = t.closeDelay?.() ?? 0;
      s = setTimeout(() => E("hover"), K);
    },
    onFocusIn(F) {
      if (t.openOnHover?.()) {
        if (!p()) return;
        T("focus");
      }
    },
    onFocusOut(F) {
      const K = F.relatedTarget;
      K && (i?.contains(K) || r?.contains(K)) || t.openOnHover?.() && E("blur");
    }
  }, W = {
    onPointerEnter(F) {
      t.openOnHover?.() && h();
    },
    onPointerLeave(F) {
      if (!t.openOnHover?.() || o.size > 0 || (h(), !u.current.active)) return;
      const K = t.closeDelay?.() ?? 0;
      s = setTimeout(() => E("hover"), K);
    },
    onGotPointerCapture(F) {
      o.add(F.pointerId);
    },
    onLostPointerCapture(F) {
      o.delete(F.pointerId);
    },
    onFocusOut(F) {
      const K = F.relatedTarget;
      if (!(K && (i?.contains(K) || r?.contains(K))) && !y()) {
        if (K !== null) {
          E("blur");
          return;
        }
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!u.current.active || u.current.status === "ending" || u.current.status === "starting") return;
            const B = si(r?.ownerDocument);
            B && (i?.contains(B) || r?.contains(B)) || E("blur");
          });
        });
      }
    }
  };
  function H(F) {
    i = F;
  }
  function z(F) {
    !F && r && u.current.active && op(r), r = F, F && u.current.active && sp(F);
  }
  return {
    input: u,
    triggerProps: O,
    popupProps: W,
    get triggerElement() {
      return i;
    },
    setTriggerElement: H,
    setPopupElement: z,
    open: S,
    close: P,
    syncOpen: C,
    destroy: c.destroy
  };
}
function Js(t) {
  const { key: e } = t;
  return e === "ArrowDown" || e === "ArrowUp" || e === "ArrowLeft" || e === "ArrowRight" || e === "Home" || e === "End" || e === "Enter" || e === " " || e === "Escape" || e.length === 1 && !t.ctrlKey && !t.altKey && !t.metaKey;
}
function D5(t, e) {
  return !t || !e ? null : {
    side: t,
    align: e
  };
}
const F5 = {
  ...cn,
  availableWidth: kr.availableWidth,
  availableHeight: kr.availableHeight
}, Cn = /* @__PURE__ */ new WeakMap();
function ob(t) {
  t.close();
}
function L5(t) {
  const e = [];
  let n = null, i = null, r = null, s = null;
  const o = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Map();
  let l = "", c = null, u = null, d = 0, h = null, f;
  function p(D) {
    const A = D.getAttribute("data-availability");
    return !!(D.hidden || D.hasAttribute("data-hidden") || D.getAttribute("aria-hidden") === "true" || A === "unavailable" || A === "unsupported");
  }
  function v() {
    return e.filter((D) => !p(D));
  }
  function g(D) {
    if (e.length === 0) return null;
    const A = n ? e.indexOf(n) : D === 1 ? -1 : 0;
    for (let N = 1; N <= e.length; N++) {
      const X = (A + D * N + e.length) % e.length, U = e[X];
      if (U && !p(U)) return U;
    }
    return null;
  }
  function m(D, A) {
    if (!D && d && (cancelAnimationFrame(d), d = 0), D && p(D)) {
      D === n && m(g(1), A);
      return;
    }
    if (n === D) {
      D?.setAttribute(ar.highlighted, A?.pointer === !0 ? "pointer" : "");
      return;
    }
    const N = n;
    N && (N.tabIndex = -1), n = D, D ? (D.tabIndex = 0, D.setAttribute(ar.highlighted, A?.pointer === !0 ? "pointer" : ""), N && F(D, N) < 0 && A?.pointer && R5(D.parentElement), N?.removeAttribute(ar.highlighted), A?.focus !== !1 && (A?.preventScroll ? D.focus({ preventScroll: !0 }) : D.focus())) : N?.removeAttribute(ar.highlighted), t.onHighlightChange?.(D);
  }
  function y() {
    n && (n.tabIndex = -1, n.removeAttribute(ar.highlighted), n = null, t.onHighlightChange?.(null));
  }
  function k(D) {
    m(v()[0] ?? null, D);
  }
  function _(D) {
    m(T(), D);
  }
  function w(D) {
    h === "imperative-action" || h === "group-open" || h === "blur" || h === "outside-click" || (D ? i?.focus(D) : i?.focus());
  }
  function T() {
    const D = v();
    return D.find((A) => A.matches('[role="menuitemradio"][aria-checked="true"], [aria-selected="true"]')) ?? D[0] ?? null;
  }
  function E() {
    c !== null && (clearTimeout(c), c = null), l = "";
  }
  function S() {
    cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      d = 0, !(!C.input.current.active || C.input.current.status === "ending" || n) && m(T(), { preventScroll: !0 });
    });
  }
  function P(D) {
    l = l.length === 1 && l.toLowerCase() === D.toLowerCase() ? D : l + D, c !== null && clearTimeout(c), c = setTimeout(E, 500);
    const A = v(), N = (n ? A.indexOf(n) : -1) + 1, X = [...A.slice(N), ...A.slice(0, N)], U = l.toLowerCase(), j = X.find((ie) => (ie.textContent?.trim().toLowerCase() ?? "").startsWith(U));
    j && m(j);
  }
  const C = Oh({
    transition: t.transition,
    deferOpenChanges: !0,
    onOpenChange(D, A) {
      h = D ? null : A.reason, t.onOpenChange(D, A), D ? S() : (y(), E());
    },
    onOpenChangeComplete(D) {
      if (t.onOpenChangeComplete?.(D), !D && r) {
        const A = si(r.ownerDocument);
        (!(A instanceof Element) || A === r.ownerDocument.body || Wt(r, A)) && w();
      }
    },
    closeOnEscape: t.closeOnEscape,
    closeOnOutsideClick: t.closeOnOutsideClick,
    ...t.group ? { group: t.group } : {}
  }), M = {
    onFocusOut(D) {
      if (D.relatedTarget === null && $()) {
        u = D;
        return;
      }
      C.popupProps.onFocusOut(D);
    },
    onKeyDown(D) {
      const { key: A } = D, N = v();
      if (A !== "Escape" && Js(D) && !D.defaultPrevented && D.preventDefault(), N.length !== 0)
        switch (A) {
          case "ArrowDown":
            D.preventDefault(), m(g(1));
            break;
          case "ArrowUp":
            D.preventDefault(), m(g(-1));
            break;
          case "Home":
            D.preventDefault(), m(N[0] ?? null);
            break;
          case "End":
            D.preventDefault(), m(N[N.length - 1] ?? null);
            break;
          case "Enter":
          case " ":
            D.preventDefault(), n && N.includes(n) && n.click();
            break;
          default:
            A.length === 1 && !D.ctrlKey && !D.altKey && !D.metaKey && P(A);
        }
    }
  };
  function O(D) {
    const A = C.input.current;
    !A.active || A.status === "ending" || D.key !== "Escape" && Js(D) && (M.onKeyDown(D), D.stopPropagation());
  }
  function W(D) {
    i = D, C.setTriggerElement(D);
  }
  function H(D) {
    r = D;
  }
  function z(D) {
    s = D, C.setPopupElement(D);
  }
  function F(D, A) {
    if (D === A) return 0;
    const N = D.compareDocumentPosition(A);
    return N & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : N & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  }
  function K(D) {
    const A = () => m(D, { focus: !1 });
    return D.tabIndex = -1, D.setAttribute(ar.item, ""), D.addEventListener("focus", A), e.push(D), e.sort(F), C.input.current.active && C.input.current.status !== "ending" && !n && S(), () => {
      D.removeEventListener("focus", A);
      const N = e.indexOf(D);
      N !== -1 && e.splice(N, 1), n === D && y();
    };
  }
  function B(D) {
    o.add(D), Cn.set(D, f);
    const A = D.input.subscribe(I);
    return a.set(D, A), () => {
      o.delete(D), Cn.get(D) === f && Cn.delete(D), a.get(D)?.(), a.delete(D), I();
    };
  }
  function $() {
    return [...o].some(({ input: D }) => D.current.status === "ending");
  }
  function I() {
    if (!u || $()) return;
    const D = u;
    u = null, C.popupProps.onFocusOut(D);
  }
  function q(D) {
    if (D) Cn.get(f)?.highlight(null);
    else for (const A of o) A.close("imperative-action");
    C.syncOpen(D);
  }
  function J() {
    cancelAnimationFrame(d), d = 0, E();
    for (const D of a.values()) D();
    for (const D of o) Cn.get(D) === f && Cn.delete(D);
    a.clear(), o.clear(), Cn.delete(f), u = null, C.destroy();
  }
  return f = {
    input: C.input,
    triggerProps: {
      onClick: C.triggerProps.onClick,
      onKeyDown: O
    },
    contentProps: M,
    get triggerElement() {
      return i;
    },
    get contentElement() {
      return r;
    },
    get popupElement() {
      return s;
    },
    setTriggerElement: W,
    setContentElement: H,
    setPopupElement: z,
    registerItem: K,
    registerSubmenu: B,
    highlight: m,
    highlightFirstItem: k,
    highlightInitialItem: _,
    restoreFocus: w,
    open: C.open,
    close: C.close,
    syncOpen: q,
    destroy: J
  }, f;
}
function N5() {
  const t = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new Map();
  let n = null, i = 0;
  function r() {
    cancelAnimationFrame(i), g(), i = requestAnimationFrame(g);
  }
  function s(_) {
    return [...t].filter((w) => w.parent === _);
  }
  function o(_) {
    return s(_).find(({ menu: w }) => {
      const T = w.input.current;
      return T.active && T.status !== "ending";
    }) ?? null;
  }
  function a(_) {
    return s(_).find(({ menu: w }) => {
      const T = w.input.current;
      return T.active && T.status === "ending";
    }) ?? null;
  }
  function l(_) {
    cancelAnimationFrame(e.get(_) ?? 0), e.delete(_);
  }
  function c(_) {
    if (e.has(_)) return;
    const w = requestAnimationFrame(() => {
      e.set(_, requestAnimationFrame(() => {
        e.delete(_), !(!t.has(_) || o(_.menu)) && (_.element.removeAttribute(Qi.childOpen), g());
      }));
    });
    e.set(_, w);
  }
  function u() {
    let _ = [...t].find((w) => w.parent === null) ?? null;
    for (; _; ) {
      const w = o(_.menu) ?? (e.has(_) ? a(_.menu) : null);
      if (!w) return _;
      _ = w;
    }
    return null;
  }
  function d(_, w) {
    w ? (_.element.setAttribute("aria-hidden", "true"), _.element.setAttribute("inert", "")) : oc(_.element, _.accessibility);
  }
  function h(_) {
    const w = () => {
      const S = si(_.element.ownerDocument);
      return S instanceof Element && Wt(_.element, S);
    };
    if (!w()) return;
    _.menu.restoreFocus();
    const T = _.parent?.input.current;
    w() && T?.active && T.status !== "ending" && _.menu.triggerElement?.focus();
    const E = si(_.element.ownerDocument);
    w() && E instanceof HTMLElement && E.blur();
  }
  function f(_) {
    return dh(_, (w) => {
      const T = YS(w, kr.availableWidth);
      return T !== null && T > 0 ? T : void 0;
    }) ?? null;
  }
  function p(_) {
    if (_.scrollHeight <= _.clientHeight) return 0;
    const w = getComputedStyle(_), T = (Number.parseFloat(w.borderInlineStartWidth) || 0) + (Number.parseFloat(w.borderInlineEndWidth) || 0);
    return Math.max(0, _.offsetWidth - _.clientWidth - T);
  }
  function v(_, w) {
    const T = FS(_, (E) => E instanceof HTMLElement && !E.hidden);
    return T.length === 0 ? Tu(_, {
      overflow: "both",
      styles: {
        width: "max-content",
        height: "auto",
        minWidth: "0px",
        maxWidth: "none"
      }
    }) : ZS(_, {
      children: T,
      includePadding: !0,
      maxWidth: w,
      measure: (E, S) => Tu(E, {
        overflow: "both",
        styles: {
          insetInlineStart: "0px",
          insetInlineEnd: "auto",
          width: S === void 0 ? "max-content" : `${S}px`,
          height: "auto",
          minWidth: "0px",
          maxWidth: "none"
        }
      })
    });
  }
  function g() {
    if (!n) return;
    const _ = /* @__PURE__ */ new Map();
    for (const z of t) {
      const F = o(z.menu);
      F ? (l(z), z.menu.highlight(null), z.element.setAttribute(Qi.childOpen, "")) : a(z.menu) && z.element.hasAttribute(Qi.childOpen) ? c(z) : (l(z), z.element.removeAttribute(Qi.childOpen));
      const K = z.menu.input.current, B = z.parent !== null && K.active && K.status === "ending";
      _.set(z, F !== null || B), d(z, !1);
    }
    for (const [z, F] of _) {
      const K = z.menu.input.current;
      z.parent !== null && K.active && K.status === "ending" && h(z), d(z, F);
    }
    const w = u();
    if (!w) return;
    const T = w.parent === null ? H0(n) : null, E = T ? U0(T) : 0, S = T ? W0(T) : 0, P = f(n), C = P === null ? null : Math.max(0, P - E), M = v(w.element, C), O = Math.ceil(M.width + E), W = Math.ceil(M.height + S);
    n.style.setProperty(kr.width, `${O}px`), n.style.setProperty(kr.height, `${W}px`);
    const H = p(w.element);
    H > 0 && n.style.setProperty(kr.width, `${O + H}px`);
  }
  function m(_) {
    n = _, r();
  }
  function y(_) {
    const w = {
      ..._,
      accessibility: DS(_.element, ["aria-hidden", "inert"]),
      stopObserving: () => {
      },
      unsubscribe: () => {
      }
    };
    return w.unsubscribe = _.menu.input.subscribe(r), w.stopObserving = tP({
      root: _.element,
      getElements: () => [_.element],
      mutations: {
        childList: !0,
        subtree: !0,
        characterData: !0
      },
      onChange: r
    }), t.add(w), _.menu.setContentElement(_.element), r(), () => {
      l(w), t.delete(w), w.unsubscribe(), w.stopObserving(), oc(_.element, w.accessibility), _.element.removeAttribute(Qi.childOpen), _.menu.contentElement === _.element && _.menu.setContentElement(null), r();
    };
  }
  function k() {
    cancelAnimationFrame(i);
    for (const _ of e.values()) cancelAnimationFrame(_);
    e.clear();
    for (const _ of t)
      _.unsubscribe(), _.stopObserving(), oc(_.element, _.accessibility), _.element.removeAttribute(Qi.childOpen), _.menu.contentElement === _.element && _.menu.setContentElement(null);
    t.clear(), n = null;
  }
  return {
    get element() {
      return n;
    },
    setElement: m,
    registerContent: y,
    sync: g,
    destroy: k
  };
}
function V5() {
  let t = null;
  const e = /* @__PURE__ */ new Set();
  function n() {
    for (const i of e) i();
  }
  return {
    open(i) {
      if (t === i) return;
      const r = t;
      t = i, r?.close("group-open"), n();
    },
    close(i) {
      t === i && (t = null, n());
    },
    isOpenFor(i) {
      return i !== null && t?.triggerElement === i;
    },
    subscribe(i) {
      return e.add(i), () => e.delete(i);
    }
  };
}
function j5(t, e) {
  if (!e) return !1;
  if (ke(t.composedPath)) return t.composedPath().includes(e);
  const n = t.target;
  return n instanceof Node && e.contains(n);
}
const Ih = {
  sideOffset: 0,
  alignOffset: 0,
  boundaryOffset: 0
}, ab = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function Go(t) {
  return `${li(t, 0, 1 / 0)}px`;
}
function Bp(t, e, n, i) {
  const r = n - i;
  return r < e ? e : li(t, e, r);
}
function lb({ align: t, direction: e = "ltr" }) {
  return e !== "rtl" ? t : t === "start" ? "end" : t === "end" ? "start" : t;
}
function Hp(t, e, n, i, r, s, o, a, l, c) {
  const u = s === "start" ? t + o : s === "end" ? e + o : t + n / 2 + o, d = l === "horizontal" ? "left" : "top", h = ab[d], f = s === "start" ? d : s === "end" ? h : "center", p = s === "start" ? "0px" : s === "end" ? "-100%" : "-50%";
  return {
    base: `calc(anchor(${f}) + ${c})`,
    translate: `clamp(${i + a - u}px, ${p}, calc(${r - a - u}px - 100%))`
  };
}
function z5(t, e, n, i, r, s, o = cn) {
  if (Pu()) return {
    ...B5(t, e, o, n, r, s),
    ...n && r ? Up(n, r, e, s, o) : {}
  };
  if (n && i) {
    const a = s ?? Ih;
    return {
      position: "fixed",
      margin: "0",
      ...H5(n, i, e, a, r),
      ...r ? Up(n, r, e, a, o) : {}
    };
  }
  return {};
}
function B5(t, e, n = cn, i, r, s = Ih) {
  const o = `var(${n.sideOffset}, 0px)`, a = `var(${n.alignOffset}, 0px)`, { side: l, align: c } = e, u = s.boundaryOffset ?? 0, d = {
    positionAnchor: `--${t}`,
    position: "fixed",
    inset: "auto",
    margin: "0",
    justifySelf: "normal",
    alignSelf: "normal",
    marginInlineStart: "0",
    marginBlockStart: "0",
    translate: "none"
  }, h = ab[l];
  if (l === "top" || l === "bottom") {
    const f = lb(e);
    if (d[h] = `calc(anchor(${l}) + ${o})`, i && r) {
      const { base: p, translate: v } = Hp(i.left, i.right, i.width, r.left, r.right, f, s.alignOffset, u, "horizontal", a);
      return d.left = p, d.translate = `${v} 0`, d;
    }
    f === "start" ? d.left = `calc(anchor(left) + ${a})` : f === "end" ? d.right = `calc(anchor(right) + ${a})` : (d.justifySelf = "anchor-center", d.marginInlineStart = a);
  } else {
    if (d[h] = `calc(anchor(${l}) + ${o})`, i && r) {
      const { base: f, translate: p } = Hp(i.top, i.bottom, i.height, r.top, r.bottom, c, s.alignOffset, u, "vertical", a);
      return d.top = f, d.translate = `0 ${p}`, d;
    }
    c === "start" ? d.top = `calc(anchor(top) + ${a})` : c === "end" ? d.bottom = `calc(anchor(bottom) + ${a})` : (d.alignSelf = "anchor-center", d.marginBlockStart = a);
  }
  return d;
}
function Up(t, e, n, i = Ih, r = cn) {
  const s = {}, { side: o } = n, a = i.boundaryOffset ?? 0, l = e.left + a, c = e.right - a, u = e.top + a, d = e.bottom - a;
  if (s[r.anchorWidth] = `${t.width}px`, s[r.anchorHeight] = `${t.height}px`, o === "top" || o === "bottom") {
    const h = o === "top" ? t.top - u : d - t.bottom;
    s[r.availableHeight] = Go(h - i.sideOffset), s[r.availableWidth] = Go(c - l);
  } else {
    const h = o === "left" ? t.left - l : c - t.right;
    s[r.availableWidth] = Go(h - i.sideOffset), s[r.availableHeight] = Go(d - u);
  }
  return s;
}
function H5(t, e, n, i = {
  sideOffset: 0,
  alignOffset: 0
}, r) {
  const { side: s, align: o } = n, { sideOffset: a, alignOffset: l } = i;
  let c = 0, u, d = 0, h;
  if (s === "top" ? u = `calc(100% - ${t.top}px + ${a}px)` : s === "bottom" ? c = t.bottom + a : s === "left" ? h = `calc(100% - ${t.left}px + ${a}px)` : d = t.right + a, s === "top" || s === "bottom") {
    const f = lb(n);
    f === "start" ? d = t.left + l : f === "end" ? d = t.right - e.width + l : d = t.left + (t.width - e.width) / 2 + l;
  } else o === "start" ? c = t.top + l : o === "end" ? c = t.bottom - e.height + l : c = t.top + (t.height - e.height) / 2 + l;
  if (r) {
    const f = i.boundaryOffset ?? 0;
    s === "top" || s === "bottom" ? d = Bp(d, r.left + f, r.right - f, e.width) : c = Bp(c, r.top + f, r.bottom - f, e.height);
  }
  return {
    top: s === "top" ? "auto" : `${c}px`,
    bottom: u ?? "auto",
    left: s === "left" ? "auto" : `${d}px`,
    right: h ?? "auto"
  };
}
function U5(t, e = cn) {
  const n = getComputedStyle(t);
  return {
    sideOffset: ma(t, n.getPropertyValue(e.sideOffset)),
    alignOffset: ma(t, n.getPropertyValue(e.alignOffset)),
    boundaryOffset: ma(t, n.getPropertyValue(e.boundaryOffset))
  };
}
function W5(t, e) {
  const n = t.getBoundingClientRect(), i = z0(t, {
    box: "layout",
    overflow: e === "left" || e === "right" ? "width" : "height"
  });
  return Mh(n.left, n.top, i.width, i.height);
}
function q5(t) {
  const e = t.parentNode;
  if (G5(t) || !e) return {
    x: 0,
    y: 0
  };
  const n = t.ownerDocument.createElement("div");
  n.style.cssText = "position:fixed;left:0;top:0;width:0;height:0;margin:0;padding:0;border:0;visibility:hidden;pointer-events:none", e.insertBefore(n, t);
  const i = n.getBoundingClientRect();
  return n.remove(), {
    x: i.left,
    y: i.top
  };
}
function mc(t, e) {
  return Mh(t.left - e.x, t.top - e.y, t.width, t.height);
}
function G5(t) {
  return t.hasAttribute("popover") && zS();
}
const K5 = [
  "position",
  "inset",
  "margin",
  "margin-top",
  "margin-right",
  "margin-bottom",
  "margin-left",
  "justify-self",
  "align-self",
  "margin-inline-start",
  "margin-block-start",
  "translate",
  "top",
  "right",
  "bottom",
  "left"
];
var Y5 = class {
  #e = null;
  #t = null;
  #i = null;
  #n = null;
  #r = null;
  #s = !1;
  #o = null;
  #a = null;
  #d = oP(() => this.#l());
  sync(t) {
    const { anchorName: e, position: n, trigger: i, popup: r, boundary: s, container: o, cssVars: a = cn } = t;
    if (!n || !i || !r) {
      this.cleanup();
      return;
    }
    const l = I5(s, {
      container: o ?? null,
      root: r.getRootNode()
    }), c = this.#e;
    !c || c.anchorName !== e || c.trigger !== i || c.popup !== r || (c.cssVars ?? cn) !== a || c.trackResize !== t.trackResize || this.#t !== l ? (c?.popup && this.#p(c.popup), this.#u(), this.#e = {
      ...t,
      cssVars: a
    }, this.#t = l, this.#h()) : this.#e = {
      ...t,
      cssVars: a
    }, this.#l();
  }
  cleanup() {
    this.#e && (this.#e.popup && this.#p(this.#e.popup), this.#u(), this.#e = null, this.#t = null);
  }
  #h() {
    const t = this.#e;
    if (!t?.trigger || !t.popup) return;
    this.#f(t.trigger, t.popup, t.anchorName), this.#i = new AbortController();
    const { signal: e } = this.#i;
    window.addEventListener("scroll", this.#c, {
      capture: !0,
      passive: !0,
      signal: e
    }), window.addEventListener("resize", this.#c, { signal: e });
    const n = [t.trigger];
    t.trackResize !== !1 && n.push(t.popup), this.#t && n.push(this.#t), this.#n = fo(n, () => this.#c());
  }
  #u() {
    this.#i?.abort(), this.#i = null, this.#n?.(), this.#n = null, this.#d.cancel(), this.#y();
  }
  #c = (t) => {
    const e = this.#e?.popup;
    !e || t && j5(t, e) || this.#d();
  };
  #l() {
    const t = this.#e;
    if (!t?.position || !t.trigger || !t.popup) return;
    const e = t.trigger, n = Pu(), i = n ? {
      x: 0,
      y: 0
    } : q5(t.popup), r = mc(e.getBoundingClientRect(), i), s = mc(O5(this.#t), i), o = U5(t.popup, t.cssVars), a = t.position, l = () => mc(W5(t.popup, a.side), i), c = (f) => {
      const p = sP(r, f, s, a, o), { positionAnchor: v, ...g } = z5(t.anchorName, {
        ...a,
        side: p,
        direction: LS(e) ? "rtl" : "ltr"
      }, r, n ? void 0 : f, s, o, t.cssVars);
      return {
        popupRect: f,
        side: p,
        style: g
      };
    }, u = c(l());
    if (this.#m(t.popup, t.cssVars ?? cn), za(t.popup, u.style), t.onSideChange?.(u.side), n || !t.onSideChange) return;
    const d = l();
    if (d.width === u.popupRect.width && d.height === u.popupRect.height) return;
    const h = c(d);
    za(t.popup, h.style), h.side !== u.side && t.onSideChange(h.side);
  }
  #m(t, e) {
    if (this.#a) return;
    const n = [
      ...K5,
      e.anchorWidth,
      e.anchorHeight,
      e.availableWidth,
      e.availableHeight
    ];
    this.#a = V0(t, n);
  }
  #p(t) {
    this.#a && (j0(t, this.#a), this.#a = null);
  }
  #f(t, e, n) {
    if (!Pu()) return;
    const i = `--${n}`, r = this.#g(t, "anchor-name");
    this.#o = this.#g(e, "position-anchor");
    const s = np(t);
    this.#r = i, this.#s = !s.includes(i), this.#s && s.push(i), t.style.setProperty("anchor-name", s.join(", "), r.priority), e.style.setProperty("position-anchor", i);
  }
  #y() {
    const t = this.#e;
    if (!(!t?.trigger || !t.popup)) {
      if (this.#r && this.#s) {
        const e = this.#g(t.trigger, "anchor-name"), n = np(t.trigger).filter((i) => i !== this.#r);
        this.#v(t.trigger, "anchor-name", {
          value: n.join(", "),
          priority: e.priority
        });
      }
      this.#o && this.#v(t.popup, "position-anchor", this.#o), this.#r = null, this.#s = !1, this.#o = null;
    }
  }
  #g(t, e) {
    const n = e.startsWith("--") ? e : Eu(e);
    return {
      value: t.style.getPropertyValue(n),
      priority: t.style.getPropertyPriority(n)
    };
  }
  #v(t, e, n) {
    const i = e.startsWith("--") ? e : Eu(e);
    n.value ? t.style.setProperty(i, n.value, n.priority) : t.style.removeProperty(i);
  }
};
function Ko(t, e, n) {
  let i;
  return n === "vertical" ? i = 1 - (t.clientY - e.top) / e.height : i = (t.clientX - e.left) / e.width, Number.isFinite(i) ? li(i * 100, 0, 100) : 0;
}
const X5 = 3;
function J5(t) {
  const e = at({
    pointerPercent: 0,
    dragPercent: 0,
    dragging: !1,
    pointing: !1,
    focused: !1
  }), n = new AbortController(), i = t.changeThrottle ?? 0;
  let r = !1, s = null, o = null, a = 0, l = 0, c = 0, u = null, d = !1, h = !1;
  const f = i > 0 ? PS((T) => t.onValueChange?.(T), i) : null;
  function p(T, E) {
    f ? f(T) : t.onValueChange?.(T);
  }
  function v() {
    if (Fi(o)) return;
    const T = o;
    o = null;
    try {
      t.getElement().releasePointerCapture(T);
    } catch {
    }
  }
  function g() {
    if (!r) return;
    const T = d && h, E = e.current.dragging;
    d || t.onValueCommit?.(c), r = !1, e.patch({
      dragging: !1,
      pointing: T
    }), E && t.onDragEnd?.(), t.onPressEnd?.(), d = !1, h = !1, m();
  }
  function m() {
    f?.cancel(), o = null, s = null;
  }
  const y = {
    onPointerDown(T) {
      if (t.isDisabled()) return;
      T.stopPropagation(), T.preventDefault();
      const E = t.getElement();
      s = E.getBoundingClientRect(), d = !1, h = !1, v(), o = T.pointerId, E.setPointerCapture(T.pointerId);
      const S = Ko(T, s, t.getOrientation());
      r = !0, a = T.clientX, l = T.clientY, c = S, u = S, e.patch({
        pointing: !0,
        pointerPercent: S,
        dragPercent: S
      }), t.onPressStart?.(), t.onValueChange?.(S), t.getThumbElement?.()?.focus({
        preventScroll: !0,
        focusVisible: !1
      });
    },
    onPointerMove(T) {
      if (t.isDisabled()) return;
      if (!Fi(o)) {
        if (T.pointerType !== "touch" && T.buttons === 0) {
          g();
          return;
        }
        const P = Ko(T, s, t.getOrientation()), C = !e.current.dragging;
        if (C && Math.hypot(T.clientX - a, T.clientY - l) < X5)
          return;
        c = P, u = P, e.patch({
          dragging: !0,
          dragPercent: P,
          pointerPercent: P
        }), C && t.onDragStart?.(), p(P);
        return;
      }
      const E = t.getElement().getBoundingClientRect(), S = Ko(T, E, t.getOrientation());
      e.patch({
        pointing: !0,
        pointerPercent: S
      });
    },
    onPointerUp(T) {
      if (t.isDisabled() || (T.stopPropagation(), Fi(o))) return;
      const E = Ko(T, s, t.getOrientation());
      h = T.pointerType !== "touch" && B0(t.getElement(), T), f?.cancel(), t.onValueChange?.(E), t.onValueCommit?.(E), d = !0;
    },
    onPointerLeave() {
      Fi(o) && e.patch({ pointing: !1 });
    },
    onLostPointerCapture() {
      g();
    }
  }, k = {
    onKeyDownCapture(T) {
      if (t.isDisabled()) {
        T.key !== "Tab" && T.preventDefault();
        return;
      }
      const E = t.getStepPercent(), S = t.getLargeStepPercent(), P = T.repeat && !Fi(u) ? u : t.getPercent(), C = gy(P, E, 0), M = T.shiftKey ? S : E;
      let O = null;
      switch (T.key) {
        case "ArrowRight":
          O = C + M;
          break;
        case "ArrowLeft":
          O = C - M;
          break;
        case "ArrowUp":
          O = C + M;
          break;
        case "ArrowDown":
          O = C - M;
          break;
        case "PageUp":
          O = C + S;
          break;
        case "PageDown":
          O = C - S;
          break;
        case "Home":
          O = 0;
          break;
        case "End":
          O = 100;
      }
      O !== null && (T.preventDefault(), O = li(O, 0, 100), u = O, e.patch({
        pointerPercent: O,
        dragPercent: O,
        pointing: !1
      }), t.onValueChange?.(O), t.onValueCommit?.(O));
    },
    onFocus() {
      e.patch({ focused: !0 });
    },
    onBlur() {
      e.patch({ focused: !1 });
    }
  };
  function _(T) {
    if (!t.adjustPercent || T.thumbAlignment !== "edge") return T;
    const E = t.getElement(), S = t.getThumbElement?.();
    if (!S) return T;
    const P = T.orientation === "horizontal", C = P ? S.offsetWidth : S.offsetHeight, M = P ? E.offsetWidth : E.offsetHeight;
    return {
      ...T,
      fillPercent: t.adjustPercent(T.fillPercent, C, M),
      pointerPercent: t.adjustPercent(T.pointerPercent, C, M)
    };
  }
  let w = null;
  return t.onResize && (w = fo(t.getElement(), () => t.onResize())), {
    input: e,
    rootProps: y,
    rootStyle: {
      touchAction: "none",
      userSelect: "none"
    },
    thumbProps: k,
    adjustForAlignment: _,
    destroy() {
      n.signal.aborted || (n.abort(), w?.(), v(), m());
    }
  };
}
function cb(t) {
  return {
    [Xs.fill]: `${t.fillPercent.toFixed(3)}%`,
    [Xs.pointer]: `${t.pointerPercent.toFixed(3)}%`
  };
}
function Z5(t) {
  return {
    ...cb(t),
    [Xs.buffer]: `${t.bufferPercent.toFixed(3)}%`
  };
}
function Q5(t, e) {
  const n = t / 2;
  return {
    position: "absolute",
    left: e === "visible" ? `calc(var(${Xs.pointer}) - ${n}px)` : `min(max(0px, calc(var(${Xs.pointer}) - ${n}px)), calc(100% - ${t}px))`,
    width: "max-content",
    pointerEvents: "none"
  };
}
function eC(t = document) {
  const e = tp(t) ? t : t.ownerDocument, n = si(e);
  return n?.getAttribute("role") !== "slider" ? !1 : tp(t) || Wt(t, n);
}
function tC(t, e) {
  let n = !0, i = !1, r = t.target, s = 0;
  const o = () => {
    r = t.target, i = !0;
    const l = ++s;
    e.resetSnapshot(), queueMicrotask(() => {
      !n || l !== s || (i = !1, r = t.target, r && e.processSnapshot(Xu(t)));
    });
  }, a = t.subscribe(() => {
    const l = t.target;
    if (l !== r) {
      o();
      return;
    }
    !l || i || e.processSnapshot(Xu(t));
  });
  return o(), () => {
    n = !1, a();
  };
}
function iC(t) {
  return !t || !eC(t);
}
function nC(t) {
  const { getContainer: e, getImg: n, onStateChange: i } = t, r = new xy();
  let s = !1, o = !1, a = 0, l = 0, c = "", u = null, d = null, h = null, f = null;
  const p = /* @__PURE__ */ new Set();
  function v() {
    const S = n();
    S && (a = S.naturalWidth, l = S.naturalHeight), p.delete(c), s = !1, o = !1, i();
  }
  function g() {
    p.add(c), s = !1, o = !0;
  }
  function m() {
    g(), i();
  }
  function y(S) {
    h = new AbortController(), Q(S, "load", v, { signal: h.signal }), Q(S, "error", m, { signal: h.signal });
  }
  function k() {
    const S = n();
    if (S !== u && (h?.abort(), h = null, u = S, d = null, S && y(S)), !f) {
      const P = e();
      P && (f = fo(P, i));
    }
  }
  function _(S) {
    k();
    const P = S ?? "";
    if (P !== c)
      if (c = P, P) {
        const C = p.has(P);
        s = !C, o = C;
      } else
        s = !1, o = !1, a = 0, l = 0;
  }
  function w() {
    k();
    const S = n();
    if (!S || S === d || (d = S, !S.complete || !c)) return;
    const P = {
      loading: s,
      error: o,
      naturalWidth: a,
      naturalHeight: l
    };
    S.naturalWidth > 0 ? (a = S.naturalWidth, l = S.naturalHeight, s = !1, o = !1) : g(), (P.loading !== s || P.error !== o || P.naturalWidth !== a || P.naturalHeight !== l) && i();
  }
  function T(S) {
    S === u && (h?.abort(), h = null, u = null, d = null);
  }
  function E() {
    h?.abort(), h = null, u = null, d = null, f?.(), f = null;
  }
  return {
    get loading() {
      return s;
    },
    get error() {
      return o;
    },
    get naturalWidth() {
      return a;
    },
    get naturalHeight() {
      return l;
    },
    readConstraints() {
      const S = e();
      return S ? r.parseConstraints(getComputedStyle(S)) : {
        minWidth: 0,
        maxWidth: 1 / 0,
        minHeight: 0,
        maxHeight: 1 / 0
      };
    },
    updateSrc: _,
    connect: w,
    disconnectImg: T,
    destroy: E
  };
}
const rC = {
  hover: "hover",
  focus: "focus",
  escape: "escape",
  blur: "blur",
  "imperative-action": "imperative-action"
};
function sC(t) {
  const e = {
    transition: t.transition,
    onOpenChange(p, v) {
      const g = rC[v.reason];
      if (!g) return;
      const m = t.group?.();
      p ? m?.notifyOpen() : m?.notifyClose();
      const y = v.event ? {
        reason: g,
        event: v.event
      } : { reason: g };
      t.onOpenChange(p, y);
    },
    closeOnEscape: () => !0,
    closeOnOutsideClick: () => !1,
    openOnHover: () => !0,
    delay: () => {
      const p = t.group?.();
      return p?.shouldSkipDelay() ? 0 : t.delay?.() ?? p?.delay ?? 600;
    },
    closeDelay: () => {
      const p = t.group?.();
      return t.closeDelay?.() ?? p?.closeDelay ?? 0;
    }
  };
  t.onOpenChangeComplete && (e.onOpenChangeComplete = t.onOpenChangeComplete);
  const n = Oh(e);
  let i = !1, r, s;
  function o() {
    return r?.isOpenFor(n.triggerElement) ?? !1;
  }
  function a() {
    return t.sticky?.() ?? !1;
  }
  function l() {
    const p = t.popupGroup?.();
    p !== r && (s?.(), r = p, s = r?.subscribe(() => {
      o() && !a() && n.close("imperative-action");
    }));
  }
  function c(p) {
    n.setTriggerElement(p), l(), o() && !a() && n.close("imperative-action");
  }
  const { onClick: u, ...d } = n.triggerProps, h = {
    ...d,
    onPointerDown() {
      l(), i = !0, a() || n.close("imperative-action");
    },
    onPointerEnter(p) {
      l(), !t.disabled?.() && (o() && !a() || p.pointerType !== "touch" && d.onPointerEnter(p));
    },
    onFocusIn(p) {
      if (l(), !t.disabled?.() && !(o() && !a())) {
        if (i) {
          i = !1;
          return;
        }
        d.onFocusIn(p);
      }
    }
  }, f = {
    ...n.popupProps,
    onPointerEnter(p) {
      t.disableHoverablePopup?.() || n.popupProps.onPointerEnter(p);
    }
  };
  return {
    ...n,
    triggerProps: h,
    popupProps: f,
    get triggerElement() {
      return n.triggerElement;
    },
    setTriggerElement: c,
    open: () => {
      l(), (!o() || a()) && n.open("hover");
    },
    close: (p = "hover") => n.close(p),
    destroy() {
      s?.(), n.destroy();
    }
  };
}
function bo() {
  const t = at({
    active: !1,
    status: "idle"
  });
  let e = !1, n = 0, i = 0, r = 0, s = null;
  function o() {
    cancelAnimationFrame(n), cancelAnimationFrame(i), n = 0, i = 0;
  }
  function a() {
    return r++, o(), s?.(), s = null, r;
  }
  function l(h) {
    if (h !== r) return;
    const f = s;
    s = null, f?.();
  }
  function c(h = null) {
    if (e) return Promise.resolve();
    const f = a(), p = t.current.active;
    return p && t.patch({ status: "idle" }), t.patch({
      active: !0,
      status: "starting"
    }), new Promise((v) => {
      s = v, n = requestAnimationFrame(() => {
        if (n = 0, p) {
          const g = Wp(h);
          aC(g), oC(g);
        }
        i = requestAnimationFrame(() => {
          if (i = 0, e || f !== r || !t.current.active) return l(f);
          t.patch({ status: "idle" }), n = requestAnimationFrame(() => {
            if (n = 0, e || f !== r || !t.current.active) return l(f);
            qp(Wp(h)).finally(() => l(f));
          });
        });
      });
    });
  }
  function u(h) {
    if (e) return Promise.resolve();
    const f = a();
    return t.patch({ status: "ending" }), new Promise((p) => {
      s = p, n = requestAnimationFrame(() => {
        n = 0, i = requestAnimationFrame(() => {
          if (i = 0, e || f !== r) return l(f);
          qp(h).finally(() => {
            if (e || f !== r || t.current.status !== "ending") return l(f);
            t.patch({
              active: !1,
              status: "idle"
            }), l(f);
          });
        });
      });
    });
  }
  function d() {
    r++, o(), s?.(), s = null, t.current.status !== "idle" && t.patch({ status: "idle" });
  }
  return {
    state: t,
    open: c,
    close: u,
    cancel: d,
    destroy() {
      e || (e = !0, d());
    }
  };
}
function Wp(t) {
  return typeof t == "function" ? t() : t;
}
function oC(t) {
  t && t.offsetHeight;
}
function aC(t) {
  const e = t?.getAnimations?.({ subtree: !0 }) ?? [];
  for (const n of e) n.cancel();
}
function qp(t) {
  if (!t) return Promise.resolve();
  const e = t.getAnimations?.() ?? [];
  return e.length === 0 ? Promise.resolve() : Promise.all(e.map((n) => n.finished)).then(pn, pn);
}
function lC(t) {
  return { onWheel(e) {
    if (t.isDisabled()) return;
    const n = Math.sign(e.deltaY);
    if (n === 0) return;
    e.preventDefault();
    const i = t.getStepPercent(), r = t.getPercent(), s = li(r - n * i, 0, 100);
    t.onValueChange?.(s);
  } };
}
function qi(t, e) {
  const n = {};
  for (const i in t) {
    if (e && !(i in e)) continue;
    const r = e?.[i] ?? cC(i), s = t[i];
    s === !0 ? n[r] = "" : s && (n[r] = String(s));
  }
  return n;
}
function cC(t) {
  return `data-${t.toLowerCase()}`;
}
const uC = {
  key: "container.label",
  text: "Media player"
}, ub = se(function(e, n) {
  const i = te.c(41);
  let r, s, o, a, l, c, u, d;
  i[0] !== e ? ({ children: o, tabIndex: u, role: d, "aria-label": r, "aria-labelledby": s, lang: l, dir: a, ...c } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c, i[7] = u, i[8] = d) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6], u = i[7], d = i[8]);
  const h = u === void 0 ? P5 : u, f = d === void 0 ? S5 : d, p = _T(), v = zt(), g = we(kh), m = qe(Ei), [y] = ue(dC), [k] = ue(hC), _ = Se(null), w = kn(n, _);
  let T, E;
  i[9] !== p ? (T = () => (p?.(_.current), () => p?.(null)), E = [p], i[9] = p, i[10] = T, i[11] = E) : (T = i[10], E = i[11]), ye(T, E);
  let S;
  i[12] !== c ? (S = (q) => {
    c.onPointerUp?.(q);
    const J = _.current;
    J && E5(J);
  }, i[12] = c, i[13] = S) : S = i[13];
  const P = S;
  let C;
  i[14] !== r || i[15] !== s || i[16] !== v ? (C = r !== void 0 || s !== void 0 ? {
    "aria-label": r,
    "aria-labelledby": s
  } : { "aria-label": v(uC) }, i[14] = r, i[15] = s, i[16] = v, i[17] = C) : C = i[17];
  const M = C, O = l ?? (g?.localeFromProp ? g.locale : void 0);
  let W;
  i[18] !== a || i[19] !== O ? (W = a ?? (O ? eP(O) : void 0), i[18] = a, i[19] = O, i[20] = W) : W = i[20];
  let H;
  i[21] !== O || i[22] !== W ? (H = {
    lang: O,
    dir: W
  }, i[21] = O, i[22] = W, i[23] = H) : H = i[23];
  const z = H;
  m && y.setMedia(m);
  let F;
  i[24] !== m || i[25] !== y ? (F = m ? qi(y.getState(), MP) : void 0, i[24] = m, i[25] = y, i[26] = F) : F = i[26];
  const K = F;
  let B;
  i[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = /* @__PURE__ */ b("a", {
    rel: "help",
    href: IP,
    hidden: !0,
    children: DP
  }), i[27] = B) : B = i[27];
  let $;
  i[28] !== o || i[29] !== k ? ($ = /* @__PURE__ */ b(wT, {
    value: k,
    children: o
  }), i[28] = o, i[29] = k, i[30] = $) : $ = i[30];
  let I;
  return i[31] !== M || i[32] !== w || i[33] !== P || i[34] !== z || i[35] !== c || i[36] !== f || i[37] !== K || i[38] !== $ || i[39] !== h ? (I = /* @__PURE__ */ Z("div", {
    ref: w,
    role: f,
    tabIndex: h,
    ...M,
    ...z,
    ...c,
    ...K,
    onPointerUp: P,
    children: [B, $]
  }), i[31] = M, i[32] = w, i[33] = P, i[34] = z, i[35] = c, i[36] = f, i[37] = K, i[38] = $, i[39] = h, i[40] = I) : I = i[40], I;
});
function dC() {
  return new RP();
}
function hC() {
  return V5();
}
function Me(t) {
  const e = Se(t);
  return e.current = t, e;
}
function Xt(t, e, n) {
  const i = te.c(6), r = Se(null), s = Me(e), o = Me(n);
  let a;
  i[0] !== t || i[1] !== s || i[2] !== o ? (a = () => (r.current !== null ? (clearTimeout(r.current), r.current = null) : s.current?.(), () => {
    r.current = setTimeout(() => {
      o.current?.(), t.destroy();
    }, 0);
  }), i[0] = t, i[1] = s, i[2] = o, i[3] = a) : a = i[3];
  let l;
  i[4] !== t ? (l = [t], i[4] = t, i[5] = l) : l = i[5], ye(a, l);
}
function fC(t) {
  const e = kS(...t.features), n = ST(t.features), i = Object.keys(n);
  function r(a) {
    const l = MS()(e);
    return pC(l, n, a), l;
  }
  function s(a) {
    const { children: l } = a, c = D0(a, i), [u, d] = ue(() => r(c)), h = Se({
      store: u,
      values: c
    }), [f, p] = ue(null), [v, g] = ue(null), m = Se(null), [y] = ue(() => new xT(() => m.current?.())), k = pt((w) => y.register(w), [y]);
    Xt(u), $t(() => {
      const w = h.current;
      if (w.store !== u) {
        h.current = {
          store: u,
          values: c
        };
        return;
      }
      for (const T of i)
        Object.is(w.values[T], c[T]) || Ry(u, n[T], c[T]);
      h.current = {
        store: u,
        values: c
      };
    }), ye(() => {
      if (f)
        return () => y.detach();
    }, [f, y]), ye(() => {
      if (!f) return;
      if (u.destroyed) {
        d(r(h.current.values));
        return;
      }
      const w = {
        media: f,
        container: v
      };
      y.attach(w);
      let T = u.attach({
        media: y.getStoreMedia(f),
        container: v
      });
      return m.current = () => {
        T(), T = u.attach({
          media: y.getStoreMedia(f),
          container: v
        });
      }, () => {
        m.current = null, T();
      };
    }, [
      f,
      v,
      u,
      y
    ]);
    const _ = Gt(() => ({
      store: u,
      media: f,
      setMedia: p,
      container: v,
      setContainer: g,
      registerExtension: k
    }), [
      u,
      f,
      v,
      k
    ]);
    return /* @__PURE__ */ b(vT, {
      value: _,
      children: l
    });
  }
  function o(a) {
    const { store: l } = Ol();
    return xh(l, a);
  }
  return {
    Player: s,
    usePlayer: o,
    useMedia: yT
  };
}
function pC(t, e, n) {
  for (const i of Object.keys(e)) Ry(t, e[i], n[i]);
}
function mC(t) {
  return t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && t.charCodeAt(2) >= 65 && t.charCodeAt(2) <= 90;
}
function gC(t, e) {
  return mC(t) && (typeof e == "function" || typeof e > "u");
}
function vC(t, e) {
  return e ? t ? (n) => {
    e(n), t(n);
  } : e : t;
}
function yC(t, e) {
  return e && t ? `${e} ${t}` : e || t;
}
function bC(t, e) {
  return e ? t ? {
    ...t,
    ...e
  } : e : t;
}
function _C(t, e) {
  if (!e) return t;
  for (const n in e) {
    const i = e[n];
    n === "className" ? t.className = yC(t.className, i) : n === "style" ? t.style = bC(t.style, i) : gC(n, i) ? t[n] = vC(t[n], i) : t[n] = i;
  }
  return t;
}
function Ju(...t) {
  let e = {};
  for (const n of t) e = _C(e, n);
  return e;
}
function lt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function me(...t) {
  const e = [];
  for (const n of t.flat()) if (R0(n) && n) e.push(n);
  else if (_S(n))
    for (const i in n) n[i] && e.push(i);
  return e.join(" ");
}
function wC(t, e) {
  return ke(t) ? t(e) : t;
}
function kC(t) {
  const e = t;
  return e.ref ?? e.props?.ref;
}
const xC = Number.parseInt(pS, 10) >= 19, SC = /* @__PURE__ */ Symbol.for("react.memo"), Ka = /* @__PURE__ */ new WeakMap();
function Gp(t) {
  if (!ke(t) || "$$typeof" in t) return !1;
  const e = t.prototype;
  return !(Je(e) && "isReactComponent" in e);
}
function PC(t) {
  return Je(t) && "$$typeof" in t && t.$$typeof === SC;
}
function Kp(t) {
  const e = Ka.get(t);
  if (e) return e;
  const n = se((i, r) => t({
    ...i,
    ref: r
  }));
  return Ka.set(t, n), n;
}
function EC(t) {
  if (xC) return t;
  if (Gp(t)) return Kp(t);
  if (!PC(t) || !Gp(t.type)) return t;
  const e = Ka.get(t);
  if (e) return e;
  const n = fS(Kp(t.type), t.compare);
  return Ka.set(t, n), n;
}
function gc(...t) {
  const e = t.flat().filter((n) => n != null);
  if (e.length !== 0)
    return e.length === 1 ? e[0] : Cy(...e);
}
function ge(t, e, n) {
  const { className: i, style: r, render: s } = e, { state: o, ref: a, props: l, stateAttrMap: c } = n, u = lt(i, o), d = wC(r, o), h = c ? qi(o, c) : {}, f = Ju(h, ...Array.isArray(l) ? l : l ? [l] : []);
  if (u !== void 0 && (f.className = f.className ? `${f.className} ${u}` : u), d !== void 0 && (f.style = f.style ? {
    ...f.style,
    ...d
  } : d), ke(s)) {
    const p = gc(a, f.ref);
    return s({
      ...f,
      ref: p
    }, o);
  }
  if (dS(s)) {
    const p = kC(s), v = gc(a, f.ref, p), g = Ju(f, s.props);
    g.ref = v;
    const m = EC(s.type);
    return m === s.type ? hS(s, g) : (s.key != null && (g.key = s.key), ku(m, g));
  }
  return f.ref = gc(a, f.ref), ku(t, f);
}
function TC(t) {
  const e = te.c(8), { displayName: n, onActivate: i, isDisabled: r } = t;
  let s;
  e[0] !== n ? (s = (u) => {
  }, e[0] = n, e[1] = s) : s = e[1];
  const o = s;
  let a;
  e[2] !== r || e[3] !== i ? (a = (u) => {
    const d = x5({
      onActivate: i,
      isDisabled: r
    });
    return Ju(d, u);
  }, e[2] = r, e[3] = i, e[4] = a) : a = e[4];
  const l = a;
  let c;
  return e[5] !== o || e[6] !== l ? (c = {
    getButtonProps: l,
    buttonRef: o
  }, e[5] = o, e[6] = l, e[7] = c) : c = e[7], c;
}
function CC(t, e) {
  const n = te.c(6), i = xn();
  let r;
  n[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = {}, n[0] = r) : r = n[0];
  const [s, o] = ue(r);
  let a, l;
  return n[1] !== t || n[2] !== i || n[3] !== e ? (a = () => {
    if (!i || !t) {
      o({});
      return;
    }
    const c = Rh(i), u = () => o(c.getShortcut(t, e));
    return u(), c.subscribeShortcutChanges(u);
  }, l = [
    i,
    t,
    e
  ], n[1] = t, n[2] = i, n[3] = e, n[4] = a, n[5] = l) : (a = n[4], l = n[5]), ye(a, l), s;
}
const Dh = Le(null), AC = Dh.Provider;
function Sn() {
  const t = we(Dh);
  if (!t) throw new Error("Menu compound components must be used within a Menu.Root");
  return t;
}
function db() {
  return we(Dh);
}
function Fl(t) {
  const e = te.c(8), n = db()?.setOptionState, [i] = ue($C), { value: r, disabled: s, hidden: o, availability: a } = t;
  let l, c;
  e[0] !== a || e[1] !== s || e[2] !== o || e[3] !== n || e[4] !== i || e[5] !== r ? (l = () => {
    if (n)
      return n(i, {
        value: r,
        disabled: s,
        hidden: o,
        availability: a
      }), () => n(i, null);
  }, c = [
    a,
    s,
    o,
    n,
    i,
    r
  ], e[0] = a, e[1] = s, e[2] = o, e[3] = n, e[4] = i, e[5] = r, e[6] = l, e[7] = c) : (l = e[6], c = e[7]), $t(l, c);
}
function $C() {
  return /* @__PURE__ */ Symbol("menu-option");
}
const hb = Le(null), RC = hb.Provider;
function MC() {
  const t = we(hb);
  if (!t) throw new Error("Menu.Content must be used within a Menu.Popup");
  return t;
}
const OC = Le(null), IC = OC.Provider, fb = Le(null), DC = fb.Provider;
function FC() {
  const t = we(fb);
  if (!t) throw new Error("Menu.RadioItem must be used within a Menu.RadioGroup");
  return t;
}
const pb = Le(!1), LC = pb.Provider;
function NC() {
  return we(pb);
}
const mb = Le(!1), VC = mb.Provider;
function jC() {
  return we(mb);
}
const Fh = Le(null), zC = Fh.Provider;
function Ll() {
  const t = we(Fh);
  if (!t) throw new Error("Tooltip compound components must be used within a Tooltip.Root");
  return t;
}
function BC() {
  return we(Fh);
}
function Yp(t, e) {
  return t.getLabelParams?.(e);
}
function or(t) {
  const { displayName: e, core: n, stateAttrMap: i, selector: r, action: s, hotkeyAction: o, hotkeyValue: a, tooltipLabel: l, isSupported: c, focusContainerOnPointerActivation: u } = t, d = new Set(Object.keys(n.defaultProps)), h = se(function(p, v) {
    const { render: g, className: m, style: y, ...k } = p, _ = {}, w = {};
    for (const D of Object.keys(k)) d.has(D) ? _[D] = k[D] : w[D] = k[D];
    const T = BC(), E = jC(), S = T?.setContent, P = qe(r), C = xn(), M = CC(o, a?.(_)), O = zt(), [W] = ue(() => new n());
    d.has("menuTrigger") && Ce(_.menuTrigger) && (_.menuTrigger = E), W.setProps(_);
    const { getButtonProps: H, buttonRef: z } = TC({
      displayName: e,
      onActivate: (D, A) => {
        u && A === "pointer" && C?.focus({ preventScroll: !0 }), Promise.resolve(s(W, P)).catch((N) => {
        });
      },
      isDisabled: () => !!_.disabled || !P
    });
    P && W.setMedia(P);
    const F = P ? W.getState() : null, K = F ? c?.(F) ?? !0 : !1, B = F && K ? Be(W.getLabel(F), O, Yp(W, F)) : void 0, $ = F && K ? l?.(W, F) ?? B : void 0;
    if ($t(() => {
      if (S)
        return S($ ? {
          label: $,
          shortcut: M.shortcut
        } : void 0), () => S(void 0);
    }, [
      S,
      $,
      M.shortcut
    ]), !P || !F || !K) return null;
    const I = W.getAttrs(F), q = I["aria-label"], J = {
      ...I,
      ...lT(q) ? { "aria-label": Be(q, O, Yp(W, F)) } : void 0,
      "aria-keyshortcuts": M.aria
    };
    return ge("button", {
      render: g,
      className: m,
      style: y
    }, {
      state: F,
      stateAttrMap: i,
      ref: [v, z],
      props: [
        H(),
        J,
        w
      ]
    });
  });
  return h.displayName = e, h;
}
const HC = or({
  displayName: "AirPlayButton",
  core: uP,
  stateAttrMap: dP,
  selector: tb,
  action: (t, e) => t.toggle(e),
  isSupported: (t) => !t.hidden
}), gb = Le(null), UC = gb.Provider;
function _o() {
  return WC("Dialog");
}
function WC(t) {
  const e = we(gb);
  if (!e) throw new Error(`${t} compound components must be used within a ${t}.Root`);
  return e;
}
var Xp = Object.defineProperty, qC = (t, e) => {
  let n = {};
  for (var i in t) Xp(n, i, {
    get: t[i],
    enumerable: !0
  });
  return Xp(n, Symbol.toStringTag, { value: "Module" }), n;
};
const GC = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { state: o, stateAttrMap: a } = _o();
  return o.open ? ge("div", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    stateAttrMap: a,
    ref: [s],
    props: [{
      role: "presentation",
      "aria-hidden": !0
    }, r]
  }) : null;
});
function Nl(t) {
  const { displayName: e, tag: n, useContext: i, staticProps: r, getProps: s } = t, o = se(function(l, c) {
    const { render: u, className: d, style: h, ...f } = l, p = i(), v = s?.(p.state);
    return ge(n, {
      render: u,
      className: d,
      style: h
    }, {
      state: p.state,
      stateAttrMap: p.stateAttrMap,
      ref: c,
      props: [
        r,
        v,
        f
      ].filter(Boolean)
    });
  });
  return o.displayName = e, o;
}
const KC = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { core: o, dialog: a, state: l, stateAttrMap: c, popupId: u } = _o(), d = pt((h) => a.setPopupElement(h), [a]);
  return l.open ? ge("div", {
    render: e,
    className: n,
    style: i
  }, {
    state: l,
    stateAttrMap: c,
    ref: [s, d],
    props: [{
      id: u,
      tabIndex: -1,
      ...o.getPopupAttrs(l)
    }, r]
  }) : null;
}), YC = /[^a-zA-Z0-9_-]/g;
function bi(t) {
  const e = te.c(2), n = E0();
  let i;
  e[0] !== n ? (i = n.replace(YC, ""), e[0] = n, e[1] = i) : i = e[1];
  const r = i;
  return t ? `${t}-${r}` : r;
}
function XC({ open: t, defaultOpen: e = Ba.defaultProps.defaultOpen, closeOnEscape: n = Ba.defaultProps.closeOnEscape, onOpenChange: i, onOpenChangeComplete: r, coreFactory: s = JC, stateAttrMap: o = K0, idPrefix: a = "dialog", interactionRoot: l }) {
  const [c] = ue(s);
  c.setProps({
    open: t,
    defaultOpen: e,
    closeOnEscape: n
  });
  const u = t !== void 0, d = Me(i), h = Me(r), f = Me(n), [p] = ue(() => {
    const _ = T5({
      transition: bo(),
      onOpenChange: (w) => d.current?.(w),
      onOpenChangeComplete: (w) => h.current?.(w),
      closeOnEscape: () => f.current
    });
    return !u && e && _.open(), _;
  }), v = bi(`${a}-popup`), g = bi(`${a}-title`), m = bi(`${a}-desc`);
  c.setTitleId(g), c.setDescriptionId(m), ye(() => {
    if (t === void 0) return;
    const { active: _ } = p.input.current;
    t !== _ && (t ? p.open() : p.close());
  }, [t, p]), $t(() => {
    p.setInteractionRoot(l ?? null);
  }, [p, l]), Xt(p);
  const y = Ur(p.input), k = Ur(p.modality);
  return c.setInput(y), c.setDocumentModal(k.documentModal), {
    core: c,
    dialog: p,
    state: c.getState(),
    stateAttrMap: o,
    popupId: v
  };
}
function JC() {
  return new Ba();
}
function Vl({ name: t, feature: e, selector: n, createCore: i }) {
  return function(s) {
    "use no memo";
    const o = qe(n), a = zt(), [l] = ue(i);
    l.setProps(s ?? {});
    const c = pt((h) => l.selectValue(o, h), [l, o]);
    if (!o) return null;
    l.setMedia(o);
    const u = l.getState(), d = u.options.map((h) => {
      const { label: f, labelParams: p, disabled: v, ...g } = h;
      return {
        ...g,
        label: Be(f, a, p),
        disabled: u.disabled || v
      };
    });
    return {
      state: u,
      label: Be(l.getLabel(u), a, l.getLabelParams?.(u)),
      value: u.value,
      selectedLabel: d.find((h) => h.value === u.value)?.label ?? "",
      options: d,
      disabled: u.disabled,
      hidden: u.hidden,
      setValue: c
    };
  };
}
const ZC = Vl({
  name: "useAudioTrackOptions",
  feature: "audioTrack",
  selector: t5,
  createCore: () => new vP()
});
function QC(t) {
  "use no memo";
  return ZC(t);
}
function eA(t) {
  return t["aria-label"] !== void 0 || t["aria-labelledby"] !== void 0;
}
function tA(t, e) {
  return {
    role: "group",
    "aria-labelledby": eA(e) ? void 0 : t
  };
}
function iA(t) {
  const e = te.c(7), { children: n } = t, [i, r] = ue();
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = (d) => (r(d), () => {
    r((h) => h === d ? void 0 : h);
  }), e[0] = s) : s = e[0];
  const o = s;
  let a;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = { registerLabel: o }, e[1] = a) : a = e[1];
  const l = a;
  let c;
  e[2] !== n || e[3] !== i ? (c = n(i), e[2] = n, e[3] = i, e[4] = c) : c = e[4];
  let u;
  return e[5] !== c ? (u = /* @__PURE__ */ b(IC, {
    value: l,
    children: c
  }), e[5] = c, e[6] = u) : u = e[6], u;
}
const jl = se(function(e, n) {
  const i = te.c(16);
  let r, s, o, a, l, c;
  i[0] !== e ? ({ render: a, className: r, style: l, value: c, onValueChange: o, ...s } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6]);
  const { state: u } = Sn();
  let d;
  return i[7] !== r || i[8] !== s || i[9] !== n || i[10] !== o || i[11] !== a || i[12] !== u || i[13] !== l || i[14] !== c ? (d = /* @__PURE__ */ b(iA, { children: (h) => /* @__PURE__ */ b(DC, {
    value: {
      value: c,
      onValueChange: o
    },
    children: ge("div", {
      render: a,
      className: r,
      style: l
    }, {
      state: u,
      ref: [n],
      props: [tA(h, s), s]
    })
  }) }), i[7] = r, i[8] = s, i[9] = n, i[10] = o, i[11] = a, i[12] = u, i[13] = l, i[14] = c, i[15] = d) : d = i[15], d;
}), vb = Le(void 0);
function nA(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ children: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  const r = QC(i);
  let s;
  e[3] !== r ? (s = oA(r), e[3] = r, e[4] = s) : s = e[4], Fl(s);
  let o;
  return e[5] !== r || e[6] !== n ? (o = /* @__PURE__ */ b(vb.Provider, {
    value: r,
    children: n
  }), e[5] = r, e[6] = n, e[7] = o) : o = e[7], o;
}
const rA = se(function({ render: e, className: n, style: i, ...r }, s) {
  const o = yb();
  return o ? ge("span", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    ref: s,
    props: [r, { children: o.selectedLabel }]
  }) : null;
}), sA = se(function(e, n) {
  const i = te.c(40);
  let r, s, o, a, l, c, u;
  i[0] !== e ? ({ renderItem: c, render: l, className: o, style: u, "aria-label": r, "aria-labelledby": s, ...a } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c, i[7] = u) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6], u = i[7]);
  const d = yb();
  if (!d) return null;
  const { state: h, value: f, options: p, setValue: v } = d, g = r ?? (s === void 0 ? d.label : void 0);
  let m;
  i[8] !== h ? (m = qi(h, yP), i[8] = h, i[9] = m) : m = i[9];
  let y;
  i[10] !== o || i[11] !== h ? (y = ke(o) ? o(h) : o, i[10] = o, i[11] = h, i[12] = y) : y = i[12];
  let k;
  i[13] !== h || i[14] !== u ? (k = ke(u) ? u(h) : u, i[13] = h, i[14] = u, i[15] = k) : k = i[15];
  let _;
  i[16] !== l || i[17] !== h ? (_ = ke(l) ? (P) => l(P, h) : l, i[16] = l, i[17] = h, i[18] = _) : _ = i[18];
  const w = h.disabled || void 0, T = h.hidden;
  let E;
  if (i[19] !== p || i[20] !== c || i[21] !== f) {
    let P;
    i[23] !== c || i[24] !== f ? (P = (C) => {
      const M = {
        ...C,
        checked: C.value === f
      };
      return /* @__PURE__ */ b(nr, { children: c({
        value: C.value,
        disabled: C.disabled,
        "data-track": C.value,
        children: C.label
      }, M) }, C.value);
    }, i[23] = c, i[24] = f, i[25] = P) : P = i[25], E = p.map(P), i[19] = p, i[20] = c, i[21] = f, i[22] = E;
  } else E = i[22];
  let S;
  return i[26] !== g || i[27] !== s || i[28] !== a || i[29] !== n || i[30] !== v || i[31] !== h.hidden || i[32] !== m || i[33] !== y || i[34] !== k || i[35] !== _ || i[36] !== w || i[37] !== E || i[38] !== f ? (S = /* @__PURE__ */ b(jl, {
    ...m,
    ...a,
    ref: n,
    className: y,
    style: k,
    render: _,
    value: f,
    onValueChange: v,
    "aria-label": g,
    "aria-labelledby": s,
    "aria-disabled": w,
    hidden: T,
    children: E
  }), i[26] = g, i[27] = s, i[28] = a, i[29] = n, i[30] = v, i[31] = h.hidden, i[32] = m, i[33] = y, i[34] = k, i[35] = _, i[36] = w, i[37] = E, i[38] = f, i[39] = S) : S = i[39], S;
});
function yb() {
  const t = we(vb);
  if (t === void 0) throw new Error("AudioTrackRadioGroup parts must be used within AudioTrackRadioGroup.Root");
  return t;
}
function oA(t) {
  return {
    value: t?.selectedLabel ?? "",
    disabled: t?.disabled ?? !0,
    hidden: t?.hidden ?? !0,
    availability: t?.state.availability ?? "unsupported"
  };
}
const aA = se(function(e, n) {
  const { render: i, className: r, style: s, delay: o, ...a } = e, l = qe(rs), [c] = ue(() => new bP());
  Xt(c), c.setProps({ delay: o }), l && c.update(l);
  const u = is((d) => c.state.subscribe(d), () => c.state.current, () => c.state.current);
  return l ? ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: u,
    stateAttrMap: _P,
    ref: [n],
    props: [a]
  }) : null;
}), lA = or({
  displayName: "CaptionsButton",
  core: xP,
  stateAttrMap: PP,
  selector: rr,
  action: (t, e) => t.toggle(e),
  hotkeyAction: "toggleSubtitles",
  isSupported: (t) => !t.hidden
}), cA = Vl({
  name: "useCaptionsOptions",
  feature: "textTrack",
  selector: rr,
  createCore: () => new TP()
});
function uA(t) {
  "use no memo";
  const e = cA(t);
  return e ? {
    ...e,
    showMenu: e.state.options.length > 2
  } : null;
}
const bb = Le(void 0);
function dA(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ children: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  const r = uA(i);
  let s;
  e[3] !== r ? (s = pA(r), e[3] = r, e[4] = s) : s = e[4], Fl(s);
  let o;
  return e[5] !== r || e[6] !== n ? (o = /* @__PURE__ */ b(bb.Provider, {
    value: r,
    children: n
  }), e[5] = r, e[6] = n, e[7] = o) : o = e[7], o;
}
const hA = se(function({ render: e, className: n, style: i, ...r }, s) {
  const o = _b();
  return o ? ge("span", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    ref: s,
    props: [r, { children: o.selectedLabel }]
  }) : null;
}), fA = se(function(e, n) {
  const i = te.c(40);
  let r, s, o, a, l, c, u;
  i[0] !== e ? ({ renderItem: c, render: l, className: o, style: u, "aria-label": r, "aria-labelledby": s, ...a } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c, i[7] = u) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6], u = i[7]);
  const d = _b();
  if (!d) return null;
  const { state: h, value: f, options: p, setValue: v } = d, g = r ?? (s === void 0 ? d.label : void 0);
  let m;
  i[8] !== h ? (m = qi(h, CP), i[8] = h, i[9] = m) : m = i[9];
  let y;
  i[10] !== o || i[11] !== h ? (y = ke(o) ? o(h) : o, i[10] = o, i[11] = h, i[12] = y) : y = i[12];
  let k;
  i[13] !== h || i[14] !== u ? (k = ke(u) ? u(h) : u, i[13] = h, i[14] = u, i[15] = k) : k = i[15];
  let _;
  i[16] !== l || i[17] !== h ? (_ = ke(l) ? (P) => l(P, h) : l, i[16] = l, i[17] = h, i[18] = _) : _ = i[18];
  const w = h.disabled || void 0, T = h.hidden;
  let E;
  if (i[19] !== p || i[20] !== c || i[21] !== f) {
    let P;
    i[23] !== c || i[24] !== f ? (P = (C) => {
      const M = {
        ...C,
        checked: C.value === f
      };
      return /* @__PURE__ */ b(nr, { children: c({
        value: C.value,
        disabled: C.disabled,
        "data-track": C.value,
        children: C.label
      }, M) }, C.value);
    }, i[23] = c, i[24] = f, i[25] = P) : P = i[25], E = p.map(P), i[19] = p, i[20] = c, i[21] = f, i[22] = E;
  } else E = i[22];
  let S;
  return i[26] !== g || i[27] !== s || i[28] !== a || i[29] !== n || i[30] !== v || i[31] !== h.hidden || i[32] !== m || i[33] !== y || i[34] !== k || i[35] !== _ || i[36] !== w || i[37] !== E || i[38] !== f ? (S = /* @__PURE__ */ b(jl, {
    ...m,
    ...a,
    ref: n,
    className: y,
    style: k,
    render: _,
    value: f,
    onValueChange: v,
    "aria-label": g,
    "aria-labelledby": s,
    "aria-disabled": w,
    hidden: T,
    children: E
  }), i[26] = g, i[27] = s, i[28] = a, i[29] = n, i[30] = v, i[31] = h.hidden, i[32] = m, i[33] = y, i[34] = k, i[35] = _, i[36] = w, i[37] = E, i[38] = f, i[39] = S) : S = i[39], S;
});
function _b() {
  const t = we(bb);
  if (t === void 0) throw new Error("CaptionsRadioGroup parts must be used within CaptionsRadioGroup.Root");
  return t;
}
function pA(t) {
  return {
    value: t?.selectedLabel ?? "",
    disabled: t?.disabled ?? !0,
    hidden: t?.hidden ?? !0,
    availability: t?.state.availability ?? "unsupported"
  };
}
const mA = or({
  displayName: "CastButton",
  core: AP,
  stateAttrMap: $P,
  selector: tb,
  action: (t, e) => t.toggle(e),
  isSupported: (t) => !t.hidden
}), Lh = Le(null), gA = Lh.Provider;
function Nh() {
  const t = we(Lh);
  if (!t) throw new Error("Controls compound components must be used within a Controls.Root");
  return t;
}
function Vh() {
  return we(Lh);
}
const vA = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { state: o, stateAttrMap: a } = Nh();
  return ge("div", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    stateAttrMap: a,
    ref: [s],
    props: [{
      role: "presentation",
      "aria-hidden": !0
    }, r]
  });
}), yA = se(function(e, n) {
  const { render: i, className: r, style: s, children: o, ...a } = e, { state: l, stateAttrMap: c } = Nh();
  return ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: l,
    stateAttrMap: c,
    ref: [n],
    props: [
      { children: o },
      a,
      { "data-interactive": "" }
    ]
  });
}), Yo = se(function(e, n) {
  const { render: i, className: r, style: s, children: o, ...a } = e, { state: l, stateAttrMap: c } = Nh(), u = a["aria-label"] || a["aria-labelledby"] ? "group" : void 0;
  return ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: l,
    stateAttrMap: c,
    ref: [n],
    props: [{
      role: u,
      children: o
    }, a]
  });
});
function bA({ children: t, visibility: e = up.defaultProps.visibility }) {
  "use no memo";
  const n = qe(Ei), [i] = ue(() => new up());
  i.setProps({ visibility: e }), i.setMedia(n ?? null);
  const r = i.getState();
  return r ? /* @__PURE__ */ b(gA, {
    value: {
      state: r,
      stateAttrMap: OP
    },
    children: t
  }) : null;
}
const wb = Le(null), _A = wb.Provider;
function wA() {
  const t = we(wb);
  if (!t) throw new Error("ErrorDialog compound components must be used within an ErrorDialog.Root");
  return t;
}
const kA = se(function({ render: e, className: n, style: i, disabled: r, children: s, ...o }, a) {
  const l = zt(), { dialog: c, state: u, stateAttrMap: d } = _o(), h = pt(() => {
    r || c.close();
  }, [c, r]), f = s ?? Be(a2(), l);
  return ge("button", {
    render: e,
    className: n,
    style: i
  }, {
    state: u,
    stateAttrMap: d,
    ref: a,
    props: [{
      type: "button",
      disabled: r,
      onClick: h,
      children: f
    }, o]
  });
}), xA = se(function({ render: e, className: n, style: i, children: r, ...s }, o) {
  const a = zt(), { state: l, stateAttrMap: c } = _o(), { lastError: u } = wA(), d = l2(u), h = r ?? Be(d, a);
  return ge("p", {
    render: e,
    className: n,
    style: i
  }, {
    state: l,
    stateAttrMap: c,
    ref: o,
    props: [{
      id: l.descriptionId,
      children: h
    }, s]
  });
});
function SA(t) {
  const e = te.c(12), { children: n } = t, i = qe(i5), r = xn(), [s, o] = ue(i?.error ?? null);
  i?.error && i.error !== s && o(i.error);
  const a = Me(i), l = !!i?.error;
  let c;
  e[0] !== r || e[1] !== a || e[2] !== l ? (c = {
    open: l,
    onOpenChange(p) {
      p || a.current?.dismissError();
    },
    coreFactory: PA,
    stateAttrMap: LP,
    idPrefix: "error-dialog",
    interactionRoot: r
  }, e[0] = r, e[1] = a, e[2] = l, e[3] = c) : c = e[3];
  const u = XC(c);
  if (!i) return null;
  let d;
  e[4] !== s ? (d = { lastError: s }, e[4] = s, e[5] = d) : d = e[5];
  let h;
  e[6] !== n || e[7] !== u ? (h = /* @__PURE__ */ b(UC, {
    value: u,
    children: n
  }), e[6] = n, e[7] = u, e[8] = h) : h = e[8];
  let f;
  return e[9] !== d || e[10] !== h ? (f = /* @__PURE__ */ b(_A, {
    value: d,
    children: h
  }), e[9] = d, e[10] = h, e[11] = f) : f = e[11], f;
}
function PA() {
  return new FP();
}
const EA = se(function({ render: e, className: n, style: i, children: r, ...s }, o) {
  const a = zt(), { state: l, stateAttrMap: c } = _o(), u = r ?? Be(o2(), a);
  return ge("h2", {
    render: e,
    className: n,
    style: i
  }, {
    state: l,
    stateAttrMap: c,
    ref: o,
    props: [{
      id: l.titleId,
      children: u
    }, s]
  });
}), TA = or({
  displayName: "FullscreenButton",
  core: u2,
  stateAttrMap: d2,
  selector: Dl,
  action: (t, e) => t.toggle(e),
  hotkeyAction: "toggleFullscreen",
  isSupported: (t) => !t.hidden,
  focusContainerOnPointerActivation: !0
});
function ps(t) {
  const e = te.c(10), { type: n, action: i, value: r, pointer: s, region: o, disabled: a } = t, l = qe(), c = xn();
  let u, d;
  return e[0] !== i || e[1] !== c || e[2] !== a || e[3] !== s || e[4] !== o || e[5] !== l || e[6] !== n || e[7] !== r ? (u = () => {
    if (!c || !n || !i) return;
    const h = s5(i);
    if (!h) return;
    const f = My(i, o, r), p = (g) => {
      h({
        store: l,
        value: f,
        event: g
      });
    }, v = {
      pointer: s,
      region: o,
      disabled: a,
      action: i,
      value: f
    };
    if (n === "doubletap") return l5(c, p, v);
    if (n === "tap") return a5(c, p, v);
  }, d = [
    c,
    l,
    n,
    i,
    r,
    s,
    o,
    a
  ], e[0] = i, e[1] = c, e[2] = a, e[3] = s, e[4] = o, e[5] = l, e[6] = n, e[7] = r, e[8] = u, e[9] = d) : (u = e[8], d = e[9]), ye(u, d), null;
}
function CA() {
  const [, t] = P0(AA, 0);
  return t;
}
function AA(t) {
  return t + 1;
}
function kb(t) {
  const e = Me(t), n = Wa(Ei)?.requestControlsLock, i = Se(null), r = pt(() => {
    i.current?.(), i.current = null;
  }, []);
  ye(() => r, [r]);
  const s = Se(null), o = Se(null), a = CA(), [l] = ue(() => {
    const g = {
      getElement: () => s.current,
      getThumbElement: () => o.current,
      getOrientation: () => e.current.orientation ?? "horizontal",
      isDisabled: () => e.current.disabled ?? !1,
      getPercent: () => e.current.getPercent(),
      getStepPercent: () => e.current.getStepPercent(),
      getLargeStepPercent: () => e.current.getLargeStepPercent(),
      changeThrottle: e.current.changeThrottle,
      adjustPercent: e.current.adjustPercent,
      onValueChange: (m) => e.current.onValueChange?.(m),
      onValueCommit: (m) => e.current.onValueCommit?.(m),
      onPressStart: () => {
        i.current ??= n?.() ?? null, e.current.onPressStart?.();
      },
      onPressEnd: () => {
        r(), e.current.onPressEnd?.();
      },
      onDragStart: () => e.current.onDragStart?.(),
      onDragEnd: () => e.current.onDragEnd?.()
    };
    return J5(g);
  });
  Xt(l);
  const c = Ur(l.input, ({ dragging: g, pointing: m, focused: y }) => ({
    dragging: g,
    pointing: m,
    focused: y
  })), u = {
    ...l.input.current,
    ...c
  }, d = t.computeState(u);
  $t(() => {
    d.thumbAlignment === "edge" && s.current && o.current && a();
  }, [d.thumbAlignment]);
  const h = t.getCSSVars(l.adjustForAlignment(d)), f = pt((g = s.current) => {
    if (!g) return;
    const { dragging: m, pointing: y } = l.input.current;
    if (!m && !y) return;
    const k = e.current.computeState(l.input.current);
    za(g, e.current.getCSSVars(l.adjustForAlignment(k)));
  }, [l]);
  $t(() => (f(), l.input.subscribe(f)), [l, f]);
  const p = pt((g) => {
    s.current = g, f(g);
  }, [f]), v = pt((g) => {
    o.current = g;
  }, []);
  return {
    state: d,
    input: l.input,
    cssVars: h,
    rootRef: p,
    thumbRef: v,
    rootProps: l.rootProps,
    rootStyle: l.rootStyle,
    thumbProps: l.thumbProps
  };
}
function mt(t) {
  const e = te.c(9), { keys: n, action: i, value: r, disabled: s, target: o } = t, a = qe(), l = xn();
  let c, u;
  return e[0] !== i || e[1] !== l || e[2] !== s || e[3] !== n || e[4] !== a || e[5] !== o || e[6] !== r ? (c = () => {
    if (!l || !n || !i || s) return;
    const d = d5(i);
    if (d)
      return w5(l, {
        keys: n,
        action: i,
        value: r,
        target: o,
        disabled: s,
        repeatable: !c5(i),
        onActivate: (h, f) => {
          d({
            store: a,
            key: f,
            value: r
          });
        }
      });
  }, u = [
    l,
    a,
    n,
    i,
    r,
    s,
    o
  ], e[0] = i, e[1] = l, e[2] = s, e[3] = n, e[4] = a, e[5] = o, e[6] = r, e[7] = c, e[8] = u) : (c = e[7], u = e[8]), ye(c, u), null;
}
const xb = /* @__PURE__ */ new WeakSet(), Jp = /* @__PURE__ */ new WeakSet();
function jh(t) {
  t.key !== "Escape" && Js(t) && !t.defaultPrevented && (t.preventDefault(), xb.add(t.nativeEvent));
}
function Zu(t, e) {
  const n = e.defaultPrevented && (!xb.has(e.nativeEvent) || Jp.has(e.nativeEvent));
  if (!t) return n;
  let i = !1;
  const r = e.preventDefault;
  e.preventDefault = () => {
    i = !0, r.call(e);
  };
  try {
    t(e);
  } finally {
    e.preventDefault = r;
  }
  return i && Jp.add(e.nativeEvent), n || i;
}
const wo = se(function(e, n) {
  const i = te.c(18), { render: r, className: s, style: o, onKeyDown: a, onBlur: l, ...c } = e, { core: u, menu: d, parent: h, state: f, contentId: p } = Sn(), { popup: v, element: g } = MC(), m = h !== null, y = m && f.open, k = Se(!1), _ = Se(null);
  let w, T;
  i[0] !== y || i[1] !== m || i[2] !== d ? (w = () => {
    if (!m) return;
    const W = k.current;
    if (k.current = y, y && !W) {
      const H = requestAnimationFrame(() => d.highlightInitialItem({ preventScroll: !0 }));
      return () => cancelAnimationFrame(H);
    }
  }, T = [
    y,
    m,
    d
  ], i[0] = y, i[1] = m, i[2] = d, i[3] = w, i[4] = T) : (w = i[3], T = i[4]), $t(w, T);
  let E;
  i[5] !== m || i[6] !== d || i[7] !== h?.menu || i[8] !== v ? (E = (W) => {
    if (_.current?.(), _.current = null, !W) {
      m && d.setPopupElement(null);
      return;
    }
    m && d.setPopupElement(W), _.current = v.registerContent({
      menu: d,
      parent: h?.menu ?? null,
      element: W
    });
  }, i[5] = m, i[6] = d, i[7] = h?.menu, i[8] = v, i[9] = E) : E = i[9], h?.menu;
  const S = kn(n, E);
  let P;
  i[10] !== m || i[11] !== d || i[12] !== a ? (P = (W) => {
    const H = Zu(a, W), z = Js(W);
    d.contentProps.onKeyDown(W), m && (W.key === "ArrowLeft" || W.key === "Escape") && !H && (W.preventDefault(), d.close("escape")), W.key !== "Escape" && z && W.stopPropagation();
  }, i[10] = m, i[11] = d, i[12] = a, i[13] = P) : P = i[13];
  const C = P;
  if (m && !y && f.status !== "ending") return null;
  let M;
  i[14] !== m || i[15] !== d || i[16] !== l ? (M = (W) => {
    l?.(W), m && d.contentProps.onFocusOut(W);
  }, i[14] = m, i[15] = d, i[16] = l, i[17] = M) : M = i[17];
  const O = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: f,
    stateAttrMap: Qi,
    ref: S,
    props: [
      {
        id: p,
        ...u.getContentAttrs()
      },
      {
        onKeyDownCapture: jh,
        onKeyDown: C,
        onBlur: M
      },
      c
    ]
  });
  return m && g ? C0(O, g) : O;
}), zl = se(function(e, n) {
  const i = te.c(29);
  let r, s, o, a, l, c, u;
  i[0] !== e ? ({ render: c, className: r, style: u, onSelect: l, disabled: s, onClick: a, ...o } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c, i[7] = u) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6], u = i[7]);
  const { menu: d, state: h } = Sn(), f = Se(null);
  let p, v;
  i[8] !== d ? (p = () => {
    const w = f.current;
    if (w)
      return d.registerItem(w);
  }, v = [d], i[8] = d, i[9] = p, i[10] = v) : (p = i[9], v = i[10]), ye(p, v);
  let g;
  i[11] !== s || i[12] !== d || i[13] !== a || i[14] !== l ? (g = (w) => {
    s || (a?.(w), !w.defaultPrevented && (l?.(), ob(d)));
  }, i[11] = s, i[12] = d, i[13] = a, i[14] = l, i[15] = g) : g = i[15];
  const m = g;
  let y;
  i[16] !== s || i[17] !== d ? (y = () => {
    const w = f.current;
    !w || s || d.highlight(w, {
      focus: !1,
      pointer: !0
    });
  }, i[16] = s, i[17] = d, i[18] = y) : y = i[18];
  const k = y;
  let _;
  return i[19] !== r || i[20] !== s || i[21] !== o || i[22] !== n || i[23] !== m || i[24] !== k || i[25] !== c || i[26] !== h || i[27] !== u ? (_ = /* @__PURE__ */ b($A, {
    disabled: s,
    elementProps: o,
    onClick: m,
    onPointerEnter: k,
    render: c,
    className: r,
    style: u,
    state: h,
    forwardedRef: n,
    elementRef: f
  }), i[19] = r, i[20] = s, i[21] = o, i[22] = n, i[23] = m, i[24] = k, i[25] = c, i[26] = h, i[27] = u, i[28] = _) : _ = i[28], _;
});
function $A({ disabled: t, elementProps: e, onClick: n, onPointerEnter: i, render: r, className: s, style: o, state: a, forwardedRef: l, elementRef: c }) {
  return ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: a,
    ref: [l, c],
    props: [{
      role: "menuitem",
      "aria-disabled": t ? !0 : void 0,
      onClick: n,
      onPointerEnter: i
    }, e]
  });
}
const RA = se(function({ render: e, className: n, style: i, checked: r, forceMount: s = !1, ...o }, a) {
  const { state: l } = Sn(), c = NC();
  return !(r ?? c) && !s ? null : ge("span", {
    render: e,
    className: n,
    style: i
  }, {
    state: l,
    ref: [a],
    props: [{ "aria-hidden": !0 }, o]
  });
}), MA = {
  position: "fixed",
  inset: "auto",
  margin: 0
};
function zh(t) {
  const e = te.c(15), { open: n, anchorName: i, position: r, triggerSource: s, popupRef: o, boundary: a, container: l, cssVars: c, trackResize: u, onSideChange: d } = t, [h] = ue(OA);
  let f;
  e[0] !== i || e[1] !== a || e[2] !== l || e[3] !== c || e[4] !== d || e[5] !== n || e[6] !== o || e[7] !== r || e[8] !== h || e[9] !== u || e[10] !== s ? (f = () => {
    if (!n) {
      h.cleanup();
      return;
    }
    h.sync({
      anchorName: i,
      position: r,
      trigger: s.triggerElement,
      popup: o.current,
      boundary: a,
      container: l,
      ...u !== void 0 ? { trackResize: u } : {},
      ...c ? { cssVars: c } : {},
      ...d ? { onSideChange: d } : {}
    });
  }, e[0] = i, e[1] = a, e[2] = l, e[3] = c, e[4] = d, e[5] = n, e[6] = o, e[7] = r, e[8] = h, e[9] = u, e[10] = s, e[11] = f) : f = e[11], $t(f);
  let p, v;
  return e[12] !== h ? (p = () => () => h.cleanup(), v = [h], e[12] = h, e[13] = p, e[14] = v) : (p = e[13], v = e[14]), $t(p, v), MA;
}
function OA() {
  return new Y5();
}
const IA = se(function(e, n) {
  const i = te.c(23), { render: r, className: s, style: o, onBlur: a, keepMounted: l, ...c } = e, u = l === void 0 ? !1 : l, { core: d, menu: h, parent: f, state: p, preferredSide: v, setPositionedSide: g, anchorName: m, boundary: y, container: k } = Sn(), [_] = ue(N5), [w, T] = ue(null), E = Se(null);
  let S;
  i[0] !== h || i[1] !== _ ? (S = ($) => {
    h.setPopupElement($), _.setElement($), T($);
  }, i[0] = h, i[1] = _, i[2] = S) : S = i[2];
  const P = kn(n, E, S);
  let C;
  i[3] !== v || i[4] !== p.align ? (C = D5(v, p.align), i[3] = v, i[4] = p.align, i[5] = C) : C = i[5];
  const M = C;
  let O;
  i[6] !== m || i[7] !== y || i[8] !== k || i[9] !== h || i[10] !== M || i[11] !== g || i[12] !== p.open ? (O = {
    open: p.open,
    anchorName: m,
    position: M,
    triggerSource: h,
    popupRef: E,
    boundary: y,
    container: k,
    cssVars: F5,
    trackResize: !1,
    onSideChange: g
  }, i[6] = m, i[7] = y, i[8] = k, i[9] = h, i[10] = M, i[11] = g, i[12] = p.open, i[13] = O) : O = i[13];
  const W = zh(O);
  Xt(_);
  const H = !p.open && p.status !== "ending";
  if (H && !u) return null;
  let z;
  i[14] !== h.contentProps || i[15] !== a ? (z = ($) => {
    a?.($), h.contentProps.onFocusOut($);
  }, i[14] = h.contentProps, i[15] = a, i[16] = z) : z = i[16];
  const F = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: p,
    stateAttrMap: hy,
    ref: P,
    props: [
      {
        style: W,
        ...d.getPopupAttrs()
      },
      { onBlur: z },
      c,
      {
        hidden: H,
        inert: H || void 0
      }
    ]
  });
  let K;
  i[17] !== _ || i[18] !== w ? (K = {
    popup: _,
    element: w
  }, i[17] = _, i[18] = w, i[19] = K) : K = i[19];
  let B;
  return i[20] !== F || i[21] !== K ? (B = /* @__PURE__ */ b(RC, {
    value: K,
    children: F
  }), i[20] = F, i[21] = K, i[22] = B) : B = i[22], B;
}), DA = se(function(e, n) {
  const i = te.c(16), { render: r, className: s, style: o, value: a, disabled: l, onClick: c, ...u } = e, { menu: d, state: h } = Sn(), { value: f, onValueChange: p } = FC(), v = Se(null), g = f === a;
  let m, y;
  i[0] !== d ? (m = () => {
    const C = v.current;
    if (C)
      return d.registerItem(C);
  }, y = [d], i[0] = d, i[1] = m, i[2] = y) : (m = i[1], y = i[2]), ye(m, y);
  let k;
  i[3] !== l || i[4] !== d || i[5] !== c || i[6] !== p || i[7] !== a ? (k = (C) => {
    l || (c?.(C), !C.defaultPrevented && (p(a), ob(d)));
  }, i[3] = l, i[4] = d, i[5] = c, i[6] = p, i[7] = a, i[8] = k) : k = i[8];
  const _ = k;
  let w;
  i[9] !== l || i[10] !== d ? (w = () => {
    const C = v.current;
    !C || l || d.highlight(C, {
      focus: !1,
      pointer: !0
    });
  }, i[9] = l, i[10] = d, i[11] = w) : w = i[11];
  const T = w, E = LC, S = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: h,
    ref: [n, v],
    props: [{
      role: "menuitemradio",
      "aria-checked": g,
      "aria-disabled": l ? !0 : void 0,
      onClick: _,
      onPointerEnter: T
    }, u]
  });
  let P;
  return i[12] !== E || i[13] !== g || i[14] !== S ? (P = /* @__PURE__ */ b(E, {
    value: g,
    children: S
  }), i[12] = E, i[13] = g, i[14] = S, i[15] = P) : P = i[15], P;
});
function Bh(t) {
  const e = te.c(17), n = t.side;
  let i;
  e[0] !== n ? (i = {
    preferred: n,
    side: n
  }, e[0] = n, e[1] = i) : i = e[1];
  const [r, s] = ue(i), o = t.open && r.preferred === n ? r.side : n;
  let a;
  e[2] !== n || e[3] !== t || e[4] !== o ? (a = o === n ? t : {
    ...t,
    side: o
  }, e[2] = n, e[3] = t, e[4] = o, e[5] = a) : a = e[5];
  const l = a;
  let c;
  e[6] !== n ? (c = (p) => s((v) => v.preferred === n && v.side === p ? v : {
    preferred: n,
    side: p
  }), e[6] = n, e[7] = c) : c = e[7];
  const u = c;
  let d, h;
  e[8] !== n || e[9] !== t.open || e[10] !== u ? (d = () => {
    t.open || u(n);
  }, h = [
    t.open,
    n,
    u
  ], e[8] = n, e[9] = t.open, e[10] = u, e[11] = d, e[12] = h) : (d = e[11], h = e[12]), ye(d, h);
  let f;
  return e[13] !== n || e[14] !== u || e[15] !== l ? (f = {
    state: l,
    preferredSide: n,
    setPositionedSide: u
  }, e[13] = n, e[14] = u, e[15] = l, e[16] = f) : f = e[16], f;
}
function ko({ open: t, defaultOpen: e = jo.defaultProps.defaultOpen, onOpenChange: n, onOpenChangeComplete: i, boundary: r = "container", children: s, ...o }) {
  const a = db(), l = Vh(), c = Wa(Ei), u = Sh(), d = Ph(), h = a !== null, { side: f, align: p, closeOnEscape: v, closeOnOutsideClick: g } = o, [m] = ue(() => new jo(o)), y = t !== void 0, [k, _] = ue(e), w = t ?? k, T = Me(n), E = Me(i), S = Me(v), P = Me(g), C = Me(d), M = Me(h), [O] = ue(() => L5({
    transition: bo(),
    onOpenChange(U, j) {
      y || _(U), T.current?.(U, j);
    },
    onOpenChangeComplete(U) {
      E.current?.(U);
    },
    closeOnEscape: () => S.current ?? jo.defaultProps.closeOnEscape,
    closeOnOutsideClick: () => P.current ?? jo.defaultProps.closeOnOutsideClick,
    group: () => M.current ? void 0 : C.current
  })), W = bi(), H = bi("menu");
  $t(() => a?.menu.registerSubmenu(O), [O, a?.menu]), $t(() => {
    O.syncOpen(w);
  }, [O, w]), ye(() => {
    h || l?.state.visible !== !1 || O.close("imperative-action");
  }, [
    l?.state.visible,
    h,
    O
  ]), Xt(O);
  const z = Ur(O.input);
  ye(() => {
    if (!(!z.active || h))
      return c?.requestControlsLock();
  }, [
    c?.requestControlsLock,
    z.active,
    h
  ]);
  const F = Gt(() => (m.setProps({
    side: f,
    align: p,
    closeOnEscape: v,
    closeOnOutsideClick: g
  }), m.setInput({
    ...z,
    isSubmenu: h
  }), m.getState()), [
    m,
    z,
    f,
    p,
    v,
    g,
    h
  ]), { state: K, preferredSide: B, setPositionedSide: $ } = Bh(F), [I, q] = ue(() => /* @__PURE__ */ new Map()), [J] = ue(() => /* @__PURE__ */ Symbol("menu")), D = pt((U, j) => {
    q((ie) => {
      const oe = ie.get(U);
      if (j && FA(oe, j) || !j && !oe) return ie;
      const Oe = new Map(ie);
      return j ? Oe.set(U, j) : Oe.delete(U), Oe;
    });
  }, []), A = Gt(() => y2(I.values()), [I]), N = a?.setOptionState;
  ye(() => {
    !A?.disabled && !A?.hidden || O.close("imperative-action");
  }, [
    O,
    A?.disabled,
    A?.hidden
  ]), $t(() => {
    if (N)
      return N(J, A), () => N(J, null);
  }, [
    J,
    A,
    N
  ]);
  const X = Gt(() => ({
    core: m,
    menu: O,
    parent: a,
    state: K,
    preferredSide: B,
    setPositionedSide: $,
    contentId: H,
    anchorName: W,
    boundary: r,
    container: u,
    optionState: A,
    setOptionState: D
  }), [
    m,
    O,
    a,
    K,
    B,
    $,
    H,
    W,
    r,
    u,
    A,
    D
  ]);
  return /* @__PURE__ */ b(AC, {
    value: X,
    children: s
  });
}
function FA(t, e) {
  return t?.value === e.value && t.disabled === e.disabled && t.hidden === e.hidden && t.availability === e.availability;
}
const Bl = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { state: o } = Sn();
  return ge("div", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    ref: [s],
    props: [{ role: "separator" }, r]
  });
}), xo = se(function(e, n) {
  const i = te.c(37), { render: r, className: s, style: o, disabled: a, onClick: l, onKeyDown: c, ...u } = e, { core: d, menu: h, parent: f, state: p, contentId: v, optionState: g } = Sn(), m = a || g?.disabled || !1, y = f !== null, k = p.open || p.status === "ending" ? v : void 0, _ = Se(null), w = bi("sub-trigger"), T = f?.menu ?? null;
  let E, S;
  i[0] !== y || i[1] !== h || i[2] !== T ? (E = () => {
    if (!y || !T) return;
    const j = _.current;
    if (!j) return;
    h.setTriggerElement(j);
    const ie = T.registerItem(j);
    return () => {
      ie(), h.setTriggerElement(null);
    };
  }, S = [
    y,
    h,
    T
  ], i[0] = y, i[1] = h, i[2] = T, i[3] = E, i[4] = S) : (E = i[3], S = i[4]), ye(E, S);
  let P;
  i[5] !== h || i[6] !== m ? (P = () => {
    m || h.open("click");
  }, i[5] = h, i[6] = m, i[7] = P) : P = i[7];
  const C = P;
  let M;
  i[8] !== l || i[9] !== C ? (M = (j) => {
    l?.(j), !j.defaultPrevented && C();
  }, i[8] = l, i[9] = C, i[10] = M) : M = i[10];
  const O = M;
  let W;
  i[11] !== c || i[12] !== C || i[13] !== m ? (W = (j) => {
    const ie = Zu(c, j);
    m || ie || j.key === "ArrowRight" && (j.preventDefault(), C());
  }, i[11] = c, i[12] = C, i[13] = m, i[14] = W) : W = i[14];
  const H = W;
  let z;
  i[15] !== T || i[16] !== m ? (z = () => {
    const j = _.current;
    !j || m || !T || T.highlight(j, {
      focus: !1,
      pointer: !0
    });
  }, i[15] = T, i[16] = m, i[17] = z) : z = i[17];
  const F = z;
  let K;
  i[18] !== h ? (K = (j) => {
    h.setTriggerElement(j);
  }, i[18] = h, i[19] = K) : K = i[19];
  const B = K;
  let $;
  i[20] !== h.triggerProps || i[21] !== c || i[22] !== m ? ($ = (j) => {
    const ie = Zu(c, j);
    if (m || ie) {
      m && Js(j) && j.preventDefault();
      return;
    }
    if (hh(j.nativeEvent)) {
      j.preventDefault(), h.triggerProps.onClick(j.nativeEvent);
      return;
    }
    h.triggerProps.onKeyDown(j);
  }, i[20] = h.triggerProps, i[21] = c, i[22] = m, i[23] = $) : $ = i[23];
  const I = $;
  let q;
  i[24] !== h.triggerProps || i[25] !== m ? (q = m ? NA : h.triggerProps.onClick, i[24] = h.triggerProps, i[25] = m, i[26] = q) : q = i[26];
  let J;
  i[27] !== I || i[28] !== q ? (J = {
    onClick: q,
    onKeyDown: I
  }, i[27] = I, i[28] = q, i[29] = J) : J = i[29];
  const D = J;
  if (y) {
    let j;
    return i[30] !== k || i[31] !== d || i[32] !== p ? (j = d.getTriggerAttrs(p, k), i[30] = k, i[31] = d, i[32] = p, i[33] = j) : j = i[33], /* @__PURE__ */ b(LA, {
      render: r,
      className: s,
      style: o,
      disabled: m,
      elementProps: u,
      forwardedRef: n,
      elementRef: _,
      triggerId: w,
      triggerAttrs: j,
      availability: g?.availability,
      hidden: g?.hidden,
      state: p,
      onSubMenuClick: O,
      onSubMenuKeyDown: H,
      onPointerEnter: F
    });
  }
  const A = VC, N = !0, X = ge("button", {
    render: r,
    className: s,
    style: o
  }, {
    state: p,
    ref: [n, B],
    props: [
      {
        type: "button",
        ...d.getTriggerAttrs(p, k)
      },
      m ? {
        disabled: !0,
        "aria-disabled": "true"
      } : void 0,
      g ? { "data-availability": g.availability } : void 0,
      p.open ? { onKeyDownCapture: jh } : void 0,
      D,
      u,
      g?.hidden ? { hidden: !0 } : void 0
    ]
  });
  let U;
  return i[34] !== A || i[35] !== X ? (U = /* @__PURE__ */ b(A, {
    value: N,
    children: X
  }), i[34] = A, i[35] = X, i[36] = U) : U = i[36], U;
});
function LA({ render: t, className: e, style: n, disabled: i, elementProps: r, forwardedRef: s, elementRef: o, triggerId: a, triggerAttrs: l, availability: c, hidden: u, state: d, onSubMenuClick: h, onSubMenuKeyDown: f, onPointerEnter: p }) {
  return ge("div", {
    render: t,
    className: e,
    style: n
  }, {
    state: d,
    ref: [s, o],
    props: [
      {
        id: a,
        role: "menuitem",
        ...l,
        "aria-disabled": i ? !0 : void 0,
        "data-availability": c,
        "data-has-submenu": "",
        onClick: h,
        onKeyDownCapture: jh,
        onKeyDown: f,
        onPointerEnter: p
      },
      r,
      u ? { hidden: !0 } : void 0
    ]
  });
}
function NA(t) {
  return t.preventDefault();
}
const VA = or({
  displayName: "MuteButton",
  core: S2,
  stateAttrMap: E2,
  selector: Zn,
  action: (t, e) => t.toggle(e),
  hotkeyAction: "toggleMuted",
  isSupported: (t) => !t.hidden
}), jA = or({
  displayName: "PiPButton",
  core: A2,
  stateAttrMap: $2,
  selector: $h,
  action: (t, e) => t.toggle(e),
  hotkeyAction: "togglePictureInPicture",
  isSupported: (t) => !t.hidden
}), zA = or({
  displayName: "PlayButton",
  core: R2,
  stateAttrMap: M2,
  selector: rs,
  action: (t, e) => t.toggle(e),
  hotkeyAction: "togglePaused"
}), BA = Vl({
  name: "usePlaybackRateOptions",
  feature: "playbackRate",
  selector: Ga,
  createCore: () => new I2()
});
function HA(t) {
  const e = BA(t), n = pt((i) => e?.setValue(String(i)), [e?.setValue]);
  return e ? {
    ...e,
    rate: e.state.rate,
    setRate: n
  } : null;
}
const Sb = Le(void 0);
function UA(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ children: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  const r = HA(i);
  let s;
  e[3] !== r ? (s = GA(r), e[3] = r, e[4] = s) : s = e[4], Fl(s);
  let o;
  return e[5] !== n || e[6] !== r ? (o = /* @__PURE__ */ b(Sb.Provider, {
    value: r,
    children: n
  }), e[5] = n, e[6] = r, e[7] = o) : o = e[7], o;
}
const WA = se(function({ render: e, className: n, style: i, ...r }, s) {
  const o = Pb();
  return o ? ge("span", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    ref: s,
    props: [r, { children: o.selectedLabel }]
  }) : null;
}), qA = se(function(e, n) {
  const i = te.c(40);
  let r, s, o, a, l, c, u;
  i[0] !== e ? ({ renderItem: c, render: l, className: o, style: u, "aria-label": r, "aria-labelledby": s, ...a } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c, i[7] = u) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6], u = i[7]);
  const d = Pb();
  if (!d) return null;
  const { state: h, value: f, options: p, setValue: v } = d, g = r ?? (s === void 0 ? d.label : void 0);
  let m;
  i[8] !== h ? (m = qi(h, D2), i[8] = h, i[9] = m) : m = i[9];
  let y;
  i[10] !== o || i[11] !== h ? (y = ke(o) ? o(h) : o, i[10] = o, i[11] = h, i[12] = y) : y = i[12];
  let k;
  i[13] !== h || i[14] !== u ? (k = ke(u) ? u(h) : u, i[13] = h, i[14] = u, i[15] = k) : k = i[15];
  let _;
  i[16] !== l || i[17] !== h ? (_ = ke(l) ? (P) => l(P, h) : l, i[16] = l, i[17] = h, i[18] = _) : _ = i[18];
  const w = h.disabled || void 0, T = h.hidden;
  let E;
  if (i[19] !== p || i[20] !== c || i[21] !== f) {
    let P;
    i[23] !== c || i[24] !== f ? (P = (C) => {
      const M = {
        ...C,
        checked: C.value === f
      };
      return /* @__PURE__ */ b(nr, { children: c({
        value: C.value,
        disabled: C.disabled,
        "data-rate": C.value,
        children: C.label
      }, M) }, C.value);
    }, i[23] = c, i[24] = f, i[25] = P) : P = i[25], E = p.map(P), i[19] = p, i[20] = c, i[21] = f, i[22] = E;
  } else E = i[22];
  let S;
  return i[26] !== g || i[27] !== s || i[28] !== a || i[29] !== n || i[30] !== v || i[31] !== h.hidden || i[32] !== m || i[33] !== y || i[34] !== k || i[35] !== _ || i[36] !== w || i[37] !== E || i[38] !== f ? (S = /* @__PURE__ */ b(jl, {
    ...m,
    ...a,
    ref: n,
    className: y,
    style: k,
    render: _,
    value: f,
    onValueChange: v,
    "aria-label": g,
    "aria-labelledby": s,
    "aria-disabled": w,
    hidden: T,
    children: E
  }), i[26] = g, i[27] = s, i[28] = a, i[29] = n, i[30] = v, i[31] = h.hidden, i[32] = m, i[33] = y, i[34] = k, i[35] = _, i[36] = w, i[37] = E, i[38] = f, i[39] = S) : S = i[39], S;
});
function Pb() {
  const t = we(Sb);
  if (t === void 0) throw new Error("PlaybackRateRadioGroup parts must be used within PlaybackRateRadioGroup.Root");
  return t;
}
function GA(t) {
  return {
    value: t?.selectedLabel ?? "",
    disabled: t?.disabled ?? !0,
    hidden: t?.hidden ?? !0,
    availability: t?.state.availability ?? "unsupported"
  };
}
const Eb = Le(null), KA = Eb.Provider;
function So() {
  const t = we(Eb);
  if (!t) throw new Error("Popover compound components must be used within a Popover.Root");
  return t;
}
const YA = Nl({
  displayName: "PopoverArrow",
  tag: "div",
  useContext: So,
  staticProps: { "aria-hidden": "true" }
}), Tb = se(function(e, n) {
  const i = te.c(13), { render: r, className: s, style: o, ...a } = e, { core: l, popover: c, state: u, preferredSide: d, setPositionedSide: h, stateAttrMap: f, anchorName: p, popupId: v, boundary: g, container: m } = So(), y = Se(null);
  let k;
  i[0] !== c ? (k = (M) => {
    c.setPopupElement(M);
  }, i[0] = c, i[1] = k) : k = i[1];
  const _ = kn(n, k, y);
  let w;
  i[2] !== d || i[3] !== u.align ? (w = {
    side: d,
    align: u.align
  }, i[2] = d, i[3] = u.align, i[4] = w) : w = i[4];
  const T = w;
  let E;
  i[5] !== p || i[6] !== g || i[7] !== m || i[8] !== c || i[9] !== T || i[10] !== h || i[11] !== u.open ? (E = {
    open: u.open,
    anchorName: p,
    position: T,
    triggerSource: c,
    popupRef: y,
    boundary: g,
    container: m,
    onSideChange: h
  }, i[5] = p, i[6] = g, i[7] = m, i[8] = c, i[9] = T, i[10] = h, i[11] = u.open, i[12] = E) : E = i[12];
  const S = zh(E);
  if (!u.open) return null;
  const { onFocusOut: P, ...C } = c.popupProps;
  return ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: u,
    stateAttrMap: f,
    ref: _,
    props: [
      {
        id: v,
        style: S,
        ...l.getPopupAttrs(u)
      },
      {
        ...C,
        onBlur: P
      },
      a
    ]
  });
});
function Cb({ open: t, defaultOpen: e = Di.defaultProps.defaultOpen, onOpenChange: n, onOpenChangeComplete: i, openOnHover: r = Di.defaultProps.openOnHover, delay: s = Di.defaultProps.delay, closeDelay: o = Di.defaultProps.closeDelay, boundary: a = "container", children: l, ...c }) {
  const u = Sh(), d = Ph(), h = Vh(), [f] = ue(() => new Di(c));
  f.setProps(c);
  const p = !Ce(t), v = Me(n), g = Me(i), m = Me(c.closeOnEscape), y = Me(c.closeOnOutsideClick), k = Me(r), _ = Me(s), w = Me(o), T = Me(d), [E] = ue(() => {
    const H = Oh({
      transition: bo(),
      onOpenChange: (z, F) => {
        v.current?.(z, F);
      },
      onOpenChangeComplete: (z) => {
        g.current?.(z);
      },
      closeOnEscape: () => m.current ?? Di.defaultProps.closeOnEscape,
      closeOnOutsideClick: () => y.current ?? Di.defaultProps.closeOnOutsideClick,
      openOnHover: () => k.current,
      delay: () => _.current,
      closeDelay: () => w.current,
      group: () => T.current
    });
    return !p && e && H.open("click"), H;
  }), S = bi(), P = bi("popup");
  ye(() => {
    if (Ce(t)) return;
    const { active: H } = E.input.current;
    t !== H && (t ? E.open("click") : E.close("click"));
  }, [t, E]), ye(() => {
    Ce(h?.state.visible) || h.state.visible || E.close("imperative-action");
  }, [h?.state.visible, E]), Xt(E);
  const C = Ur(E.input);
  f.setInput(C);
  const { state: M, preferredSide: O, setPositionedSide: W } = Bh(f.getState());
  return /* @__PURE__ */ b(KA, {
    value: {
      core: f,
      popover: E,
      state: M,
      preferredSide: O,
      setPositionedSide: W,
      stateAttrMap: F2,
      anchorName: S,
      popupId: P,
      boundary: a,
      container: u
    },
    children: l
  });
}
const Ab = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { core: o, popover: a, state: l, stateAttrMap: c, popupId: u } = So(), d = l.open ? u : void 0, h = pt((g) => {
    a.setTriggerElement(g);
  }, [a]), { onFocusIn: f, onFocusOut: p, ...v } = a.triggerProps;
  return ge("button", {
    render: e,
    className: n,
    style: i
  }, {
    state: l,
    stateAttrMap: c,
    ref: [s, h],
    props: [
      {
        type: "button",
        ...o.getTriggerAttrs(l, d)
      },
      {
        ...v,
        onFocus: f,
        onBlur: p
      },
      r
    ]
  });
});
var vc = /* @__PURE__ */ qC({
  Arrow: () => YA,
  Popup: () => Tb,
  Root: () => Cb,
  Trigger: () => Ab
});
const $b = Le(null);
function XA(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b($b.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function JA() {
  const t = we($b);
  if (!t) throw new Error("Poster compound components must be used within a Poster.Root");
  return t;
}
const ZA = se(function(e, n) {
  const i = te.c(13), { render: r, className: s, style: o, ...a } = e, { state: l, setImageLoadState: c } = JA(), { src: u, srcSet: d } = a, h = u ?? (d === void 0 ? l.src : ""), f = !h && d === void 0 ? "none" : "loading", [p, v] = ue(() => ({
    src: h,
    srcSet: d,
    state: f
  })), g = Se(!1);
  let m;
  i[0] !== d || i[1] !== h ? (m = {
    src: h,
    srcSet: d
  }, i[0] = d, i[1] = h, i[2] = m) : m = i[2];
  const y = Me(m), k = p.src === h && p.srcSet === d;
  k || v({
    src: h,
    srcSet: d,
    state: f
  });
  const _ = k ? p.state : f;
  let w;
  i[3] !== _ || i[4] !== c ? (w = () => (c(_), () => c("none")), i[3] = _, i[4] = c, i[5] = w) : w = i[5];
  let T;
  i[6] !== d || i[7] !== _ || i[8] !== c || i[9] !== h ? (T = [
    d,
    _,
    c,
    h
  ], i[6] = d, i[7] = _, i[8] = c, i[9] = h, i[10] = T) : T = i[10], $t(w, T);
  let E;
  i[11] !== y ? (E = (M) => {
    if (!M || g.current) return;
    g.current = !0;
    const { src: O, srcSet: W } = y.current;
    M.naturalWidth > 0 ? v({
      src: O,
      srcSet: W,
      state: "loaded"
    }) : M.complete && (M.getAttribute("src") || M.hasAttribute("srcset")) && v({
      src: O,
      srcSet: W,
      state: "error"
    });
  }, i[11] = y, i[12] = E) : E = i[12];
  const S = kn(n, E);
  return ge("img", {
    render: r,
    className: s,
    style: o
  }, {
    state: l,
    ref: S,
    props: [
      { alt: "" },
      a,
      {
        src: h || void 0,
        onLoad: () => v({
          src: h,
          srcSet: d,
          state: "loaded"
        }),
        onError: () => v({
          src: h,
          srcSet: d,
          state: "error"
        })
      }
    ]
  });
}), QA = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, a = qe(rs), l = qe(eb), [c] = ue(e$), [u, d] = ue(null);
  if (!a) return null;
  c.setMedia({
    started: a.started,
    poster: l?.poster ?? ""
  }), c.setImageLoadState(u ?? (l?.poster ? "loading" : "none"));
  const h = c.getState();
  return /* @__PURE__ */ b(XA, {
    value: {
      state: h,
      setImageLoadState: d
    },
    children: ge("div", {
      render: i,
      className: r,
      style: s
    }, {
      state: h,
      stateAttrMap: N2,
      ref: n,
      props: o
    })
  });
});
function e$() {
  return new L2();
}
const t$ = Vl({
  name: "useQualityOptions",
  feature: "quality",
  selector: n5,
  createCore: () => new H2()
});
function i$(t) {
  "use no memo";
  return t$(t);
}
const Rb = Le(void 0);
function n$(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ children: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  const r = i$(i);
  let s;
  e[3] !== r ? (s = o$(r), e[3] = r, e[4] = s) : s = e[4], Fl(s);
  let o;
  return e[5] !== n || e[6] !== r ? (o = /* @__PURE__ */ b(Rb.Provider, {
    value: r,
    children: n
  }), e[5] = n, e[6] = r, e[7] = o) : o = e[7], o;
}
const r$ = se(function({ render: e, className: n, style: i, ...r }, s) {
  const o = Mb();
  return o ? ge("span", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    ref: s,
    props: [r, { children: o.selectedLabel }]
  }) : null;
}), s$ = se(function(e, n) {
  const i = te.c(40);
  let r, s, o, a, l, c, u;
  i[0] !== e ? ({ renderItem: c, render: l, className: o, style: u, "aria-label": r, "aria-labelledby": s, ...a } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l, i[6] = c, i[7] = u) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5], c = i[6], u = i[7]);
  const d = Mb();
  if (!d) return null;
  const { state: h, value: f, options: p, setValue: v } = d, g = r ?? (s === void 0 ? d.label : void 0);
  let m;
  i[8] !== h ? (m = qi(h, U2), i[8] = h, i[9] = m) : m = i[9];
  let y;
  i[10] !== o || i[11] !== h ? (y = ke(o) ? o(h) : o, i[10] = o, i[11] = h, i[12] = y) : y = i[12];
  let k;
  i[13] !== h || i[14] !== u ? (k = ke(u) ? u(h) : u, i[13] = h, i[14] = u, i[15] = k) : k = i[15];
  let _;
  i[16] !== l || i[17] !== h ? (_ = ke(l) ? (P) => l(P, h) : l, i[16] = l, i[17] = h, i[18] = _) : _ = i[18];
  const w = h.disabled || void 0, T = h.hidden;
  let E;
  if (i[19] !== p || i[20] !== c || i[21] !== f) {
    let P;
    i[23] !== c || i[24] !== f ? (P = (C) => {
      const M = {
        ...C,
        checked: C.value === f
      };
      return /* @__PURE__ */ b(nr, { children: c({
        value: C.value,
        disabled: C.disabled,
        "data-rendition": C.value,
        children: C.label
      }, M) }, C.value);
    }, i[23] = c, i[24] = f, i[25] = P) : P = i[25], E = p.map(P), i[19] = p, i[20] = c, i[21] = f, i[22] = E;
  } else E = i[22];
  let S;
  return i[26] !== g || i[27] !== s || i[28] !== a || i[29] !== n || i[30] !== v || i[31] !== h.hidden || i[32] !== m || i[33] !== y || i[34] !== k || i[35] !== _ || i[36] !== w || i[37] !== E || i[38] !== f ? (S = /* @__PURE__ */ b(jl, {
    ...m,
    ...a,
    ref: n,
    className: y,
    style: k,
    render: _,
    value: f,
    onValueChange: v,
    "aria-label": g,
    "aria-labelledby": s,
    "aria-disabled": w,
    hidden: T,
    children: E
  }), i[26] = g, i[27] = s, i[28] = a, i[29] = n, i[30] = v, i[31] = h.hidden, i[32] = m, i[33] = y, i[34] = k, i[35] = _, i[36] = w, i[37] = E, i[38] = f, i[39] = S) : S = i[39], S;
});
function Mb() {
  const t = we(Rb);
  if (t === void 0) throw new Error("QualityRadioGroup parts must be used within QualityRadioGroup.Root");
  return t;
}
function o$(t) {
  return {
    value: t?.selectedLabel ?? "",
    disabled: t?.disabled ?? !0,
    hidden: t?.hidden ?? !0,
    availability: t?.state.availability ?? "unsupported"
  };
}
function a$(t) {
  const e = te.c(8), n = xn(), i = Me(t), r = Se(null);
  let s;
  e[0] !== i ? (s = () => ({ close: () => i.current() }), e[0] = i, e[1] = s) : s = e[1];
  const [o] = ue(s);
  let a, l;
  e[2] !== n || e[3] !== o ? (a = () => {
    if (!n) return;
    const u = $5(n);
    return r.current = u, u.register(o);
  }, l = [n, o], e[2] = n, e[3] = o, e[4] = a, e[5] = l) : (a = e[4], l = e[5]), ye(a, l);
  let c;
  return e[6] !== o ? (c = () => {
    r.current?.show(o);
  }, e[6] = o, e[7] = c) : c = e[7], c;
}
function l$(t) {
  const e = te.c(6), n = xn(), i = qe(), r = Me(t), s = Me(i);
  let o;
  e[0] !== r || e[1] !== n || e[2] !== s ? (o = () => {
    if (n)
      return A5(n, (l) => {
        r.current(l, Xu(s.current));
      });
  }, e[0] = r, e[1] = n, e[2] = s, e[3] = o) : o = e[3];
  let a;
  e[4] !== n ? (a = [n], e[4] = n, e[5] = a) : a = e[5], ye(o, a);
}
function c$(t, e = {}) {
  const n = Se(null), i = Se(t), r = Se(t), [s] = ue(() => bo());
  Xt(s), i.current = t;
  const o = is((c) => s.state.subscribe(c), () => s.state.current, () => s.state.current), { generation: a, open: l } = t;
  return $t(() => {
    if (l) {
      const d = i.current;
      if (d.generation !== a) return;
      r.current = d;
      const h = s.state.current;
      !h.active || e.replayOnUpdate !== !1 ? s.open(n.current) : h.status === "ending" && s.cancel();
      return;
    }
    const { active: c, status: u } = s.state.current;
    c && u !== "ending" && s.close(n.current);
  }, [
    a,
    l,
    e.replayOnUpdate,
    s
  ]), {
    elementRef: n,
    present: m2(t, o),
    state: g2(t, r.current, o)
  };
}
function Hh(t, e, n) {
  const i = te.c(10), [r] = ue(t);
  Xt(r), r.setProps(e);
  let s;
  i[0] !== r ? (s = () => r.close(), i[0] = r, i[1] = s) : s = i[1];
  const o = a$(s);
  let a;
  i[2] !== r || i[3] !== o ? (a = (h, f) => {
    r.processEvent(h, f) && o();
  }, i[2] = r, i[3] = o, i[4] = a) : a = i[4], l$(a);
  let l;
  i[5] !== r.state ? (l = (h) => r.state.subscribe(h), i[5] = r.state, i[6] = l) : l = i[6];
  let c, u;
  i[7] !== r.state.current ? (c = () => r.state.current, u = () => r.state.current, i[7] = r.state.current, i[8] = c, i[9] = u) : (c = i[8], u = i[9]);
  const d = is(l, c, u);
  return c$(d, n);
}
const Ob = Le(null);
function u$(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b(Ob.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function d$() {
  const t = we(Ob);
  if (!t) throw new Error("SeekIndicator child compounds must be used within a SeekIndicator.Root");
  return t;
}
const h$ = se(function(e, n) {
  const i = te.c(9), { render: r, className: s, style: o, closeDelay: a, ...l } = e, c = yo();
  let u;
  i[0] !== a || i[1] !== c ? (u = {
    closeDelay: a,
    locale: c
  }, i[0] = a, i[1] = c, i[2] = u) : u = i[2];
  const { elementRef: d, present: h, state: f } = Hh(f$, u);
  if (!h) return null;
  const p = u$;
  let v;
  i[3] !== f ? (v = { state: f }, i[3] = f, i[4] = v) : v = i[4];
  const g = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: f,
    stateAttrMap: tE,
    ref: [n, d],
    props: [l]
  });
  let m;
  return i[5] !== p || i[6] !== v || i[7] !== g ? (m = /* @__PURE__ */ b(p, {
    value: v,
    children: g
  }), i[5] = p, i[6] = v, i[7] = g, i[8] = m) : m = i[8], m;
});
function f$() {
  return new eE();
}
const p$ = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, { state: a } = d$();
  return ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: a,
    ref: n,
    props: [{ children: X2(a) }, o]
  });
}), Ib = Le(null);
function m$(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b(Ib.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function g$() {
  const t = we(Ib);
  if (!t) throw new Error("Thumbnail compound components must be used within a Thumbnail.Root");
  return t;
}
const v$ = se(function(e, n) {
  const { render: i, className: r, style: s, crossOrigin: o, loading: a, fetchPriority: l, ...c } = e, { core: u, state: d, src: h, imageStyle: f, inheritedCrossOrigin: p, imageRef: v } = g$(), g = kn(n, v);
  return ge("img", {
    render: i,
    className: r,
    style: s
  }, {
    state: d,
    ref: g,
    props: [
      {
        alt: "",
        "aria-hidden": "true",
        decoding: "async"
      },
      c,
      {
        src: h,
        crossOrigin: u.resolveCrossOrigin(o, p),
        loading: a,
        style: f,
        fetchPriority: l
      }
    ]
  });
}), y$ = se(function(e, n) {
  "use no memo";
  const { render: i, className: r, style: s, time: o = 0, thumbnails: a, ...l } = e, [c] = ue(() => new xy()), u = Se(null), d = Se(null), h = Wa(rr);
  Wa(Dl);
  const [, f] = ue(0), [p] = ue(() => nC({
    getContainer: () => u.current,
    getImg: () => d.current,
    onStateChange: () => f((w) => w + 1)
  }));
  Xt(p, () => p.connect());
  const v = pt((w) => {
    const T = d.current;
    d.current = w, w ? p.connect() : T && p.disconnectImg(T);
  }, [p]), g = Gt(() => {
    if (a && a.length > 0) return a;
    const w = h?.thumbnailsTrack;
    return w && w.cues.length > 0 ? _E(w.cues, w.src ?? void 0) : [];
  }, [a, h]), m = Gt(() => c.findActiveThumbnail(g, o), [
    c,
    g,
    o
  ]);
  p.updateSrc(m?.url);
  const y = c.getState(p.loading, p.error, m);
  let k = { overflow: "hidden" }, _;
  if (m && p.naturalWidth && p.naturalHeight) {
    const w = p.readConstraints(), T = c.resize(m, p.naturalWidth, p.naturalHeight, w);
    T && (k = {
      overflow: "hidden",
      width: T.containerWidth,
      height: T.containerHeight
    }, _ = {
      width: T.imageWidth,
      height: T.imageHeight,
      maxWidth: "none",
      transform: T.offsetX || T.offsetY ? `translate(-${T.offsetX}px, -${T.offsetY}px)` : void 0
    });
  }
  return /* @__PURE__ */ b(m$, {
    value: {
      core: c,
      state: y,
      src: m?.url,
      imageStyle: _,
      inheritedCrossOrigin: a?.length ? void 0 : h?.thumbnailsTrack?.crossOrigin,
      imageRef: v
    },
    children: ge("div", {
      render: i,
      className: r,
      style: s
    }, {
      state: y,
      stateAttrMap: yE,
      ref: [n, u],
      props: [
        c.getAttrs(y),
        { style: k },
        l
      ]
    })
  });
}), Db = Le(null);
function Fb(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b(Db.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function Gi() {
  const t = we(Db);
  if (!t) throw new Error("Slider compound components must be used within a Slider.Root");
  return t;
}
function Hl(t) {
  const e = te.c(9), n = t === void 0 ? !0 : t, i = Gi();
  let r;
  e[0] !== i.input ? (r = (c) => i.input?.subscribe(c) ?? b$, e[0] = i.input, e[1] = r) : r = e[1];
  let s, o;
  e[2] !== i.input?.current || e[3] !== n ? (s = () => n ? i.input?.current.pointerPercent ?? null : null, o = () => n ? i.input?.current.pointerPercent ?? null : null, e[2] = i.input?.current, e[3] = n, e[4] = s, e[5] = o) : (s = e[4], o = e[5]);
  const a = is(r, s, o);
  let l;
  return e[6] !== i || e[7] !== a ? (l = a === null ? i.pointerValue : i.getPointerValue?.(a) ?? i.pointerValue, e[6] = i, e[7] = a, e[8] = l) : l = e[8], l;
}
function b$() {
}
const _$ = Nl({
  displayName: "SliderBuffer",
  tag: "div",
  useContext: Gi
}), Lb = Nl({
  displayName: "SliderFill",
  tag: "div",
  useContext: Gi
}), w$ = se(function(e, n) {
  const { render: i, className: r, style: s, overflow: o = "clamp", ...a } = e, l = Gi(), { state: c } = l, u = Se(null), [d, h] = ue(0);
  ye(() => {
    const p = u.current;
    if (p)
      return fo(p, ([v]) => {
        h(v.contentRect.width);
      });
  }, []);
  const f = Q5(d, o);
  return ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: c,
    stateAttrMap: l.stateAttrMap,
    ref: [n, u],
    props: [{ style: f }, a]
  });
}), Nb = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, a = Gi(), { state: l, thumbRef: c, thumbProps: u, getAttrs: d } = a, h = d(l);
  return ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: l,
    stateAttrMap: a.stateAttrMap,
    ref: [n, c],
    props: [
      h,
      u,
      o
    ]
  });
}), k$ = se(function(e, n) {
  const i = te.c(4), r = Hl();
  let s;
  return i[0] !== e || i[1] !== n || i[2] !== r ? (s = /* @__PURE__ */ b(y$, {
    ref: n,
    ...e,
    time: r
  }), i[0] = e, i[1] = n, i[2] = r, i[3] = s) : s = i[3], s;
}), Vb = Nl({
  displayName: "SliderTrack",
  tag: "div",
  useContext: Gi
}), x$ = se(function(e, n) {
  const { render: i, className: r, style: s, type: o = "current", format: a, ...l } = e, c = Gi(), { state: u, formatValue: d } = c, h = Hl(o === "pointer"), f = o === "pointer" ? h : u.value, p = a ? a(f) : d ? d(f, o) : String(Math.round(f));
  return ge("output", {
    render: i,
    className: r,
    style: s
  }, {
    state: u,
    stateAttrMap: c.stateAttrMap,
    ref: n,
    props: [{
      "aria-live": "off",
      children: p
    }, l]
  });
}), S$ = se(function(e, n) {
  const { render: i, className: r, style: s, closeDelay: o, labels: a, ...l } = e, c = zt(), u = yo(), [d] = ue(() => new uE()), h = qe(), f = xn();
  Xt(d), d.setProps({
    closeDelay: o,
    labels: {
      ...nE(c, u),
      ...a
    },
    shouldAnnounce: () => iC(f)
  }), ye(() => tC(h, d), [d, h]);
  const p = is((v) => d.state.subscribe(v), () => d.state.current, () => d.state.current);
  return ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: p,
    ref: n,
    props: [l, {
      role: "status",
      children: /* @__PURE__ */ b("span", {
        "data-status-announcer-content": "",
        children: p.label ?? ""
      }, p.generation)
    }]
  });
}), jb = Le(null);
function P$(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b(jb.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function E$() {
  const t = we(jb);
  if (!t) throw new Error("StatusIndicator child compounds must be used within a StatusIndicator.Root");
  return t;
}
const zb = se(function(e, n) {
  const i = te.c(14), { render: r, className: s, style: o, actions: a, closeDelay: l, deriveCustomStatus: c, ...u } = e, d = zt();
  let h;
  i[0] !== d ? (h = bh(d), i[0] = d, i[1] = h) : h = i[1];
  let f;
  i[2] !== a || i[3] !== l || i[4] !== c || i[5] !== h ? (f = {
    actions: a,
    closeDelay: l,
    deriveCustomStatus: c,
    labels: h
  }, i[2] = a, i[3] = l, i[4] = c, i[5] = h, i[6] = f) : f = i[6];
  let p;
  i[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = { replayOnUpdate: !1 }, i[7] = p) : p = i[7];
  const { elementRef: v, present: g, state: m } = Hh(T$, f, p);
  if (!g) return null;
  const y = P$;
  let k;
  i[8] !== m ? (k = { state: m }, i[8] = m, i[9] = k) : k = i[9];
  const _ = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: m,
    stateAttrMap: mE,
    ref: [n, v],
    props: [u]
  });
  let w;
  return i[10] !== y || i[11] !== k || i[12] !== _ ? (w = /* @__PURE__ */ b(y, {
    value: k,
    children: _
  }), i[10] = y, i[11] = k, i[12] = _, i[13] = w) : w = i[13], w;
});
function T$() {
  return new pE();
}
const C$ = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, { state: a } = E$();
  return ge("span", {
    render: i,
    className: r,
    style: s
  }, {
    state: a,
    ref: n,
    props: [{ children: hE(a) }, o]
  });
}), A$ = se(function(e, n) {
  const { render: i, className: r, style: s, children: o, ...a } = e;
  return ge("span", {
    render: i,
    className: r,
    style: s
  }, {
    state: {},
    ref: [n],
    props: [{ children: o }, a]
  });
}), $$ = se(function(e, n) {
  const { render: i, className: r, style: s, children: o = "/", ...a } = e;
  return ge("span", {
    render: i,
    className: r,
    style: s
  }, {
    state: {},
    ref: [n],
    props: [{
      "aria-hidden": "true",
      children: o
    }, a]
  });
}), Zp = se(function(e, n) {
  const { render: i, className: r, style: s, type: o, negativeSign: a, label: l, toggle: c = !1, ...u } = e, d = qe(sr), h = qe(Il), f = zt(), p = yo(), [v] = ue(() => new uc()), g = o ?? uc.defaultProps.type, [m, y] = ue(g);
  if (ye(() => {
    y(g);
  }, [g, c]), v.setProps({
    type: m,
    negativeSign: a,
    label: l,
    toggle: c
  }), !d) return null;
  v.setMedia({
    ...d,
    seekable: h?.seekable ?? []
  }), v.setFormatLocale(p);
  const k = v.getState(), _ = v.getAttrs(k, g), w = v.getLabelParams(k), T = {
    current: SE,
    duration: PE,
    remaining: EE
  }[k.type], E = w ? { duration: Be(T, f, { duration: un(Math.abs(k.seconds), { locale: p }) }) } : void 0, S = k.negative ? /* @__PURE__ */ Z(bn, { children: [/* @__PURE__ */ b("span", {
    "aria-hidden": "true",
    children: a ?? uc.defaultProps.negativeSign
  }), k.text] }) : k.text, P = () => {
    y((O) => g === "current" ? O === "remaining" ? "current" : "remaining" : O === "duration" ? "remaining" : "duration");
  }, C = (O) => {
    O.defaultPrevented || k.disabled || P();
  }, M = (O) => {
    O.defaultPrevented || k.disabled || !hh(O.nativeEvent) || (O.preventDefault(), !O.repeat && P());
  };
  return ge("time", {
    render: i,
    className: r,
    style: s
  }, {
    state: k,
    stateAttrMap: DE,
    ref: [n],
    props: [{
      dateTime: c || k.unavailable ? void 0 : k.datetime,
      children: S,
      ..._,
      "aria-label": Be(_["aria-label"], f, E),
      "aria-description": _["aria-description"] ? Be(_["aria-description"], f) : void 0,
      ...c ? {
        onClick: C,
        onKeyDown: M
      } : void 0
    }, u]
  });
}), R$ = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, a = Gi(), l = Hl(), c = qe(rr), u = qe(sr), [d] = ue(() => new Py()), { chapters: h } = Gt(() => d.getRanges(c?.chaptersCues ?? [], 0, u?.duration ?? 0), [
    d,
    c?.chaptersCues,
    u?.duration
  ]), f = a.state.interactive && !a.state.pointing && !a.state.dragging, p = a.state.pointing || a.state.dragging ? l : a.state.value, v = d.findChapter(h, p)?.cue ?? null, g = {
    cue: v,
    text: v?.text ?? ""
  };
  return ge("span", {
    render: i,
    className: r,
    style: s
  }, {
    state: g,
    ref: n,
    props: [{
      "aria-hidden": f ? void 0 : !0,
      "aria-live": f ? "polite" : void 0,
      children: g.text
    }, o]
  });
}), M$ = se(function(e, n) {
  const { ranges: i, min: r, max: s, renderSegment: o, render: a, className: l, style: c, ...u } = e, d = Gi(), h = Hl(), [f] = ue(() => new iE()), p = Gt(() => f.getGeometry({
    ranges: i,
    min: r,
    max: s,
    orientation: d.state.orientation
  }), [
    f,
    i,
    r,
    s,
    d.state.orientation
  ]), v = qi(d.state, d.stateAttrMap), g = p.map((y) => {
    const k = f.getState(y, d.state, h), _ = {
      [Es.start]: k.startPercent,
      [Es.end]: k.endPercent,
      [Es.width]: k.width ?? k.height,
      [Es.fill]: `${k.fillPercent}%`
    };
    return /* @__PURE__ */ b(nr, { children: o({
      ...v,
      style: _
    }, k) }, k.key);
  }), m = p.length > 0 ? f.getState(p[0], d.state, h) : null;
  return m ? ge("div", {
    render: a,
    className: l,
    style: c
  }, {
    state: m,
    ref: n,
    props: [
      { "aria-hidden": "true" },
      v,
      u,
      { children: g }
    ]
  }) : null;
}), O$ = se(function(e, n) {
  const i = te.c(39);
  let r, s, o, a, l;
  i[0] !== e ? ({ renderChapter: a, className: r, style: l, render: o, ...s } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o, i[4] = a, i[5] = l) : (r = i[1], s = i[2], o = i[3], a = i[4], l = i[5]);
  const c = qe(rr), u = qe(Il), d = qe(sr)?.duration ?? 0, [h] = ue(I$);
  c?.chaptersCues;
  let f;
  if (i[6] !== h || i[7] !== d || i[8] !== c?.chaptersCues) {
    let M;
    i[10] !== c?.chaptersCues ? (M = c?.chaptersCues ?? [], i[10] = c?.chaptersCues, i[11] = M) : M = i[11], f = h.getRanges(M, 0, d), i[6] = h, i[7] = d, i[8] = c?.chaptersCues, i[9] = f;
  } else f = i[9];
  const { chapters: p, ranges: v, max: g } = f, m = u?.buffered.length ? u.buffered[u.buffered.length - 1][1] : 0;
  let y;
  i[12] !== m || i[13] !== p || i[14] !== h ? (y = (M) => h.getState(M, p, m), i[12] = m, i[13] = p, i[14] = h, i[15] = y) : y = i[15];
  const k = y;
  let _;
  i[16] !== p ? (_ = { chapters: p }, i[16] = p, i[17] = _) : _ = i[17];
  const w = _;
  let T;
  i[18] !== r || i[19] !== w ? (T = ke(r) ? r(w) : r, i[18] = r, i[19] = w, i[20] = T) : T = i[20];
  let E;
  i[21] !== w || i[22] !== l ? (E = ke(l) ? l(w) : l, i[21] = w, i[22] = l, i[23] = E) : E = i[23];
  let S;
  i[24] !== o || i[25] !== w ? (S = ke(o) ? (M) => o(M, w) : o, i[24] = o, i[25] = w, i[26] = S) : S = i[26];
  let P;
  i[27] !== k || i[28] !== a ? (P = (M, O) => {
    const W = k(O), H = {
      ...M,
      ...qi(W, VE),
      style: {
        ...M.style,
        pointerEvents: W.cue ? void 0 : "none",
        [Es.buffer]: `${W.bufferPercent}%`
      }
    };
    return a(H, W);
  }, i[27] = k, i[28] = a, i[29] = P) : P = i[29];
  let C;
  return i[30] !== g || i[31] !== s || i[32] !== v || i[33] !== n || i[34] !== T || i[35] !== E || i[36] !== S || i[37] !== P ? (C = /* @__PURE__ */ b(M$, {
    ref: n,
    ...s,
    className: T,
    style: E,
    render: S,
    ranges: v,
    min: 0,
    max: g,
    renderSegment: P
  }), i[30] = g, i[31] = s, i[32] = v, i[33] = n, i[34] = T, i[35] = E, i[36] = S, i[37] = P, i[38] = C) : C = i[38], C;
});
function I$() {
  return new Py();
}
const D$ = () => Promise.resolve(0), F$ = se(function(e, n) {
  const i = te.c(69), { render: r, className: s, style: o, label: a, changeThrottle: l, step: c, largeStep: u, orientation: d, disabled: h, thumbAlignment: f, onDragStart: p, onDragEnd: v, pauseOnDrag: g, ...m } = e, y = l === void 0 ? ya.defaultProps.changeThrottle : l, k = c === void 0 ? ya.defaultProps.step : c, _ = u === void 0 ? ya.defaultProps.largeStep : u, w = qe(sr), T = qe(Il), E = qe(rs), S = zt(), P = yo(), [C] = ue(L$);
  C.setProps({
    label: a,
    step: k,
    largeStep: _,
    orientation: d,
    disabled: h,
    thumbAlignment: f,
    pauseOnDrag: g,
    changeThrottle: y
  }), C.setFormatLocale(P);
  let M;
  i[0] !== T || i[1] !== w ? (M = w ? {
    ...w,
    ...T ?? {
      buffered: [],
      seekable: []
    }
  } : null, i[0] = T, i[1] = w, i[2] = M) : M = i[2];
  const O = M, W = Me(O), H = Me(E);
  let z;
  i[3] !== C || i[4] !== H ? (z = () => () => C.endDrag(H.current), i[3] = C, i[4] = H, i[5] = z) : z = i[5];
  let F;
  i[6] !== C ? (F = [C], i[6] = C, i[7] = F) : F = i[7], ye(z, F);
  let K;
  i[8] !== C || i[9] !== O ? (K = (fe) => (C.setInput(fe), C.setMedia(O ?? {
    currentTime: 0,
    duration: 0,
    seeking: !1,
    seek: D$,
    buffered: [],
    seekable: []
  }), C.getState()), i[8] = C, i[9] = O, i[10] = K) : K = i[10];
  let B;
  i[11] !== C || i[12] !== w?.currentTime ? (B = () => C.percentFromValue(w?.currentTime ?? 0), i[11] = C, i[12] = w?.currentTime, i[13] = B) : B = i[13];
  let $, I;
  i[14] !== C ? ($ = () => C.getStepPercent(), I = () => C.getLargeStepPercent(), i[14] = C, i[15] = $, i[16] = I) : ($ = i[15], I = i[16]);
  let q;
  i[17] !== h || i[18] !== O ? (q = h || !O || !mh(O), i[17] = h, i[18] = O, i[19] = q) : q = i[19];
  let J;
  i[20] !== C ? (J = (fe, Nt, Oo) => C.adjustPercentForAlignment(fe, Nt, Oo), i[20] = C, i[21] = J) : J = i[21];
  let D;
  i[22] !== C || i[23] !== W ? (D = (fe) => {
    const Nt = W.current;
    Nt && Nt.seek(C.rawValueFromPercent(fe));
  }, i[22] = C, i[23] = W, i[24] = D) : D = i[24];
  let A;
  i[25] !== C || i[26] !== p || i[27] !== H ? (A = () => {
    C.startDrag(H.current), p?.();
  }, i[25] = C, i[26] = p, i[27] = H, i[28] = A) : A = i[28];
  let N;
  i[29] !== C || i[30] !== v || i[31] !== H ? (N = () => {
    C.endDrag(H.current), v?.();
  }, i[29] = C, i[30] = v, i[31] = H, i[32] = N) : N = i[32];
  let X;
  i[33] !== y || i[34] !== d || i[35] !== q || i[36] !== J || i[37] !== D || i[38] !== A || i[39] !== N || i[40] !== K || i[41] !== B || i[42] !== $ || i[43] !== I ? (X = {
    computeState: K,
    getPercent: B,
    getStepPercent: $,
    getLargeStepPercent: I,
    orientation: d,
    disabled: q,
    changeThrottle: y,
    adjustPercent: J,
    getCSSVars: Z5,
    onValueCommit: D,
    onDragStart: A,
    onDragEnd: N
  }, i[33] = y, i[34] = d, i[35] = q, i[36] = J, i[37] = D, i[38] = A, i[39] = N, i[40] = K, i[41] = B, i[42] = $, i[43] = I, i[44] = X) : X = i[44];
  const { state: U, input: j, cssVars: ie, rootRef: oe, thumbRef: Oe, rootProps: $e, rootStyle: Ae, thumbProps: Bt } = kb(X);
  if (!w) return null;
  const Yi = Fb;
  let ht;
  i[45] !== C || i[46] !== U.pointerPercent ? (ht = C.rawValueFromPercent(U.pointerPercent), i[45] = C, i[46] = U.pointerPercent, i[47] = ht) : ht = i[47];
  let Jt;
  i[48] !== C ? (Jt = (fe) => C.rawValueFromPercent(fe), i[48] = C, i[49] = Jt) : Jt = i[49];
  let Ht;
  i[50] !== C || i[51] !== S ? (Ht = (fe) => {
    const Nt = C.getAttrs(fe);
    return {
      ...Nt,
      "aria-label": Be(Nt["aria-label"], S),
      "aria-valuetext": Be(Nt["aria-valuetext"], S, C.getValueTextParams(fe))
    };
  }, i[50] = C, i[51] = S, i[52] = Ht) : Ht = i[52];
  let Rt;
  i[53] !== P || i[54] !== U.duration ? (Rt = (fe) => _h(fe, U.duration, { locale: P }), i[53] = P, i[54] = U.duration, i[55] = Rt) : Rt = i[55];
  let it;
  i[56] !== j || i[57] !== U || i[58] !== ht || i[59] !== Jt || i[60] !== Ht || i[61] !== Rt || i[62] !== Bt || i[63] !== Oe ? (it = {
    state: U,
    pointerValue: ht,
    input: j,
    getPointerValue: Jt,
    thumbRef: Oe,
    thumbProps: Bt,
    stateAttrMap: wp,
    getAttrs: Ht,
    formatValue: Rt
  }, i[56] = j, i[57] = U, i[58] = ht, i[59] = Jt, i[60] = Ht, i[61] = Rt, i[62] = Bt, i[63] = Oe, i[64] = it) : it = i[64];
  const Ti = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: U,
    stateAttrMap: wp,
    ref: [n, oe],
    props: [
      { style: {
        ...ie,
        ...Ae
      } },
      $e,
      m
    ]
  });
  let Ci;
  return i[65] !== Yi || i[66] !== it || i[67] !== Ti ? (Ci = /* @__PURE__ */ b(Yi, {
    value: it,
    children: Ti
  }), i[65] = Yi, i[66] = it, i[67] = Ti, i[68] = Ci) : Ci = i[68], Ci;
});
function L$() {
  return new ya();
}
const N$ = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, a = qe(eb), l = qe(Ei), [c] = ue(() => new jE());
  if (!a) return null;
  const u = c.getState(a, l);
  return u.hidden ? null : ge("div", {
    render: i,
    className: r,
    style: s
  }, {
    state: u,
    stateAttrMap: zE,
    ref: [n],
    props: [{ children: u.title }, o]
  });
}), Bb = se(function({ render: e, className: n, style: i, children: r, ...s }, o) {
  const { state: a, stateAttrMap: l, content: c } = Ll(), u = r !== void 0 ? r : c?.label ?? "";
  return ge("span", {
    render: e,
    className: n,
    style: i
  }, {
    state: a,
    stateAttrMap: l,
    ref: o,
    props: [s, { children: u }]
  });
}), Hb = se(function({ render: e, className: n, style: i, children: r, ...s }, o) {
  const { state: a, stateAttrMap: l, content: c } = Ll(), u = r ?? c?.shortcut ?? null;
  return u ? ge("kbd", {
    render: e,
    className: n,
    style: i
  }, {
    state: a,
    stateAttrMap: l,
    ref: o,
    props: [s, { children: u }]
  }) : null;
}), V$ = se(function(e, n) {
  const i = te.c(15), { render: r, className: s, style: o, children: a, ...l } = e, { core: c, tooltip: u, state: d, preferredSide: h, setPositionedSide: f, stateAttrMap: p, anchorName: v, popupId: g, boundary: m, container: y } = Ll(), k = Se(null);
  let _;
  i[0] !== u ? (_ = (H) => {
    u.setPopupElement(H);
  }, i[0] = u, i[1] = _) : _ = i[1];
  const w = kn(n, _, k);
  let T;
  i[2] !== h || i[3] !== d.align ? (T = {
    side: h,
    align: d.align
  }, i[2] = h, i[3] = d.align, i[4] = T) : T = i[4];
  const E = T;
  let S;
  i[5] !== v || i[6] !== m || i[7] !== y || i[8] !== E || i[9] !== f || i[10] !== d.open || i[11] !== u ? (S = {
    open: d.open,
    anchorName: v,
    position: E,
    triggerSource: u,
    popupRef: k,
    boundary: m,
    container: y,
    cssVars: UE,
    onSideChange: f
  }, i[5] = v, i[6] = m, i[7] = y, i[8] = E, i[9] = f, i[10] = d.open, i[11] = u, i[12] = S) : S = i[12];
  const P = zh(S);
  if (!d.open) return null;
  let C;
  i[13] !== a ? (C = a !== void 0 ? a : /* @__PURE__ */ Z(bn, { children: [/* @__PURE__ */ b(Bb, {}), /* @__PURE__ */ b(Hb, {})] }), i[13] = a, i[14] = C) : C = i[14];
  const M = C, { onFocusOut: O, ...W } = u.popupProps;
  return ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: d,
    stateAttrMap: p,
    ref: w,
    props: [
      {
        id: g,
        style: P,
        ...c.getPopupAttrs(d)
      },
      { children: M },
      {
        ...W,
        onBlur: O
      },
      l
    ]
  });
}), Ub = Le(null), j$ = Ub.Provider;
function z$() {
  return we(Ub)?.group;
}
function B$(t) {
  const e = te.c(9), { delay: n, closeDelay: i, timeout: r, children: s } = t;
  let o;
  e[0] !== i || e[1] !== n || e[2] !== r ? (o = () => new HE({
    delay: n,
    closeDelay: i,
    timeout: r
  }), e[0] = i, e[1] = n, e[2] = r, e[3] = o) : o = e[3];
  const [a] = ue(o);
  a.setProps({
    delay: n,
    closeDelay: i,
    timeout: r
  });
  let l;
  e[4] !== a ? (l = { group: a }, e[4] = a, e[5] = l) : l = e[5];
  let c;
  return e[6] !== s || e[7] !== l ? (c = /* @__PURE__ */ b(j$, {
    value: l,
    children: s
  }), e[6] = s, e[7] = l, e[8] = c) : c = e[8], c;
}
function H$({ open: t, defaultOpen: e = Tn.defaultProps.defaultOpen, onOpenChange: n, onOpenChangeComplete: i, delay: r = Tn.defaultProps.delay, closeDelay: s = Tn.defaultProps.closeDelay, disableHoverablePopup: o = Tn.defaultProps.disableHoverablePopup, disabled: a = Tn.defaultProps.disabled, sticky: l = Tn.defaultProps.sticky, boundary: c = "container", children: u, ...d }) {
  const h = Sh(), f = Ph(), p = Vh(), [v] = ue(() => new Tn(d));
  v.setProps(d);
  const g = !Ce(t), m = z$(), y = Me(n), k = Me(i), _ = Me(r), w = Me(s), T = Me(o), E = Me(a), S = Me(l), P = Me(m), C = Me(f), [M] = ue(() => {
    const I = sC({
      transition: bo(),
      onOpenChange: (q, J) => {
        y.current?.(q, J);
      },
      onOpenChangeComplete: (q) => {
        k.current?.(q);
      },
      delay: () => _.current,
      closeDelay: () => w.current,
      disableHoverablePopup: () => T.current,
      disabled: () => E.current,
      sticky: () => S.current,
      group: () => P.current,
      popupGroup: () => C.current
    });
    return !g && e && I.open(), I;
  }), [O, W] = ue(), H = bi(), z = bi("tooltip");
  ye(() => {
    if (Ce(t)) return;
    const { active: I } = M.input.current;
    t !== I && (t ? M.open() : M.close());
  }, [t, M]), ye(() => {
    Ce(p?.state.visible) || p.state.visible || M.close("imperative-action");
  }, [p?.state.visible, M]), Xt(M);
  const F = Ur(M.input);
  v.setInput(F);
  const { state: K, preferredSide: B, setPositionedSide: $ } = Bh(v.getState());
  return /* @__PURE__ */ b(zC, {
    value: {
      core: v,
      tooltip: M,
      state: K,
      preferredSide: B,
      setPositionedSide: $,
      stateAttrMap: BE,
      anchorName: H,
      popupId: z,
      content: O,
      setContent: W,
      boundary: c,
      container: h
    },
    children: u
  });
}
const U$ = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { tooltip: o, state: a, stateAttrMap: l } = Ll(), c = pt((f) => {
    o.setTriggerElement(f);
  }, [o]), { onFocusIn: u, onFocusOut: d, ...h } = o.triggerProps;
  return ge("button", {
    render: e,
    className: n,
    style: i
  }, {
    state: a,
    stateAttrMap: l,
    ref: [s, c],
    props: [
      { type: "button" },
      {
        ...h,
        onFocus: u,
        onBlur: d
      },
      r
    ]
  });
}), Wb = Le(null);
function W$(t) {
  const e = te.c(3), { value: n, children: i } = t;
  let r;
  return e[0] !== i || e[1] !== n ? (r = /* @__PURE__ */ b(Wb.Provider, {
    value: n,
    children: i
  }), e[0] = i, e[1] = n, e[2] = r) : r = e[2], r;
}
function qb() {
  const t = we(Wb);
  if (!t) throw new Error("VolumeIndicator child compounds must be used within a VolumeIndicator.Root");
  return t;
}
const q$ = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, { state: a } = qb(), l = G$(a, s);
  return ge("div", {
    render: i,
    className: r,
    style: l
  }, {
    state: a,
    ref: n,
    props: [o]
  });
});
function G$(t, e) {
  const n = t.fill ? { [XE.fill]: t.fill } : void 0;
  return n ? ke(e) ? (i) => ({
    ...e(i),
    ...n
  }) : {
    ...e,
    ...n
  } : e;
}
const K$ = se(function(e, n) {
  const i = te.c(12), { render: r, className: s, style: o, closeDelay: a, ...l } = e, c = zt();
  let u;
  i[0] !== c ? (u = bh(c), i[0] = c, i[1] = u) : u = i[1];
  let d;
  i[2] !== a || i[3] !== u ? (d = {
    closeDelay: a,
    labels: u
  }, i[2] = a, i[3] = u, i[4] = d) : d = i[4];
  let h;
  i[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = { replayOnUpdate: !1 }, i[5] = h) : h = i[5];
  const { elementRef: f, present: p, state: v } = Hh(Y$, d, h);
  if (!p) return null;
  const g = W$;
  let m;
  i[6] !== v ? (m = { state: v }, i[6] = v, i[7] = m) : m = i[7];
  const y = ge("div", {
    render: r,
    className: s,
    style: o
  }, {
    state: v,
    stateAttrMap: YE,
    ref: [n, f],
    props: [l]
  });
  let k;
  return i[8] !== g || i[9] !== m || i[10] !== y ? (k = /* @__PURE__ */ b(g, {
    value: m,
    children: y
  }), i[8] = g, i[9] = m, i[10] = y, i[11] = k) : k = i[11], k;
});
function Y$() {
  return new GE();
}
const X$ = se(function(e, n) {
  const { render: i, className: r, style: s, ...o } = e, { state: a } = qb();
  return ge("span", {
    render: i,
    className: r,
    style: s
  }, {
    state: a,
    ref: n,
    props: [{ children: oE(a) }, o]
  });
}), Gb = Le(null), J$ = Gb.Provider;
function Kb() {
  const t = we(Gb);
  if (!t) throw new Error("VolumePopover compound components must be used within a VolumePopover.Root");
  return t;
}
const Z$ = se(function(e, n) {
  const i = te.c(6), { state: r } = Kb();
  if (r.hidden) return null;
  let s;
  i[0] !== r ? (s = qi(r, ZE), i[0] = r, i[1] = s) : s = i[1];
  let o;
  return i[2] !== n || i[3] !== e || i[4] !== s ? (o = /* @__PURE__ */ b(Tb, {
    ref: n,
    ...s,
    ...e
  }), i[2] = n, i[3] = e, i[4] = s, i[5] = o) : o = i[5], o;
}), Q$ = {
  volume: 0,
  muted: !1,
  volumeAvailability: "unsupported",
  mutedAvailability: "unsupported",
  setVolume: () => 0,
  setMuted: () => !1
};
function eR(t) {
  const e = te.c(9);
  let n, i;
  e[0] !== t ? ({ children: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  let r;
  e[3] !== n || e[4] !== i ? (r = /* @__PURE__ */ b(tR, {
    ...i,
    children: n
  }), e[3] = n, e[4] = i, e[5] = r) : r = e[5];
  let s;
  return e[6] !== i || e[7] !== r ? (s = /* @__PURE__ */ b(Cb, {
    ...i,
    children: r
  }), e[6] = i, e[7] = r, e[8] = s) : s = e[8], s;
}
function tR({ children: t, ...e }) {
  "use no memo";
  const n = qe(Zn), { popover: i, state: r } = So(), [s] = ue(() => new JE(e));
  s.setProps(e), s.setMedia(n ?? Q$), s.setInput({
    active: r.open,
    status: r.status
  });
  const o = s.getState();
  return ye(() => {
    o.hidden && i.close("imperative-action");
  }, [i, o.hidden]), /* @__PURE__ */ b(J$, {
    value: { state: o },
    children: t
  });
}
const iR = se(function({ render: e, className: n, style: i, ...r }, s) {
  const { state: o } = So(), { state: a } = Kb();
  return a.hidden ? ge("button", {
    render: e,
    className: n,
    style: i
  }, {
    state: o,
    ref: s,
    props: [{ type: "button" }, r]
  }) : /* @__PURE__ */ b(Ab, {
    ref: s,
    render: e,
    className: n,
    style: i,
    ...r
  });
}), nR = {
  volume: 0,
  muted: !1,
  volumeAvailability: "unsupported",
  mutedAvailability: "unsupported",
  setVolume: () => 0,
  setMuted: () => !1
}, rR = se(function(e, n) {
  const { render: i, className: r, style: s, label: o, orientation: a, step: l = Bo.defaultProps.step, largeStep: c = Bo.defaultProps.largeStep, wheelStep: u = Bo.defaultProps.wheelStep, disabled: d, thumbAlignment: h, onDragStart: f, onDragEnd: p, ...v } = e, g = qe(Zn), m = zt(), y = yo(), k = g?.volumeAvailability !== "available", _ = !!d || k, [w] = ue(() => new Bo());
  w.setProps({
    label: o,
    orientation: a,
    step: l,
    largeStep: c,
    wheelStep: u,
    disabled: d,
    thumbAlignment: h
  }), w.setFormatLocale(y);
  const T = Me(g), E = Me(_), S = () => (T.current?.volume ?? 0) * 100, P = () => w.getStepPercent(), C = (J) => T.current?.setVolume(w.valueFromPercent(J) / 100), { state: M, input: O, cssVars: W, rootRef: H, thumbRef: z, rootProps: F, rootStyle: K, thumbProps: B } = kb({
    computeState: (J) => (w.setInput(J), w.setMedia(g ?? nR), w.getState()),
    getPercent: S,
    getStepPercent: P,
    getLargeStepPercent: () => w.getLargeStepPercent(),
    orientation: a,
    disabled: _,
    adjustPercent: (J, D, A) => w.adjustPercentForAlignment(J, D, A),
    getCSSVars: cb,
    onValueChange: C,
    onValueCommit: C,
    onDragStart: f,
    onDragEnd: p
  }), [$] = ue(() => lC({
    isDisabled: () => E.current,
    getPercent: () => (T.current?.volume ?? 0) * 100,
    getStepPercent: () => w.getWheelStepPercent(),
    onValueChange: (J) => T.current?.setVolume(w.rawValueFromPercent(J) / 100)
  })), I = Se(null), q = pt((J) => {
    I.current?.(), I.current = null, J && (I.current = Q(J, "wheel", $.onWheel, { passive: !1 }));
  }, [$]);
  return !g || M.hidden ? null : /* @__PURE__ */ b(Fb, {
    value: {
      state: M,
      pointerValue: w.valueFromPercent(M.pointerPercent),
      input: O,
      getPointerValue: (J) => w.valueFromPercent(J),
      thumbRef: z,
      thumbProps: B,
      stateAttrMap: Sp,
      getAttrs: (J) => {
        const D = w.getAttrs(J);
        return {
          ...D,
          "aria-label": Be(D["aria-label"], m),
          "aria-valuetext": Be(D["aria-valuetext"], m, w.getValueTextParams(J))
        };
      },
      formatValue: (J) => `${Math.round(J)}%`
    },
    children: ge("div", {
      render: i,
      className: r,
      style: s
    }, {
      state: M,
      stateAttrMap: Sp,
      ref: [
        n,
        H,
        q
      ],
      props: [
        { style: {
          ...W,
          ...K
        } },
        F,
        v
      ]
    })
  });
}), sR = se(function(e, n) {
  const i = te.c(8);
  let r, s, o;
  i[0] !== e ? ({ children: r, mediaRef: s, ...o } = e, i[0] = e, i[1] = r, i[2] = s, i[3] = o) : (r = i[1], s = i[2], o = i[3]);
  const a = bT(), l = kn(n, s, a);
  let c;
  return i[4] !== r || i[5] !== l || i[6] !== o ? (c = /* @__PURE__ */ b("video", {
    ref: l,
    ...o,
    children: r
  }), i[4] = r, i[5] = l, i[6] = o, i[7] = c) : c = i[7], c;
});
function oR(t) {
  const e = te.c(4);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const { disabled: i } = n, r = i === void 0 ? !1 : i;
  let s;
  return e[2] !== r ? (s = /* @__PURE__ */ Z(bn, { children: [
    /* @__PURE__ */ b(ps, {
      disabled: r,
      type: "tap",
      action: "togglePaused",
      pointer: "mouse",
      region: "center"
    }),
    /* @__PURE__ */ b(ps, {
      disabled: r,
      type: "tap",
      action: "toggleControls",
      pointer: "touch"
    }),
    /* @__PURE__ */ b(ps, {
      disabled: r,
      type: "doubletap",
      action: "seekStep",
      region: "left"
    }),
    /* @__PURE__ */ b(ps, {
      disabled: r,
      type: "doubletap",
      action: "toggleFullscreen",
      region: "center"
    }),
    /* @__PURE__ */ b(ps, {
      disabled: r,
      type: "doubletap",
      action: "seekStep",
      region: "right"
    })
  ] }), e[2] = r, e[3] = s) : s = e[3], s;
}
function aR(t) {
  const e = te.c(4);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const { disabled: i } = n, r = i === void 0 ? !1 : i;
  let s;
  return e[2] !== r ? (s = /* @__PURE__ */ Z(bn, { children: [
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "Space",
      action: "togglePaused"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "k",
      action: "togglePaused"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "m",
      action: "toggleMuted"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "ArrowRight",
      action: "seekStep"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "ArrowLeft",
      action: "seekStep"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "l",
      action: "seekStep"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "j",
      action: "seekStep"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "ArrowUp",
      action: "volumeStep"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "ArrowDown",
      action: "volumeStep"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "0-9",
      action: "seekToPercent"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "Home",
      action: "seekToPercent",
      value: 0
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "End",
      action: "seekToPercent",
      value: 100
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: ">",
      action: "speedUp"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "<",
      action: "speedDown"
    })
  ] }), e[2] = r, e[3] = s) : s = e[3], s;
}
function lR(t) {
  const e = te.c(4);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const { disabled: i } = n, r = i === void 0 ? !1 : i;
  let s;
  return e[2] !== r ? (s = /* @__PURE__ */ Z(bn, { children: [
    /* @__PURE__ */ b(aR, { disabled: r }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "f",
      action: "toggleFullscreen"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "c",
      action: "toggleSubtitles"
    }),
    /* @__PURE__ */ b(mt, {
      disabled: r,
      keys: "i",
      action: "togglePictureInPicture"
    })
  ] }), e[2] = r, e[3] = s) : s = e[3], s;
}
function cR(t) {
  const e = te.c(10);
  let n, i, r;
  e[0] !== t ? ({ children: n, className: i, ...r } = t, e[0] = t, e[1] = n, e[2] = i, e[3] = r) : (n = e[1], i = e[2], r = e[3]);
  let s;
  e[4] !== i ? (s = me("media-skin", "media-container", i), e[4] = i, e[5] = s) : s = e[5];
  let o;
  return e[6] !== n || e[7] !== r || e[8] !== s ? (o = /* @__PURE__ */ b(ub, {
    className: s,
    ...r,
    children: n
  }), e[6] = n, e[7] = r, e[8] = s, e[9] = o) : o = e[9], o;
}
function Ki(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ className: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  let r;
  e[3] !== n ? (r = me("media-button", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== i || e[6] !== r ? (s = /* @__PURE__ */ b("button", {
    className: r,
    ...i
  }), e[5] = i, e[6] = r, e[7] = s) : s = e[7], s;
}
function uR() {
  const t = te.c(3);
  let e;
  t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ b(GC, { className: "media-dialog-backdrop" }), t[0] = e) : e = t[0];
  let n;
  t[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ Z("div", {
    className: "media-dialog-content",
    children: [/* @__PURE__ */ b(EA, { className: "media-dialog-title" }), /* @__PURE__ */ b(xA, { className: "media-dialog-description" })]
  }), t[1] = n) : n = t[1];
  let i;
  return t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ Z(SA, { children: [e, /* @__PURE__ */ Z(KC, {
    className: "media-dialog-popup",
    children: [n, /* @__PURE__ */ b("div", {
      className: "media-dialog-actions",
      children: /* @__PURE__ */ b(kA, {
        render: /* @__PURE__ */ b(Ki, {}),
        className: "media-dialog-close"
      })
    })]
  })] }), t[2] = i) : i = t[2], i;
}
function dR(t) {
  const e = te.c(16);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r, s, o;
  e[2] !== n ? ({ children: i, className: r, renderImage: o, ...s } = n, e[2] = n, e[3] = i, e[4] = r, e[5] = s, e[6] = o) : (i = e[3], r = e[4], s = e[5], o = e[6]);
  let a;
  e[7] !== r ? (a = (u) => me("media-poster", lt(r, u)), e[7] = r, e[8] = a) : a = e[8];
  let l;
  e[9] !== s || e[10] !== o ? (l = /* @__PURE__ */ b(ZA, {
    render: o,
    className: "media-poster-image",
    ...s
  }), e[9] = s, e[10] = o, e[11] = l) : l = e[11];
  let c;
  return e[12] !== i || e[13] !== a || e[14] !== l ? (c = /* @__PURE__ */ Z(QA, {
    className: a,
    children: [l, i]
  }), e[12] = i, e[13] = a, e[14] = l, e[15] = c) : c = e[15], c;
}
function hR(t) {
  const e = te.c(10);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (a) => me("media-title", lt(i, a)), e[5] = i, e[6] = s) : s = e[6];
  let o;
  return e[7] !== r || e[8] !== s ? (o = /* @__PURE__ */ b(N$, {
    className: s,
    ...r
  }), e[7] = r, e[8] = s, e[9] = o) : o = e[9], o;
}
const fR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 2,
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("style", { children: "@keyframes media-spinner-fade{0%{opacity:1}to{opacity:0}}.media-spinner__segment{animation:var(--media-spinner-animation, media-spinner-fade 1s steps(8, end) infinite);animation-delay:var(--media-spinner-delay)}@media (prefers-reduced-motion:reduce){.media-spinner__segment{animation:none}}" }),
    /* @__PURE__ */ b("path", {
      d: "M9 1.5v3",
      className: "media-spinner__segment",
      opacity: 0.5,
      style: { "--media-spinner-delay": "0s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "m14.5 3.5-2 2",
      className: "media-spinner__segment",
      opacity: 0.45,
      style: { "--media-spinner-delay": "0.125s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "M16.5 9h-3",
      className: "media-spinner__segment",
      opacity: 0.4,
      style: { "--media-spinner-delay": "0.25s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "m14.5 14.5-2-2",
      className: "media-spinner__segment",
      opacity: 0.35,
      style: { "--media-spinner-delay": "0.375s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "M9 16.5v-3",
      className: "media-spinner__segment",
      opacity: 0.3,
      style: { "--media-spinner-delay": "0.5s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "m3.5 14.5 2-2",
      className: "media-spinner__segment",
      opacity: 0.25,
      style: { "--media-spinner-delay": "0.625s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "M1.5 9h3",
      className: "media-spinner__segment",
      opacity: 0.15,
      style: { "--media-spinner-delay": "0.75s" }
    }),
    /* @__PURE__ */ b("path", {
      d: "m3.5 3.5 2 2",
      className: "media-spinner__segment",
      opacity: 0.1,
      style: { "--media-spinner-delay": "0.875s" }
    })
  ]
}), Yb = se(fR);
function pR(t) {
  const e = te.c(11);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (l) => me("media-buffering-indicator", lt(i, l)), e[5] = i, e[6] = s) : s = e[6];
  let o;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b(Yb, { className: "media-buffering-indicator-spinner-icon" }), e[7] = o) : o = e[7];
  let a;
  return e[8] !== r || e[9] !== s ? (a = /* @__PURE__ */ b(aA, {
    className: s,
    ...r,
    children: o
  }), e[8] = r, e[9] = s, e[10] = a) : a = e[10], a;
}
function en(t) {
  const e = te.c(18);
  let n, i, r;
  e[0] !== t ? ({ children: n, label: i, ...r } = t, e[0] = t, e[1] = n, e[2] = i, e[3] = r) : (n = e[1], i = e[2], r = e[3]);
  let s;
  e[4] !== n ? (s = /* @__PURE__ */ b(U$, { render: n }), e[4] = n, e[5] = s) : s = e[5];
  let o;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = me("media-popup", "media-popup-safe-area", "media-popup-transition", "media-popup-surface", "media-tooltip"), e[6] = o) : o = e[6];
  let a;
  e[7] !== i ? (a = i ?? /* @__PURE__ */ b(Bb, {}), e[7] = i, e[8] = a) : a = e[8];
  let l;
  e[9] !== i ? (l = !i && /* @__PURE__ */ b(Hb, { className: "media-tooltip-shortcut" }), e[9] = i, e[10] = l) : l = e[10];
  let c;
  e[11] !== a || e[12] !== l ? (c = /* @__PURE__ */ Z(V$, {
    className: o,
    children: [a, l]
  }), e[11] = a, e[12] = l, e[13] = c) : c = e[13];
  let u;
  return e[14] !== r || e[15] !== s || e[16] !== c ? (u = /* @__PURE__ */ Z(H$, {
    ...r,
    children: [s, c]
  }), e[14] = r, e[15] = s, e[16] = c, e[17] = u) : u = e[17], u;
}
const mR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("path", { d: "M15.154 2.004A3 3 0 0 1 18 5v6a3 3 0 0 1-2.846 2.996L15 14l-1.5-1.5H15a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 15 3.5H3A1.5 1.5 0 0 0 1.5 5v6A1.5 1.5 0 0 0 3 12.5h1.5L3 14a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h12z" }), /* @__PURE__ */ b("path", { d: "M8.631 10.902a.5.5 0 0 1 .738 0l4.363 4.76a.5.5 0 0 1-.369.838H4.637a.5.5 0 0 1-.369-.838z" })]
}), gR = se(mR), vR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("style", { children: "@keyframes media-icon-airplay-triangle{0%{translate:0 0}to{translate:0-2px}}@keyframes media-icon-airplay-fill{0%{opacity:0}to{opacity:.2}}@media (prefers-reduced-motion:reduce){:root{--media-icon-airplay-fill-animation:none;--media-icon-airplay-triangle-animation:none}}" }),
    /* @__PURE__ */ b("path", {
      d: "M14.5 2A3.5 3.5 0 0 1 18 5.5v5a3.5 3.5 0 0 1-3.032 3.468L9.354 8.354a.5.5 0 0 0-.708 0l-5.615 5.614A3.5 3.5 0 0 1 0 10.5v-5A3.5 3.5 0 0 1 3.5 2z",
      style: { animation: "var(--media-icon-airplay-fill-animation, media-icon-airplay-fill 1s ease-in-out infinite alternate)" }
    }),
    /* @__PURE__ */ b("path", { d: "M14.5 2A3.5 3.5 0 0 1 18 5.5v5l-.005.18a3.5 3.5 0 0 1-3.027 3.288L13.5 12.5h1a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-11a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h1l-1.468 1.467A3.5 3.5 0 0 1 0 10.5v-5A3.5 3.5 0 0 1 3.5 2z" }),
    /* @__PURE__ */ b("path", {
      d: "M8.631 10.902a.5.5 0 0 1 .738 0l4.363 4.76a.5.5 0 0 1-.369.838H4.637a.5.5 0 0 1-.369-.838z",
      style: { animation: "var(--media-icon-airplay-triangle-animation, media-icon-airplay-triangle 1s ease-in-out infinite alternate)" }
    })
  ]
}), yR = se(vR);
function bR(t) {
  const e = te.c(13);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (u) => me("media-airplay-button", lt(i, u)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(gR, { className: me("media-button-icon", "media-airplay-button-enter-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(yR, { className: me("media-button-icon", "media-airplay-button-exit-icon") }), e[9] = l) : l = e[9];
  let c;
  return e[10] !== r || e[11] !== o ? (c = /* @__PURE__ */ Z(HC, {
    render: s,
    className: o,
    ...r,
    children: [a, l]
  }), e[10] = r, e[11] = o, e[12] = c) : c = e[12], c;
}
const _R = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("rect", {
      width: 16.5,
      height: 12.5,
      x: 0.75,
      y: 2.75,
      stroke: "currentColor",
      strokeWidth: 1.5,
      rx: 3
    }),
    /* @__PURE__ */ b("rect", {
      width: 3,
      height: 1.5,
      x: 3,
      y: 8.5,
      fill: "currentColor",
      fillOpacity: 0.5,
      rx: 0.75
    }),
    /* @__PURE__ */ b("rect", {
      width: 2,
      height: 1.5,
      x: 13,
      y: 8.5,
      fill: "currentColor",
      fillOpacity: 0.5,
      rx: 0.75
    }),
    /* @__PURE__ */ b("rect", {
      width: 4,
      height: 1.5,
      x: 11,
      y: 11.5,
      fill: "currentColor",
      fillOpacity: 0.5,
      rx: 0.75
    }),
    /* @__PURE__ */ b("rect", {
      width: 5,
      height: 1.5,
      x: 7,
      y: 8.5,
      fill: "currentColor",
      fillOpacity: 0.5,
      rx: 0.75
    }),
    /* @__PURE__ */ b("rect", {
      width: 7,
      height: 1.5,
      x: 3,
      y: 11.5,
      fill: "currentColor",
      fillOpacity: 0.5,
      rx: 0.75
    })
  ]
}), Uh = se(_R), wR = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", { d: "M15 2a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3zM3.75 11.5a.75.75 0 0 0 0 1.5h5.5a.75.75 0 0 0 0-1.5zm8 0a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5zm-8-3a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5zm4 0a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5zm6 0a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5z" })
}), Xb = se(wR);
function kR(t) {
  const e = te.c(13);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (u) => me("media-captions-button", lt(i, u)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(Uh, { className: me("media-button-icon", "media-captions-button-off-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(Xb, { className: me("media-button-icon", "media-captions-button-on-icon") }), e[9] = l) : l = e[9];
  let c;
  return e[10] !== r || e[11] !== o ? (c = /* @__PURE__ */ Z(lA, {
    render: s,
    className: o,
    ...r,
    children: [a, l]
  }), e[10] = r, e[11] = o, e[12] = c) : c = e[12], c;
}
const xR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("path", { d: "M15.154 2.004A3 3 0 0 1 18 5v8l-.004.154a3 3 0 0 1-2.842 2.842L15 16H7.5q-.002-.772-.15-1.5H15a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 15 3.5H3A1.5 1.5 0 0 0 1.5 5v3.65A7.5 7.5 0 0 0 0 8.5V5a3 3 0 0 1 3-3h12zM0 12a4 4 0 0 1 4 4H2.5A2.5 2.5 0 0 0 0 13.5z" }), /* @__PURE__ */ b("path", { d: "M0 9.5A6.5 6.5 0 0 1 6.5 16H5a5 5 0 0 0-5-5zm0 5A1.5 1.5 0 0 1 1.5 16h-1a.5.5 0 0 1-.5-.5z" })]
}), SR = se(xR), PR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("path", { d: "M15.154 2.004A3 3 0 0 1 18 5v8l-.004.154a3 3 0 0 1-2.842 2.842L15 16H7.5q-.002-.772-.15-1.5H15a1.5 1.5 0 0 0 1.5-1.5V5A1.5 1.5 0 0 0 15 3.5H3A1.5 1.5 0 0 0 1.5 5v3.65A7.5 7.5 0 0 0 0 8.5V5a3 3 0 0 1 3-3h12z" }),
    /* @__PURE__ */ b("path", { d: "M14 5a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6.874A7.52 7.52 0 0 0 3 9.126V6a1 1 0 0 1 1-1zM0 12a4 4 0 0 1 4 4H2.5A2.5 2.5 0 0 0 0 13.5z" }),
    /* @__PURE__ */ b("path", { d: "M0 9.5A6.5 6.5 0 0 1 6.5 16H5a5 5 0 0 0-5-5zm0 5A1.5 1.5 0 0 1 1.5 16h-1a.5.5 0 0 1-.5-.5z" })
  ]
}), ER = se(PR);
function TR(t) {
  const e = te.c(13);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (u) => me("media-cast-button", lt(i, u)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(SR, { className: me("media-button-icon", "media-cast-button-enter-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(ER, { className: me("media-button-icon", "media-cast-button-exit-icon") }), e[9] = l) : l = e[9];
  let c;
  return e[10] !== r || e[11] !== o ? (c = /* @__PURE__ */ Z(mA, {
    render: s,
    className: o,
    ...r,
    children: [a, l]
  }), e[10] = r, e[11] = o, e[12] = c) : c = e[12], c;
}
const CR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("path", { d: "M15.25 2a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V3.5h-3.75a.75.75 0 0 1-.743-.648L10 2.75a.75.75 0 0 1 .75-.75z" }),
    /* @__PURE__ */ b("path", { d: "M14.72 2.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06zM2.75 10a.75.75 0 0 1 .75.75v3.75h3.75a.75.75 0 0 1 .743.648L8 15.25a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75" }),
    /* @__PURE__ */ b("path", { d: "M6.72 10.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06z" })
  ]
}), Jb = se(CR), AR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("path", { d: "M10.75 2a.75.75 0 0 1 .75.75V6.5h3.75a.75.75 0 0 1 .743.648L16 7.25a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 .75-.75" }),
    /* @__PURE__ */ b("path", { d: "M14.72 2.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06zM7.25 10a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V11.5H2.75a.75.75 0 0 1-.743-.648L2 10.75a.75.75 0 0 1 .75-.75z" }),
    /* @__PURE__ */ b("path", { d: "M6.72 10.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06z" })
  ]
}), Zb = se(AR);
function $R(t) {
  const e = te.c(13);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (u) => me("media-fullscreen-button", lt(i, u)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(Jb, { className: me("media-button-icon", "media-fullscreen-button-enter-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(Zb, { className: me("media-button-icon", "media-fullscreen-button-exit-icon") }), e[9] = l) : l = e[9];
  let c;
  return e[10] !== r || e[11] !== o ? (c = /* @__PURE__ */ Z(TA, {
    render: s,
    className: o,
    ...r,
    children: [a, l]
  }), e[10] = r, e[11] = o, e[12] = c) : c = e[12], c;
}
const RR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("path", { d: "M13 2a4 4 0 0 1 4 4v2.645a3.5 3.5 0 0 0-1-.145h-.5V6A2.5 2.5 0 0 0 13 3.5H4A2.5 2.5 0 0 0 1.5 6v6A2.5 2.5 0 0 0 4 14.5h2.5v.5c0 .347.05.683.145 1H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z" }),
    /* @__PURE__ */ b("rect", {
      width: 10,
      height: 7,
      x: 8,
      y: 10,
      rx: 2
    }),
    /* @__PURE__ */ b("path", { d: "M7.25 10A.75.75 0 0 0 8 9.25v-3.5a.75.75 0 0 0-1.5 0V8.5H3.75a.75.75 0 0 0-.743.648L3 9.25c0 .414.336.75.75.75z" }),
    /* @__PURE__ */ b("path", { d: "M6.72 9.78a.75.75 0 0 0 1.06-1.06l-3.5-3.5a.75.75 0 0 0-1.06 1.06z" })
  ]
}), Qb = se(RR), MR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("path", { d: "M13 2a4 4 0 0 1 4 4v2.646a3.5 3.5 0 0 0-1-.146h-.5V6A2.5 2.5 0 0 0 13 3.5H4A2.5 2.5 0 0 0 1.5 6v6A2.5 2.5 0 0 0 4 14.5h2.5v.5q.002.523.146 1H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4z" }),
    /* @__PURE__ */ b("rect", {
      width: 10,
      height: 7,
      x: 8,
      y: 10,
      rx: 2
    }),
    /* @__PURE__ */ b("path", { d: "M3.75 5a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0V6.5h2.75a.75.75 0 0 0 .743-.648L8 5.75A.75.75 0 0 0 7.25 5z" }),
    /* @__PURE__ */ b("path", { d: "M4.28 5.22a.75.75 0 0 0-1.06 1.06l3.5 3.5a.75.75 0 0 0 1.06-1.06z" })
  ]
}), e1 = se(MR);
function OR(t) {
  const e = te.c(13);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (u) => me("media-pip-button", lt(i, u)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(Qb, { className: me("media-button-icon", "media-pip-button-enter-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(e1, { className: me("media-button-icon", "media-pip-button-exit-icon") }), e[9] = l) : l = e[9];
  let c;
  return e[10] !== r || e[11] !== o ? (c = /* @__PURE__ */ Z(jA, {
    render: s,
    className: o,
    ...r,
    children: [a, l]
  }), e[10] = r, e[11] = o, e[12] = c) : c = e[12], c;
}
const IR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("rect", {
    width: 4,
    height: 12,
    x: 3,
    y: 3,
    rx: 1.75
  }), /* @__PURE__ */ b("rect", {
    width: 4,
    height: 12,
    x: 11,
    y: 3,
    rx: 1.75
  })]
}), t1 = se(IR), DR = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", { d: "m13.473 10.476-6.845 4.256a1.697 1.697 0 0 1-2.364-.547 1.77 1.77 0 0 1-.264-.93v-8.51C4 3.78 4.768 3 5.714 3c.324 0 .64.093.914.268l6.845 4.255a1.763 1.763 0 0 1 0 2.953" })
}), i1 = se(DR), FR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("path", { d: "M9 17a8 8 0 0 1-8-8h1.5a6.5 6.5 0 1 0 1.43-4.07l1.643 1.643A.25.25 0 0 1 5.396 7H1.25A.25.25 0 0 1 1 6.75V2.604a.25.25 0 0 1 .427-.177l1.438 1.438A8 8 0 1 1 9 17" }), /* @__PURE__ */ b("path", { d: "m11.61 9.639-3.331 2.07a.826.826 0 0 1-1.15-.266.86.86 0 0 1-.129-.452V6.849C7 6.38 7.374 6 7.834 6c.158 0 .312.045.445.13l3.331 2.071a.858.858 0 0 1 0 1.438" })]
}), LR = se(FR);
function NR(t) {
  const e = te.c(14);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (d) => me("media-play-button", lt(i, d)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(LR, { className: me("media-button-icon", "media-play-button-restart-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(i1, { className: me("media-button-icon", "media-play-button-play-icon") }), e[9] = l) : l = e[9];
  let c;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ b(t1, { className: me("media-button-icon", "media-play-button-pause-icon") }), e[10] = c) : c = e[10];
  let u;
  return e[11] !== r || e[12] !== o ? (u = /* @__PURE__ */ Z(zA, {
    render: s,
    className: o,
    ...r,
    children: [
      a,
      l,
      c
    ]
  }), e[11] = r, e[12] = o, e[13] = u) : u = e[13], u;
}
function n1(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ className: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  let r;
  e[3] !== n ? (r = me("media-slider-track", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== i || e[6] !== r ? (s = /* @__PURE__ */ b("div", {
    className: r,
    ...i
  }), e[5] = i, e[6] = r, e[7] = s) : s = e[7], s;
}
function r1(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ className: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  let r;
  e[3] !== n ? (r = me("media-slider-fill", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== i || e[6] !== r ? (s = /* @__PURE__ */ b("div", {
    className: r,
    ...i
  }), e[5] = i, e[6] = r, e[7] = s) : s = e[7], s;
}
function VR(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ className: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  let r;
  e[3] !== n ? (r = me("media-slider-buffer", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== i || e[6] !== r ? (s = /* @__PURE__ */ b("div", {
    className: r,
    ...i
  }), e[5] = i, e[6] = r, e[7] = s) : s = e[7], s;
}
function s1(t) {
  const e = te.c(8);
  let n, i;
  e[0] !== t ? ({ className: n, ...i } = t, e[0] = t, e[1] = n, e[2] = i) : (n = e[1], i = e[2]);
  let r;
  e[3] !== n ? (r = me("media-slider-thumb", n), e[3] = n, e[4] = r) : r = e[4];
  let s;
  return e[5] !== i || e[6] !== r ? (s = /* @__PURE__ */ b("div", {
    className: r,
    ...i
  }), e[5] = i, e[6] = r, e[7] = s) : s = e[7], s;
}
function jR(t) {
  const e = te.c(13);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (u) => me("media-slider", "media-volume-slider", lt(i, u)), e[5] = i, e[6] = s) : s = e[6];
  let o;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b(n1, {}), e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(Vb, {
    render: o,
    children: /* @__PURE__ */ b(Lb, { render: /* @__PURE__ */ b(r1, {}) })
  }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(Nb, {
    render: /* @__PURE__ */ b(s1, {}),
    className: "media-volume-slider-thumb"
  }), e[9] = l) : l = e[9];
  let c;
  return e[10] !== r || e[11] !== s ? (c = /* @__PURE__ */ Z(rR, {
    className: s,
    thumbAlignment: "edge",
    ...r,
    children: [a, l]
  }), e[10] = r, e[11] = s, e[12] = c) : c = e[12], c;
}
const zR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("path", { d: "M15.6 3.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4C15.4 5.9 16 7.4 16 9s-.6 3.1-1.8 4.3c-.4.4-.4 1 0 1.4.2.2.5.3.7.3.3 0 .5-.1.7-.3C17.1 13.2 18 11.2 18 9s-.9-4.2-2.4-5.7" }), /* @__PURE__ */ b("path", { d: "M.714 6.008h3.072l4.071-3.857c.5-.376 1.143 0 1.143.601V15.28c0 .602-.643.903-1.143.602l-4.071-3.858H.714c-.428 0-.714-.3-.714-.752V6.76c0-.451.286-.752.714-.752m10.568.59a.91.91 0 0 1 0-1.316.91.91 0 0 1 1.316 0c1.203 1.203 1.47 2.216 1.522 3.208q.012.255.011.51c0 1.16-.358 2.733-1.533 3.803a.7.7 0 0 1-.298.156c-.382.106-.873-.011-1.018-.156a.91.91 0 0 1 0-1.316c.57-.57.995-1.551.995-2.487 0-.944-.26-1.667-.995-2.402" })]
}), o1 = se(zR), BR = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", { d: "M.714 6.008h3.072l4.071-3.857c.5-.376 1.143 0 1.143.601V15.28c0 .602-.643.903-1.143.602l-4.071-3.858H.714c-.428 0-.714-.3-.714-.752V6.76c0-.451.286-.752.714-.752m10.568.59a.91.91 0 0 1 0-1.316.91.91 0 0 1 1.316 0c1.203 1.203 1.47 2.216 1.522 3.208q.012.255.011.51c0 1.16-.358 2.733-1.533 3.803a.7.7 0 0 1-.298.156c-.382.106-.873-.011-1.018-.156a.91.91 0 0 1 0-1.316c.57-.57.995-1.551.995-2.487 0-.944-.26-1.667-.995-2.402" })
}), a1 = se(BR), HR = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", { d: "M.714 6.008h3.072l4.071-3.857c.5-.376 1.143 0 1.143.601V15.28c0 .602-.643.903-1.143.602l-4.071-3.858H.714c-.428 0-.714-.3-.714-.752V6.76c0-.451.286-.752.714-.752M14.5 7.586l-1.768-1.768a1 1 0 1 0-1.414 1.414L13.085 9l-1.767 1.768a1 1 0 0 0 1.414 1.414l1.768-1.768 1.768 1.768a1 1 0 0 0 1.414-1.414L15.914 9l1.768-1.768a1 1 0 0 0-1.414-1.414z" })
}), l1 = se(HR);
function UR(t) {
  const e = te.c(14);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(Ki, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = (d) => me("media-mute-button", lt(i, d)), e[6] = i, e[7] = o) : o = e[7];
  let a;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(l1, { className: me("media-button-icon", "media-mute-button-off-icon") }), e[8] = a) : a = e[8];
  let l;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(a1, { className: me("media-button-icon", "media-mute-button-low-icon") }), e[9] = l) : l = e[9];
  let c;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ b(o1, { className: me("media-button-icon", "media-mute-button-high-icon") }), e[10] = c) : c = e[10];
  let u;
  return e[11] !== r || e[12] !== o ? (u = /* @__PURE__ */ Z(VA, {
    render: s,
    className: o,
    ...r,
    children: [
      a,
      l,
      c
    ]
  }), e[11] = r, e[12] = o, e[13] = u) : u = e[13], u;
}
function WR(t) {
  const e = te.c(23);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r, s, o, a;
  e[2] !== n ? ({ className: i, showTooltip: s, side: o, orientation: a, ...r } = n, e[2] = n, e[3] = i, e[4] = r, e[5] = s, e[6] = o, e[7] = a) : (i = e[3], r = e[4], s = e[5], o = e[6], a = e[7]);
  const l = s === void 0 ? !1 : s, c = o === void 0 ? "top" : o, u = a === void 0 ? "vertical" : a, d = !l;
  let h;
  e[8] !== i ? (h = me(i), e[8] = i, e[9] = h) : h = e[9];
  let f;
  e[10] !== h ? (f = /* @__PURE__ */ b(iR, { render: /* @__PURE__ */ b(UR, { className: h }) }), e[10] = h, e[11] = f) : f = e[11];
  let p;
  e[12] !== d || e[13] !== f ? (p = /* @__PURE__ */ b(en, {
    delay: 0,
    disabled: d,
    sticky: !0,
    side: "top",
    children: f
  }), e[12] = d, e[13] = f, e[14] = p) : p = e[14];
  let v;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = me("media-popup", "media-popup-safe-area", "media-popup-transition", "media-popup-surface", "media-volume-popover"), e[15] = v) : v = e[15];
  let g;
  e[16] !== u ? (g = /* @__PURE__ */ b(Z$, {
    className: v,
    children: /* @__PURE__ */ b(jR, { orientation: u })
  }), e[16] = u, e[17] = g) : g = e[17];
  let m;
  return e[18] !== r || e[19] !== c || e[20] !== g || e[21] !== p ? (m = /* @__PURE__ */ Z(eR, {
    openOnHover: !0,
    delay: 200,
    closeDelay: 100,
    side: c,
    ...r,
    children: [p, g]
  }), e[18] = r, e[19] = c, e[20] = g, e[21] = p, e[22] = m) : m = e[22], m;
}
function qR(t) {
  const e = te.c(25);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r, s, o;
  e[2] !== n ? ({ className: i, previewOverflow: o, renderThumbnail: s, ...r } = n, e[2] = n, e[3] = i, e[4] = r, e[5] = s, e[6] = o) : (i = e[3], r = e[4], s = e[5], o = e[6]);
  const a = o === void 0 ? "visible" : o;
  let l;
  e[7] !== i ? (l = (y) => me("media-slider", "media-time-slider", lt(i, y)), e[7] = i, e[8] = l) : l = e[8];
  let c;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ b(O$, {
    className: "media-time-slider-chapters",
    renderChapter: GR
  }), e[9] = c) : c = e[9];
  let u;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ b(Nb, {
    render: /* @__PURE__ */ b(s1, {}),
    className: "media-time-slider-thumb"
  }), e[10] = u) : u = e[10];
  let d;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = me("media-slider-preview-content", "media-popup-surface", "media-slider-thumbnail"), e[11] = d) : d = e[11];
  let h;
  e[12] !== s ? (h = /* @__PURE__ */ b(v$, {
    render: s,
    className: "media-slider-thumbnail-image"
  }), e[12] = s, e[13] = h) : h = e[13];
  let f;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ b(Yb, { className: "media-slider-thumbnail-spinner-icon" }), e[14] = f) : f = e[14];
  let p;
  e[15] !== h ? (p = /* @__PURE__ */ Z(k$, {
    className: d,
    children: [h, f]
  }), e[15] = h, e[16] = p) : p = e[16];
  let v;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ Z("div", {
    className: me("media-slider-preview-content", "media-time-slider-preview-content"),
    children: [/* @__PURE__ */ b(R$, { className: "media-time-slider-chapter-title" }), /* @__PURE__ */ b(x$, {
      className: "media-time-slider-value",
      type: "pointer"
    })]
  }), e[17] = v) : v = e[17];
  let g;
  e[18] !== a || e[19] !== p ? (g = /* @__PURE__ */ Z(w$, {
    className: "media-slider-preview",
    overflow: a,
    children: [p, v]
  }), e[18] = a, e[19] = p, e[20] = g) : g = e[20];
  let m;
  return e[21] !== r || e[22] !== g || e[23] !== l ? (m = /* @__PURE__ */ Z(F$, {
    className: l,
    ...r,
    children: [
      c,
      u,
      g
    ]
  }), e[21] = r, e[22] = g, e[23] = l, e[24] = m) : m = e[24], m;
}
function GR(t) {
  return /* @__PURE__ */ b("div", {
    className: "media-time-slider-chapter",
    ...t,
    children: /* @__PURE__ */ Z(Vb, {
      render: /* @__PURE__ */ b(n1, {}),
      className: "media-time-slider-chapter-track",
      children: [/* @__PURE__ */ b(_$, {
        render: /* @__PURE__ */ b(VR, {}),
        className: "media-time-slider-chapter-layer"
      }), /* @__PURE__ */ b(Lb, {
        render: /* @__PURE__ */ b(r1, {}),
        className: "media-time-slider-chapter-layer"
      })]
    })
  });
}
const KR = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("path", {
    fillOpacity: 0.2,
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M6 12.75a4.25 4.25 0 0 1 3.835 2.417c.008.016.005.017.006.009 0-.006.001-.003-.007.009a.2.2 0 0 1-.158.065H2.324a.2.2 0 0 1-.158-.065c-.009-.012-.007-.015-.006-.01 0 .01-.003.008.005-.008a4.25 4.25 0 0 1 3.521-2.405zm0-6a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5Z"
  }), /* @__PURE__ */ b("path", { d: "M14 2a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1.333L10.8 8.4A.5.5 0 0 1 10 8V6.73A2 2 0 0 1 9 5V4a2 2 0 0 1 2-2zm-2.75 1.5a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75h2.5a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75z" })]
}), YR = se(KR), XR = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M11.667 9.014 6.364 3.711m0 10.606 5.303-5.303"
  })
}), c1 = se(XR);
function mn(t) {
  const e = te.c(7);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const { back: i, className: r } = n, s = i !== void 0 && i ? "media-menu-back-chevron" : "media-menu-forward-chevron";
  let o;
  e[2] !== r || e[3] !== s ? (o = me(s, r), e[2] = r, e[3] = s, e[4] = o) : o = e[4];
  let a;
  return e[5] !== o ? (a = /* @__PURE__ */ b(c1, { className: o }), e[5] = o, e[6] = a) : a = e[6], a;
}
const JR = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 10.455 6.5 13 14 5"
  })
}), ZR = se(JR);
function Ul(t) {
  const e = te.c(11);
  let n, i, r;
  e[0] !== t ? ({ children: n, className: i, ...r } = t, e[0] = t, e[1] = n, e[2] = i, e[3] = r) : (n = e[1], i = e[2], r = e[3]);
  let s;
  e[4] !== i ? (s = (l) => me("media-menu-radio-item", lt(i, l)), e[4] = i, e[5] = s) : s = e[5];
  let o;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b(RA, {
    forceMount: !0,
    className: "media-menu-item-indicator",
    children: /* @__PURE__ */ b(ZR, { className: "media-menu-radio-item-icon" })
  }), e[6] = o) : o = e[6];
  let a;
  return e[7] !== n || e[8] !== r || e[9] !== s ? (a = /* @__PURE__ */ Z(DA, {
    className: s,
    ...r,
    children: [n, o]
  }), e[7] = n, e[8] = r, e[9] = s, e[10] = a) : a = e[10], a;
}
function QR(t) {
  const e = te.c(10);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i;
  e[2] !== n ? ({ ...i } = n, e[2] = n, e[3] = i) : i = e[3];
  let r, s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(YR, { className: "media-menu-trigger-item-icon" }), s = /* @__PURE__ */ b(wi, {
    token: _r.key,
    children: _r.text
  }), e[4] = r, e[5] = s) : (r = e[4], s = e[5]);
  let o;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z(xo, {
    className: "media-menu-trigger-item",
    children: [
      r,
      s,
      /* @__PURE__ */ Z("span", {
        className: "media-menu-hint",
        children: [/* @__PURE__ */ b(rA, { className: "media-menu-hint-label" }), /* @__PURE__ */ b(mn, {})]
      })
    ]
  }), e[6] = o) : o = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ Z(nA, { children: [o, /* @__PURE__ */ Z(wo, {
    className: "media-menu-content",
    children: [
      /* @__PURE__ */ Z(zl, {
        className: "media-menu-back-item",
        children: [/* @__PURE__ */ b(mn, { back: !0 }), /* @__PURE__ */ b(wi, {
          token: _r.key,
          children: _r.text
        })]
      }),
      /* @__PURE__ */ b(Bl, { className: "media-menu-separator" }),
      /* @__PURE__ */ b(sA, {
        className: "media-menu-radio-group",
        renderItem: eM
      })
    ]
  })] }), e[7] = a) : a = e[7];
  let l;
  return e[8] !== i ? (l = /* @__PURE__ */ b(ko, {
    ...i,
    children: a
  }), e[8] = i, e[9] = l) : l = e[9], l;
}
function eM(t, e) {
  return /* @__PURE__ */ b(Ul, {
    ...t,
    children: /* @__PURE__ */ b("span", { children: e.label })
  });
}
function tM(t) {
  const e = te.c(10);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i;
  e[2] !== n ? ({ ...i } = n, e[2] = n, e[3] = i) : i = e[3];
  let r, s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(Uh, { className: "media-menu-trigger-item-icon" }), s = /* @__PURE__ */ b(wi, {
    token: wr.key,
    children: wr.text
  }), e[4] = r, e[5] = s) : (r = e[4], s = e[5]);
  let o;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z(xo, {
    className: "media-menu-trigger-item",
    children: [
      r,
      s,
      /* @__PURE__ */ Z("span", {
        className: "media-menu-hint",
        children: [/* @__PURE__ */ b(hA, { className: "media-menu-hint-label" }), /* @__PURE__ */ b(mn, {})]
      })
    ]
  }), e[6] = o) : o = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ Z(dA, { children: [o, /* @__PURE__ */ Z(wo, {
    className: "media-menu-content",
    children: [
      /* @__PURE__ */ Z(zl, {
        className: "media-menu-back-item",
        children: [/* @__PURE__ */ b(mn, { back: !0 }), /* @__PURE__ */ b(wi, {
          token: wr.key,
          children: wr.text
        })]
      }),
      /* @__PURE__ */ b(Bl, { className: "media-menu-separator" }),
      /* @__PURE__ */ b(fA, {
        className: "media-menu-radio-group",
        renderItem: iM
      })
    ]
  })] }), e[7] = a) : a = e[7];
  let l;
  return e[8] !== i ? (l = /* @__PURE__ */ b(ko, {
    ...i,
    children: a
  }), e[8] = i, e[9] = l) : l = e[9], l;
}
function iM(t, e) {
  return /* @__PURE__ */ b(Ul, {
    ...t,
    children: /* @__PURE__ */ b("span", { children: e.label })
  });
}
const nM = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [
    /* @__PURE__ */ b("path", { d: "M9 18q-.213 0-.424-.012h.85Q9.214 18 9 18M9 2a8 8 0 0 1 8 8c0 1.975-.719 3.78-1.905 5.175a.75.75 0 0 1-1.204.018l-1.509-1.971a.75.75 0 0 1 .596-1.206h2.202a6.5 6.5 0 1 0-12.36 0h2.209a.75.75 0 0 1 .595 1.206l-1.507 1.971a.75.75 0 0 1-1.133.07l-.003.004A8 8 0 0 1 9 2" }),
    /* @__PURE__ */ b("rect", {
      width: 6,
      height: 1.5,
      x: 6,
      y: 14,
      fillOpacity: 0.5,
      rx: 0.75
    }),
    /* @__PURE__ */ b("path", { d: "M8.504 5.217c.077-.578.915-.578.992 0l.399 2.996A1.998 1.998 0 0 1 9 12a2 2 0 0 1-.896-3.787z" }),
    /* @__PURE__ */ Z("g", {
      fillOpacity: 0.5,
      children: [
        /* @__PURE__ */ b("circle", {
          cx: 4.75,
          cy: 9.75,
          r: 0.75
        }),
        /* @__PURE__ */ b("circle", {
          cx: 13.25,
          cy: 9.75,
          r: 0.75
        }),
        /* @__PURE__ */ b("circle", {
          cx: 6,
          cy: 6.75,
          r: 0.75
        }),
        /* @__PURE__ */ b("circle", {
          cx: 12,
          cy: 6.75,
          r: 0.75
        })
      ]
    })
  ]
}), rM = se(nM);
function sM(t) {
  const e = te.c(10);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i;
  e[2] !== n ? ({ ...i } = n, e[2] = n, e[3] = i) : i = e[3];
  let r, s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(rM, { className: "media-menu-trigger-item-icon" }), s = /* @__PURE__ */ b(wi, {
    token: No.key,
    children: No.text
  }), e[4] = r, e[5] = s) : (r = e[4], s = e[5]);
  let o;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z(xo, {
    className: "media-menu-trigger-item",
    children: [
      r,
      s,
      /* @__PURE__ */ Z("span", {
        className: "media-menu-hint",
        children: [/* @__PURE__ */ b(WA, { className: "media-menu-hint-label" }), /* @__PURE__ */ b(mn, {})]
      })
    ]
  }), e[6] = o) : o = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ Z(UA, { children: [o, /* @__PURE__ */ Z(wo, {
    className: "media-menu-content",
    children: [
      /* @__PURE__ */ Z(zl, {
        className: "media-menu-back-item",
        children: [/* @__PURE__ */ b(mn, { back: !0 }), /* @__PURE__ */ b(wi, {
          token: No.key,
          children: No.text
        })]
      }),
      /* @__PURE__ */ b(Bl, { className: "media-menu-separator" }),
      /* @__PURE__ */ b(qA, {
        className: "media-menu-radio-group",
        renderItem: oM
      })
    ]
  })] }), e[7] = a) : a = e[7];
  let l;
  return e[8] !== i ? (l = /* @__PURE__ */ b(ko, {
    ...i,
    children: a
  }), e[8] = i, e[9] = l) : l = e[9], l;
}
function oM(t, e) {
  return /* @__PURE__ */ b(Ul, {
    ...t,
    children: /* @__PURE__ */ b("span", { children: e.label })
  });
}
const aM = (t, e) => /* @__PURE__ */ Z("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: [/* @__PURE__ */ b("path", { d: "M12.5 9.5a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7zm-2 1.5a2 2 0 1 0 0 4h2a2 2 0 1 0 0-4z" }), /* @__PURE__ */ b("path", {
    fillOpacity: 0.5,
    d: "M12.5 1.5a3.5 3.5 0 1 1 0 7h-7a3.5 3.5 0 1 1 0-7zM5.5 3a2 2 0 1 0 0 4h2a2 2 0 1 0 0-4z"
  })]
}), lM = se(aM);
function cM(t) {
  const e = te.c(10);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i;
  e[2] !== n ? ({ ...i } = n, e[2] = n, e[3] = i) : i = e[3];
  let r, s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(lM, { className: "media-menu-trigger-item-icon" }), s = /* @__PURE__ */ b(wi, {
    token: br.key,
    children: br.text
  }), e[4] = r, e[5] = s) : (r = e[4], s = e[5]);
  let o;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z(xo, {
    className: "media-menu-trigger-item",
    children: [
      r,
      s,
      /* @__PURE__ */ Z("span", {
        className: "media-menu-hint",
        children: [/* @__PURE__ */ b(r$, { className: "media-menu-hint-label" }), /* @__PURE__ */ b(mn, {})]
      })
    ]
  }), e[6] = o) : o = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ Z(n$, { children: [o, /* @__PURE__ */ Z(wo, {
    className: "media-menu-content",
    children: [
      /* @__PURE__ */ Z(zl, {
        className: "media-menu-back-item",
        children: [/* @__PURE__ */ b(mn, { back: !0 }), /* @__PURE__ */ b(wi, {
          token: br.key,
          children: br.text
        })]
      }),
      /* @__PURE__ */ b(Bl, { className: "media-menu-separator" }),
      /* @__PURE__ */ b(s$, {
        className: "media-menu-radio-group",
        renderItem: uM
      })
    ]
  })] }), e[7] = a) : a = e[7];
  let l;
  return e[8] !== i ? (l = /* @__PURE__ */ b(ko, {
    ...i,
    children: a
  }), e[8] = i, e[9] = l) : l = e[9], l;
}
function uM(t, e) {
  return /* @__PURE__ */ Z(Ul, {
    ...t,
    children: [/* @__PURE__ */ Z("span", { children: [/* @__PURE__ */ b("span", { children: e.label }), e.tier ? /* @__PURE__ */ b("sup", {
      className: "media-menu-tier",
      children: e.tier
    }) : null] }), e.badge ? /* @__PURE__ */ b("span", {
      className: "media-menu-badge",
      children: e.badge
    }) : null]
  });
}
const dM = (t, e) => /* @__PURE__ */ b("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "currentColor",
  "aria-hidden": "true",
  viewBox: "0 0 18 18",
  ref: e,
  ...t,
  children: /* @__PURE__ */ b("path", { d: "M7.519 2.184c.356-1.579 2.605-1.579 2.962 0a1.52 1.52 0 0 0 2.292.949c1.368-.864 2.958.727 2.094 2.095-.56.886-.073 2.06.95 2.29 1.578.357 1.578 2.607 0 2.964a1.518 1.518 0 0 0-.95 2.29c.864 1.369-.726 2.96-2.094 2.095a1.52 1.52 0 0 0-2.292.95c-.357 1.578-2.606 1.578-2.962 0a1.518 1.518 0 0 0-2.291-.95c-1.368.864-2.959-.726-2.095-2.094.56-.887.074-2.06-.95-2.291-1.578-.357-1.578-2.607 0-2.963a1.518 1.518 0 0 0 .95-2.291c-.864-1.368.727-2.959 2.095-2.095.886.56 2.06.074 2.29-.95M9 5.1a3.9 3.9 0 1 0 0 7.8 3.9 3.9 0 0 0 0-7.8" })
}), hM = se(dM);
function fM(t) {
  const e = te.c(19);
  let n, i, r;
  e[0] !== t ? ({ children: n, className: i, ...r } = t, e[0] = t, e[1] = n, e[2] = i, e[3] = r) : (n = e[1], i = e[2], r = e[3]);
  let s;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(wi, {
    token: Lo.key,
    children: Lo.text
  }), e[4] = s) : s = e[4];
  let o;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b(Ki, {}), e[5] = o) : o = e[5];
  let a;
  e[6] !== i ? (a = (p) => me("media-settings-menu-trigger", lt(i, p)), e[6] = i, e[7] = a) : a = e[7];
  let l, c;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ b(hM, { className: me("media-button-icon-base", "media-settings-menu-trigger-icon") }), c = /* @__PURE__ */ b(wi, {
    className: "media-settings-menu-trigger-label",
    token: Lo.key,
    children: Lo.text
  }), e[8] = l, e[9] = c) : (l = e[8], c = e[9]);
  let u;
  e[10] !== a ? (u = /* @__PURE__ */ b(en, {
    label: s,
    side: "top",
    children: /* @__PURE__ */ Z(xo, {
      render: o,
      className: a,
      children: [l, c]
    })
  }), e[10] = a, e[11] = u) : u = e[11];
  let d;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = me("media-popup", "media-popup-surface", "media-menu-popup", "media-menu-resizable-popup"), e[12] = d) : d = e[12];
  let h;
  e[13] !== n ? (h = /* @__PURE__ */ b(IA, {
    keepMounted: !0,
    className: d,
    children: /* @__PURE__ */ b(wo, {
      className: "media-menu-content",
      children: n
    })
  }), e[13] = n, e[14] = h) : h = e[14];
  let f;
  return e[15] !== r || e[16] !== u || e[17] !== h ? (f = /* @__PURE__ */ Z(ko, {
    side: "top",
    align: "center",
    ...r,
    children: [u, h]
  }), e[15] = r, e[16] = u, e[17] = h, e[18] = f) : f = e[18], f;
}
function pM(t) {
  const e = te.c(8);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const i = n;
  let r, s, o, a;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(cM, {}), s = /* @__PURE__ */ b(QR, {}), o = /* @__PURE__ */ b(sM, {}), a = /* @__PURE__ */ b(tM, {}), e[2] = r, e[3] = s, e[4] = o, e[5] = a) : (r = e[2], s = e[3], o = e[4], a = e[5]);
  let l;
  return e[6] !== i ? (l = /* @__PURE__ */ Z(fM, {
    ...i,
    children: [
      r,
      s,
      o,
      a
    ]
  }), e[6] = i, e[7] = l) : l = e[7], l;
}
function mM(t) {
  const e = te.c(16);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  const { renderThumbnail: i } = n;
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ b(vA, { className: "video-controls-backdrop" }), e[2] = r) : r = e[2];
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = me("video-controls", "video-controls-content", "video-controls-wrap"), e[3] = s) : s = e[3];
  let o;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z(Yo, {
    className: "video-controls-start",
    children: [/* @__PURE__ */ b(en, {
      side: "top",
      children: /* @__PURE__ */ b(NR, {})
    }), /* @__PURE__ */ b(WR, {
      showTooltip: !0,
      side: "right",
      orientation: "horizontal"
    })]
  }), e[4] = o) : o = e[4];
  let a;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ Z(A$, {
    className: "media-time-group",
    children: [
      /* @__PURE__ */ b(Zp, {
        className: me("media-time-toggle", "media-time-current-value"),
        type: "current",
        toggle: !0
      }),
      /* @__PURE__ */ b($$, { className: "media-time-separator" }),
      /* @__PURE__ */ b(Zp, {
        className: "media-time-duration-value",
        type: "duration"
      })
    ]
  }), e[5] = a) : a = e[5];
  let l;
  e[6] !== i ? (l = /* @__PURE__ */ Z(Yo, {
    className: "video-time-slider-group",
    children: [a, /* @__PURE__ */ b(qR, {
      previewOverflow: "clamp",
      renderThumbnail: i
    })]
  }), e[6] = i, e[7] = l) : l = e[7];
  let c, u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ b(en, {
    side: "top",
    children: /* @__PURE__ */ b(kR, { className: "video-controls-captions-button" })
  }), u = /* @__PURE__ */ b(pM, {}), e[8] = c, e[9] = u) : (c = e[8], u = e[9]);
  let d;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ b(en, {
    side: "top",
    children: /* @__PURE__ */ b(TR, {})
  }), e[10] = d) : d = e[10];
  let h;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = /* @__PURE__ */ b(en, {
    side: "top",
    children: /* @__PURE__ */ b(bR, {})
  }), e[11] = h) : h = e[11];
  let f;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ b(en, {
    side: "top",
    children: /* @__PURE__ */ b(OR, {})
  }), e[12] = f) : f = e[12];
  let p;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ Z(Yo, {
    className: "video-controls-end",
    children: [
      c,
      u,
      /* @__PURE__ */ Z(Yo, {
        className: "video-controls-trailing",
        children: [
          d,
          h,
          f,
          /* @__PURE__ */ b(en, {
            side: "top",
            children: /* @__PURE__ */ b($R, {})
          })
        ]
      })
    ]
  }), e[13] = p) : p = e[13];
  let v;
  return e[14] !== l ? (v = /* @__PURE__ */ Z(bA, { children: [r, /* @__PURE__ */ b(yA, {
    className: s,
    children: /* @__PURE__ */ Z(B$, { children: [
      o,
      l,
      p
    ] })
  })] }), e[14] = l, e[15] = v) : v = e[15], v;
}
function gM(t) {
  const e = te.c(10);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (a) => me("media-status-announcer", lt(i, a)), e[5] = i, e[6] = s) : s = e[6];
  let o;
  return e[7] !== r || e[8] !== s ? (o = /* @__PURE__ */ b(S$, {
    className: s,
    ...r
  }), e[7] = r, e[8] = s, e[9] = o) : o = e[9], o;
}
function vM(t) {
  const e = te.c(12);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (c) => me("media-seek-indicator", lt(i, c)), e[5] = i, e[6] = s) : s = e[6];
  let o, a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b(c1, { className: "media-seek-indicator-icon" }), a = /* @__PURE__ */ b(p$, { className: "media-seek-indicator-value" }), e[7] = o, e[8] = a) : (o = e[7], a = e[8]);
  let l;
  return e[9] !== r || e[10] !== s ? (l = /* @__PURE__ */ Z(h$, {
    className: s,
    ...r,
    children: [o, a]
  }), e[9] = r, e[10] = s, e[11] = l) : l = e[11], l;
}
const yM = [
  "toggleSubtitles",
  "toggleFullscreen",
  "togglePictureInPicture"
], bM = ["togglePaused"];
function _M(t) {
  const e = te.c(11);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (l) => me("media-indicator", "media-status-indicator", lt(i, l)), e[5] = i, e[6] = s) : s = e[6];
  let o;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z("div", {
    className: me("media-indicator-content", "media-status-indicator-content"),
    children: [
      /* @__PURE__ */ b(Xb, { className: "media-status-indicator-captions-on-icon" }),
      /* @__PURE__ */ b(Uh, { className: "media-status-indicator-captions-off-icon" }),
      /* @__PURE__ */ b(Jb, { className: "media-status-indicator-fullscreen-enter-icon" }),
      /* @__PURE__ */ b(Zb, { className: "media-status-indicator-fullscreen-exit-icon" }),
      /* @__PURE__ */ b(Qb, { className: "media-status-indicator-pip-enter-icon" }),
      /* @__PURE__ */ b(e1, { className: "media-status-indicator-pip-exit-icon" }),
      /* @__PURE__ */ b(C$, { className: "media-status-indicator-value" })
    ]
  }), e[7] = o) : o = e[7];
  let a;
  return e[8] !== r || e[9] !== s ? (a = /* @__PURE__ */ b(zb, {
    actions: yM,
    className: s,
    ...r,
    children: o
  }), e[8] = r, e[9] = s, e[10] = a) : a = e[10], a;
}
function wM(t) {
  const e = te.c(12);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (c) => me("media-playback-status-indicator", lt(i, c)), e[5] = i, e[6] = s) : s = e[6];
  let o, a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ b(i1, { className: "media-playback-status-indicator-play-icon" }), a = /* @__PURE__ */ b(t1, { className: "media-playback-status-indicator-pause-icon" }), e[7] = o, e[8] = a) : (o = e[7], a = e[8]);
  let l;
  return e[9] !== r || e[10] !== s ? (l = /* @__PURE__ */ Z(zb, {
    actions: bM,
    className: s,
    ...r,
    children: [o, a]
  }), e[9] = r, e[10] = s, e[11] = l) : l = e[11], l;
}
function kM(t) {
  const e = te.c(11);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] !== i ? (s = (l) => me("media-indicator", "media-volume-indicator", lt(i, l)), e[5] = i, e[6] = s) : s = e[6];
  let o;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ Z(q$, {
    className: me("media-indicator-content", "media-volume-indicator-fill"),
    children: [
      /* @__PURE__ */ b(o1, { className: "media-volume-indicator-high-icon" }),
      /* @__PURE__ */ b(a1, { className: "media-volume-indicator-low-icon" }),
      /* @__PURE__ */ b(l1, { className: "media-volume-indicator-off-icon" }),
      /* @__PURE__ */ b(X$, { className: "media-volume-indicator-value" })
    ]
  }), e[7] = o) : o = e[7];
  let a;
  return e[8] !== r || e[9] !== s ? (a = /* @__PURE__ */ b(K$, {
    className: s,
    ...r,
    children: o
  }), e[8] = r, e[9] = s, e[10] = a) : a = e[10], a;
}
function xM(t) {
  const e = te.c(15);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r;
  e[2] !== n ? ({ className: i, ...r } = n, e[2] = n, e[3] = i, e[4] = r) : (i = e[3], r = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ b(gM, {}), e[5] = s) : s = e[5];
  let o;
  e[6] !== i ? (o = me("video-status-indicators", i), e[6] = i, e[7] = o) : o = e[7];
  let a, l, c, u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ b(kM, {}), l = /* @__PURE__ */ b(_M, {}), c = /* @__PURE__ */ b(vM, {}), u = /* @__PURE__ */ b(wM, {}), e[8] = a, e[9] = l, e[10] = c, e[11] = u) : (a = e[8], l = e[9], c = e[10], u = e[11]);
  let d;
  return e[12] !== r || e[13] !== o ? (d = /* @__PURE__ */ Z(bn, { children: [s, /* @__PURE__ */ Z("div", {
    className: o,
    ...r,
    children: [
      a,
      l,
      c,
      u
    ]
  })] }), e[12] = r, e[13] = o, e[14] = d) : d = e[14], d;
}
function SM(t) {
  const e = te.c(26);
  let n;
  e[0] !== t ? (n = t === void 0 ? {} : t, e[0] = t, e[1] = n) : n = e[1];
  let i, r, s, o, a;
  e[2] !== n ? ({ children: i, className: r, renderPoster: o, renderThumbnail: a, ...s } = n, e[2] = n, e[3] = i, e[4] = r, e[5] = s, e[6] = o, e[7] = a) : (i = e[3], r = e[4], s = e[5], o = e[6], a = e[7]);
  let l;
  e[8] !== r ? (l = me("video-skin", r), e[8] = r, e[9] = l) : l = e[9];
  let c;
  e[10] !== o ? (c = /* @__PURE__ */ b(dR, { renderImage: o }), e[10] = o, e[11] = c) : c = e[11];
  let u, d, h;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ b(pR, {}), d = /* @__PURE__ */ b(uR, {}), h = /* @__PURE__ */ b(hR, {}), e[12] = u, e[13] = d, e[14] = h) : (u = e[12], d = e[13], h = e[14]);
  let f;
  e[15] !== a ? (f = /* @__PURE__ */ b(mM, { renderThumbnail: a }), e[15] = a, e[16] = f) : f = e[16];
  let p, v, g;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ b(lR, {}), g = /* @__PURE__ */ b(oR, {}), p = /* @__PURE__ */ b(xM, {}), e[17] = p, e[18] = v, e[19] = g) : (p = e[17], v = e[18], g = e[19]);
  let m;
  return e[20] !== i || e[21] !== s || e[22] !== l || e[23] !== c || e[24] !== f ? (m = /* @__PURE__ */ Z(cR, {
    className: l,
    "data-theme": "neutral",
    "data-preset": "video",
    ...s,
    children: [
      i,
      c,
      u,
      d,
      h,
      f,
      v,
      g,
      p
    ]
  }), e[20] = i, e[21] = s, e[22] = l, e[23] = c, e[24] = f, e[25] = m) : m = e[25], m;
}
function PM(t) {
  const e = te.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ b(SM, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
const tt = fC({ features: k5 }), Po = () => tt.useMedia(), EM = '@layer base.theme{.media-skin[data-theme=neutral]{--media-control-corner-shape: squircle;--media-control-radius: calc(var(--media-spacing) * 2);--media-control-size: calc(var(--media-spacing) * 9);--media-controls-radius: calc(var(--media-spacing) * 3);--media-popover: oklch(0% 0 0 / .5);--media-border: oklch(100% 0 0 / .1);--media-shadow-surface: 0 1px 2px oklch(0% 0 0 / .2);--media-shadow-thumb: 0 0 0 1px #00000026, 0 1px 3px 0 #00000026, 0 1px 2px -1px #00000026;--media-text-shadow-dialog: 0 1px 0 #00000080;--media-backdrop-filter-dialog: blur(16px) saturate(120%);--media-shadow-tooltip: 0 0 0 1px var(--media-border), 0 4px 6px -1px oklch(0% 0 0 / .2), 0 2px 4px -2px oklch(0% 0 0 / .2);--media-duration-dialog: var(--media-duration);--media-duration-indicator: .4s;--media-hidden-offset: 100%;--media-hidden-indicator-offset: -100%;--media-menu-item-radius: calc(var(--media-spacing) * 1.5);--media-popover-boundary-offset: calc(var(--media-spacing) * 2);--media-popover-side-offset: calc(var(--media-spacing) * 5);--media-popup-radius: calc(var(--media-spacing) * 2.5);--media-popup-translate-distance: calc(var(--media-spacing) * 2);--media-dialog-width: 100%;--media-dialog-max-width: calc(var(--media-spacing) * 64);--media-slider-preview-label-offset: calc(var(--media-spacing) * 5);--media-video-border-radius: var(--media-border-radius, 12px)}.media-skin{--media-background: oklch(0% 0 0);--media-foreground: oklch(100% 0 0);--media-controls: oklch(0% 0 0 / .35);--media-controls-foreground: var(--media-foreground);--media-popover: oklch(100% 0 0 / .1);--media-popover-foreground: var(--media-foreground);--media-primary: var(--media-accent-color, var(--media-default-accent-color));--media-primary-foreground: var(--media-accent-text-color, var(--media-default-accent-text-color));--media-accent: var(--media-accent-color, color-mix(in oklab, var(--media-default-accent-color) 10%, transparent));--media-accent-foreground: var(--media-accent-text-color, currentColor);--media-muted: oklch(100% 0 0 / .15);--media-muted-foreground: oklch(100% 0 0 / .65);--media-border: oklch(0% 0 0 / .1);--media-ring: oklch(100% 0 0);--media-backdrop: oklch(0% 0 0);--media-live-color: oklch(65% .22 27);--media-shadow-surface: 0 1px 3px 0 oklch(0% 0 0 / .15), 0 1px 2px -1px oklch(0% 0 0 / .15);--media-shadow-surface-inset: inset 0 1px 0 0 #ffffff1a, inset 0 0 0 1px #ffffff0d;--media-shadow-thumb: 0 0 0 1px #0000001a, 0 1px 3px 0 #00000059, 0 1px 2px -1px #00000059;--media-shadow-tooltip: 0 0 0 1px var(--media-border), var(--media-shadow-surface);--media-shadow-separator: 0 1px 0 0 oklch(100% 0 0 / .075);--media-shadow-current-color: oklch(from currentColor 0 0 0 / clamp(0, calc((l - .5)/2) , .15));--media-shadow-subtle-current-color: color-mix(in oklab, var(--media-shadow-current-color) 40%, transparent);--media-text-shadow-dialog: 0 1px 0 #00000040;--media-backdrop-filter-surface: blur(16px) saturate(110%);--media-backdrop-filter-indicator: blur(8px);--media-backdrop-filter-dialog: blur(16px) saturate(110%);--media-control-corner-shape: round;--media-control-radius: 99px;--media-control-size: calc(var(--media-spacing) * 9);--media-controls-radius: var(--media-control-radius);--media-default-accent-color: oklch(100% 0 0);--media-default-accent-text-color: oklch(0% 0 0);--media-duration-instant: 50ms;--media-duration-fast: .1s;--media-duration: .15s;--media-duration-slow: .2s;--media-duration-slower: .25s;--media-duration-controls: .1s;--media-duration-dialog: .35s;--media-duration-indicator: var(--media-duration-slower);--media-duration-menu: .25s;--media-duration-slider: var(--media-duration-fast);--media-delay-dialog: .1s;--media-hidden-scale: .95;--media-hidden-blur: 8px;--media-hidden-offset: calc(var(--media-spacing) * 1);--media-hidden-icon-scale: 0;--media-hidden-indicator-scale: .9;--media-hidden-indicator-offset: -25%;--media-hidden-playback-scale: .85;--media-hidden-popup-scale: .95;--media-hidden-popup-blur: 4px;--media-hidden-preview-scale: .8;--media-hidden-preview-offset: calc(var(--media-spacing) * 2);--media-hidden-seek-offset: 60%;--media-menu-item-radius: calc(var(--media-spacing) * 2);--media-popover-boundary-offset: calc(var(--media-spacing) * 3);--media-popover-side-offset: calc(var(--media-spacing) * 3);--media-popup-radius: calc(var(--media-spacing) * 3);--media-popup-translate-distance: calc(var(--media-spacing) * 2);--media-tooltip-boundary-offset: var(--media-popover-boundary-offset);--media-tooltip-side-offset: var(--media-popover-side-offset);--media-dialog-radius: calc(var(--media-spacing) * 7);--media-dialog-width: calc(100% - var(--media-spacing) * 6);--media-dialog-max-width: calc(var(--media-spacing) * 72);--media-slider-preview-label-offset: calc(var(--media-spacing) * 10.5);--media-video-border-radius: var(--media-border-radius, 28px);--media-scale: 1;--media-scrollbar-thumb-color: color-mix(in oklab, currentColor 30%, transparent);--media-spacing: calc(var(--media-scale-unit, 16px) * var(--media-scale) / 4);scrollbar-color:var(--media-scrollbar-thumb-color) transparent;scrollbar-width:thin}@supports (color: contrast-color(red)){.media-skin{--media-primary-foreground: var(--media-accent-text-color, contrast-color(var(--media-primary)));--media-accent-foreground: var(--media-accent-text-color, contrast-color(var(--media-accent-color, var(--media-internal-accent-text-fallback, oklch(0% 0 0)))))}}@supports (color: oklch(from red l c h)){.media-skin{--media-shadow-subtle-current-color: oklch(from var(--media-shadow-current-color) l c h / calc(alpha*.4) )}}@supports (color: oklch(from currentColor l c h)){.media-skin{--media-scrollbar-thumb-color: oklch(from currentColor l c h / .3)}}.media-skin::-webkit-scrollbar-thumb{background:var(--media-scrollbar-thumb-color);border-radius:9999px}.media-skin:fullscreen{--media-object-fit: contain;--media-video-border-radius: 0}@media(min-width:1280px){.media-skin:fullscreen{--media-scale: 1.25}}@media(min-width:1536px){.media-skin:fullscreen{--media-scale: 1.5}}@media(min-width:1920px){.media-skin:fullscreen{--media-scale: 1.75}}}@layer base.preset{.media-skin:is([data-preset=video],[data-preset=live-video]){--media-frame-border: var(--media-border-color, #0000001a);--media-controls-gradient: linear-gradient(to top, color-mix(in oklab, var(--media-backdrop) 40%, transparent), color-mix(in oklab, var(--media-backdrop) 20%, transparent), color-mix(in oklab, var(--media-backdrop) 50%, transparent));--media-caption-controls-y: calc(var(--media-spacing) * -14);--media-slider-preview-offset: calc(var(--media-spacing) * 9);--media-thumbnail-gradient: linear-gradient(to top, color-mix(in oklab, var(--media-backdrop) 50%, transparent), color-mix(in oklab, var(--media-backdrop) 10%, transparent), transparent)}@supports (color: oklch(from red l c h)) and (background-image: linear-gradient(in oklab,red,red)){.media-skin:is([data-preset=video],[data-preset=live-video]){--media-controls-gradient: linear-gradient(to top in oklab, oklch(from var(--media-backdrop) l c h / .4), oklch(from var(--media-backdrop) l c h / .2), oklch(from var(--media-backdrop) l c h / .5))}}@supports (color: oklch(from red l c h)){.media-skin:is([data-preset=video],[data-preset=live-video]){--media-thumbnail-gradient: linear-gradient(to top, oklch(from var(--media-backdrop) l c h / .5), oklch(from var(--media-backdrop) l c h / .1), transparent)}}.media-skin:is([data-preset=video],[data-preset=live-video])[data-theme=neutral]{--media-frame-border: var(--media-border-color, #00000026);--media-controls-gradient: linear-gradient(to top, color-mix(in oklab, var(--media-backdrop) 50%, transparent), color-mix(in oklab, var(--media-backdrop) 20%, transparent));--media-indicator-gradient: linear-gradient(to bottom, color-mix(in oklab, var(--media-backdrop) 35%, transparent), color-mix(in oklab, var(--media-backdrop) 20%, transparent) calc(var(--media-spacing) * 12), transparent);--media-caption-controls-y: calc(var(--media-spacing) * -18);--media-slider-preview-offset: calc(var(--media-spacing) * 11)}@supports (color: oklch(from red l c h)) and (background-image: linear-gradient(in oklab,red,red)){.media-skin:is([data-preset=video],[data-preset=live-video])[data-theme=neutral]{--media-controls-gradient: linear-gradient(to top in oklab, oklch(from var(--media-backdrop) l c h / .5), oklch(from var(--media-backdrop) l c h / .2))}}@supports (color: oklch(from red l c h)){.media-skin:is([data-preset=video],[data-preset=live-video])[data-theme=neutral]{--media-indicator-gradient: linear-gradient(to bottom, oklch(from var(--media-backdrop) l c h / .35), oklch(from var(--media-backdrop) l c h / .2) calc(var(--media-spacing) * 12), transparent)}}@supports (color: light-dark(red,red)){.media-skin:is([data-preset=video],[data-preset=live-video]){--media-frame-border: var(--media-border-color, light-dark(#0000001a, #ffffff26))}.media-skin:is([data-preset=video],[data-preset=live-video])[data-theme=neutral]{--media-frame-border: var(--media-border-color, light-dark(#00000026, #ffffff26))}}}@layer base.preferences{@media(pointer:fine)and (prefers-reduced-motion:no-preference){.media-skin:not([data-controls-visible]){--media-duration-controls: .3s}}@media(pointer:coarse)and (prefers-reduced-motion:no-preference){.media-skin:not([data-controls-visible]){--media-duration-controls: .15s}}@media(prefers-reduced-motion:reduce){.media-skin{--media-duration-fast: var(--media-duration-instant);--media-duration: var(--media-duration-instant);--media-duration-slow: var(--media-duration-instant);--media-duration-slower: var(--media-duration-instant);--media-duration-controls: var(--media-duration-instant);--media-duration-dialog: var(--media-duration-instant);--media-duration-indicator: var(--media-duration-instant);--media-duration-menu: 0s;--media-duration-slider: 0s;--media-delay-dialog: 0s;--media-hidden-scale: 1;--media-hidden-blur: 0px;--media-hidden-offset: 0px;--media-hidden-icon-scale: 1;--media-hidden-indicator-scale: 1;--media-hidden-indicator-offset: 0px;--media-hidden-playback-scale: 1;--media-hidden-popup-scale: 1;--media-hidden-popup-blur: 0px;--media-hidden-preview-scale: 1;--media-hidden-preview-offset: 0px;--media-hidden-seek-offset: 0px;--media-popup-translate-distance: 0px;--media-spinner-animation: none;--media-icon-airplay-fill-animation: none;--media-icon-airplay-triangle-animation: none}}@media(prefers-reduced-transparency:reduce),(prefers-contrast:more){.media-skin{--media-popover: var(--media-background);--media-scrollbar-thumb-color: color-mix(in oklab, currentColor 80%, transparent);--media-backdrop-filter-surface: none;--media-backdrop-filter-indicator: none;--media-backdrop-filter-dialog: none;--media-shadow-surface-inset: inset 0 1px 0 0 #ffffff40, inset 0 0 0 1px #ffffff20;scrollbar-width:auto}@supports (color: oklch(from currentColor l c h)){.media-skin{--media-scrollbar-thumb-color: oklch(from currentColor l c h / .8)}}}@media(forced-colors:active){.media-skin{--media-border: CanvasText;--media-frame-border: CanvasText;--media-popover: Canvas;--media-popover-foreground: CanvasText;--media-ring: CanvasText;--media-shadow-surface-inset: inset 0 1px 0 0 CanvasText, inset 0 0 0 1px CanvasText}}}@layer base{:where(.media-skin){text-align:start;text-transform:none;letter-spacing:normal;font-style:normal;font-weight:400}:where(.media-skin),:where(.media-skin) *,:where(.media-skin) :before,:where(.media-skin) :after{box-sizing:border-box;border:0 solid;margin:0;padding:0}:where(.media-skin) button{font:inherit;color:inherit;text-transform:none;letter-spacing:inherit;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:none}:where(.media-skin) img,:where(.media-skin) svg,:where(.media-skin) media-icon{max-width:100%;display:block}:where(.media-skin) svg[fill=currentColor]{fill:currentColor}:where(.media-skin) svg[fill=none]{fill:none}:where(.media-skin) svg[stroke=currentColor]{stroke:currentColor}:where(.media-skin) video{border-radius:inherit;-o-object-fit:var(--media-object-fit, contain);object-fit:var(--media-object-fit, contain);-o-object-position:var(--media-object-position, center);object-position:var(--media-object-position, center);width:100%;max-width:100%;height:100%;display:block}:where(.media-skin) media-icon>svg{width:100%;height:100%}:where(.media-skin) media-tooltip-group,:where(.media-skin) media-dialog,:where(.media-skin) media-alert-dialog,:where(.media-skin) media-error-dialog,:where(.media-skin) media-controls{display:contents}:where(.media-skin) [hidden][hidden]{display:none!important}@media(prefers-reduced-motion:no-preference){.media-skin{interpolate-size:allow-keywords}}@supports not selector(:popover-open){:where(.media-skin) [popover]:not([data-open],[data-ending-style]){display:none!important}.media-skin:is([data-preset=audio],[data-preset=live-audio]){overflow:visible!important}}}@layer components{:where(.media-skin){--media-caption-track-duration: var(--media-duration-controls);--media-caption-track-delay: 25ms;--media-caption-track-y: calc(var(--media-spacing) * -2)}:where(.media-skin) video::-webkit-media-text-track-container{z-index:20;scale:.98;translate:0 var(--media-caption-track-y);-webkit-transition:translate var(--media-caption-track-duration) ease-out;transition:translate var(--media-caption-track-duration) ease-out;transition-delay:var(--media-caption-track-delay);font-family:inherit}:where(.media-skin)[data-controls-visible]{--media-caption-track-y: var(--media-caption-controls-y)}:where(.media-skin)[data-theme=compat] video::-webkit-media-text-track-container{translate:none;scale:none;transform:translateY(var(--media-caption-track-y, 0px)) scale(.98);-webkit-transition-property:transform;transition-property:transform}@container media-root (width >= 42rem){:where(.media-skin)[data-theme=neutral][data-controls-visible] video{--media-caption-track-y: calc(var(--media-spacing) * -12)}}:where(.media-skin[data-theme=neutral]) .media-button{width:var(--media-control-size);height:var(--media-control-size);cursor:pointer;touch-action:manipulation;border-radius:var(--media-control-radius);text-align:center;min-height:0;color:inherit;outline-offset:-2px;transition-property:background-color,color,outline-offset,scale;transition-duration:var(--media-duration);will-change:scale;-webkit-user-select:none;-moz-user-select:none;user-select:none;corner-shape:var(--media-control-corner-shape);background-color:#0000;border-style:solid;border-width:0;outline:2px solid #0000;flex-shrink:0;place-items:center;padding:0;transition-timing-function:cubic-bezier(0,0,.2,1);display:grid}@media(hover:hover){:where(.media-skin[data-theme=neutral]) .media-button:not([aria-disabled=true]):hover{background-color:var(--media-accent);color:var(--media-accent-foreground)}}:where(.media-skin[data-theme=neutral]) .media-button:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(.media-skin[data-theme=neutral]) .media-button:not([aria-disabled=true]):active{scale:.97}:where(.media-skin[data-theme=neutral]) .media-button[aria-disabled=true]{cursor:not-allowed;opacity:.5}@supports (corner-shape: squircle){:where(.media-skin[data-theme=neutral]) .media-button{border-radius:1rem}}@media(prefers-reduced-motion:reduce){:where(.media-skin[data-theme=neutral]) .media-button{will-change:auto;transition-property:background-color,color;scale:1}}:where(.media-skin[data-theme=neutral]) .media-button:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){background-color:var(--media-accent);color:var(--media-accent-foreground)}:where(.media-skin[data-theme=neutral]) .media-dialog-actions{gap:calc(var(--media-spacing) * 2);flex-shrink:0;display:flex}:where(.media-skin[data-theme=neutral]) .media-dialog-backdrop{z-index:40;border-radius:inherit;background-color:var(--media-backdrop);opacity:1;-webkit-backdrop-filter:var(--media-backdrop-filter-dialog);backdrop-filter:var(--media-backdrop-filter-dialog);transition-property:opacity;transition-duration:.15s;transition-delay:var(--media-delay-dialog);transition-duration:var(--media-duration-dialog);transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;inset:0}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-dialog-backdrop{background-color:color-mix(in oklab,var(--media-backdrop) 20%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-dialog-backdrop:not([data-open]){display:none}:where(.media-skin[data-theme=neutral]) .media-dialog-backdrop[data-ending-style]{transition-delay:0s;transition-duration:var(--media-duration-instant)}:where(.media-skin[data-theme=neutral]) .media-dialog-backdrop:is([data-starting-style],[data-ending-style]){opacity:0}:where(.media-skin[data-theme=neutral]) .media-dialog-close{height:var(--media-control-size);width:100%;padding-inline:calc(var(--media-spacing) * 4);padding-block:calc(var(--media-spacing) * 2);flex:1;font-weight:500;background-color:var(--media-primary)!important;color:var(--media-primary-foreground)!important}:where(.media-skin[data-theme=neutral]) .media-dialog-content{gap:calc(var(--media-spacing) * 2);min-height:0;padding-block:calc(var(--media-spacing) * 1.5);flex-direction:column;display:flex;overflow-y:auto}:where(.media-skin[data-theme=neutral]) .media-dialog-description{overflow-wrap:anywhere;opacity:.7;margin:0}:where(.media-skin[data-theme=neutral]) .media-dialog-popup{z-index:50;max-height:calc(100% - .5rem);width:var(--media-dialog-width);max-width:var(--media-dialog-max-width);gap:calc(var(--media-spacing) * 3);border-radius:var(--media-dialog-radius);padding:calc(var(--media-spacing) * 4);color:var(--media-popover-foreground);transition-property:opacity,scale;transition-duration:.15s;transition-delay:var(--media-delay-dialog);transition-duration:var(--media-duration-dialog);text-shadow:var(--media-text-shadow-dialog);outline-style:none;flex-direction:column;transition-timing-function:cubic-bezier(0,0,.2,1);display:flex;position:absolute;top:50%;left:50%;translate:-50% -50%}@media(forced-colors:active){:where(.media-skin[data-theme=neutral]) .media-dialog-popup{outline-offset:2px;outline:2px solid #0000}}:where(.media-skin[data-theme=neutral]) .media-dialog-popup:not([data-open]){display:none}:where(.media-skin[data-theme=neutral]) .media-dialog-popup[data-ending-style]{transition-delay:0s;transition-duration:var(--media-duration-instant)}:where(.media-skin[data-theme=neutral]) .media-dialog-popup:is([data-starting-style],[data-ending-style]){scale:var(--media-hidden-popup-scale) var(--media-hidden-popup-scale);opacity:0}:where(.media-skin[data-theme=neutral]) .media-dialog-title{font-size:calc(var(--media-spacing) * 3.75);margin:0;font-weight:600;line-height:1.25}:where(.media-skin[data-theme=neutral]) .media-buffering-indicator{pointer-events:none;color:var(--media-controls-foreground);place-content:center;display:none;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-buffering-indicator:not([data-visible]){--media-spinner-animation: none}:where(.media-skin[data-theme=neutral]) .media-buffering-indicator:before{background-color:var(--media-backdrop);content:"";-webkit-backdrop-filter:var(--media-backdrop-filter-indicator);backdrop-filter:var(--media-backdrop-filter-indicator);position:absolute;inset:0}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-buffering-indicator:before{background-color:color-mix(in oklab,var(--media-backdrop) 35%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-buffering-indicator[data-visible]{display:grid}:where(.media-skin[data-theme=neutral]) .media-buffering-indicator-spinner-icon{z-index:30;width:var(--media-icon-size, calc(var(--media-spacing) * 4.5));height:var(--media-icon-size, calc(var(--media-spacing) * 4.5));filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));position:relative}:where(.media-skin[data-theme=neutral]) .media-poster{pointer-events:none;border-radius:inherit;width:100%;height:100%;transition-property:opacity;transition-duration:.15s;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:var(--media-duration-slower);position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-poster:not([data-visible]){opacity:0}:where(.media-skin[data-theme=neutral]) .media-poster-image{border-radius:inherit;-o-object-fit:var(--media-object-fit, contain);object-fit:var(--media-object-fit, contain);-o-object-position:var(--media-object-position, center);object-position:var(--media-object-position, center);width:100%;height:100%;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-poster-image:not([src]):not([srcset]){visibility:hidden}:where(.media-skin[data-theme=neutral]) .media-title{pointer-events:none;isolation:isolate;z-index:20;transform-origin:top;padding-inline:calc(var(--media-spacing) * 4);padding-top:calc(var(--media-spacing) * 2.5);font-size:calc(var(--media-spacing) * 3.25);letter-spacing:-.0125em;overflow-wrap:anywhere;color:var(--media-controls-foreground);transition-property:filter,opacity,translate;transition-duration:.15s;transition-duration:calc(var(--media-duration-controls) / 2);text-shadow:0 1px 0 var(--media-shadow-current-color);inset-inline:0;font-weight:400;transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;top:0}:where(.media-skin[data-theme=neutral]) .media-title:not([data-visible]){translate:0 calc(min(var(--media-hidden-offset),var(--media-control-size))*-1);opacity:0;transition-duration:var(--media-duration-controls)}@media(pointer:fine){:where(.media-skin[data-theme=neutral]) .media-title:not([data-visible]){filter:blur(var(--media-hidden-blur))}}@container media-root (width >= 28rem){:where(.media-skin[data-theme=neutral]) .media-title{padding-inline:calc(var(--media-spacing) * 6);padding-top:calc(var(--media-spacing) * 4);font-size:calc(var(--media-spacing) * 4.25)}}:where(.media-skin[data-theme=neutral]) .media-container,:where(.media-skin[data-theme=neutral]).media-container{isolation:isolate;border-radius:var(--media-video-border-radius);background-color:var(--media-background);width:100%;height:100%;font-family:var(--media-font-family, "Inter Variable", Inter, ui-sans-serif, system-ui, sans-serif);font-size:calc(var(--media-spacing) * 3.25);-webkit-font-smoothing:auto;-moz-osx-font-smoothing:auto;outline-offset:-4px;transition-property:outline-offset,outline-color;transition-duration:.15s;transition-duration:var(--media-duration-fast);--spacing: var(--media-spacing);outline:2px solid #0000;line-height:1.5;transition-timing-function:cubic-bezier(0,0,.2,1);display:block;position:relative;overflow:clip;container:media-root / inline-size}:where(.media-skin[data-theme=neutral]) .media-container:after,:where(.media-skin[data-theme=neutral]).media-container:after{pointer-events:none;z-index:10;border-radius:inherit;content:"";border-style:solid;border-width:1px;border-color:var(--media-frame-border);position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-container:focus-visible,:where(.media-skin[data-theme=neutral]).media-container:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(.media-skin[data-theme=neutral]) .media-container:fullscreen:after,:where(.media-skin[data-theme=neutral]).media-container:fullscreen:after{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-status-announcer{clip-path:inset(50%);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}:where(.media-skin[data-theme=neutral]) .media-seek-indicator{place-content:center;gap:var(--media-spacing);padding:calc(var(--media-spacing) * 4);text-align:center;grid-row-start:1;grid-column-start:2;display:grid}:where(.media-skin[data-theme=neutral]) .media-seek-indicator[data-direction=backward]{grid-column-start:1;justify-self:flex-start}:where(.media-skin[data-theme=neutral]) .media-seek-indicator[data-direction=forward]{grid-column-start:3;justify-self:flex-end}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral]) .media-seek-indicator{padding:calc(var(--media-spacing) * 6)}}:where(.media-skin[data-theme=neutral]) .media-seek-indicator-icon{width:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 1.5);height:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 1.5);transition-property:translate,opacity;transition-duration:.15s;transition-duration:var(--media-duration-slow);transition-timing-function:cubic-bezier(.4,0,.2,1);display:none}:where(:where(.media-skin[data-theme=neutral]) .media-seek-indicator)[data-direction] .media-seek-indicator-icon{display:block}:where(:where(.media-skin[data-theme=neutral]) .media-seek-indicator)[data-direction=backward] .media-seek-indicator-icon{scale:-1 1}:where(:where(.media-skin[data-theme=neutral]) .media-seek-indicator)[data-direction=backward][data-starting-style] .media-seek-indicator-icon{translate:var(--media-hidden-seek-offset) 0}:where(:where(.media-skin[data-theme=neutral]) .media-seek-indicator)[data-direction=forward][data-starting-style] .media-seek-indicator-icon{translate:calc(var(--media-hidden-seek-offset) * -1) 0}:where(:where(.media-skin[data-theme=neutral]) .media-seek-indicator):is([data-starting-style],[data-ending-style]) .media-seek-indicator-icon{opacity:0}:where(.media-skin[data-theme=neutral]) .media-seek-indicator-value{font-variant-numeric:tabular-nums}:where(.media-skin[data-theme=neutral]) .media-indicator{pointer-events:none;transform-origin:top;background-image:var(--media-indicator-gradient);padding-top:calc(var(--media-spacing) * 3);padding-bottom:calc(var(--media-spacing) * 32);color:inherit;transition-duration:var(--media-duration-fast);text-shadow:0 1px 0 var(--media-shadow-current-color);inset-inline:0;justify-content:center;transition-timing-function:cubic-bezier(0,0,.2,1);display:flex;position:absolute;top:0}:where(.media-skin[data-theme=neutral]) .media-indicator[data-ending-style]{translate:0 var(--media-hidden-indicator-offset)}@media(pointer:coarse){:where(.media-skin[data-theme=neutral]) .media-indicator{will-change:translate,opacity;transition-property:translate,opacity}}@media(pointer:fine){:where(.media-skin[data-theme=neutral]) .media-indicator{will-change:translate,filter,opacity;transition-property:translate,filter,opacity}}:where(.media-skin[data-theme=neutral]) .media-indicator:is([data-starting-style],[data-ending-style]){opacity:0;transition-duration:var(--media-duration-indicator);transition-timing-function:cubic-bezier(.4,0,1,1)}@media(pointer:fine){:where(.media-skin[data-theme=neutral]) .media-indicator:is([data-starting-style],[data-ending-style]){filter:blur(var(--media-hidden-blur))}}:where(.media-skin[data-theme=neutral]) .media-indicator-content{justify-content:space-between;align-items:center;gap:calc(var(--media-spacing) * 2);padding-inline:calc(var(--media-spacing) * 2.5);padding-block:var(--media-spacing)}@media(prefers-reduced-transparency:reduce),(prefers-contrast:more){:where(.media-skin[data-theme=neutral]) .media-indicator-content{border-radius:var(--media-control-radius);background-color:var(--media-background)}}:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator{padding:calc(var(--media-spacing) * 4);text-align:center;transition-property:opacity,scale;transition-duration:.15s;transition-duration:var(--media-duration-slow);grid-row-start:1;grid-column-start:2;place-content:center;transition-timing-function:cubic-bezier(0,0,.2,1);display:grid}:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator[data-ending-style]{transition-duration:var(--media-duration-fast);transition-timing-function:cubic-bezier(.4,0,1,1)}:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator:is([data-starting-style],[data-ending-style]){scale:var(--media-hidden-playback-scale) var(--media-hidden-playback-scale);opacity:0}:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator-pause-icon{width:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);height:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);scale:var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);opacity:0;transition-property:opacity,scale;transition-duration:.15s;transition-duration:var(--media-duration);grid-row-start:1;grid-column-start:1;transition-timing-function:cubic-bezier(0,0,.2,1)}:where(:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator)[data-status=pause] .media-playback-status-indicator-pause-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator-play-icon{width:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);height:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 2);scale:var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);opacity:0;transition-property:opacity,scale;transition-duration:.15s;transition-duration:var(--media-duration);grid-row-start:1;grid-column-start:1;transition-timing-function:cubic-bezier(0,0,.2,1)}:where(:where(.media-skin[data-theme=neutral]) .media-playback-status-indicator)[data-status=play] .media-playback-status-indicator-play-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-status-indicator-captions-off-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-status-indicator)[data-status=captions-off] .media-status-indicator-captions-off-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-status-indicator-captions-on-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-status-indicator)[data-status=captions-on] .media-status-indicator-captions-on-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-status-indicator-content{display:flex}:where(.media-skin[data-theme=neutral]) .media-status-indicator-fullscreen-enter-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-status-indicator)[data-status=fullscreen] .media-status-indicator-fullscreen-enter-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-status-indicator-fullscreen-exit-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-status-indicator)[data-status=exit-fullscreen] .media-status-indicator-fullscreen-exit-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-status-indicator-pip-enter-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-status-indicator)[data-status=pip] .media-status-indicator-pip-enter-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-status-indicator-pip-exit-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-status-indicator)[data-status=exit-pip] .media-status-indicator-pip-exit-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-status-indicator-value{margin-left:auto}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-fill{border-radius:inherit;grid-template-columns:auto minmax(0,1fr) auto;width:min(80%,14rem);display:grid;transform:translate(0)}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-fill:before{height:calc(var(--media-spacing) * .75);content:"";width:100%;box-shadow:0 0 #0000,0 0 #0000,0 0 #0000,0 0 #0000,0 1px 0 var(--media-shadow-subtle-current-color);background-color:currentColor;border-radius:9999px;grid-row-start:1;grid-column-start:2}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-volume-indicator-fill:before{background-color:color-mix(in oklab,currentcolor 20%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-fill:after{height:calc(var(--media-spacing) * .75);width:var(--media-volume-fill, 0%);background-color:var(--media-primary);transition-property:width;transition-duration:.15s;transition-duration:var(--media-duration-slow);content:"";border-radius:9999px;grid-row-start:1;grid-column-start:2;justify-self:flex-start;transition-timing-function:linear}@media(prefers-reduced-motion:no-preference){:where(:where(.media-skin[data-theme=neutral]) .media-volume-indicator):is([data-min],[data-max]):not([data-starting-style],[data-ending-style]) .media-volume-indicator-fill{transition:transform .3s linear(0,-24 20%,16 40%,-8 60%,4 80%,1);transform:translate(.25px)}}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-high-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;grid-row-start:1;grid-column-start:1;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-volume-indicator)[data-level=high] .media-volume-indicator-high-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-low-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;grid-row-start:1;grid-column-start:1;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-volume-indicator)[data-level=low] .media-volume-indicator-low-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-off-icon{filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;grid-row-start:1;grid-column-start:1;display:none}:where(:where(.media-skin[data-theme=neutral]) .media-volume-indicator)[data-level=off] .media-volume-indicator-off-icon{display:block}:where(.media-skin[data-theme=neutral]) .media-volume-indicator-value{grid-row-start:1;grid-column-start:3}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-status-indicators{pointer-events:none;z-index:20;color:var(--media-controls-foreground);grid-template-columns:repeat(3,minmax(0,1fr));place-items:center;display:grid;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-airplay-button:not([data-airplay-state=connected]){--media-icon-airplay-fill-animation: none;--media-icon-airplay-triangle-animation: none}:where(.media-skin[data-theme=neutral]) .media-airplay-button-enter-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-airplay-button):not([data-airplay-state=connected]) .media-airplay-button-enter-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-airplay-button-exit-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-airplay-button)[data-airplay-state=connected] .media-airplay-button-exit-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-button-icon{width:var(--media-icon-size, calc(var(--media-spacing) * 4.5));height:var(--media-icon-size, calc(var(--media-spacing) * 4.5));filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));transition-property:opacity,scale;transition-duration:.15s;transition-duration:var(--media-duration);text-shadow:inherit;grid-row-start:1;grid-column-start:1;transition-timing-function:cubic-bezier(0,0,.2,1)}:where(.media-skin[data-theme=neutral]) .media-popup{color:inherit;border-style:solid;border-width:0;margin:0;overflow:visible}:where(.media-skin[data-theme=neutral]) .media-popup[data-ending-style]{transform:none}:where(.media-skin[data-theme=neutral]) .media-popup[data-starting-style]{transform:translate(var(--media-popup-translate-x-distance, 0),var(--media-popup-translate-y-distance, 0));filter:none}:where(.media-skin[data-theme=neutral]) .media-popup[data-side=bottom]{transform-origin:top;--media-popup-translate-y-distance: calc(var(--media-popup-translate-distance) * -1)}:where(.media-skin[data-theme=neutral]) .media-popup[data-side=left]{transform-origin:100%;--media-popup-translate-x-distance: var(--media-popup-translate-distance)}:where(.media-skin[data-theme=neutral]) .media-popup[data-side=right]{transform-origin:0;--media-popup-translate-x-distance: calc(var(--media-popup-translate-distance) * -1)}:where(.media-skin[data-theme=neutral]) .media-popup[data-side=top]{transform-origin:bottom;--media-popup-translate-y-distance: var(--media-popup-translate-distance)}:where(.media-skin[data-theme=neutral]) .media-popup:is([data-starting-style],[data-ending-style]){scale:var(--media-hidden-popup-scale) var(--media-hidden-popup-scale);opacity:0;filter:blur(var(--media-hidden-popup-blur))}:where(.media-skin[data-theme=neutral]) .media-popup-safe-area:before{pointer-events:auto;content:"";position:absolute}:where(.media-skin[data-theme=neutral]) .media-popup-safe-area[data-side=bottom]:before{content:"";height:var(--media-popup-side-offset);inset-inline:0;bottom:100%}:where(.media-skin[data-theme=neutral]) .media-popup-safe-area[data-side=left]:before{content:"";width:var(--media-popup-side-offset);inset-block:0;left:100%}:where(.media-skin[data-theme=neutral]) .media-popup-safe-area[data-side=right]:before{content:"";width:var(--media-popup-side-offset);inset-block:0;right:100%}:where(.media-skin[data-theme=neutral]) .media-popup-safe-area[data-side=top]:before{content:"";height:var(--media-popup-side-offset);inset-inline:0;top:100%}:where(.media-skin[data-theme=neutral]) .media-popup-transition{transition-property:opacity,filter,transform,scale;transition-duration:var(--media-duration-fast);transition-timing-function:cubic-bezier(0,0,.2,1)}:where(.media-skin[data-theme=neutral]) .media-popup-transition[data-ending-style]{transition-duration:var(--media-duration-instant)}:where(.media-skin[data-theme=neutral]) .media-tooltip{border-radius:var(--media-control-radius);padding-inline:calc(var(--media-spacing) * 2);padding-block:var(--media-spacing);font-size:calc(var(--media-spacing) * 3.25);white-space:nowrap;--media-popup-side-offset: var(--media-tooltip-side-offset);box-shadow:0 0 #0000,0 0 #0000,0 0 #0000,0 0 #0000,var(--media-shadow-tooltip)!important}:where(.media-skin[data-theme=neutral]) .media-tooltip[data-open]{align-items:center;gap:var(--media-spacing);display:flex}:where(.media-skin[data-theme=neutral]) .media-tooltip-shortcut{border-radius:var(--media-spacing);background-color:var(--media-muted);text-align:center;min-width:1.5em;font-family:inherit;font-size:calc(var(--media-spacing) * 2.75);margin-inline-end:calc(var(--media-spacing) * -1);padding:.1em;font-weight:600;line-height:1.25}:where(.media-skin[data-theme=neutral]) .media-popup-surface{background-color:var(--media-popover);color:var(--media-popover-foreground);box-shadow:0 0 0 1px var(--media-surface-border, var(--media-border)),var(--media-shadow-surface);-webkit-backdrop-filter:var(--media-backdrop-filter-surface);backdrop-filter:var(--media-backdrop-filter-surface)}:where(.media-skin[data-theme=neutral]) .media-popup-surface:after{z-index:10;pointer-events:none;border-radius:inherit;box-shadow:var(--media-shadow-surface-inset);content:"";display:none;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-captions-button-off-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-captions-button):not([data-active]) .media-captions-button-off-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-captions-button-on-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-captions-button)[data-active] .media-captions-button-on-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-cast-button-enter-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-cast-button):not([data-cast-state=connected]) .media-cast-button-enter-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-cast-button-exit-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-cast-button)[data-cast-state=connected] .media-cast-button-exit-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-fullscreen-button-enter-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-fullscreen-button):not([data-fullscreen]) .media-fullscreen-button-enter-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-fullscreen-button-exit-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-fullscreen-button)[data-fullscreen] .media-fullscreen-button-exit-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-pip-button-enter-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-pip-button):not([data-pip]) .media-pip-button-enter-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-pip-button-exit-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-pip-button)[data-pip] .media-pip-button-exit-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-play-button-pause-icon{scale:var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-play-button)[data-started]:not([data-paused]):not([data-ended]) .media-play-button-pause-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-play-button-play-icon{scale:var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-play-button):not([data-ended]):not([data-started]) .media-play-button-play-icon,:where(:where(.media-skin[data-theme=neutral]) .media-play-button):not([data-ended])[data-paused] .media-play-button-play-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-play-button-restart-icon{scale:var(--media-hidden-icon-scale) var(--media-hidden-icon-scale);opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-play-button)[data-ended] .media-play-button-restart-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-mute-button-high-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-mute-button):not([data-muted]):not([data-volume-level=low]) .media-mute-button-high-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-mute-button-low-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-mute-button):not([data-muted])[data-volume-level=low] .media-mute-button-low-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-mute-button-off-icon{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-mute-button)[data-muted] .media-mute-button-off-icon{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-slider-buffer{pointer-events:none;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-slider-buffer:before{border-radius:var(--media-control-radius);content:"";background-color:currentColor;width:100%;height:100%;position:absolute}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-slider-buffer:before{background-color:color-mix(in oklab,currentcolor 20%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-slider-buffer[data-orientation=horizontal]{left:calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));right:max(calc(100% - var(--media-slider-buffer, 0%)),calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0)));clip-path:inset(-1px 0)}:where(.media-skin[data-theme=neutral]) .media-slider-buffer[data-orientation=horizontal]:before{content:"";min-width:var(--media-spacing);left:0}:where(.media-skin[data-theme=neutral]) .media-slider-buffer[data-orientation=vertical]{bottom:calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));top:max(calc(100% - var(--media-slider-buffer, 0%)),calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0)));clip-path:inset(0 -1px)}:where(.media-skin[data-theme=neutral]) .media-slider-buffer[data-orientation=vertical]:before{content:"";min-height:var(--media-spacing);bottom:0}:where(.media-skin[data-theme=neutral]) .media-slider-fill{pointer-events:none;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-slider-fill:before{border-radius:var(--media-control-radius);content:"";background-color:var(--media-primary);width:100%;height:100%;position:absolute}:where(.media-skin[data-theme=neutral]) .media-slider-fill[data-orientation=horizontal]{left:calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));right:max(calc(100% - var(--media-slider-fill, 0%)),calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0)));clip-path:inset(-1px 0)}:where(:where(.media-skin[data-theme=neutral]) .media-slider)[data-dragging] .media-slider-fill[data-orientation=horizontal]{left:calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));right:max(calc(100% - var(--media-slider-pointer, 0%)),calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0)));clip-path:inset(-1px 0)}:where(.media-skin[data-theme=neutral]) .media-slider-fill[data-orientation=horizontal]:before{content:"";min-width:var(--media-spacing);left:0}:where(.media-skin[data-theme=neutral]) .media-slider-fill[data-orientation=vertical]{bottom:calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));top:max(calc(100% - var(--media-slider-fill, 0%)),calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0)));clip-path:inset(0 -1px)}:where(:where(.media-skin[data-theme=neutral]) .media-slider)[data-dragging] .media-slider-fill[data-orientation=vertical]{bottom:calc(var(--media-slider-chapter-start, 0%) + var(--media-spacing) * var(--media-chapter-inset-start, 0));top:max(calc(100% - var(--media-slider-pointer, 0%)),calc(100% - var(--media-slider-chapter-end, 100%) + var(--media-spacing) * var(--media-chapter-inset-end, 0)));clip-path:inset(0 -1px)}:where(.media-skin[data-theme=neutral]) .media-slider-fill[data-orientation=vertical]:before{content:"";min-height:var(--media-spacing);bottom:0}:where(.media-skin[data-theme=neutral]) .media-slider-thumb{top:50%;left:var(--media-slider-fill, 0%);z-index:10;width:calc(var(--media-spacing) * 3);height:calc(var(--media-spacing) * 3);border-radius:var(--media-control-radius);box-shadow:0 0 #0000,0 0 #0000,0 0 #0000,0 0 #0000,var(--media-shadow-thumb);outline-offset:-2px;transition-property:opacity,height,width,outline-offset,scale;transition-duration:.15s;transition-duration:var(--media-duration-slider);-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:#fff;outline:2px solid #0000;transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;translate:-50% -50%}:where(:where(.media-skin[data-theme=neutral]) .media-slider)[data-dragging] .media-slider-thumb{scale:.9}:where(.media-skin[data-theme=neutral]) .media-slider-thumb:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(:where(.media-skin[data-theme=neutral]) .media-slider)[data-dragging] .media-slider-thumb[data-orientation=horizontal]{left:var(--media-slider-pointer)}:where(.media-skin[data-theme=neutral]) .media-slider-thumb[data-orientation=vertical]{top:calc(100% - var(--media-slider-fill, 0%));left:50%}:where(:where(.media-skin[data-theme=neutral]) .media-slider)[data-dragging] .media-slider-thumb[data-orientation=vertical]{top:calc(100% - var(--media-slider-pointer))}:where(.media-skin[data-theme=neutral]) .media-slider-track{isolation:isolate;-webkit-user-select:none;-moz-user-select:none;user-select:none;border-radius:9999px;width:100%;position:relative}:where(.media-skin[data-theme=neutral]) .media-slider-track:before{pointer-events:none;border-radius:var(--media-control-radius);content:"";background-color:currentColor;position:absolute;inset:0}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-slider-track:before{background-color:color-mix(in oklab,currentcolor 20%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-slider-track[data-orientation=horizontal]{height:var(--media-spacing)}:where(.media-skin[data-theme=neutral]) .media-slider-track[data-orientation=vertical]{height:100%;width:var(--media-spacing)}:where(.media-skin[data-theme=neutral]) .media-slider{cursor:pointer;transition-property:--media-slider-fill,--media-slider-buffer;transition-duration:.15s;transition-duration:var(--media-duration-slider);border-radius:9999px;outline-style:none;flex:1;justify-content:center;align-items:center;transition-timing-function:cubic-bezier(0,0,.2,1);display:flex;position:relative}@media(forced-colors:active){:where(.media-skin[data-theme=neutral]) .media-slider{outline-offset:2px;outline:2px solid #0000}}:where(.media-skin[data-theme=neutral]) .media-slider[data-disabled]{pointer-events:none}:where(.media-skin[data-theme=neutral]) .media-slider[data-dragging]{transition-duration:0s}:where(.media-skin[data-theme=neutral]) .media-slider[data-orientation=horizontal]{height:var(--media-slider-height, calc(var(--media-spacing) * 8));min-width:calc(var(--media-spacing) * 20)}:where(.media-skin[data-theme=neutral]) .media-slider[data-orientation=vertical]{height:calc(var(--media-spacing) * 20);width:calc(var(--media-spacing) * 8);min-width:0}:where(.media-skin[data-theme=neutral]) .media-volume-slider-thumb{opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-volume-popover{border-radius:var(--media-control-radius);padding-inline:0;padding-block:calc(var(--media-spacing) * 3);--media-popup-side-offset: var(--media-popover-side-offset)}:where(.media-skin[data-theme=neutral]) .media-volume-popover[data-side=left]{background-image:linear-gradient(to left,var(--media-controls) 80%,transparent 100%);--media-popover-side-offset: 0rem;border-style:solid;border-width:0;border-radius:0;padding-block:0;padding-inline-start:calc(var(--media-spacing) * 16);padding-inline-end:calc(var(--media-spacing) * 2);box-shadow:none!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;background-color:#0000!important}:where(.media-skin[data-theme=neutral]) .media-volume-popover[data-side=left]:after{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-volume-popover[data-side=right]{padding:0;padding-inline:calc(var(--media-spacing) * 3);--media-popover-side-offset: 0rem;border-radius:0;box-shadow:none!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;background-color:#0000!important}:where(.media-skin[data-theme=neutral]) .media-volume-popover[data-side=right]:after{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-slider-preview{height:var(--media-spacing);--media-preview-end-inset: calc(100cqi - 100%) ;--media-preview-left: clamp(calc(var(--media-slider-preview-max-width) / 2), var(--media-slider-pointer), calc(100% - var(--media-slider-preview-max-width) / 2 + var(--media-preview-end-inset)));--media-slider-preview-max-height: var(--media-slider-preview-max-width);--media-slider-preview-max-width: min(calc(var(--media-spacing) * 28), 100cqi);min-width:100%;position:relative}:where(.media-skin[data-theme=neutral]) .media-slider-preview:before{pointer-events:none;z-index:1;opacity:0;transition-property:opacity,scale;transition-duration:.15s;transition-duration:var(--media-duration-slow);content:"";background-color:currentColor;transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;translate:-50% -50%;scale:.5}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-slider-preview:before{background-color:color-mix(in oklab,currentcolor 35%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-slider-preview[data-pointing]:not([data-dragging]):before{content:"";opacity:1;scale:1}:where(.media-skin[data-theme=neutral]) .media-slider-preview[data-orientation=horizontal]:before{top:50%;left:var(--media-slider-pointer);height:calc(var(--media-spacing) * 5);content:"";width:1px}:where(.media-skin[data-theme=neutral]) .media-slider-preview[data-orientation=vertical]:before{top:calc(100% - var(--media-slider-pointer));content:"";height:1px;width:calc(var(--media-spacing) * 5);left:50%}@container media-root (width >= 32rem){:where(.media-skin[data-theme=neutral]) .media-slider-preview{--media-slider-preview-max-width: min(calc(var(--media-spacing) * 36), 100cqi)}}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral]) .media-slider-preview{--media-preview-left: var(--media-slider-pointer);--media-slider-preview-max-width: min(calc(var(--media-spacing) * 48), 100cqi)}}:where(:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail)[data-loading] .media-slider-thumbnail-image{opacity:0}:where(:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail):not([data-loading]) .media-slider-thumbnail-spinner-icon{--media-spinner-animation: none}:where(:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail)[data-loading] .media-slider-thumbnail-spinner-icon{opacity:1}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter{--media-chapter-inset-end: .5;--media-chapter-inset-start: .5;justify-content:center;align-items:center;min-width:0;min-height:0;display:flex;position:absolute;inset:0}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter:first-of-type{--media-chapter-inset-start: 0}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter:last-of-type{--media-chapter-inset-end: 0}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter[data-orientation=horizontal]{clip-path:inset(0 calc(100% - var(--media-slider-chapter-end)) 0 var(--media-slider-chapter-start))}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter[data-orientation=vertical]{clip-path:inset(calc(100% - var(--media-slider-chapter-end)) 0 var(--media-slider-chapter-start) 0)}:where(:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter)[data-highlighted] .media-time-slider-chapter-layer[data-orientation=horizontal]:before{content:"";min-width:calc(var(--media-spacing) * 1.75)}:where(:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter)[data-highlighted] .media-time-slider-chapter-layer[data-orientation=vertical]:before{content:"";min-height:calc(var(--media-spacing) * 1.75)}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter-title{max-width:var(--media-slider-preview-max-width);text-overflow:ellipsis;white-space:nowrap;min-width:0;overflow:hidden}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter-title:empty{display:none}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter-track{transition-property:height,width;transition-duration:.15s;transition-duration:var(--media-duration-slow);transition-timing-function:cubic-bezier(0,0,.2,1)}:where(:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter)[data-highlighted] .media-time-slider-chapter-track[data-orientation=horizontal]{height:calc(var(--media-spacing) * 1.75)}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter-track[data-orientation=horizontal]:before{content:"";left:calc(var(--media-slider-chapter-start) + var(--media-spacing) * var(--media-chapter-inset-start));right:calc(100% - var(--media-slider-chapter-end) + var(--media-spacing) * var(--media-chapter-inset-end));clip-path:inset(-1px)}:where(:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter)[data-highlighted] .media-time-slider-chapter-track[data-orientation=vertical]{width:calc(var(--media-spacing) * 1.75)}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapter-track[data-orientation=vertical]:before{content:"";top:calc(100% - var(--media-slider-chapter-end) + var(--media-spacing) * var(--media-chapter-inset-end));bottom:calc(var(--media-slider-chapter-start) + var(--media-spacing) * var(--media-chapter-inset-start));clip-path:inset(-1px)}:where(.media-skin[data-theme=neutral]) .media-time-slider-chapters{border-radius:inherit;flex:1;align-items:center;width:100%;min-width:0;height:100%;min-height:0;display:flex;position:relative}:where(.media-skin[data-theme=neutral]) .media-time-slider-preview-content{bottom:calc(100% + var(--media-slider-preview-label-offset));left:var(--media-preview-left, var(--media-slider-pointer));justify-content:center;gap:calc(var(--media-spacing) * 2);font-variant-numeric:tabular-nums;flex-direction:row-reverse;display:flex}:where(.media-skin[data-theme=neutral]) .media-time-slider-thumb{opacity:0;scale:.7}:where(.media-skin[data-theme=neutral]) .media-time-slider-thumb:focus-visible{opacity:1}:where(.media-skin[data-theme=neutral]) .media-time-slider-thumb[data-interactive]{opacity:1;scale:1}@media(pointer:fine){@media(hover:hover){:where(:where(.media-skin[data-theme=neutral]) .media-slider):hover .media-time-slider-thumb{opacity:1;scale:1}}}:where(.media-skin[data-theme=neutral]) .media-time-slider-value{font-variant-numeric:tabular-nums}:where(.media-skin[data-theme=neutral]) .media-slider-preview-content{max-width:var(--media-slider-preview-max-width);transform-origin:bottom;translate:-50% var(--media-hidden-preview-offset);scale:var(--media-hidden-preview-scale) var(--media-hidden-preview-scale);opacity:0;filter:blur(var(--media-hidden-blur));transition-property:filter,opacity,scale;transition-duration:.15s;transition-duration:var(--media-duration);transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute}:where(.media-skin[data-theme=neutral]) :where(.media-slider):has(:focus-visible) .media-slider-preview-content,:where(.media-skin[data-theme=neutral]) :where(.media-slider-preview)[data-pointing] .media-slider-preview-content{opacity:1;filter:none;scale:1}:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail{pointer-events:none;bottom:calc(100% + var(--media-slider-preview-offset));left:var(--media-preview-left, var(--media-slider-pointer));max-height:var(--media-slider-preview-max-height);border-radius:var(--media-popup-radius);background-color:var(--media-backdrop);overflow:hidden}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail{background-color:color-mix(in oklab,var(--media-backdrop) 90%,transparent)}}:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail[data-loading]{aspect-ratio:16 / 9;width:var(--media-slider-preview-max-width)}:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail-image{transition-property:opacity;transition-duration:.15s;transition-duration:var(--media-duration);transition-timing-function:cubic-bezier(0,0,.2,1);display:block}:where(.media-skin[data-theme=neutral]) :where(.media-slider-thumbnail)[data-loading] .media-slider-thumbnail-image{opacity:0}:where(.media-skin[data-theme=neutral]) .media-slider-thumbnail-spinner-icon{z-index:10;width:var(--media-icon-size, calc(var(--media-spacing) * 4.5));height:var(--media-icon-size, calc(var(--media-spacing) * 4.5));opacity:0;filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));transition-property:opacity;transition-duration:.15s;transition-duration:var(--media-duration);transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;top:50%;left:50%;translate:-50% -50%}:where(.media-skin[data-theme=neutral]) :where(.media-slider-thumbnail):not([data-loading]) .media-slider-thumbnail-spinner-icon{--media-spinner-animation: none}:where(.media-skin[data-theme=neutral]) :where(.media-slider-thumbnail)[data-loading] .media-slider-thumbnail-spinner-icon{opacity:1}:where(.media-skin[data-theme=neutral]) .media-menu-back-chevron{width:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 7 / 9);height:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 7 / 9);color:var(--media-muted-foreground);filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0;rotate:180deg}:where(:where(.media-skin[data-theme=neutral]) .media-menu-back-item):where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])) .media-menu-back-chevron{color:inherit}:where(.media-skin[data-theme=neutral]) .media-menu-back-chevron:where(:dir(rtl),[dir=rtl],[dir=rtl] *){rotate:0deg;scale:1}:where(.media-skin[data-theme=neutral]) .media-menu-forward-chevron{width:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 7 / 9);height:calc(var(--media-icon-size, calc(var(--media-spacing) * 4.5)) * 7 / 9);color:var(--media-muted-foreground);filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0}:where(:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item):where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])) .media-menu-forward-chevron{color:inherit}:where(.media-skin[data-theme=neutral]) .media-menu-forward-chevron:where(:dir(rtl),[dir=rtl],[dir=rtl] *){scale:-1 1}:where(.media-skin[data-theme=neutral]) .media-menu-item-indicator{opacity:0;flex-shrink:0;margin-inline-start:auto;margin-inline-end:calc(var(--media-spacing) * -1)}:where(:where(.media-skin[data-theme=neutral]) .media-menu-radio-item)[aria-checked=true] .media-menu-item-indicator{opacity:1}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item{cursor:pointer;justify-content:space-between;align-items:center;gap:calc(var(--media-spacing) * 1.5);border-radius:var(--media-menu-item-radius);padding-inline:calc(var(--media-spacing) * 2);padding-block:calc(var(--media-spacing) * 1.5);text-align:start;white-space:nowrap;color:inherit;font-variant-numeric:tabular-nums;outline-offset:-2px;transition-property:background-color,color;transition-duration:.15s;transition-duration:var(--media-duration-fast);-webkit-user-select:none;-moz-user-select:none;user-select:none;text-shadow:0 1px 0 var(--media-shadow-current-color);outline:2px solid #0000;transition-timing-function:cubic-bezier(.4,0,.2,1);display:flex;position:relative}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item[aria-disabled=true]{pointer-events:none;cursor:not-allowed;opacity:.5}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item[data-availability=unavailable],:where(.media-skin[data-theme=neutral]) .media-menu-radio-item[data-availability=unsupported]{display:none}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){background-color:var(--media-accent);color:var(--media-accent-foreground)}@supports (top: anchor(top)){:where(.media-skin[data-theme=neutral]) .media-menu-radio-item{transition-duration:var(--media-duration-instant)}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item[data-highlighted]{anchor-name:--media-menu-item-highlight-anchor}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){transition-duration:var(--media-duration-slow);background-color:#0000}}:where(.media-skin[data-theme=neutral]) .media-menu-radio-item-icon{width:var(--media-icon-size, calc(var(--media-spacing) * 4.5));height:var(--media-icon-size, calc(var(--media-spacing) * 4.5));color:var(--media-muted-foreground);filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0}:where(:where(.media-skin[data-theme=neutral]) .media-menu-radio-item):where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])) .media-menu-radio-item-icon{color:inherit}:where(.media-skin[data-theme=neutral]) .media-menu-back-item{margin-bottom:calc(var(--media-spacing) * .5);cursor:pointer;align-items:center;gap:calc(var(--media-spacing) * 1.5);border-radius:var(--media-menu-item-radius);width:100%;padding-inline:calc(var(--media-spacing) * 2);padding-block:calc(var(--media-spacing) * 1.5);text-align:start;white-space:nowrap;outline-offset:-2px;transition-property:background-color,color;transition-duration:.15s;transition-duration:var(--media-duration-fast);-webkit-user-select:none;-moz-user-select:none;user-select:none;text-shadow:0 1px 0 var(--media-shadow-current-color);outline:2px solid #0000;transition-timing-function:cubic-bezier(.4,0,.2,1);display:flex;position:relative}:where(.media-skin[data-theme=neutral]) .media-menu-back-item:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(.media-skin[data-theme=neutral]) .media-menu-back-item:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){background-color:var(--media-accent);color:var(--media-accent-foreground)}@supports (top: anchor(top)){:where(.media-skin[data-theme=neutral]) .media-menu-back-item{transition-duration:var(--media-duration-instant)}:where(.media-skin[data-theme=neutral]) .media-menu-back-item:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){transition-duration:var(--media-duration-slow)}}:where(.media-skin[data-theme=neutral]) .media-menu-content{max-height:inherit;overscroll-behavior:none;transition-property:translate,filter;transition-duration:.15s;transition-duration:var(--media-duration-menu);anchor-scope:--media-menu-item-highlight-anchor;outline-style:none;transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;overflow:auto}@media(forced-colors:active){:where(.media-skin[data-theme=neutral]) .media-menu-content{outline-offset:2px;outline:2px solid #0000}}:where(.media-skin[data-theme=neutral]) .media-menu-content:not([data-submenu]){inset-inline:var(--media-spacing);top:var(--media-spacing);gap:calc(var(--media-spacing) * .5);flex-direction:column;display:flex}:where(.media-skin[data-theme=neutral]) .media-menu-content:not([data-submenu])[data-child-open]{filter:blur(var(--media-hidden-blur));translate:-100%}:where(.media-skin[data-theme=neutral]) .media-menu-content:not([data-submenu])[data-child-open]:before{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-menu-content[data-submenu]{z-index:10;max-height:inherit;padding:var(--media-spacing);inset-inline:0;top:0}:where(.media-skin[data-theme=neutral]) .media-menu-content:not([data-submenu])[data-child-open]:where(:dir(rtl),[dir=rtl],[dir=rtl] *){translate:100%}:where(.media-skin[data-theme=neutral]) .media-menu-content:is([data-starting-style],[data-ending-style]):before{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-menu-content[data-submenu]:is([data-starting-style],[data-ending-style]){pointer-events:none;filter:blur(var(--media-hidden-blur));overflow:hidden;translate:100%}:where(.media-skin[data-theme=neutral]) .media-menu-content[data-submenu]:is([data-starting-style],[data-ending-style]):where(:dir(rtl),[dir=rtl],[dir=rtl] *){translate:-100%}@supports (top: anchor(top)){:where(.media-skin[data-theme=neutral]) .media-menu-content:before{content:"";position-anchor:--media-menu-item-highlight-anchor;inset:anchor(inside);overflow-anchor:none;pointer-events:none;border-radius:var(--media-menu-item-radius);background-color:var(--media-accent);transition:inset var(--media-duration-fast) ease-in-out;position:absolute}:where(.media-skin[data-theme=neutral]) .media-menu-content:has([data-highlighted=""]):before{content:"";transition-duration:0s}}:where(.media-skin[data-theme=neutral]) .media-menu-content:is([data-starting-style],[data-ending-style]) :before{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-menu-hint{align-items:center;gap:var(--media-spacing);min-width:0;margin-inline-start:auto;padding-inline-start:calc(var(--media-spacing) * 2);display:inline-flex}:where(.media-skin[data-theme=neutral]) .media-menu-hint-label{max-width:calc(var(--media-spacing) * 24);text-overflow:ellipsis;white-space:nowrap;opacity:.65;overflow:hidden}:where(.media-skin[data-theme=neutral]) .media-menu-radio-group{max-height:inherit;gap:calc(var(--media-spacing) * .5);anchor-scope:--media-menu-item-highlight-anchor;flex-direction:column;display:flex}:where(.media-skin[data-theme=neutral]) .media-menu-radio-group:is([data-starting-style],[data-ending-style]):before{content:"";display:none}@supports (top: anchor(top)){:where(.media-skin[data-theme=neutral]) .media-menu-radio-group:before{content:"";position-anchor:--media-menu-item-highlight-anchor;inset:anchor(inside);overflow-anchor:none;pointer-events:none;border-radius:var(--media-menu-item-radius);background-color:var(--media-accent);transition:inset var(--media-duration-fast) ease-in-out;position:absolute}:where(.media-skin[data-theme=neutral]) .media-menu-radio-group:has([data-highlighted=""]):before{content:"";transition-duration:0s}}:where(.media-skin[data-theme=neutral]) .media-menu-radio-group:is([data-starting-style],[data-ending-style]) :before{content:"";display:none}:where(.media-skin[data-theme=neutral]) .media-menu-separator{margin-block:var(--media-spacing);border-bottom-style:solid;border-bottom-width:1px;border-color:var(--media-border);display:block}@media(prefers-reduced-transparency:reduce),(prefers-contrast:more){:where(.media-skin[data-theme=neutral]) .media-menu-separator{border-color:var(--media-foreground)}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral]) .media-menu-separator{border-color:color-mix(in oklab,var(--media-foreground) 25%,transparent)}}}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item{cursor:pointer;justify-content:space-between;align-items:center;gap:calc(var(--media-spacing) * 1.5);border-radius:var(--media-menu-item-radius);padding-inline:calc(var(--media-spacing) * 2);padding-block:calc(var(--media-spacing) * 1.5);text-align:start;white-space:nowrap;color:inherit;font-variant-numeric:tabular-nums;outline-offset:-2px;transition-property:background-color,color;transition-duration:.15s;transition-duration:var(--media-duration-fast);-webkit-user-select:none;-moz-user-select:none;user-select:none;text-shadow:0 1px 0 var(--media-shadow-current-color);outline:2px solid #0000;transition-timing-function:cubic-bezier(.4,0,.2,1);display:flex;position:relative}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item[aria-disabled=true]{pointer-events:none;cursor:not-allowed;opacity:.5}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item[data-availability=unavailable],:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item[data-availability=unsupported]{display:none}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){background-color:var(--media-accent);color:var(--media-accent-foreground)}@supports (top: anchor(top)){:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item{transition-duration:var(--media-duration-instant)}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item[data-highlighted]{anchor-name:--media-menu-item-highlight-anchor}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item:where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])){transition-duration:var(--media-duration-slow);background-color:#0000}}:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item-icon{width:var(--media-icon-size, calc(var(--media-spacing) * 4.5));height:var(--media-icon-size, calc(var(--media-spacing) * 4.5));color:var(--media-muted-foreground);filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));flex-shrink:0}:where(:where(.media-skin[data-theme=neutral]) .media-menu-trigger-item):where(:focus-visible,[aria-expanded=true],[data-highlighted]):where(:not([aria-disabled=true])) .media-menu-trigger-item-icon{color:inherit}:where(.media-skin[data-theme=neutral]) .media-menu-badge{border-radius:var(--media-control-radius);background-color:var(--media-accent);padding-inline:calc(var(--media-spacing) * 1.5);font-size:.7em;font-weight:600}:where(.media-skin[data-theme=neutral]) .media-menu-tier{opacity:.7;padding-inline-start:calc(var(--media-spacing) * .5);padding-top:1px;font-size:.7em;font-weight:600;line-height:1}:where(.media-skin[data-theme=neutral]) .media-menu-popup{height:var(--media-menu-height);max-height:min(var(--media-menu-available-height, calc(var(--media-spacing) * 56)),calc(var(--media-spacing) * 56));width:var(--media-menu-width);max-width:var(--media-menu-available-width);min-width:calc(var(--media-spacing) * 44);overscroll-behavior:none;border-radius:var(--media-popup-radius);padding:var(--media-spacing);transition-property:opacity,filter,transform,scale;transition-duration:var(--media-duration-fast);--media-popup-side-offset: var(--media-popover-side-offset);border-style:solid;border-width:0;margin:0;transition-timing-function:cubic-bezier(0,0,.2,1);overflow:hidden!important}:where(.media-skin[data-theme=neutral]) .media-menu-popup:is([data-starting-style],[data-ending-style]){transition-property:opacity,filter,transform,scale;transition-duration:var(--media-duration-fast);transition-timing-function:cubic-bezier(0,0,.2,1)}:where(.media-skin[data-theme=neutral]) .media-menu-resizable-popup{transition-property:opacity,filter,transform,scale,width,height;transition-duration:var(--media-duration-fast),var(--media-duration-fast),var(--media-duration-fast),var(--media-duration-fast),var(--media-duration-menu),var(--media-duration-menu)}:where(.media-skin[data-theme=neutral]) .media-settings-menu-trigger-icon{transition-property:transform,translate,scale,rotate;transition-duration:.15s;transition-duration:var(--media-duration);transition-timing-function:cubic-bezier(.4,0,.2,1)}:where(:where(.media-skin[data-theme=neutral]) .media-settings-menu-trigger)[aria-expanded=true] .media-settings-menu-trigger-icon{rotate:90deg}@media(prefers-reduced-motion:reduce){:where(.media-skin[data-theme=neutral]) .media-settings-menu-trigger-icon{transition-property:none}}:where(.media-skin[data-theme=neutral]) .media-settings-menu-trigger-label{clip-path:inset(50%);white-space:nowrap;border-width:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}:where(.media-skin[data-theme=neutral]) .media-button-icon-base{width:var(--media-icon-size, calc(var(--media-spacing) * 4.5));height:var(--media-icon-size, calc(var(--media-spacing) * 4.5));filter:drop-shadow(0 1px 0 var(--media-shadow-current-color));text-shadow:inherit;grid-row-start:1;grid-column-start:1}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-backdrop{pointer-events:none;z-index:10;border-radius:inherit;background-image:var(--media-controls-gradient);transition-property:opacity;transition-duration:.15s;transition-duration:var(--media-duration-controls);transition-timing-function:cubic-bezier(0,0,.2,1);position:absolute;inset:0}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-backdrop:not([data-visible]){opacity:0}@container media-root (width < 20rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-captions-button{display:none}}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content{inset-inline:calc(var(--media-spacing) * .5);bottom:calc(var(--media-spacing) * .5);z-index:30;align-items:center;-moz-column-gap:calc(var(--media-spacing) * 2);column-gap:calc(var(--media-spacing) * 2);border-radius:var(--media-controls-radius);padding:var(--media-spacing);color:var(--media-controls-foreground);transition-property:filter,opacity,translate;transition-duration:.15s;transition-duration:calc(var(--media-duration-controls) / 2);text-shadow:0 1px 0 var(--media-shadow-current-color);background-color:#0000;transition-timing-function:cubic-bezier(0,0,.2,1);display:flex;position:absolute}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content:not([data-visible]){pointer-events:none;translate:0 var(--media-hidden-offset);opacity:0;transition-duration:var(--media-duration-controls)}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row-reverse}@media(pointer:fine){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content:not([data-visible]){filter:blur(var(--media-hidden-blur))}}@media(prefers-reduced-transparency:reduce),(prefers-contrast:more){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content{background-color:var(--media-background)}}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content{inset-inline:calc(var(--media-spacing) * 2);bottom:calc(var(--media-spacing) * 2);--media-popover-side-offset: calc(var(--media-spacing) * 3);--media-tooltip-side-offset: var(--media-popover-side-offset)}}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-end{flex:1;justify-content:flex-end;align-items:center;gap:1px;display:flex}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-end:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row-reverse}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-end{flex:none}}@container media-root (width < 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-end{transition:-webkit-mask-position var(--media-duration-instant) ease-out;transition:mask-position var(--media-duration-instant) ease-out;transition:mask-position var(--media-duration-instant) ease-out,-webkit-mask-position var(--media-duration-instant) ease-out;-webkit-mask-position:100% 0;mask-position:100% 0;-webkit-mask-size:400% 100%;mask-size:400% 100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}:where(:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content):has([data-volume-level][aria-expanded=true]) .video-controls-end{-webkit-mask-image:linear-gradient(to right,#0000 10%,#000 25% 100%);mask-image:linear-gradient(to right,#0000 10%,#000 25% 100%);-webkit-mask-position:0 0;mask-position:0 0}}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-start{flex:1;align-items:center;gap:1px;display:flex}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-start:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row-reverse}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-start{flex:none}}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-trailing{align-items:center;gap:1px;display:flex}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-trailing:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row-reverse}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-wrap{flex-wrap:wrap}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-wrap{flex-wrap:nowrap}}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-time-slider-group{align-items:center;gap:calc(var(--media-spacing) * 3);padding-inline:calc(var(--media-spacing) * 1.5);--media-slider-height: calc(var(--media-spacing) * 5);flex-direction:row-reverse;flex:0 0 100%;order:-1;display:flex;container:video-time-controls / inline-size}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-time-slider-group:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-time-slider-group{min-width:0;transition:-webkit-mask-position var(--media-duration-instant) ease-out;transition:mask-position var(--media-duration-instant) ease-out;transition:mask-position var(--media-duration-instant) ease-out,-webkit-mask-position var(--media-duration-instant) ease-out;--media-slider-height: calc(var(--media-spacing) * 8);flex-direction:row;flex:1;order:0;-webkit-mask-position:100% 0;mask-position:100% 0;-webkit-mask-size:200% 100%;mask-size:200% 100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}:where(:where(.media-skin[data-theme=neutral][data-preset=video]) .video-controls-content):has([data-volume-level][aria-expanded=true]) .video-time-slider-group{-webkit-mask-image:linear-gradient(to right,#0000 10%,#000 25% 100%);mask-image:linear-gradient(to right,#0000 10%,#000 25% 100%);-webkit-mask-position:0 0;mask-position:0 0}:where(.media-skin[data-theme=neutral][data-preset=video]) .video-time-slider-group:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row-reverse}}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-current-value{display:none}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-current-value{display:inline}}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-duration-value{font-variant-numeric:tabular-nums;transition-property:opacity;transition-duration:.15s;transition-duration:var(--media-duration-slow);transition-timing-function:cubic-bezier(0,0,.2,1)}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-duration-value[data-unavailable]{opacity:.5}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-duration-value{color:var(--media-controls-foreground)}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-duration-value{color:color-mix(in oklab,var(--media-controls-foreground) 60%,transparent)}}}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-group{align-items:center;gap:var(--media-spacing);display:flex}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-group:where(:dir(rtl),[dir=rtl],[dir=rtl] *){flex-direction:row-reverse}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-separator{display:none}@container media-root (width >= 42rem){:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-separator{color:var(--media-controls-foreground);display:inline}@supports (color: color-mix(in lab,red,red)){:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-separator{color:color-mix(in oklab,var(--media-controls-foreground) 60%,transparent)}}}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-toggle{cursor:pointer;font-variant-numeric:tabular-nums;outline-offset:-2px;transition-property:outline-color,outline-offset;transition-duration:.15s;transition-duration:var(--media-duration-fast);border-radius:.25rem;outline:2px solid #0000;transition-timing-function:cubic-bezier(0,0,.2,1)}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-toggle:focus-visible{outline-offset:2px;outline-color:var(--media-ring)}:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-toggle[aria-disabled=true]{cursor:not-allowed;opacity:.5}@supports (corner-shape: squircle){:where(.media-skin[data-theme=neutral][data-preset=video]) .media-time-toggle{corner-shape:squircle;border-radius:1rem}}@media(pointer:fine){:where(.media-skin[data-theme=neutral][data-preset=video]) .video-skin:not([data-controls-visible]),:where(.media-skin[data-theme=neutral][data-preset=video]).video-skin:not([data-controls-visible]){cursor:none}}}@layer utilities;@property --media-slider-fill{syntax: "<percentage>"; inherits: true; initial-value: 0%;}@property --media-slider-buffer{syntax: "<percentage>"; inherits: true; initial-value: 0%;}', TM = '@layer properties;@layer theme,base,components,utilities;@layer theme{:root,:host{--font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";--font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;--color-black: #000;--color-white: #fff;--spacing: .25rem;--text-xs: .75rem;--text-xs--line-height: calc(1 / .75);--text-sm: .875rem;--text-sm--line-height: calc(1.25 / .875);--text-lg: 1.125rem;--text-lg--line-height: calc(1.75 / 1.125);--text-xl: 1.25rem;--text-xl--line-height: calc(1.75 / 1.25);--text-2xl: 1.5rem;--text-2xl--line-height: calc(2 / 1.5);--font-weight-semibold: 600;--font-weight-bold: 700;--tracking-widest: .1em;--radius-md: .375rem;--radius-lg: .5rem;--blur-sm: 8px;--default-transition-duration: .15s;--default-transition-timing-function: cubic-bezier(.4, 0, .2, 1);--default-font-family: var(--font-sans);--default-mono-font-family: var(--font-mono)}}@layer base{*,:after,:before,::backdrop,::file-selector-button{box-sizing:border-box;margin:0;padding:0;border:0 solid}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:var(--default-font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");font-feature-settings:var(--default-font-feature-settings, normal);font-variation-settings:var(--default-font-variation-settings, normal);-webkit-tap-highlight-color:transparent}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;-webkit-text-decoration:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);font-feature-settings:var(--default-mono-font-feature-settings, normal);font-variation-settings:var(--default-mono-font-variation-settings, normal);font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}:-moz-focusring:where(:not(iframe)){outline:auto}progress{vertical-align:baseline}summary{display:list-item}ol,ul,menu{list-style:none}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}button,input,select,optgroup,textarea,::file-selector-button{font:inherit;font-feature-settings:inherit;font-variation-settings:inherit;letter-spacing:inherit;color:inherit;border-radius:0;background-color:transparent;opacity:1}:where(select:is([multiple],[size])) optgroup{font-weight:bolder}:where(select:is([multiple],[size])) optgroup option{padding-inline-start:20px}::file-selector-button{margin-inline-end:4px}::-moz-placeholder{opacity:1}::placeholder{opacity:1}@supports (not (-webkit-appearance: -apple-pay-button)) or (contain-intrinsic-size: 1px){::-moz-placeholder{color:currentcolor}@supports (color: color-mix(in lab,red,red)){::-moz-placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}::placeholder{color:currentcolor}@supports (color: color-mix(in lab,red,red)){::placeholder{color:color-mix(in oklab,currentcolor 50%,transparent)}}}textarea{resize:vertical}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-date-and-time-value{min-height:1lh;text-align:inherit}::-webkit-datetime-edit{display:inline-flex}::-webkit-datetime-edit-fields-wrapper{padding:0}::-webkit-datetime-edit,::-webkit-datetime-edit-year-field,::-webkit-datetime-edit-month-field,::-webkit-datetime-edit-day-field,::-webkit-datetime-edit-hour-field,::-webkit-datetime-edit-minute-field,::-webkit-datetime-edit-second-field,::-webkit-datetime-edit-millisecond-field,::-webkit-datetime-edit-meridiem-field{padding-block:0}::-webkit-calendar-picker-indicator{line-height:1}:-moz-ui-invalid{box-shadow:none}button,input:where([type=button],[type=reset],[type=submit]),::file-selector-button{-webkit-appearance:button;-moz-appearance:button;appearance:button}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[hidden]:where(:not([hidden=until-found])){display:none!important}}@layer utilities{.visible{visibility:visible}.absolute{position:absolute}.fixed{position:fixed}.relative{position:relative}.top-3{top:calc(var(--spacing) * 3)}.right-3{right:calc(var(--spacing) * 3)}.bottom-3{bottom:calc(var(--spacing) * 3)}.mt-3{margin-top:calc(var(--spacing) * 3)}.mb-1{margin-bottom:var(--spacing)}.mb-4{margin-bottom:calc(var(--spacing) * 4)}.mb-5{margin-bottom:calc(var(--spacing) * 5)}.mb-6{margin-bottom:calc(var(--spacing) * 6)}.line-clamp-1{overflow:hidden;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:1}.block{display:block}.flex{display:flex}.hidden{display:none}.inline{display:inline}.h-7{height:calc(var(--spacing) * 7)}.h-full{height:100%}.max-h-20{max-height:calc(var(--spacing) * 20)}.w-7{width:calc(var(--spacing) * 7)}.w-full{width:100%}.max-w-56{max-width:calc(var(--spacing) * 56)}.max-w-\\[70\\%\\]{max-width:70%}.transform{transform:var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,)}.flex-col{flex-direction:column}.items-center{align-items:center}.justify-center{justify-content:center}.gap-3{gap:calc(var(--spacing) * 3)}.overflow-hidden{overflow:hidden}.rounded{border-radius:.25rem}.rounded-full{border-radius:calc(infinity * 1px)}.rounded-lg{border-radius:var(--radius-lg)}.rounded-md{border-radius:var(--radius-md)}.border{border-style:var(--tw-border-style);border-width:1px}.border-white\\/10{border-color:color-mix(in srgb,#fff 10%,transparent)}@supports (color: color-mix(in lab,red,red)){.border-white\\/10{border-color:color-mix(in oklab,var(--color-white) 10%,transparent)}}.bg-black{background-color:var(--color-black)}.bg-black\\/60{background-color:color-mix(in srgb,#000 60%,transparent)}@supports (color: color-mix(in lab,red,red)){.bg-black\\/60{background-color:color-mix(in oklab,var(--color-black) 60%,transparent)}}.bg-black\\/80{background-color:color-mix(in srgb,#000 80%,transparent)}@supports (color: color-mix(in lab,red,red)){.bg-black\\/80{background-color:color-mix(in oklab,var(--color-black) 80%,transparent)}}.bg-white{background-color:var(--color-white)}.bg-white\\/10{background-color:color-mix(in srgb,#fff 10%,transparent)}@supports (color: color-mix(in lab,red,red)){.bg-white\\/10{background-color:color-mix(in oklab,var(--color-white) 10%,transparent)}}.px-3{padding-inline:calc(var(--spacing) * 3)}.px-5{padding-inline:calc(var(--spacing) * 5)}.px-6{padding-inline:calc(var(--spacing) * 6)}.py-1\\.5{padding-block:calc(var(--spacing) * 1.5)}.py-2{padding-block:calc(var(--spacing) * 2)}.text-center{text-align:center}.text-2xl{font-size:var(--text-2xl);line-height:var(--tw-leading, var(--text-2xl--line-height))}.text-lg{font-size:var(--text-lg);line-height:var(--tw-leading, var(--text-lg--line-height))}.text-sm{font-size:var(--text-sm);line-height:var(--tw-leading, var(--text-sm--line-height))}.text-xl{font-size:var(--text-xl);line-height:var(--tw-leading, var(--text-xl--line-height))}.text-xs{font-size:var(--text-xs);line-height:var(--tw-leading, var(--text-xs--line-height))}.font-bold{--tw-font-weight: var(--font-weight-bold);font-weight:var(--font-weight-bold)}.font-semibold{--tw-font-weight: var(--font-weight-semibold);font-weight:var(--font-weight-semibold)}.tracking-widest{--tw-tracking: var(--tracking-widest);letter-spacing:var(--tracking-widest)}.text-black{color:var(--color-black)}.text-white{color:var(--color-white)}.text-white\\/30{color:color-mix(in srgb,#fff 30%,transparent)}@supports (color: color-mix(in lab,red,red)){.text-white\\/30{color:color-mix(in oklab,var(--color-white) 30%,transparent)}}.text-white\\/50{color:color-mix(in srgb,#fff 50%,transparent)}@supports (color: color-mix(in lab,red,red)){.text-white\\/50{color:color-mix(in oklab,var(--color-white) 50%,transparent)}}.text-white\\/60{color:color-mix(in srgb,#fff 60%,transparent)}@supports (color: color-mix(in lab,red,red)){.text-white\\/60{color:color-mix(in oklab,var(--color-white) 60%,transparent)}}.text-white\\/70{color:color-mix(in srgb,#fff 70%,transparent)}@supports (color: color-mix(in lab,red,red)){.text-white\\/70{color:color-mix(in oklab,var(--color-white) 70%,transparent)}}.uppercase{text-transform:uppercase}.tabular-nums{--tw-numeric-spacing: tabular-nums;font-variant-numeric:var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,)}.shadow{--tw-shadow: 0 1px 3px 0 var(--tw-shadow-color, rgb(0 0 0 / .1)), 0 1px 2px -1px var(--tw-shadow-color, rgb(0 0 0 / .1));box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.shadow-lg{--tw-shadow: 0 10px 15px -3px var(--tw-shadow-color, rgb(0 0 0 / .1)), 0 4px 6px -4px var(--tw-shadow-color, rgb(0 0 0 / .1));box-shadow:var(--tw-inset-shadow),var(--tw-inset-ring-shadow),var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow)}.outline{outline-style:var(--tw-outline-style);outline-width:1px}.filter{filter:var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,)}.backdrop-blur-sm{--tw-backdrop-blur: blur(var(--blur-sm));-webkit-backdrop-filter:var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);backdrop-filter:var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,)}.transition{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to,opacity,box-shadow,transform,translate,scale,rotate,filter,backdrop-filter,display,content-visibility,overlay,pointer-events;transition-timing-function:var(--tw-ease, var(--default-transition-timing-function));transition-duration:var(--tw-duration, var(--default-transition-duration))}.transition-colors{transition-property:color,background-color,border-color,outline-color,text-decoration-color,fill,stroke,--tw-gradient-from,--tw-gradient-via,--tw-gradient-to;transition-timing-function:var(--tw-ease, var(--default-transition-timing-function));transition-duration:var(--tw-duration, var(--default-transition-duration))}.transition-opacity{transition-property:opacity;transition-timing-function:var(--tw-ease, var(--default-transition-timing-function));transition-duration:var(--tw-duration, var(--default-transition-duration))}@media(hover:hover){.hover\\:bg-white\\/20:hover{background-color:color-mix(in srgb,#fff 20%,transparent)}@supports (color: color-mix(in lab,red,red)){.hover\\:bg-white\\/20:hover{background-color:color-mix(in oklab,var(--color-white) 20%,transparent)}}.hover\\:text-white:hover{color:var(--color-white)}.hover\\:text-white\\/80:hover{color:color-mix(in srgb,#fff 80%,transparent)}@supports (color: color-mix(in lab,red,red)){.hover\\:text-white\\/80:hover{color:color-mix(in oklab,var(--color-white) 80%,transparent)}}.hover\\:opacity-80:hover{opacity:80%}.hover\\:opacity-90:hover{opacity:90%}}}@property --tw-rotate-x{syntax: "*"; inherits: false;}@property --tw-rotate-y{syntax: "*"; inherits: false;}@property --tw-rotate-z{syntax: "*"; inherits: false;}@property --tw-skew-x{syntax: "*"; inherits: false;}@property --tw-skew-y{syntax: "*"; inherits: false;}@property --tw-border-style{syntax: "*"; inherits: false; initial-value: solid;}@property --tw-font-weight{syntax: "*"; inherits: false;}@property --tw-tracking{syntax: "*"; inherits: false;}@property --tw-ordinal{syntax: "*"; inherits: false;}@property --tw-slashed-zero{syntax: "*"; inherits: false;}@property --tw-numeric-figure{syntax: "*"; inherits: false;}@property --tw-numeric-spacing{syntax: "*"; inherits: false;}@property --tw-numeric-fraction{syntax: "*"; inherits: false;}@property --tw-shadow{syntax: "*"; inherits: false; initial-value: 0 0 #0000;}@property --tw-shadow-color{syntax: "*"; inherits: false;}@property --tw-shadow-alpha{syntax: "<percentage>"; inherits: false; initial-value: 100%;}@property --tw-inset-shadow{syntax: "*"; inherits: false; initial-value: 0 0 #0000;}@property --tw-inset-shadow-color{syntax: "*"; inherits: false;}@property --tw-inset-shadow-alpha{syntax: "<percentage>"; inherits: false; initial-value: 100%;}@property --tw-ring-color{syntax: "*"; inherits: false;}@property --tw-ring-shadow{syntax: "*"; inherits: false; initial-value: 0 0 #0000;}@property --tw-inset-ring-color{syntax: "*"; inherits: false;}@property --tw-inset-ring-shadow{syntax: "*"; inherits: false; initial-value: 0 0 #0000;}@property --tw-ring-inset{syntax: "*"; inherits: false;}@property --tw-ring-offset-width{syntax: "<length>"; inherits: false; initial-value: 0px;}@property --tw-ring-offset-color{syntax: "*"; inherits: false; initial-value: #fff;}@property --tw-ring-offset-shadow{syntax: "*"; inherits: false; initial-value: 0 0 #0000;}@property --tw-outline-style{syntax: "*"; inherits: false; initial-value: solid;}@property --tw-blur{syntax: "*"; inherits: false;}@property --tw-brightness{syntax: "*"; inherits: false;}@property --tw-contrast{syntax: "*"; inherits: false;}@property --tw-grayscale{syntax: "*"; inherits: false;}@property --tw-hue-rotate{syntax: "*"; inherits: false;}@property --tw-invert{syntax: "*"; inherits: false;}@property --tw-opacity{syntax: "*"; inherits: false;}@property --tw-saturate{syntax: "*"; inherits: false;}@property --tw-sepia{syntax: "*"; inherits: false;}@property --tw-drop-shadow{syntax: "*"; inherits: false;}@property --tw-drop-shadow-color{syntax: "*"; inherits: false;}@property --tw-drop-shadow-alpha{syntax: "<percentage>"; inherits: false; initial-value: 100%;}@property --tw-drop-shadow-size{syntax: "*"; inherits: false;}@property --tw-backdrop-blur{syntax: "*"; inherits: false;}@property --tw-backdrop-brightness{syntax: "*"; inherits: false;}@property --tw-backdrop-contrast{syntax: "*"; inherits: false;}@property --tw-backdrop-grayscale{syntax: "*"; inherits: false;}@property --tw-backdrop-hue-rotate{syntax: "*"; inherits: false;}@property --tw-backdrop-invert{syntax: "*"; inherits: false;}@property --tw-backdrop-opacity{syntax: "*"; inherits: false;}@property --tw-backdrop-saturate{syntax: "*"; inherits: false;}@property --tw-backdrop-sepia{syntax: "*"; inherits: false;}@layer properties{@supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))){*,:before,:after,::backdrop{--tw-rotate-x: initial;--tw-rotate-y: initial;--tw-rotate-z: initial;--tw-skew-x: initial;--tw-skew-y: initial;--tw-border-style: solid;--tw-font-weight: initial;--tw-tracking: initial;--tw-ordinal: initial;--tw-slashed-zero: initial;--tw-numeric-figure: initial;--tw-numeric-spacing: initial;--tw-numeric-fraction: initial;--tw-shadow: 0 0 #0000;--tw-shadow-color: initial;--tw-shadow-alpha: 100%;--tw-inset-shadow: 0 0 #0000;--tw-inset-shadow-color: initial;--tw-inset-shadow-alpha: 100%;--tw-ring-color: initial;--tw-ring-shadow: 0 0 #0000;--tw-inset-ring-color: initial;--tw-inset-ring-shadow: 0 0 #0000;--tw-ring-inset: initial;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-offset-shadow: 0 0 #0000;--tw-outline-style: solid;--tw-blur: initial;--tw-brightness: initial;--tw-contrast: initial;--tw-grayscale: initial;--tw-hue-rotate: initial;--tw-invert: initial;--tw-opacity: initial;--tw-saturate: initial;--tw-sepia: initial;--tw-drop-shadow: initial;--tw-drop-shadow-color: initial;--tw-drop-shadow-alpha: 100%;--tw-drop-shadow-size: initial;--tw-backdrop-blur: initial;--tw-backdrop-brightness: initial;--tw-backdrop-contrast: initial;--tw-backdrop-grayscale: initial;--tw-backdrop-hue-rotate: initial;--tw-backdrop-invert: initial;--tw-backdrop-opacity: initial;--tw-backdrop-saturate: initial;--tw-backdrop-sepia: initial}}}';
function CM({ title: t }) {
  const n = tt.usePlayer(Ei)?.controlsVisible ?? !0;
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        position: "absolute",
        top: "0.75rem",
        left: "0.75rem",
        zIndex: 10,
        transition: "opacity 300ms",
        opacity: n ? 1 : 0,
        pointerEvents: "none"
      },
      className: "max-w-[70%] rounded-lg bg-black/60 px-3 py-1.5 text-xs font-semibold text-white backdrop-blur-sm border border-white/10 line-clamp-1",
      children: t
    }
  );
}
function Qp(t) {
  const e = Math.floor(t / 1e3), n = Math.floor(e / 60), i = e % 60;
  return `${n}:${i.toString().padStart(2, "0")}`;
}
const AM = "seeen", $M = "cta", RM = "video", u1 = {
  utm_source: AM,
  utm_medium: $M,
  utm_campaign: RM,
  utm_term: "",
  utm_content: ""
};
function MM(t) {
  try {
    const e = new URL(t);
    return e.protocol !== "http:" && e.protocol !== "https:" ? !1 : !Object.keys(u1).some(
      (n) => e.searchParams.has(n)
    );
  } catch {
    return !1;
  }
}
function OM(t) {
  let e = t;
  for (; e; ) {
    const n = getComputedStyle(e).backgroundColor;
    if (n && n !== "rgba(0, 0, 0, 0)" && n !== "transparent") {
      const i = n.match(/[\d.]+/g);
      if (i && i.length >= 3) {
        const [r, s, o] = i.map(Number);
        return (0.299 * r + 0.587 * s + 0.114 * o) / 255;
      }
    }
    if (e.parentElement)
      e = e.parentElement;
    else {
      const i = e.getRootNode();
      e = i instanceof ShadowRoot ? i.host : null;
    }
  }
  return 1;
}
function IM(t, e) {
  try {
    const n = new URL(t);
    for (const [i, r] of Object.entries(e))
      n.searchParams.set(i, r);
    return n.toString();
  } catch {
    return t;
  }
}
function Wr(t) {
  if (!MM(t))
    return t;
  try {
    const e = new URL(t);
    return Object.entries(u1).forEach(([n, i]) => {
      e.searchParams.set(n, i);
    }), e.toString();
  } catch (e) {
    return console.error("Error adding UTM parameters:", e), t;
  }
}
var yc = { exports: {} }, xe = {}, em;
function DM() {
  if (em) return xe;
  em = 1;
  var t = /* @__PURE__ */ Symbol.for("react.transitional.element"), e = /* @__PURE__ */ Symbol.for("react.portal"), n = /* @__PURE__ */ Symbol.for("react.fragment"), i = /* @__PURE__ */ Symbol.for("react.strict_mode"), r = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.consumer"), o = /* @__PURE__ */ Symbol.for("react.context"), a = /* @__PURE__ */ Symbol.for("react.forward_ref"), l = /* @__PURE__ */ Symbol.for("react.suspense"), c = /* @__PURE__ */ Symbol.for("react.memo"), u = /* @__PURE__ */ Symbol.for("react.lazy"), d = /* @__PURE__ */ Symbol.for("react.activity"), h = /* @__PURE__ */ Symbol.for("react.view_transition"), f = Symbol.iterator;
  function p(A) {
    return A === null || typeof A != "object" ? null : (A = f && A[f] || A["@@iterator"], typeof A == "function" ? A : null);
  }
  var v = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, g = Object.assign, m = {};
  function y(A, N, X) {
    this.props = A, this.context = N, this.refs = m, this.updater = X || v;
  }
  y.prototype.isReactComponent = {}, y.prototype.setState = function(A, N) {
    if (typeof A != "object" && typeof A != "function" && A != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, A, N, "setState");
  }, y.prototype.forceUpdate = function(A) {
    this.updater.enqueueForceUpdate(this, A, "forceUpdate");
  };
  function k() {
  }
  k.prototype = y.prototype;
  function _(A, N, X) {
    this.props = A, this.context = N, this.refs = m, this.updater = X || v;
  }
  var w = _.prototype = new k();
  w.constructor = _, g(w, y.prototype), w.isPureReactComponent = !0;
  var T = Array.isArray;
  function E() {
  }
  var S = { H: null, A: null, T: null, S: null }, P = Object.prototype.hasOwnProperty;
  function C(A, N, X) {
    var U = X.ref;
    return {
      $$typeof: t,
      type: A,
      key: N,
      ref: U !== void 0 ? U : null,
      props: X
    };
  }
  function M(A, N) {
    return C(A.type, N, A.props);
  }
  function O(A) {
    return typeof A == "object" && A !== null && A.$$typeof === t;
  }
  function W(A) {
    var N = { "=": "=0", ":": "=2" };
    return "$" + A.replace(/[=:]/g, function(X) {
      return N[X];
    });
  }
  var H = /\/+/g;
  function z(A, N) {
    return typeof A == "object" && A !== null && A.key != null ? W("" + A.key) : N.toString(36);
  }
  function F(A) {
    switch (A.status) {
      case "fulfilled":
        return A.value;
      case "rejected":
        throw A.reason;
      default:
        switch (typeof A.status == "string" ? A.then(E, E) : (A.status = "pending", A.then(
          function(N) {
            A.status === "pending" && (A.status = "fulfilled", A.value = N);
          },
          function(N) {
            A.status === "pending" && (A.status = "rejected", A.reason = N);
          }
        )), A.status) {
          case "fulfilled":
            return A.value;
          case "rejected":
            throw A.reason;
        }
    }
    throw A;
  }
  function K(A, N, X, U, j) {
    var ie = typeof A;
    (ie === "undefined" || ie === "boolean") && (A = null);
    var oe = !1;
    if (A === null) oe = !0;
    else
      switch (ie) {
        case "bigint":
        case "string":
        case "number":
          oe = !0;
          break;
        case "object":
          switch (A.$$typeof) {
            case t:
            case e:
              oe = !0;
              break;
            case u:
              return oe = A._init, K(
                oe(A._payload),
                N,
                X,
                U,
                j
              );
          }
      }
    if (oe)
      return j = j(A), oe = U === "" ? "." + z(A, 0) : U, T(j) ? (X = "", oe != null && (X = oe.replace(H, "$&/") + "/"), K(j, N, X, "", function(Ae) {
        return Ae;
      })) : j != null && (O(j) && (j = M(
        j,
        X + (j.key == null || A && A.key === j.key ? "" : ("" + j.key).replace(
          H,
          "$&/"
        ) + "/") + oe
      )), N.push(j)), 1;
    oe = 0;
    var Oe = U === "" ? "." : U + ":";
    if (T(A))
      for (var $e = 0; $e < A.length; $e++)
        U = A[$e], ie = Oe + z(U, $e), oe += K(
          U,
          N,
          X,
          ie,
          j
        );
    else if ($e = p(A), typeof $e == "function")
      for (A = $e.call(A), $e = 0; !(U = A.next()).done; )
        U = U.value, ie = Oe + z(U, $e++), oe += K(
          U,
          N,
          X,
          ie,
          j
        );
    else if (ie === "object") {
      if (typeof A.then == "function")
        return K(
          F(A),
          N,
          X,
          U,
          j
        );
      throw N = String(A), Error(
        "Objects are not valid as a React child (found: " + (N === "[object Object]" ? "object with keys {" + Object.keys(A).join(", ") + "}" : N) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return oe;
  }
  function B(A, N, X) {
    if (A == null) return A;
    var U = [], j = 0;
    return K(A, U, "", "", function(ie) {
      return N.call(X, ie, j++);
    }), U;
  }
  function $(A) {
    if (A._status === -1) {
      var N = A._result, X = N();
      X.then(
        function(U) {
          (A._status === 0 || A._status === -1) && (A._status = 1, A._result = U, X.status === void 0 && (X.status = "fulfilled", X.value = U));
        },
        function(U) {
          (A._status === 0 || A._status === -1) && (A._status = 2, A._result = U, X.status === void 0 && (X.status = "rejected", X.reason = U));
        }
      ), A._status === -1 && (A._status = 0, A._result = X);
    }
    if (A._status === 1) return A._result.default;
    throw A._result;
  }
  var I = typeof reportError == "function" ? reportError : function(A) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var N = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof A == "object" && A !== null && typeof A.message == "string" ? String(A.message) : String(A),
        error: A
      });
      if (!window.dispatchEvent(N)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", A);
      return;
    }
    console.error(A);
  };
  function q(A) {
    var N = S.T, X = {};
    X.types = N !== null ? N.types : null, S.T = X;
    try {
      var U = A(), j = S.S;
      j !== null && j(X, U), typeof U == "object" && U !== null && typeof U.then == "function" && U.then(E, I);
    } catch (ie) {
      I(ie);
    } finally {
      N !== null && X.types !== null && (N.types = X.types), S.T = N;
    }
  }
  function J(A) {
    var N = S.T;
    if (N !== null) {
      var X = N.types;
      X === null ? N.types = [A] : X.indexOf(A) === -1 && X.push(A);
    } else q(J.bind(null, A));
  }
  var D = {
    map: B,
    forEach: function(A, N, X) {
      B(
        A,
        function() {
          N.apply(this, arguments);
        },
        X
      );
    },
    count: function(A) {
      var N = 0;
      return B(A, function() {
        N++;
      }), N;
    },
    toArray: function(A) {
      return B(A, function(N) {
        return N;
      }) || [];
    },
    only: function(A) {
      if (!O(A))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return A;
    }
  };
  return xe.Activity = d, xe.Children = D, xe.Component = y, xe.Fragment = n, xe.Profiler = r, xe.PureComponent = _, xe.StrictMode = i, xe.Suspense = l, xe.ViewTransition = h, xe.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = S, xe.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(A) {
      return S.H.useMemoCache(A);
    }
  }, xe.addTransitionType = J, xe.cache = function(A) {
    return function() {
      return A.apply(null, arguments);
    };
  }, xe.cacheSignal = function() {
    return null;
  }, xe.cloneElement = function(A, N, X) {
    if (A == null)
      throw Error(
        "The argument must be a React element, but you passed " + A + "."
      );
    var U = g({}, A.props), j = A.key;
    if (N != null)
      for (ie in N.key !== void 0 && (j = "" + N.key), N)
        !P.call(N, ie) || ie === "key" || ie === "__self" || ie === "__source" || ie === "ref" && N.ref === void 0 || (U[ie] = N[ie]);
    var ie = arguments.length - 2;
    if (ie === 1) U.children = X;
    else if (1 < ie) {
      for (var oe = Array(ie), Oe = 0; Oe < ie; Oe++)
        oe[Oe] = arguments[Oe + 2];
      U.children = oe;
    }
    return C(A.type, j, U);
  }, xe.createContext = function(A) {
    return A = {
      $$typeof: o,
      _currentValue: A,
      _currentValue2: A,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, A.Provider = A, A.Consumer = {
      $$typeof: s,
      _context: A
    }, A;
  }, xe.createElement = function(A, N, X) {
    var U, j = {}, ie = null;
    if (N != null)
      for (U in N.key !== void 0 && (ie = "" + N.key), N)
        P.call(N, U) && U !== "key" && U !== "__self" && U !== "__source" && (j[U] = N[U]);
    var oe = arguments.length - 2;
    if (oe === 1) j.children = X;
    else if (1 < oe) {
      for (var Oe = Array(oe), $e = 0; $e < oe; $e++)
        Oe[$e] = arguments[$e + 2];
      j.children = Oe;
    }
    if (A && A.defaultProps)
      for (U in oe = A.defaultProps, oe)
        j[U] === void 0 && (j[U] = oe[U]);
    return C(A, ie, j);
  }, xe.createRef = function() {
    return { current: null };
  }, xe.forwardRef = function(A) {
    return { $$typeof: a, render: A };
  }, xe.isValidElement = O, xe.lazy = function(A) {
    return {
      $$typeof: u,
      _payload: { _status: -1, _result: A },
      _init: $
    };
  }, xe.memo = function(A, N) {
    return {
      $$typeof: c,
      type: A,
      compare: N === void 0 ? null : N
    };
  }, xe.startTransition = q, xe.unstable_useCacheRefresh = function() {
    return S.H.useCacheRefresh();
  }, xe.use = function(A) {
    return S.H.use(A);
  }, xe.useActionState = function(A, N, X) {
    return S.H.useActionState(A, N, X);
  }, xe.useCallback = function(A, N) {
    return S.H.useCallback(A, N);
  }, xe.useContext = function(A) {
    return S.H.useContext(A);
  }, xe.useDebugValue = function() {
  }, xe.useDeferredValue = function(A, N) {
    return S.H.useDeferredValue(A, N);
  }, xe.useEffect = function(A, N) {
    return S.H.useEffect(A, N);
  }, xe.useEffectEvent = function(A) {
    return S.H.useEffectEvent(A);
  }, xe.useId = function() {
    return S.H.useId();
  }, xe.useImperativeHandle = function(A, N, X) {
    return S.H.useImperativeHandle(A, N, X);
  }, xe.useInsertionEffect = function(A, N) {
    return S.H.useInsertionEffect(A, N);
  }, xe.useLayoutEffect = function(A, N) {
    return S.H.useLayoutEffect(A, N);
  }, xe.useMemo = function(A, N) {
    return S.H.useMemo(A, N);
  }, xe.useOptimistic = function(A, N) {
    return S.H.useOptimistic(A, N);
  }, xe.useReducer = function(A, N, X) {
    return S.H.useReducer(A, N, X);
  }, xe.useRef = function(A) {
    return S.H.useRef(A);
  }, xe.useState = function(A) {
    return S.H.useState(A);
  }, xe.useSyncExternalStore = function(A, N, X) {
    return S.H.useSyncExternalStore(
      A,
      N,
      X
    );
  }, xe.useTransition = function() {
    return S.H.useTransition();
  }, xe.version = "19.3.0", xe;
}
var ka = { exports: {} };
ka.exports;
var tm;
function FM() {
  return tm || (tm = 1, (function(t, e) {
    process.env.NODE_ENV !== "production" && (function() {
      function n(x, V) {
        Object.defineProperty(s.prototype, x, {
          get: function() {
            console.warn(
              "%s(...) is deprecated in plain JavaScript React classes. %s",
              V[0],
              V[1]
            );
          }
        });
      }
      function i(x) {
        return x === null || typeof x != "object" ? null : (x = Yi && x[Yi] || x["@@iterator"], typeof x == "function" ? x : null);
      }
      function r(x, V) {
        x = (x = x.constructor) && (x.displayName || x.name) || "ReactClass";
        var re = x + "." + V;
        ht[re] || (console.error(
          "Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.",
          V,
          x
        ), ht[re] = !0);
      }
      function s(x, V, re) {
        this.props = x, this.context = V, this.refs = Rt, this.updater = re || Jt;
      }
      function o() {
      }
      function a(x, V, re) {
        this.props = x, this.context = V, this.refs = Rt, this.updater = re || Jt;
      }
      function l() {
      }
      function c(x) {
        return "" + x;
      }
      function u(x) {
        try {
          c(x);
          var V = !1;
        } catch {
          V = !0;
        }
        if (V) {
          V = console;
          var re = V.error, ne = typeof Symbol == "function" && Symbol.toStringTag && x[Symbol.toStringTag] || x.constructor.name || "Object";
          return re.call(
            V,
            "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
            ne
          ), c(x);
        }
      }
      function d(x) {
        if (x == null) return null;
        if (typeof x == "function")
          return x.$$typeof === Ci ? null : x.displayName || x.name || null;
        if (typeof x == "string") return x;
        switch (x) {
          case D:
            return "Fragment";
          case N:
            return "Profiler";
          case A:
            return "StrictMode";
          case ie:
            return "Suspense";
          case oe:
            return "SuspenseList";
          case Ae:
            return "Activity";
          case Bt:
            return "ViewTransition";
        }
        if (typeof x == "object")
          switch (typeof x.tag == "number" && console.error(
            "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
          ), x.$$typeof) {
            case J:
              return "Portal";
            case U:
              return x.displayName || "Context";
            case X:
              return (x._context.displayName || "Context") + ".Consumer";
            case j:
              var V = x.render;
              return x = x.displayName, x || (x = V.displayName || V.name || "", x = x !== "" ? "ForwardRef(" + x + ")" : "ForwardRef"), x;
            case Oe:
              return V = x.displayName || null, V !== null ? V : d(x.type) || "Memo";
            case $e:
              V = x._payload, x = x._init;
              try {
                return d(x(V));
              } catch {
              }
          }
        return null;
      }
      function h(x) {
        if (x === D) return "<>";
        if (typeof x == "object" && x !== null && x.$$typeof === $e)
          return "<...>";
        try {
          var V = d(x);
          return V ? "<" + V + ">" : "<...>";
        } catch {
          return "<...>";
        }
      }
      function f() {
        var x = fe.A;
        return x === null ? null : x.getOwner();
      }
      function p() {
        return Error("react-stack-top-frame");
      }
      function v(x) {
        if (Nt.call(x, "key")) {
          var V = Object.getOwnPropertyDescriptor(x, "key").get;
          if (V && V.isReactWarning) return !1;
        }
        return x.key !== void 0;
      }
      function g(x, V) {
        function re() {
          Wf || (Wf = !0, console.error(
            "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
            V
          ));
        }
        re.isReactWarning = !0, Object.defineProperty(x, "key", {
          get: re,
          configurable: !0
        });
      }
      function m() {
        var x = d(this.type);
        return Gf[x] || (Gf[x] = !0, console.error(
          "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
        )), x = this.props.ref, x !== void 0 ? x : null;
      }
      function y(x, V, re, ne, ae, Ve) {
        var he = re.ref;
        return x = {
          $$typeof: q,
          type: x,
          key: V,
          props: re,
          _owner: ne
        }, (he !== void 0 ? he : null) !== null ? Object.defineProperty(x, "ref", {
          enumerable: !1,
          get: m
        }) : Object.defineProperty(x, "ref", { enumerable: !1, value: null }), x._store = {}, Object.defineProperty(x._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: 0
        }), Object.defineProperty(x, "_debugInfo", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: null
        }), Object.defineProperty(x, "_debugStack", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: ae
        }), Object.defineProperty(x, "_debugTask", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: Ve
        }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
      }
      function k(x, V) {
        return V = y(
          x.type,
          V,
          x.props,
          x._owner,
          x._debugStack,
          x._debugTask
        ), x._store && (V._store.validated = x._store.validated), V;
      }
      function _(x) {
        w(x) ? x._store && (x._store.validated = 1) : typeof x == "object" && x !== null && x.$$typeof === $e && (x._payload.status === "fulfilled" ? w(x._payload.value) && x._payload.value._store && (x._payload.value._store.validated = 1) : x._store && (x._store.validated = 1));
      }
      function w(x) {
        return typeof x == "object" && x !== null && x.$$typeof === q;
      }
      function T(x) {
        var V = { "=": "=0", ":": "=2" };
        return "$" + x.replace(/[=:]/g, function(re) {
          return V[re];
        });
      }
      function E(x, V) {
        return typeof x == "object" && x !== null && x.key != null ? (u(x.key), T("" + x.key)) : V.toString(36);
      }
      function S(x) {
        switch (x.status) {
          case "fulfilled":
            return x.value;
          case "rejected":
            throw x.reason;
          default:
            switch (typeof x.status == "string" ? x.then(l, l) : (x.status = "pending", x.then(
              function(V) {
                x.status === "pending" && (x.status = "fulfilled", x.value = V);
              },
              function(V) {
                x.status === "pending" && (x.status = "rejected", x.reason = V);
              }
            )), x.status) {
              case "fulfilled":
                return x.value;
              case "rejected":
                throw x.reason;
            }
        }
        throw x;
      }
      function P(x, V, re, ne, ae) {
        var Ve = typeof x;
        (Ve === "undefined" || Ve === "boolean") && (x = null);
        var he = !1;
        if (x === null) he = !0;
        else
          switch (Ve) {
            case "bigint":
            case "string":
            case "number":
              he = !0;
              break;
            case "object":
              switch (x.$$typeof) {
                case q:
                case J:
                  he = !0;
                  break;
                case $e:
                  return he = x._init, P(
                    he(x._payload),
                    V,
                    re,
                    ne,
                    ae
                  );
              }
          }
        if (he) {
          he = x, ae = ae(he);
          var Te = ne === "" ? "." + E(he, 0) : ne;
          return Ti(ae) ? (re = "", Te != null && (re = Te.replace(Yf, "$&/") + "/"), P(ae, V, re, "", function(En) {
            return En;
          })) : ae != null && (w(ae) && (ae.key != null && (he && he.key === ae.key || u(ae.key)), re = k(
            ae,
            re + (ae.key == null || he && he.key === ae.key ? "" : ("" + ae.key).replace(
              Yf,
              "$&/"
            ) + "/") + Te
          ), ne !== "" && he != null && w(he) && he.key == null && he._store && !he._store.validated && (re._store.validated = 2), ae = re), V.push(ae)), 1;
        }
        if (he = 0, Te = ne === "" ? "." : ne + ":", Ti(x))
          for (var Ne = 0; Ne < x.length; Ne++)
            ne = x[Ne], Ve = Te + E(ne, Ne), he += P(
              ne,
              V,
              re,
              Ve,
              ae
            );
        else if (Ne = i(x), typeof Ne == "function")
          for (Ne === x.entries && (Kf || console.warn(
            "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
          ), Kf = !0), x = Ne.call(x), Ne = 0; !(ne = x.next()).done; )
            ne = ne.value, Ve = Te + E(ne, Ne++), he += P(
              ne,
              V,
              re,
              Ve,
              ae
            );
        else if (Ve === "object") {
          if (typeof x.then == "function")
            return P(
              S(x),
              V,
              re,
              ne,
              ae
            );
          throw V = String(x), Error(
            "Objects are not valid as a React child (found: " + (V === "[object Object]" ? "object with keys {" + Object.keys(x).join(", ") + "}" : V) + "). If you meant to render a collection of children, use an array instead."
          );
        }
        return he;
      }
      function C(x, V, re) {
        if (x == null) return x;
        var ne = [], ae = 0;
        return P(x, ne, "", "", function(Ve) {
          return V.call(re, Ve, ae++);
        }), ne;
      }
      function M(x) {
        if (x._status === -1) {
          var V = null, re = null, ne = x._ioInfo;
          ne != null && (ne.start = ne.end = performance.now(), ne.value = new Promise(function(he, Te) {
            V = he, re = Te;
          })), ne = x._result;
          var ae = ne();
          if (ae.then(
            function(he) {
              if (x._status === 0 || x._status === -1) {
                x._status = 1, x._result = he;
                var Te = x._ioInfo;
                if (Te != null) {
                  Te.end = performance.now();
                  var Ne = he?.default;
                  V(Ne), Te.value.status = "fulfilled", Te.value.value = Ne;
                }
                ae.status === void 0 && (ae.status = "fulfilled", ae.value = he);
              }
            },
            function(he) {
              if (x._status === 0 || x._status === -1) {
                x._status = 2, x._result = he;
                var Te = x._ioInfo;
                Te != null && (Te.end = performance.now(), Te.value.then(l, l), re(he), Te.value.status = "rejected", Te.value.reason = he), ae.status === void 0 && (ae.status = "rejected", ae.reason = he);
              }
            }
          ), ne = x._ioInfo, ne != null) {
            var Ve = ae.displayName;
            typeof Ve == "string" && (ne.name = Ve);
          }
          x._status === -1 && (x._status = 0, x._result = ae);
        }
        if (x._status === 1)
          return ne = x._result, ne === void 0 && console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`,
            ne
          ), "default" in ne || console.error(
            `lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`,
            ne
          ), ne.default;
        throw x._result;
      }
      function O() {
        var x = fe.H;
        return x === null && console.error(
          `Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem.`
        ), x;
      }
      function W() {
        fe.asyncTransitions--;
      }
      function H(x) {
        var V = fe.T, re = {};
        re.types = V !== null ? V.types : null, re._updatedFibers = /* @__PURE__ */ new Set(), fe.T = re;
        try {
          var ne = x(), ae = fe.S;
          ae !== null && ae(re, ne), typeof ne == "object" && ne !== null && typeof ne.then == "function" && (fe.asyncTransitions++, ne.then(W, W), ne.then(l, Xf));
        } catch (Ve) {
          Xf(Ve);
        } finally {
          V === null && re._updatedFibers && (x = re._updatedFibers.size, re._updatedFibers.clear(), 10 < x && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          )), V !== null && re.types !== null && (V.types !== null && V.types !== re.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), V.types = re.types), fe.T = V;
        }
      }
      function z(x) {
        var V = fe.T;
        if (V !== null) {
          var re = V.types;
          re === null ? V.types = [x] : re.indexOf(x) === -1 && re.push(x);
        } else
          fe.asyncTransitions === 0 && console.error(
            "addTransitionType can only be called inside a `startTransition()` callback. It must be associated with a specific Transition."
          ), H(z.bind(null, x));
      }
      function F(x) {
        if (Io === null)
          try {
            var V = ("require" + Math.random()).slice(0, 7);
            Io = (t && t[V]).call(
              t,
              "timers"
            ).setImmediate;
          } catch {
            Io = function(re) {
              Jf === !1 && (Jf = !0, typeof MessageChannel > "u" && console.error(
                "This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."
              ));
              var ne = new MessageChannel();
              ne.port1.onmessage = re, ne.port2.postMessage(void 0);
            };
          }
        return Io(x);
      }
      function K(x) {
        return 1 < x.length && typeof AggregateError == "function" ? new AggregateError(x) : x[0];
      }
      function B(x, V) {
        V !== Do - 1 && console.error(
          "You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "
        ), Do = V;
      }
      function $(x, V, re) {
        var ne = fe.actQueue;
        if (ne !== null)
          if (ne.length !== 0)
            try {
              I(ne), F(function() {
                return $(x, V, re);
              });
              return;
            } catch (ae) {
              fe.thrownErrors.push(ae);
            }
          else fe.actQueue = null;
        0 < fe.thrownErrors.length ? (ne = K(fe.thrownErrors), fe.thrownErrors.length = 0, re(ne)) : V(x);
      }
      function I(x) {
        if (!sc) {
          sc = !0;
          var V = 0;
          try {
            for (; V < x.length; V++) {
              var re = x[V];
              do {
                fe.didUsePromise = !1;
                var ne = re(!1);
                if (ne !== null) {
                  if (fe.didUsePromise) {
                    x[V] = re, x.splice(0, V);
                    return;
                  }
                  re = ne;
                } else break;
              } while (!0);
            }
            x.length = 0;
          } catch (ae) {
            x.splice(0, V + 1), fe.thrownErrors.push(ae);
          } finally {
            sc = !1;
          }
        }
      }
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      var q = /* @__PURE__ */ Symbol.for("react.transitional.element"), J = /* @__PURE__ */ Symbol.for("react.portal"), D = /* @__PURE__ */ Symbol.for("react.fragment"), A = /* @__PURE__ */ Symbol.for("react.strict_mode"), N = /* @__PURE__ */ Symbol.for("react.profiler"), X = /* @__PURE__ */ Symbol.for("react.consumer"), U = /* @__PURE__ */ Symbol.for("react.context"), j = /* @__PURE__ */ Symbol.for("react.forward_ref"), ie = /* @__PURE__ */ Symbol.for("react.suspense"), oe = /* @__PURE__ */ Symbol.for("react.suspense_list"), Oe = /* @__PURE__ */ Symbol.for("react.memo"), $e = /* @__PURE__ */ Symbol.for("react.lazy"), Ae = /* @__PURE__ */ Symbol.for("react.activity"), Bt = /* @__PURE__ */ Symbol.for("react.view_transition"), Yi = Symbol.iterator, ht = {}, Jt = {
        isMounted: function() {
          return !1;
        },
        enqueueForceUpdate: function(x) {
          r(x, "forceUpdate");
        },
        enqueueReplaceState: function(x) {
          r(x, "replaceState");
        },
        enqueueSetState: function(x) {
          r(x, "setState");
        }
      }, Ht = Object.assign, Rt = {};
      Object.freeze(Rt), s.prototype.isReactComponent = {}, s.prototype.setState = function(x, V) {
        if (typeof x != "object" && typeof x != "function" && x != null)
          throw Error(
            "takes an object of state variables to update or a function which returns an object of state variables."
          );
        this.updater.enqueueSetState(this, x, V, "setState");
      }, s.prototype.forceUpdate = function(x) {
        this.updater.enqueueForceUpdate(this, x, "forceUpdate");
      };
      var it = {
        isMounted: [
          "isMounted",
          "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
          "replaceState",
          "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
      };
      for (hs in it)
        it.hasOwnProperty(hs) && n(hs, it[hs]);
      o.prototype = s.prototype, it = a.prototype = new o(), it.constructor = a, Ht(it, s.prototype), it.isPureReactComponent = !0;
      var Ti = Array.isArray, Ci = /* @__PURE__ */ Symbol.for("react.client.reference"), fe = {
        H: null,
        A: null,
        T: null,
        S: null,
        actQueue: null,
        asyncTransitions: 0,
        isBatchingLegacy: !1,
        didScheduleLegacyUpdate: !1,
        didUsePromise: !1,
        thrownErrors: [],
        getCurrentStack: null,
        recentlyCreatedOwnerStacks: 0
      }, Nt = Object.prototype.hasOwnProperty, Oo = console.createTask ? console.createTask : function() {
        return null;
      };
      it = {
        react_stack_bottom_frame: function(x) {
          return x();
        }
      };
      var Wf, qf, Gf = {}, oS = it.react_stack_bottom_frame.bind(
        it,
        p
      )(), aS = Oo(h(p)), Kf = !1, Yf = /\/+/g, Xf = typeof reportError == "function" ? reportError : function(x) {
        if (typeof window == "object" && typeof window.ErrorEvent == "function") {
          var V = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: typeof x == "object" && x !== null && typeof x.message == "string" ? String(x.message) : String(x),
            error: x
          });
          if (!window.dispatchEvent(V)) return;
        } else if (typeof process == "object" && typeof process.emit == "function") {
          process.emit("uncaughtException", x);
          return;
        }
        console.error(x);
      }, Jf = !1, Io = null, Do = 0, Fo = !1, sc = !1, Zf = typeof queueMicrotask == "function" ? function(x) {
        queueMicrotask(function() {
          return queueMicrotask(x);
        });
      } : F;
      it = Object.freeze({
        __proto__: null,
        c: function(x) {
          return O().useMemoCache(x);
        }
      });
      var hs = {
        map: C,
        forEach: function(x, V, re) {
          C(
            x,
            function() {
              V.apply(this, arguments);
            },
            re
          );
        },
        count: function(x) {
          var V = 0;
          return C(x, function() {
            V++;
          }), V;
        },
        toArray: function(x) {
          return C(x, function(V) {
            return V;
          }) || [];
        },
        only: function(x) {
          if (!w(x))
            throw Error(
              "React.Children.only expected to receive a single React element child."
            );
          return x;
        }
      };
      e.Activity = Ae, e.Children = hs, e.Component = s, e.Fragment = D, e.Profiler = N, e.PureComponent = a, e.StrictMode = A, e.Suspense = ie, e.ViewTransition = Bt, e.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = fe, e.__COMPILER_RUNTIME = it, e.act = function(x) {
        var V = fe.actQueue, re = Do;
        Do++;
        var ne = fe.actQueue = V !== null ? V : [], ae = !1;
        try {
          var Ve = x();
        } catch (Ne) {
          fe.thrownErrors.push(Ne);
        }
        if (0 < fe.thrownErrors.length)
          throw B(V, re), x = K(fe.thrownErrors), fe.thrownErrors.length = 0, x;
        if (Ve !== null && typeof Ve == "object" && typeof Ve.then == "function") {
          var he = Ve;
          return Zf(function() {
            ae || Fo || (Fo = !0, console.error(
              "You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"
            ));
          }), {
            then: function(Ne, En) {
              ae = !0, he.then(
                function(fs) {
                  if (B(V, re), re === 0) {
                    try {
                      I(ne), F(function() {
                        return $(
                          fs,
                          Ne,
                          En
                        );
                      });
                    } catch (cS) {
                      fe.thrownErrors.push(cS);
                    }
                    if (0 < fe.thrownErrors.length) {
                      var lS = K(
                        fe.thrownErrors
                      );
                      fe.thrownErrors.length = 0, En(lS);
                    }
                  } else Ne(fs);
                },
                function(fs) {
                  B(V, re), 0 < fe.thrownErrors.length && (fs = K(
                    fe.thrownErrors
                  ), fe.thrownErrors.length = 0), En(fs);
                }
              );
            }
          };
        }
        var Te = Ve;
        if (B(V, re), re === 0 && (I(ne), ne.length !== 0 && Zf(function() {
          ae || Fo || (Fo = !0, console.error(
            "A component suspended inside an `act` scope, but the `act` call was not awaited. When testing React components that depend on asynchronous data, you must await the result:\n\nawait act(() => ...)"
          ));
        }), fe.actQueue = null), 0 < fe.thrownErrors.length)
          throw x = K(fe.thrownErrors), fe.thrownErrors.length = 0, x;
        return {
          then: function(Ne, En) {
            ae = !0, re === 0 ? (fe.actQueue = ne, F(function() {
              return $(
                Te,
                Ne,
                En
              );
            })) : Ne(Te);
          }
        };
      }, e.addTransitionType = z, e.cache = function(x) {
        return function() {
          return x.apply(null, arguments);
        };
      }, e.cacheSignal = function() {
        return null;
      }, e.captureOwnerStack = function() {
        var x = fe.getCurrentStack;
        return x === null ? null : x();
      }, e.cloneElement = function(x, V, re) {
        if (x == null)
          throw Error(
            "The argument must be a React element, but you passed " + x + "."
          );
        var ne = Ht({}, x.props), ae = x.key, Ve = x._owner;
        if (V != null) {
          var he;
          e: {
            if (Nt.call(V, "ref") && (he = Object.getOwnPropertyDescriptor(
              V,
              "ref"
            ).get) && he.isReactWarning) {
              he = !1;
              break e;
            }
            he = V.ref !== void 0;
          }
          he && (Ve = f()), v(V) && (u(V.key), ae = "" + V.key);
          for (Te in V)
            !Nt.call(V, Te) || Te === "key" || Te === "__self" || Te === "__source" || Te === "ref" && V.ref === void 0 || (ne[Te] = V[Te]);
        }
        var Te = arguments.length - 2;
        if (Te === 1) ne.children = re;
        else if (1 < Te) {
          he = Array(Te);
          for (var Ne = 0; Ne < Te; Ne++)
            he[Ne] = arguments[Ne + 2];
          ne.children = he;
        }
        for (ne = y(
          x.type,
          ae,
          ne,
          Ve,
          x._debugStack,
          x._debugTask
        ), ae = 2; ae < arguments.length; ae++)
          _(arguments[ae]);
        return ne;
      }, e.createContext = function(x) {
        return x = {
          $$typeof: U,
          _currentValue: x,
          _currentValue2: x,
          _threadCount: 0,
          Provider: null,
          Consumer: null
        }, x.Provider = x, x.Consumer = {
          $$typeof: X,
          _context: x
        }, x._currentRenderer = null, x._currentRenderer2 = null, x;
      }, e.createElement = function(x, V, re) {
        for (var ne = 2; ne < arguments.length; ne++)
          _(arguments[ne]);
        var ae;
        ne = {};
        var Ve = null;
        if (V != null)
          for (ae in qf || !("__self" in V) || "key" in V || (qf = !0, console.warn(
            "Your app (or one of its dependencies) is using an outdated JSX transform. Update to the modern JSX transform for faster performance: https://react.dev/link/new-jsx-transform"
          )), v(V) && (u(V.key), Ve = "" + V.key), V)
            Nt.call(V, ae) && ae !== "key" && ae !== "__self" && ae !== "__source" && (ne[ae] = V[ae]);
        var he = arguments.length - 2;
        if (he === 1) ne.children = re;
        else if (1 < he) {
          for (var Te = Array(he), Ne = 0; Ne < he; Ne++)
            Te[Ne] = arguments[Ne + 2];
          Object.freeze && Object.freeze(Te), ne.children = Te;
        }
        if (x && x.defaultProps)
          for (ae in he = x.defaultProps, he)
            ne[ae] === void 0 && (ne[ae] = he[ae]);
        return Ve && g(
          ne,
          typeof x == "function" ? x.displayName || x.name || "Unknown" : x
        ), (ae = 1e4 > fe.recentlyCreatedOwnerStacks++) ? (Te = Error.stackTraceLimit, Error.stackTraceLimit = 10, he = Error("react-stack-top-frame"), Error.stackTraceLimit = Te) : he = oS, y(
          x,
          Ve,
          ne,
          f(),
          he,
          ae ? Oo(h(x)) : aS
        );
      }, e.createRef = function() {
        var x = { current: null };
        return Object.seal(x), x;
      }, e.forwardRef = function(x) {
        x != null && x.$$typeof === Oe ? console.error(
          "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))."
        ) : typeof x != "function" ? console.error(
          "forwardRef requires a render function but was given %s.",
          x === null ? "null" : typeof x
        ) : x.length !== 0 && x.length !== 2 && console.error(
          "forwardRef render functions accept exactly two parameters: props and ref. %s",
          x.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."
        ), x != null && x.defaultProps != null && console.error(
          "forwardRef render functions do not support defaultProps. Did you accidentally pass a React component?"
        );
        var V = { $$typeof: j, render: x }, re;
        return Object.defineProperty(V, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return re;
          },
          set: function(ne) {
            re = ne, x.name || x.displayName || (Object.defineProperty(x, "name", { value: ne }), x.displayName = ne);
          }
        }), V;
      }, e.isValidElement = w, e.lazy = function(x) {
        x = { _status: -1, _result: x };
        var V = {
          $$typeof: $e,
          _payload: x,
          _init: M
        }, re = {
          name: "lazy",
          start: -1,
          end: -1,
          value: null,
          owner: null,
          debugStack: Error("react-stack-top-frame"),
          debugTask: console.createTask ? console.createTask("lazy()") : null
        };
        return x._ioInfo = re, V._debugInfo = [{ awaited: re }], V;
      }, e.memo = function(x, V) {
        x == null && console.error(
          "memo: The first argument must be a component. Instead received: %s",
          x === null ? "null" : typeof x
        ), V = {
          $$typeof: Oe,
          type: x,
          compare: V === void 0 ? null : V
        };
        var re;
        return Object.defineProperty(V, "displayName", {
          enumerable: !1,
          configurable: !0,
          get: function() {
            return re;
          },
          set: function(ne) {
            re = ne, x.name || x.displayName || (Object.defineProperty(x, "name", { value: ne }), x.displayName = ne);
          }
        }), V;
      }, e.startTransition = H, e.unstable_useCacheRefresh = function() {
        return O().useCacheRefresh();
      }, e.use = function(x) {
        return O().use(x);
      }, e.useActionState = function(x, V, re) {
        return O().useActionState(
          x,
          V,
          re
        );
      }, e.useCallback = function(x, V) {
        return O().useCallback(x, V);
      }, e.useContext = function(x) {
        var V = O();
        return x.$$typeof === X && console.error(
          "Calling useContext(Context.Consumer) is not supported and will cause bugs. Did you mean to call useContext(Context) instead?"
        ), V.useContext(x);
      }, e.useDebugValue = function(x, V) {
        return O().useDebugValue(x, V);
      }, e.useDeferredValue = function(x, V) {
        return O().useDeferredValue(x, V);
      }, e.useEffect = function(x, V) {
        return x == null && console.warn(
          "React Hook useEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), O().useEffect(x, V);
      }, e.useEffectEvent = function(x) {
        return O().useEffectEvent(x);
      }, e.useId = function() {
        return O().useId();
      }, e.useImperativeHandle = function(x, V, re) {
        return O().useImperativeHandle(x, V, re);
      }, e.useInsertionEffect = function(x, V) {
        return x == null && console.warn(
          "React Hook useInsertionEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), O().useInsertionEffect(x, V);
      }, e.useLayoutEffect = function(x, V) {
        return x == null && console.warn(
          "React Hook useLayoutEffect requires an effect callback. Did you forget to pass a callback to the hook?"
        ), O().useLayoutEffect(x, V);
      }, e.useMemo = function(x, V) {
        return O().useMemo(x, V);
      }, e.useOptimistic = function(x, V) {
        return O().useOptimistic(x, V);
      }, e.useReducer = function(x, V, re) {
        return O().useReducer(x, V, re);
      }, e.useRef = function(x) {
        return O().useRef(x);
      }, e.useState = function(x) {
        return O().useState(x);
      }, e.useSyncExternalStore = function(x, V, re) {
        return O().useSyncExternalStore(
          x,
          V,
          re
        );
      }, e.useTransition = function() {
        return O().useTransition();
      }, e.version = "19.3.0", typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(ka, ka.exports)), ka.exports;
}
var im;
function LM() {
  return im || (im = 1, process.env.NODE_ENV === "production" ? yc.exports = DM() : yc.exports = FM()), yc.exports;
}
var Un = LM();
const NM = (t) => t?.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
function VM(t, e, n = []) {
  if (e == null)
    throw new Error("[lucide]: iconNode is required when icon name is used");
  return {
    name: NM(t),
    size: 24,
    node: e,
    ...n.length > 0 ? { aliases: n } : {}
  };
}
const jM = (t) => {
  let e = "", n = !1;
  for (const i of t) {
    if (i === "-" || i === "_" || i <= " ") {
      n = e.length > 0;
      continue;
    }
    e.length === 0 ? e += i.toLowerCase() : e += n ? i.toUpperCase() : i, n = !1;
  }
  return e;
}, zM = (t) => {
  const e = jM(t);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, Qu = (...t) => t.filter((e, n, i) => !!e && e.trim() !== "" && i.indexOf(e) === n).join(" ").trim(), An = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function bc(t) {
  return t != null;
}
function BM(t, e = {}) {
  const n = e.attributeNames ?? {}, i = (d) => n[d] ?? d, r = t.size ?? t.width ?? An.width, s = t.size ?? t.height ?? An.height, o = t.aliases?.filter((d) => typeof d == "string" && d.trim() !== "").map((d) => `lucide-${d}`) ?? [], a = [...t.name ? [`lucide-${t.name}`] : [], ...o], l = e.className?.split(" ").filter(Boolean) ?? [], c = e.includeDefaultClasses === !1 ? Qu(...l) : Qu("lucide", ...a, ...l), u = e.absoluteStrokeWidth ? Number(e.strokeWidth ?? An["stroke-width"]) * Number(t.size ?? t.width ?? An.width) / Number(e.size ?? e.width ?? An.width) : e.strokeWidth ?? An["stroke-width"];
  return [
    "svg",
    {
      ...Object.entries(An).reduce((d, [h, f]) => (d[i(h)] = f, d), {}),
      ..."color" in e && e.color && {
        [i("stroke")]: e.color
      },
      ..."size" in e && bc(e.size) && {
        [i("width")]: e.size,
        [i("height")]: e.size
      },
      ..."width" in e && bc(e.width) && {
        [i("width")]: e.width
      },
      ..."height" in e && bc(e.height) && {
        [i("height")]: e.height
      },
      [i("stroke-width")]: u,
      ...c && {
        [i("class")]: c
      },
      [i("viewBox")]: `0 0 ${r} ${s}`,
      ...e.hasA11yProp === !1 ? {
        [i("aria-hidden")]: "true"
      } : {},
      ..."attributes" in e && e.attributes
    },
    t.node.map((d) => {
      const [h, f, p] = d, v = e.nonScalingStroke ? { [i("vector-effect")]: "non-scaling-stroke", ...f } : f;
      return p ? [h, v, p] : [h, v];
    })
  ];
}
function HM(t, e = {}) {
  return BM(t, {
    ...e,
    attributeNames: {
      ...e.attributeNames,
      class: "className",
      "stroke-width": "strokeWidth",
      "stroke-linecap": "strokeLinecap",
      "stroke-linejoin": "strokeLinejoin",
      "vector-effect": "vectorEffect"
    }
  });
}
const UM = (t) => {
  for (const e in t)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
  return !1;
}, WM = Un.createContext({}), qM = () => Un.useContext(WM), GM = Un.forwardRef(
  ({
    color: t,
    size: e,
    width: n,
    height: i,
    strokeWidth: r,
    absoluteStrokeWidth: s,
    nonScalingStroke: o,
    className: a = "",
    children: l,
    iconNode: c = [],
    icon: u = {
      node: c,
      aliases: [],
      size: 24
    },
    ...d
  }, h) => {
    const {
      size: f = 24,
      strokeWidth: p = 2,
      absoluteStrokeWidth: v = !1,
      nonScalingStroke: g = !1,
      color: m = "currentColor",
      className: y = ""
    } = qM() ?? {}, k = !!l || UM(d), [_, w, T = []] = HM(u, {
      color: t ?? m,
      width: n ?? e ?? f,
      height: i ?? e ?? f,
      strokeWidth: r ?? p,
      absoluteStrokeWidth: s ?? v,
      nonScalingStroke: o ?? g,
      className: Qu(y, a),
      hasA11yProp: k,
      attributes: d
    });
    return Un.createElement(
      _,
      {
        ref: h,
        ...w
      },
      [
        ...T.map(([E, S]) => Un.createElement(E, S)),
        ...Array.isArray(l) ? l : [l]
      ]
    );
  }
);
function xt(t, e = [], n = []) {
  const i = typeof t == "string" ? VM(t, e, n) : t, r = Un.forwardRef(
    ({ className: s, ...o }, a) => Un.createElement(GM, {
      ref: a,
      icon: i,
      className: s,
      ...o
    })
  );
  return i.name && (r.displayName = zM(i.name)), r;
}
const d1 = {
  name: "arrow-right",
  size: 24,
  node: [
    ["path", { d: "M5 12h14", key: "1ays0h" }],
    ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
  ]
};
d1.node;
xt(d1);
const h1 = {
  name: "bookmark",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z",
        key: "oz39mx"
      }
    ]
  ]
};
h1.node;
xt(h1);
const f1 = {
  name: "chevron-right",
  size: 24,
  node: [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]]
};
f1.node;
xt(f1);
const p1 = {
  name: "circle-check-big",
  size: 24,
  node: [
    ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
    ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
  ],
  aliases: ["check-circle"]
};
p1.node;
xt(p1);
const m1 = {
  name: "circle-play",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M9 9.003a1 1 0 0 1 1.517-.859l4.997 2.997a1 1 0 0 1 0 1.718l-4.997 2.997A1 1 0 0 1 9 14.996z",
        key: "kmsa83"
      }
    ],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["play-circle"]
};
m1.node;
xt(m1);
const g1 = {
  name: "circle",
  size: 24,
  node: [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]]
};
g1.node;
xt(g1);
const v1 = {
  name: "coffee",
  size: 24,
  node: [
    ["path", { d: "M10 2v2", key: "7u0qdc" }],
    ["path", { d: "M14 2v2", key: "6buw04" }],
    [
      "path",
      {
        d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
        key: "pwadti"
      }
    ],
    ["path", { d: "M6 2v2", key: "colzsn" }]
  ]
};
v1.node;
xt(v1);
const y1 = {
  name: "dollar-sign",
  size: 24,
  node: [
    ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
    ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
  ]
};
y1.node;
xt(y1);
const b1 = {
  name: "gift",
  size: 24,
  node: [
    ["path", { d: "M12 7v14", key: "1akyts" }],
    ["path", { d: "M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "1sqzm4" }],
    [
      "path",
      { d: "M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5", key: "kc0143" }
    ],
    ["rect", { x: "3", y: "7", width: "18", height: "4", rx: "1", key: "1hberx" }]
  ]
};
b1.node;
xt(b1);
const _1 = {
  name: "heart",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5",
        key: "mvr1a0"
      }
    ]
  ]
};
_1.node;
xt(_1);
const w1 = {
  name: "info",
  size: 24,
  node: [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }]
  ]
};
w1.node;
xt(w1);
const k1 = {
  name: "share-2",
  size: 24,
  node: [
    ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
    ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
    ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
    ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
    ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
  ]
};
k1.node;
xt(k1);
const x1 = {
  name: "shopping-bag",
  size: 24,
  node: [
    ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }],
    ["path", { d: "M3.103 6.034h17.794", key: "awc11p" }],
    [
      "path",
      {
        d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
        key: "o988cm"
      }
    ]
  ]
};
x1.node;
xt(x1);
const S1 = {
  name: "shopping-cart",
  size: 24,
  node: [
    [
      "path",
      {
        d: "m2.05 2.05 1.099-.028a1 1 0 0 1 1.008.815l2.69 14.347A1 1 0 0 0 7.83 18H18",
        key: "uebgi3"
      }
    ],
    [
      "path",
      {
        d: "M4.563 5h16.435a1 1 0 0 1 .981 1.204l-1.026 6.226A2 2 0 0 1 18.962 14H6.25",
        key: "1j7c9p"
      }
    ],
    ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
    ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
  ]
};
S1.node;
xt(S1);
const P1 = {
  name: "star",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
        key: "r04s7s"
      }
    ]
  ]
};
P1.node;
xt(P1);
const E1 = {
  name: "tag",
  size: 24,
  node: [
    [
      "path",
      {
        d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
        key: "vktsd0"
      }
    ],
    ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
  ]
};
E1.node;
xt(E1);
function T1({
  imageUrl: t,
  alt: e = "",
  href: n,
  onClick: i,
  imgClassName: r,
  linkClassName: s
}) {
  const o = /* @__PURE__ */ b("img", { src: t, alt: e, className: r });
  return n ? /* @__PURE__ */ b(
    "a",
    {
      href: Wr(n),
      target: "_blank",
      rel: "noopener noreferrer",
      className: s,
      onClick: i,
      children: o
    }
  ) : o;
}
function C1({
  text: t,
  background: e,
  border: n,
  href: i,
  onClick: r
}) {
  const s = /* @__PURE__ */ b(
    "button",
    {
      style: {
        padding: "0.4rem 0.9rem",
        borderRadius: "0.375rem",
        fontWeight: 600,
        fontSize: "0.8rem",
        cursor: "pointer",
        background: e ?? "#fff",
        border: `1px solid ${n ?? "transparent"}`,
        color: "#000"
      },
      children: t
    }
  );
  return i ? /* @__PURE__ */ b(
    "a",
    {
      href: Wr(i),
      target: "_blank",
      rel: "noopener noreferrer",
      style: { display: "block" },
      onClick: r,
      children: s
    }
  ) : s;
}
const Ai = "0.75rem", KM = "4rem", YM = "0.75rem";
function XM(t, e) {
  const n = e ? KM : YM;
  switch (t) {
    case "top-left":
      return { top: Ai, left: Ai };
    case "top-center":
      return { top: Ai, left: "50%", transform: "translateX(-50%)" };
    case "top-right":
      return { top: Ai, right: Ai };
    case "left":
      return { top: "50%", left: Ai, transform: "translateY(-50%)" };
    case "center":
      return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
    case "right":
      return { top: "50%", right: Ai, transform: "translateY(-50%)" };
    case "bottom-left":
      return { bottom: n, left: Ai };
    case "bottom-center":
      return { bottom: n, left: "50%", transform: "translateX(-50%)" };
    case "bottom-right":
      return { bottom: n, right: Ai };
  }
}
function JM({
  imageUrl: t,
  alt: e = "Call to action",
  buttonText: n,
  buttonBackground: i,
  buttonBorder: r,
  href: s,
  location: o = "bottom-right",
  opacity: a = 1,
  startTime: l,
  endTime: c,
  width: u = "25%",
  children: d
}) {
  const h = Po(), f = tt.usePlayer((C) => C.paused), p = tt.usePlayer((C) => C.currentTime), v = tt.usePlayer((C) => C.duration), g = tt.usePlayer((C) => C.isFullscreen), m = tt.usePlayer(Ei), [y, k] = ue(!1);
  ye(() => {
    f || k(!0);
  }, [f]);
  const _ = l != null ? p >= l : !0, w = c != null ? p <= c : v > 0 && p > 0 && p < v, T = y && _ && w, E = (m?.controlsVisible ?? !0) && !g, S = o.startsWith("bottom"), P = d ?? (t ? /* @__PURE__ */ b(
    T1,
    {
      imageUrl: t,
      alt: e,
      href: s,
      onClick: () => h?.pause(),
      imgClassName: "w-full block rounded-lg shadow-lg",
      linkClassName: "hover:opacity-80 transition-opacity"
    }
  ) : n ? /* @__PURE__ */ b(
    C1,
    {
      text: n,
      background: i,
      border: r,
      href: s,
      onClick: () => h?.pause()
    }
  ) : null);
  return P ? /* @__PURE__ */ b(
    "div",
    {
      style: {
        position: "absolute",
        zIndex: 10,
        width: u,
        transition: `${S ? "bottom 300ms, " : ""}opacity 300ms`,
        opacity: T ? E ? 1 : a : 0,
        pointerEvents: T ? "auto" : "none",
        ...XM(o, E)
      },
      children: P
    }
  ) : null;
}
function nm(t, e, n, i, r) {
  for (e = e.split ? e.split(".") : e, i = 0; i < e.length; i++) t = t ? t[e[i]] : r;
  return t === r ? n : t;
}
var ZM = "function", QM = "string", oi = "undefined", eO = "boolean", Ya = "object", tO = "array", iO = "number", nO = "symbol", rO = "null", A1 = "any", $1 = "*", Qn = "__", sO = "form", oO = "input", aO = "button", lO = "select", Xa = typeof process !== oi ? process : {};
Xa.env && Xa.env.NODE_ENV;
var ci = typeof document !== oi;
Xa.versions != null && Xa.versions.node != null;
typeof Deno !== oi && Deno.core;
ci && window.name === "nodejs" || typeof navigator !== oi && typeof navigator.userAgent !== oi && (navigator.userAgent.includes("Node.js") || navigator.userAgent.includes("jsdom"));
function R1(t, e) {
  return e.charAt(0)[t]() + e.slice(1);
}
var cO = R1.bind(null, "toUpperCase"), uO = R1.bind(null, "toLowerCase");
function dO(t) {
  return M1(t) ? cO(rO) : typeof t === Ya ? gO(t) : Object.prototype.toString.call(t).slice(8, -1);
}
function Ja(t, e) {
  e === void 0 && (e = !0);
  var n = dO(t);
  return e ? uO(n) : n;
}
function Eo(t, e) {
  return typeof e === t;
}
var vi = Eo.bind(null, ZM), Ir = Eo.bind(null, QM), xr = Eo.bind(null, oi), hO = Eo.bind(null, eO);
Eo.bind(null, nO);
function M1(t) {
  return t === null;
}
function fO(t) {
  return Ja(t) === iO && !isNaN(t);
}
function pO(t) {
  return Ja(t) === tO;
}
function Mt(t) {
  if (!mO(t)) return !1;
  for (var e = t; Object.getPrototypeOf(e) !== null; ) e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
function mO(t) {
  return t && (typeof t === Ya || t !== null);
}
function gO(t) {
  return vi(t.constructor) ? t.constructor.name : null;
}
function vO(t) {
  return t instanceof Error || Ir(t.message) && t.constructor && fO(t.constructor.stackTraceLimit);
}
function O1(t, e) {
  if (typeof e != "object" || M1(e)) return !1;
  if (e instanceof t) return !0;
  var n = Ja(new t(""));
  if (vO(e)) for (; e; ) {
    if (Ja(e) === n) return !0;
    e = Object.getPrototypeOf(e);
  }
  return !1;
}
O1.bind(null, TypeError);
O1.bind(null, SyntaxError);
function Wl(t, e) {
  var n = t instanceof Element || t instanceof HTMLDocument;
  return n && e ? yO(t, e) : n;
}
function yO(t, e) {
  return e === void 0 && (e = ""), t && t.nodeName === e.toUpperCase();
}
function ql(t) {
  var e = [].slice.call(arguments, 1);
  return function() {
    return t.apply(void 0, [].slice.call(arguments).concat(e));
  };
}
ql(Wl, sO);
ql(Wl, aO);
ql(Wl, oO);
ql(Wl, lO);
function rm(t) {
  try {
    return decodeURIComponent(t.replace(/\+/g, " "));
  } catch {
    return null;
  }
}
function bO() {
  if (ci) {
    var t = navigator, e = t.languages;
    return t.userLanguage || (e && e.length ? e[0] : t.language);
  }
}
function _O() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
  }
}
function wO(t) {
  return (function(e) {
    for (var n, i = /* @__PURE__ */ Object.create(null), r = /([^&=]+)=?([^&]*)/g; n = r.exec(e); ) {
      var s = rm(n[1]), o = rm(n[2]);
      if (s) if (s.substring(s.length - 2) === "[]") {
        var a = i[s = s.substring(0, s.length - 2)] || (i[s] = []);
        i[s] = Array.isArray(a) ? a : [], i[s].push(o);
      } else i[s] = o === "" || o;
    }
    for (var l in i) {
      var c = l.split("[");
      c.length > 1 && (kO(i, c.map(function(u) {
        return u.replace(/[?[\]\\ ]/g, "");
      }), i[l]), delete i[l]);
    }
    return i;
  })((function(e) {
    return ci && window.location.search.substring(1);
  })());
}
function kO(t, e, n) {
  for (var i = e.length - 1, r = 0; r < i; ++r) {
    var s = e[r];
    if (s === "__proto__" || s === "constructor") break;
    s in t || (t[s] = {}), t = t[s];
  }
  t[e[i]] = n;
}
function Gl() {
  for (var t = "", e = 0, n = 4294967295 * Math.random() | 0; e++ < 36; ) {
    var i = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"[e - 1], r = 15 & n;
    t += i == "-" || i == "4" ? i : (i == "x" ? r : 3 & r | 8).toString(16), n = e % 8 == 0 ? 4294967295 * Math.random() | 0 : n >> 4;
  }
  return t;
}
var Wn = "global", qr = Qn + Wn + Qn, Gr = typeof self === Ya && self.self === self && self || typeof global === Ya && global[Wn] === global && global || void 0;
function er(t) {
  return Gr[qr][t];
}
function tr(t, e) {
  return Gr[qr][t] = e;
}
function ss(t) {
  delete Gr[qr][t];
}
function os(t, e, n) {
  var i;
  try {
    if (Wh(t)) {
      var r = window[t];
      i = r[e].bind(r);
    }
  } catch {
  }
  return i || n;
}
Gr[qr] || (Gr[qr] = {});
var Xo = {};
function Wh(t) {
  if (typeof Xo[t] !== oi) return Xo[t];
  try {
    var e = window[t];
    e.setItem(oi, oi), e.removeItem(oi);
  } catch {
    return Xo[t] = !1;
  }
  return Xo[t] = !0;
}
function _e() {
  return _e = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n) ({}).hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, _e.apply(null, arguments);
}
var nn = "function", Vi = "undefined", Ms = "reducer", I1 = "@@redux/", ed = I1 + "INIT", xO = I1 + Math.random().toString(36), sm = /* @__PURE__ */ (function() {
  return typeof Symbol === nn && Symbol.observable || "@@observable";
})(), Jo = " != " + nn;
function D1(t, e, n) {
  var i;
  if (typeof e === nn && typeof n === Vi && (n = e, e = void 0), typeof n !== Vi) {
    if (typeof n !== nn) throw new Error("enhancer" + Jo);
    return n(D1)(t, e);
  }
  if (typeof t !== nn) throw new Error(Ms + Jo);
  var r = t, s = e, o = [], a = o, l = !1;
  function c() {
    a === o && (a = o.slice());
  }
  function u() {
    return s;
  }
  function d(f) {
    if (typeof f !== nn) throw new Error("Listener" + Jo);
    var p = !0;
    return c(), a.push(f), function() {
      if (p) {
        p = !1, c();
        var v = a.indexOf(f);
        a.splice(v, 1);
      }
    };
  }
  function h(f) {
    if (!Mt(f)) throw new Error("Act != obj");
    if (typeof f.type === Vi) throw new Error("ActType " + Vi);
    if (l) throw new Error("Dispatch in " + Ms);
    try {
      l = !0, s = r(s, f);
    } finally {
      l = !1;
    }
    for (var p = o = a, v = 0; v < p.length; v++) (0, p[v])();
    return f;
  }
  return h({ type: ed }), (i = { dispatch: h, subscribe: d, getState: u, replaceReducer: function(f) {
    if (typeof f !== nn) throw new Error("next " + Ms + Jo);
    r = f, h({ type: ed });
  } })[sm] = function() {
    var f, p = d;
    return (f = { subscribe: function(v) {
      if (typeof v != "object") throw new TypeError("Observer != obj");
      function g() {
        v.next && v.next(u());
      }
      return g(), { unsubscribe: p(g) };
    } })[sm] = function() {
      return this;
    }, f;
  }, i;
}
function SO(t, e) {
  var n = e && e.type;
  return "action " + (n && n.toString() || "?") + Ms + " " + t + " returns " + Vi;
}
function Kr() {
  var t = [].slice.call(arguments);
  return t.length === 0 ? function(e) {
    return e;
  } : t.length === 1 ? t[0] : t.reduce(function(e, n) {
    return function() {
      return e(n.apply(void 0, [].slice.call(arguments)));
    };
  });
}
function PO() {
  var t = arguments;
  return function(e) {
    return function(n, i, r) {
      var s, o = e(n, i, r), a = o.dispatch, l = { getState: o.getState, dispatch: function(c) {
        return a(c);
      } };
      return s = [].slice.call(t).map(function(c) {
        return c(l);
      }), _e({}, o, { dispatch: a = Kr.apply(void 0, s)(o.dispatch) });
    };
  };
}
var dn = Qn + "anon_id", qn = Qn + "user_id", Dr = Qn + "user_traits", td = "analytics", tn = "userId", Sr = "anonymousId", xa = ["bootstrap", "params", "campaign", "initializeStart", "initialize", "initializeEnd", "ready", "resetStart", "reset", "resetEnd", "pageStart", "page", "pageEnd", "pageAborted", "trackStart", "track", "trackEnd", "trackAborted", "identifyStart", "identify", "identifyEnd", "identifyAborted", "userIdChanged", "registerPlugins", "enablePlugin", "disablePlugin", "online", "offline", "setItemStart", "setItem", "setItemEnd", "setItemAborted", "removeItemStart", "removeItem", "removeItemEnd", "removeItemAborted"], id = ["name", "EVENTS", "config", "loaded"], be = xa.reduce(function(t, e) {
  return t[e] = e, t;
}, { registerPluginType: function(t) {
  return "registerPlugin:" + t;
}, pluginReadyType: function(t) {
  return "ready:" + t;
} }), om = /^utm_/, am = /^an_prop_/, lm = /^an_trait_/;
function EO(t) {
  var e = t.storage.setItem;
  return function(n) {
    return function(i) {
      return function(r) {
        if (r.type === be.bootstrap) {
          var s = r.params, o = r.user, a = r.persistedUser, l = r.initialUser, c = a.userId === o.userId;
          a.anonymousId !== o.anonymousId && e(dn, o.anonymousId), c || e(qn, o.userId), l.traits && e(Dr, _e({}, c && a.traits ? a.traits : {}, l.traits));
          var u = Object.keys(r.params);
          if (u.length) {
            var d = s.an_uid, h = s.an_event, f = u.reduce(function(p, v) {
              if (v.match(om) || v.match(/^(d|g)clid/)) {
                var g = v.replace(om, "");
                p.campaign[g === "campaign" ? "name" : g] = s[v];
              }
              return v.match(am) && (p.props[v.replace(am, "")] = s[v]), v.match(lm) && (p.traits[v.replace(lm, "")] = s[v]), p;
            }, { campaign: {}, props: {}, traits: {} });
            n.dispatch(_e({ type: be.params, raw: s }, f, d ? { userId: d } : {})), d && setTimeout(function() {
              return t.identify(d, f.traits);
            }, 0), h && setTimeout(function() {
              return t.track(h, f.props);
            }, 0), Object.keys(f.campaign).length && n.dispatch({ type: be.campaign, campaign: f.campaign });
          }
        }
        return i(r);
      };
    };
  };
}
function TO(t) {
  return function(e, n) {
    if (e === void 0 && (e = {}), n === void 0 && (n = {}), n.type === be.setItemEnd) {
      if (n.key === dn) return _e({}, e, { anonymousId: n.value });
      if (n.key === qn) return _e({}, e, { userId: n.value });
    }
    switch (n.type) {
      case be.identify:
        return Object.assign({}, e, { userId: n.userId, traits: _e({}, e.traits, n.traits) });
      case be.reset:
        return [qn, dn, Dr].forEach(function(i) {
          t.removeItem(i);
        }), Object.assign({}, e, { userId: null, anonymousId: null, traits: {} });
      default:
        return e;
    }
  };
}
function cm(t) {
  return { userId: t.getItem(qn), anonymousId: t.getItem(dn), traits: t.getItem(Dr) };
}
var nd = function(t) {
  return Qn + "TEMP" + Qn + t;
};
function CO(t) {
  var e = t.storage, n = e.setItem, i = e.removeItem, r = e.getItem;
  return function(s) {
    return function(o) {
      return function(a) {
        var l = a.userId, c = a.traits, u = a.options;
        if (a.type === be.reset && ([qn, Dr, dn].forEach(function(f) {
          i(f);
        }), [tn, Sr, "traits"].forEach(function(f) {
          ss(nd(f));
        })), a.type === be.identify) {
          r(dn) || n(dn, Gl());
          var d = r(qn), h = r(Dr) || {};
          d && d !== l && s.dispatch({ type: be.userIdChanged, old: { userId: d, traits: h }, new: { userId: l, traits: c }, options: u }), l && n(qn, l), c && n(Dr, _e({}, h, c));
        }
        return o(a);
      };
    };
  };
}
var Ts = {};
function um(t, e) {
  Ts[t] && vi(Ts[t]) && (Ts[t](e), delete Ts[t]);
}
function F1(t, e, n) {
  return new Promise(function(i, r) {
    return e() ? i(t) : n < 1 ? r(_e({}, t, { queue: !0 })) : new Promise(function(s) {
      return setTimeout(s, 10);
    }).then(function(s) {
      return F1(t, e, n - 10).then(i, r);
    });
  });
}
function AO(t) {
  return { abort: t };
}
function L1(t, e, n) {
  var i = {}, r = e(), s = t.getState(), o = s.plugins, a = s.queue, l = s.user;
  if (!s.context.offline && a && a.actions && a.actions.length) {
    var c = a.actions.reduce(function(d, h, f) {
      return o[h.plugin].loaded ? (d.process.push(h), d.processIndex.push(f)) : (d.requeue.push(h), d.requeueIndex.push(f)), d;
    }, { processIndex: [], process: [], requeue: [], requeueIndex: [] });
    if (c.processIndex && c.processIndex.length) {
      c.processIndex.forEach(function(d) {
        var h = a.actions[d], f = h.plugin, p = h.payload.type, v = r[f][p];
        if (v && vi(v)) {
          var g, m = (function(_, w) {
            return _ === void 0 && (_ = {}), w === void 0 && (w = {}), [tn, Sr].reduce(function(T, E) {
              return _.hasOwnProperty(E) && w[E] && w[E] !== _[E] && (T[E] = w[E]), T;
            }, _);
          })(h.payload, l), y = i[m.meta.rid];
          if (!y && (g = v({ payload: m, config: o[f].config, instance: n, abort: AO })) && Mt(g) && g.abort) return void (i[m.meta.rid] = !0);
          if (!y) {
            var k = p + ":" + f;
            t.dispatch(_e({}, m, { type: k, _: { called: k, from: "queueDrain" } }));
          }
        }
      });
      var u = a.actions.filter(function(d, h) {
        return !~c.processIndex.indexOf(h);
      });
      a.actions = u;
    }
  }
}
var _c = function(t) {
  var e = t.data, n = t.action, i = t.instance, r = t.state, s = t.allPlugins, o = t.allMatches, a = t.store, l = t.EVENTS;
  try {
    var c = r.plugins, u = r.context, d = n.type, h = d.match(Fr), f = e.exact.map(function(g) {
      return g.pluginName;
    });
    h && (f = o.during.map(function(g) {
      return g.pluginName;
    }));
    var p = /* @__PURE__ */ (function(g, m) {
      return function(y, k, _) {
        var w = k.config, T = k.name, E = T + "." + y.type;
        _ && (E = _.event);
        var S = y.type.match(Fr) ? /* @__PURE__ */ (function(P, C, M, O, W) {
          return function(H, z) {
            var F = O ? O.name : P, K = z && Zs(z) ? z : M;
            if (O && (!(K = z && Zs(z) ? z : [P]).includes(P) || K.length !== 1)) throw new Error("Method " + C + " can only abort " + P + " plugin. " + JSON.stringify(K) + " input valid");
            return _e({}, W, { abort: { reason: H, plugins: K, caller: C, _: F } });
          };
        })(T, E, m, _, y) : /* @__PURE__ */ (function(P, C) {
          return function() {
            throw new Error(P.type + " action not cancellable. Remove abort in " + C);
          };
        })(y, E);
        return { payload: $O(y), instance: g, config: w || {}, abort: S };
      };
    })(i, f), v = e.exact.reduce(function(g, m) {
      var y = m.pluginName, k = m.methodName, _ = !1;
      return k.match(/^initialize/) || k.match(/^reset/) || (_ = !c[y].loaded), u.offline && k.match(/^(page|track|identify)/) && (_ = !0), g["" + y] = _, g;
    }, {});
    return Promise.resolve(e.exact.reduce(function(g, m, y) {
      var k = m.pluginName;
      return Promise.resolve(g).then(function(_) {
        function w() {
          return Promise.resolve(_);
        }
        var T = (function() {
          if (e.namespaced && e.namespaced[k]) return Promise.resolve(e.namespaced[k].reduce(function(E, S, P) {
            return Promise.resolve(E).then(function(C) {
              return S.method && vi(S.method) ? ((function(H, z) {
                var F = vm(H);
                if (F && F.name === z) {
                  var K = vm(F.method);
                  throw new Error([z + " plugin is calling method " + H, "Plugins cant call self", "Use " + F.method + " " + (K ? "or " + K.method : "") + " in " + z + " plugin insteadof " + H].join(`
`));
                }
              })(S.methodName, S.pluginName), Promise.resolve(S.method({ payload: C, instance: i, abort: (M = C, O = k, W = S.pluginName, function(H, z) {
                return _e({}, M, { abort: { reason: H, plugins: z || [O], caller: d, from: W || O } });
              }), config: fm(S.pluginName, c, s), plugins: c })).then(function(H) {
                var z = Mt(H) ? H : {};
                return Promise.resolve(_e({}, C, z));
              })) : C;
              var M, O, W;
            });
          }, Promise.resolve(n))).then(function(E) {
            _[k] = E;
          });
          _[k] = n;
        })();
        return T && T.then ? T.then(w) : w();
      });
    }, Promise.resolve({}))).then(function(g) {
      return Promise.resolve(e.exact.reduce(function(m, y, k) {
        try {
          var _ = e.exact.length === k + 1, w = y.pluginName, T = s[w];
          return Promise.resolve(m).then(function(E) {
            var S = g[w] ? g[w] : {};
            if (h && (S = E), kc(S, w)) return wc({ data: S, method: d, instance: i, pluginName: w, store: a }), Promise.resolve(E);
            if (kc(E, w)) return _ && wc({ data: E, method: d, instance: i, store: a }), Promise.resolve(E);
            if (v.hasOwnProperty(w) && v[w] === !0) return a.dispatch({ type: "queue", plugin: w, payload: S, _: { called: "queue", from: "queueMechanism" } }), Promise.resolve(E);
            var P = p(g[w], s[w]);
            return Promise.resolve(T[d]({ abort: P.abort, payload: S, instance: i, config: fm(w, c, s), plugins: c })).then(function(C) {
              var M = Mt(C) ? C : {}, O = _e({}, E, M), W = g[w];
              if (kc(W, w)) wc({ data: W, method: d, instance: i, pluginName: w, store: a });
              else {
                var H = d + ":" + w;
                (H.match(/:/g) || []).length < 2 && !d.match(dm) && !d.match(hm) && i.dispatch(_e({}, h ? O : S, { type: H, _: { called: H, from: "submethod" } }));
              }
              return Promise.resolve(O);
            });
          });
        } catch (E) {
          return Promise.reject(E);
        }
      }, Promise.resolve(n))).then(function(m) {
        if (!(d.match(Fr) || d.match(/^registerPlugin/) || d.match(hm) || d.match(dm) || d.match(/^params/) || d.match(/^userIdChanged/))) {
          if (l.plugins.includes(d), m._ && m._.originalAction === d) return m;
          var y = _e({}, m, { _: { originalAction: m.type, called: m.type, from: "engineEnd" } });
          N1(m, e.exact.length) && !d.match(/End$/) && (y = _e({}, y, { type: m.type + "Aborted" })), a.dispatch(y);
        }
        return m;
      });
    });
  } catch (g) {
    return Promise.reject(g);
  }
}, Fr = /Start$/, dm = /^bootstrap/, hm = /^ready/;
function wc(t) {
  var e = t.pluginName, n = t.method + "Aborted" + (e ? ":" + e : "");
  t.store.dispatch(_e({}, t.data, { type: n, _: { called: n, from: "abort" } }));
}
function fm(t, e, n) {
  var i = e[t] || n[t];
  return i && i.config ? i.config : {};
}
function pm(t, e) {
  return e.reduce(function(n, i) {
    return i[t] ? n.concat({ methodName: t, pluginName: i.name, method: i[t] }) : n;
  }, []);
}
function mm(t, e) {
  var n = t.replace(Fr, ""), i = e ? ":" + e : "";
  return ["" + t + i, "" + n + i, n + "End" + i];
}
function kc(t, e) {
  var n = t.abort;
  return !!n && (n === !0 || gm(n, e) || n && gm(n.plugins, e));
}
function N1(t, e) {
  var n = t.abort;
  if (!n) return !1;
  if (n === !0 || Ir(n)) return !0;
  var i = n.plugins;
  return Zs(n) && n.length === e || Zs(i) && i.length === e;
}
function Zs(t) {
  return Array.isArray(t);
}
function gm(t, e) {
  return !(!t || !Zs(t)) && t.includes(e);
}
function vm(t) {
  var e = t.match(/(.*):(.*)/);
  return !!e && { method: e[1], name: e[2] };
}
function $O(t) {
  return Object.keys(t).reduce(function(e, n) {
    return n === "type" || (e[n] = Mt(t[n]) ? Object.assign({}, t[n]) : t[n]), e;
  }, {});
}
function RO(t, e, n) {
  var i = {};
  return function(r) {
    return function(s) {
      return function(o) {
        try {
          var a, l = function(_) {
            return a ? _ : s(d);
          }, c = o.type, u = o.plugins, d = o;
          if (o.abort) return Promise.resolve(s(o));
          if (c === be.enablePlugin && r.dispatch({ type: be.initializeStart, plugins: u, disabled: [], fromEnable: !0, meta: o.meta }), c === be.disablePlugin && setTimeout(function() {
            return um(o.meta.rid, { payload: o });
          }, 0), c === be.initializeEnd) {
            var h = e(), f = Object.keys(h), p = f.filter(function(_) {
              return u.includes(_);
            }).map(function(_) {
              return h[_];
            }), v = [], g = [], m = o.disabled, y = p.map(function(_) {
              var w = _.loaded, T = _.name, E = _.config;
              return F1(_, function() {
                return w({ config: E });
              }, 1e4).then(function(S) {
                return i[T] || (r.dispatch({ type: be.pluginReadyType(T), name: T, events: Object.keys(_).filter(function(P) {
                  return !id.includes(P);
                }) }), i[T] = !0), v = v.concat(T), _;
              }).catch(function(S) {
                if (S instanceof Error) throw new Error(S);
                return g = g.concat(S.name), S;
              });
            });
            Promise.all(y).then(function(_) {
              var w = { plugins: v, failed: g, disabled: m };
              setTimeout(function() {
                f.length === y.length + m.length && r.dispatch(_e({}, { type: be.ready }, w));
              }, 0);
            });
          }
          var k = (function() {
            if (c !== be.bootstrap) return /^ready:([^:]*)$/.test(c) && setTimeout(function() {
              return L1(r, e, t);
            }, 0), Promise.resolve((function(_, w, T, E, S) {
              try {
                var P = vi(w) ? w() : w, C = _.type, M = C.replace(Fr, "");
                if (_._ && _._.called) return Promise.resolve(_);
                var O = T.getState(), W = (F = P, (K = O.plugins) === void 0 && (K = {}), (B = _.options) === void 0 && (B = {}), Object.keys(F).filter(function($) {
                  var I = B.plugins || {};
                  return hO(I[$]) ? I[$] : I.all !== !1 && (!K[$] || K[$].enabled !== !1);
                }).map(function($) {
                  return F[$];
                }));
                C === be.initializeStart && _.fromEnable && (W = Object.keys(O.plugins).filter(function($) {
                  var I = O.plugins[$];
                  return _.plugins.includes($) && !I.initialized;
                }).map(function($) {
                  return P[$];
                }));
                var H = W.map(function($) {
                  return $.name;
                }), z = (function($, I) {
                  var q = mm($).map(function(J) {
                    return pm(J, I);
                  });
                  return I.reduce(function(J, D) {
                    var A = D.name, N = mm($, A).map(function(ie) {
                      return pm(ie, I);
                    }), X = N[0], U = N[1], j = N[2];
                    return X.length && (J.beforeNS[A] = X), U.length && (J.duringNS[A] = U), j.length && (J.afterNS[A] = j), J;
                  }, { before: q[0], beforeNS: {}, during: q[1], duringNS: {}, after: q[2], afterNS: {} });
                })(C, W);
                return Promise.resolve(_c({ action: _, data: { exact: z.before, namespaced: z.beforeNS }, state: O, allPlugins: P, allMatches: z, instance: T, store: E, EVENTS: S })).then(function($) {
                  function I() {
                    var D = (function() {
                      if (C.match(Fr)) return Promise.resolve(_c({ action: _e({}, q, { type: M + "End" }), data: { exact: z.after, namespaced: z.afterNS }, state: O, allPlugins: P, allMatches: z, instance: T, store: E, EVENTS: S })).then(function(A) {
                        A.meta && A.meta.hasCallback && um(A.meta.rid, { payload: A });
                      });
                    })();
                    return D && D.then ? D.then(function() {
                      return $;
                    }) : $;
                  }
                  if (N1($, H.length)) return $;
                  var q, J = (function() {
                    if (C !== M) return Promise.resolve(_c({ action: _e({}, $, { type: M }), data: { exact: z.during, namespaced: z.duringNS }, state: O, allPlugins: P, allMatches: z, instance: T, store: E, EVENTS: S })).then(function(D) {
                      q = D;
                    });
                    q = $;
                  })();
                  return J && J.then ? J.then(I) : I();
                });
              } catch ($) {
                return Promise.reject($);
              }
              var F, K, B;
            })(o, e, t, r, n)).then(function(_) {
              var w = s(_);
              return a = 1, w;
            });
          })();
          return Promise.resolve(k && k.then ? k.then(l) : l(k));
        } catch (_) {
          return Promise.reject(_);
        }
      };
    };
  };
}
function MO(t) {
  return function(e) {
    return function(n) {
      return function(i) {
        var r = i.type, s = i.key, o = i.value, a = i.options;
        if (r === be.setItem || r === be.removeItem) {
          if (i.abort) return n(i);
          r === be.setItem ? t.setItem(s, o, a) : t.removeItem(s, a);
        }
        return n(i);
      };
    };
  };
}
var OO = function() {
  var t = this;
  this.before = [], this.after = [], this.addMiddleware = function(e, n) {
    t[n] = t[n].concat(e);
  }, this.removeMiddleware = function(e, n) {
    var i = t[n].findIndex(function(r) {
      return r === e;
    });
    i !== -1 && (t[n] = [].concat(t[n].slice(0, i), t[n].slice(i + 1)));
  }, this.dynamicMiddlewares = function(e) {
    return function(n) {
      return function(i) {
        return function(r) {
          var s = { getState: n.getState, dispatch: function(a) {
            return n.dispatch(a);
          } }, o = t[e].map(function(a) {
            return a(s);
          });
          return Kr.apply(void 0, o)(i)(r);
        };
      };
    };
  };
};
function IO(t) {
  return function(e, n) {
    e === void 0 && (e = {});
    var i = {};
    if (n.type === "initialize:aborted") return e;
    if (/^registerPlugin:([^:]*)$/.test(n.type)) {
      var r = ym(n.type, "registerPlugin"), s = t()[r];
      if (!s || !r) return e;
      var o = n.enabled, a = s.config;
      return i[r] = { enabled: o, initialized: !!o && !s.initialize, loaded: !!o && !!s.loaded({ config: a }), config: a }, _e({}, e, i);
    }
    if (/^initialize:([^:]*)$/.test(n.type)) {
      var l = ym(n.type, be.initialize), c = t()[l];
      return c && l ? (i[l] = _e({}, e[l], { initialized: !0, loaded: !!c.loaded({ config: c.config }) }), _e({}, e, i)) : e;
    }
    if (/^ready:([^:]*)$/.test(n.type)) return i[n.name] = _e({}, e[n.name], { loaded: !0 }), _e({}, e, i);
    switch (n.type) {
      case be.disablePlugin:
        return _e({}, e, bm(n.plugins, !1, e));
      case be.enablePlugin:
        return _e({}, e, bm(n.plugins, !0, e));
      default:
        return e;
    }
  };
}
function ym(t, e) {
  return t.substring(e.length + 1, t.length);
}
function bm(t, e, n) {
  return t.reduce(function(i, r) {
    return i[r] = _e({}, n[r], { enabled: e }), i;
  }, n);
}
function V1(t) {
  try {
    return JSON.parse(JSON.stringify(t));
  } catch {
  }
  return t;
}
var DO = { last: {}, history: [] };
function FO(t, e) {
  t === void 0 && (t = DO);
  var n = e.options, i = e.meta;
  if (e.type === be.track) {
    var r = V1(_e({ event: e.event, properties: e.properties }, Object.keys(n).length && { options: n }, { meta: i }));
    return _e({}, t, { last: r, history: t.history.concat(r) });
  }
  return t;
}
var LO = { actions: [] };
function NO(t, e) {
  t === void 0 && (t = LO);
  var n = e.payload;
  switch (e.type) {
    case "queue":
      var i;
      return i = n && n.type && n.type === be.identify ? [e].concat(t.actions) : t.actions.concat(e), _e({}, t, { actions: i });
    case "dequeue":
      return [];
    default:
      return t;
  }
}
var j1 = /#.*$/;
function VO(t) {
  var e = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(t);
  return "/" + (e && e[3] ? e[3].split("?")[0].replace(j1, "") : "");
}
var z1, B1, H1, U1, jO = function(t) {
  if (t === void 0 && (t = {}), !ci) return t;
  var e = document, n = e.title, i = e.referrer, r = window, s = r.location, o = r.innerWidth, a = r.innerHeight, l = s.hash, c = s.search, u = (function(h) {
    var f = (function() {
      if (ci) {
        for (var p, v = document.getElementsByTagName("link"), g = 0; p = v[g]; g++) if (p.getAttribute("rel") === "canonical") return p.getAttribute("href");
      }
    })();
    return f ? f.match(/\?/) ? f : f + h : window.location.href.replace(j1, "");
  })(c), d = { title: n, url: u, path: VO(u), hash: l, search: c, width: o, height: a };
  return i && i !== "" && (d.referrer = i), _e({}, d, t);
}, zO = { last: {}, history: [] };
function BO(t, e) {
  t === void 0 && (t = zO);
  var n = e.options;
  if (e.type === be.page) {
    var i = V1(_e({ properties: e.properties, meta: e.meta }, Object.keys(n).length && { options: n }));
    return _e({}, t, { last: i, history: t.history.concat(i) });
  }
  return t;
}
z1 = (function() {
  if (!ci) return !1;
  var t = navigator.appVersion;
  return ~t.indexOf("Win") ? "Windows" : ~t.indexOf("Mac") ? "MacOS" : ~t.indexOf("X11") ? "UNIX" : ~t.indexOf("Linux") ? "Linux" : "Unknown OS";
})(), B1 = ci ? document.referrer : null, H1 = bO(), U1 = _O();
var _m = { initialized: !1, sessionId: Gl(), app: null, version: null, debug: !1, offline: !!ci && !navigator.onLine, os: { name: z1 }, userAgent: ci ? navigator.userAgent : "node", library: { name: td, version: "0.13.1" }, timezone: U1, locale: H1, campaign: {}, referrer: B1 };
function HO(t, e) {
  t === void 0 && (t = _m);
  var n = t.initialized, i = e.campaign;
  switch (e.type) {
    case be.campaign:
      return _e({}, t, { campaign: i });
    case be.offline:
      return _e({}, t, { offline: !0 });
    case be.online:
      return _e({}, t, { offline: !1 });
    default:
      return n ? t : _e({}, _m, t, { initialized: !0 });
  }
}
var UO = ["plugins", "reducers", "storage"];
function WO(t, e, n) {
  if (ci) {
    var i = window[(n ? "add" : "remove") + "EventListener"];
    t.split(" ").forEach(function(r) {
      i(r, e);
    });
  }
}
function qO(t) {
  var e = WO.bind(null, "online offline", function(n) {
    return Promise.resolve(!navigator.onLine).then(t);
  });
  return e(!0), function(n) {
    return e(!1);
  };
}
function W1() {
  return tr(td, []), function(t) {
    return function(e, n, i) {
      var r = t(e, n, i), s = r.dispatch;
      return Object.assign(r, { dispatch: function(o) {
        return Gr[qr][td].push(o.action || o), s(o);
      } });
    };
  };
}
function wm(t) {
  return function() {
    return Kr(Kr.apply(null, arguments), W1());
  };
}
function xc(t) {
  return t ? pO(t) ? t : [t] : [];
}
function km(t, e, n) {
  t === void 0 && (t = {});
  var i, r, s = Gl();
  return e && (Ts[s] = (i = e, r = (function(o) {
    for (var a, l = o || Array.prototype.slice.call(arguments), c = 0; c < l.length; c++) if (vi(l[c])) {
      a = l[c];
      break;
    }
    return a;
  })(n), function(o) {
    r && r(o), i(o);
  })), _e({}, t, { rid: s, ts: (/* @__PURE__ */ new Date()).getTime() }, e ? { hasCallback: !0 } : {});
}
function GO(t) {
  t === void 0 && (t = {});
  var e = t.reducers || {}, n = t.initialUser || {}, i = (t.plugins || []).reduce(function($, I) {
    if (vi(I)) return $.middlewares = $.middlewares.concat(I), $;
    if (I.NAMESPACE && (I.name = I.NAMESPACE), !I.name) throw new Error("https://lytics.dev/errors/1");
    I.config || (I.config = {});
    var q = I.EVENTS ? Object.keys(I.EVENTS).map(function(A) {
      return I.EVENTS[A];
    }) : [];
    $.pluginEnabled[I.name] = !(I.enabled === !1 || I.config.enabled === !1), delete I.enabled, I.methods && ($.methods[I.name] = Object.keys(I.methods).reduce(function(A, N) {
      var X;
      return A[N] = (X = I.methods[N], function() {
        for (var U = Array.prototype.slice.call(arguments), j = new Array(X.length), ie = 0; ie < U.length; ie++) j[ie] = U[ie];
        return j[j.length] = w, X.apply({ instance: w }, j);
      }), A;
    }, {}), delete I.methods);
    var J = Object.keys(I).concat(q), D = new Set($.events.concat(J));
    if ($.events = Array.from(D), $.pluginsArray = $.pluginsArray.concat(I), $.plugins[I.name]) throw new Error(I.name + "AlreadyLoaded");
    return $.plugins[I.name] = I, $.plugins[I.name].loaded || ($.plugins[I.name].loaded = function() {
      return !0;
    }), $;
  }, { plugins: {}, pluginEnabled: {}, methods: {}, pluginsArray: [], middlewares: [], events: [] }), r = t.storage ? t.storage : { getItem: er, setItem: tr, removeItem: ss }, s = /* @__PURE__ */ (function($) {
    return function(I, q, J) {
      return q.getState("user")[I] || (J && Mt(J) && J[I] ? J[I] : cm($)[I] || er(nd(I)) || null);
    };
  })(r), o = i.plugins, a = i.events.filter(function($) {
    return !id.includes($);
  }).sort(), l = new Set(a.concat(xa).filter(function($) {
    return !id.includes($);
  })), c = Array.from(l).sort(), u = function() {
    return o;
  }, d = new OO(), h = d.addMiddleware, f = d.removeMiddleware, p = d.dynamicMiddlewares, v = function() {
    throw new Error("Abort disabled inListener");
  }, g = wO(), m = cm(r), y = _e({}, m, n, g.an_uid ? { userId: g.an_uid } : {}, g.an_aid ? { anonymousId: g.an_aid } : {});
  y.anonymousId || (y.anonymousId = Gl());
  var k = _e({ enable: function($, I) {
    return new Promise(function(q) {
      z.dispatch({ type: be.enablePlugin, plugins: xc($), _: { originalAction: be.enablePlugin } }, q, [I]);
    });
  }, disable: function($, I) {
    return new Promise(function(q) {
      z.dispatch({ type: be.disablePlugin, plugins: xc($), _: { originalAction: be.disablePlugin } }, q, [I]);
    });
  } }, i.methods), _ = !1, w = { identify: function($, I, q, J) {
    try {
      var D = Ir($) ? $ : null, A = Mt($) ? $ : I, N = q || {}, X = w.user();
      tr(nd(tn), D);
      var U = D || A.userId || s(tn, w, A);
      return Promise.resolve(new Promise(function(j) {
        z.dispatch(_e({ type: be.identifyStart, userId: U, traits: A || {}, options: N, anonymousId: X.anonymousId }, X.id && X.id !== D && { previousId: X.id }), j, [I, q, J]);
      }));
    } catch (j) {
      return Promise.reject(j);
    }
  }, track: function($, I, q, J) {
    try {
      var D = Mt($) ? $.event : $;
      if (!D || !Ir(D)) throw new Error("EventMissing");
      var A = Mt($) ? $ : I || {}, N = Mt(q) ? q : {};
      return Promise.resolve(new Promise(function(X) {
        z.dispatch({ type: be.trackStart, event: D, properties: A, options: N, userId: s(tn, w, I), anonymousId: s(Sr, w, I) }, X, [I, q, J]);
      }));
    } catch (X) {
      return Promise.reject(X);
    }
  }, page: function($, I, q) {
    try {
      var J = Mt($) ? $ : {}, D = Mt(I) ? I : {};
      return Promise.resolve(new Promise(function(A) {
        z.dispatch({ type: be.pageStart, properties: jO(J), options: D, userId: s(tn, w, J), anonymousId: s(Sr, w, J) }, A, [$, I, q]);
      }));
    } catch (A) {
      return Promise.reject(A);
    }
  }, user: function($) {
    if ($ === tn || $ === "id") return s(tn, w);
    if ($ === Sr || $ === "anonId") return s(Sr, w);
    var I = w.getState("user");
    return $ ? nm(I, $) : I;
  }, reset: function($) {
    return new Promise(function(I) {
      z.dispatch({ type: be.resetStart }, I, $);
    });
  }, ready: function($) {
    return _ && $({ plugins: k, instance: w }), w.on(be.ready, function(I) {
      $ && $(I), _ = !0;
    });
  }, on: function($, I) {
    if (!$ || !vi(I)) return !1;
    if ($ === be.bootstrap) throw new Error(".on disabled for " + $);
    var q = /Start$|Start:/;
    if ($ === "*") {
      var J = function(X) {
        return function(U) {
          return function(j) {
            return j.type.match(q) && I({ payload: j, instance: w, plugins: o }), U(j);
          };
        };
      }, D = function(X) {
        return function(U) {
          return function(j) {
            return j.type.match(q) || I({ payload: j, instance: w, plugins: o }), U(j);
          };
        };
      };
      return h(J, Zo), h(D, Qo), function() {
        f(J, Zo), f(D, Qo);
      };
    }
    var A = $.match(q) ? Zo : Qo, N = function(X) {
      return function(U) {
        return function(j) {
          return j.type === $ && I({ payload: j, instance: w, plugins: o, abort: v }), U(j);
        };
      };
    };
    return h(N, A), function() {
      return f(N, A);
    };
  }, once: function($, I) {
    if (!$ || !vi(I)) return !1;
    if ($ === be.bootstrap) throw new Error(".once disabled for " + $);
    var q = w.on($, function(J) {
      I({ payload: J.payload, instance: w, plugins: o, abort: v }), q();
    });
    return q;
  }, getState: function($) {
    var I = z.getState();
    return $ ? nm(I, $) : Object.assign({}, I);
  }, dispatch: function($) {
    var I = Ir($) ? { type: $ } : $;
    if (xa.includes(I.type)) throw new Error("reserved action " + I.type);
    var q = _e({}, I, { _: _e({ originalAction: I.type }, $._ || {}) });
    z.dispatch(q);
  }, enablePlugin: k.enable, disablePlugin: k.disable, plugins: k, storage: { getItem: r.getItem, setItem: function($, I, q) {
    z.dispatch({ type: be.setItemStart, key: $, value: I, options: q });
  }, removeItem: function($, I) {
    z.dispatch({ type: be.removeItemStart, key: $, options: I });
  } }, setAnonymousId: function($, I) {
    w.storage.setItem(dn, $, I);
  }, events: { core: xa, plugins: a } }, T = i.middlewares.concat([function($) {
    return function(I) {
      return function(q) {
        return q.meta || (q.meta = km()), I(q);
      };
    };
  }, p(Zo), RO(w, u, { all: c, plugins: a }), MO(r), EO(w), CO(w), p(Qo)]), E = { context: HO, user: TO(r), page: BO, track: FO, plugins: IO(u), queue: NO }, S = Kr, P = Kr;
  if (ci && t.debug) {
    var C = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    C && (S = C({ trace: !0, traceLimit: 25 })), P = function() {
      return arguments.length === 0 ? W1() : Mt(typeof arguments[0]) ? wm() : wm().apply(null, arguments);
    };
  }
  var M, O = (function($) {
    return Object.keys($).reduce(function(I, q) {
      return UO.includes(q) || (I[q] = $[q]), I;
    }, {});
  })(t), W = i.pluginsArray.reduce(function($, I) {
    var q = I.name, J = I.config, D = I.loaded, A = i.pluginEnabled[q];
    return $[q] = { enabled: A, initialized: !!A && !I.initialize, loaded: !!D({ config: J }), config: J }, $;
  }, {}), H = { context: O, user: y, plugins: W }, z = D1((function($) {
    for (var I = Object.keys($), q = {}, J = 0; J < I.length; J++) {
      var D = I[J];
      typeof $[D] === nn && (q[D] = $[D]);
    }
    var A, N = Object.keys(q);
    try {
      (function(X) {
        Object.keys(X).forEach(function(U) {
          var j = X[U];
          if (typeof j(void 0, { type: ed }) === Vi || typeof j(void 0, { type: xO }) === Vi) throw new Error(Ms + " " + U + " " + Vi);
        });
      })(q);
    } catch (X) {
      A = X;
    }
    return function(X, U) {
      if (X === void 0 && (X = {}), A) throw A;
      for (var j = !1, ie = {}, oe = 0; oe < N.length; oe++) {
        var Oe = N[oe], $e = X[Oe], Ae = (0, q[Oe])($e, U);
        if (typeof Ae === Vi) {
          var Bt = SO(Oe, U);
          throw new Error(Bt);
        }
        ie[Oe] = Ae, j = j || Ae !== $e;
      }
      return j ? ie : X;
    };
  })(_e({}, E, e)), H, P(S(PO.apply(void 0, T))));
  z.dispatch = (M = z.dispatch, function($, I, q) {
    var J = _e({}, $, { meta: km($.meta, I, xc(q)) });
    return M.apply(null, [J]);
  });
  var F = Object.keys(o);
  z.dispatch({ type: be.bootstrap, plugins: F, config: O, params: g, user: y, initialUser: n, persistedUser: m });
  var K = F.filter(function($) {
    return i.pluginEnabled[$];
  }), B = F.filter(function($) {
    return !i.pluginEnabled[$];
  });
  return z.dispatch({ type: be.registerPlugins, plugins: F, enabled: i.pluginEnabled }), i.pluginsArray.map(function($, I) {
    var q = $.bootstrap, J = $.config, D = $.name;
    q && vi(q) && q({ instance: w, config: J, payload: $ }), z.dispatch({ type: be.registerPluginType(D), name: D, enabled: i.pluginEnabled[D], plugin: $ }), i.pluginsArray.length === I + 1 && z.dispatch({ type: be.initializeStart, plugins: K, disabled: B });
  }), qO(function($) {
    z.dispatch({ type: $ ? be.offline : be.online });
  }), (function($, I, q) {
    setInterval(function() {
      return L1($, I, q);
    }, 3e3);
  })(z, u, w), w;
}
var Zo = "before", Qo = "after", Gn = "cookie", zn = K1(), q1 = Kl, KO = Kl;
function G1(t) {
  return zn ? Kl(t, "", -1) : ss(t);
}
function K1() {
  if (zn !== void 0) return zn;
  var t = Gn + Gn;
  try {
    Kl(t, t), zn = document.cookie.indexOf(t) !== -1, G1(t);
  } catch {
    zn = !1;
  }
  return zn;
}
function Kl(t, e, n, i, r, s) {
  if (typeof window < "u") {
    var o = arguments.length > 1;
    return zn === !1 && (o ? tr(t, e) : er(t)), o ? document.cookie = t + "=" + encodeURIComponent(e) + (n ? "; expires=" + new Date(+/* @__PURE__ */ new Date() + 1e3 * n).toUTCString() + (i ? "; path=" + i : "") + (r ? "; domain=" + r : "") + (s ? "; secure" : "") : "") : decodeURIComponent((("; " + document.cookie).split("; " + t + "=")[1] || "").split(";")[0]);
  }
}
var Bi = "localStorage", YO = Wh.bind(null, Bi);
os(Bi, "getItem", er);
os(Bi, "setItem", tr);
os(Bi, "removeItem", ss);
var Hi = "sessionStorage", XO = Wh.bind(null, Hi);
os(Hi, "getItem", er);
os(Hi, "setItem", tr);
os(Hi, "removeItem", ss);
function Lr(t) {
  var e = t;
  try {
    if ((e = JSON.parse(t)) === "true") return !0;
    if (e === "false") return !1;
    if (Mt(e)) return e;
    parseFloat(e) === e && (e = parseFloat(e));
  } catch {
  }
  if (e !== null && e !== "") return e;
}
var JO = YO(), ZO = XO(), QO = K1();
function Y1(t, e) {
  if (t) {
    var n = qh(e), i = !Xh(n), r = Gh(n) ? Lr(localStorage.getItem(t)) : void 0;
    if (i && !xr(r)) return r;
    var s = Kh(n) ? Lr(q1(t)) : void 0;
    if (i && s) return s;
    var o = Yh(n) ? Lr(sessionStorage.getItem(t)) : void 0;
    if (i && o) return o;
    var a = er(t);
    return i ? a : { localStorage: r, sessionStorage: o, cookie: s, global: a };
  }
}
function e3(t, e, n) {
  if (t && !xr(e)) {
    var i = {}, r = qh(n), s = JSON.stringify(e), o = !Xh(r);
    return Gh(r) && (i[Bi] = ea(Bi, e, Lr(localStorage.getItem(t))), localStorage.setItem(t, s), o) ? i[Bi] : Kh(r) && (i[Gn] = ea(Gn, e, Lr(q1(t))), KO(t, s), o) ? i[Gn] : Yh(r) && (i[Hi] = ea(Hi, e, Lr(sessionStorage.getItem(t))), sessionStorage.setItem(t, s), o) ? i[Hi] : (i[Wn] = ea(Wn, e, er(t)), tr(t, e), o ? i[Wn] : i);
  }
}
function t3(t, e) {
  if (t) {
    var n = qh(e), i = Y1(t, $1), r = {};
    return !xr(i.localStorage) && Gh(n) && (localStorage.removeItem(t), r[Bi] = i.localStorage), !xr(i.cookie) && Kh(n) && (G1(t), r[Gn] = i.cookie), !xr(i.sessionStorage) && Yh(n) && (sessionStorage.removeItem(t), r[Hi] = i.sessionStorage), !xr(i.global) && Yl(n, Wn) && (ss(t), r[Wn] = i.global), r;
  }
}
function qh(t) {
  return t ? Ir(t) ? t : t.storage : A1;
}
function Gh(t) {
  return JO && Yl(t, Bi);
}
function Kh(t) {
  return QO && Yl(t, Gn);
}
function Yh(t) {
  return ZO && Yl(t, Hi);
}
function Xh(t) {
  return t === $1 || t === "all";
}
function Yl(t, e) {
  return t === A1 || t === e || Xh(t);
}
function ea(t, e, n) {
  return { location: t, current: e, previous: n };
}
var i3 = { setItem: e3, getItem: Y1, removeItem: t3 };
function n3(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function xm(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Sm(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xm(Object(n), !0).forEach(function(i) {
      n3(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : xm(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function r3() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = {
    storage: i3
  };
  return GO(Sm(Sm({}, e), t));
}
function Pm(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Zt(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pm(Object(n), !0).forEach(function(i) {
      s3(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Pm(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function s3(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var Em = {}, Tm = "https://www.googletagmanager.com/gtag/js", X1 = {
  // https://support.google.com/analytics/answer/7201382?hl=en#zippy=%2Cglobal-site-tag-websites
  debug_mode: !1,
  /**
   * Disable automatic sending of page views, instead let analytics.page() do this
   * https://developers.google.com/analytics/devguides/collection/gtagjs
   */
  send_page_view: !1,
  // https://developers.google.com/analytics/devguides/collection/gtagjs/ip-anonymization
  anonymize_ip: !1,
  /**
   * Disable All Advertising
   * https://developers.google.com/analytics/devguides/collection/ga4/display-features#disable_all_advertising_features
   */
  allow_google_signals: !0,
  /**
   * Disable Advertising Personalization
   * https://developers.google.com/analytics/devguides/collection/ga4/display-features#disable_advertising_personalization
   */
  allow_ad_personalization_signals: !0,
  /**
   * https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#configure_cookie_field_settings
   */
  // cookie_domain: 'auto',
  // cookie_expires
  // cookie_prefix
  // cookie_update
  // cookie_flags
  /**
   * Cookie Flags
   * https://developers.google.com/analytics/devguides/collection/ga4/cookies-user-id#cookie_flags
   */
  cookie_flags: ""
}, o3 = {
  gtagName: "gtag",
  dataLayerName: "ga4DataLayer",
  measurementIds: [],
  gtagConfig: X1
};
function a3() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = 0, n = Sc(t.measurementIds), i = Zt(Zt({}, o3), t);
  return {
    name: "google-analytics",
    config: i,
    // Load gtag.js and define gtag
    initialize: function(s) {
      var o = s.config, a = s.instance, l = o.dataLayerName, c = o.customScriptSrc, u = o.gtagName, d = o.gtagConfig, h = o.debug, f = o.nonce, p = l ? "&l=".concat(l) : "", v = c || "".concat(Tm, "?id=").concat(n[0]).concat(p);
      if (!Am(v)) {
        var g = document.createElement("script");
        g.async = !0, g.src = v, f && g.setAttribute("nonce", f), document.body.appendChild(g);
      }
      window[l] || (window[l] = window[l] || []), window[u] || (window[u] = function() {
        window[l].push(arguments);
      }), window[u]("js", /* @__PURE__ */ new Date());
      var m = Zt(Zt({}, X1), d || {});
      h === !0 ? m.debug_mode = !0 : delete m.debug_mode;
      var y = a.user() || {}, k = y.traits || {};
      Object.keys(k).length && window[u]("set", "user_properties", k);
      for (var _ = 0; _ < n.length; _++)
        Em[n[_]] || (window[u]("config", n[_], m), Em[n[_]] = !0);
    },
    // Set parameter scope at user level with 'set' method
    identify: function(s) {
      var o = s.payload, a = s.config, l = a.gtagName;
      !window[l] || !n.length || (o.userId && window[l]("set", {
        user_id: o.userId
      }), Object.keys(o.traits).length && window[l]("set", "user_properties", o.traits));
    },
    // Set parameter scope at page level with 'config' method
    page: function(s) {
      var o = s.payload, a = s.config, l = s.instance, c = a.gtagName, u = a.gtagConfig;
      if (!(!window[c] || !n.length)) {
        var d = o.properties, h = d.send_to, f = l.getState("context.campaign"), p = {
          page_title: d.title,
          page_location: d.url,
          page_path: d.path || document.location.pathname,
          page_hash: d.hash,
          page_search: d.page_search,
          page_referrer: d.referrer
        }, v = Cm(f), g = l.user("userId"), m = Zt(Zt(Zt(Zt({}, h ? {
          send_to: h
        } : {}), p), v), g ? {
          user_id: g
        } : {});
        if (u && u.send_page_view && e === 0) {
          e++;
          return;
        }
        window[c]("event", "page_view", m), e++;
      }
    },
    // Set parameter scope at event level with 'event' method
    track: function(s) {
      var o = s.payload, a = s.config, l = s.instance, c = o.properties, u = o.event, d = l.getState("context.campaign"), h = a.gtagName;
      if (!(!window[h] || !n.length)) {
        var f = Cm(d), p = l.user("userId"), v = Zt(Zt(Zt({}, c), f), p ? {
          user_id: p
        } : {});
        window[h]("event", u, v);
      }
    },
    /* Verify gtag loaded and ready to use */
    loaded: function() {
      var s = i.dataLayerName, o = i.customScriptSrc, a = s && window[s] && Array.prototype.push === window[s].push;
      return Am(o || Tm) && a;
    },
    /* Custom methods */
    methods: {
      addTag: function(s) {
        var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        window[i.gtagName] && (window[i.gtagName]("config", s, o), n && !n.includes(s) && (n = n.concat(s)));
      },
      /* Disable gtag for user */
      disable: function(s) {
        for (var o = s ? Sc(s) : n, a = 0; a < n.length; a++) {
          var l = n[a];
          o.includes(l) && (window["ga-disable-".concat(l)] = !0);
        }
      },
      /* Enable gtag for user */
      enable: function(s) {
        for (var o = s ? Sc(s) : n, a = 0; a < n.length; a++) {
          var l = n[a];
          o.includes(l) && (window["ga-disable-".concat(l)] = !1);
        }
      }
    }
  };
}
function Sc(t) {
  if (!t) throw new Error("No GA Measurement ID defined");
  if (Array.isArray(t))
    return t;
  if (typeof t == "string")
    return [t];
  throw new Error("GA Measurement ID must be string or array of strings");
}
function Cm() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = {}, n = t.id, i = t.name, r = t.source, s = t.medium, o = t.content, a = t.keyword;
  return n && (e.campaignId = n), i && (e.campaignName = i), r && (e.campaignSource = r), s && (e.campaignMedium = s), o && (e.campaignContent = o), a && (e.campaignKeyword = a), e;
}
function Am(t) {
  var e = document.querySelectorAll("script[src]"), n = new RegExp("^".concat(t));
  return !!Object.values(e).filter(function(i) {
    return n.test(i.src);
  }).length;
}
var l3 = a3, ta = {};
const L = "u" > typeof window ? window : void 0, kt = "u" > typeof globalThis ? globalThis : L, dt = kt?.navigator, Y = kt?.document, Ke = kt?.location, Qs = kt?.fetch, Jh = kt?.XMLHttpRequest && "withCredentials" in new kt.XMLHttpRequest() ? kt.XMLHttpRequest : void 0, $m = kt?.AbortController, c3 = kt?.CompressionStream, Pt = dt?.userAgent;
function J1() {
  return !(!L || L.navigator.onLine === !1);
}
const ms = typeof globalThis < "u" ? globalThis : L;
ms && typeof self > "u" && (ms.self = ms), ms && typeof File > "u" && (ms.File = function() {
});
const le = L ?? {}, u3 = "0.9.0", ji = { DEBUG: !1, LIB_VERSION: u3, LIB_NAME: "browser-common" };
var hi = (function(t) {
  return t.AnonymousId = "anonymous_id", t.DistinctId = "distinct_id", t.Props = "props", t.EnablePersonProcessing = "enable_person_processing", t.PersonMode = "person_mode", t.FeatureFlagDetails = "feature_flag_details", t.FeatureFlags = "feature_flags", t.FeatureFlagPayloads = "feature_flag_payloads", t.BootstrapFeatureFlagDetails = "bootstrap_feature_flag_details", t.BootstrapFeatureFlags = "bootstrap_feature_flags", t.BootstrapFeatureFlagPayloads = "bootstrap_feature_flag_payloads", t.OverrideFeatureFlags = "override_feature_flags", t.Queue = "queue", t.AiQueue = "ai_queue", t.AiCaptureQueue = "ai_capture_queue", t.LogsQueue = "logs_queue", t.OptedOut = "opted_out", t.SessionId = "session_id", t.SessionStartTimestamp = "session_start_timestamp", t.SessionLastTimestamp = "session_timestamp", t.PersonProperties = "person_properties", t.GroupProperties = "group_properties", t.InstalledAppBuild = "installed_app_build", t.InstalledAppVersion = "installed_app_version", t.SessionReplay = "session_replay", t.PushRegistered = "push_registered", t.SessionReplayEventTriggerActivatedSession = "session_replay_event_trigger_activated_session", t.SurveyLastSeenDate = "survey_last_seen_date", t.SurveysInProgress = "surveys_in_progress", t.SurveysSeen = "surveys_seen", t.Surveys = "surveys", t.RemoteConfig = "remote_config", t.FlagsEndpointWasHit = "flags_endpoint_was_hit", t.DeviceId = "device_id", t;
})({}), rd = (function(t) {
  return t.GZipJS = "gzip-js", t.Base64 = "base64", t;
})({});
const d3 = ["$snapshot", "$pageview", "$pageleave", "$set", "survey dismissed", "survey sent", "survey shown", "$identify", "$groupidentify", "$create_alias", "$$client_ingestion_warning", "$web_experiment_applied", "$feature_enrollment_update", "$feature_flag_called"], h3 = ["token"];
function pe(t, e) {
  return t.indexOf(e) !== -1;
}
const Xl = function(t) {
  return t.trim();
}, sd = function(t) {
  return t.replace(/^\$/, "");
};
function Z1(t) {
  var e;
  const n = [];
  return (e = JSON.stringify(t, function(i, r) {
    if (typeof r == "bigint") return r.toString();
    if (typeof r != "function" && typeof r != "symbol") {
      if (r instanceof Error) return { name: r.name, message: r.message, stack: r.stack };
      if (r && typeof r == "object") {
        for (; n.length > 0 && n[n.length - 1] !== this; ) n.pop();
        if (n.includes(r)) return "[Circular]";
        n.push(r);
      }
      return r;
    }
  })) !== null && e !== void 0 ? e : "null";
}
const Q1 = Object.prototype, Zh = Q1.hasOwnProperty, Jl = Q1.toString, de = Array.isArray || function(t) {
  return Jl.call(t) === "[object Array]";
}, ut = (t) => typeof t == "function", Ee = (t) => t === Object(t) && !de(t), Ot = (t) => {
  if (Ee(t)) {
    for (const e in t) if (Zh.call(t, e)) return !1;
    return !0;
  }
  return !1;
}, G = (t) => t === void 0, Pe = (t) => Jl.call(t) == "[object String]", Os = (t) => Pe(t) && t.trim().length === 0, Ye = (t) => t === null, ve = (t) => G(t) || Ye(t), Qe = (t) => Jl.call(t) == "[object Number]" && t == t, Mi = (t) => Qe(t) && t > 0, Tt = (t) => Jl.call(t) === "[object Boolean]", f3 = (t) => pe(d3, t), p3 = (t) => pe(h3, t);
function e_(t) {
  return t === null || typeof t != "object";
}
function Za(t, e) {
  return {}.toString.call(t) === `[object ${e}]`;
}
function as(t) {
  switch ({}.toString.call(t)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object DOMError]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return t_(t, Error);
  }
}
function Qh(t) {
  return "u" > typeof Event && t_(t, Event);
}
function t_(t, e) {
  try {
    return t instanceof e;
  } catch {
    return !1;
  }
}
const m3 = [!0, "true", 1, "1", "yes"], Pc = (t) => pe(m3, t), g3 = [!1, "false", 0, "0", "no"];
function Rm(t, e, n, i, r, s, o) {
  try {
    var a = t[s](o), l = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(l) : Promise.resolve(l).then(i, r);
}
function He(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(i, r) {
      var s = t.apply(e, n);
      function o(l) {
        Rm(s, i, r, o, a, "next", l);
      }
      function a(l) {
        Rm(s, i, r, o, a, "throw", l);
      }
      o(void 0);
    });
  };
}
const v3 = ["amazonbot", "amazonproductbot", "app.hypefactors.com", "applebot", "archive.org_bot", "awariobot", "backlinksextendedbot", "baiduspider", "bingbot", "bingpreview", "chrome-lighthouse", "dataforseobot", "deepscan", "duckduckbot", "facebookexternal", "facebookcatalog", "http://yandex.com/bots", "hubspot", "ia_archiver", "leikibot", "linkedinbot", "meta-externalagent", "mj12bot", "msnbot", "nessus", "petalbot", "pinterestbot", "prerender", "rogerbot", "screaming frog", "sebot-wa", "sitebulb", "slackbot", "slurp", "trendictionbot", "turnitin", "twitterbot", "vercel-screenshot", "vercelbot", "yahoo! slurp", "yandexbot", "zoombot", "bot.htm", "bot.php", "(bot;", "bot/", "crawler", "ahrefsbot", "ahrefssiteaudit", "semrushbot", "siteauditbot", "splitsignalbot", "gptbot", "oai-searchbot", "chatgpt-user", "perplexitybot", "better uptime bot", "sentryuptimebot", "uptimerobot", "headlesschrome", "cypress", "google-hoteladsverifier", "adsbot-google", "apis-google", "duplexweb-google", "feedfetcher-google", "google favicon", "google web preview", "google-read-aloud", "googlebot", "googleother", "google-cloudvertexbot", "googleweblight", "mediapartners-google", "storebot-google", "google-inspectiontool", "bytespider"], Mm = function(t, e = []) {
  if (!t) return !1;
  const n = t.toLowerCase();
  return v3.concat(e).some((i) => {
    const r = i.toLowerCase();
    return n.indexOf(r) !== -1;
  });
};
function yi(t, e, n, i, r) {
  return e > n && (i.warn("min cannot be greater than max."), e = n), Qe(t) ? t > n ? (i.warn(" cannot be  greater than max: " + n + ". Using max value instead."), n) : e > t ? (i.warn(" cannot be less than min: " + e + ". Using min value instead."), e) : t : (i.warn(" must be a number. using max or fallback. max: " + n + ", fallback: " + r), yi(r ?? n, e, n, i));
}
var y3 = class {
  constructor(t) {
    this.C = {}, this.I = t.I, this.R = yi(t.bucketSize, 0, 100, t.$), this.A = yi(t.refillRate, 0, this.R, t.$), this.O = yi(t.refillInterval, 0, 864e5, t.$);
  }
  F(t, e) {
    const n = Math.floor((e - t.lastAccess) / this.O);
    n > 0 && (t.tokens = Math.min(t.tokens + n * this.A, this.R), t.lastAccess = t.lastAccess + n * this.O);
  }
  consumeRateLimit(t) {
    var e;
    const n = Date.now(), i = String(t);
    let r = this.C[i];
    return r ? this.F(r, n) : (r = { tokens: this.R, lastAccess: n }, this.C[i] = r), r.tokens === 0 || (r.tokens--, r.tokens === 0 && ((e = this.I) === null || e === void 0 || e.call(this, t)), r.tokens === 0);
  }
  stop() {
    this.C = {};
  }
};
const Yr = "Mobile", eo = "Android", Qa = "Tablet", i_ = "Android Tablet", n_ = "iPad", r_ = "Apple Watch", Sa = "Safari", Zl = "BlackBerry", s_ = "Samsung Internet", Pa = "Chrome", o_ = "Chrome iOS", a_ = "Internet Explorer", l_ = "Internet Explorer Mobile", c_ = "Opera", u_ = "Microsoft Edge", Ea = "Firefox", d_ = "Firefox iOS", el = "Nintendo", tl = "PlayStation", Ql = "Xbox", h_ = "Android Mobile", f_ = "Mobile Safari", Ec = "Windows", p_ = "Windows Phone", Om = "Nokia", od = "Ouya", b3 = "Generic " + Yr.toLowerCase(), m_ = "Generic " + Qa.toLowerCase(), ad = "Konqueror", g_ = "Oculus Browser", v_ = "Vivaldi", y_ = "Yandex", b_ = "Whale", __ = "DuckDuckGo", w_ = "Pale Moon", k_ = "Waterfox", ld = "Brave", x_ = "Claude", S_ = "Codex", P_ = "ChatGPT", E_ = "Google Search App", Tc = new RegExp("Version/(\\d+(\\.\\d+)?)"), Cc = new RegExp("(Claude|Codex|ChatGPT)\\/(\\d+(\\.\\d+)?)"), _3 = new RegExp(Ql, "i"), w3 = new RegExp("PlayStation \\w+", "i"), k3 = new RegExp("Nintendo \\w+", "i"), ef = new RegExp("BlackBerry|PlayBook|BB10", "i"), x3 = { "NT3.51": "NT 3.11", "NT4.0": "NT 4.0", "5.0": "2000", 5.1: "XP", 5.2: "XP", "6.0": "Vista", 6.1: "7", 6.2: "8", 6.3: "8.1", 6.4: "10", "10.0": "10" }, T_ = function(t, e, n, i) {
  return e = e || "", (function(s) {
    return s?.brave ? ld : null;
  })(n) || (i?.detectGoogleSearchApp && pe(t, "GSA/") ? E_ : pe(t, " OPR/") && pe(t, "Mini") ? "Opera Mini" : pe(t, " OPR/") ? c_ : ef.test(t) ? Zl : pe(t, "IEMobile") || pe(t, "WPDesktop") ? l_ : pe(t, "OculusBrowser") ? g_ : pe(t, "SamsungBrowser") ? s_ : pe(t, "Edge") || pe(t, "Edg/") ? u_ : pe(t, "Vivaldi/") ? v_ : pe(t, "YaBrowser/") ? y_ : pe(t, "Whale/") ? b_ : pe(t, "DuckDuckGo/") || pe(t, "Ddg/") ? __ : pe(t, "Claude/") ? x_ : pe(t, "Codex/") ? S_ : pe(t, "ChatGPT/") ? P_ : pe(t, "FBIOS") ? "Facebook Mobile" : pe(t, "UCWEB") || pe(t, "UCBrowser") ? "UC Browser" : pe(t, "CriOS") ? o_ : pe(t, "CrMo") || pe(t, Pa) ? Pa : pe(t, eo) && pe(t, Sa) ? h_ : pe(t, "FxiOS") ? d_ : pe(t.toLowerCase(), ad.toLowerCase()) ? ad : pe(t, "Brave/") ? ld : ((s, o) => o && pe(o, "Apple") || (function(a) {
    return pe(a, Sa) && !pe(a, Pa) && !pe(a, eo);
  })(s))(t, e) ? pe(t, Yr) ? f_ : Sa : pe(t, "PaleMoon/") ? w_ : pe(t, "Waterfox/") ? k_ : pe(t, Ea) ? Ea : pe(t, "MSIE") || pe(t, "Trident/") ? a_ : pe(t, "Gecko") ? Ea : "");
}, S3 = { [l_]: [new RegExp("rv:(\\d+(\\.\\d+)?)")], [u_]: [new RegExp("Edge?\\/(\\d+(\\.\\d+)?)")], [Pa]: [new RegExp("(Chrome|CrMo)\\/(\\d+(\\.\\d+)?)")], [o_]: [new RegExp("CriOS\\/(\\d+(\\.\\d+)?)")], "UC Browser": [new RegExp("(UCBrowser|UCWEB)\\/(\\d+(\\.\\d+)?)")], [Sa]: [Tc], [f_]: [Tc], [c_]: [new RegExp("(Opera|OPR)\\/(\\d+(\\.\\d+)?)")], [Ea]: [new RegExp("Firefox\\/(\\d+(\\.\\d+)?)")], [d_]: [new RegExp("FxiOS\\/(\\d+(\\.\\d+)?)")], [ad]: [new RegExp("Konqueror[:/]?(\\d+(\\.\\d+)?)", "i")], [Zl]: [new RegExp("BlackBerry (\\d+(\\.\\d+)?)"), Tc], [h_]: [new RegExp("android\\s(\\d+(\\.\\d+)?)", "i")], [s_]: [new RegExp("SamsungBrowser\\/(\\d+(\\.\\d+)?)")], [g_]: [new RegExp("OculusBrowser\\/(\\d+(\\.\\d+)?)")], [v_]: [new RegExp("Vivaldi\\/(\\d+(\\.\\d+)?)")], [y_]: [new RegExp("YaBrowser\\/(\\d+(\\.\\d+)?)")], [b_]: [new RegExp("Whale\\/(\\d+(\\.\\d+)?)")], [ld]: [new RegExp("Brave\\/(\\d+(\\.\\d+)?)")], [x_]: [Cc], [S_]: [Cc], [P_]: [Cc], [__]: [new RegExp("(DuckDuckGo|Ddg)\\/(\\d+(\\.\\d+)?)")], [w_]: [new RegExp("PaleMoon\\/(\\d+(\\.\\d+)?)")], [k_]: [new RegExp("Waterfox\\/(\\d+(\\.\\d+)?)")], [E_]: [new RegExp("GSA\\/(\\d+(\\.\\d+)?)")], [a_]: [new RegExp("(rv:|MSIE )(\\d+(\\.\\d+)?)")], Mozilla: [new RegExp("rv:(\\d+(\\.\\d+)?)")] }, P3 = function(t, e, n, i) {
  const r = T_(t, e, n, i), s = S3[r];
  if (G(s)) return null;
  for (let o = 0; s.length > o; o++) {
    const a = t.match(s[o]);
    if (a) return parseFloat(a[a.length - 2]);
  }
  return null;
}, Im = [[new RegExp("Xbox; Xbox (.*?)[);]", "i"), (t) => [Ql, t && t[1] || ""]], [new RegExp(el, "i"), [el, ""]], [new RegExp(tl, "i"), [tl, ""]], [ef, [Zl, ""]], [new RegExp(Ec, "i"), (t, e) => {
  if (/Phone/.test(e) || /WPDesktop/.test(e)) return [p_, ""];
  if (new RegExp(Yr).test(e) && !/IEMobile\b/.test(e)) return ["Windows Mobile", ""];
  const n = /Windows NT ([0-9.]+)/i.exec(e);
  if (n && n[1]) {
    let i = x3[n[1]] || "";
    return /arm/i.test(e) && (i = "RT"), [Ec, i];
  }
  return [Ec, ""];
}], [/((iPhone|iPad|iPod).*?OS (\d+)_(\d+)_?(\d+)?|iPhone)/, (t) => t && t[3] ? ["iOS", [t[3], t[4], t[5] || "0"].join(".")] : ["iOS", ""]], [/(watch.*\/(\d+\.\d+\.\d+)|watch os,(\d+\.\d+),)/i, (t) => {
  let e = "";
  return t && t.length >= 3 && (e = G(t[2]) ? t[3] : t[2]), ["watchOS", e];
}], [new RegExp("(Android (\\d+)\\.(\\d+)\\.?(\\d+)?|Android)", "i"), (t) => t && t[2] ? [eo, [t[2], t[3], t[4] || "0"].join(".")] : [eo, ""]], [/Mac OS X (\d+)[_.](\d+)[_.]?(\d+)?/i, (t) => {
  const e = ["Mac OS X", ""];
  return t && t[1] && (e[1] = [t[1], t[2], t[3] || "0"].join(".")), e;
}], [/Mac/i, ["Mac OS X", ""]], [/CrOS/, ["Chrome OS", ""]], [/Linux|debian/i, ["Linux", ""]]], C_ = function(t) {
  for (let e = 0; Im.length > e; e++) {
    const [n, i] = Im[e], r = n.exec(t), s = r && (ut(i) ? i(r, t) : i);
    if (s) return s;
  }
  return ["", ""];
}, A_ = function(t) {
  return k3.test(t) ? el : w3.test(t) ? tl : _3.test(t) ? Ql : new RegExp(od, "i").test(t) ? od : new RegExp("(Windows Phone|WPDesktop)", "i").test(t) ? p_ : /iPad/.test(t) ? n_ : /iPod/.test(t) ? "iPod Touch" : /iPhone/.test(t) ? "iPhone" : /(watch)(?: ?os[,/]|\d,\d\/)[\d.]+/i.test(t) ? r_ : ef.test(t) ? Zl : /(kobo)\s(ereader|touch)/i.test(t) ? "Kobo" : new RegExp(Om, "i").test(t) ? Om : /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i.test(t) || /(kf[a-z]+)( bui|\)).+silk\//i.test(t) ? "Kindle Fire" : /(Android|ZTE)/i.test(t) ? new RegExp(Yr).test(t) && !/(9138B|TB782B|Nexus [97]|pixel c|HUAWEISHT|BTV|noble nook|smart ultra 6)/i.test(t) || /pixel[\daxl ]{1,6}/i.test(t) && !/pixel c/i.test(t) || /(huaweimed-al00|tah-|APA|SM-G92|i980|zte|U304AA)/i.test(t) || /lmy47v/i.test(t) && !/QTAQZ3/i.test(t) ? eo : i_ : new RegExp("(pda|Mobile)", "i").test(t) ? b3 : new RegExp(Qa, "i").test(t) && !new RegExp("Tablet pc", "i").test(t) ? m_ : "";
}, E3 = function(t, e) {
  var n;
  const i = A_(t);
  return i === n_ || i === i_ || i === "Kobo" || i === "Kindle Fire" || i === m_ ? Qa : i === el || i === Ql || i === tl || i === od ? "Console" : i === r_ ? "Wearable" : i ? Yr : e?.userAgentDataPlatform === "Android" && ((n = e?.maxTouchPoints) !== null && n !== void 0 ? n : 0) > 0 ? 600 > Math.min((r = e?.screenWidth) !== null && r !== void 0 ? r : 0, (s = e?.screenHeight) !== null && s !== void 0 ? s : 0) / ((o = e?.devicePixelRatio) !== null && o !== void 0 ? o : 1) ? Yr : Qa : "Desktop";
  var r, s, o;
}, Ac = /\bFBAV\/(\d+(?:\.\d+)*)/i, Dm = [[/\bInstagram(?:[ /](\d+(?:\.\d+)*))?\b/i, "Instagram"], [/\bBarcelona[ /](\d+(?:\.\d+)*)?/i, "Threads"], [/\b(?:MessengerForiOS|(?:FBAN|FB_IAB)\/Orca-Android)\b/i, "Messenger", Ac], [/\bFBAN\/EMA\b/i, "Facebook Lite", Ac], [/\b(?:FBIOS|(?:FBAN|FB_IAB)\/(?:FB4A|FBIOS))\b/i, "Facebook", Ac], [/\bLinkedInApp(?:\]?\/(\d+(?:\.\d+)*))?\b/i, "LinkedIn"], [/\bTwitter(?:Android| for (?:iPhone|iPad|Android))(?:\/(\d+(?:\.\d+)*))?\b/i, "Twitter"], [/\b(?:musical_ly|trill)(?:[_/](\d+\.\d+(?:\.\d+)*))?(?=\b|_)/i, "TikTok", /\bapp_version\/(\d+(?:\.\d+)*)/i], [/\b(?:MicroMessenger|WeChat)\/(\d+(?:\.\d+)*)?/i, "WeChat"], [/\bLine\/(\d+(?:\.\d+)*)?/i, "Line"], [/\bGSA\/(\d+(?:\.\d+)*)?/i, "Google"], [/\[Pinterest\/(?:iOS|Android)\b|\bPinterest(?: for (?:Android(?: Tablet)?|iOS))?\/(\d+(?:\.\d+)*)/i, "Pinterest"], [/\b(?:WA4A|WAiOS)\/(\d+(?:\.\d+)*)?/i, "WhatsApp"], [/\bSnapchat[ /](\d+(?:\.\d+)*)?/i, "Snapchat"], [/\bBing(?:Web|Sapphire)\/(\d+(?:\.\d+)*)?/i, "Bing"], [/\bNAVER\(inapp; search;/i, "Naver", /\bNAVER\(inapp; search;[^;)]*; (\d+(?:\.\d+)*)/i], [/\bKAKAOTALK[ /](\d+\.\d+(?:\.\d+)*)?/i, "KakaoTalk"]], cd = "[Truncated]", To = "[Unserializable]";
function Nr(t) {
  let e = "";
  for (let n = 0; t.length > n; n++) {
    const i = t.charCodeAt(n);
    if (55296 > i || i > 56319) e += 56320 > i || i > 57343 ? t[n] : "�";
    else {
      const r = t.charCodeAt(n + 1);
      56320 > r || r > 57343 ? e += "�" : (e += t[n] + t[n + 1], n++);
    }
  }
  return e;
}
function $_(t, e) {
  if (!e) return t;
  let n = [];
  try {
    n = Object.keys(e);
  } catch {
    n = [];
  }
  for (const i of n) {
    let r;
    try {
      r = e[i];
    } catch {
      r = To;
    }
    Object.defineProperty(t, i, { value: r, enumerable: !0, writable: !0, configurable: !0 });
  }
  return t;
}
const Ta = 3e5;
var R_ = class {
  record(t) {
    if (t.kind === "too-large") return;
    if (t.kind !== "retry-later") return void this.reset();
    if (!t.retryAfterMs) return;
    const e = this.isOpen(), n = Date.now(), i = Math.min(t.retryAfterMs, Ta);
    if (!e) return this.ts = n, void (this.es = n + i);
    this.es = Math.max(this.es, Math.min(n + i, this.ts + Ta));
  }
  remainingMs() {
    const t = Date.now();
    if (this.ts - 5e3 > t) return this.reset(), 0;
    const e = Math.min(Ta, Math.max(0, this.es - t));
    return e === 0 && this.reset(), e;
  }
  isOpen() {
    return this.remainingMs() > 0;
  }
  reset() {
    this.es = 0, this.ts = 0;
  }
  constructor() {
    this.es = 0, this.ts = 0;
  }
};
const T3 = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function Fm(t, e) {
  return typeof (n = t) == "string" && T3.test(n) ? t : e();
  var n;
}
function M_(t, e) {
  const n = new Error(e);
  try {
    Object.defineProperty(n, "name", { value: t, writable: !0, enumerable: !0, configurable: !0 });
  } catch {
  }
  return n;
}
function gn(t) {
  return t && t.split("#")[0];
}
function Lm(t) {
  try {
    return t();
  } catch {
    return;
  }
}
function O_(t, e) {
  const n = setTimeout(t, e);
  return n != null && n.unref && n?.unref(), n;
}
function Nm(t, e, n) {
  return I_.apply(this, arguments);
}
function I_() {
  return (I_ = He(function* (t, e, n) {
    let i;
    try {
      return yield Promise.race([t, new Promise((r, s) => {
        i = O_(() => {
          try {
            n?.(), r();
          } catch (o) {
            s(o);
          }
        }, e);
      })]);
    } finally {
      clearTimeout(i);
    }
  })).apply(this, arguments);
}
let ia, Vm, $c;
function C3(t) {
  const e = globalThis._posthogChunkIds;
  if (!e) return;
  const n = Object.keys(e);
  return $c && n.length === Vm || (Vm = n.length, $c = n.reduce((i, r) => {
    ia || (ia = {});
    const s = ia[r];
    if (s) i[s[0]] = s[1];
    else {
      const o = t(r);
      for (let a = o.length - 1; a >= 0; a--) {
        const l = o[a], c = l?.filename, u = e[r];
        if (c && u) {
          i[c] = u, ia[r] = [c, u];
          break;
        }
      }
    }
    return i;
  }, {})), $c;
}
function Is(t) {
  return Is = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Is(t);
}
function A3(t, e, n) {
  return (e = (function(i) {
    var r = (function(s) {
      if (Is(s) != "object" || !s) return s;
      var o = s[Symbol.toPrimitive];
      if (o !== void 0) {
        var a = o.call(s, "string");
        if (Is(a) != "object") return a;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return String(s);
    })(i);
    return Is(r) == "symbol" ? r : r + "";
  })(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function jm(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function R(t) {
  for (var e = 1; arguments.length > e; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jm(Object(n), !0).forEach(function(i) {
      A3(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : jm(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
var $3 = class {
  constructor(t, e, n = []) {
    this.coercers = t, this.stackParser = e, this.modifiers = n;
  }
  buildFromUnknown(t, e = {}) {
    const n = e && e.mechanism || { handled: !0, type: "generic" }, i = this.buildCoercingContext(n, e, 0).apply(t), r = this.buildParsingContext(e), s = this.parseStacktrace(i, r);
    return { $exception_list: this.convertToExceptionList(s, n), $exception_level: "error" };
  }
  modifyFrames(t) {
    var e = this;
    return He(function* () {
      for (const n of t) n.stacktrace && n.stacktrace.frames && de(n.stacktrace.frames) && (n.stacktrace.frames = yield e.applyModifiers(n.stacktrace.frames));
      return t;
    })();
  }
  coerceFallback(t) {
    var e;
    return { type: "Error", value: "Unknown error", stack: (e = t.syntheticException) === null || e === void 0 ? void 0 : e.stack, synthetic: !0 };
  }
  parseStacktrace(t, e) {
    var n;
    let i, r;
    if (t.cause != null && (i = this.parseStacktrace(t.cause, e)), t.stack != "" && t.stack != null) try {
      r = this.applyChunkIds(this.stackParser(t.stack, t.synthetic ? e.skipFirstLines : 0), e.chunkIdMap);
    } catch {
    }
    return R(R({}, t), {}, { cause: i, stack: r, errors: (n = t.errors) === null || n === void 0 ? void 0 : n.map((s) => this.parseStacktrace(s, e)) });
  }
  applyChunkIds(t, e) {
    return t.map((n) => (n.filename && e && (n.chunk_id = e[n.filename]), n));
  }
  applyCoercers(t, e) {
    for (const n of this.coercers) if (n.match(t)) return n.coerce(t, e);
    return this.coerceFallback(e);
  }
  applyModifiers(t) {
    var e = this;
    return He(function* () {
      let n = t;
      for (const i of e.modifiers) n = yield i(n);
      return n;
    })();
  }
  convertToExceptionList(t, e) {
    const n = [], i = (r, s, o) => {
      var a;
      const l = n.length, c = s === void 0 ? R(R({ type: typeof e.type == "string" && e.type.length > 0 ? e.type : "generic" }, typeof e.handled == "boolean" ? { handled: e.handled } : e.handled === void 0 ? { handled: !0 } : {}), {}, { synthetic: typeof e.synthetic == "boolean" ? e.synthetic : r.synthetic, exception_id: l }) : { type: "chained", source: o, synthetic: r.synthetic, exception_id: l, parent_id: s }, u = { type: r.type, value: r.value, mechanism: c };
      r.stack && (u.stacktrace = { type: "raw", frames: r.stack }), n.push(u), r.cause && i(r.cause, l, "cause");
      for (const d of (a = r.errors) !== null && a !== void 0 ? a : []) i(d, l, "member");
    };
    return i(t), n;
  }
  buildParsingContext(t) {
    var e;
    return { chunkIdMap: C3(this.stackParser), skipFirstLines: (e = t.skipFirstLines) !== null && e !== void 0 ? e : 1 };
  }
  getAggregateErrors(t) {
    try {
      if (as(t)) {
        let n = Object.getPrototypeOf(t);
        for (let i = 0; n && 100 > i; i++) {
          var e;
          const r = (e = Object.getOwnPropertyDescriptor(n, "constructor")) === null || e === void 0 ? void 0 : e.value;
          if (typeof r == "function" && r.name === "AggregateError") {
            const s = t.errors;
            return de(s) ? s : void 0;
          }
          n = Object.getPrototypeOf(n);
        }
      }
    } catch {
    }
  }
  buildCoercingContext(t, e, n = 0) {
    let i = 0, r = 0, s = !1;
    const o = /* @__PURE__ */ new Set(), a = [], l = {}, c = (h, f, p = 0) => {
      const v = u(f, p), g = v.apply;
      if (v.apply = (T) => {
        a.push(h);
        try {
          return g(T);
        } finally {
          a.pop();
        }
      }, p > 4 || p > 0 && a.indexOf(h) !== -1) return this.coerceFallback(v);
      const m = typeof h == "object" && h !== null || typeof h == "function";
      if (p === 0 && i >= 50 || m && o.has(h)) return;
      m && o.add(h), p === 0 && i++;
      const y = this.getAggregateErrors(h);
      let k, _;
      s || (s = !!y);
      try {
        if (k = this.applyCoercers(h, v), !k) throw l;
      } catch (T) {
        if (T === l) return void (p === 0 && i--);
        if (!s) throw T;
        k = this.coerceFallback(v);
      }
      if (!y || i >= 50) return k;
      try {
        _ = y.length;
      } catch {
        return k;
      }
      if (!Number.isInteger(_) || 0 > _ || _ > 4294967295) return k;
      const w = [];
      for (let T = 0; 50 > i && 1e3 > r && _ > T; T++) {
        let E;
        r++;
        try {
          E = v.next(y[T]);
        } catch {
          i++, E = this.coerceFallback(u(f + 1));
        }
        E && w.push(E);
      }
      return R(R({}, k), {}, { errors: w });
    }, u = (h, f = 0) => R(R({}, e), {}, { syntheticException: h == 0 ? e.syntheticException : void 0, mechanism: h == 0 ? t : {}, apply(p) {
      const v = c(p, h, f + 1);
      if (!v) throw l;
      return v;
    }, next: (p) => c(p, h + 1) }), d = u(n);
    return R(R({}, d), {}, { apply: (h) => {
      var f;
      return (f = c(h, n)) !== null && f !== void 0 ? f : this.coerceFallback(d);
    } });
  }
};
const R3 = /^([a-z][a-z0-9.+-]+):/i, M3 = ["http", "https", "file", "blob", "app", "capacitor", "ionic", "webpack", "webpack-internal", "ng"];
function O3(t) {
  if (!t || t === "<anonymous>") return !1;
  const e = R3.exec(t);
  return !e || M3.includes(e[1].toLowerCase());
}
function ud(t, e, n, i, r) {
  const s = { platform: t, filename: e, function: n === "<anonymous>" ? "?" : n, in_app: O3(e) };
  return G(i) || (s.lineno = i), G(r) || (s.colno = r), s;
}
const D_ = (t, e) => {
  const n = t.indexOf("safari-extension") !== -1, i = t.indexOf("safari-web-extension") !== -1;
  return n || i ? [t.indexOf("@") !== -1 ? t.split("@")[0] : "?", n ? `safari-extension:${e}` : `safari-web-extension:${e}`] : [t, e];
}, I3 = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, D3 = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, F3 = /\((\S*)(?::(\d+))(?::(\d+))\)/, L3 = (t, e) => {
  const n = I3.exec(t);
  if (n) {
    const [, r, s, o] = n;
    return ud(e, r, "?", +s, +o);
  }
  const i = D3.exec(t);
  if (i) {
    if (i[2] && i[2].indexOf("eval") === 0) {
      const o = F3.exec(i[2]);
      o && (i[2] = o[1], i[3] = o[2], i[4] = o[3]);
    }
    const [r, s] = D_(i[1] || "?", i[2]);
    return ud(e, s, r, i[3] ? +i[3] : void 0, i[4] ? +i[4] : void 0);
  }
}, N3 = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, V3 = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, j3 = (t, e) => {
  const n = N3.exec(t);
  if (n) {
    if (n[3] && n[3].indexOf(" > eval") > -1) {
      const s = V3.exec(n[3]);
      s && (n[1] = n[1] || "eval", n[3] = s[1], n[4] = s[2], n[5] = "");
    }
    let i = n[3], r = n[1] || "?";
    return [r, i] = D_(r, i), ud(e, i, r, n[4] ? +n[4] : void 0, n[5] ? +n[5] : void 0);
  }
}, zm = /\(error: (.*)\)/;
function tf(t, e) {
  return t.filename === e.filename && t.function === e.function && t.module === e.module && t.lineno === e.lineno && t.colno === e.colno;
}
function z3(t) {
  for (let e = 1; 10 >= e; e++) {
    const n = t.length - 2 * e;
    if (0 > n) break;
    let i = !0;
    for (let r = 0; e > r; r++) if (!tf(t[n + r], t[n + e + r])) {
      i = !1;
      break;
    }
    if (i) {
      for (let r = 0; e > r; r++) t[n + r] = t[n + e + r];
      return t.length = n + e, { start: n, length: e };
    }
  }
}
function B3(t, e) {
  const n = e.start + e.length, i = L_(t, e);
  i && t.splice(n + i === t.length ? n : e.start, i);
}
function F_(t, e) {
  let n = e.start;
  for (; n > 0 && tf(t[n - 1], t[n - 1 + e.length]); ) n--;
  return e.start - n;
}
function L_(t, e) {
  const n = e.start + e.length;
  let i = n;
  for (; t.length > i && tf(t[i], t[i - e.length]); ) i++;
  return i - n;
}
function H3(t, e) {
  const n = e[0];
  let i = t.length - (n ? F_(t, n) : 0);
  for (const r of e) i -= L_(t, r);
  return i;
}
function U3(t, e, n) {
  for (let i = 0; t.length > i; i++) {
    const r = t[(e + i) % t.length], s = t[(n + i) % t.length];
    if (r !== s) return s > r;
  }
  return !1;
}
var W3 = class {
  match(t) {
    return this.isDOMException(t) || this.isDOMError(t);
  }
  coerce(t, e) {
    const n = Pe(t.stack);
    return { type: this.getType(t), value: this.getValue(t), stack: n ? t.stack : void 0, cause: t.cause ? e.next(t.cause) : void 0, synthetic: !1 };
  }
  getType(t) {
    return this.isDOMError(t) ? "DOMError" : "DOMException";
  }
  getValue(t) {
    const e = t.name || (this.isDOMError(t) ? "DOMError" : "DOMException");
    return t.message ? `${e}: ${t.message}` : e;
  }
  isDOMException(t) {
    return Za(t, "DOMException");
  }
  isDOMError(t) {
    return Za(t, "DOMError");
  }
}, q3 = class {
  match(t) {
    return as(t);
  }
  coerce(t, e) {
    var n;
    const i = this.getStack(t), r = i === void 0 ? (n = e.syntheticException) === null || n === void 0 ? void 0 : n.stack : void 0, s = !!r;
    return { type: this.getType(t), value: this.getMessage(t, e), stack: i ?? r, cause: t.cause ? e.next(t.cause) : void 0, synthetic: s };
  }
  getType(t) {
    return t.name || t.constructor.name;
  }
  getMessage(t, e) {
    const n = t.message;
    return String(n.error && typeof n.error.message == "string" ? n.error.message : n);
  }
  getStack(t) {
    try {
      const e = t.stacktrace;
      if (typeof e == "string" && e.length > 0) return e;
      const n = t.stack;
      return typeof n == "string" && n.length > 0 ? n : void 0;
    } catch {
      return;
    }
  }
}, G3 = class {
  match(t) {
    return !!Za(t, "ErrorEvent") && (t.error != null || this.ur(t));
  }
  coerce(t, e) {
    var n;
    if (t.error != null) return e.apply(t.error);
    const i = e.apply(t.message);
    return R(R({}, i), {}, { stack: (n = this.cr(t)) !== null && n !== void 0 ? n : i.stack, synthetic: !0 });
  }
  ur(t) {
    return Pe(t.message) && t.message.length > 0;
  }
  cr(t) {
    var e, n;
    const i = t, r = (e = i.lineno) !== null && e !== void 0 ? e : 0, s = (n = i.colno) !== null && n !== void 0 ? n : 0;
    if (Pe(i.filename) && i.filename.length !== 0 && r !== 0) return `Error
    at ${i.filename}:${r}:${s}`;
  }
};
const K3 = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
var Y3 = class {
  match(t) {
    return typeof t == "string";
  }
  coerce(t, e) {
    var n;
    const [i, r] = this.getInfos(t);
    return { type: i ?? "Error", value: r ?? t, stack: (n = e.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 };
  }
  getInfos(t) {
    let e = "Error", n = t;
    const i = t.match(K3);
    return i && (e = i[1], n = i[2]), [e, n];
  }
};
const X3 = ["fatal", "error", "warning", "log", "info", "debug"];
function N_(t, e = 40) {
  const n = Object.keys(t);
  if (n.sort(), !n.length) return "[object has no keys]";
  for (let i = n.length; i > 0; i--) {
    const r = n.slice(0, i).join(", ");
    if (e >= r.length) return i === n.length ? r : r.length > e ? `${r.slice(0, e)}...` : r;
  }
  return "";
}
var J3 = class {
  match(t) {
    return typeof t == "object" && t !== null;
  }
  coerce(t, e) {
    var n, i;
    const r = this.getErrorPropertyFromObject(t);
    return r ? e.apply(r) : { type: this.getType(t), value: this.getValue(t), stack: (n = this.getStack(t)) !== null && n !== void 0 ? n : (i = e.syntheticException) === null || i === void 0 ? void 0 : i.stack, level: this.isSeverityLevel(t.level) ? t.level : "error", synthetic: !0 };
  }
  getType(t) {
    if (Qh(t)) return t.constructor.name;
    const e = "name" in t ? t.name : void 0;
    return Pe(e) && !Os(e) ? e : "Error";
  }
  getValue(t) {
    if ("name" in t && typeof t.name == "string") {
      let n = `'${t.name}' captured as exception`;
      return "message" in t && typeof t.message == "string" && (n += ` with message: '${t.message}'`), n;
    }
    if ("message" in t && typeof t.message == "string") return t.message;
    const e = this.getObjectClassName(t);
    return `${e && e !== "Object" ? `'${e}'` : "Object"} captured as exception with keys: ${N_(t)}`;
  }
  isSeverityLevel(t) {
    return Pe(t) && !Os(t) && X3.indexOf(t) >= 0;
  }
  getStack(t) {
    try {
      return Pe(t.stacktrace) && t.stacktrace.length > 0 ? t.stacktrace : Pe(t.stack) && t.stack.length > 0 ? t.stack : void 0;
    } catch {
      return;
    }
  }
  getErrorPropertyFromObject(t) {
    for (const e in t) if ({}.hasOwnProperty.call(t, e)) {
      const n = t[e];
      if (as(n)) return n;
    }
  }
  getObjectClassName(t) {
    try {
      const e = Object.getPrototypeOf(t);
      return e ? e.constructor.name : void 0;
    } catch {
      return;
    }
  }
}, Z3 = class {
  match(t) {
    return Qh(t);
  }
  coerce(t, e) {
    var n;
    const i = t.constructor.name;
    return { type: i, value: `${i} captured as exception with keys: ${N_(t)}`, stack: (n = e.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 };
  }
}, Q3 = class {
  match(t) {
    return e_(t);
  }
  coerce(t, e) {
    var n;
    return { type: "Error", value: `Primitive value captured as exception: ${String(t)}`, stack: (n = e.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 };
  }
}, eI = class {
  match(t) {
    return Za(t, "PromiseRejectionEvent") || this.isCustomEventWrappingRejection(t);
  }
  isCustomEventWrappingRejection(t) {
    if (!Qh(t)) return !1;
    try {
      const e = t.detail;
      return e != null && typeof e == "object" && "reason" in e;
    } catch {
      return !1;
    }
  }
  coerce(t, e) {
    var n;
    const i = this.getUnhandledRejectionReason(t);
    return e_(i) ? { type: "UnhandledRejection", value: `Non-Error promise rejection captured with value: ${String(i)}`, stack: (n = e.syntheticException) === null || n === void 0 ? void 0 : n.stack, synthetic: !0 } : e.apply(i);
  }
  getUnhandledRejectionReason(t) {
    try {
      if ("reason" in t) return t.reason;
      if ("detail" in t && t.detail != null && typeof t.detail == "object" && "reason" in t.detail) return t.detail.reason;
    } catch {
    }
    return t;
  }
};
const il = "$message", nl = "$timestamp", tI = /* @__PURE__ */ new Set([il, nl]), Rc = { enabled: !0, max_bytes: 32768 };
function rl(t) {
  var e;
  return t ? { enabled: (e = t.enabled) !== null && e !== void 0 ? e : Rc.enabled, max_bytes: nI(t.max_bytes, Rc.max_bytes) } : R({}, Rc);
}
var iI = class {
  constructor(t) {
    this.ns = [], this.ss = 0, this.Rr = rl(t);
  }
  setConfig(t) {
    this.Rr = rl(t), this.rs();
  }
  add(t) {
    const e = (function(i) {
      let r;
      try {
        r = Z1(i);
      } catch {
        return;
      }
      try {
        const s = JSON.parse(r);
        if (!Ee(s)) return;
        const o = s, a = o[il], l = o[nl];
        return !Pe(a) || a.trim().length === 0 || !Pe(l) && !Qe(l) ? void 0 : { step: o, json: r };
      } catch {
        return;
      }
    })(t);
    if (!e) return;
    const n = (function(i) {
      if ("u" > typeof TextEncoder) return new TextEncoder().encode(i).length;
      const r = encodeURIComponent(i);
      let s = 0;
      for (let o = 0; r.length > o; o++) r[o] === "%" ? (s += 1, o += 2) : s += 1;
      return s;
    })(e.json);
    n > this.Rr.max_bytes || (this.ns.push({ step: e.step, bytes: n }), this.ss += n, this.rs());
  }
  getAttachable() {
    return this.ns.map((t) => t.step);
  }
  clear() {
    this.ns = [], this.ss = 0;
  }
  size() {
    return this.ns.length;
  }
  rs() {
    for (; this.ss > this.Rr.max_bytes && this.ns.length > 0; ) {
      const t = this.ns.shift();
      t && (this.ss -= t.bytes);
    }
  }
};
function nI(t, e) {
  if (!Qe(t) || t === 1 / 0 || t === -1 / 0) return e;
  const n = Math.floor(t);
  return 0 > n ? e : n;
}
const Bm = (t) => {
  if (typeof t != "string") return t;
  try {
    return JSON.parse(t);
  } catch {
    return t;
  }
};
function Hm(t) {
  return typeof t == "string" || t;
}
function Um(t) {
  return typeof t == "string" ? t : void 0;
}
const rI = ["$feature_flag", "$feature_flag_response", "$feature_flag_has_experiment", "$feature_flag_id", "$feature_flag_version", "$feature_flag_reason", "$feature_flag_request_id", "$feature_flag_evaluated_at", "$feature_flag_error", "locally_evaluated", "$groups", "$process_person_profile", "$geoip_disable", "$current_url", "$pathname", "$referring_domain", "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid", "gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx", "$session_id", "$window_id", "$lib", "$lib_version", "$device_id", "$is_server"], V_ = "NativeGzipValidationError", dd = (t) => t.length >= 2 && t[0] === 31 && t[1] === 139, Wm = (t, e) => t === rd.GZipJS || e === rd.GZipJS || e === "gzip", qm = (t) => !(!t || typeof t != "object") && ("name" in t ? String(t.name) : "") === "NotReadableError";
let gs;
const na = (t) => {
  throw M_(V_, `Native gzip produced invalid output: ${t}`);
}, sI = (Gm = He(function* (t, e) {
  18 > t.size && na("too-short");
  const n = new Uint8Array(yield t.slice(0, 10).arrayBuffer());
  dd(n) && n[2] === 8 || na("invalid-header");
  const i = new DataView(yield t.slice(t.size - 8).arrayBuffer());
  i.getUint32(0, !0) !== ((s) => {
    const o = (() => {
      if (gs) return gs;
      gs = [];
      for (let l = 0; 256 > l; l++) {
        let c = l;
        for (let u = 0; 8 > u; u++) c = 1 & c ? 3988292384 ^ c >>> 1 : c >>> 1;
        gs[l] = c >>> 0;
      }
      return gs;
    })();
    let a = 4294967295;
    for (let l = 0; s.length > l; l++) a = o[255 & (a ^ s[l])] ^ a >>> 8;
    return (4294967295 ^ a) >>> 0;
  })(e) && na("invalid-crc");
  const r = e.length >>> 0;
  i.getUint32(4, !0) !== r && na("invalid-size");
}), function(t, e) {
  return Gm.apply(this, arguments);
});
var Gm;
function hd() {
  return hd = He(function* (t, e = !0, n) {
    try {
      const r = new TextEncoder().encode(t), s = new globalThis.CompressionStream("gzip"), o = s.writable.getWriter(), a = o.write(r).then(() => o.close()).catch((i = He(function* (u) {
        try {
          yield o.abort(u);
        } catch {
        }
        throw u;
      }), function(u) {
        return i.apply(this, arguments);
      })), l = new Response(s.readable).blob(), [c] = yield Promise.all([l, a]);
      return yield sI(c, r), c;
    } catch (r) {
      if (n?.rethrow) throw r;
      return e && console.error("Failed to gzip compress data", r), null;
    }
    var i;
  }), hd.apply(this, arguments);
}
function j_(t, e) {
  if (t == null) return {};
  var n, i, r = (function(o, a) {
    if (o == null) return {};
    var l = {};
    for (var c in o) if ({}.hasOwnProperty.call(o, c)) {
      if (a.includes(c)) continue;
      l[c] = o[c];
    }
    return l;
  })(t, e);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(t);
    for (i = 0; s.length > i; i++) e.includes(n = s[i]) || {}.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
const oI = {}.propertyIsEnumerable;
function sl(t, e) {
  try {
    return z_(t, e, { ancestors: /* @__PURE__ */ new WeakSet(), remainingNodes: 1e4 }, 0);
  } catch {
    return [];
  }
}
function nf(t, e, n, i) {
  if (0 >= n.remainingNodes) return { stringValue: cd };
  if (n.remainingNodes--, Tt(t)) return { boolValue: t };
  if (typeof t == "bigint") return (function(r, s) {
    const o = r.toString(), a = BigInt("9223372036854775808");
    return r >= a || -a > r ? (s?.debug(`Attribute ${o} is outside the int64 range; encoding it as a string`), { stringValue: o }) : { intValue: o };
  })(t, e);
  if (typeof t == "number") {
    if (!Number.isFinite(t)) return { stringValue: String(t) };
    if (Number.isInteger(t)) {
      if (Number.isSafeInteger(t)) return { intValue: String(t) };
      if (typeof BigInt > "u") return { stringValue: String(t) };
      const r = BigInt(t).toString();
      return t >= 9223372036854776e3 || -9223372036854776e3 > t ? (e?.debug(`Attribute ${r} is outside the int64 range; encoding it as a string`), { stringValue: r }) : { intValue: r };
    }
    return { doubleValue: t };
  }
  if (typeof t == "string") return { stringValue: Nr(t) };
  if (typeof t == "function") return { stringValue: "[Function]" };
  if (typeof t == "symbol") return { stringValue: String(t) };
  if (typeof t == "object" && t !== null) {
    if (n.ancestors.has(t)) return { stringValue: "[Circular]" };
    if (i >= 20) return { stringValue: cd };
    if (t instanceof Date) {
      const r = t.getTime(), s = Number.isFinite(r) ? t.toISOString() : String(t);
      return { stringValue: typeof s == "string" ? Nr(s) : String(s) };
    }
    n.ancestors.add(t);
    try {
      try {
        const r = t.toJSON;
        if (typeof r == "function") return nf(r.call(t), e, n, i + 1);
      } catch {
      }
      return de(t) ? { arrayValue: { values: aI(t, e, n, i + 1) } } : { kvlistValue: { values: z_(t, e, n, i + 1) } };
    } finally {
      n.ancestors.delete(t);
    }
  }
  return { stringValue: Nr(String(t)) };
}
function aI(t, e, n, i) {
  const r = [], s = Math.min(t.length, 1e3);
  let o = 0;
  for (; s > o && n.remainingNodes > 0; o++) try {
    const a = o in t ? t[o] : void 0;
    if (ve(a)) continue;
    r.push(nf(a, e, n, i));
  } catch {
    r.push({ stringValue: To });
  }
  return t.length > o && r.push({ stringValue: cd }), r;
}
function z_(t, e, n, i) {
  const r = [];
  for (const s in t) if (oI.call(t, s)) {
    if (!s) {
      e?.debug("Dropping an attribute with an empty key");
      continue;
    }
    if (r.length >= 1e3 || 0 >= n.remainingNodes) {
      e?.debug("Attributes truncated: the value exceeds the OTLP encoder budget");
      break;
    }
    try {
      const o = t[s];
      if (Ye(o) || G(o)) continue;
      r.push({ key: Nr(s), value: nf(o, e, n, i) });
    } catch {
      r.push({ key: Nr(s), value: { stringValue: To } });
    }
  }
  return r;
}
function B_(t, e, n) {
  return R(R(R(R({}, $_({}, t.resourceAttributes)), {}, { "service.name": t.serviceName || "unknown_service" }, t.environment && { "deployment.environment": t.environment }), t.serviceVersion && { "service.version": t.serviceVersion }), {}, { "telemetry.sdk.name": e, "telemetry.sdk.version": n });
}
const lI = ["service.name", "deployment.environment", "service.version", "telemetry.sdk.name", "telemetry.sdk.version"];
function H_(t, e) {
  const n = $_({}, t), i = {};
  for (const r of lI) ({}).hasOwnProperty.call(n, r) && (i[r] = n[r], delete n[r]);
  return [...sl(n, e), ...sl(i, e)];
}
const Km = { darwin: "macOS", win32: "Windows", cygwin: "Windows", linux: "Linux", android: "Android", freebsd: "FreeBSD", openbsd: "OpenBSD", netbsd: "NetBSD", sunos: "SunOS", aix: "AIX", haiku: "Haiku", "Mac OS X": "macOS" }, U_ = { trace: { text: "TRACE", number: 1 }, debug: { text: "DEBUG", number: 5 }, info: { text: "INFO", number: 9 }, warn: { text: "WARN", number: 13 }, error: { text: "ERROR", number: 17 }, fatal: { text: "FATAL", number: 21 } }, cI = U_.info;
function uI(t) {
  try {
    return Nr(String(t));
  } catch {
    return To;
  }
}
function dI(t, e, n, i) {
  const r = t.level || "info", { text: s, number: o } = U_[r] || cI, a = (function(h = Date.now()) {
    return String(h) + "000000";
  })(Qe(i) ? i : void 0), l = {};
  e.distinctId && (l.posthogDistinctId = e.distinctId), e.sessionId && (l.sessionId = e.sessionId), e.windowId && (l["window.id"] = e.windowId), ve(e.sessionStartTimestamp) || (l.sessionStartTimestamp = String(e.sessionStartTimestamp)), ve(e.lastActivityTimestamp) || (l.lastActivityTimestamp = String(e.lastActivityTimestamp)), e.currentUrl && (l["url.full"] = e.currentUrl), e.screenName && (l["screen.name"] = e.screenName), e.appState && (l["app.state"] = e.appState), e.activeFeatureFlags && e.activeFeatureFlags.length > 0 && (l.feature_flags = e.activeFeatureFlags);
  const c = R({}, l), u = t.attributes;
  if (u) {
    let h = [];
    try {
      h = Object.keys(u);
    } catch {
      h = [];
    }
    for (const f of h) {
      let p;
      try {
        p = u[f];
      } catch {
        p = To;
      }
      Object.defineProperty(c, f, { value: p, enumerable: !0, writable: !0, configurable: !0 });
    }
  }
  const d = { timeUnixNano: a, observedTimeUnixNano: a, severityNumber: o, severityText: s, body: { stringValue: uI(t.body) }, attributes: sl(c, n) };
  return t.trace_id && (d.traceId = t.trace_id), t.span_id && (d.spanId = t.span_id), G(t.trace_flags) || (d.flags = t.trace_flags), d;
}
function W_(t, e, n) {
  return B_(t, e, n);
}
function q_(t, e, n, i) {
  return { resourceLogs: [{ resource: { attributes: H_(e) }, scopeLogs: [{ scope: { name: n, version: i }, logRecords: t }] }] };
}
var G_ = class {
  constructor(t) {
    this.ls = t, this.us = 0;
  }
  get pending() {
    return !!this.hs;
  }
  arm(t) {
    this.clear(), this.us = Date.now() + t, this.hs = O_(() => {
      this.hs = void 0, this.ls();
    }, t);
  }
  armNoEarlierThan(t) {
    this.hs && Date.now() + t <= this.us || this.arm(t);
  }
  clear() {
    this.hs && (clearTimeout(this.hs), this.hs = void 0);
  }
};
function K_() {
  return 0.75 + 0.5 * Math.random();
}
function Y_(t, e, n, i) {
  const r = Math.min(Math.max(0, e - 1), 6), s = t * Math.pow(2, r);
  return Math.round(Math.min(s, Math.max(i, t)) * n);
}
var hI = class {
  constructor(t, e, n, i, r, s = () => Promise.resolve(), o) {
    var a;
    this._instance = t, this.Rr = e, this.$ = n, this.cs = i, this.ds = r, this.vs = s, this.fs = o, this.ps = new G_(() => this.gs()), this.ys = null, this.bs = 0, this._s = 0, this.ws = new R_(), this.ks = 0, this.Ss = 1, this.xs = 0, this.Cs = 0, this.$s = !1, this.Ts = e.maxBufferSize, this.Is = Math.max((a = e.maxQueueSize) !== null && a !== void 0 ? a : e.maxBufferSize, e.maxBufferSize), this.Ms = e.flushIntervalMs, this.Es = e.maxBatchRecordsPerPost, this.Ps = e.rateCapWindowMs, this.Rs = e.maxLogsPerInterval;
  }
  clearQueue() {
    this._s++, this._instance.setPersistedProperty(hi.LogsQueue, []);
  }
  reset() {
    this.ps.clear(), this.xs = 0, this.Cs = 0, this.$s = !1, this.ks = 0, this.Ss = 1, this.ws.reset(), this.Es = this.Rr.maxBatchRecordsPerPost;
  }
  onReconnect() {
    this.ks = 0, this.Ss = 1, this.ws.isOpen() ? this.As() && this.Fs() : this.gs();
  }
  captureLog(t, e) {
    var n;
    if (this._instance.isDisabled || this._instance.optedOut || !t?.body) return;
    const i = this.Os(t);
    if (i === null) return;
    if (!i.body) return void this.$.info("Log was rejected in beforeSend function");
    if (!this.Ds()) return;
    const r = { record: dI(i, (n = e?.context) !== null && n !== void 0 ? n : this.cs(), this.$, e?.occurredAtMs) };
    this.ds(() => this.Ls(r));
  }
  Os(t) {
    const e = this.Rr.beforeSend;
    if (!e) return t;
    const n = de(e) ? e : [e];
    let i = t;
    for (const r of n) try {
      const s = r(i);
      if (!s) return this.$.info("Log was rejected in beforeSend function"), null;
      i = s;
    } catch (s) {
      return this.$.error("Error in beforeSend function for log:", s), null;
    }
    return i;
  }
  Ds() {
    if (this.Rs === void 0) return !0;
    const t = Date.now(), e = t - this.xs;
    return this.Ps > e && e >= 0 || (this.xs = t, this.Cs = 0, this.$s = !1), this.Rs > this.Cs ? (this.Cs++, !0) : (this.$s || (this.$.warn(`captureLog dropping logs: exceeded ${this.Rs} logs per ${this.Ps}ms`), this.$s = !0), !1);
  }
  flush() {
    var t = this;
    return He(function* () {
      if (!t._instance.isDisabled) return t.ys || (t.ys = t.Ns().finally(() => {
        t.ys = null;
      })), t.ys;
    })();
  }
  Ns() {
    var t = this;
    return He(function* () {
      var e;
      t.ps.clear();
      let n = (e = t._instance.getPersistedProperty(hi.LogsQueue)) !== null && e !== void 0 ? e : [];
      if (n.length === 0) return;
      const i = n.length;
      let r = 0;
      for (; n.length > 0 && i > r; ) {
        var s, o;
        const a = t._s;
        t.bs = 0;
        const l = Math.min(n.length, t.Es), c = n.slice(0, l), u = q_(c.map((h) => h.record), t.qs(), (s = t.fs) !== null && s !== void 0 ? s : t._instance.getLibraryId(), t._instance.getLibraryVersion()), d = yield t._instance.js(u);
        if (t._s !== a) return;
        if (d.kind === "too-large" && c.length > 1) t.Es = Math.max(1, Math.floor(c.length / 2)), t.$.warn(`Logs batch of size ${c.length} was too large for the ingestion endpoint, reducing batch size to ${t.Es}`);
        else if (t.ws.record(d), t.ps.pending && t.ps.arm(Math.max(t.Ms, t.ws.remainingMs())), d.kind === "retry-later" || (d.kind === "too-large" ? t.$.warn("Dropping a single log record with batch size 1 — the record is larger than the server cap and cannot be split further.") : d.kind === "ok" && t.Rr.maxBatchRecordsPerPost > t.Es && (t.Es = Math.min(t.Rr.maxBatchRecordsPerPost, t.Es + 1)), yield t.Bs(c.length), n = (o = t._instance.getPersistedProperty(hi.LogsQueue)) !== null && o !== void 0 ? o : [], r += c.length, d.kind === "fatal")) throw d.error;
      }
    })();
  }
  Bs(t) {
    var e = this;
    return He(function* () {
      var n;
      const i = Math.max(0, t - e.bs), r = (n = e._instance.getPersistedProperty(hi.LogsQueue)) !== null && n !== void 0 ? n : [];
      e._instance.setPersistedProperty(hi.LogsQueue, r.slice(i)), yield e.vs();
    })();
  }
  qs() {
    return W_(this.Rr, this._instance.getLibraryId(), this._instance.getLibraryVersion());
  }
  Ls(t) {
    var e;
    if (this._instance.optedOut) return;
    const n = (e = this._instance.getPersistedProperty(hi.LogsQueue)) !== null && e !== void 0 ? e : [];
    this.Is > n.length || (n.shift(), this.bs++, this.$.info("Logs queue is full, dropping oldest record.")), n.push(t), this._instance.setPersistedProperty(hi.LogsQueue, n), this.Ts > n.length || this.ws.isOpen() ? this.Fs() : this.gs();
  }
  Fs() {
    this.ps.pending || this.ps.arm(Math.max(this.Ms, this.ws.remainingMs()));
  }
  Hs() {
    return Math.max(Y_(this.Ms, this.ks, this.Ss, 3e4), this.ws.remainingMs());
  }
  As() {
    const t = this._instance.getPersistedProperty(hi.LogsQueue);
    return !!t && t.length > 0;
  }
  shutdown(t) {
    var e = this;
    return He(function* () {
      e.ps.clear();
      const n = e.flush().catch(() => {
      });
      t !== void 0 ? yield Nm(n, t) : yield n;
    })();
  }
  flushWithTimeout(t) {
    var e = this;
    return He(function* () {
      const n = e.flush();
      yield Nm(n, t, () => {
        n.catch(() => {
        });
      });
    })();
  }
  gs() {
    this.flush().then(() => {
      this.ks = 0, this.Ss = 1;
    }, (t) => {
      this.ks++, this.Ss = K_(), this.$.error("PostHog logs flush failed:", t);
    }).finally(() => {
      !this._instance.isDisabled && this.As() && this.ps.armNoEarlierThan(this.Hs());
    });
  }
};
const Mc = [0, 5, 10, 25, 50, 75, 100, 250, 500, 750, 1e3, 2500, 5e3, 7500, 1e4];
function Ym(t) {
  return String(t) + "000000";
}
function Xm(t, e, n, i) {
  let r = "";
  return i && (r = Object.keys(i).sort().map((s) => `${JSON.stringify(s)}:${JSON.stringify(i[s])}`).join(",")), `${t}\0${e}\0${n ?? ""}\0${r}`;
}
var fI = class {
  constructor(t, e, n) {
    this._instance = t, this.Rr = e, this.$ = n, this.zs = /* @__PURE__ */ new Map(), this.ps = new G_(() => this.flush().catch((i) => {
      this.$.error("Metrics flush failed:", i);
    })), this.ys = null, this.Us = !1, this.Ws = /* @__PURE__ */ new Map(), this.Vs = /* @__PURE__ */ new Set(), this.ws = new R_(), this.ks = 0, this.Ss = 1, this.Gs = 0;
  }
  count(t, e = 1, n) {
    this.Zs({ name: t, type: "count", value: e, unit: n?.unit, attributes: n?.attributes });
  }
  gauge(t, e, n) {
    this.Zs({ name: t, type: "gauge", value: e, unit: n?.unit, attributes: n?.attributes });
  }
  histogram(t, e, n) {
    this.Zs({ name: t, type: "histogram", value: e, unit: n?.unit, attributes: n?.attributes });
  }
  flush() {
    var t = this;
    const e = this.ys, n = (function() {
      var i = He(function* () {
        e && (yield e.catch(() => {
        })), yield t.Qs();
      });
      return function() {
        return i.apply(this, arguments);
      };
    })()().finally(() => {
      this.ys === n && (this.ys = null);
    });
    return this.ys = n, n;
  }
  drainWindow() {
    if (this.zs.size === 0) return null;
    const t = this.zs;
    return this.zs = /* @__PURE__ */ new Map(), this.Us = !1, this.Ws = /* @__PURE__ */ new Map(), this.Vs = /* @__PURE__ */ new Set(), this.Js(t);
  }
  reset() {
    this.Gs++, this.ws.reset(), this.ks = 0, this.Ss = 1, this.ps.clear(), this.zs = /* @__PURE__ */ new Map(), this.ys = null, this.Us = !1, this.Ws = /* @__PURE__ */ new Map(), this.Vs = /* @__PURE__ */ new Set();
  }
  Zs(t) {
    if (this._instance.isDisabled || this._instance.optedOut) return;
    const e = this.Os(t);
    if (e === null) return;
    if (!e.name || typeof e.name != "string") return void this.$.warn("Dropping metric with empty name");
    if (typeof e.value != "number" || !Number.isFinite(e.value)) return void this.$.warn(`Dropping metric '${e.name}': value must be a finite number`);
    if (e.type === "count" && 0 > e.value) return void this.$.warn(`Dropping count '${e.name}': counters are monotonic, value must be >= 0`);
    let n, i;
    try {
      n = e.attributes ? R({}, e.attributes) : void 0, i = Xm(e.type, e.name, e.unit, n);
    } catch (o) {
      return void this.$.warn(`Dropping metric '${e.name}': attributes could not be serialized`, o);
    }
    let r = this.zs.get(i);
    if (!r) {
      if (!this.Ks()) return;
      r = { name: e.name, type: e.type, unit: e.unit, attributes: n, windowStartMs: Date.now() }, this.zs.set(i, r);
    }
    const s = this.Ws.get(e.name);
    s === void 0 ? this.Ws.set(e.name, e.type) : s === e.type || this.Vs.has(e.name) || (this.Vs.add(e.name), this.$.warn(`Metric name '${e.name}' is already used as a ${s}; recording it as a ${e.type} too will blend both series in charts. Use a distinct name.`)), this.Xs(r, e.value), this.Fs();
  }
  Ks() {
    return this.Rr.maxSeriesPerFlush > this.zs.size || (this.Us || (this.Us = !0, this.$.warn(`Metric series cap reached (${this.Rr.maxSeriesPerFlush} per flush window); dropping new series until the next flush. Reduce attribute cardinality.`)), !1);
  }
  Xs(t, e) {
    switch (t.type) {
      case "count":
        var n;
        t.total = ((n = t.total) !== null && n !== void 0 ? n : 0) + e;
        break;
      case "gauge":
        t.last = e;
        break;
      case "histogram": {
        t.hist || (t.hist = { count: 0, sum: 0, min: e, max: e, bucketCounts: new Array(Mc.length + 1).fill(0) });
        const i = t.hist;
        i.count += 1, i.sum += e, i.min = Math.min(i.min, e), i.max = Math.max(i.max, e), i.bucketCounts[(function(r, s) {
          for (let o = 0; s.length > o; o++) if (s[o] >= r) return o;
          return s.length;
        })(e, Mc)] += 1;
        break;
      }
    }
  }
  Os(t) {
    const e = this.Rr.beforeSend;
    if (!e) return t;
    const n = de(e) ? e : [e];
    let i = t;
    for (const r of n) try {
      const s = r(i);
      if (!s) return this.$.info("Metric was rejected in beforeSend function"), null;
      i = s;
    } catch (s) {
      return this.$.error("Error in beforeSend function for metric:", s), null;
    }
    return i;
  }
  Fs() {
    this.ps.pending || this.ps.arm(this.Hs());
  }
  Hs() {
    return Math.max(Y_(this.Rr.flushIntervalMs, this.ks, this.Ss, 3e4), this.ws.remainingMs());
  }
  Qs() {
    var t = this;
    return He(function* () {
      if (t.ps.clear(), t.zs.size === 0) return;
      const e = t.zs;
      t.zs = /* @__PURE__ */ new Map(), t.Us = !1, t.Ws = /* @__PURE__ */ new Map(), t.Vs = /* @__PURE__ */ new Set();
      const n = t.Gs, i = yield t._instance.Ys(t.Js(e));
      if (n === t.Gs) switch (t.ws.record(i), i.kind === "retry-later" ? (t.ks++, t.Ss = K_()) : (t.ks = 0, t.Ss = 1), t.ps.pending && t.ps.arm(t.Hs()), i.kind) {
        case "ok":
          return;
        case "retry-later":
          return t.ho(e), void t.ps.armNoEarlierThan(t.Hs());
        case "too-large":
          return void t.$.warn("Metrics batch exceeded the server size limit and was dropped");
        case "fatal":
          return void t.$.error("Failed to send metrics batch:", i.error);
      }
    })();
  }
  Js(t) {
    return e = this.vo(t), n = (function(s, o, a) {
      return B_(s, o, a);
    })(this.Rr, this._instance.getLibraryId(), this._instance.getLibraryVersion()), i = this._instance.getLibraryId(), r = this._instance.getLibraryVersion(), { resourceMetrics: [{ resource: { attributes: H_(n) }, scopeMetrics: [{ scope: { name: i, version: r }, metrics: e }] }] };
    var e, n, i, r;
  }
  vo(t) {
    const e = Ym(Date.now()), n = /* @__PURE__ */ new Map();
    for (const o of t.values()) {
      var i;
      const a = Xm(o.type, o.name, o.unit, void 0);
      let l = n.get(a);
      l || (l = R({ name: o.name }, o.unit && { unit: o.unit }), o.type === "count" ? l.sum = { aggregationTemporality: 1, isMonotonic: !0, dataPoints: [] } : o.type === "gauge" ? l.gauge = { dataPoints: [] } : l.histogram = { aggregationTemporality: 1, dataPoints: [] }, n.set(a, l));
      const c = sl((i = o.attributes) !== null && i !== void 0 ? i : {}, this.$), u = Ym(o.windowStartMs);
      if (o.type === "count") {
        var r;
        const d = { attributes: c, startTimeUnixNano: u, timeUnixNano: e, asDouble: (r = o.total) !== null && r !== void 0 ? r : 0 };
        l.sum.dataPoints.push(d);
      } else if (o.type === "gauge") {
        var s;
        const d = { attributes: c, timeUnixNano: e, asDouble: (s = o.last) !== null && s !== void 0 ? s : 0 };
        l.gauge.dataPoints.push(d);
      } else o.hist && l.histogram.dataPoints.push({ attributes: c, startTimeUnixNano: u, timeUnixNano: e, count: o.hist.count, sum: o.hist.sum, min: o.hist.min, max: o.hist.max, bucketCounts: o.hist.bucketCounts, explicitBounds: Mc });
    }
    return Array.from(n.values());
  }
  ho(t) {
    for (const [i, r] of t) {
      const s = this.zs.get(i);
      if (s) switch (s.windowStartMs = Math.min(s.windowStartMs, r.windowStartMs), s.type) {
        case "count":
          var e, n;
          s.total = ((e = s.total) !== null && e !== void 0 ? e : 0) + ((n = r.total) !== null && n !== void 0 ? n : 0);
          break;
        case "gauge":
          break;
        case "histogram":
          if (r.hist) if (s.hist) {
            s.hist.count += r.hist.count, s.hist.sum += r.hist.sum, s.hist.min = Math.min(s.hist.min, r.hist.min), s.hist.max = Math.max(s.hist.max, r.hist.max);
            for (let o = 0; s.hist.bucketCounts.length > o; o++) s.hist.bucketCounts[o] += r.hist.bucketCounts[o];
          } else s.hist = r.hist;
      }
      else this.Ks() && this.zs.set(i, r);
    }
  }
};
const X_ = (t, { debugEnabled: e } = {}) => {
  const n = { N(i, ...r) {
    L && (ji.DEBUG || L.POSTHOG_DEBUG || e) && !G(L.console) && L.console && ("__rrweb_original__" in L.console[i] ? L.console[i].__rrweb_original__ : L.console[i])(t, ...r);
  }, debug(...i) {
    n.N("debug", ...i);
  }, info(...i) {
    n.N("log", ...i);
  }, warn(...i) {
    n.N("warn", ...i);
  }, error(...i) {
    n.N("error", ...i);
  }, critical(...i) {
    console.error(t, ...i);
  }, uninitializedWarning(i) {
    n.error(`You must initialize PostHog before calling ${i}`);
  }, createLogger: (i, r) => X_(`${t} ${i}`, r) };
  return n;
}, ee = X_("[PostHog.js]"), Ze = ee.createLogger, pI = Ze("[ExternalScriptsLoader]"), ol = (t) => {
  const e = Y?.querySelectorAll("script");
  if (e) {
    for (let n = 0; e.length > n; n++) if (e[n].src === t || e[n].getAttribute("src") === t) return e[n];
  }
}, Dn = (t, e, n) => {
  if (t.config.disable_external_dependency_loading) return pI.warn(`${e} was requested but loading of external scripts is disabled.`), n("Loading of external scripts is disabled");
  const i = ol(e);
  if (i) {
    if (i.__posthog_loading_callback_fired) return n();
    const s = i.__posthog_loading_error;
    return s ? n(s) : (i.addEventListener("load", (o) => {
      i.__posthog_loading_callback_fired = !0, n(void 0, o);
    }), void i.addEventListener("error", (o) => {
      i.__posthog_loading_error = o, n(o);
    }));
  }
  const r = () => {
    if (!Y) return n("document not found");
    if (ol(e)) return Dn(t, e, n);
    let s = Y.createElement("script");
    if (s.type = "text/javascript", s.crossOrigin = "anonymous", s.src = e, s.onload = (a) => {
      s.__posthog_loading_callback_fired = !0, n(void 0, a);
    }, s.onerror = (a) => {
      s.__posthog_loading_error = a, n(a);
    }, t.config.prepare_external_dependency_script && (s = t.config.prepare_external_dependency_script(s)), !s) return n("prepare_external_dependency_script returned null");
    if (t.config.external_scripts_inject_target === "head") Y.head.appendChild(s);
    else {
      const a = Y.querySelectorAll("body > script");
      var o;
      a.length > 0 ? (o = a[0].parentNode) === null || o === void 0 || o.insertBefore(s, a[0]) : Y.body.appendChild(s);
    }
  };
  Y?.body ? r() : Y?.addEventListener("DOMContentLoaded", r);
}, Oc = {}, Jm = (t, e) => {
  let n = `/static/${e}.js?v=${t.version}`;
  return e === "toolbar" && (n = `${n}&t=${Math.floor(Date.now() / 3e5) * 3e5}`), t.requestRouter.endpointFor("assets", n);
};
le.__PosthogExtensions__ = le.__PosthogExtensions__ || {}, le.__PosthogExtensions__.loadExternalDependency = (t, e, n) => {
  if (e === "remote-config") {
    const r = t.requestRouter.endpointFor("assets", `/array/${t.config.token}/config.js`);
    return void Dn(t, r, n);
  }
  const i = t.config.strict_script_versioning;
  if (i) {
    const r = t.requestRouter.endpointFor("assets", `/static/${t.version}/${e}.js`), s = Oc[r];
    if (i === "fallback" && s) {
      if (ol(s)) return void Dn(t, s, n);
      delete Oc[r];
    }
    return void Dn(t, r, i === "fallback" ? (o, a) => {
      if (o) if (typeof o == "string") n(o);
      else {
        var l;
        const c = Jm(t, e);
        Oc[r] = c;
        const u = ol(r);
        u == null || (l = u.parentNode) === null || l === void 0 || l.removeChild(u), Dn(t, c, n);
      }
      else n(void 0, a);
    } : n);
  }
  Dn(t, Jm(t, e), n);
}, le.__PosthogExtensions__.loadSiteApp = (t, e, n) => {
  const i = t.requestRouter.endpointFor("api", e);
  Dn(t, i, n);
}, ji.DEBUG = !1, ji.LIB_VERSION = "1.434.15", ji.LIB_NAME = "web";
var ot = ji;
const mI = "$people_distinct_id", ti = "distinct_id", rf = "$device_id", Ic = "$device_model", al = "__alias", gI = "__cmpns", Zm = "$fbc", Vr = "$fbc_persistence", Qm = "$fbp", Ds = "$fbp_persistence", fd = "__timers", J_ = "$autocapture_disabled_server_side", pd = "$heatmaps_enabled_server_side", md = "$exception_capture_enabled_server_side", Z_ = "$error_tracking_suppression_rules", gd = "$error_tracking_capture_extension_exceptions", vd = "$web_vitals_enabled_server_side", sf = "$dead_clicks_enabled_server_side", of = "$product_tours_enabled_server_side", Q_ = "$logs_capture_enabled_server_side", ew = "$web_vitals_allowed_metrics", Fs = "$session_recording_remote_config", vI = "$session_recording_enabled_server_side", yI = "$replay_sample_rate", bI = "$replay_override_sampling", _I = "$replay_override_linked_flag", wI = "$replay_override_url_trigger", kI = "$replay_override_event_trigger", Pr = "$sesid", tw = "$session_is_sampled", xI = "$session_past_minimum_duration", SI = "$session_recording_url_trigger_activated_session", PI = "$session_recording_event_trigger_activated_session", EI = "$debug_first_full_snapshot_timestamp", TI = "$sess_rec_flush_size", ni = "$enabled_feature_flags", Li = "$active_feature_flags", yd = "$early_access_features", Kn = "$feature_flag_details", rn = "$feature_flag_payloads", Yn = "$feature_flag_request_id", Ls = "$minimal_flag_called_events", di = "$override_feature_flags", Fn = "$override_feature_flag_payloads", sn = "$stored_person_properties", on = "$stored_group_properties", iw = "$groups", bd = "$surveys", ll = "$surveys_loaded_at", nw = "$surveys_activated", rw = "$surveys_activated_session", sw = "$surveys_activated_timestamps", _d = "ph_product_tours", CI = "$product_tours_activated", AI = "$product_tours_activated_session", $I = "$conversations_widget_session_id", RI = "$conversations_ticket_id", MI = "$conversations_widget_state", OI = "$conversations_user_traits", an = "$flag_call_reported", Cs = "$flag_call_reported_session_id", to = "$feature_flag_errors", hn = "$feature_flag_evaluated_at", Et = "$user_state", wd = "$client_session_props", II = "$capture_rate_limit", ow = "$initial_campaign_params", aw = "$initial_referrer_info", Er = "$initial_person_info", af = "$epp", Dc = "$posthog_cookieless", lw = "$cookieless_mode", cw = "$sdk_debug_extensions_init_method", uw = "$sdk_debug_extensions_init_time_ms", dw = "$sdk_debug_recording_script_not_loaded", hw = "$sdk_debug_replay_stale_config", DI = "$sdk_debug_replay_event_trigger_status", FI = "$sdk_debug_replay_linked_flag_trigger_status", LI = "$sdk_debug_replay_matched_recording_trigger_groups", NI = "$sdk_debug_replay_pending_trigger_conditions", VI = "$sdk_debug_replay_remote_trigger_matching_config", jI = "$sdk_debug_replay_trigger_groups_count", zI = "$sdk_debug_replay_url_trigger_status", BI = "$session_recording_start_reason", lf = "PostHog loadExternalDependency extension not found.", Ni = "anonymous", Ca = "identified", fw = "identified_only", io = "visibilitychange", cl = "beforeunload", cf = "$pageview", eg = "$pageleave", pw = "$identify", tg = "$groupidentify";
function Tr(t, e) {
  de(t) && t.forEach(e);
}
function Fe(t, e) {
  if (!ve(t)) if (de(t)) t.forEach(e);
  else if (((n) => n instanceof FormData)(t)) t.forEach((n, i) => e(n, i));
  else for (const n in t) Zh.call(t, n) && e(t[n], n);
}
const ze = function(t, ...e) {
  for (const n of e) for (const i in n) n[i] !== void 0 && (t[i] = n[i]);
  return t;
};
function Aa(t) {
  const e = Object.keys(t);
  let n = e.length;
  const i = new Array(n);
  for (; n--; ) i[n] = [e[n], t[e[n]]];
  return i;
}
const HI = function(t) {
  return function(...e) {
    try {
      return t.apply(this, e);
    } catch (n) {
      ee.critical("Implementation error. Please turn on debug mode and open a ticket on https://app.posthog.com/home#panel=support%3Asupport%3A."), ee.critical(n);
    }
  };
}, uf = function(t) {
  const e = {};
  return Fe(t, function(n, i) {
    (Pe(n) && n.length > 0 || Qe(n)) && (e[i] = n);
  }), e;
};
function mw(t) {
  const e = R({}, t);
  for (const n of ["name", "message", "stack", "cause", "errors"]) try {
    n in t && (e[n] = t[n]);
  } catch {
  }
  return e;
}
const UI = ["herokuapp.com", "vercel.app", "netlify.app"];
function WI(t) {
  const e = t?.hostname;
  if (!Pe(e)) return !1;
  const n = e.split(".").slice(-2).join(".");
  for (const i of UI) if (n === i) return !1;
  return !0;
}
function Ie(t, e, n, i) {
  const { capture: r = !1, passive: s = !0 } = i ?? {};
  t?.addEventListener(e, n, { capture: r, passive: s });
}
function kd(t) {
  return t.name === "ph_toolbar_internal";
}
const Ns = (t) => {
  if (Y) {
    try {
      const e = t + "=", n = Y.cookie.split(";").filter((i) => i.length);
      for (let i = 0; n.length > i; i++) {
        let r = n[i];
        for (; r.charAt(0) == " "; ) r = r.substring(1, r.length);
        if (r.indexOf(e) === 0) return decodeURIComponent(r.substring(e.length, r.length));
      }
    } catch {
    }
    return null;
  }
};
Math.trunc || (Math.trunc = function(t) {
  return 0 > t ? Math.ceil(t) : Math.floor(t);
}), Number.isInteger || (Number.isInteger = function(t) {
  return Qe(t) && isFinite(t) && Math.floor(t) === t;
});
var qI = class xd {
  constructor(e) {
    if (this.bytes = e, e.length !== 16) throw new TypeError("not 128-bit length");
  }
  static fromFieldsV7(e, n, i, r) {
    if (!Number.isInteger(e) || !Number.isInteger(n) || !Number.isInteger(i) || !Number.isInteger(r) || 0 > e || 0 > n || 0 > i || 0 > r || e > 281474976710655 || n > 4095 || i > 1073741823 || r > 4294967295) throw new RangeError("invalid field value");
    const s = new Uint8Array(16);
    return s[0] = e / Math.pow(2, 40), s[1] = e / Math.pow(2, 32), s[2] = e / Math.pow(2, 24), s[3] = e / Math.pow(2, 16), s[4] = e / 256, s[5] = e, s[6] = 112 | n >>> 8, s[7] = n, s[8] = 128 | i >>> 24, s[9] = i >>> 16, s[10] = i >>> 8, s[11] = i, s[12] = r >>> 24, s[13] = r >>> 16, s[14] = r >>> 8, s[15] = r, new xd(s);
  }
  toString() {
    let e = "";
    for (let n = 0; this.bytes.length > n; n++) e = e + (this.bytes[n] >>> 4).toString(16) + (15 & this.bytes[n]).toString(16), n !== 3 && n !== 5 && n !== 7 && n !== 9 || (e += "-");
    if (e.length !== 36) throw new Error("Invalid UUIDv7 was generated");
    return e;
  }
  clone() {
    return new xd(this.bytes.slice(0));
  }
  equals(e) {
    return this.compareTo(e) === 0;
  }
  compareTo(e) {
    for (let n = 0; 16 > n; n++) {
      const i = this.bytes[n] - e.bytes[n];
      if (i !== 0) return Math.sign(i);
    }
    return 0;
  }
}, GI = class {
  generate() {
    const t = this.generateOrAbort();
    if (!G(t)) return t;
    {
      this.Ct = 0;
      const e = this.generateOrAbort();
      if (G(e)) throw new Error("Could not generate UUID after timestamp reset");
      return e;
    }
  }
  generateOrAbort() {
    const t = (() => {
      const e = Date.now();
      return Qe(e) && isFinite(e) ? Math.min(Math.max(Math.floor(e), 0), 281474976710655) : 0;
    })();
    if (t > this.Ct) this.Ct = t, this.Mt();
    else {
      if (this.Ct >= t + 1e4) return;
      this.It++, this.It > 4398046511103 && (this.Ct++, this.Mt());
    }
    return qI.fromFieldsV7(this.Ct, Math.trunc(this.It / Math.pow(2, 30)), this.It & Math.pow(2, 30) - 1, this.Tt.nextUint32());
  }
  Mt() {
    this.It = 1024 * this.Tt.nextUint32() + (1023 & this.Tt.nextUint32());
  }
  constructor() {
    this.Ct = 0, this.It = 0, this.Tt = new KI();
  }
};
let gw = (t) => {
  if ("u" > typeof UUIDV7_DENY_WEAK_RNG && UUIDV7_DENY_WEAK_RNG) throw new Error("no cryptographically strong RNG available");
  for (let e = 0; t.length > e; e++) t[e] = 65536 * Math.trunc(65536 * Math.random()) + Math.trunc(65536 * Math.random());
  return t;
};
L && !G(L.crypto) && crypto.getRandomValues && (gw = (t) => crypto.getRandomValues(t));
var KI = class {
  nextUint32() {
    return this.Rt.length > this.$t || (gw(this.Rt), this.$t = 0), this.Rt[this.$t++];
  }
  constructor() {
    this.Rt = new Uint32Array(8), this.$t = 1 / 0;
  }
};
let ig;
const ri = () => YI().toString(), YI = () => (ig || (ig = new GI())).generate();
let vs = "";
const XI = /[a-z0-9][a-z0-9-]+\.[a-z]{2,}$/i;
let lr = null;
const Ge = { Et() {
  if (!Ye(lr)) return lr;
  if (lr = !1, Y) try {
    const t = `__ph_cookie_support_${ri()}`;
    Ge.At(t, "xyz"), lr = Ns(t) === '"xyz"', Ge.Lt(t);
  } catch {
    lr = !1;
  }
  return lr;
}, Pt(t) {
  ee.error("cookieStore error: " + t);
}, Ot: Ns, Dt(t) {
  let e;
  try {
    e = JSON.parse(Ge.Ot(t)) || {};
  } catch {
  }
  return e;
}, At(t, e, n, i, r) {
  if (!Y) return !1;
  try {
    let s = "", o = "";
    const a = (function(c, u) {
      if (u) {
        let d = (function(h, f = Y) {
          if (vs) return vs;
          if (!f || ["localhost", "127.0.0.1"].includes(h)) return "";
          const p = h.split(".");
          let v = Math.min(p.length, 8);
          const g = "dmn_chk_" + ri();
          for (; !vs && v--; ) {
            const m = p.slice(v).join("."), y = g + "=1;domain=." + m + ";path=/";
            f.cookie = y + ";max-age=3", f.cookie.includes(g) && (f.cookie = y + ";max-age=0", vs = m);
          }
          return vs;
        })(c);
        if (!d) {
          const h = ((f) => {
            const p = f.match(XI);
            return p ? p[0] : "";
          })(c);
          h !== d && ee.info("Warning: cookie subdomain discovery mismatch", h, d), d = h;
        }
        return d ? "; domain=." + d : "";
      }
      return "";
    })(Y.location.hostname, i);
    if (n) {
      const c = /* @__PURE__ */ new Date();
      c.setTime(c.getTime() + 864e5 * n), s = "; expires=" + c.toUTCString();
    }
    r && (o = "; secure");
    const l = t + "=" + encodeURIComponent(JSON.stringify(e)) + s + "; SameSite=Lax; path=/" + a + o;
    return l.length > 3686.4 && ee.warn("cookieStore warning: large cookie, len=" + l.length), Y.cookie = l, !0;
  } catch {
    return !1;
  }
}, Lt(t, e) {
  if (Y?.cookie && (!e || !Ye(Ns(t)))) try {
    Ge.At(t, "", -1, e);
  } catch {
    return;
  }
} };
let Fc = null;
const Re = { Et() {
  if (!Ye(Fc)) return Fc;
  let t = !0;
  if (G(L)) t = !1;
  else try {
    const e = "__mplssupport__";
    Re.At(e, "xyz"), Re.Ot(e) !== '"xyz"' && (t = !1), Re.Lt(e);
  } catch {
    t = !1;
  }
  return t || ee.error("localStorage unsupported; falling back to cookie store"), Fc = t, t;
}, Pt(t) {
  ee.error("localStorage error: " + t);
}, Ot(t) {
  try {
    return L?.localStorage.getItem(t);
  } catch (e) {
    Re.Pt(e);
  }
  return null;
}, Dt(t) {
  try {
    return JSON.parse(Re.Ot(t)) || {};
  } catch {
  }
  return null;
}, At(t, e) {
  try {
    return L?.localStorage.setItem(t, JSON.stringify(e)), !0;
  } catch (n) {
    Re.Pt(n);
  }
  return !1;
}, Lt(t) {
  try {
    L?.localStorage.removeItem(t);
  } catch (e) {
    Re.Pt(e);
  }
} }, Lc = [sn, Li, ni, Kn, rn, Yn, hn, to, an], Ln = [rf, ti, Pr, tw, af, Er, Vr, Et], ul = (t) => t + "_cpm", JI = ["__proto__", "constructor", "prototype"], Nc = (t) => {
  if (!Ee(t)) return {};
  const e = {};
  return Object.keys(t).forEach((n) => {
    JI.indexOf(n) === -1 && (e[n] = t[n]);
  }), e;
}, Vc = (t, e = []) => {
  const n = {};
  return [...Ln, ...e].forEach((i) => {
    const r = t[i];
    G(r) || Ye(r) || r === "" || (n[i] = r);
  }), n;
}, vw = (t) => {
  let e = 5381, n = 2166136261;
  for (let i = 0; t.length > i; i++) {
    const r = t.charCodeAt(i);
    e = 33 * e ^ r, n = Math.imul(n ^ r, 16777619);
  }
  return t.length.toString(36) + "." + (e >>> 0).toString(36) + "." + (n >>> 0).toString(36);
}, ng = (t, e) => ({ p: e, f: vw(JSON.stringify(t)) }), rg = (t, e) => {
  if (!e) return { properties: [], isValid: !1 };
  try {
    const n = Ge.Dt(ul(t)), i = n?.f === vw(e) && de(n.p);
    return { properties: i ? n.p : [], isValid: i };
  } catch {
    return { properties: [], isValid: !1 };
  }
}, jc = (t, e) => e + "|" + (Ge.Ot(ul(t)) || ""), cr = {}, Sd = { Et: () => !0, Pt(t) {
  ee.error("memoryStorage error: " + t);
}, Ot: (t) => t in cr ? cr[t] : null, Dt: (t) => t in cr ? cr[t] : null, At: (t, e) => (cr[t] = e, !0), Lt(t) {
  delete cr[t];
} };
let $n = null;
const je = { Et() {
  if (!Ye($n)) return $n;
  if ($n = !0, G(L)) $n = !1;
  else try {
    const t = "__support__";
    je.At(t, "xyz"), je.Ot(t) !== '"xyz"' && ($n = !1), je.Lt(t);
  } catch {
    $n = !1;
  }
  return $n;
}, Pt(t) {
  ee.error("sessionStorage error: ", t);
}, Ot(t) {
  try {
    return L?.sessionStorage.getItem(t);
  } catch (e) {
    je.Pt(e);
  }
  return null;
}, Dt(t) {
  try {
    return JSON.parse(je.Ot(t)) || null;
  } catch {
  }
  return null;
}, At(t, e) {
  try {
    return L?.sessionStorage.setItem(t, JSON.stringify(e)), !0;
  } catch (n) {
    je.Pt(n);
  }
  return !1;
}, Lt(t) {
  try {
    L?.sessionStorage.removeItem(t);
  } catch (e) {
    je.Pt(e);
  }
} };
var ZI = class {
  constructor(t) {
    this._instance = t;
  }
  get Rr() {
    return this._instance.config;
  }
  get consent() {
    return this.Lo() ? 0 : this.No;
  }
  isOptedOut() {
    return this.Rr.cookieless_mode === "always" || this.isRejected() || this.consent === -1 && this.Rr.cookieless_mode === "on_reject";
  }
  isOptedIn() {
    return !this.isOptedOut();
  }
  isExplicitlyOptedOut() {
    return this.consent === 0;
  }
  isRejected() {
    return this.consent === 0 || this.consent === -1 && this.Rr.opt_out_capturing_by_default;
  }
  optInOut(t) {
    this.qo.At(this.jo, t ? 1 : 0, this.Rr.cookie_expiration, this.Rr.cross_subdomain_cookie, this.Rr.secure_cookie);
  }
  reset() {
    this.qo.Lt(this.jo, this.Rr.cross_subdomain_cookie);
  }
  get jo() {
    const { token: t, opt_out_capturing_cookie_prefix: e, consent_persistence_name: n } = this._instance.config;
    return n || (e ? e + t : "__ph_opt_in_out_" + t);
  }
  get No() {
    const t = this.qo.Ot(this.jo);
    return Pc(t) ? 1 : pe(g3, t) ? 0 : -1;
  }
  get qo() {
    const t = this.Rr.opt_out_capturing_persistence_type, e = t === "localStorage" ? Re : Ge, n = e.Et() ? e : Sd;
    if (!this.Bo || this.Bo !== n) {
      this.Bo = n;
      const i = t === "localStorage" ? Ge : Re;
      i.Ot(this.jo) && (this.Bo.Ot(this.jo) || this.optInOut(Pc(i.Ot(this.jo))), i.Lt(this.jo, this.Rr.cross_subdomain_cookie));
    }
    return this.Bo;
  }
  Lo() {
    return !!this.Rr.respect_dnt && [dt?.doNotTrack, dt?.msDoNotTrack, le.doNotTrack, dt?.globalPrivacyControl].some((t) => Pc(t));
  }
};
function yw(t, e) {
  var n;
  const i = t == null || (n = t.config) === null || n === void 0 ? void 0 : n.get_current_url;
  if (!ut(i)) return e;
  try {
    const r = i(e);
    return Pe(r) && r ? r : e;
  } catch (r) {
    return ee.error("Error in get_current_url, falling back to window.location.href", r), e;
  }
}
function sg(t) {
  var e;
  return t instanceof Element && (t.id === "__POSTHOG_TOOLBAR__" || !!(!((e = t.closest) === null || e === void 0) && e.call(t, ".toolbar-global-fade-container")));
}
function ki(t) {
  return !!t && t.nodeType === 1;
}
function vt(t, e) {
  return !!t && !!t.tagName && t.tagName.toLowerCase() === e.toLowerCase();
}
function bw(t) {
  return !!t && t.nodeType === 3;
}
function df(t) {
  return !!t && t.nodeType === 11 && ki(t.host);
}
function hf(t) {
  return t ? Xl(t).split(/\s+/) : [];
}
function og(t, e) {
  const n = (function(i) {
    var r;
    const s = L == null || (r = L.location) === null || r === void 0 ? void 0 : r.href;
    return G(s) ? void 0 : yw(i, s);
  })(e);
  return !!(n && t && t.some((i) => n.match(i)));
}
function Xr(t) {
  let e = "";
  switch (typeof t.className) {
    case "string":
      e = t.className;
      break;
    case "object":
      e = (t.className && "baseVal" in t.className ? t.className.baseVal : null) || t.getAttribute("class") || "";
      break;
    default:
      e = "";
  }
  return hf(e);
}
function _w(t) {
  return ve(t) ? null : Xl(t).split(/(\s+)/).filter((e) => js(e)).join("").replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255);
}
function no(t) {
  let e = "";
  return jr(t) && !ro(t) && t.childNodes && t.childNodes.length && Fe(t.childNodes, function(n) {
    var i;
    bw(n) && n.textContent && (e += (i = _w(n.textContent)) !== null && i !== void 0 ? i : "");
  }), Xl(e);
}
function Vs(t) {
  var e;
  return G(t.target) ? t.srcElement || null : !((e = t.target) === null || e === void 0) && e.shadowRoot ? t.composedPath()[0] || null : t.target || null;
}
const ff = ["a", "button", "form", "input", "select", "textarea", "label"];
function Pd(t, e) {
  const n = t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector;
  try {
    return !!n && n.call(t, e);
  } catch {
    return !1;
  }
}
function Ed(t, e) {
  if (G(e)) return !0;
  for (const n of t) if (e.some((i) => Pd(n, i))) return !0;
  return !1;
}
function ww(t) {
  const e = t.parentNode;
  return !(!e || !ki(e)) && e;
}
const zc = [".ph-no-autocapture", "[data-ph-no-autocapture]"], kw = ["next", "previous", "prev", ">", "<"], QI = [...kw, "+", "-", "−", "–"], ag = (t, e) => /[a-z0-9]/i.test(e) ? t.includes(e) : t === e, lg = [".ph-no-rageclick", ".ph-no-capture"], e4 = ["", "text", "search", "email", "password", "url", "tel", "number"];
function xw(t, e) {
  if (!L || pf(t)) return !1;
  let n, i, r;
  var s, o;
  if (Tt(e) ? (n = !!e && lg, i = void 0, r = !1) : (n = (s = e?.css_selector_ignorelist) !== null && s !== void 0 ? s : lg, i = e?.content_ignorelist, r = (o = e?.ignore_text_selection) !== null && o !== void 0 && o), n === !1 || r && (function(l) {
    return !(!l || !ki(l)) && (!!vt(l, "textarea") || (vt(l, "input") ? pe(e4, (l.getAttribute("type") || "").toLowerCase()) : (function(c) {
      var u;
      if (c.isContentEditable) return !0;
      const d = (u = c.getAttribute) === null || u === void 0 ? void 0 : u.call(c, "contenteditable");
      return d === "true" || d === "";
    })(l)));
  })(t)) return !1;
  const { targetElementList: a } = Sw(t, !1);
  return !(function(l, c) {
    if (l === !1 || G(l)) return !1;
    let u;
    if (l === !0) u = kw;
    else {
      if (!de(l)) return !1;
      if (l.length > 10) return ee.error("[PostHog] content_ignorelist array cannot exceed 10 items. Use css_selector_ignorelist for more complex matching."), !1;
      u = l.map((d) => d.toLowerCase());
    }
    return c.some(({ safeText: d, ariaLabel: h }) => u.some((f) => ag(d, f) || ag(h, f)));
  })(i, a.map((l) => {
    var c;
    return { safeText: no(l).toLowerCase(), ariaLabel: ((c = l.getAttribute("aria-label")) === null || c === void 0 ? void 0 : c.toLowerCase().trim()) || "" };
  })) && !Ed(a, n);
}
const pf = (t) => !t || vt(t, "html") || !ki(t), Sw = (t, e) => {
  if (!L || pf(t)) return { parentIsUsefulElement: !1, targetElementList: [] };
  let n = !1;
  const i = [t];
  let r = t;
  for (; r.parentNode && !vt(r, "body"); ) {
    if (df(r.parentNode)) {
      i.push(r.parentNode.host), r = r.parentNode.host;
      continue;
    }
    const s = ww(r);
    if (!s) break;
    if (e || ff.indexOf(s.tagName.toLowerCase()) > -1) n = !0;
    else try {
      const o = L.getComputedStyle(s);
      o && o.getPropertyValue("cursor") === "pointer" && (n = !0);
    } catch {
    }
    i.push(s), r = s;
  }
  return { parentIsUsefulElement: n, targetElementList: i };
};
function jr(t) {
  const e = /* @__PURE__ */ new Set();
  let n = 0;
  for (let s = t; s.parentNode && !vt(s, "body"); s = s.parentNode) {
    if (n++ >= 1e3 || e.has(s)) return !1;
    e.add(s);
    const o = Xr(s);
    if (pe(o, "ph-sensitive") || pe(o, "ph-no-capture")) return !1;
  }
  if (pe(Xr(t), "ph-include")) return !0;
  const i = t.type || "";
  if (Pe(i)) switch (i.toLowerCase()) {
    case "hidden":
    case "password":
      return !1;
  }
  const r = t.name || t.id || "";
  return !Pe(r) || !/^cc|cardnum|ccnum|creditcard|csc|cvc|cvv|exp|pass|pwd|routing|seccode|securitycode|securitynum|socialsec|socsec|ssn/i.test(r.replace(/[^a-zA-Z0-9]/g, ""));
}
function ro(t) {
  return !!(vt(t, "input") && !["button", "checkbox", "submit", "reset"].includes(t.type) || vt(t, "select") || vt(t, "textarea") || t.getAttribute("contenteditable") === "true");
}
const cg = new RegExp("^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$"), ug = /(^|[^0-9A-Za-z_])([0-9][0-9 -]*[0-9])(?=$|[^0-9A-Za-z_])/g, t4 = [16, 15, 14, 13], i4 = new RegExp("^(\\d{3}-?\\d{2}-?\\d{4})$"), dg = new RegExp("(^|[^0-9])((?!000|666)[0-9]{3}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4})(?=$|([^0-9]))", "g"), hg = /[0-9A-Za-z_]/;
function n4(t) {
  let e = 0, n = !1;
  for (let i = t.length - 1; i >= 0; i--) {
    let r = t.charCodeAt(i) - 48;
    n && (r *= 2, r > 9 && (r -= 9)), e += r, n = !n;
  }
  return e % 10 == 0;
}
function js(t, e = !0) {
  return !(ve(t) || Pe(t) && (t = Xl(t), (e ? cg.test((t || "").replace(/[- ]/g, "")) : (function(n) {
    let i;
    for (ug.lastIndex = 0; i = ug.exec(n); ) {
      const r = i[2];
      if (!r) continue;
      const s = r.replace(/[- ]/g, "");
      for (let o = 0; s.length > o; o++) for (const a of t4) {
        const l = o + a;
        if (s.length >= l) {
          const c = s.slice(o, l);
          if (cg.test(c) && n4(c)) return !0;
        }
      }
    }
    return !1;
  })(t)) || (e ? i4.test(t) : (function(n) {
    let i;
    for (dg.lastIndex = 0; i = dg.exec(n); ) {
      const r = i[1], s = i[3];
      if (!(r && s && hg.test(r) && hg.test(s))) return !0;
    }
    return !1;
  })(t))));
}
function fg(t) {
  let e = no(t);
  return e = `${e} ${Pw(t)}`.trim(), js(e) ? e : "";
}
function Pw(t) {
  let e = "";
  return t && t.childNodes && t.childNodes.length && Fe(t.childNodes, function(n) {
    var i;
    if (n && ((i = n.tagName) === null || i === void 0 ? void 0 : i.toLowerCase()) === "span") try {
      const r = no(n);
      e = `${e} ${r}`.trim(), n.childNodes && n.childNodes.length && (e = `${e} ${Pw(n)}`.trim());
    } catch (r) {
      ee.error("[AutoCapture]", r);
    }
  }), e;
}
function pg(t) {
  return t.replace(/"|\\"/g, '\\"');
}
function r4(t) {
  const e = t.attr__class;
  if (e) return de(e) ? e : hf(e);
}
const ra = Ze("[Dead Clicks]"), s4 = () => !0, o4 = (t) => {
  var e;
  const n = !!(!((e = t.instance.persistence) === null || e === void 0) && e.get_property(sf)), i = t.instance.config.capture_dead_clicks;
  return Tt(i) ? i : !!Ee(i) || n;
};
var mg = class {
  get lazyLoadedDeadClicksAutocapture() {
    return this.Ho;
  }
  constructor(t, e, n) {
    this.instance = t, this.isEnabled = e, this.onCapture = n, this.startIfEnabledOrStop();
  }
  onRemoteConfig(t) {
    if (!t.ok) return;
    const e = t.config;
    "captureDeadClicks" in e && (this.instance.persistence && this.instance.persistence.register({ [sf]: e.captureDeadClicks }), this.startIfEnabledOrStop());
  }
  startIfEnabledOrStop() {
    this.isEnabled(this) ? this.zo(() => {
      this.Uo();
    }) : this.stop();
  }
  zo(t) {
    var e, n, i;
    !((e = le.__PosthogExtensions__) === null || e === void 0) && e.initDeadClicksAutocapture ? t() : (n = le.__PosthogExtensions__) === null || n === void 0 || (i = n.loadExternalDependency) === null || i === void 0 || i.call(n, this.instance, "dead-clicks-autocapture", (r) => {
      r ? ra.error("failed to load script", r) : t();
    });
  }
  Uo() {
    var t;
    if (Y) {
      if (!this.Ho && (!((t = le.__PosthogExtensions__) === null || t === void 0) && t.initDeadClicksAutocapture)) {
        const e = Ee(this.instance.config.capture_dead_clicks) ? R({}, this.instance.config.capture_dead_clicks) : {};
        e.__onCapture = this.onCapture, this.onCapture && (e.capture_dead_swipes = !1), this.Ho = le.__PosthogExtensions__.initDeadClicksAutocapture(this.instance, e), this.Ho.start(Y), ra.info("starting...");
      }
    } else ra.error("`document` not found. Cannot start.");
  }
  stop() {
    this.Ho && (this.Ho.stop(), this.Ho = void 0, ra.info("stopping..."));
  }
};
const ys = Ze("[SegmentIntegration]");
function gg(t, e, n = !0) {
  const i = t.config.segment;
  if (!i) return e();
  const { analytics: r, filterProperties: s } = ((a) => ut(a.register))(o = i) ? { analytics: o } : o;
  var o;
  (function(a, l, c, u) {
    const d = (f) => {
      const p = () => f.anonymousId() || ri();
      a.config.get_device_id = p, u && f.id() && (a.register({ distinct_id: f.id(), $device_id: p() }), a.persistence.set_property(Et, Ca)), c(u ? void 0 : f.anonymousId() || void 0);
    }, h = l.user();
    "then" in h && ut(h.then) ? h.then(d) : d(h);
  })(t, r, (a) => {
    r.register(((l, c, { filterProperties: u } = {}) => {
      typeof Promise < "u" && Promise.resolve || ys.warn("This browser does not have Promise support, and can not use the segment integration");
      const d = (h, f) => {
        if (!f) return h;
        const p = !!c && h.event.anonymousId === c && !h.event.userId;
        p || h.event.userId || h.event.anonymousId === l.get_distinct_id() || (ys.info("No userId set, resetting PostHog"), l.reset()), p || (c = void 0), h.event.userId && h.event.userId !== l.get_distinct_id() && (ys.info("UserId set, identifying with PostHog"), l.identify(h.event.userId));
        let v = l.calculateEventProperties(f, h.event.properties);
        if (!ve(u)) {
          const g = h.event.properties || {}, m = {};
          for (const k of Object.keys(v)) Zh.call(g, k) || (m[k] = v[k]);
          const y = ((k, _) => {
            const w = de(k) ? k : [k];
            let T = R({}, _);
            for (const E of w) try {
              if (T = E(T), ve(T)) return null;
            } catch (S) {
              return ys.error("Error in Segment filterProperties:", S), null;
            }
            return T;
          })(u, m);
          if (ve(y)) return h;
          v = y;
        }
        return h.event.properties = Object.assign({}, v, h.event.properties), h;
      };
      return { name: "PostHog JS", type: "enrichment", version: "1.0.0", isLoaded() {
        return !0;
      }, load() {
        return Promise.resolve();
      }, track(h) {
        return d(h, h.event.event);
      }, page(h) {
        return d(h, cf);
      }, identify(h) {
        return d(h, pw);
      }, screen(h) {
        return d(h, "$screen");
      } };
    })(t, a, { filterProperties: s })).then(() => {
      e();
    }, (l) => {
      ys.error("Failed to register the Segment integration", l), e();
    });
  }, n);
}
const Ew = "posthog-js";
function Tw(t, { organization: e, projectId: n, prefix: i, severityAllowList: r = ["error"], sendExceptionsToPostHog: s = !0 } = {}) {
  return (o) => {
    var a, l, c, u, d;
    if (r !== "*" && !r.includes(o.level) || !t.__loaded) return o;
    o.tags || (o.tags = {});
    const h = t.requestRouter.endpointFor("ui", `/project/${t.config.token}/person/${t.get_distinct_id()}`);
    o.tags["PostHog Person URL"] = h, t.sessionRecordingStarted() && (o.tags["PostHog Recording URL"] = t.get_session_replay_url({ withTimestamp: !0 }));
    const f = ((a = o.exception) === null || a === void 0 ? void 0 : a.values) || [], p = f.map((m) => R(R({}, m), {}, { stacktrace: m.stacktrace ? R(R({}, m.stacktrace), {}, { type: "raw", frames: (m.stacktrace.frames || []).map((y) => R(R({}, y), {}, { platform: "web:javascript" })) }) : void 0 })), v = { $exception_message: ((l = f[0]) === null || l === void 0 ? void 0 : l.value) || o.message, $exception_type: (c = f[0]) === null || c === void 0 ? void 0 : c.type, $exception_level: o.level, $exception_list: p, $sentry_event_id: o.event_id, $sentry_exception: o.exception, $sentry_exception_message: ((u = f[0]) === null || u === void 0 ? void 0 : u.value) || o.message, $sentry_exception_type: (d = f[0]) === null || d === void 0 ? void 0 : d.type, $sentry_tags: o.tags };
    var g;
    return e && n && (v.$sentry_url = (i || "https://sentry.io/organizations/") + e + "/issues/?project=" + n + "&query=" + o.event_id), s && ((g = t.exceptions) === null || g === void 0 || g.sendExceptionEvent(v)), o;
  };
}
var a4 = class {
  constructor(t, e, n, i, r, s) {
    this.name = Ew, this.setupOnce = function(o) {
      o(Tw(t, { organization: e, projectId: n, prefix: i, severityAllowList: r, sendExceptionsToPostHog: s == null || s }));
    };
  }
}, vg = class {
  constructor(t) {
    this.Wo = (e, n, i) => {
      i && (i.noSessionId || i.activityTimeout || i.sessionPastMaximumLength || i.crossTabAdoption) && (ee.info("[PageViewManager] Session rotated, clearing pageview state", { sessionId: e, changeReason: i }), this.Vo = void 0, this._instance.scrollManager.resetContext());
    }, this._instance = t, this.Go();
  }
  Go() {
    var t;
    this.Zo = (t = this._instance.sessionManager) === null || t === void 0 ? void 0 : t.onSessionId(this.Wo);
  }
  destroy() {
    var t;
    (t = this.Zo) === null || t === void 0 || t.call(this), this.Zo = void 0;
  }
  doPageView(t, e) {
    var n;
    const i = this.Qo(t, e);
    return this.Vo = { pathname: (n = L?.location.pathname) !== null && n !== void 0 ? n : "", pageViewId: e, timestamp: t }, this._instance.scrollManager.resetContext(), i;
  }
  doPageLeave(t) {
    var e;
    return this.Qo(t, (e = this.Vo) === null || e === void 0 ? void 0 : e.pageViewId);
  }
  doEvent() {
    var t;
    return { $pageview_id: (t = this.Vo) === null || t === void 0 ? void 0 : t.pageViewId };
  }
  Qo(t, e) {
    const n = this.Vo;
    if (!n) return { $pageview_id: e };
    let i = { $pageview_id: e, $prev_pageview_id: n.pageViewId };
    const r = this._instance.scrollManager.getContext();
    if (r && !this._instance.config.disable_scroll_properties) {
      let { maxScrollHeight: s, lastScrollY: o, maxScrollY: a, maxContentHeight: l, lastContentY: c, maxContentY: u } = r;
      if (!(G(s) || G(o) || G(a) || G(l) || G(c) || G(u))) {
        s = Math.ceil(s), o = Math.ceil(o), a = Math.ceil(a), l = Math.ceil(l), c = Math.ceil(c), u = Math.ceil(u);
        const d = s > 1 ? yi(o / s, 0, 1, ee) : 1, h = s > 1 ? yi(a / s, 0, 1, ee) : 1, f = l > 1 ? yi(c / l, 0, 1, ee) : 1, p = l > 1 ? yi(u / l, 0, 1, ee) : 1;
        i = ze(i, { $prev_pageview_last_scroll: o, $prev_pageview_last_scroll_percentage: d, $prev_pageview_max_scroll: a, $prev_pageview_max_scroll_percentage: h, $prev_pageview_last_content: c, $prev_pageview_last_content_percentage: f, $prev_pageview_max_content: u, $prev_pageview_max_content_percentage: p });
      }
    }
    return n.pathname && (i.$prev_pageview_pathname = n.pathname), n.timestamp && (i.$prev_pageview_duration = (t.getTime() - n.timestamp.getTime()) / 1e3), i;
  }
};
const bs = ["flags", "surveys"], l4 = { [mI]: { exposure: "hidden" }, [al]: { exposure: "hidden" }, [gI]: { exposure: "hidden" }, [fd]: { exposure: "hidden" }, [Vr]: { exposure: "hidden" }, [Ds]: { exposure: "hidden" }, [J_]: { exposure: "event" }, [pd]: { exposure: "hidden" }, [Q_]: { exposure: "hidden" }, [md]: { exposure: "event" }, [Z_]: { exposure: "hidden" }, [gd]: { exposure: "event" }, [vd]: { exposure: "event" }, [sf]: { exposure: "event" }, [of]: { exposure: "hidden" }, [ew]: { exposure: "event" }, [Fs]: { exposure: "hidden" }, [vI]: { exposure: "hidden" }, [Pr]: { exposure: "hidden" }, [tw]: { exposure: "event" }, [yI]: { exposure: "event", shouldSkipFromEventProperties: (t) => Ye(t) }, [xI]: { exposure: "event" }, [SI]: { exposure: "event" }, [PI]: { exposure: "event" }, [EI]: { exposure: "event" }, [TI]: { exposure: "hidden" }, [ni]: { exposure: "hidden", storageGroup: "flags" }, [Li]: { exposure: "hidden", storageGroup: "flags" }, [yd]: { exposure: "hidden" }, [Kn]: { exposure: "hidden", storageGroup: "flags" }, [rn]: { exposure: "hidden", storageGroup: "flags" }, [Yn]: { exposure: "hidden", storageGroup: "flags", volatile: !0 }, [Ls]: { exposure: "hidden", storageGroup: "flags" }, [di]: { exposure: "hidden" }, [Fn]: { exposure: "hidden" }, [sn]: { exposure: "hidden" }, [on]: { exposure: "hidden" }, [bd]: { exposure: "hidden", storageGroup: "surveys" }, [ll]: { exposure: "hidden", storageGroup: "surveys", volatile: !0 }, [nw]: { exposure: "event" }, [rw]: { exposure: "hidden" }, [sw]: { exposure: "hidden" }, [_d]: { exposure: "hidden" }, [CI]: { exposure: "hidden" }, [AI]: { exposure: "hidden" }, [$I]: { exposure: "event" }, [RI]: { exposure: "event" }, [MI]: { exposure: "event" }, [OI]: { exposure: "event" }, [an]: { exposure: "hidden" }, [Cs]: { exposure: "hidden" }, [iw]: { exposure: "event" }, [to]: { exposure: "hidden" }, [hn]: { exposure: "hidden", storageGroup: "flags", volatile: !0 }, [Et]: { exposure: "hidden" }, [wd]: { exposure: "hidden" }, [II]: { exposure: "hidden" }, [ow]: { exposure: "hidden" }, [aw]: { exposure: "hidden" }, [Er]: { exposure: "hidden" }, [af]: { exposure: "hidden" }, [bI]: { exposure: "event" }, [_I]: { exposure: "event" }, [wI]: { exposure: "event" }, [kI]: { exposure: "event" }, [cw]: { exposure: "event" }, [uw]: { exposure: "event" }, [dw]: { exposure: "event" }, [hw]: { exposure: "event" }, [DI]: { exposure: "event" }, [FI]: { exposure: "event" }, [LI]: { exposure: "event" }, [NI]: { exposure: "event" }, [VI]: { exposure: "event" }, [jI]: { exposure: "event" }, [zI]: { exposure: "event" }, [BI]: { exposure: "event" } }, c4 = [["$posthog_sr_group_event_trigger_", { exposure: "hidden" }], ["$posthog_sr_group_url_trigger_", { exposure: "hidden" }], ["$posthog_sr_group_sampling_", { exposure: "hidden" }]], ft = (t) => {
  const e = l4[t];
  if (e) return e;
  for (const [n, i] of c4) if (t.indexOf(n) === 0) return i;
}, Cr = (t, e) => {
  try {
    let n;
    return JSON.stringify(t, (i, r) => {
      var s;
      return as(r) ? ((s = n) !== null && s !== void 0 || (n = /* @__PURE__ */ new WeakMap()), n.has(r) || n.set(r, mw(r)), n.get(r)) : typeof r == "bigint" ? r.toString() : r;
    }, e);
  } catch {
    return Z1(t);
  }
}, Wi = (t) => {
  const e = Y?.createElement("a");
  return G(e) ? null : (e.href = t, e);
}, Jr = function(t, e) {
  const n = ((t.split("#")[0] || "").split(/\?(.*)/)[1] || "").replace(/^\?+/g, "").split("&");
  let i;
  for (let r = 0; n.length > r; r++) {
    const s = n[r].split("=");
    if (s[0] === e) {
      i = s;
      break;
    }
  }
  if (!de(i) || 2 > i.length) return "";
  {
    let r = i[1];
    try {
      r = decodeURIComponent(r);
    } catch {
      ee.error("Skipping decoding for malformed query param: " + r);
    }
    return r.replace(/\+/g, " ");
  }
}, so = function(t, e, n) {
  if (!t || !e || !e.length) return t;
  const i = t.split("#"), r = i[1], s = (i[0] || "").split("?"), o = s[1], a = s[0], l = (o || "").split("&"), c = [];
  for (let d = 0; l.length > d; d++) {
    const h = l[d].split("=");
    de(h) && (e.includes(h[0]) ? c.push(h[0] + "=" + n) : c.push(l[d]));
  }
  let u = a;
  return o != null && (u += "?" + c.join("&")), r != null && (u += "#" + r), u;
}, dl = function(t, e) {
  const n = t.match(new RegExp(e + "=([^&]*)"));
  return n ? n[1] : null;
}, Cw = (t, e) => t >= e && J1(), Aw = (t, e, n, i) => {
  if (t === 0) {
    if (J1()) {
      const r = e + 1;
      return r === n && i(), r;
    }
    return e;
  }
  return 0;
}, Zr = ["gclid", "gclsrc", "dclid", "gbraid", "wbraid", "fbclid", "msclkid", "twclid", "li_fat_id", "igshid", "ttclid", "rdt_cid", "epik", "qclid", "sccid", "irclid", "_kx"], u4 = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gad_source", "mc_cid", ...Zr], oo = "<masked>", d4 = ["li_fat_id"];
function $w(t, e, n) {
  if (!Y) return {};
  const i = e ? [...Zr, ...n || []] : [], r = Rw(so(Y.URL, i, oo), t), s = (function() {
    const o = {};
    return Fe(d4, function(a) {
      const l = Ns(a);
      o[a] = l || null;
    }), o;
  })();
  return ze(s, r);
}
function Rw(t, e) {
  const n = u4.concat(e || []), i = {};
  return Fe(n, function(r) {
    const s = Jr(t, r);
    i[r] = s || null;
  }), i;
}
function Mw(t) {
  const e = (function(r) {
    return r ? r.search("https?://(.*)google.([^/?]*)") === 0 ? "google" : r.search("https?://(.*)bing.com") === 0 ? "bing" : r.search("https?://(.*)yahoo.com") === 0 ? "yahoo" : r.search("https?://(.*)duckduckgo.com") === 0 ? "duckduckgo" : null : null;
  })(t), n = e != "yahoo" ? "q" : "p", i = {};
  if (!Ye(e)) {
    i.$search_engine = e;
    const r = Y ? Jr(Y.referrer, n) : "";
    r.length && (i.ph_keyword = r);
  }
  return i;
}
function Ow() {
  return navigator.language || navigator.userLanguage;
}
function h4() {
  const t = Ow();
  return typeof t == "string" ? t.split("-")[0] : void 0;
}
const hl = "$direct";
function Iw() {
  return Y?.referrer || hl;
}
function Dw(t, e, n = !1) {
  const i = t ? [...Zr, ...e || []] : [], r = n ? gn(Ke?.href) : Ke?.href, s = r?.substring(0, 1e3);
  return { r: Iw().substring(0, 1e3), u: s ? so(s, i, oo) : void 0 };
}
function Fw(t, e = !1) {
  var n;
  const { r: i, u: r } = t, s = e ? gn(r) : r, o = { $referrer: i, $referring_domain: i == null ? void 0 : i == hl ? hl : (n = Wi(i)) === null || n === void 0 ? void 0 : n.host };
  if (s) {
    o.$current_url = s;
    const a = Wi(s);
    o.$host = a?.host, o.$pathname = a?.pathname;
    const l = Rw(s);
    ze(o, l);
  }
  if (i) {
    const a = Mw(i);
    ze(o, a);
  }
  return o;
}
function Lw() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return;
  }
}
function f4() {
  try {
    return (/* @__PURE__ */ new Date()).getTimezoneOffset();
  } catch {
    return;
  }
}
const p4 = { flags: hn, surveys: ll }, m4 = ["cookie", "localstorage", "localstorage+cookie", "sessionstorage", "memory"], sa = (t) => `${t}_cookie_identity_change_pending`, oa = (t) => {
  let e = "", n = 0;
  for (const i of t) {
    const r = encodeURIComponent(JSON.stringify(i).slice(1, -1)).length;
    if (n + r > 1e3) break;
    e += i, n += r;
  }
  return e;
}, rt = "main", Oi = [ni, Li, Kn, rn, Yn, hn, Ls, sn], Bc = (t) => Oi.indexOf(t) !== -1, Nw = [Vr, Ds], yg = (t) => Nw.indexOf(t) !== -1, Xi = (t, e) => {
  try {
    return JSON.stringify(t) === JSON.stringify(e);
  } catch {
    return t === e;
  }
}, ur = (t) => {
  if (!t) return {};
  const e = JSON.parse(t);
  return Ee(e) ? e : {};
}, bg = (t, e) => {
  Fe(t, (n, i) => {
    const r = ft(i);
    r && r.exposure !== "event" || {}.hasOwnProperty.call(e, i) || delete t[i];
  });
};
var Hc = class {
  constructor(t, e, n = !0) {
    if (this.Jo = {}, this.Ko = !1, this.Xo = !1, this.Yo = !1, this.ta = !1, this.ea = !1, this.ia = /* @__PURE__ */ new Map(), this.na = !1, this.sa = !1, this.ra = !1, this.oa = /* @__PURE__ */ new Set(), this.aa = /* @__PURE__ */ new Set(), this.Rr = t, this.la = n, this.props = {}, this.ua = void 0, this.ha = ((i) => {
      let r = "";
      return i.token && (r = i.token.replace(/\+/g, "PL").replace(/\//g, "SL").replace(/=/g, "EQ")), i.persistence_name ? "ph_" + i.persistence_name : "ph_" + r + "_posthog";
    })(t), this.qo = this.ca(t), this.Yo = this.da(t), this.load(), this.va(), t.debug && ee.info("Persistence loaded", t.persistence, R({}, this.props)), this.update_config(t, t, e), this.save(), L) {
      const i = () => this.flush();
      Ie(L, "beforeunload", i, { capture: !1 }), Ie(L, "pagehide", i, { capture: !1 }), this.fa = (r) => {
        if (this.Ko && (!r.storageArea || r.storageArea === L?.localStorage) && r.key) if (r.key !== this.ha) {
          if (this.Yo) {
            const s = bs.find((o) => r.key === this.pa(o));
            s && this.ga(r.key, s);
          }
        } else this.ga(r.key, rt);
      }, Ie(L, "storage", this.fa);
    }
  }
  markCrossTabFeatureFlagChanges(t) {
    Object.entries(t).forEach(([e, n]) => {
      const i = this.ia.get(e);
      if (!Bc(e) || i === !0) return;
      if (n === !0) return void this.ma(e, !0);
      const r = new Set(i || []);
      n.forEach((s) => r.add(s)), r.size && this.ma(e, r);
    });
  }
  onCrossTabFeatureFlagChange(t) {
    return this.aa.add(t), () => this.aa.delete(t);
  }
  destroy() {
    this.fa && L && (L.removeEventListener("storage", this.fa), this.fa = void 0), this.aa.clear();
  }
  ga(t, e, n = !0) {
    if (this.mi) return !1;
    let i, r;
    try {
      if (r = Re.Ot(t), Ye(r)) {
        const a = this.ya(e);
        return a.storageValue = null, e !== rt && (a.persisted = !1), !1;
      }
      i = ur(r);
    } catch {
      return !1;
    }
    const s = e === rt ? i : Re.Dt(this.ha);
    if (s && this.ba(s)) return !1;
    const o = this._a(i, e, n);
    return e === rt && this.Yo && !Xi(this.wa().main, i) || this.ka(i, e, !0, r), o;
  }
  ba(t) {
    const e = this.props[ti], n = t[ti];
    return !G(e) && !G(n) && e !== n;
  }
  ka(t, e, n, i) {
    const r = this.ya(e);
    r.storageValue = i, e !== rt && (r.persisted = n);
    try {
      r.fingerprint = this.Sa(t, e);
    } catch {
      r.fingerprint = void 0;
    }
  }
  _a(t, e, n) {
    let i = !1;
    return Oi.forEach((r) => {
      var s;
      const o = (s = ft(r)) === null || s === void 0 ? void 0 : s.storageGroup;
      if (e === rt && this.Yo && o || e !== rt && o !== e) return;
      const a = r in t, l = this.xa(r, a ? t[r] : void 0), c = this.ia.has(r) ? r in this.props : a;
      c === r in this.props && Xi(l, this.props[r]) || (c ? this.Ca(r, l, !1) : this.$a(r, !1), i = !0);
    }), i && n && this.aa.forEach((r) => r()), i;
  }
  Ta() {
    if (!this.Ko) return !1;
    try {
      this.ra = !1;
      const t = Re.Ot(this.ha), e = this.ya(rt);
      let n, i = !1, r = !1;
      if (t !== e.storageValue) if (Ye(t)) e.storageValue = null;
      else {
        if (n = ur(t), this.ra = !this.sa && this.ba(n), this.ra) return !1;
        r = this._a(n, rt, !1), !this.Yo || Xi(this.wa().main, n) ? this.ka(n, rt, !0, t) : e.storageValue = t, i = !0;
      }
      return this.Yo && bs.forEach((s) => {
        const o = Re.Ot(this.pa(s)), a = this.ya(s), l = n || {}, c = i && Oi.some((d) => {
          var h;
          return ((h = ft(d)) === null || h === void 0 ? void 0 : h.storageGroup) === s && d in l;
        });
        if (o === a.storageValue && !c) return;
        if (Ye(o)) return a.storageValue = null, a.persisted = !1, void (c && (r = this._a(l, s, !1) || r));
        const u = ur(o);
        r = this._a(u, s, !1) || r, this.ka(u, s, !0, o);
      }), r;
    } catch {
      return !1;
    }
  }
  ma(t, e) {
    this.ia.set(t, e);
    const n = ft(t);
    n?.volatile || (this.ya((this.Yo ? n?.storageGroup : void 0) || rt).fingerprint = void 0, this.Ia(t));
  }
  Ma() {
    Oi.forEach((t) => this.ia.set(t, !0));
  }
  va() {
    if (this.Ko) try {
      const t = Re.Ot(this.ha), e = ur(t);
      this.ya(rt).storageValue = t, Oi.forEach((n) => {
        var i;
        const r = this.Yo ? (i = ft(n)) === null || i === void 0 ? void 0 : i.storageGroup : void 0, s = r ? Re.Ot(this.pa(r)) : null;
        if (r) {
          const a = this.ya(r);
          a.storageValue = s, a.persisted = !Ye(s);
        }
        const o = r && !Ye(s) ? ur(s) : e;
        n in this.props ? this.Ea(n, o[n], this.props[n]) : n in o && this.ma(n, !0);
      });
    } catch {
    }
  }
  xa(t, e) {
    const n = this.ia.get(t);
    if (!n) return e;
    if (n === !0) return this.props[t];
    if (t === "$active_feature_flags") {
      const s = new Set(de(e) ? e : []), o = new Set(de(this.props[t]) ? this.props[t] : []);
      return n.forEach((a) => o.has(a) ? s.add(a) : s.delete(a)), Array.from(s);
    }
    const i = Ee(e) ? R({}, e) : {}, r = Ee(this.props[t]) ? this.props[t] : {};
    return n.forEach((s) => {
      s in r ? i[s] = r[s] : delete i[s];
    }), i;
  }
  Ea(t, e, n) {
    if (!Bc(t)) return;
    const i = this.ia.get(t);
    if (i === !0) return;
    let r = e;
    if (this.Ko) try {
      var s;
      const a = this.Yo ? (s = ft(t)) === null || s === void 0 ? void 0 : s.storageGroup : void 0, l = a ? this.pa(a) : this.ha;
      r = ur(Re.Ot(l))[t];
    } catch {
    }
    const o = new Set(i || []);
    if (t === "$active_feature_flags") {
      if (!G(e) && !de(e) || !G(r) && !de(r) || !de(n)) return void this.ma(t, !0);
      const a = new Set(e || []), l = new Set(r || []), c = new Set(n);
      (/* @__PURE__ */ new Set([...a, ...c])).forEach((u) => {
        a.has(u) !== c.has(u) && o.add(u);
      }), o.forEach((u) => {
        l.has(u) === c.has(u) && o.delete(u);
      });
    } else {
      if (!Ee(n)) return void (Xi(r, n) ? this.ia.delete(t) : this.ma(t, !0));
      {
        if (!G(e) && !Ee(e) || G(e) && Ot(n) && G(r)) return void this.ma(t, !0);
        const a = Ee(e) ? e : {}, l = Ee(r) ? r : {};
        (/* @__PURE__ */ new Set([...Object.keys(a), ...Object.keys(n)])).forEach((c) => {
          c in a == c in n && Xi(a[c], n[c]) || o.add(c);
        }), o.forEach((c) => {
          c in l == c in n && Xi(l[c], n[c]) && o.delete(c);
        });
      }
    }
    o.size ? this.ma(t, o) : this.ia.delete(t);
  }
  Pa() {
    var t;
    const e = (t = this.Rr) === null || t === void 0 ? void 0 : t.persistence_save_debounce_ms;
    return Qe(e) && e > 0 ? e : 0;
  }
  Ra(t) {
    if (this.Rr.cookieWinsOnConflict && this.Rr.persistence.toLowerCase() === "localstorage+cookie") if (t) try {
      const e = Vc(t, this.Rr.cookie_persisted_properties || []), n = ng(e, this.Rr.cookie_persisted_properties || []), i = JSON.stringify(e) + "|" + JSON.stringify(n), r = Ge.Ot(this.ha) || void 0;
      r && jc(this.ha, r) === i && (this.Aa = i, this.Fa = r);
    } catch {
    }
    else try {
      const e = Ge.Ot(this.ha) || void 0;
      this.Aa = e ? jc(this.ha, e) : void 0, this.Fa = e;
    } catch {
    }
  }
  syncCookieProperties() {
    return this.Oa(this.Rr);
  }
  Oa(t, e = !1) {
    if (this.mi && !e || this.ea || !t.cookieWinsOnConflict || t.persistence.toLowerCase() !== "localstorage+cookie") return !1;
    let n;
    try {
      n = Ge.Ot(this.ha) || void 0;
    } catch {
    }
    if (!n || n === this.Fa) return !1;
    const i = jc(this.ha, n);
    let r;
    try {
      r = Nc(JSON.parse(n));
    } catch {
      return !1;
    }
    if ((Ge.Ot(this.ha) || void 0) !== n) return !1;
    this.Aa = i, this.Fa = n;
    const s = rg(this.ha, n), o = [...Ln, ...s.properties], a = {};
    if (Object.keys(r).forEach((v) => {
      const g = r[v];
      (G(g) || Ye(g) || g === "" || v === "$user_state" && g !== "anonymous" && g !== "identified") && (a[v] = !0, delete r[v]);
    }), Ot(r)) return !1;
    const l = "distinct_id" in r || r.$user_state === "anonymous" || r.$user_state === "identified", c = this.props, u = c[ti], d = c[Et], h = ze({}, c);
    [...Ln, ...t.cookie_persisted_properties || []].forEach((v) => {
      if (o.indexOf(v) !== -1 && !(v in r) && !a[v] && (l || v !== "distinct_id" && v !== "$user_state")) {
        const g = h[v];
        (s.isValid || Ln.indexOf(v) === -1 || g !== !1 && g !== 0) && delete h[v];
      }
    }), this.props = ze(h, r), Oi.forEach((v) => {
      const g = v in this.props;
      v in c === g && Xi(c[v], this.props[v]) || (g ? this.Ea(v, c[v], this.props[v]) : this.ma(v, !0));
    }), !l || "$user_state" in r || "$user_state" in this.props || this.Ca(Et, Ni);
    const f = this.props[ti], p = this.props[Et];
    return !l || f === u && p === d || (this.sa = !0, this.ta = !0, je.At(sa(this.ha), !0), this.$a(sn), this.$a(Li), this.$a(ni), this.$a(Kn), this.$a(rn), this.$a(Yn), this.$a(hn), this.$a(to), this.$a(an), p !== "anonymous" || d !== "identified" && r.$user_state !== "anonymous" && (G(u) || f === u) || (bg(this.props, r), this.$a(on)), p === "identified" ? this.props.$user_id = f : delete this.props.$user_id, this.$a(al)), !0;
  }
  consumeCookieIdentityChange() {
    const t = sa(this.ha), e = this.ta || !!je.Ot(t);
    return this.ta = !1, e && je.Lt(t), e;
  }
  Da(t = !1) {
    return !(this.ea || this.mi && !t || !this.Rr.cookieWinsOnConflict || this.Rr.persistence.toLowerCase() !== "localstorage+cookie" || (this.ea = !0, 0));
  }
  La() {
    this.ea && (G(this.Na) || (clearTimeout(this.Na), this.Na = void 0), delete this.Jo[rt], this.qa(!0));
  }
  ja(t = !0) {
    if (this.ea) try {
      t ? this.La() : G(this.Na) || (clearTimeout(this.Na), this.Na = void 0);
    } finally {
      this.ea = !1;
    }
  }
  isDisabled() {
    return !!this.mi;
  }
  ca(t) {
    m4.indexOf(t.persistence.toLowerCase()) === -1 && (ee.critical("Unknown persistence type " + t.persistence + "; falling back to localStorage+cookie"), t.persistence = "localStorage+cookie");
    const e = ((o = [], a = !1) => {
      const l = [...Ln, ...o];
      return R(R({}, Re), {}, { Dt(c) {
        try {
          let d, h = {};
          try {
            d = Ge.Ot(c) || void 0, h = d ? Nc(JSON.parse(d)) : {};
          } catch {
          }
          const f = JSON.parse(Re.Ot(c) || "{}");
          let p;
          if (a) {
            const v = rg(c, d), g = [...Ln, ...v.properties], m = {};
            Object.keys(h).forEach((k) => {
              const _ = h[k];
              Ye(_) || _ === "" || k === "$user_state" && _ !== "anonymous" && _ !== "identified" || (m[k] = _);
            });
            const y = "distinct_id" in m || m.$user_state === "anonymous" || m.$user_state === "identified";
            if (Object.keys(m).length > 0) {
              var u;
              const k = f[ti], _ = (u = f.$user_state) !== null && u !== void 0 ? u : Ni;
              l.forEach((w) => {
                if (g.indexOf(w) !== -1 && !(w in h) && (y || w !== "distinct_id" && w !== "$user_state")) {
                  const T = f[w];
                  (v.isValid || Ln.indexOf(w) === -1 || T !== !1 && T !== 0) && delete f[w];
                }
              }), !y || "$user_state" in h || "$user_state" in f || (f[Et] = Ni), !y || ("distinct_id" in m ? m[ti] : f[ti]) === k && ("$user_state" in m ? m[Et] : f[Et]) === _ || (Lc.forEach((w) => delete f[w]), m.$user_state === "identified" && "distinct_id" in m ? f.$user_id = m[ti] : delete f.$user_id, m.$user_state !== "identified" && (delete f[iw], delete f[on]), delete f.__alias);
            }
            p = ze(f, m);
          } else p = ze(h, f);
          return Re.At(c, p), p;
        } catch {
        }
        return null;
      }, At(c, u, d, h, f, p) {
        const v = Re.At(c, u, void 0, void 0, p);
        try {
          const g = Vc(u, o);
          if (Object.keys(g).length) {
            if (a) {
              const m = ul(c), y = ng(g, o);
              if (Ge.At(m, y, d, h, f, p), Ge.Ot(m) !== JSON.stringify(y)) {
                Ge.Lt(m, h);
                const k = Vc(u);
                return Ge.At(c, k, d, h, f, p), v;
              }
            }
            Ge.At(c, g, d, h, f, p);
          }
        } catch (g) {
          Re.Pt(g);
        }
        return v;
      }, Lt(c, u) {
        try {
          L?.localStorage.removeItem(c), Ge.Lt(c, u), Ge.Lt(ul(c), u);
        } catch (d) {
          Re.Pt(d);
        }
      } });
    })(t.cookie_persisted_properties || [], t.cookieWinsOnConflict);
    let n, i = !1, r = !1;
    const s = t.persistence.toLowerCase();
    return s === "localstorage" && Re.Et() ? (n = Re, r = !0) : s === "localstorage+cookie" && e.Et() ? (n = e, r = !0, i = !0) : s === "sessionstorage" && je.Et() ? n = je : s === "memory" ? n = Sd : s === "cookie" && Ge.Et() ? (n = Ge, i = !0) : e.Et() ? (n = e, r = !0, i = !0) : Ge.Et() ? (n = Ge, i = !0) : n = Sd, this.Ko = r, this.Xo = i, n;
  }
  pa(t) {
    return `${this.ha}__${t}`;
  }
  da(t) {
    return this.Ko && !!t.split_storage;
  }
  properties() {
    const t = {};
    return Fe(this.props, (e, n) => {
      const i = ft(n);
      if (!i || i.exposure === "event") {
        var r;
        if (!(i == null || (r = i.shouldSkipFromEventProperties) === null || r === void 0) && r.call(i, e)) return;
        t[n] = e;
      }
    }), t;
  }
  load(t = !1) {
    if (this.mi && !t) return;
    const e = this.Rr.cookieWinsOnConflict && this.Rr.persistence.toLowerCase() === "localstorage+cookie", n = e ? Re.Dt(this.ha) : null;
    let i = {};
    if (e) try {
      i = Nc(Ge.Dt(this.ha)), Fe(i, (a, l) => {
        (G(a) || Ye(a) || a === "") && delete i[l];
      });
    } catch {
    }
    const r = this.qo.Dt(this.ha);
    if (r && (this.props = ze({}, r)), this.Yo && this.Ba(), e && r) {
      var s, o;
      const a = n?.[ti], l = (s = n?.$user_state) !== null && s !== void 0 ? s : Ni, c = r[ti], u = (o = r.$user_state) !== null && o !== void 0 ? o : Ni;
      if (c !== a || u !== l) {
        this.ta = !0, je.At(sa(this.ha), !0);
        const d = ze({}, this.props);
        Lc.forEach((f) => delete d[f]), u !== "anonymous" || l !== "identified" && i.$user_state !== "anonymous" && (G(a) || c === a) || (bg(d, i), delete d[on]), this.props = d;
        const h = /* @__PURE__ */ new Set();
        Lc.forEach((f) => {
          var p;
          const v = (p = ft(f)) === null || p === void 0 ? void 0 : p.storageGroup;
          v && h.add(v);
        }), h.forEach((f) => {
          const p = {};
          Fe(this.props, (v, g) => {
            var m;
            ((m = ft(g)) === null || m === void 0 ? void 0 : m.storageGroup) === f && (p[g] = v);
          }), Ot(p) ? (Re.Lt(this.pa(f)), this.Jo[f] = {}) : Re.At(this.pa(f), p) && (this.Jo[f] = { persisted: !0, fingerprint: this.Sa(p, f) });
        });
      }
    }
    je.Ot(sa(this.ha)) && (this.ta = !0);
  }
  Ba() {
    for (const t of bs) {
      const e = Re.Dt(this.pa(t));
      if (e && !Ot(e)) {
        const n = this.ya(t);
        n.persisted = !0, this.Ha(t) || (n.fingerprint = this.Sa(e, t)), this.za(t, e) || ze(this.props, e);
      }
    }
  }
  Ha(t) {
    return Object.keys(this.props).some((e) => {
      var n;
      return ((n = ft(e)) === null || n === void 0 ? void 0 : n.storageGroup) === t;
    });
  }
  za(t, e) {
    const n = p4[t];
    if (!n) return !1;
    const i = e[n], r = this.props[n];
    return Qe(i) && Qe(r) && r > i;
  }
  refreshKey(t) {
    var e;
    if (this.mi || this.oa.has(t)) return;
    const n = this.Yo ? (e = ft(t)) === null || e === void 0 ? void 0 : e.storageGroup : void 0, i = n ? Re.Dt(this.pa(n)) : this.qo.Dt(this.ha);
    if (i && t in i) this.Ca(t, i[t], !1);
    else {
      if (n) {
        const r = this.qo.Dt(this.ha);
        if (r && t in r) return void this.Ca(t, r[t], !1);
      }
      this.$a(t, !1);
    }
  }
  save() {
    if (this.mi) return;
    const t = this.Pa();
    t > 0 ? G(this.Na) && (this.Na = setTimeout(() => {
      this.Na = void 0, this.qa();
    }, t)) : this.qa();
  }
  flush() {
    G(this.Na) || (clearTimeout(this.Na), this.Na = void 0, this.qa());
  }
  qa(t = !1) {
    if (this.mi || this.ea && !t) return;
    t || (this.syncCookieProperties(), this.Rr.cookieWinsOnConflict && this.Rr.persistence.toLowerCase() === "localstorage+cookie" || Nw.forEach((r) => this.refreshKey(r)));
    const e = !t && !this.na;
    e || (this.ra = !1);
    const n = !!e && this.Ta();
    if (this.ra) return void (this.Rr.debug && ee.warn("skipping persistence write because storage belongs to a different distinct ID"));
    if (this.Yo) return this.Ua(), void (n && this.aa.forEach((r) => r()));
    const i = this.Wa(this.qo, this.ha, this.props, rt);
    i === "written" && this.Ra(this.props), i !== "failed" && (this.ia.clear(), this.sa = !1, this.oa.clear()), n && this.aa.forEach((r) => r());
  }
  Ua() {
    const { main: t, groups: e } = this.wa(), n = this.Wa(this.qo, this.ha, t, rt);
    n === "written" && this.Ra(t), n !== "failed" && (this.sa = !1, this.oa.clear(), Oi.forEach((r) => {
      var s;
      !((s = ft(r)) === null || s === void 0) && s.storageGroup || this.ia.delete(r);
    }));
    for (const r of bs) {
      var i;
      const s = e[r];
      if (Ot(s) && !(!((i = this.Jo[r]) === null || i === void 0) && i.persisted)) {
        Oi.forEach((a) => {
          var l;
          ((l = ft(a)) === null || l === void 0 ? void 0 : l.storageGroup) === r && this.ia.delete(a);
        });
        continue;
      }
      const o = this.Wa(Re, this.pa(r), s, r);
      o !== "failed" && Oi.forEach((a) => {
        const l = ft(a);
        l?.storageGroup !== r || o !== "written" && l.volatile || this.ia.delete(a);
      });
    }
  }
  wa() {
    const t = {}, e = { flags: {}, surveys: {} };
    return Fe(this.props, (n, i) => {
      var r;
      const s = (r = ft(i)) === null || r === void 0 ? void 0 : r.storageGroup;
      s ? e[s][i] = n : t[i] = n;
    }), { main: t, groups: e };
  }
  Sa(t, e) {
    if (e === rt) return JSON.stringify(t) + "|" + this.Va + "|" + this.Ga + "|" + this.Za;
    const n = {};
    return Fe(t, (i, r) => {
      var s;
      n[r] = !((s = ft(r)) === null || s === void 0) && s.volatile ? "__volatile__" : i;
    }), JSON.stringify(n);
  }
  Wa(t, e, n, i) {
    const r = this.ya(i);
    if (i !== rt && !r.dirty && !G(r.fingerprint)) return "skipped";
    let s;
    try {
      if (s = this.Sa(n, i), s === r.fingerprint) return r.dirty = !1, "skipped";
    } catch {
      s = void 0;
    }
    return t.At(e, n, this.Va, this.Ga, this.Za, this.Rr.debug) ? (r.dirty = !1, i !== rt && (r.persisted = !0), G(s) || (r.fingerprint = s), this.Ko && (r.storageValue = Re.Ot(e)), "written") : (this.Rr.debug && ee.warn(`failed to persist storage entry "${e}"; will retry on next save`), "failed");
  }
  remove({ keepGroupEntries: t = !1 } = {}) {
    if (this.Ma(), G(this.Na) || (clearTimeout(this.Na), this.Na = void 0), this.qo.Lt(this.ha, !1), this.qo.Lt(this.ha, !0), !t && this.la) for (const e of bs) Re.Lt(this.pa(e));
    t ? delete this.Jo[rt] : this.Jo = {}, this.Aa = void 0, this.Fa = void 0;
  }
  clear() {
    this.remove(), this.props = {};
  }
  register_once(t, e, n) {
    if (Ee(t)) {
      this.syncCookieProperties(), G(e) && (e = "None"), this.Va = G(n) ? this.Qa : n;
      let i = !1;
      if (Fe(t, (r, s) => {
        this.props.hasOwnProperty(s) && this.props[s] !== e || (this.Ca(s, r), i = !0);
      }), i) return this.save(), !0;
    }
    return !1;
  }
  register(t, e) {
    if (Ee(t)) {
      this.syncCookieProperties(), this.Va = G(e) ? this.Qa : e;
      let n = !1;
      if (Fe(t, (i, r) => {
        t.hasOwnProperty(r) && (this.props[r] !== i || Ee(i) || de(i)) && (this.Ca(r, i), n = !0);
      }), n) return this.save(), !0;
    }
    return !1;
  }
  unregister(t) {
    this.syncCookieProperties();
    const e = typeof t == "string" ? [t] : t;
    let n = !1;
    for (const i of e) i in this.props && (this.$a(i), n = !0);
    n && this.save();
  }
  update_campaign_params() {
    const t = Y?.URL;
    if (t === this.ua) return;
    const e = $w(this.Rr.custom_campaign_params, this.Rr.mask_personal_data_properties, this.Rr.custom_personal_data_properties), n = !Ot(uf(e));
    return n && this.register(e), this.ua = t, n ? e : void 0;
  }
  update_search_keyword() {
    this.register((function() {
      const t = Y?.referrer;
      return t ? Mw(t) : {};
    })());
  }
  update_referrer_info() {
    var t;
    this.register_once({ $referrer: Iw(), $referring_domain: Y?.referrer && ((t = Wi(Y.referrer)) === null || t === void 0 ? void 0 : t.host) || hl }, void 0);
  }
  set_initial_person_info() {
    if (this.props.$initial_campaign_params || this.props.$initial_referrer_info) return;
    const t = Dw(this.Rr.mask_personal_data_properties, this.Rr.custom_personal_data_properties, this.Rr.disable_capture_url_hashes);
    this.register_once({ [Er]: this.Xo ? { r: oa(t.r), u: t.u ? oa(t.u) : void 0 } : t }, void 0);
  }
  get_initial_props() {
    const t = {};
    Fe([aw, ow], (n) => {
      const i = this.props[n];
      i && Fe(i, function(r, s) {
        t["$initial_" + sd(s)] = r;
      });
    });
    const e = this.props[Er];
    if (e) {
      const n = (function(i, r = !1) {
        const s = Fw(i, r), o = {};
        return Fe(s, function(a, l) {
          o[`$initial_${sd(l)}`] = a;
        }), o;
      })(e, this.Rr.disable_capture_url_hashes);
      ze(t, n);
    }
    return t;
  }
  safe_merge(t) {
    return Fe(this.props, function(e, n) {
      n in t || (t[n] = e);
    }), t;
  }
  update_config(t, e, n) {
    const i = t.persistence !== e.persistence, r = !((f, p) => {
      if (f.length !== p.length) return !1;
      const v = [...f].sort(), g = [...p].sort();
      return v.every((m, y) => m === g[y]);
    })(t.cookie_persisted_properties || [], e.cookie_persisted_properties || []), s = i || r, o = t.cookieWinsOnConflict !== e.cookieWinsOnConflict, a = t.disable_persistence || !!n, l = !!this.mi && !a;
    a || this.Oa(e, l), this.Rr = t, !a && (i || r || o) && (this.Aa = void 0, this.Fa = void 0, this.Oa(R(R({}, t), {}, { cookie_persisted_properties: e.cookie_persisted_properties }), l));
    const c = s || o ? this.ca(t) : this.qo;
    this.Ja();
    const u = this.da(t), d = s || u !== this.Yo, h = !a && (d || t.cross_subdomain_cookie !== this.Ga || t.secure_cookie !== this.Za) && this.Da(l);
    this.na = d;
    try {
      if (this.Qa = this.Va = t.cookie_expiration, this.set_disabled(a), this.set_cross_subdomain(t.cross_subdomain_cookie), this.set_secure(t.secure_cookie), d) {
        const f = this.props;
        this.clear(), this.qo = c, this.Yo = u, this.props = f, this.save();
      } else o && (this.qo = c, a || (delete this.Jo[rt], this.qa()));
    } finally {
      this.na = !1, h && this.ja();
    }
  }
  Ja() {
    const t = this.props[Er];
    if (!this.Xo || !Ee(t) || typeof t.r != "string") return;
    const e = oa(t.r), n = typeof t.u == "string" ? oa(t.u) : t.u;
    e === t.r && n === t.u || this.Ca(Er, R(R({}, t), {}, { r: e, u: n }));
  }
  set_disabled(t) {
    this.mi = t, this.mi ? this.remove() : this.save();
  }
  set_cross_subdomain(t) {
    t !== this.Ga && (this.Ga = t, this.remove({ keepGroupEntries: !0 }), this.save());
  }
  set_secure(t) {
    t !== this.Za && (this.Za = t, this.remove({ keepGroupEntries: !0 }), this.save());
  }
  set_event_timer(t, e) {
    const n = this.props.__timers || {};
    n[t] = e, this.Ca(fd, n), this.save();
  }
  remove_event_timer(t) {
    const e = this.props.__timers || {}, n = e[t];
    return G(n) || (delete e[t], this.Ca(fd, e), this.save()), n;
  }
  get_property(t) {
    return this.props[t];
  }
  set_property(t, e) {
    this.Ca(t, e), this.save();
  }
  Ca(t, e, n = !0) {
    var i;
    const r = this.props[t];
    this.props[t] = e, n && (t !== "distinct_id" && t !== "$user_state" || r === e || (this.sa = !0), yg(t) && !Xi(r, e) && this.oa.add(t), this.Ea(t, r, e), !((i = ft(t)) === null || i === void 0) && i.volatile || this.Ia(t));
  }
  $a(t, e = !0) {
    delete this.props[t], e && (Bc(t) && this.ma(t, !0), yg(t) && this.oa.add(t), this.Ia(t));
  }
  Ia(t) {
    var e;
    const n = (e = ft(t)) === null || e === void 0 ? void 0 : e.storageGroup;
    n && (this.ya(n).dirty = !0);
  }
  ya(t) {
    return this.Jo[t] || (this.Jo[t] = {});
  }
};
const It = { GZipJS: "gzip-js", Base64: "base64" }, vr = { Activation: "events", Cancellation: "cancelEvents" }, g4 = { Button: "button", Tab: "tab", Selector: "selector" }, v4 = { TopLeft: "top_left", TopRight: "top_right", TopCenter: "top_center", MiddleLeft: "middle_left", MiddleRight: "middle_right", MiddleCenter: "middle_center", Left: "left", Center: "center", Right: "right", NextToTrigger: "next_to_trigger" }, y4 = { Top: "top", Left: "left", Right: "right", Bottom: "bottom" }, $a = { Popover: "popover", API: "api", Widget: "widget", ExternalSurvey: "external_survey" }, b4 = { Open: "open", MultipleChoice: "multiple_choice", SingleChoice: "single_choice", Rating: "rating", Link: "link" }, _4 = { NextQuestion: "next_question", End: "end", ResponseBased: "response_based", SpecificQuestion: "specific_question" }, w4 = { Once: "once", Recurring: "recurring", Always: "always" }, gi = { SHOWN: "survey shown", DISMISSED: "survey dismissed", SENT: "survey sent", ABANDONED: "survey abandoned" }, Ra = { SURVEY_ID: "$survey_id", SURVEY_NAME: "$survey_name", SURVEY_RESPONSE: "$survey_response", SURVEY_ITERATION: "$survey_iteration", SURVEY_ITERATION_START_DATE: "$survey_iteration_start_date", SURVEY_PARTIALLY_COMPLETED: "$survey_partially_completed", SURVEY_SUBMISSION_ID: "$survey_submission_id", SURVEY_QUESTIONS: "$survey_questions", SURVEY_COMPLETED: "$survey_completed", PRODUCT_TOUR_ID: "$product_tour_id", SURVEY_LAST_SEEN_DATE: "$survey_last_seen_date", SURVEY_LANGUAGE: "$survey_language" }, fl = { Popover: "popover", Inline: "inline" };
function aa(t) {
  let e = !0;
  return { dispose() {
    if (e) {
      e = !1;
      const n = t();
      n && ut(n.then) && n.then(void 0, () => {
      });
    }
  } };
}
const k4 = { backgroundColor: "#ffffff", textColor: "#1d1f27", buttonColor: "#1d1f27", borderRadius: 8, buttonBorderRadius: 6, borderColor: "#e5e7eb", fontFamily: "system-ui", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)", showOverlay: !0, whiteLabel: !1, dismissOnClickOutside: !0, zIndex: 2147483646 }, Vw = { SHOWN: "product tour shown", DISMISSED: "product tour dismissed", COMPLETED: "product tour completed", STEP_SHOWN: "product tour step shown", STEP_COMPLETED: "product tour step completed", BUTTON_CLICKED: "product tour button clicked", STEP_SELECTOR_FAILED: "product tour step selector failed", BANNER_CONTAINER_SELECTOR_FAILED: "product tour banner container selector failed", BANNER_ACTION_CLICKED: "product tour banner action clicked" }, Td = { TOUR_ID: "$product_tour_id", TOUR_NAME: "$product_tour_name", TOUR_ITERATION: "$product_tour_iteration", TOUR_RENDER_REASON: "$product_tour_render_reason", TOUR_STEP_ID: "$product_tour_step_id", TOUR_STEP_ORDER: "$product_tour_step_order", TOUR_STEP_TYPE: "$product_tour_step_type", TOUR_DISMISS_REASON: "$product_tour_dismiss_reason", TOUR_BUTTON_TEXT: "$product_tour_button_text", TOUR_BUTTON_ACTION: "$product_tour_button_action", TOUR_BUTTON_LINK: "$product_tour_button_link", TOUR_BUTTON_TOUR_ID: "$product_tour_button_tour_id", TOUR_STEPS_COUNT: "$product_tour_steps_count", TOUR_STEP_SELECTOR: "$product_tour_step_selector", TOUR_STEP_SELECTOR_FOUND: "$product_tour_step_selector_found", TOUR_STEP_ELEMENT_TAG: "$product_tour_step_element_tag", TOUR_STEP_ELEMENT_ID: "$product_tour_step_element_id", TOUR_STEP_ELEMENT_CLASSES: "$product_tour_step_element_classes", TOUR_STEP_ELEMENT_TEXT: "$product_tour_step_element_text", TOUR_ERROR: "$product_tour_error", TOUR_MATCHES_COUNT: "$product_tour_matches_count", TOUR_FAILURE_PHASE: "$product_tour_failure_phase", TOUR_WAITED_FOR_ELEMENT: "$product_tour_waited_for_element", TOUR_WAIT_DURATION_MS: "$product_tour_wait_duration_ms", TOUR_BANNER_SELECTOR: "$product_tour_banner_selector", TOUR_LINKED_SURVEY_ID: "$product_tour_linked_survey_id", USE_MANUAL_SELECTOR: "$use_manual_selector", INFERENCE_DATA_PRESENT: "$inference_data_present", TOUR_LAST_SEEN_DATE: "$product_tour_last_seen_date", TOUR_TYPE: "$product_tour_type" }, _g = Ze("[RateLimiter]");
var x4 = class {
  constructor(t) {
    this.serverLimits = {}, this.lastEventRateLimited = !1, this.checkForLimiting = (e) => {
      const n = e.text;
      if (n && n.length) try {
        (JSON.parse(n).quota_limited || []).forEach((i) => {
          _g.info(`${i || "events"} is quota limited.`), this.serverLimits[i] = (/* @__PURE__ */ new Date()).getTime() + 6e4;
        });
      } catch (i) {
        return void _g.warn(`could not rate limit - continuing. Error: "${i?.message}"`, { text: n });
      }
    }, this.instance = t, this.lastEventRateLimited = this.clientRateLimitContext(!0).isRateLimited;
  }
  get captureEventsPerSecond() {
    var t;
    return ((t = this.instance.config.rate_limiting) === null || t === void 0 ? void 0 : t.events_per_second) || 10;
  }
  get captureEventsBurstLimit() {
    var t;
    return Math.max(((t = this.instance.config.rate_limiting) === null || t === void 0 ? void 0 : t.events_burst_limit) || 10 * this.captureEventsPerSecond, this.captureEventsPerSecond);
  }
  clientRateLimitContext(t = !1) {
    var e, n, i;
    const { captureEventsBurstLimit: r, captureEventsPerSecond: s } = this, o = (/* @__PURE__ */ new Date()).getTime(), a = (e = (n = this.instance.persistence) === null || n === void 0 ? void 0 : n.get_property("$capture_rate_limit")) !== null && e !== void 0 ? e : { tokens: r, last: o };
    a.tokens += (o - a.last) / 1e3 * s, a.last = o, a.tokens > r && (a.tokens = r);
    const l = 1 > a.tokens;
    if (l || t || (a.tokens = Math.max(0, a.tokens - 1)), l && !t) {
      const c = (Qe(a.dropped) ? a.dropped : 0) + 1;
      a.dropped = c, !this.lastEventRateLimited && this.Ka(c) && (a.dropped = 0);
    }
    return this.lastEventRateLimited = l, (i = this.instance.persistence) === null || i === void 0 || i.set_property("$capture_rate_limit", a), { isRateLimited: l, remainingTokens: a.tokens };
  }
  Xa(t) {
    const e = this.instance.config.property_denylist;
    return !de(e) || !e.includes(t);
  }
  Ya() {
    var t;
    if (this.Xa("$current_url") && this.Xa("$pathname") && Ke?.pathname) return `${(t = Ke.origin) !== null && t !== void 0 ? t : ""}${Ke.pathname}`;
  }
  Ka(t) {
    var e, n;
    const { captureEventsBurstLimit: i, captureEventsPerSecond: r } = this, s = this.Ya(), o = this.Xa("$session_id") ? (e = (n = this.instance).get_session_id) === null || e === void 0 ? void 0 : e.call(n) : void 0, a = [`${t} event(s) dropped since the last warning`, s ? `triggered on ${s}` : void 0, o ? `session ${o}` : void 0].filter(Boolean).join(", ");
    return !!this.instance.capture("$$client_ingestion_warning", { $$client_ingestion_warning_message: `posthog-js client rate limited: ${a}. Config is set to ${r} events per second and ${i} events burst limit.` }, { skip_client_rate_limiting: !0 });
  }
  isServerRateLimited(t) {
    const e = this.serverLimits[t || "events"] || !1;
    return e !== !1 && (/* @__PURE__ */ new Date()).getTime() < e;
  }
};
const Ji = Ze("[RemoteConfig]");
var jw = class {
  constructor(t) {
    this._instance = t;
  }
  get remoteConfig() {
    var t;
    return (t = le._POSTHOG_REMOTE_CONFIG) === null || t === void 0 || (t = t[this._instance.config.token]) === null || t === void 0 ? void 0 : t.config;
  }
  tl(t) {
    var e, n, i;
    !((e = le.__PosthogExtensions__) === null || e === void 0) && e.loadExternalDependency ? (n = le.__PosthogExtensions__) === null || n === void 0 || (i = n.loadExternalDependency) === null || i === void 0 || i.call(n, this._instance, "remote-config", () => t(this.remoteConfig)) : t();
  }
  el(t) {
    this._instance._send_request({ method: "GET", url: this._instance.requestRouter.endpointFor("assets", `/array/${this._instance.config.token}/config`), callback: t });
  }
  load() {
    try {
      if (this.remoteConfig) return Ji.info("Using preloaded remote config", this.remoteConfig), void this.il(this.remoteConfig);
      if (this._instance.nl()) return void Ji.warn("Remote config is disabled. Falling back to local config.");
      this.tl((t) => {
        if (!t) return Ji.info("No config found after loading remote JS config. Falling back to JSON."), void this.el((e) => {
          this.il(e.json, e);
        });
        this.il(t);
      });
    } catch (t) {
      Ji.error("Error loading remote config", t), this.il();
    }
  }
  il(t, e) {
    !t && e && (e.statusCode === 0 ? e.error || Ji.warn("Failed to fetch remote config from PostHog.") : Ji.error("Failed to fetch remote config from PostHog."));
    try {
      this._instance.il(t ? { ok: !0, config: t } : { ok: !1 });
    } catch (i) {
      Ji.error("Error applying remote config", i);
    }
    if (t?.hasFeatureFlags !== !1 && !this._instance.config.advanced_disable_feature_flags_on_first_load) try {
      var n;
      (n = this._instance.featureFlags) === null || n === void 0 || n.ensureFlagsLoaded();
    } catch (i) {
      Ji.error("Error loading feature flags", i);
    }
  }
};
const S4 = ["fatal", "error", "warning", "log", "info", "debug"];
var Kt = Uint8Array, Dt = Uint16Array, Qr = Uint32Array, mf = new Kt([0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0]), gf = new Kt([0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0]), wg = new Kt([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), zw = function(t, e) {
  for (var n = new Dt(31), i = 0; 31 > i; ++i) n[i] = e += 1 << t[i - 1];
  var r = new Qr(n[30]);
  for (i = 1; 30 > i; ++i) for (var s = n[i]; n[i + 1] > s; ++s) r[s] = s - n[i] << 5 | i;
  return [n, r];
}, Bw = zw(mf, 2), Cd = Bw[1];
Bw[0][28] = 258, Cd[258] = 28;
for (var kg = zw(gf, 0)[1], Hw = new Dt(32768), Xe = 0; 32768 > Xe; ++Xe) {
  var dr = (43690 & Xe) >>> 1 | (21845 & Xe) << 1;
  Hw[Xe] = ((65280 & (dr = (61680 & (dr = (52428 & dr) >>> 2 | (13107 & dr) << 2)) >>> 4 | (3855 & dr) << 4)) >>> 8 | (255 & dr) << 8) >>> 1;
}
var zs = function(t, e, n) {
  for (var i = t.length, r = 0, s = new Dt(e); i > r; ++r) ++s[t[r] - 1];
  var o, a = new Dt(e);
  for (r = 0; e > r; ++r) a[r] = a[r - 1] + s[r - 1] << 1;
  for (o = new Dt(i), r = 0; i > r; ++r) o[r] = Hw[a[t[r] - 1]++] >>> 15 - t[r];
  return o;
}, ir = new Kt(288);
for (Xe = 0; 144 > Xe; ++Xe) ir[Xe] = 8;
for (Xe = 144; 256 > Xe; ++Xe) ir[Xe] = 9;
for (Xe = 256; 280 > Xe; ++Xe) ir[Xe] = 7;
for (Xe = 280; 288 > Xe; ++Xe) ir[Xe] = 8;
var pl = new Kt(32);
for (Xe = 0; 32 > Xe; ++Xe) pl[Xe] = 5;
var P4 = zs(ir, 9), E4 = zs(pl, 5), Uw = function(t) {
  return (t / 8 | 0) + (7 & t && 1);
}, Ww = function(t, e, n) {
  (n == null || n > t.length) && (n = t.length);
  var i = new (t instanceof Dt ? Dt : t instanceof Qr ? Qr : Kt)(n - e);
  return i.set(t.subarray(e, n)), i;
}, $i = function(t, e, n) {
  var i = e / 8 | 0;
  t[i] |= n <<= 7 & e, t[i + 1] |= n >>> 8;
}, _s = function(t, e, n) {
  var i = e / 8 | 0;
  t[i] |= n <<= 7 & e, t[i + 1] |= n >>> 8, t[i + 2] |= n >>> 16;
}, Uc = function(t, e) {
  for (var n = [], i = 0; t.length > i; ++i) t[i] && n.push({ s: i, f: t[i] });
  var r = n.length, s = n.slice();
  if (!r) return [new Kt(0), 0];
  if (r == 1) {
    var o = new Kt(n[0].s + 1);
    return o[n[0].s] = 1, [o, 1];
  }
  n.sort(function(w, T) {
    return w.f - T.f;
  }), n.push({ s: -1, f: 25001 });
  var a = n[0], l = n[1], c = 0, u = 1, d = 2;
  for (n[0] = { s: -1, f: a.f + l.f, l: a, r: l }; u != r - 1; ) a = n[n[d].f > n[c].f ? c++ : d++], l = n[c != u && n[d].f > n[c].f ? c++ : d++], n[u++] = { s: -1, f: a.f + l.f, l: a, r: l };
  var h = s[0].s;
  for (i = 1; r > i; ++i) s[i].s > h && (h = s[i].s);
  var f = new Dt(h + 1), p = Ad(n[u - 1], f, 0);
  if (p > e) {
    i = 0;
    var v = 0, g = p - e, m = 1 << g;
    for (s.sort(function(w, T) {
      return f[T.s] - f[w.s] || w.f - T.f;
    }); r > i; ++i) {
      var y = s[i].s;
      if (e >= f[y]) break;
      v += m - (1 << p - f[y]), f[y] = e;
    }
    for (v >>>= g; v > 0; ) {
      var k = s[i].s;
      e > f[k] ? v -= 1 << e - f[k]++ - 1 : ++i;
    }
    for (; i >= 0 && v; --i) {
      var _ = s[i].s;
      f[_] == e && (--f[_], ++v);
    }
    p = e;
  }
  return [new Kt(f), p];
}, Ad = function(t, e, n) {
  return t.s == -1 ? Math.max(Ad(t.l, e, n + 1), Ad(t.r, e, n + 1)) : e[t.s] = n;
}, xg = function(t) {
  for (var e = t.length; e && !t[--e]; ) ;
  for (var n = new Dt(++e), i = 0, r = t[0], s = 1, o = function(l) {
    n[i++] = l;
  }, a = 1; e >= a; ++a) if (t[a] == r && a != e) ++s;
  else {
    if (!r && s > 2) {
      for (; s > 138; s -= 138) o(32754);
      s > 2 && (o(s > 10 ? s - 11 << 5 | 28690 : s - 3 << 5 | 12305), s = 0);
    } else if (s > 3) {
      for (o(r), --s; s > 6; s -= 6) o(8304);
      s > 2 && (o(s - 3 << 5 | 8208), s = 0);
    }
    for (; s--; ) o(r);
    s = 1, r = t[a];
  }
  return [n.subarray(0, i), e];
}, ws = function(t, e) {
  for (var n = 0, i = 0; e.length > i; ++i) n += t[i] * e[i];
  return n;
}, $d = function(t, e, n) {
  var i = n.length, r = Uw(e + 2);
  t[r] = 255 & i, t[r + 1] = i >>> 8, t[r + 2] = 255 ^ t[r], t[r + 3] = 255 ^ t[r + 1];
  for (var s = 0; i > s; ++s) t[r + s + 4] = n[s];
  return 8 * (r + 4 + i);
}, Sg = function(t, e, n, i, r, s, o, a, l, c, u) {
  $i(e, u++, n), ++r[256];
  for (var d = Uc(r, 15), h = d[0], f = d[1], p = Uc(s, 15), v = p[0], g = p[1], m = xg(h), y = m[0], k = m[1], _ = xg(v), w = _[0], T = _[1], E = new Dt(19), S = 0; y.length > S; ++S) E[31 & y[S]]++;
  for (S = 0; w.length > S; ++S) E[31 & w[S]]++;
  for (var P = Uc(E, 7), C = P[0], M = P[1], O = 19; O > 4 && !C[wg[O - 1]]; --O) ;
  var W, H, z, F, K = c + 5 << 3, B = ws(r, ir) + ws(s, pl) + o, $ = ws(r, h) + ws(s, v) + o + 14 + 3 * O + ws(E, C) + (2 * E[16] + 3 * E[17] + 7 * E[18]);
  if (B >= K && $ >= K) return $d(e, u, t.subarray(l, l + c));
  if ($i(e, u, 1 + (B > $)), u += 2, B > $) {
    W = zs(h, f), H = h, z = zs(v, g), F = v;
    var I = zs(C, M);
    for ($i(e, u, k - 257), $i(e, u + 5, T - 1), $i(e, u + 10, O - 4), u += 14, S = 0; O > S; ++S) $i(e, u + 3 * S, C[wg[S]]);
    u += 3 * O;
    for (var q = [y, w], J = 0; 2 > J; ++J) {
      var D = q[J];
      for (S = 0; D.length > S; ++S) $i(e, u, I[A = 31 & D[S]]), u += C[A], A > 15 && ($i(e, u, D[S] >>> 5 & 127), u += D[S] >>> 12);
    }
  } else W = P4, H = ir, z = E4, F = pl;
  for (S = 0; a > S; ++S) if (i[S] > 255) {
    var A;
    _s(e, u, W[257 + (A = i[S] >>> 18 & 31)]), u += H[A + 257], A > 7 && ($i(e, u, i[S] >>> 23 & 31), u += mf[A]);
    var N = 31 & i[S];
    _s(e, u, z[N]), u += F[N], N > 3 && (_s(e, u, i[S] >>> 5 & 8191), u += gf[N]);
  } else _s(e, u, W[i[S]]), u += H[i[S]];
  return _s(e, u, W[256]), u + H[256];
}, T4 = new Qr([65540, 131080, 131088, 131104, 262176, 1048704, 1048832, 2114560, 2117632]), C4 = (function() {
  for (var t = new Qr(256), e = 0; 256 > e; ++e) {
    for (var n = e, i = 9; --i; ) n = (1 & n && 3988292384) ^ n >>> 1;
    t[e] = n;
  }
  return t;
})(), Wc = function(t, e, n) {
  for (; n; ++e) t[e] = n, n >>>= 8;
};
function A4(t, e) {
  e === void 0 && (e = {});
  var n = /* @__PURE__ */ (function() {
    var d = 4294967295;
    return { p(h) {
      for (var f = d, p = 0; h.length > p; ++p) f = C4[255 & f ^ h[p]] ^ f >>> 8;
      d = f;
    }, d() {
      return 4294967295 ^ d;
    } };
  })(), i = t.length;
  n.p(t);
  var r, s, o, a, l, c = (a = 10 + ((r = e).filename && r.filename.length + 1 || 0), l = 8, (function(d, h, f, p, v, g) {
    var m = d.length, y = new Kt(p + m + 5 * (1 + Math.floor(m / 7e3)) + v), k = y.subarray(p, y.length - v), _ = 0;
    if (!h || 8 > m) for (var w = 0; m >= w; w += 65535) {
      var T = w + 65535;
      m > T ? _ = $d(k, _, d.subarray(w, T)) : (k[w] = g, _ = $d(k, _, d.subarray(w, m)));
    }
    else {
      for (var E = T4[h - 1], S = E >>> 13, P = 8191 & E, C = (1 << f) - 1, M = new Dt(32768), O = new Dt(C + 1), W = Math.ceil(f / 3), H = 2 * W, z = function(fe) {
        return (d[fe] ^ d[fe + 1] << W ^ d[fe + 2] << H) & C;
      }, F = new Qr(25e3), K = new Dt(288), B = new Dt(32), $ = 0, I = 0, q = (w = 0, 0), J = 0, D = 0; m > w; ++w) {
        var A = z(w), N = 32767 & w, X = O[A];
        if (M[N] = X, O[A] = N, w >= J) {
          var U = m - w;
          if (($ > 7e3 || q > 24576) && U > 423) {
            _ = Sg(d, k, 0, F, K, B, I, q, D, w - D, _), q = $ = I = 0, D = w;
            for (var j = 0; 286 > j; ++j) K[j] = 0;
            for (j = 0; 30 > j; ++j) B[j] = 0;
          }
          var ie = 2, oe = 0, Oe = P, $e = N - X & 32767;
          if (U > 2 && A == z(w - $e)) for (var Ae = Math.min(S, U) - 1, Bt = Math.min(32767, w), Yi = Math.min(258, U); Bt >= $e && --Oe && N != X; ) {
            if (d[w + ie] == d[w + ie - $e]) {
              for (var ht = 0; Yi > ht && d[w + ht] == d[w + ht - $e]; ++ht) ;
              if (ht > ie) {
                if (ie = ht, oe = $e, ht > Ae) break;
                var Jt = Math.min($e, ht - 2), Ht = 0;
                for (j = 0; Jt > j; ++j) {
                  var Rt = w - $e + j + 32768 & 32767, it = Rt - M[Rt] + 32768 & 32767;
                  it > Ht && (Ht = it, X = Rt);
                }
              }
            }
            $e += (N = X) - (X = M[N]) + 32768 & 32767;
          }
          if (oe) {
            F[q++] = 268435456 | Cd[ie] << 18 | kg[oe];
            var Ti = 31 & Cd[ie], Ci = 31 & kg[oe];
            I += mf[Ti] + gf[Ci], ++K[257 + Ti], ++B[Ci], J = w + ie, ++$;
          } else F[q++] = d[w], ++K[d[w]];
        }
      }
      _ = Sg(d, k, g, F, K, B, I, q, D, w - D, _);
    }
    return Ww(y, 0, p + Uw(_) + v);
  })(s = t, (o = e).level == null ? 6 : o.level, o.mem == null ? Math.ceil(1.5 * Math.max(8, Math.min(13, Math.log(s.length)))) : 12 + o.mem, a, l, !0)), u = c.length;
  return (function(d, h) {
    var f = h.filename;
    if (d[0] = 31, d[1] = 139, d[2] = 8, d[8] = 2 > h.level ? 4 : h.level == 9 ? 2 : 0, d[9] = 3, h.mtime != 0 && Wc(d, 4, Math.floor(new Date(h.mtime || Date.now()) / 1e3)), f) {
      d[3] = 8;
      for (var p = 0; f.length >= p; ++p) d[p + 10] = f.charCodeAt(p);
    }
  })(c, e), Wc(c, u - 8, n.d()), Wc(c, u - 4, i), c;
}
const $4 = !!Jh || !!Qs, qw = /* @__PURE__ */ new WeakMap(), Gw = "text/plain";
let qc = 0, Ma = !1;
const Kw = (t, e) => {
  const [n, i] = t.split("#"), [r, s] = n.split("?");
  if (!s) return t;
  const o = s.split("&").filter((a) => a.split("=")[0] !== e).join("&");
  return `${r}${o ? `?${o}` : ""}${i ? `#${i}` : ""}`;
}, Co = (t, e, n = !0) => {
  var i;
  const [r, s] = t.split("?"), o = R({}, e), a = (i = s?.split("&").map((c) => {
    var u;
    const [d, h] = c.split("="), f = n && (u = o[d]) !== null && u !== void 0 ? u : h;
    return delete o[d], `${d}=${f}`;
  })) !== null && i !== void 0 ? i : [], l = (function(c, u = "&") {
    let d, h;
    const f = [];
    return Fe(c, function(p, v) {
      G(p) || G(v) || v === "undefined" || (d = encodeURIComponent(((g) => g instanceof File)(p) ? p.name : p.toString()), h = encodeURIComponent(v), f[f.length] = h + "=" + d);
    }), f.join(u);
  })(o);
  return l && a.push(l), a.length > 0 ? `${r}?${a.join("&")}` : r;
}, Gc = (t) => {
  if (t.sl) return t.sl;
  const { data: e, compression: n } = t;
  if (!e) return;
  if (n === It.GZipJS) {
    const r = A4((function(s) {
      var o = s.length;
      if (typeof TextEncoder < "u") return new TextEncoder().encode(s);
      for (var a = new Kt(s.length + (s.length >>> 1)), l = 0, c = function(f) {
        a[l++] = f;
      }, u = 0; o > u; ++u) {
        if (l + 5 > a.length) {
          var d = new Kt(l + 8 + (o - u << 1));
          d.set(a), a = d;
        }
        var h = s.charCodeAt(u);
        128 > h ? c(h) : 2048 > h ? (c(192 | h >>> 6), c(128 | 63 & h)) : h > 55295 && 57344 > h ? (c(240 | (h = 65536 + (1047552 & h) | 1023 & s.charCodeAt(++u)) >>> 18), c(128 | h >>> 12 & 63), c(128 | h >>> 6 & 63), c(128 | 63 & h)) : (c(224 | h >>> 12), c(128 | h >>> 6 & 63), c(128 | 63 & h));
      }
      return Ww(a, 0, l);
    })(Cr(e)), { mtime: 0 });
    return { contentType: Gw, body: r.buffer.slice(r.byteOffset, r.byteOffset + r.byteLength), estimatedSize: r.byteLength };
  }
  if (n === It.Base64) {
    const r = (function(o) {
      return o && btoa(encodeURIComponent(o).replace(/%([0-9A-F]{2})/g, (a, l) => String.fromCharCode(parseInt(l, 16))));
    })(Cr(e)), s = ((o) => "data=" + encodeURIComponent(typeof o == "string" ? o : Cr(o)))(r);
    return { contentType: "application/x-www-form-urlencoded", body: s, estimatedSize: new Blob([s]).size };
  }
  const i = Cr(e);
  return { contentType: "application/json", body: i, estimatedSize: new Blob([i]).size };
}, Yw = (t) => {
  const e = () => t.transport === "sendBeacon" ? { url: Co(t.url, { compression: It.Base64 }), encodedBody: Gc(R(R({}, t), {}, { compression: It.Base64, sl: void 0 })) } : { url: Kw(t.url, "compression"), encodedBody: Gc(R(R({}, t), {}, { compression: void 0, sl: void 0 })) };
  let n;
  try {
    n = Gc(t);
  } catch (r) {
    if (Wm(t.compression, Jr(t.url, "compression"))) return ee.error("Failed to gzip request body, sending uncompressed payload", r), e();
    throw r;
  }
  return n && Wm(t.compression, Jr(t.url, "compression")) && !((i = n.body) instanceof ArrayBuffer ? dd(new Uint8Array(i)) : ArrayBuffer.isView(i) && dd(new Uint8Array(i.buffer, i.byteOffset, i.byteLength))) ? (Ma = !0, e()) : { url: t.url, encodedBody: n };
  var i;
}, Xw = (t) => {
  try {
    return Yw(t);
  } catch (n) {
    var e;
    return ee.error(n), void ((e = t.callback) === null || e === void 0 || e.call(t, { statusCode: 0, error: n }));
  }
}, R4 = (function() {
  var t = He(function* (e) {
    const n = yield (function(r) {
      return hd.apply(this, arguments);
    })(Cr(e.data), ot.DEBUG, { rethrow: !0 });
    if (!n) return e;
    const i = yield n.arrayBuffer();
    return R(R({}, e), {}, { sl: { contentType: Gw, body: i, estimatedSize: i.byteLength } });
  });
  return function(e) {
    return t.apply(this, arguments);
  };
})(), M4 = /Failed to fetch|NetworkError|Load failed/i, Jw = (t) => t?.name === "TypeError" && M4.test(t?.message || ""), Zw = (t) => {
  try {
    const e = (function(n, i = Date.now()) {
      if (typeof n != "string" || !n) return;
      const r = n.trim(), s = /^\d+\s*,/.test(r) ? r.slice(0, r.indexOf(",")).trim() : r;
      if (/^\d+$/.test(s)) {
        const l = 1e3 * Math.min(Number(s), 300);
        return l > 0 ? l : void 0;
      }
      if (!/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun)[a-z]*[ ,]/.test(s)) return;
      const o = /^\w{3} \w{3} /.test(s) ? s + " GMT" : s, a = Date.parse(o) - i;
      return Number.isFinite(a) && a > 0 ? Math.min(a, Ta) : void 0;
    })(t());
    return G(e) ? void 0 : Math.min(e, 3e4);
  } catch {
    return;
  }
}, Qw = (t) => {
  const e = Xw(t);
  if (!e) return;
  const n = new Jh();
  qw.set(n, !0);
  const { url: i, encodedBody: r } = e;
  n.open(t.method || "GET", i, !0);
  const { contentType: s, body: o } = r ?? {};
  Fe(t.headers, function(a, l) {
    n.setRequestHeader(l, a);
  }), s && n.setRequestHeader("Content-Type", s), t.timeout && (n.timeout = t.timeout), n.onreadystatechange = () => {
    if (n.readyState === 4) {
      var a;
      const l = { statusCode: n.status, text: n.responseText };
      if (n.status === 200) try {
        l.json = JSON.parse(n.responseText);
      } catch {
      }
      (a = t.callback) === null || a === void 0 || a.call(t, l, Zw(() => n.getResponseHeader("Retry-After")));
    }
  }, n.send(o);
}, ek = (t) => {
  const e = Xw(t);
  if (!e) return;
  const { url: n, encodedBody: i } = e, { contentType: r, body: s, estimatedSize: o } = i ?? {}, a = new Headers();
  Fe(t.headers, function(p, v) {
    a.append(v, p);
  }), r && a.append("Content-Type", r);
  let l = null, c = !1;
  if ($m) {
    const p = new $m();
    l = { signal: p.signal, timeout: setTimeout(() => {
      c = !0;
      try {
        p.abort(M_("AbortError", "PostHog request timed out" + ((v = t.timeout) ? ` after ${v}ms` : "")));
      } catch (g) {
        d(g);
      }
      var v;
    }, t.timeout) };
  }
  let u = !1;
  const d = (p) => {
    var v;
    u || (u = !0, c && p?.name === "AbortError" || Jw(p) ? ee.warn(p) : ee.error(p), (v = t.callback) === null || v === void 0 || v.call(t, { statusCode: 0, error: p }));
  };
  let h = 0;
  const f = () => {
    qc -= h, h = 0, l && clearTimeout(l.timeout);
  };
  try {
    const p = R({ method: t?.method || "GET", headers: a, referrerPolicy: "strict-origin", body: s, signal: l?.signal }, t.fetchOptions), v = o ?? (G(s) ? 0 : void 0);
    p.keepalive = p.method === "POST" && !t.rl && p.keepalive !== !1 && p.body === s && !G(v) && v >= 0 && 52428.8 > qc + v, p.keepalive && (h = v, qc += h), Qs(n, p).then((g) => g.text().then((m) => {
      var y;
      if (u) return;
      const k = { statusCode: g.status, text: m };
      if (g.status === 200) try {
        k.json = JSON.parse(m);
      } catch (_) {
        ee.error(_);
      }
      u = !0, f(), (y = t.callback) === null || y === void 0 || y.call(t, k, Zw(() => g.headers.get("Retry-After")));
    })).catch((g) => {
      f(), d(g);
    }).finally(f);
  } catch (p) {
    f(), d(p);
  }
}, Rd = (t) => {
  try {
    var e;
    const { url: n, encodedBody: i } = Yw(t), { contentType: r, body: s, estimatedSize: o } = i ?? {};
    if (!s) return;
    const a = s instanceof Blob ? s : new Blob([s], { type: r });
    if (dt.sendBeacon(n, a)) return;
    const l = de(t.data) ? t.data : (e = t.data) === null || e === void 0 ? void 0 : e.batch;
    if (de(l) && l.length > 1 && (o ?? 0) > 16384) {
      const c = Math.ceil(l.length / 2), u = (d) => de(t.data) ? d : R(R({}, t.data), {}, { batch: d });
      return Rd(R(R({}, t), {}, { data: u(l.slice(0, c)) })), void Rd(R(R({}, t), {}, { data: u(l.slice(c)) }));
    }
    ee.warn(`Beacon of ~${o ?? 0} bytes was rejected by the browser, falling back to ${Qs ? "fetch" : "XHR"}`), Qs ? ek(R(R({}, t), {}, { rl: !0 })) : Qw(t);
  } catch (n) {
    ee.warn("Beacon send failed", n);
  }
}, Pg = (t, e, n, i) => {
  const r = i === "query" ? e === "POST" ? "sent_at" : "_" : void 0;
  return Co(n === It.GZipJS ? Kw(t, "compression") : t, R(R({}, r ? { [r]: Date.now().toString() } : {}), n === It.GZipJS ? {} : { compression: n }));
}, O4 = (() => {
  const t = [];
  return Qs && t.push({ transport: "fetch", method: ek }), Jh && t.push({ transport: "XHR", method: Qw }), dt?.sendBeacon && t.push({ transport: "sendBeacon", method: Rd }), t;
})();
let tk = !$4 && Pt?.indexOf("MSIE") === -1 && Pt?.indexOf("Mozilla") === -1;
function ik(t, e, n) {
  var i, r, s;
  n && (e = R(R({}, e), {}, { callback: (o) => n(o) })), t.__loaded ? tk ? t.__request_queue.push(e) : t.rateLimiter.isServerRateLimited(e.batchKey) ? e.fireCallbackOnDrop && ((r = e.callback) === null || r === void 0 || r.call(e, { statusCode: 429 })) : (e.transport = e.transport || t.config.api_transport, e.headers = R(R({}, t.config.request_headers), e.headers), e.compression = e.compression === "best-available" ? (i = t.compression) !== null && i !== void 0 ? i : e.compressionFallback : e.compression, (G(t.config.disable_beacon) ? t.config.__preview_disable_beacon : t.config.disable_beacon) && (e.disableTransport = ["sendBeacon"]), e.fetchOptions = e.fetchOptions || t.config.fetch_options, ((o, a) => {
    var l, c, u;
    const d = R(R({}, o), {}, { callback: a ?? ((g) => {
      var m;
      return (m = o.callback) === null || m === void 0 ? void 0 : m.call(o, g);
    }) });
    d.timeout = d.timeout || 6e4;
    const h = (l = d.transport) !== null && l !== void 0 ? l : "fetch";
    h === "sendBeacon" && G(d.compression) && d.data && (d.compression = It.Base64), d.method === "POST" && d.data && (d.timestampMode === "capture-body" ? d.data = ((g) => {
      var m, y;
      const k = (de(g) ? g : [g]).map((w) => R(R({}, w), w.timestamp instanceof Date && !isNaN(w.timestamp.getTime()) ? { timestamp: w.timestamp.toISOString() } : {})), _ = k[0];
      return { api_key: (m = _ == null || (y = _.properties) === null || y === void 0 ? void 0 : y.token) !== null && m !== void 0 ? m : _?.token, batch: k, sent_at: (/* @__PURE__ */ new Date()).toISOString() };
    })(d.data) : d.timestampMode === "body" && (d.data = ((g, m = (/* @__PURE__ */ new Date()).toISOString()) => de(g) ? g.map((y) => R(R({}, y), {}, { sent_at: m })) : R(R({}, g), {}, { sent_at: m }))(d.data))), d.url = Pg(d.url, d.method, d.compression, d.timestampMode);
    const f = O4.filter((g) => !d.disableTransport || !g.transport || !d.disableTransport.includes(g.transport)), p = (c = (u = (function(g, m) {
      for (let y = 0; g.length > y; y++) if (m(g[y])) return g[y];
    })(f, (g) => g.transport === h)) === null || u === void 0 ? void 0 : u.method) !== null && c !== void 0 ? c : f[0].method;
    if (!p) throw new Error("No available transport method");
    const v = (g) => {
      try {
        p(g);
      } catch (y) {
        var m;
        Jw(y) ? ee.warn(y) : ee.error(y), (m = d.callback) === null || m === void 0 || m.call(d, { statusCode: 0, error: y });
      }
    };
    h !== "sendBeacon" && !d.preferSyncCompression && d.data && d.compression === It.GZipJS && c3 && typeof Promise < "u" && !Ma ? R4(d).then((g) => {
      v(g);
    }).catch((g) => {
      if (qm(g)) return Ma = !0, void v(R(R({}, d), {}, { compression: void 0, url: Pg(o.url, o.method, void 0, o.timestampMode) }));
      ((m) => {
        if (!m || typeof m != "object") return !1;
        const y = "name" in m ? String(m.name) : "";
        return qm(m) || y === V_;
      })(g) && (Ma = !0), v(d);
    }) : v(d);
  })(e, (o, a) => {
    var l, c, u;
    t.rateLimiter.checkForLimiting(o), 400 > o.statusCode || (l = (c = t.config).on_request_error) === null || l === void 0 || l.call(c, o), n ? n(o, a) : (u = e.callback) === null || u === void 0 || u.call(e, o);
  })) : e.fireCallbackOnDrop && ((s = e.callback) === null || s === void 0 || s.call(e, { statusCode: 0 }));
}
var I4 = class {
  constructor(t, e) {
    this.ol = !0, this.al = [], this.ll = yi(e?.flush_interval_ms || 3e3, 250, 5e3, ee.createLogger("flush interval"), 3e3), this.ul = t;
  }
  enqueue(t) {
    this.al.push(t), this.hl || this.cl();
  }
  unload() {
    this.dl();
    const t = this.al.length > 0 ? this.vl() : {}, e = Object.values(t);
    [...e.filter((n) => n.url.indexOf("/e") === 0), ...e.filter((n) => n.url.indexOf("/e") !== 0)].map((n) => {
      this.fl(n, "sendBeacon");
    });
  }
  enable() {
    this.ol = !1, this.cl();
  }
  cl() {
    this.ol || (this.hl = setTimeout(() => {
      if (this.dl(), this.al.length > 0) {
        const t = this.vl();
        for (const e in t) this.fl(t[e]);
      }
    }, this.ll));
  }
  fl(t, e) {
    try {
      this.ul(t, e);
    } catch (n) {
      ee.error(n);
    }
  }
  dl() {
    clearTimeout(this.hl), this.hl = void 0;
  }
  vl() {
    const t = {};
    return Fe(this.al, (e) => {
      var n;
      const i = e, r = ((i ? i.batchKey : null) || i.url) + (i.batchGroup ? `:${i.batchGroup}` : "");
      G(t[r]) && (t[r] = R(R({}, i), {}, { data: [] })), (n = t[r].data) === null || n === void 0 || n.push(i.data);
    }), this.al = [], t;
  }
};
const D4 = ["retriesPerformedSoFar"];
var F4 = class {
  constructor(t) {
    this._instance = t, this.pl = !1, this.gl = 3e3, this.al = [], this.al = [], this.ml = !0, this.resume();
  }
  resume() {
    if (!G(L) && "onLine" in L.navigator) {
      if (this.ml = L.navigator.onLine, this.yl) return;
      this.yl = () => {
        this.ml = !0, this.bl();
      }, this._l = () => {
        this.ml = !1;
      }, Ie(L, "online", this.yl), Ie(L, "offline", this._l);
    }
  }
  get length() {
    return this.al.length;
  }
  retriableRequest(t, e) {
    let { retriesPerformedSoFar: n } = t, i = j_(t, D4);
    Mi(n) && (i.url = Co(i.url, { retry_count: n })), ik(this._instance, e ? R(R({}, i), {}, { transport: e }) : i, (r, s) => {
      var o;
      if (r.statusCode !== 200 && (400 > r.statusCode || r.statusCode >= 500)) {
        if ((r.statusCode === 0 ? 3 : 10) > (n ?? 0)) return void this.Ls(R({ retriesPerformedSoFar: n }, i), s);
        r.statusCode === 0 && ee.warn(`Request failed before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped retrying after ${n ?? 0} retries.`);
      }
      (o = i.callback) === null || o === void 0 || o.call(i, r);
    });
  }
  Ls(t, e) {
    const n = t.retriesPerformedSoFar || 0;
    t.retriesPerformedSoFar = n + 1;
    const i = Math.max((function(o) {
      const a = 3e3 * Math.pow(2, o), l = a / 2, c = Math.min(18e5, a), u = (Math.random() - 0.5) * (c - l);
      return Math.ceil(c + u);
    })(n), e ?? 0), r = Date.now() + i;
    this.al.push({ retryAt: r, requestOptions: t });
    let s = `Enqueued failed request for retry in ${i}`;
    navigator.onLine || (s += " (Browser is offline)"), ee.warn(s), this.pl || (this.pl = !0, this.wl());
  }
  wl() {
    if (this.kl && clearTimeout(this.kl), this.al.length === 0) return this.pl = !1, void (this.kl = void 0);
    this.kl = setTimeout(() => {
      this.ml && this.al.length > 0 && this.bl(), this.wl();
    }, this.gl);
  }
  bl() {
    const t = Date.now(), e = [], n = this.al.filter((i) => t > i.retryAt || (e.push(i), !1));
    if (this.al = e, n.length > 0) for (const { requestOptions: i } of n) this.retriableRequest(i);
  }
  unload() {
    this.kl && (clearTimeout(this.kl), this.kl = void 0), this.pl = !1, G(L) || (this.yl && (L.removeEventListener("online", this.yl), this.yl = void 0), this._l && (L.removeEventListener("offline", this._l), this._l = void 0));
    for (const { requestOptions: t } of this.al) try {
      this._instance._send_request(R(R({}, t), {}, { transport: "sendBeacon" }));
    } catch (e) {
      ee.error(e);
    }
    this.al = [];
  }
}, L4 = class {
  constructor(t) {
    this._instance = t, this.Sl = () => {
      var e, n, i, r;
      this.xl || (this.xl = {});
      const s = this.scrollElement(), o = this.scrollY(), a = s ? Math.max(0, s.scrollHeight - s.clientHeight) : 0, l = o + (s?.clientHeight || 0), c = s?.scrollHeight || 0;
      this.xl.lastScrollY = Math.ceil(o), this.xl.maxScrollY = Math.max(o, (e = this.xl.maxScrollY) !== null && e !== void 0 ? e : 0), this.xl.maxScrollHeight = Math.max(a, (n = this.xl.maxScrollHeight) !== null && n !== void 0 ? n : 0), this.xl.lastContentY = l, this.xl.maxContentY = Math.max(l, (i = this.xl.maxContentY) !== null && i !== void 0 ? i : 0), this.xl.maxContentHeight = Math.max(c, (r = this.xl.maxContentHeight) !== null && r !== void 0 ? r : 0);
    };
  }
  get Cl() {
    return this._instance.config.scroll_root_selector;
  }
  getContext() {
    return this.xl;
  }
  resetContext() {
    const t = this.xl;
    return this.xl = void 0, setTimeout(this.Sl, 0), t;
  }
  startMeasuringScrollPosition() {
    Ie(L, "scroll", this.Sl, { capture: !0 }), Ie(L, "scrollend", this.Sl, { capture: !0 }), Ie(L, "resize", this.Sl);
  }
  scrollElement() {
    if (this.Cl) {
      const n = de(this.Cl) ? this.Cl : [this.Cl];
      for (const i of n) {
        var t;
        const r = L == null || (t = L.document) === null || t === void 0 ? void 0 : t.querySelector(i);
        if (r) return r;
      }
      return;
    }
    var e;
    return L == null || (e = L.document) === null || e === void 0 ? void 0 : e.documentElement;
  }
  $l(t) {
    var e, n;
    const i = t === "y" ? "scrollTop" : "scrollLeft";
    if (this.Cl) {
      const r = this.scrollElement();
      return r && r[i] || 0;
    }
    return L ? t === "y" ? L.scrollY || L.pageYOffset || ((e = L.document) === null || e === void 0 || (e = e.documentElement) === null || e === void 0 ? void 0 : e.scrollTop) || 0 : L.scrollX || L.pageXOffset || ((n = L.document) === null || n === void 0 || (n = n.documentElement) === null || n === void 0 ? void 0 : n.scrollLeft) || 0 : 0;
  }
  scrollY() {
    return this.$l("y");
  }
  scrollX() {
    return this.$l("x");
  }
};
const N4 = (t) => Dw(t?.config.mask_personal_data_properties, t?.config.custom_personal_data_properties, t?.config.disable_capture_url_hashes);
var Eg = class {
  constructor(t, e, n, i) {
    this.Be = (r) => {
      const s = this.Tl();
      if (s && s.sessionId === r) return;
      const o = { sessionId: r, props: this.Il(this._instance) };
      this.Ml.register({ [wd]: o });
    }, this._instance = t, this.El = e, this.Ml = n, this.Il = i || N4, this.El.onSessionId(this.Be);
  }
  Tl() {
    return this.Ml.props[wd];
  }
  getSetOnceProps() {
    var t;
    const e = (t = this.Tl()) === null || t === void 0 ? void 0 : t.props;
    return e ? "r" in e ? Fw(e, this._instance.config.disable_capture_url_hashes) : { $referring_domain: e.referringDomain, $pathname: e.initialPathName, utm_source: e.utm_source, utm_campaign: e.utm_campaign, utm_medium: e.utm_medium, utm_content: e.utm_content, utm_term: e.utm_term } : {};
  }
  getSessionProps() {
    const t = {};
    return Fe(uf(this.getSetOnceProps()), (e, n) => {
      n === "$current_url" && (n = "url"), t[`$session_entry_${sd(n)}`] = e;
    }), t;
  }
}, ml = class {
  on(t, e) {
    return this.Pl[t] || (this.Pl[t] = []), this.Pl[t].push(e), () => {
      this.Pl[t] = this.Pl[t].filter((n) => n !== e);
    };
  }
  emit(t, e) {
    for (const n of this.Pl[t] || []) n(e);
    for (const n of this.Pl["*"] || []) n(t, e);
  }
  constructor() {
    this.Pl = {};
  }
};
const hr = Ze("[SessionId]"), Tg = 864e5;
var Cg = class {
  on(t, e) {
    return this.Rl.on(t, e);
  }
  constructor(t, e, n) {
    var i;
    if (this.Al = null, this.Fl = null, this.Ol = [], this.Dl = void 0, this.Ll = !1, this.Rl = new ml(), this.Nl = (s, o) => !(!Mi(s) || !Mi(o)) && Math.abs(s - o) > this.sessionTimeoutMs, !t.persistence) throw new Error("SessionIdManager requires a PostHogPersistence instance");
    if (t.config.cookieless_mode === "always") throw new Error('SessionIdManager cannot be used with cookieless_mode="always"');
    this.Rr = t.config, this.Ml = t.persistence, this.He = void 0, this.Xt = void 0, this._sessionStartTimestamp = null, this.ql = void 0, this._sessionActivityTimestamp = null, this.jl = e || ri, this.Bl = n || ri;
    const r = this.Rr.persistence_name || this.Rr.token;
    if (this._sessionTimeoutMs = 1e3 * yi(this.Rr.session_idle_timeout_seconds || 1800, 60, 36e3, hr.createLogger("session_idle_timeout_seconds"), 1800), t.register({ $configured_session_timeout_ms: this._sessionTimeoutMs }), this.Hl(), this.zl = "ph_" + r + "_window_id", this.Ul = "ph_" + r + "_primary_window_exists", this.Wl()) {
      const s = je.Dt(this.zl), o = je.Dt(this.Ul);
      s && !o ? this.He = s : je.Lt(this.zl), je.At(this.Ul, !0);
    }
    !((i = this.Rr.bootstrap) === null || i === void 0) && i.sessionID && this.setBootstrapSessionId(this.Rr.bootstrap.sessionID), this.Vl();
  }
  get sessionTimeoutMs() {
    return this._sessionTimeoutMs;
  }
  onSessionId(t) {
    return G(this.Ol) && (this.Ol = []), this.Ol.push(t), this.Xt && t(this.Xt, this.He), () => {
      this.Ol = this.Ol.filter((e) => e !== t);
    };
  }
  Wl() {
    return this.Rr.persistence !== "memory" && !this.Ml.mi && je.Et();
  }
  Gl(t) {
    t !== this.He && (this.He = t, this.Wl() && je.At(this.zl, t));
  }
  Zl() {
    return this.He ? this.He : this.Wl() ? je.Dt(this.zl) : null;
  }
  Ql(t) {
    const e = this.Al;
    return !Ye(e) && !Ye(t) && 5e3 > Math.abs(t - e);
  }
  Jl(t, e, n) {
    const i = e !== this._sessionActivityTimestamp, r = !(t !== this.Xt || n !== this._sessionStartTimestamp);
    this._sessionStartTimestamp = n, this._sessionActivityTimestamp = e, this.Xt = t, r && !i || r && this.Ql(e) || (this.Al = e, this.Ml.register({ [Pr]: [e, t, n] }));
  }
  Kl() {
    var t;
    const e = (t = this.Rr) === null || t === void 0 ? void 0 : t.persistence_save_debounce_ms;
    return Mi(e) && e > 0;
  }
  Xl() {
    this.Kl() ? this.Ml.refreshKey(Pr) : (this.Ml.flush(), this.Ml.load());
  }
  Yl() {
    var t;
    if (Ye(this._sessionActivityTimestamp) || this._sessionActivityTimestamp === this.Al) return;
    this.Xl();
    const [, e, n] = this.tu();
    e === this.Xt && n === this._sessionStartTimestamp && (this.Al = this._sessionActivityTimestamp, this.Ml.register({ [Pr]: [this._sessionActivityTimestamp, (t = this.Xt) !== null && t !== void 0 ? t : null, this._sessionStartTimestamp] }), this.Ml.flush());
  }
  eu() {
    const [t] = this.tu(), e = Mi(t) ? t : 0, n = Mi(this._sessionActivityTimestamp) ? this._sessionActivityTimestamp : 0;
    return Math.max(e, n);
  }
  iu(t) {
    return this.Xl(), this.Nl(t, this.eu());
  }
  tu() {
    const t = this.Ml.props[Pr];
    return de(t) && t.length === 2 && t.push(t[0]), t || [0, null, 0];
  }
  resetSessionId() {
    this.Al = null, this.ql = void 0, clearTimeout(this.nu), this.nu = void 0, this.Jl(null, null, null);
  }
  setBootstrapSessionId(t, e = !1) {
    const n = ((i, r = (/* @__PURE__ */ new Date()).getTime()) => {
      try {
        const s = ((o) => {
          const a = o.replace(/-/g, "");
          if (a.length !== 32) throw new Error("Not a valid UUID");
          if (a[12] !== "7") throw new Error("Not a UUIDv7");
          return parseInt(a.substring(0, 12), 16);
        })(i);
        return s > r + 6e4 ? void hr.error("Bootstrap sessionID cannot be in the future") : s;
      } catch (s) {
        return void hr.error("Invalid sessionID in bootstrap", s);
      }
    })(t);
    return !G(n) && (e ? this.ql = { sessionId: t, sessionStartTimestamp: n } : this.Jl(t, (/* @__PURE__ */ new Date()).getTime(), n), !0);
  }
  destroy() {
    this.Ll = !0, this.Yl(), clearTimeout(this.nu), this.nu = void 0, this.Dl && L && (L.removeEventListener(cl, this.Dl, { capture: !1 }), this.Dl = void 0), this.Ol = [];
  }
  Vl() {
    this.Dl = () => {
      this.Yl(), this.Wl() && je.Lt(this.Ul);
    }, Ie(L, cl, this.Dl, { capture: !1 });
  }
  checkAndGetSessionAndWindowId(t = !1, e = null, n = !1) {
    if (this.Rr.cookieless_mode === "always") throw new Error('checkAndGetSessionAndWindowId should not be called with cookieless_mode="always"');
    const i = e || (/* @__PURE__ */ new Date()).getTime(), r = this.Xt;
    if (n) this.Fl = i;
    else if (Ye(this.Fl) || this.Fl > i || i - this.Fl >= 1e3) {
      var s, o;
      (s = (o = this.Ml).syncCookieProperties) === null || s === void 0 || s.call(o), this.Fl = i;
    }
    let [, a, l] = this.tu();
    const c = !G(r) && a !== r, u = this.eu();
    let d = this.Zl();
    const h = this.ql, f = !!h && (h.sessionStartTimestamp > i + 6e4 || i - h.sessionStartTimestamp > Tg), p = h ? f : Mi(l) && Math.abs(i - l) > Tg;
    let v = !1, g = c, m = !a || !!h;
    const y = a;
    let k = !m && !t && this.Nl(i, u);
    if (k && (k = this.iu(i), k || hr.info("cross-tab refresh kept the session alive", { sessionId: a }), [, a, l] = this.tu(), k || (m = !a || !!h)), m || k || p) {
      g = !1;
      const E = h && !f;
      a = E ? h.sessionId : this.jl(), d = this.Bl(), hr.info("new session ID assigned", { sessionId: a, windowId: d, bootstrapped: !!E, changeReason: { noSessionId: m, activityTimeout: k, sessionPastMaximumLength: p } }), l = E ? h.sessionStartTimestamp : i, this.ql = void 0, v = !0;
    } else d || (d = this.Bl(), v = !0), g = g || a !== y, g && (hr.info("adopted cross-tab session id", { sessionId: a, windowId: d }), v = !0);
    const _ = Mi(u) && t && !p ? u : i, w = Mi(l) ? l : (/* @__PURE__ */ new Date()).getTime();
    this.Gl(d), this.Jl(a, _, w), t || this.Hl();
    const T = { noSessionId: m, activityTimeout: k, sessionPastMaximumLength: p, crossTabAdoption: g };
    return v && this.Ol.forEach((E) => E(a, d, T)), { sessionId: a, windowId: d, sessionStartTimestamp: w, changeReason: v ? T : void 0, lastActivityTimestamp: u };
  }
  Hl() {
    this.Ll || (clearTimeout(this.nu), this.nu = setTimeout(() => {
      if (!this.Ll) if (this.iu((/* @__PURE__ */ new Date()).getTime())) {
        const t = this.Xt;
        this.resetSessionId(), this.Rl.emit("forcedIdleReset", { idleSessionId: t });
      } else this.Hl();
    }, 1.1 * this.sessionTimeoutMs));
  }
};
const nk = function(t, e) {
  if (!t) return !1;
  const n = t.userAgent;
  if (n && Mm(n, e)) return !0;
  try {
    const i = t?.userAgentData;
    if (i?.brands && i.brands.some((r) => Mm(r?.brand, e))) return !0;
  } catch {
  }
  return !!t.webdriver;
};
function rk() {
  return (rk = He(function* () {
    const t = dt?.userAgentData;
    if (t?.getHighEntropyValues) try {
      const e = yield t.getHighEntropyValues(["model"]), n = e?.model;
      return Pe(n) && n.length > 0 ? n : void 0;
    } catch (e) {
      return void ee.info("Unable to resolve $device_model from userAgentData.getHighEntropyValues", e);
    }
  })).apply(this, arguments);
}
function V4(t, e) {
  let n = `$survey_${e}/${t.id}`;
  return t.current_iteration && t.current_iteration > 0 && (n = `$survey_${e}/${t.id}/${t.current_iteration}`), n;
}
function sk(t) {
  var e;
  return !!(!((e = t.conditions) === null || e === void 0 || (e = e.events) === null || e === void 0 || (e = e.values) === null || e === void 0) && e.length);
}
const gl = (t, e) => {
  if (!((n) => {
    try {
      new RegExp(n);
    } catch {
      return !1;
    }
    return !0;
  })(e)) return !1;
  try {
    return new RegExp(e).test(t);
  } catch {
    return !1;
  }
}, la = (t) => t.toLowerCase(), ok = { exact: (t, e) => e.some((n) => t.some((i) => n === i)), is_not: (t, e) => e.every((n) => t.every((i) => n !== i)), regex: (t, e) => e.some((n) => t.some((i) => gl(n, i))), not_regex: (t, e) => e.every((n) => t.every((i) => !gl(n, i))), icontains: (t, e) => e.map(la).some((n) => t.map(la).some((i) => n.includes(i))), not_icontains: (t, e) => e.map(la).every((n) => t.map(la).every((i) => !n.includes(i))), gt: (t, e) => e.some((n) => {
  const i = parseFloat(n);
  return !isNaN(i) && t.some((r) => i > parseFloat(r));
}), lt: (t, e) => e.some((n) => {
  const i = parseFloat(n);
  return !isNaN(i) && t.some((r) => i < parseFloat(r));
}) };
function ak(t, e) {
  return !t || Object.entries(t).every(([n, i]) => {
    const r = e?.[n];
    if (r == null) return !1;
    const s = ok[i.operator];
    return !!s && s(i.values.map(String), [String(r)]);
  });
}
function Kc(t, e, n) {
  return Cr({ distinct_id: t, userPropertiesToSet: e, userPropertiesToSetOnce: n });
}
const Md = "custom", Ag = "i.posthog.com", j4 = /^\/static\//, z4 = ["/s/", "/e/", "/i/"];
var B4 = class {
  constructor(t) {
    this.su = {}, this.instance = t;
  }
  get apiHost() {
    const t = this.instance.config.api_host.trim().replace(/\/$/, "");
    return t === "https://app.posthog.com" ? "https://us.i.posthog.com" : t;
  }
  get flagsApiHost() {
    const t = this.instance.config.flags_api_host;
    return t ? t.trim().replace(/\/$/, "") : this.apiHost;
  }
  get uiHost() {
    var t;
    let e = (t = this.instance.config.ui_host) === null || t === void 0 ? void 0 : t.replace(/\/$/, "");
    return e || (e = this.apiHost.replace(`.${Ag}`, ".posthog.com")), e === "https://app.posthog.com" ? "https://us.posthog.com" : e;
  }
  get region() {
    return this.su[this.apiHost] || (this.su[this.apiHost] = /https:\/\/(app|us|us-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "us" : /https:\/\/(eu|eu-assets)(\.i)?\.posthog\.com/i.test(this.apiHost) ? "eu" : Md), this.su[this.apiHost];
  }
  ru(t) {
    if (!j4.test(t)) return;
    const e = this.instance.config.asset_host;
    return typeof e == "string" && e.trim().replace(/\/$/, "") || void 0;
  }
  ou(t) {
    const e = Wi(t);
    return e ? e.protocol + "//" + e.host + e.pathname : void 0;
  }
  au(t, e, n) {
    if (t === "ui") return n;
    let i = n;
    const r = this.instance.config.rewriteRequestPath;
    if (r) {
      var s;
      const o = ((s = Wi(n)) === null || s === void 0 ? void 0 : s.href) || n;
      i = r(new URL(o)).toString();
    }
    if (r && t === "api" && z4.some((o) => e.indexOf(o) === 0)) {
      const o = this.ou(i);
      if (o) {
        const a = this.apiHost;
        let l = this.lu;
        l?.apiHost === a && l.rewriteRequestPath === r || (l = { apiHost: a, rewriteRequestPath: r, urls: /* @__PURE__ */ new Set() }, this.lu = l), l.urls.add(o);
      }
    }
    return i;
  }
  isIngestionEndpoint(t) {
    const e = this.lu, n = this.ou(t);
    return e?.apiHost === this.apiHost && e.rewriteRequestPath === this.instance.config.rewriteRequestPath && !!n && e.urls.has(n);
  }
  endpointFor(t, e = "") {
    if (e && (e = e[0] === "/" ? e : `/${e}`), t === "ui") return this.au(t, e, this.uiHost + e);
    if (t === "flags") return this.au(t, e, this.flagsApiHost + e);
    if (t === "assets") {
      const i = this.ru(e);
      if (i) return this.au(t, e, `${i}${e}`);
    }
    if (this.region === Md) return this.au(t, e, this.apiHost + e);
    const n = Ag + e;
    switch (t) {
      case "assets":
        return this.au(t, e, `https://${this.region}-assets.${n}`);
      case "api":
        return this.au(t, e, `https://${this.region}.${n}`);
    }
  }
};
const De = Ze("[Surveys]"), lk = (t) => {
  try {
    const e = ((n) => ((i, r) => `seenSurvey_${(function(s) {
      return s.current_iteration && s.current_iteration > 0 ? `${s.id}_${s.current_iteration}` : s.id;
    })(r)}`)(0, n))(t);
    if (localStorage.getItem(e)) return;
    localStorage.setItem(e, "true");
  } catch (e) {
    De.error("Failed to persist survey seen state", e);
  }
}, H4 = [$a.Popover, $a.Widget, $a.API], U4 = { ignoreConditions: !1, ignoreDelay: !1, displayType: fl.Popover }, W4 = Ze("[PostHog ExternalIntegrations]"), q4 = { intercom: "intercom-integration", crispChat: "crisp-chat-integration" };
var G4 = class {
  constructor(t) {
    this._instance = t;
  }
  zo(t, e) {
    var n, i;
    (n = le.__PosthogExtensions__) === null || n === void 0 || (i = n.loadExternalDependency) === null || i === void 0 || i.call(n, this._instance, t, (r) => {
      if (r) return W4.error("failed to load script", r);
      e();
    });
  }
  startIfEnabledOrStop() {
    var t;
    for (const [r, s] of Object.entries((t = this._instance.config.integrations) !== null && t !== void 0 ? t : {})) {
      var e, n, i;
      s && !(!((e = le.__PosthogExtensions__) === null || e === void 0 || (e = e.integrations) === null || e === void 0) && e[r]) && this.zo(q4[r], () => {
        var o;
        (o = le.__PosthogExtensions__) === null || o === void 0 || (o = o.integrations) === null || o === void 0 || (o = o[r]) === null || o === void 0 || o.start(this._instance);
      }), !s && (!((n = le.__PosthogExtensions__) === null || n === void 0 || (n = n.integrations) === null || n === void 0) && n[r]) && ((i = le.__PosthogExtensions__) === null || i === void 0 || (i = i.integrations) === null || i === void 0 || (i = i[r]) === null || i === void 0 || i.stop());
    }
  }
}, K4 = class {
  constructor(t, e) {
    this.$ = t, this.wo = e, this.uu = /* @__PURE__ */ new Map(), this.Io = !1;
  }
  add(t) {
    var e = this;
    return He(function* () {
      if (e.Io) throw new Error("Cannot add an extension to a disposed ExtensionRuntime");
      if (e.uu.has(t.name)) throw new Error(`Browser extension "${t.name}" is already registered`);
      e.uu.set(t.name, t);
      try {
        const n = t.setup(e.wo);
        n && (yield n);
      } catch (n) {
        const i = e.uu.get(t.name) === t;
        i && e.uu.delete(t.name), e.$.error(`Failed to set up browser extension "${t.name}"`, n), i && e.hu(t);
      }
    })();
  }
  getExtension(t) {
    return this.uu.get(t);
  }
  dispose() {
    if (this.Io) return;
    this.Io = !0;
    const t = Array.from(this.uu.values()).reverse();
    this.uu.clear();
    for (const e of t) this.hu(e);
  }
  hu(t) {
    try {
      var e;
      const n = (e = t.dispose) === null || e === void 0 ? void 0 : e.call(t);
      n && ut(n.then) && n.then(void 0, (i) => {
        this.$.error(`Failed to dispose browser extension "${t.name}"`, i);
      });
    } catch (n) {
      this.$.error(`Failed to dispose browser extension "${t.name}"`, n);
    }
  }
}, Y4 = class {
  constructor(t) {
    this._instance = t;
  }
  initialize() {
  }
  get(t) {
    const e = this._instance.persistence;
    if (typeof t == "string") return e?.get_property(t);
    const n = {};
    for (const i of t) {
      const r = e?.get_property(i);
      G(r) || (n[i] = r);
    }
    return n;
  }
  set(t, e) {
    var n;
    (n = this._instance.persistence) === null || n === void 0 || n.register(typeof t == "string" ? { [t]: e } : t);
  }
  remove(t) {
    var e;
    (e = this._instance.persistence) === null || e === void 0 || e.unregister(t);
  }
};
const $g = "extensionsRemoteConfig";
var X4 = class {
  constructor(t) {
    this.instance = t, this.Io = !1, this.$ = ee, this.cu = t.du, this.kv = new Y4(t), this.onEvent = (e) => aa(this.instance.on("eventCaptured", (n) => {
      try {
        e({ event: n.event, properties: n.properties });
      } catch (i) {
        this.$.error("Browser extension event listener failed", i);
      }
    })), this.onRemoteConfig = (e) => {
      if (this.Io) return aa(() => {
      });
      const n = (r) => {
        try {
          e(r);
        } catch (s) {
          this.$.error("Browser extension remote config listener failed", s);
        }
      }, i = this.instance.vu.on($g, n);
      return this.cu && n(this.cu), aa(i);
    }, this.fu = new K4(ee.createLogger("[BrowserExtensions]"), this);
  }
  get logger() {
    return this.$;
  }
  get distinctId() {
    return this.instance.get_distinct_id();
  }
  get anonymousId() {
    var t;
    return (t = this.instance.get_property("$device_id")) !== null && t !== void 0 ? t : this.distinctId;
  }
  get deviceId() {
    const t = this.instance.get_property(rf);
    return typeof t == "string" ? t : void 0;
  }
  get library() {
    return { name: ot.LIB_NAME, version: ot.LIB_VERSION };
  }
  get initialPersonProperties() {
    var t, e;
    return (t = (e = this.instance.persistence) === null || e === void 0 ? void 0 : e.get_initial_props()) !== null && t !== void 0 ? t : {};
  }
  get groups() {
    return this.instance.getGroups();
  }
  get session() {
    try {
      var t, e, n, i;
      const r = (t = this.instance.sessionManager) === null || t === void 0 ? void 0 : t.checkAndGetSessionAndWindowId(!0);
      return { sessionId: (e = r?.sessionId) !== null && e !== void 0 ? e : "", windowId: (n = r?.windowId) !== null && n !== void 0 ? n : "", sessionStartTimestamp: (i = r?.sessionStartTimestamp) !== null && i !== void 0 ? i : 0 };
    } catch {
      return { sessionId: "", windowId: "", sessionStartTimestamp: 0 };
    }
  }
  get canCapture() {
    return this.instance.is_capturing();
  }
  get projectToken() {
    return this.instance.config.token;
  }
  add(t) {
    return this.fu.add(t);
  }
  getExtension(t) {
    return this.fu.getExtension(t);
  }
  capture(t, e, n) {
    n ? this.instance.capture(t, e, { timestamp: n.timestamp, uuid: n.uuid, $set: n.set, $set_once: n.setOnce }) : this.instance.capture(t, e);
  }
  registerDynamicEventProperties(t) {
    return aa(this.instance.pu(t));
  }
  handleRemoteConfig(t) {
    this.Io || (this.cu = t, this.instance.vu.emit($g, t));
  }
  sendRequest(t) {
    var e = this;
    return He(function* (n, i = {}) {
      var r;
      const s = e.instance.requestRouter.endpointFor((r = i.target) !== null && r !== void 0 ? r : "api", n), o = { method: i.method, url: i.query ? Co(s, i.query) : s, data: i.body, headers: i.headers, timeout: i.timeoutMs, fireCallbackOnDrop: !0, transport: i.transport, compression: i.compression, compressionFallback: i.target === "flags" && i.compression === "best-available" ? rd.Base64 : void 0, timestampMode: i.sentAt };
      return i.transport === "sendBeacon" ? (e.instance._send_request(o), { statusCode: 202 }) : new Promise((a) => {
        o.callback = a, e.instance._send_request(o);
      });
    }).apply(this, arguments);
  }
  dispose() {
    this.Io || (this.Io = !0, this.fu.dispose());
  }
};
const Bs = {};
let Yc = 0;
const Hs = () => {
}, Rg = 'Consent opt in/out is not valid with cookieless_mode="always" and will be ignored', ks = "Surveys module not available", Mg = "sanitize_properties is deprecated. Use before_send instead", ck = "Invalid value for property_denylist config: ", J4 = /^[A-Za-z0-9_-]{1,400}$/, Og = /^fb\.[0-9]+\.[0-9]+\.[A-Za-z0-9_-]+(?:\.[A-Za-z0-9_-]+)?$/, Ig = /^fb\.[0-9]+\.[0-9]+\.[0-9]+$/, Z4 = ["token", "distinct_id", lw], As = "posthog", Q4 = (t) => {
  const e = {};
  return t && t !== "unset" && ("2025-11-30" > t || (e.strictMinimumDuration = !0), "2026-05-30" > t || (e.canvasCapture = { resolutionScale: 0.6 }), "2026-06-25" > t || (e.streamNetworkBody = !0), "2026-08-30" > t || (e.captureJsonLd = !0)), e;
}, Xc = (t) => {
  var e;
  return R({ api_host: "https://us.i.posthog.com", flags_api_host: null, ui_host: null, asset_host: null, token: "", autocapture: !0, cross_subdomain_cookie: WI(Y?.location), persistence: "localStorage+cookie", persistence_name: "", cookie_persisted_properties: [], loaded: Hs, save_campaign_params: !0, custom_campaign_params: [], custom_blocked_useragents: [], save_referrer: !0, capture_pageleave: "if_capture_pageview", defaults: t ?? "unset", __preview_deferred_init_extensions: !1, __preview_external_dependency_versioned_paths: !1, __preview_cookie_wins_on_conflict: !1, debug: Ke && Pe(Ke?.search) && Ke.search.indexOf("__posthog_debug=true") !== -1 || !1, cookie_expiration: 365, upgrade: !1, disable_session_recording: !1, disable_persistence: !1, disable_web_experiments: !0, disable_surveys: !1, disable_surveys_automatic_display: !1, disable_conversations: !1, disable_product_tours: !1, disableDeviceModel: !1, reuseAnonymousId: !1, disable_external_dependency_loading: !1, strict_script_versioning: "fallback", enable_recording_console_log: void 0, secure_cookie: (L == null || (e = L.location) === null || e === void 0 ? void 0 : e.protocol) === "https:", ip: !1, opt_out_capturing_by_default: !1, opt_out_persistence_by_default: !1, opt_out_useragent_filter: !1, opt_out_capturing_persistence_type: "localStorage", consent_persistence_name: null, opt_out_capturing_cookie_prefix: null, opt_in_site_apps: !1, property_denylist: [], respect_dnt: !1, sanitize_properties: null, request_headers: {}, request_batching: !0, properties_string_max_length: 65535, mask_all_element_attributes: !1, mask_all_text: !1, mask_personal_data_properties: !1, custom_personal_data_properties: [], advanced_disable_flags: !1, advanced_disable_decide: !1, advanced_disable_feature_flags: !1, advanced_disable_feature_flags_on_first_load: !1, advanced_only_evaluate_survey_feature_flags: !1, advanced_feature_flags_dedup_per_session: !1, advanced_enable_surveys: !1, advanced_disable_toolbar_metrics: !1, feature_flag_request_timeout_ms: 3e3, feature_flag_request_max_retries: 1, surveys_request_timeout_ms: 1e4, on_request_error(n) {
    ee.error("Bad HTTP status: " + n.statusCode + " " + n.text);
  }, get_device_id: (n) => n, capture_performance: void 0, name: "posthog", bootstrap: {}, disable_compression: !1, session_idle_timeout_seconds: 1800, person_profiles: fw, before_send: void 0, get_current_url: void 0, request_queue_config: { flush_interval_ms: 3e3 }, error_tracking: {}, _onCapture: Hs }, ((n) => ({ rageclick: n && n >= "2026-05-30" ? { content_ignorelist: QI, ignore_text_selection: !0 } : !n || "2025-11-30" > n || { content_ignorelist: !0 }, capture_pageview: !n || "2025-05-24" > n || "history_change", session_recording: Q4(n), external_scripts_inject_target: n && n >= "2026-01-30" ? "head" : "body", internal_or_test_user_hostname: n && n >= "2026-01-30" ? /^(localhost|127\.0\.0\.1)$/ : void 0, persistence_save_debounce_ms: n && n >= "2026-05-30" ? 250 : 0, split_storage: !(!n || "2026-05-30" > n), detect_google_search_app: !(!n || "2026-05-30" > n), disable_capture_url_hashes: !(!n || "2026-06-25" > n), cookieWinsOnConflict: !(!n || n === "unset" || "2026-08-29" > n) }))(t));
}, eD = [["process_person", "person_profiles"], ["xhr_headers", "request_headers"], ["cookie_name", "persistence_name"], ["disable_cookie", "disable_persistence"], ["__preview_disable_beacon", "disable_beacon"], ["store_google", "save_campaign_params"], ["verbose", "debug"], ["__preview_cookie_wins_on_conflict", "cookieWinsOnConflict"]], Dg = (t) => {
  const e = {};
  for (const [r, s] of eD) G(t[r]) || (e[s] = t[r]);
  const n = ze({}, e, t), i = t.__preview_external_dependency_versioned_paths;
  return G(i) || (G(t.strict_script_versioning) && (n.strict_script_versioning = !!i), Pe(i) && G(t.asset_host) && (n.asset_host = i)), de(t.property_blacklist) && (G(t.property_denylist) ? n.property_denylist = t.property_blacklist : de(t.property_denylist) ? n.property_denylist = [...t.property_blacklist, ...t.property_denylist] : ee.error(ck + t.property_denylist)), n;
};
var tD = class {
  constructor() {
    this.__forceAllowLocalhost = !1;
  }
  get gu() {
    return this.__forceAllowLocalhost;
  }
  set gu(t) {
    ee.error("WebPerformanceObserver is deprecated and has no impact on network capture. Use `_forceAllowLocalhostNetworkCapture` on `posthog.sessionRecording`"), this.__forceAllowLocalhost = t;
  }
}, zr = class Zi {
  mu(e) {
    if (!e) return;
    const n = this.uu.indexOf(e);
    n !== -1 && this.uu.splice(n, 1);
  }
  yu(e, n) {
    var i;
    return this.mu(e), this.uu.push(n), (i = n.initialize) === null || i === void 0 || i.call(n), n;
  }
  bu() {
    return this.config.cookieless_mode === "always" || this.config.cookieless_mode === "on_reject" && this.consent.isRejected();
  }
  _u() {
    if (this.wu || this.config.reuseAnonymousId || this.config.segment || this.bu()) return;
    const e = this.config.persistence === "memory" || this.config.persistence === "sessionStorage";
    if (!e && !this.config.disable_persistence || this.ku) return;
    let n, i, r;
    e ? (n = `persistence is set to '${this.config.persistence}'`, i = this.config.persistence === "memory" ? "on every page load" : "for every new browser tab or window", r = "Either set persistence to 'localStorage+cookie', keep this persistence and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId.") : (n = "persistence is disabled (disable_persistence is true)", i = "on every page load", r = "Either set disable_persistence to false, keep persistence disabled and pass a stable ID through bootstrap.distinctID, or enable reuseAnonymousId."), this.wu = !0, console.warn("[PostHog.js]", `${n} but no bootstrap.distinctID was provided. PostHog will mint a new distinct ID ${i}, so calling identify() merges a new ID onto the person each time. A person can then pass the distinct-ID limit and its events stop appearing on person pages and the session tab. ${r}`);
  }
  Su() {
    if (this.bu() || this.get_distinct_id() !== "$posthog_cookieless") return;
    const e = this.persistence;
    if (!e) return;
    this.xu() || e.load(!0);
    const n = this.get_distinct_id();
    if (!n || n === "$posthog_cookieless") {
      const i = this.config.get_device_id(ri());
      this.register({ distinct_id: i, $device_id: i }), e.set_property(Et, Ni);
    }
    this.Cu();
  }
  get decideEndpointWasHit() {
    var e, n;
    return (e = (n = this.featureFlags) === null || n === void 0 ? void 0 : n.hasLoadedFlags) !== null && e !== void 0 && e;
  }
  get flagsEndpointWasHit() {
    var e, n;
    return (e = (n = this.featureFlags) === null || n === void 0 ? void 0 : n.hasLoadedFlags) !== null && e !== void 0 && e;
  }
  constructor() {
    var e;
    this.$u = !1, this.Tu = !1, this.webPerformance = new tD(), this.Iu = !1, this.version = ot.LIB_VERSION, this.Mu = /* @__PURE__ */ new Set(), this.Eu = "", this.vu = new ml(), this.uu = [], this.Pu = [], this.ku = !1, this.wu = !1, this._calculate_event_properties = this.calculateEventProperties.bind(this), this.config = Xc(), this.SentryIntegration = a4, this.sentryIntegration = (i) => (function(r, s) {
      const o = Tw(r, s);
      return { name: Ew, processEvent: (a) => o(a) };
    })(this, i), this.__request_queue = [], this.__loaded = !1, this.analyticsDefaultEndpoint = "/e/", this.Ru = !1, this.Au = null, this.Fu = null, this.Ou = null, this.scrollManager = new L4(this), this.pageViewManager = new vg(this), this.rateLimiter = new x4(this), this.requestRouter = new B4(this), this.consent = new ZI(this), this.externalIntegrations = new G4(this);
    const n = (e = Zi.__defaultExtensionClasses) !== null && e !== void 0 ? e : {};
    this.featureFlags = n.featureFlags && new n.featureFlags(this), this.toolbar = n.toolbar && new n.toolbar(this), this.surveys = n.surveys && new n.surveys(this), this.conversations = n.conversations && new n.conversations(this), this.logs = n.logs && new n.logs(this), this.metrics = n.metrics && new n.metrics(this), this.experiments = n.experiments && new n.experiments(this), this.exceptions = n.exceptions && new n.exceptions(this), this.people = { set: (i, r, s) => {
      const o = Pe(i) ? { [i]: r } : i;
      this.setPersonProperties(o), s?.({});
    }, set_once: (i, r, s) => {
      const o = Pe(i) ? { [i]: r } : i;
      this.setPersonProperties(void 0, o), s?.({});
    } }, this.on("eventCaptured", (i) => ee.info(`send "${i?.event}"`, i));
  }
  init(e, n, i) {
    if (i && i !== As) {
      var r;
      const s = (r = Bs[i]) !== null && r !== void 0 ? r : new Zi();
      return s._init(e, n, i), Bs[i] = s, Bs[As][i] = s, s;
    }
    return this._init(e, n, i);
  }
  _init(e, n = {}, i) {
    var r, s, o;
    const a = Pe(e) ? e.trim() : "";
    if (!a) return ee.critical("PostHog was initialized without a token. This likely indicates a misconfiguration. Please check the first argument passed to posthog.init()"), this;
    var l;
    if (this.__loaded) return a !== ((l = this.config) === null || l === void 0 ? void 0 : l.token) ? console.warn("[PostHog.js]", `You have already initialized PostHog with a different project token! Re-initializing is a no-op, so events will keep going to the project this instance was initialized with. To capture into a second project, load PostHog once, then initialize a named instance after the SDK has loaded, e.g. posthog.init('${a}', { ... }, 'project2')`) : console.warn("[PostHog.js]", "You have already initialized PostHog! Re-initializing is a no-op"), this;
    this.__loaded = !0, this.config = Xc(n.defaults), n.debug = this.Du(n.debug), this.Lu = n, this.Nu = [], n.person_profiles ? this.Fu = n.person_profiles : n.process_person && (this.Fu = n.process_person);
    const c = Xc(n.defaults), u = Dg(n), d = ze({}, c, u, { name: i, token: a });
    Ee(c.rageclick) && Ee(u.rageclick) && (d.rageclick = ze({}, c.rageclick, u.rageclick)), Ee(c.session_recording) && Ee(u.session_recording) && (d.session_recording = ze({}, c.session_recording, u.session_recording)), this.set_config(d), this.config.on_xhr_error && ee.error("on_xhr_error is deprecated. Use on_request_error instead"), this.compression = n.disable_compression ? void 0 : It.GZipJS;
    const h = this.xu();
    if (this.persistence = new Hc(this.config, h), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Hc(R(R({}, this.config), {}, { persistence: "sessionStorage" }), h, !1), this.Eu = "ph_" + (this.config.persistence_name || this.config.token) + "_session_registered_properties", this.config.persistence !== "memory" && !h && je.Et()) {
      const m = je.Dt(this.Eu);
      de(m) && m.forEach((y) => {
        Pe(y) && this.Mu.add(y);
      });
    } else je.Lt(this.Eu);
    const f = R({}, this.persistence.props), p = R({}, this.sessionPersistence.props);
    this.register({ $initialization_time: (/* @__PURE__ */ new Date()).toISOString() }), this.qu = new I4((m, y) => this.ju(m, y), this.config.request_queue_config), this.Bu = new F4(this), this.__request_queue = [];
    const v = this.bu();
    v || (this.sessionManager = new Cg(this), this.sessionPropsManager = new Eg(this, this.sessionManager, this.persistence), this.sessionManager.onSessionId((m, y, k) => {
      (k?.activityTimeout || k?.sessionPastMaximumLength || k?.crossTabAdoption) && this.Hu();
    })), this.zu(), this.config.__preview_deferred_init_extensions ? (ee.info("Deferring extension initialization to improve startup performance"), setTimeout(() => {
      this.Uu(v);
    }, 0)) : (ee.info("Initializing extensions synchronously"), this.Uu(v)), ot.DEBUG = ot.DEBUG || this.config.debug, ot.DEBUG && ee.info("Starting in debug mode", { this: this, config: n, thisC: R({}, this.config), p: f, s: p }), this.config.identity_distinct_id && !(!((r = n.bootstrap) === null || r === void 0) && r.distinctID) && (n.bootstrap = R(R({}, n.bootstrap), {}, { distinctID: this.config.identity_distinct_id, isIdentifiedID: !0 }));
    const g = (s = n.bootstrap) === null || s === void 0 ? void 0 : s.distinctID;
    if (this.ku = !!g && !Os(g), (o = n.bootstrap) === null || o === void 0 ? void 0 : o.distinctID) {
      const m = n.bootstrap.distinctID, y = this.get_distinct_id(), k = this.persistence.get_property(Et);
      if (n.bootstrap.isIdentifiedID && y != null && y !== m && k === "anonymous") this.identify(m);
      else if (n.bootstrap.isIdentifiedID && y != null && y !== m && k === "identified") ee.warn("Bootstrap distinctID differs from an already-identified user. The existing identity is preserved. Call reset() before reinitializing if you intend to switch users.");
      else {
        const _ = this.config.get_device_id(ri()), w = n.bootstrap.isIdentifiedID ? _ : m;
        this.persistence.set_property(Et, n.bootstrap.isIdentifiedID ? Ca : Ni), this.register({ distinct_id: m, $device_id: w });
      }
    }
    if (v) this.register_once({ distinct_id: Dc, $device_id: null }, "");
    else if (!this.get_distinct_id()) {
      const m = this.config.get_device_id(ri());
      this.register_once({ distinct_id: m, $device_id: m }, ""), this.persistence.set_property(Et, Ni);
    }
    return Ie(L, "onpagehide" in self ? "pagehide" : "unload", this._handle_unload.bind(this), { passive: !1 }), Ie(L, "pageshow", () => {
      var m;
      this.$u = !1, this.Tu || (m = this.Bu) === null || m === void 0 || m.resume();
    }), n.segment ? gg(this, () => this.Wu()) : this.Wu(), ut(this.config._onCapture) && this.config._onCapture !== Hs && (ee.warn("onCapture is deprecated. Please use `before_send` instead"), this.on("eventCaptured", (m) => this.config._onCapture(m.event, m))), this.config.ip && ee.warn('The `ip` config option has NO EFFECT AT ALL and has been deprecated. Use a custom transformation or "Discard IP data" project setting instead. See https://posthog.com/tutorials/web-redact-properties#hiding-customer-ip-address for more information.'), this.config.disableDeviceModel || (function() {
      return rk.apply(this, arguments);
    })().then((m) => {
      m && this.register({ [Ic]: m });
    }).catch(Hs), this;
  }
  Vu(e) {
    const n = e;
    return Pe(n.name) && ut(n.setup);
  }
  Gu(e, n) {
    this.Vu(e) ? n.push(() => {
      this.Zu().add(e).catch(() => {
        var i;
        return (i = e.dispose) === null || i === void 0 ? void 0 : i.call(e);
      }).catch((i) => {
        ee.error(`Failed to dispose browser extension "${e.name}"`, i);
      });
    }) : this.uu.push(e);
  }
  zu() {
    var e, n, i;
    const r = (e = (n = this.config.__extensionClasses) === null || n === void 0 ? void 0 : n.featureFlags) !== null && e !== void 0 ? e : (i = Zi.__defaultExtensionClasses) === null || i === void 0 ? void 0 : i.featureFlags;
    var s, o, a;
    r && (this.featureFlags && this.featureFlags instanceof r || ((s = this.Qu) === null || s === void 0 || s.call(this), this.Qu = void 0, this.featureFlags = new r(this)), ut(this.featureFlags.onReloading) && ut(this.featureFlags.setup) ? this.Qu || (this.Qu = this.featureFlags.onReloading(() => {
      this.vu.emit("featureFlagsReloading", !0);
    }), this.Zu().add(this.featureFlags)) : (o = (a = this.featureFlags).initialize) === null || o === void 0 || o.call(a));
  }
  Uu(e) {
    const n = performance.now(), i = R(R({}, Zi.__defaultExtensionClasses), this.config.__extensionClasses), r = [];
    var s, o, a, l, c, u, d;
    i.exceptions && this.uu.push(this.exceptions = (s = this.exceptions) !== null && s !== void 0 ? s : new i.exceptions(this)), i.historyAutocapture && this.uu.push(this.historyAutocapture = new i.historyAutocapture(this)), i.tracingHeaders && this.uu.push(this.tracingHeaders = new i.tracingHeaders(this)), i.siteApps && this.uu.push(this.siteApps = new i.siteApps(this)), i.sessionRecording && !e && this.uu.push(this.sessionRecording = new i.sessionRecording(this)), this.config.disable_scroll_properties || r.push(() => {
      this.scrollManager.startMeasuringScrollPosition();
    }), i.autocapture && this.Gu(this.autocapture = new i.autocapture(this), r), i.surveys && this.Gu(this.surveys = (o = this.surveys) !== null && o !== void 0 ? o : new i.surveys(this), r), i.logs && this.Gu(this.logs = (a = this.logs) !== null && a !== void 0 ? a : new i.logs(this), r), i.metrics && this.uu.push(this.metrics = (l = this.metrics) !== null && l !== void 0 ? l : new i.metrics(this)), i.conversations && this.uu.push(this.conversations = (c = this.conversations) !== null && c !== void 0 ? c : new i.conversations(this)), i.productTours && this.uu.push(this.productTours = new i.productTours(this)), i.heatmaps && this.uu.push(this.heatmaps = new i.heatmaps(this)), i.webVitalsAutocapture && this.uu.push(this.webVitalsAutocapture = new i.webVitalsAutocapture(this)), i.exceptionObserver && this.uu.push(this.exceptionObserver = new i.exceptionObserver(this)), i.deadClicksAutocapture && this.uu.push(this.deadClicksAutocapture = new i.deadClicksAutocapture(this, o4)), i.toolbar && this.uu.push(this.toolbar = (u = this.toolbar) !== null && u !== void 0 ? u : new i.toolbar(this)), i.experiments && this.uu.push(this.experiments = (d = this.experiments) !== null && d !== void 0 ? d : new i.experiments(this)), this.uu.forEach((h) => {
      h.initialize && r.push(() => {
        var f;
        (f = h.initialize) === null || f === void 0 || f.call(h);
      });
    }), r.push(() => {
      if (this.Ju) {
        const h = this.Ju;
        this.Ju = void 0, this.uu.forEach((f) => {
          var p;
          return (p = f.onRemoteConfig) === null || p === void 0 ? void 0 : p.call(f, h);
        });
      }
    }), this.Ku(r, n);
  }
  Ku(e, n) {
    for (; e.length > 0; ) {
      if (this.config.__preview_deferred_init_extensions && performance.now() - n >= 30 && e.length > 0) return void setTimeout(() => {
        this.Ku(e, n);
      }, 0);
      const r = e.shift();
      if (r) try {
        r();
      } catch (s) {
        ee.error("Error initializing extension:", s);
      }
    }
    const i = Math.round(performance.now() - n);
    this.register_for_session({ [cw]: this.config.__preview_deferred_init_extensions ? "deferred" : "synchronous", [uw]: i }), this.config.__preview_deferred_init_extensions && ee.info(`PostHog extensions initialized (${i}ms)`);
  }
  il(e) {
    var n;
    if (!Y || !Y.body) return ee.info("document not ready yet, trying again in 500 milliseconds..."), void setTimeout(() => {
      this.il(e);
    }, 500);
    if (this.config.__preview_deferred_init_extensions && (this.Ju = e), this.du = e, this.compression = void 0, e.ok) {
      var i;
      const r = e.config;
      r.supportedCompression && !this.config.disable_compression && (this.compression = pe(r.supportedCompression, It.GZipJS) ? It.GZipJS : pe(r.supportedCompression, It.Base64) ? It.Base64 : void 0), !((i = r.analytics) === null || i === void 0) && i.endpoint && (this.analyticsDefaultEndpoint = r.analytics.endpoint);
    }
    this.set_config({ person_profiles: this.Fu ? this.Fu : fw }), (n = this.Xu) === null || n === void 0 || n.handleRemoteConfig(e), this.uu.forEach((r) => {
      var s;
      return (s = r.onRemoteConfig) === null || s === void 0 ? void 0 : s.call(r, e);
    });
  }
  Wu() {
    try {
      this.config.loaded(this);
    } catch (e) {
      ee.critical("`loaded` function failed", e);
    }
    if (this.Yu(), this.config.internal_or_test_user_hostname && Ke?.hostname) {
      const e = Ke.hostname, n = this.config.internal_or_test_user_hostname;
      (typeof n == "string" ? e === n : n.test(e)) && this.setInternalOrTestUser();
    }
    this.config.capture_pageview && setTimeout(() => {
      (this.consent.isOptedIn() || this.bu()) && this.th();
    }, 1), this.eh = new jw(this), this.eh.load();
  }
  Yu() {
    var e;
    this.is_capturing() && this.config.request_batching && ((e = this.qu) === null || e === void 0 || e.enable());
  }
  _dom_loaded() {
    this.is_capturing() && Tr(this.__request_queue, (e) => this.ju(e)), this.__request_queue = [], this.Yu();
  }
  _handle_unload() {
    var e, n, i, r, s, o;
    this.$u = !0, (e = this.surveys) === null || e === void 0 || (n = e.handlePageUnload) === null || n === void 0 || n.call(e), (i = this.metrics) === null || i === void 0 || i.flush("sendBeacon"), this.config.request_batching ? (this.ih() && this.capture(eg), (r = this.logs) === null || r === void 0 || r.flushLogs("sendBeacon"), (s = this.qu) === null || s === void 0 || s.unload(), (o = this.Bu) === null || o === void 0 || o.unload()) : this.ih() && this.capture(eg, null, { transport: "sendBeacon" });
  }
  _send_request(e) {
    ik(this, e);
  }
  ju(e, n) {
    this.Bu ? this.Bu.retriableRequest(e, n) : this._send_request(n ? R(R({}, e), {}, { transport: n }) : e);
  }
  _execute_array(e) {
    Yc++;
    try {
      let n;
      const i = [], r = [], s = [];
      Tr(e, (a) => {
        if (a) if (n = a[0], de(n)) s.push(a);
        else if (ut(a)) try {
          a.call(this);
        } catch (l) {
          ee.error("Error executing queued PostHog call", a, l);
        }
        else de(a) && n === "alias" ? i.push(a) : de(a) && n.indexOf("capture") !== -1 && ut(this[n]) ? s.push(a) : r.push(a);
      });
      const o = function(a, l) {
        Tr(a, function(c) {
          try {
            if (de(c[0])) {
              let u = l;
              Fe(c, function(d) {
                u = u[d[0]].apply(u, d.slice(1));
              });
            } else l[c[0]].apply(l, c.slice(1));
          } catch (u) {
            ee.error("Error executing queued PostHog call", c, u);
          }
        });
      };
      o(i, this), o(r, this), o(s, this);
    } finally {
      Yc--;
    }
  }
  push(e) {
    if (Yc > 0 && de(e) && Pe(e[0])) {
      const n = Zi.prototype[e[0]];
      return void (ut(n) && n.apply(this, e.slice(1)));
    }
    this._execute_array([e]);
  }
  get nh() {
    return { property: Zm, persistenceKey: Vr, cookieName: "_fbc", pattern: Og, register: (e, n) => {
      var i;
      return (i = this.persistence) === null || i === void 0 ? void 0 : i.register({ [Vr]: { value: e, delivered: n } });
    }, unregister: () => {
      var e;
      return (e = this.persistence) === null || e === void 0 ? void 0 : e.unregister(Vr);
    } };
  }
  get sh() {
    return { property: Qm, persistenceKey: Ds, cookieName: "_fbp", pattern: Ig, register: (e, n) => {
      var i;
      return (i = this.persistence) === null || i === void 0 ? void 0 : i.register({ [Ds]: { value: e, delivered: n } });
    }, unregister: () => {
      var e;
      return (e = this.persistence) === null || e === void 0 ? void 0 : e.unregister(Ds);
    } };
  }
  rh(e) {
    var n;
    const i = (n = this.persistence) === null || n === void 0 ? void 0 : n.get_property(e.persistenceKey);
    return Pe(i) && e.pattern.test(i) ? { value: i, delivered: !1 } : Ee(i) && Pe(i.value) && e.pattern.test(i.value) ? { value: i.value, delivered: i.delivered === !0 } : void 0;
  }
  oh(e, n, i) {
    return n === i?.value ? { value: n, pending: !i.delivered } : (e.register(n, !1), { value: n, pending: !0 });
  }
  ah(e) {
    if (!this.config.save_campaign_params || this.bu()) return;
    const n = Ns(e.cookieName);
    return Pe(n) && e.pattern.test(n) ? n : void 0;
  }
  uh(e, n, i, r) {
    if (!this.persistence) return;
    const s = this.nh;
    this.persistence.refreshKey(s.persistenceKey);
    const o = this.rh(s);
    if (r) return void s.unregister();
    if (i) return Pe(n) && Og.test(n) ? this.oh(s, n, o) : void s.unregister();
    const a = Pe(e) && J4.test(e) ? e : void 0, l = this.ah(s);
    return l && ((c, u, d) => {
      const h = c.split(".");
      if (u) return h[3] === u;
      if (!d) return !0;
      const f = d.value.split(".");
      return h[3] === f[3] || Number(h[2]) > Number(f[2]);
    })(l, a, o) ? this.oh(s, l, o) : a ? o?.value.split(".")[3] === a ? { value: o.value, pending: !o.delivered } : this.oh(s, `fb.1.${Date.now()}.${a}`, o) : o ? { value: o.value, pending: !o.delivered } : void 0;
  }
  hh(e, n, i) {
    if (!this.persistence) return;
    const r = this.sh;
    this.persistence.refreshKey(r.persistenceKey);
    const s = this.rh(r);
    if (i) return void r.unregister();
    if (n) return Pe(e) && Ig.test(e) ? this.oh(r, e, s) : void r.unregister();
    const o = this.ah(r);
    return o ? this.oh(r, o, s) : s ? { value: s.value, pending: !s.delivered } : void 0;
  }
  dh(e, n) {
    if (!this.persistence) return;
    this.persistence.refreshKey(e.persistenceKey);
    const i = this.rh(e);
    i?.value !== n || i.delivered || e.register(n, !0);
  }
  capture(e, n, i) {
    var r, s;
    if (!(this.__loaded && this.persistence && this.sessionPersistence && this.qu)) return void ee.uninitializedWarning("posthog.capture");
    if (!this.is_capturing()) return;
    if (G(e) || !Pe(e)) return void ee.error("No event name provided to posthog.capture");
    this.Su();
    const o = !this.config.opt_out_useragent_filter && this._is_bot();
    if (o && !this.config.__preview_capture_bot_pageviews) return;
    const a = i?.skip_client_rate_limiting ? void 0 : this.rateLimiter.clientRateLimitContext();
    if (a?.isRateLimited) return void ee.critical("This capture call is ignored due to client rate limiting.");
    let l;
    n?.$current_url && !Pe(n?.$current_url) && (ee.error("Invalid `$current_url` property provided to `posthog.capture`. Input must be a string. Ignoring provided value."), n == null || delete n.$current_url), e !== "$exception" || i?.fh || ee.warn("Using `posthog.capture('$exception')` is unreliable because it does not attach required metadata. Use `posthog.captureException(error)` instead, which attaches required metadata automatically."), this.sessionPersistence.update_search_keyword(), this.config.save_campaign_params && (l = this.sessionPersistence.update_campaign_params()), this.config.save_referrer && this.sessionPersistence.update_referrer_info(), (this.config.save_campaign_params || this.config.save_referrer) && this.persistence.set_initial_person_info();
    const c = /* @__PURE__ */ new Date(), u = i?.timestamp || c, d = Fm(i?.uuid, ri);
    let h = { uuid: d, event: e, properties: this.calculateEventProperties(e, n || {}, u, d) };
    e === "$pageview" && this.config.__preview_capture_bot_pageviews && o && (h.event = "$bot_pageview", h.properties.$browser_type = "bot"), a && (h.properties.$lib_rate_limit_remaining_tokens = a.remainingTokens);
    const f = e === "$feature_flag_called" && h.properties.$feature_flag_has_experiment === !1 && this.get_property("$minimal_flag_called_events") === !0;
    i?.$set && !f && (h.$set = i?.$set);
    const p = Ee(n?.$set) ? n.$set : void 0, v = de(n?.$unset) ? n.$unset : [], g = i?.$unset || [], m = (H) => {
      var z;
      const F = !!i?.$set && H in i.$set;
      return { hasProvided: F || !!p && H in p, provided: F ? i == null || (z = i.$set) === null || z === void 0 ? void 0 : z[H] : p?.[H], unset: v.indexOf(H) !== -1 || g.indexOf(H) !== -1 };
    }, y = m(Zm), k = m(Qm), _ = [{ channel: this.nh, hasProvided: y.hasProvided, update: this.uh(l?.fbclid, y.provided, y.hasProvided, y.unset) }, { channel: this.sh, hasProvided: k.hasProvided, update: this.hh(k.provided, k.hasProvided, k.unset) }];
    for (const { channel: H, hasProvided: z, update: F } of _) F && h.properties.$process_person_profile === !0 && F.pending && !z && !f && (h.$set = R({ [H.property]: F.value }, h.$set));
    const w = i?.$unset;
    w && (h.$unset = w);
    const T = f ? void 0 : this.ph(i?.$set_once, e !== tg, e === pw);
    if (T && (h.$set_once = T), i?._noTruncate || (E = this.config.properties_string_max_length, h = (function(H, z) {
      const F = /* @__PURE__ */ new Set();
      return (function K(B, $) {
        if (B !== Object(B)) return z ? z(B) : B;
        if (F.has(B)) return;
        let I;
        if (F.add(B), de(B)) I = [], Tr(B, (q) => {
          I.push(K(q));
        });
        else {
          const q = {};
          Fe(as(B) ? mw(B) : B, (J, D) => {
            F.has(J) || (q[D] = K(J));
          }), I = q;
        }
        return I;
      })(H);
    })(h, (H) => Pe(H) ? H.slice(0, E) : H)), h.timestamp = u, G(i?.timestamp) || (h.properties.$event_time_override_provided = !0, h.properties.$event_time_override_system_time = c), f && (h.properties = ((H, z = []) => {
      const F = {}, K = (B) => {
        H[B] !== void 0 && (F[B] = H[B]);
      };
      return rI.forEach(K), z.forEach(K), F;
    })(h.properties, Z4)), e === gi.DISMISSED || e === gi.SENT) {
      const H = n?.[Ra.SURVEY_ID], z = n?.[Ra.SURVEY_ITERATION];
      lk({ id: H, current_iteration: z }), h.$set = R(R({}, h.$set), {}, { [V4({ id: H, current_iteration: z }, e === gi.SENT ? "responded" : "dismissed")]: !0 });
    } else e === gi.SHOWN && (h.$set = R(R({}, h.$set), {}, { [Ra.SURVEY_LAST_SEEN_DATE]: (/* @__PURE__ */ new Date()).toISOString() }));
    var E;
    if (e === Vw.SHOWN) {
      const H = n?.[Td.TOUR_TYPE];
      H && (h.$set = R(R({}, h.$set), {}, { [`${Td.TOUR_LAST_SEEN_DATE}/${H}`]: (/* @__PURE__ */ new Date()).toISOString() }));
    }
    const S = R(R({}, h.properties.$set), h.$set);
    if (Ot(S) || this.setPersonPropertiesForFlags(S), !ve(this.config.before_send)) {
      const H = this.Os(h);
      if (!H) return;
      h = H, h.uuid = Fm(h.uuid, ri);
    }
    const P = _.filter(({ channel: H, update: z }) => {
      var F, K, B;
      const $ = (F = (K = h.$set) === null || K === void 0 ? void 0 : K[H.property]) !== null && F !== void 0 ? F : Ee((B = h.properties) === null || B === void 0 ? void 0 : B.$set) ? h.properties.$set[H.property] : void 0;
      return z?.pending && $ === z.value;
    });
    this.vu.emit("eventCaptured", h);
    const C = (r = i?._url) !== null && r !== void 0 ? r : this.requestRouter.endpointFor("api", this.analyticsDefaultEndpoint), M = i?._batchKey === "recordings" || /\/s\/(?:\?|$)/.test(C), O = R(R(R({ method: "POST", url: C, data: h, compression: "best-available", preferSyncCompression: i?.send_instantly, timestampMode: M ? "body" : "capture-body", batchKey: i?._batchKey }, M && (!((s = h.properties) === null || s === void 0) && s.$session_id) ? { batchGroup: h.properties.$session_id + (h.properties.$window_id ? `-${h.properties.$window_id}` : "") } : {}), i?.transport ? { transport: i.transport } : {}), P.length ? { fireCallbackOnDrop: !0, callback: (H) => {
      if (H.statusCode >= 200 && 300 > H.statusCode) for (const { channel: z, update: F } of P) this.dh(z, F.value);
    } } : {});
    if (!this.config.request_batching || i && !i?._batchKey || i?.send_instantly || P.length) {
      var W;
      let H;
      !O.transport && !O.callback && Ot((W = this.config.request_headers) !== null && W !== void 0 ? W : {}) && this.$u && (H = "sendBeacon"), this.ju(O, H);
    } else this.qu.enqueue(O);
    return h;
  }
  _addCaptureHook(e) {
    return this.on("eventCaptured", (n) => e(n.event, n));
  }
  getExtension(e) {
    var n;
    return (n = this.Xu) === null || n === void 0 ? void 0 : n.getExtension(e);
  }
  Zu() {
    var e;
    return (e = this.Xu) !== null && e !== void 0 ? e : this.Xu = new X4(this);
  }
  pu(e) {
    this.Pu.push(e);
    let n = !0;
    return () => {
      if (!n) return;
      n = !1;
      const i = this.Pu.indexOf(e);
      i !== -1 && this.Pu.splice(i, 1);
    };
  }
  gh(e = !0) {
    var n, i, r;
    return !!(!((n = this.persistence) === null || n === void 0) && n.consumeCookieIdentityChange()) && (this.Ou = null, this.persistence.get_property("$user_state") === "anonymous" && ((r = this.sessionPersistence) === null || r === void 0 || r.clear(), this.Mu.clear(), this.mh()), (i = this.featureFlags) === null || i === void 0 || i.reset(), e && this.reloadFeatureFlags(), !0);
  }
  calculateEventProperties(e, n, i, r, s) {
    if (i = i || /* @__PURE__ */ new Date(), !this.persistence || !this.sessionPersistence) return n;
    this.persistence.syncCookieProperties(), this.gh();
    const o = s ? void 0 : this.persistence.remove_event_timer(e);
    let a = R({}, n);
    if (a.token = this.config.token, a.$config_defaults = this.config.defaults, this.bu() && (a[lw] = !0), e === "$snapshot") {
      const y = R(R({}, this.persistence.properties()), this.sessionPersistence.properties());
      return a.distinct_id = y.distinct_id, (!Pe(a.distinct_id) && !Qe(a.distinct_id) || Os(a.distinct_id)) && ee.error("Invalid distinct_id for replay event. This indicates a bug in your implementation"), a;
    }
    const l = (function(y, k, _, w = !1) {
      var T, E, S, P;
      if (!Pt) return {};
      const C = y ? [...Zr, ...k || []] : [], [M, O] = C_(Pt), [W, H] = (function(A) {
        for (let N = 0; Dm.length > N; N++) {
          const [X, U, j] = Dm[N], ie = A.match(X);
          if (ie) {
            const oe = j && A.match(j) || ie;
            return [U, oe?.[1] || ""];
          }
        }
        return ["", ""];
      })(Pt), z = (function() {
        const A = "u" > typeof navigator ? navigator : void 0;
        return A?.brave ? { brave: !0 } : {};
      })(), F = {};
      G(_) || (F.detectGoogleSearchApp = _);
      const K = {}, B = (T = navigator) === null || T === void 0 || (T = T.userAgentData) === null || T === void 0 ? void 0 : T.platform, $ = (E = navigator) === null || E === void 0 ? void 0 : E.maxTouchPoints, I = L == null || (S = L.screen) === null || S === void 0 ? void 0 : S.width, q = L == null || (P = L.screen) === null || P === void 0 ? void 0 : P.height, J = L?.devicePixelRatio;
      G(B) || (K.userAgentDataPlatform = B), G($) || (K.maxTouchPoints = $), G(I) || (K.screenWidth = I), G(q) || (K.screenHeight = q), G(J) || (K.devicePixelRatio = J);
      const D = ze(uf({ $os: M, $os_version: O, $browser: T_(Pt, navigator.vendor, z, F), $webview_app: W, $webview_app_version: H, $device: A_(Pt), $device_type: E3(Pt, K), $timezone: Lw(), $timezone_offset: f4() }), { $current_url: so(w ? gn(Ke?.href) : Ke?.href, C, oo), $host: Ke?.host, $pathname: Ke?.pathname, $raw_user_agent: Pt.length > 1e3 ? Pt.substring(0, 997) + "..." : Pt, $browser_version: P3(Pt, navigator.vendor, z, F), $browser_language: Ow(), $browser_language_prefix: h4(), $screen_height: L?.screen.height, $screen_width: L?.screen.width, $viewport_height: L?.innerHeight, $viewport_width: L?.innerWidth, $lib: ji.LIB_NAME, $lib_version: ji.LIB_VERSION, $insert_id: Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10), $time: Date.now() / 1e3 });
      return ji.SDK_DIST_CHANNEL && (D.$sdk_dist_channel = ji.SDK_DIST_CHANNEL), D;
    })(this.config.mask_personal_data_properties, this.config.custom_personal_data_properties, this.config.detect_google_search_app, this.config.disable_capture_url_hashes);
    if (this.sessionManager) {
      const { sessionId: y, windowId: k } = this.sessionManager.checkAndGetSessionAndWindowId(s, i.getTime(), !0);
      a.$session_id = y, a.$window_id = k;
    }
    this.sessionPropsManager && ze(a, this.sessionPropsManager.getSessionProps());
    try {
      var c;
      this.sessionRecording && ze(a, this.sessionRecording.sdkDebugProperties), a.$sdk_debug_retry_queue_size = (c = this.Bu) === null || c === void 0 ? void 0 : c.length;
    } catch (y) {
      a.$sdk_debug_error_capturing_properties = String(y);
    }
    let u;
    if (this.requestRouter.region === Md && (a.$lib_custom_api_host = this.config.api_host), u = e !== "$pageview" || s ? e !== "$pageleave" || s ? this.pageViewManager.doEvent() : this.pageViewManager.doPageLeave(i) : this.pageViewManager.doPageView(i, r), a = ze(a, u), e === "$pageview" && Y && (a.title = Y.title), !G(o)) {
      const y = i.getTime() - o;
      a.$duration = parseFloat((y / 1e3).toFixed(3));
    }
    Pt && this.config.opt_out_useragent_filter && (a.$browser_type = this._is_bot() ? "bot" : "browser");
    const d = this.persistence.properties(), h = this.sessionPersistence.properties(), f = a.$groups, p = d.$groups;
    Ee(f) && !Ot(f) && (a.$groups = R(R({}, Ee(p) ? p : {}), f)), Fe(["$referrer", "$referring_domain"], (y) => {
      y in d && delete h[y];
    });
    const v = {};
    if (this.Pu.length > 0) for (const y of this.Pu.slice()) try {
      ze(v, y());
    } catch (k) {
      ee.error("Failed to produce browser extension event properties", k);
    }
    a = ze({}, l, d, h, R(R({}, v), a)), a.$is_identified = this._isIdentified(), de(this.config.property_denylist) ? Fe(this.config.property_denylist, function(y) {
      delete a[y];
    }) : ee.error(ck + this.config.property_denylist + " or property_blacklist config: " + this.config.property_blacklist);
    const g = this.config.sanitize_properties;
    g && (ee.error(Mg), a = g(a, e));
    const m = this.yh();
    return a.$process_person_profile = m, m && !s && this.bh("_calculate_event_properties"), a;
  }
  ph(e, n = !0, i = !1) {
    var r;
    if (!this.persistence || !this.yh() || this.Iu && !i) return e;
    const s = this.persistence.get_initial_props(), o = (r = this.sessionPropsManager) === null || r === void 0 ? void 0 : r.getSetOnceProps();
    let a = ze({}, s, o || {}, e || {});
    const l = this.config.sanitize_properties;
    return l && (ee.error(Mg), a = l(a, "$set_once")), n && (this.Iu = !0), Ot(a) ? void 0 : a;
  }
  register(e, n) {
    var i;
    (i = this.persistence) === null || i === void 0 || i.register(e, n);
  }
  register_once(e, n, i) {
    var r;
    (r = this.persistence) === null || r === void 0 || r.register_once(e, n, i);
  }
  register_for_session(e) {
    var n, i;
    (n = this.persistence) === null || n === void 0 || n.syncCookieProperties(), this.gh(), (i = this.sessionPersistence) === null || i === void 0 || i.register(e), Object.keys(e).forEach((r) => this.Mu.add(r)), this.mh();
  }
  unregister(e) {
    var n;
    (n = this.persistence) === null || n === void 0 || n.unregister(e);
  }
  unregister_for_session(e) {
    var n;
    (n = this.sessionPersistence) === null || n === void 0 || n.unregister(e), this.Mu.delete(e), this.mh();
  }
  _h(e, n) {
    this.register({ [e]: n });
  }
  Hu() {
    this.Mu.forEach((e) => {
      var n;
      (n = this.sessionPersistence) === null || n === void 0 || n.unregister(e);
    }), this.Mu.clear(), this.mh();
  }
  mh() {
    var e;
    if (!this.Eu) return;
    if (this.config.persistence === "memory" || !((e = this.sessionPersistence) === null || e === void 0) && e.mi || !je.Et()) return void je.Lt(this.Eu);
    const n = [];
    this.Mu.forEach((i) => n.push(i)), n.length > 0 ? je.At(this.Eu, n) : je.Lt(this.Eu);
  }
  getFeatureFlag(e, n) {
    var i;
    return (i = this.featureFlags) === null || i === void 0 ? void 0 : i.getFeatureFlag(e, n);
  }
  getFeatureFlagPayload(e) {
    var n;
    return (n = this.featureFlags) === null || n === void 0 ? void 0 : n.getFeatureFlagPayload(e);
  }
  getFeatureFlagResult(e, n) {
    var i;
    return (i = this.featureFlags) === null || i === void 0 ? void 0 : i.getFeatureFlagResult(e, n);
  }
  getAllFeatureFlags() {
    var e, n;
    return (e = (n = this.featureFlags) === null || n === void 0 ? void 0 : n.getAllFeatureFlags()) !== null && e !== void 0 ? e : [];
  }
  isFeatureEnabled(e, n) {
    var i, r;
    return (i = (r = this.featureFlags) === null || r === void 0 ? void 0 : r.isFeatureEnabled(e, n)) !== null && i !== void 0 ? i : n?.defaultValue;
  }
  reloadFeatureFlags() {
    var e;
    (e = this.featureFlags) === null || e === void 0 || e.reloadFeatureFlags();
  }
  updateFlags(e, n, i) {
    var r;
    (r = this.featureFlags) === null || r === void 0 || r.updateFlags(e, n, i);
  }
  updateEarlyAccessFeatureEnrollment(e, n, i) {
    var r;
    (r = this.featureFlags) === null || r === void 0 || r.updateEarlyAccessFeatureEnrollment(e, n, i);
  }
  getEarlyAccessFeatures(e, n = !1, i) {
    var r;
    return (r = this.featureFlags) === null || r === void 0 ? void 0 : r.getEarlyAccessFeatures(e, n, i);
  }
  on(e, n) {
    return this.vu.on(e, n);
  }
  onFeatureFlags(e) {
    return this.featureFlags ? this.featureFlags.onFeatureFlags(e) : (e([], {}, { errorsLoading: !0 }), () => {
    });
  }
  onSurveysLoaded(e) {
    return this.surveys ? this.surveys.onSurveysLoaded(e) : (e([], { isLoaded: !1, error: ks }), () => {
    });
  }
  onSessionId(e) {
    var n, i;
    return (n = (i = this.sessionManager) === null || i === void 0 ? void 0 : i.onSessionId(e)) !== null && n !== void 0 ? n : () => {
    };
  }
  getSurveys(e, n = !1) {
    this.surveys ? this.surveys.getSurveys(e, n) : e([], { isLoaded: !1, error: ks });
  }
  getActiveMatchingSurveys(e, n = !1) {
    this.surveys ? this.surveys.getActiveMatchingSurveys(e, n) : e([], { isLoaded: !1, error: ks });
  }
  renderSurvey(e, n) {
    var i;
    (i = this.surveys) === null || i === void 0 || i.renderSurvey(e, n);
  }
  displaySurvey(e, n = U4) {
    var i;
    (i = this.surveys) === null || i === void 0 || i.displaySurvey(e, n);
  }
  cancelPendingSurvey(e) {
    var n;
    (n = this.surveys) === null || n === void 0 || n.cancelPendingSurvey(e);
  }
  canRenderSurvey(e) {
    var n, i;
    return (n = (i = this.surveys) === null || i === void 0 ? void 0 : i.canRenderSurvey(e)) !== null && n !== void 0 ? n : { visible: !1, disabledReason: ks };
  }
  canRenderSurveyAsync(e, n = !1) {
    var i, r;
    return (i = (r = this.surveys) === null || r === void 0 ? void 0 : r.canRenderSurveyAsync(e, n)) !== null && i !== void 0 ? i : Promise.resolve({ visible: !1, disabledReason: ks });
  }
  wh(e) {
    return !e || Os(e) ? (ee.critical("Unique user id has not been set in posthog.identify"), !1) : e === "$posthog_cookieless" ? (ee.critical(`The string "${e}" was set in posthog.identify which indicates an error. This ID is only used as a sentinel value.`), !1) : !["distinct_id", "distinctid"].includes(e.toLowerCase()) && !["undefined", "null"].includes(e.toLowerCase()) || (ee.critical(`The string "${e}" was set in posthog.identify which indicates an error. This ID should be unique to the user and not a hardcoded string.`), !1);
  }
  identify(e, n, i) {
    if (!this.__loaded || !this.persistence) return ee.uninitializedWarning("posthog.identify");
    if (Qe(e) && (e = e.toString(), ee.warn("The first argument to posthog.identify was a number, but it should be a string. It has been converted to a string.")), !this.wh(e) || !this.bh("posthog.identify")) return;
    this.Su();
    const r = this.get_distinct_id(), s = this.persistence.syncCookieProperties() && this.get_distinct_id() !== r, o = this.gh(!1), a = this.persistence.Da();
    let l = !1;
    try {
      const u = this.get_distinct_id();
      this.register({ $user_id: e }), this.get_property("$device_id") || this.register_once({ $had_persisted_distinct_id: !0, $device_id: u }, ""), e !== u && e !== this.get_property("__alias") && (this.unregister(al), this.register({ distinct_id: e }));
      const d = (this.persistence.get_property("$user_state") || "anonymous") === Ni, h = e !== u, f = !h && d;
      if (h && d) {
        var c;
        const p = this.config.reuseAnonymousId ? { distinct_id: e } : { distinct_id: e, $anon_distinct_id: u };
        this.persistence.set_property(Et, Ca), this.setPersonPropertiesForFlags({ $set: n || {}, $set_once: i || {} }, !1), this.config.cookieWinsOnConflict && this.persistence.La(), this.capture("$identify", p, { $set: n || {}, $set_once: i || {} }) && (this.Ou = Kc(e, n, i)), (c = this.featureFlags) === null || c === void 0 || c.setAnonymousDistinctId(this.config.reuseAnonymousId ? void 0 : u);
      } else if (f) {
        this.persistence.set_property(Et, Ca);
        const p = n || {}, v = i || {};
        this.setPersonPropertiesForFlags({ $set: p, $set_once: v }, !1), this.config.cookieWinsOnConflict && this.persistence.La(), this.capture("$set", { $set: p, $set_once: v }) && (this.Ou = Kc(e, n, i));
      } else (n || i) && this.setPersonProperties(n, i);
      h || s || o ? (this.reloadFeatureFlags(), this.featureFlags ? this.featureFlags.resetFlagCallReported() : this.unregister(an)) : f && (n || i) && this.reloadFeatureFlags(), l = !0;
    } finally {
      a && this.persistence.ja(l);
    }
  }
  setPersonProperties(e, n) {
    if (!e && !n || !this.bh("posthog.setPersonProperties")) return;
    const i = Kc(this.get_distinct_id(), e, n);
    this.Ou !== i ? (this.setPersonPropertiesForFlags({ $set: e || {}, $set_once: n || {} }, !0), this.capture("$set", { $set: e || {}, $set_once: n || {} }) && (this.Ou = i)) : ee.info("A duplicate setPersonProperties call was made with the same properties. It has been ignored.");
  }
  unsetPersonProperties(e) {
    var n;
    const i = (de(e) ? e : [e]).filter((r) => Pe(r) && r.length > 0);
    i.length !== 0 && this.bh("posthog.unsetPersonProperties") && ((n = this.featureFlags) === null || n === void 0 || n.unsetPersonPropertiesForFlags(i, !0), this.capture("$set", { $unset: i }), this.Ou = null);
  }
  group(e, n, i) {
    var r;
    if (!e || !n) return void ee.error("posthog.group requires a group type and group key");
    (r = this.persistence) === null || r === void 0 || r.syncCookieProperties(), this.gh();
    const s = this.getGroups(), o = s[e] !== n;
    if (o && this.resetGroupPropertiesForFlags(e), this.register({ $groups: R(R({}, s), {}, { [e]: n }) }), (o || i) && this.yh()) {
      const a = { $group_type: e, $group_key: n };
      i && (a.$group_set = i), this.capture(tg, a);
    }
    i && this.setGroupPropertiesForFlags({ [e]: i }), o && !i && this.reloadFeatureFlags();
  }
  resetGroups() {
    this.register({ $groups: {} }), this.resetGroupPropertiesForFlags(), this.reloadFeatureFlags();
  }
  setPersonPropertiesForFlags(e, n = !0) {
    var i;
    (i = this.featureFlags) === null || i === void 0 || i.setPersonPropertiesForFlags(e, n);
  }
  resetPersonPropertiesForFlags(e = !0) {
    var n;
    (n = this.featureFlags) === null || n === void 0 || n.resetPersonPropertiesForFlags(e);
  }
  setGroupPropertiesForFlags(e, n = !0) {
    var i;
    this.bh("posthog.setGroupPropertiesForFlags") && ((i = this.featureFlags) === null || i === void 0 || i.setGroupPropertiesForFlags(e, n));
  }
  resetGroupPropertiesForFlags(e) {
    var n;
    (n = this.featureFlags) === null || n === void 0 || n.resetGroupPropertiesForFlags(e);
  }
  reset(e) {
    const n = Tt(e) ? e : e?.resetDeviceID, i = Tt(e) || e == null ? void 0 : e.bootstrap;
    this.kh(n, !1, i);
  }
  kh(e, n = !1, i) {
    var r, s, o, a, l, c;
    if (ee.info("reset"), !this.__loaded) return ee.uninitializedWarning("posthog.reset");
    const u = i?.sessionID;
    this.config.bootstrap = i || ((r = this.Lu) === null || r === void 0 ? void 0 : r.bootstrap) || {}, (s = this.featureFlags) === null || s === void 0 || (o = s.updateConfig) === null || o === void 0 || o.call(s, this.config, this.nl());
    const d = this.get_property(rf), h = this.get_property(Ic), f = this.get_property(Fs);
    (a = this.sessionRecording) === null || a === void 0 || a.flushBeforeIdentityReset();
    const p = this.is_capturing();
    this.consent.reset(), n || !p || this.is_capturing() || console.warn("[PostHog.js]", "reset() cleared the stored consent, and capturing is now off because of `opt_out_capturing_by_default`. Call opt_in_capturing() again, and prefer calling reset() before opting in rather than after.");
    const v = (l = this.persistence) === null || l === void 0 || (c = l.Da) === null || c === void 0 ? void 0 : c.call(l);
    let g = !1;
    try {
      var m, y, k, _, w, T, E, S, P, C, M, O, W;
      if ((m = this.persistence) === null || m === void 0 || m.clear(), (y = this.sessionPersistence) === null || y === void 0 || y.clear(), this.Mu.clear(), this.mh(), G(f) || (C = this.persistence) === null || C === void 0 || C.register({ $session_recording_remote_config: f }), (k = this.surveys) === null || k === void 0 || k.reset(), (_ = this.featureFlags) === null || _ === void 0 || _.reset(), (w = this.conversations) === null || w === void 0 || w.reset(), (T = this.logs) === null || T === void 0 || T.reset(), (E = this.metrics) === null || E === void 0 || E.reset(), (S = this.persistence) === null || S === void 0 || S.set_property("$user_state", "anonymous"), (P = this.sessionManager) === null || P === void 0 || P.resetSessionId(), this.Ou = null, this.config.cookieless_mode === "always") this.register_once({ distinct_id: Dc, $device_id: null }, "");
      else {
        const F = this.config.get_device_id(ri());
        this.register_once({ distinct_id: F, $device_id: e ? F : d }, ""), e || G(h) || this.register({ [Ic]: h });
      }
      if (this.register({ $last_posthog_reset: (/* @__PURE__ */ new Date()).toISOString() }, 1), i && (i.distinctID && !this.bu() && ((W = this.persistence) === null || W === void 0 || W.set_property("$user_state", i.isIdentifiedID ? "identified" : "anonymous"), this.register({ distinct_id: i.distinctID })), (M = this.featureFlags) === null || M === void 0 || M.initialize(), !ve(u) && !(!((O = this.sessionManager) === null || O === void 0) && O.setBootstrapSessionId(u, !0)))) {
        const F = R({}, i);
        delete F.sessionID, this.config.bootstrap = F;
      }
      delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, g = !0;
    } finally {
      var H, z;
      v && ((H = this.persistence) === null || H === void 0 || (z = H.ja) === null || z === void 0 || z.call(H, g));
    }
    this.reloadFeatureFlags();
  }
  shutdown(e) {
    var n = this;
    return He(function* () {
      var i, r, s, o, a, l, c, u;
      if (n.__loaded) {
        n.Tu = !0, n.Zu().dispose(), (i = n.sessionRecording) === null || i === void 0 || i.dispose(), (r = n.logs) === null || r === void 0 || r.flushLogs("sendBeacon"), (s = n.metrics) === null || s === void 0 || s.flush("sendBeacon"), (o = n.metrics) === null || o === void 0 || o.dispose(), (a = n.qu) === null || a === void 0 || a.unload(), (l = n.Bu) === null || l === void 0 || l.unload();
        try {
          var d;
          (d = n.featureFlags) === null || d === void 0 || d.destroy();
        } catch (h) {
          ee.error("Error while destroying feature flags", h);
        }
        (c = n.persistence) === null || c === void 0 || c.destroy(), (u = n.sessionPersistence) === null || u === void 0 || u.destroy();
      } else ee.uninitializedWarning("posthog.shutdown");
    })();
  }
  setIdentity(e, n) {
    var i;
    delete this.config.identity_claims, this.config.identity_distinct_id = e, this.config.identity_hash = n, this.alias(e), (i = this.conversations) === null || i === void 0 || i.Sh();
  }
  clearIdentity() {
    var e;
    delete this.config.identity_distinct_id, delete this.config.identity_hash, delete this.config.identity_claims, (e = this.conversations) === null || e === void 0 || e.xh();
  }
  get_distinct_id() {
    return this.get_property("distinct_id");
  }
  getGroups() {
    return this.get_property("$groups") || {};
  }
  get_session_id() {
    var e, n;
    return (e = (n = this.sessionManager) === null || n === void 0 ? void 0 : n.checkAndGetSessionAndWindowId(!0).sessionId) !== null && e !== void 0 ? e : "";
  }
  get_session_replay_url(e) {
    if (!this.sessionManager) return "";
    const { sessionId: n, sessionStartTimestamp: i } = this.sessionManager.checkAndGetSessionAndWindowId(!0);
    let r = this.requestRouter.endpointFor("ui", `/project/${this.config.token}/replay/${n}`);
    if (e?.withTimestamp && i) {
      var s;
      const o = (s = e.timestampLookBack) !== null && s !== void 0 ? s : 10;
      if (!i) return r;
      r += `?t=${Math.max(Math.floor(((/* @__PURE__ */ new Date()).getTime() - i) / 1e3) - o, 0)}`;
    }
    return r;
  }
  alias(e, n) {
    return e === this.get_property("$people_distinct_id") ? (ee.critical("Attempting to create alias for existing People user - aborting."), -2) : this.bh("posthog.alias") ? (G(n) && (n = this.get_distinct_id()), e !== n ? (this._h(al, e), this.capture("$create_alias", { alias: e, distinct_id: n })) : (ee.warn("alias matches current distinct_id - skipping api call."), this.identify(e), -1)) : void 0;
  }
  set_config(e) {
    const n = R({}, this.config);
    if (Ee(e)) {
      var i, r, s, o, a, l, c, u, d, h, f, p, v, g;
      ze(this.config, Dg(e));
      const y = this.xu();
      (i = this.persistence) === null || i === void 0 || i.update_config(this.config, n, y), this.sessionPersistence = this.config.persistence === "sessionStorage" || this.config.persistence === "memory" ? this.persistence : new Hc(R(R({}, this.config), {}, { persistence: "sessionStorage" }), y, !1);
      const k = this.Du(this.config.debug);
      var m;
      Tt(k) && (this.config.debug = k), Tt(this.config.debug) && (this.config.debug ? (ot.DEBUG = !0, Re.Et() && Re.At("ph_debug", !0), ee.info("set_config", { config: e, oldConfig: n, newConfig: R({}, this.config) })) : (ot.DEBUG = !1, Re.Et() && Re.Lt("ph_debug"))), (r = this.featureFlags) === null || r === void 0 || (s = r.updateConfig) === null || s === void 0 || s.call(r, this.config, this.nl()), (o = this.exceptionObserver) === null || o === void 0 || o.onConfigChange(), (a = this.exceptions) === null || a === void 0 || a.onConfigChange(), (l = this.metrics) === null || l === void 0 || l.onConfigChange(), (c = this.sessionRecording) === null || c === void 0 || c.startIfEnabledOrStop(), (u = this.tracingHeaders) === null || u === void 0 || u.startIfEnabledOrStop(), (d = this.autocapture) === null || d === void 0 || d.startIfEnabled(), (h = this.heatmaps) === null || h === void 0 || h.startIfEnabled(), ("capture_pageview" in e || "disable_capture_url_hashes" in e) && ((m = this.historyAutocapture) === null || m === void 0 || m.startIfEnabledOrStop()), (f = this.exceptionObserver) === null || f === void 0 || f.startIfEnabledOrStop(), (p = this.deadClicksAutocapture) === null || p === void 0 || p.startIfEnabledOrStop(), (v = this.surveys) === null || v === void 0 || v.loadIfEnabled(), this.Cu(), (g = this.externalIntegrations) === null || g === void 0 || g.startIfEnabledOrStop(), !n.segment && this.config.segment && this.persistence && gg(this, Hs, !1);
    }
  }
  _overrideSDKInfo(e, n) {
    ot.LIB_NAME = e, ot.LIB_VERSION = n;
  }
  startSessionRecording(e) {
    const n = e === !0, i = { sampling: n || !!e?.sampling, linked_flag: n || !!e?.linked_flag, url_trigger: n || !!e?.url_trigger, event_trigger: n || !!e?.event_trigger };
    var r, s, o, a, l;
    Object.values(i).some(Boolean) && ((r = this.sessionManager) === null || r === void 0 || r.checkAndGetSessionAndWindowId(), i.sampling && ((s = this.sessionRecording) === null || s === void 0 || s.overrideSampling()), i.linked_flag && ((o = this.sessionRecording) === null || o === void 0 || o.overrideLinkedFlag()), i.url_trigger && ((a = this.sessionRecording) === null || a === void 0 || a.overrideTrigger("url")), i.event_trigger && ((l = this.sessionRecording) === null || l === void 0 || l.overrideTrigger("event"))), this.set_config({ disable_session_recording: !1 });
  }
  stopSessionRecording() {
    this.set_config({ disable_session_recording: !0 });
  }
  sessionRecordingStarted() {
    var e;
    return !!(!((e = this.sessionRecording) === null || e === void 0) && e.started);
  }
  captureException(e, n) {
    try {
      if (!this.exceptions) return;
      const i = this.exceptions.buildProperties(e, { handled: !0, syntheticException: new Error("PostHog syntheticException") });
      return this.exceptions.sendExceptionEvent(R(R({}, i), n));
    } catch {
      return;
    }
  }
  addExceptionStep(e, n) {
    var i;
    (i = this.exceptions) === null || i === void 0 || i.addExceptionStep(e, n);
  }
  captureLog(e) {
    var n;
    (n = this.logs) === null || n === void 0 || n.captureLog(e);
  }
  get logger() {
    var e, n;
    return (e = (n = this.logs) === null || n === void 0 ? void 0 : n.logger) !== null && e !== void 0 ? e : Zi.Ch;
  }
  startExceptionAutocapture(e) {
    this.set_config({ capture_exceptions: e == null || e });
  }
  stopExceptionAutocapture() {
    this.set_config({ capture_exceptions: !1 });
  }
  loadToolbar(e) {
    var n, i;
    return (n = (i = this.toolbar) === null || i === void 0 ? void 0 : i.loadToolbar(e)) !== null && n !== void 0 && n;
  }
  get_property(e) {
    var n;
    return (n = this.persistence) === null || n === void 0 ? void 0 : n.props[e];
  }
  getSessionProperty(e) {
    var n;
    return (n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.props[e];
  }
  toString() {
    var e;
    let n = (e = this.config.name) !== null && e !== void 0 ? e : As;
    return n !== As && (n = "posthog." + n), n;
  }
  _isIdentified() {
    var e, n;
    return ((e = this.persistence) === null || e === void 0 ? void 0 : e.get_property("$user_state")) === "identified" || ((n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.get_property("$user_state")) === "identified";
  }
  yh() {
    var e, n;
    return !(this.config.person_profiles === "never" || this.config.person_profiles === "identified_only" && !this._isIdentified() && Ot(this.getGroups()) && !(!((e = this.persistence) === null || e === void 0 || (e = e.props) === null || e === void 0) && e.__alias) && !(!((n = this.persistence) === null || n === void 0 || (n = n.props) === null || n === void 0) && n.$epp));
  }
  ih() {
    return this.config.capture_pageleave === !0 || this.config.capture_pageleave === "if_capture_pageview" && !!this.config.capture_pageview;
  }
  createPersonProfile() {
    this.yh() || this.bh("posthog.createPersonProfile") && this.setPersonProperties({}, {});
  }
  setInternalOrTestUser() {
    this.bh("posthog.setInternalOrTestUser") && this.setPersonProperties({ $internal_or_test_user: !0 });
  }
  bh(e) {
    return this.config.person_profiles === "never" ? (ee.error(e + ' was called, but process_person is set to "never". This call will be ignored.'), !1) : (this._u(), this._h(af, !0), !0);
  }
  xu() {
    if (this.config.cookieless_mode === "always") return !0;
    const e = this.consent.isOptedOut();
    return this.config.disable_persistence || e && !(!this.config.opt_out_persistence_by_default && this.config.cookieless_mode !== "on_reject");
  }
  Cu() {
    var e, n;
    const i = this.xu();
    var r, s, o;
    return this.is_capturing() || (r = this.logs) === null || r === void 0 || r.$h(), ((e = this.persistence) === null || e === void 0 ? void 0 : e.mi) !== i && ((s = this.persistence) === null || s === void 0 || s.set_disabled(i)), ((n = this.sessionPersistence) === null || n === void 0 ? void 0 : n.mi) !== i && ((o = this.sessionPersistence) === null || o === void 0 || o.set_disabled(i)), i && (this.Mu.clear(), this.mh()), i;
  }
  opt_in_capturing(e) {
    var n;
    if (this.config.cookieless_mode !== "always") {
      if (this.bu()) {
        var i, r, s, o, a, l;
        (i = this.sessionRecording) === null || i === void 0 || i.dispose({ discardBufferedEvents: !0 }), this.kh(!0, !0), (r = this.sessionManager) === null || r === void 0 || r.destroy(), (s = this.pageViewManager) === null || s === void 0 || s.destroy(), this.sessionManager = new Cg(this), this.pageViewManager = new vg(this), this.persistence && (this.sessionPropsManager = new Eg(this, this.sessionManager, this.persistence));
        const f = (o = (a = this.config.__extensionClasses) === null || a === void 0 ? void 0 : a.sessionRecording) !== null && o !== void 0 ? o : (l = Zi.__defaultExtensionClasses) === null || l === void 0 ? void 0 : l.sessionRecording;
        var c, u;
        f && (this.sessionRecording = this.yu(this.sessionRecording, new f(this)), this.du && ((c = this.sessionRecording) === null || c === void 0 || (u = c.onRemoteConfig) === null || u === void 0 || u.call(c, this.du)));
      }
      var d, h;
      this.consent.optInOut(!0), this.Cu(), this.Yu(), (n = this.sessionRecording) === null || n === void 0 || n.startIfEnabledOrStop(), this.config.cookieless_mode == "on_reject" && ((d = this.surveys) === null || d === void 0 || d.loadIfEnabled()), (G(e?.captureEventName) || e?.captureEventName) && this.capture((h = e?.captureEventName) !== null && h !== void 0 ? h : "$opt_in", e?.captureProperties, { send_instantly: !0 }), this.config.capture_pageview && this.th();
    } else ee.warn(Rg);
  }
  opt_out_capturing() {
    if (this.config.cookieless_mode === "always") return void ee.warn(Rg);
    const e = this.config.cookieless_mode === "on_reject" ? this.sessionRecording : void 0;
    var n, i;
    e?.dispose({ discardBufferedEvents: !0 }), this.config.cookieless_mode === "on_reject" && this.consent.isOptedIn() && this.kh(!0, !0), this.consent.optInOut(!1), this.Cu(), this.config.cookieless_mode === "on_reject" && (this.register({ distinct_id: Dc, $device_id: null }), this.mu(e), this.sessionRecording = void 0, (n = this.sessionManager) === null || n === void 0 || n.destroy(), (i = this.pageViewManager) === null || i === void 0 || i.destroy(), this.sessionManager = void 0, this.sessionPropsManager = void 0, this.config.capture_pageview && this.th(), this.Yu());
  }
  has_opted_in_capturing() {
    return this.consent.isOptedIn();
  }
  has_opted_out_capturing() {
    return this.consent.isOptedOut();
  }
  get_explicit_consent_status() {
    const e = this.consent.consent;
    return e === 1 ? "granted" : e === 0 ? "denied" : "pending";
  }
  is_capturing() {
    return this.config.cookieless_mode === "always" || (this.config.cookieless_mode === "on_reject" ? this.consent.isRejected() || this.consent.isOptedIn() : !this.has_opted_out_capturing());
  }
  clear_opt_in_out_capturing() {
    this.consent.reset(), this.Cu();
  }
  _is_bot() {
    return dt ? nk(dt, this.config.custom_blocked_useragents) : void 0;
  }
  th() {
    Y && (Y.visibilityState === "visible" ? this.Ru || (this.Ru = !0, this.capture(cf, { title: Y.title }, { send_instantly: !0 }), this.Au && (Y.removeEventListener(io, this.Au), this.Au = null)) : this.Au || (this.Au = this.th.bind(this), Ie(Y, io, this.Au)));
  }
  debug(e) {
    e === !1 ? (L?.console.log("You've disabled debug mode."), this.set_config({ debug: !1 })) : (L?.console.log("You're now in debug mode. All calls to PostHog will be logged in your console.\nYou can disable this with `posthog.debug(false)`."), this.set_config({ debug: !0 }));
  }
  nl() {
    const e = this.Lu || {};
    return "advanced_disable_flags" in e ? !!e.advanced_disable_flags : this.config.advanced_disable_flags !== !1 ? !!this.config.advanced_disable_flags : this.config.advanced_disable_decide === !0 ? (ee.warn("Config field 'advanced_disable_decide' is deprecated. Please use 'advanced_disable_flags' instead. The old field will be removed in a future major version."), !0) : (function(n, i, r, s, o) {
      const a = i in n && !ve(n[i]), l = r in n && !ve(n[r]);
      return a ? n[i] : !!l && (o && o.warn(`Config field '${r}' is deprecated. Please use '${i}' instead. The old field will be removed in a future major version.`), n[r]);
    })(e, "advanced_disable_flags", "advanced_disable_decide", 0, ee);
  }
  Os(e) {
    var n;
    if (ve(this.config.before_send)) return e;
    const i = Object.keys((n = e.properties) !== null && n !== void 0 ? n : {}).filter(p3), r = de(this.config.before_send) ? this.config.before_send : [this.config.before_send];
    let s = e;
    for (const o of r) try {
      if (s = o(s), ve(s)) {
        const a = `Event '${e.event}' was rejected in beforeSend function`;
        return f3(e.event) ? ee.warn(`${a}. This can cause unexpected behavior.`) : ee.info(a), null;
      }
      s.properties && !Ot(s.properties) || ee.warn(`Event '${e.event}' has no properties after beforeSend function, this is likely an error.`);
    } catch (a) {
      return ee.error(`Error in beforeSend function for event '${e.event}':`, a), null;
    }
    for (const o of i) if (s.properties && ve(s.properties[o])) return ee.warn(`Event '${e.event}' had its '${o}' property removed in a beforeSend function. This property is required for ingestion, so the event will be dropped.`), null;
    return s;
  }
  getPageViewId() {
    var e;
    return (e = this.pageViewManager.Vo) === null || e === void 0 ? void 0 : e.pageViewId;
  }
  captureTraceFeedback(e, n) {
    this.capture("$ai_feedback", { $ai_trace_id: String(e), $ai_feedback_text: n });
  }
  captureTraceMetric(e, n, i) {
    this.capture("$ai_metric", { $ai_trace_id: String(e), $ai_metric_name: n, $ai_metric_value: String(i) });
  }
  Du(e) {
    const n = Tt(e) && !e, i = Re.Et() && Re.Ot("ph_debug") === "true";
    return !n && (!!i || e);
  }
};
zr.__defaultExtensionClasses = {}, zr.Ch = /* @__PURE__ */ (() => {
  const t = () => {
  };
  return { trace: t, debug: t, info: t, warn: t, error: t, fatal: t };
})(), (function(t, e) {
  for (let n = 0; e.length > n; n++) t.prototype[e[n]] = HI(t.prototype[e[n]]);
})(zr, ["identify"]);
var uk = class {
  constructor(t) {
    this.disabled = t === !1;
    const e = Ee(t) ? t : {};
    this.thresholdPx = e.threshold_px || 30, this.timeoutMs = e.timeout_ms || 1e3, this.clickCount = e.click_count || 3, this.clicks = [];
  }
  isRageClick(t, e, n) {
    if (this.disabled) return !1;
    const i = this.clicks[this.clicks.length - 1];
    if (i && Math.abs(t - i.x) + Math.abs(e - i.y) < this.thresholdPx && this.timeoutMs > n - i.timestamp) {
      if (this.clicks.push({ x: t, y: e, timestamp: n }), this.clicks.length === this.clickCount) return !0;
    } else this.clicks = [{ x: t, y: e, timestamp: n }];
    return !1;
  }
};
const Jc = "$copy_autocapture", Zc = Ze("[AutoCapture]");
function Qc(t, e) {
  return e.length > t ? e.slice(0, t) + "..." : e;
}
function iD(t) {
  if (t.previousElementSibling) return t.previousElementSibling;
  let e = t;
  do
    e = e.previousSibling;
  while (e && !ki(e));
  return e;
}
function nD(t, { e, maskAllElementAttributes: n, maskAllText: i, elementAttributeIgnoreList: r, elementsChainAsString: s, disableCaptureUrlHashes: o }) {
  var a, l;
  if (!ki(t)) return { props: {} };
  const c = [t], u = /* @__PURE__ */ new Set([t]);
  let d = t;
  for (; d.parentNode && !vt(d, "body") && 1e3 > c.length; ) {
    if (df(d.parentNode)) {
      const T = d.parentNode.host;
      if (u.has(T)) break;
      u.add(T), c.push(T), d = T;
      continue;
    }
    if (!ki(d.parentNode) || u.has(d.parentNode)) break;
    u.add(d.parentNode), c.push(d.parentNode), d = d.parentNode;
  }
  const h = e.type === "click" && t.namespaceURI === "http://www.w3.org/2000/svg" ? c.findIndex((T) => vt(T, "button") || vt(T, "a")) : -1;
  h > 0 && (i = i || c.slice(0, h + 1).some((T) => !jr(T) || ro(T)));
  const f = [], p = {};
  let v, g = !1, m = !1;
  if (Fe(c, (T) => {
    const E = jr(T);
    if (vt(T, "a") && !n && !r?.includes("href")) {
      const S = T.getAttribute("href");
      g = !!(E && S && js(S)) && (o ? gn(S) : S);
    }
    pe(Xr(T), "ph-no-capture") && (m = !0), f.push((function(S, P, C, M, O = !1) {
      const W = S.tagName.toLowerCase(), H = { tag_name: W };
      ff.indexOf(W) > -1 && !C && (H.$el_text = W.toLowerCase() === "a" || W.toLowerCase() === "button" ? Qc(1024, fg(S)) : Qc(1024, no(S)));
      const z = Xr(S);
      P || M?.includes("class") || 0 >= z.length || (H.classes = z.filter(function($) {
        return $ !== "";
      })), Fe(S.attributes, function($) {
        var I;
        if ((!ro(S) || ["name", "id", "class", "aria-label"].indexOf($.name) !== -1) && !M?.includes($.name) && !P && js($.value) && (!Pe(I = $.name) || I.substring(0, 10) !== "_ngcontent" && I.substring(0, 7) !== "_nghost")) {
          let q = $.value;
          $.name === "class" && (q = hf(q).join(" ")), H["attr__" + $.name] = Qc(1024, $.name === "href" && O ? gn(q) : q);
        }
      });
      let F = 1, K = 1, B = S;
      for (; B = iD(B); ) F++, B.tagName === S.tagName && K++;
      return H.nth_child = F, H.nth_of_type = K, H;
    })(T, n, i, r, o)), Fe((function(S) {
      if (!jr(S)) return {};
      const P = {};
      return Fe(S.attributes, function(C) {
        if (C.name && C.name.indexOf("data-ph-capture-attribute") === 0) {
          const M = C.name.replace("data-ph-capture-attribute-", ""), O = C.value;
          M && O && js(O) && (P[M] = O);
        }
      }), P;
    })(T), (S, P) => {
      ({}).hasOwnProperty.call(p, P) || (p[P] = S);
    });
  }), m) return { props: {}, explicitNoCapture: m };
  if (h > 0 && (t = c[h], f.splice(0, h)), i || (f[0].$el_text = vt(t, "a") || vt(t, "button") ? fg(t) : no(t)), g) {
    var y, k;
    f[0].attr__href = g;
    const T = (y = Wi(g)) === null || y === void 0 ? void 0 : y.host, E = L == null || (k = L.location) === null || k === void 0 ? void 0 : k.host;
    T && E && T !== E && (v = g);
  }
  return { props: ze((w = e.type, { $event_type: w, $ce_version: 1 }), s ? {} : { $elements: f }, { $elements_chain: (_ = f, de(_) ? (function(T) {
    return T.map((E) => {
      var S, P;
      let C = "";
      if (E.tag_name && (C += E.tag_name), E.attr_class) {
        E.attr_class.sort();
        for (const W of E.attr_class) C += `.${W.replace(/"/g, "")}`;
      }
      const M = R(R(R(R({}, E.text ? { text: E.text } : {}), {}, { "nth-child": (S = E.nth_child) !== null && S !== void 0 ? S : 0, "nth-of-type": (P = E.nth_of_type) !== null && P !== void 0 ? P : 0 }, E.href ? { href: E.href } : {}), E.attr_id ? { attr_id: E.attr_id } : {}), E.attributes), O = {};
      return Aa(M).sort(([W], [H]) => (function(z, F) {
        return F > z ? -1 : z > F ? 1 : 0;
      })(W, H)).forEach(([W, H]) => O[pg(W.toString())] = pg(H.toString())), C += ":", C += Aa(O).map(([W, H]) => `${W}="${H}"`).join(""), C;
    }).join(";");
  })((function(T) {
    return T.map((E) => {
      var S, P;
      const C = { text: (S = E.$el_text) === null || S === void 0 ? void 0 : S.slice(0, 400), tag_name: E.tag_name, href: (P = E.attr__href) === null || P === void 0 ? void 0 : P.slice(0, 2048), attr_class: r4(E), attr_id: E.attr__id, nth_child: E.nth_child, nth_of_type: E.nth_of_type, attributes: {} };
      return Aa(E).filter(([M]) => M.indexOf("attr__") === 0).forEach(([M, O]) => C.attributes[M] = O), C;
    });
  })(_)) : "") }, !((a = f[0]) === null || a === void 0) && a.$el_text ? { $el_text: (l = f[0]) === null || l === void 0 ? void 0 : l.$el_text } : {}, v && e.type === "click" ? { $external_click_url: v } : {}, p), target: t };
  var _, w;
}
var rD = class {
  fo() {
    this.po = void 0, clearTimeout(this.mo), this.mo = void 0;
  }
  yo(t) {
    var e;
    if (!jr(t)) return !0;
    const n = (e = this.bo().css_selector_ignorelist) !== null && e !== void 0 ? e : zc, i = /* @__PURE__ */ new Set();
    let r = t;
    for (; r; ) {
      if (i.size >= 1e3 || i.has(r)) return !0;
      i.add(r);
      const s = r, o = Xr(s);
      if (pe(o, "ph-no-capture") || pe(o, "ph-sensitive") || ro(s) || n.some((l) => Pd(s, l))) return !0;
      const a = r.parentNode;
      r = df(a) ? a.host : a && ki(a) ? a : null;
    }
    return !1;
  }
  _o(t) {
    if (!this.isEnabled || t.type === "pointercancel") return void this.fo();
    if (t.type === "pointerdown") {
      this.fo();
      const i = Vs(t);
      var e;
      return void (t.isPrimary && t.button === 0 && !t.ctrlKey && i && ki(i) && (this.po = { target: i, excluded: this.yo(i), id: t.pointerId, x: t.clientX, y: t.clientY, released: !1, distinctId: (e = this.wo) === null || e === void 0 ? void 0 : e.distinctId }));
    }
    const n = this.po;
    n && (t.pointerId !== n.id || Math.abs(t.clientX - n.x) > 5 || Math.abs(t.clientY - n.y) > 5 ? this.fo() : t.type === "pointerup" && (n.released = !0, this.mo = setTimeout(() => this.fo(), 0)));
  }
  ko(t) {
    var e;
    const n = this.po;
    this.fo();
    const i = Vs(t);
    if (n?.released && n.target.isConnected && n.distinctId === ((e = this.wo) === null || e === void 0 ? void 0 : e.distinctId) && t.pointerId === n.id && (t.detail > 0 || t.pointerType === "touch" || t.pointerType === "pen") && t.button === 0 && 5 >= Math.abs(t.clientX - n.x) && 5 >= Math.abs(t.clientY - n.y) && i && (vt(i, "html") || vt(i, "body"))) {
      var r;
      if (n.excluded) return null;
      const s = (r = this.bo().css_selector_ignorelist) !== null && r !== void 0 ? r : zc;
      return [i, Y?.documentElement, Y?.body].some((o) => {
        if (!o) return !1;
        const a = Xr(o);
        return pe(a, "ph-no-capture") || pe(a, "ph-sensitive") || !jr(o) || ro(o) || s.some((l) => Pd(o, l));
      }) ? null : n.target;
    }
  }
  constructor(t) {
    this.So = t, this.name = "autocapture", this.xo = !1, this.Co = null, this.$o = !1, this.To = !1, this.Rr = { enabled: !1, rageclick: !1, maskAllElementAttributes: !1, maskAllText: !1, disableCaptureUrlHashes: !1, remoteRequestsDisabled: !1 }, this.Io = !1, this.So.refresh(this.Rr), this.rageclicks = new uk(this.Rr.rageclick), this.Mo = null;
  }
  setup(t) {
    this.Eo(), this.wo = t;
    const e = t.onRemoteConfig(this.onRemoteConfig.bind(this));
    this.Io ? e.dispose() : (this.Po = e, this.startIfEnabled());
  }
  dispose() {
    var t;
    this.Io || (this.Io = !0, this.wo = void 0, (t = this.Po) === null || t === void 0 || t.dispose(), this.Po = void 0, this.Ro());
  }
  bo() {
    return this.So.refresh(this.Rr), this.Rr;
  }
  Eo() {
    var t, e;
    return this.bo(), this.Rr.url_allowlist = (t = this.Rr.url_allowlist) === null || t === void 0 ? void 0 : t.map((n) => new RegExp(n)), this.Rr.url_ignorelist = (e = this.Rr.url_ignorelist) === null || e === void 0 ? void 0 : e.map((n) => new RegExp(n)), this.Rr;
  }
  Ao() {
    if (!this.isBrowserSupported()) return void Zc.info("Disabling Automatic Event Collection because this browser is not supported");
    if (!L || !Y) return;
    const t = this.Fo = (e) => {
      e = e || L?.event;
      try {
        if (e.type === "blur") return void this.fo();
        if (e.type.indexOf("pointer") === 0) return void this._o(e);
        const n = e.type === "click" ? this.ko(e) : void 0;
        if (Ye(n)) return;
        this.Oo(e, "$autocapture", n);
      } catch (n) {
        Zc.error("Failed to capture event", n);
      }
    };
    if (Ie(L, "blur", t), Ie(Y, "submit", t, { capture: !0 }), Ie(Y, "change", t, { capture: !0 }), Ie(Y, "click", t, { capture: !0 }), Fe(["pointerdown", "pointermove", "pointerup", "pointercancel"], (e) => {
      Ie(Y, e, t, { capture: !0 });
    }), this.bo().capture_copied_text) {
      const e = this.Do = (n) => {
        n = n || L?.event;
        try {
          this.Oo(n, Jc);
        } catch (i) {
          Zc.error("Failed to capture clipboard event", i);
        }
      };
      Ie(Y, "copy", e, { capture: !0 }), Ie(Y, "cut", e, { capture: !0 }), Ie(Y, "paste", e, { capture: !0 });
    }
  }
  Ro() {
    this.fo(), this.Fo && (L?.removeEventListener("blur", this.Fo), Fe(["pointerdown", "pointermove", "pointerup", "pointercancel"], (t) => {
      Y?.removeEventListener(t, this.Fo, !0);
    }), Y?.removeEventListener("submit", this.Fo, !0), Y?.removeEventListener("change", this.Fo, !0), Y?.removeEventListener("click", this.Fo, !0), this.Fo = void 0), this.Do && (Y?.removeEventListener("copy", this.Do, !0), Y?.removeEventListener("cut", this.Do, !0), Y?.removeEventListener("paste", this.Do, !0), this.Do = void 0), this.xo = !1;
  }
  startIfEnabled() {
    this.isEnabled || this.fo(), !this.Io && this.wo && this.isEnabled && !this.xo && (this.Ao(), this.xo = !0);
  }
  onRemoteConfig(t) {
    if (this.Io) return;
    if (this.$o = !0, !t.ok) return void this.startIfEnabled();
    const e = t.config;
    e.elementsChainAsString && (this.To = e.elementsChainAsString);
    const n = e.autocapture_opt_out;
    var i;
    Tt(n) && ((i = this.wo) === null || i === void 0 || i.kv.set("$autocapture_disabled_server_side", n), this.Co = n), this.startIfEnabled();
  }
  setElementSelectors(t) {
    this.Mo = t;
  }
  getElementSelectors(t, e) {
    var n;
    const i = [];
    return (n = this.Mo) === null || n === void 0 || n.forEach((r) => {
      const s = Y?.querySelectorAll(r);
      s?.forEach((o) => {
        t !== o && e !== o || pe(i, r) || i.push(r);
      });
    }), i;
  }
  get isEnabled() {
    var t, e;
    if (this.Io) return !1;
    const n = (t = this.wo) === null || t === void 0 ? void 0 : t.kv.get(J_), i = this.Co, r = this.bo();
    if (!r.remoteRequestsDisabled && !this.$o) return !1;
    const s = r.remoteRequestsDisabled && !this.$o;
    if (Ye(i) && !Tt(n) && !s) return !1;
    const o = (e = this.Co) !== null && e !== void 0 ? e : !!n;
    return !!r.enabled && !o;
  }
  Oo(t, e = "$autocapture", n) {
    if (!this.isEnabled) return void this.fo();
    let i = n || Vs(t);
    bw(i) && (i = i.parentNode || null);
    const r = this.Eo();
    var s;
    e === "$autocapture" && t.type === "click" && t instanceof MouseEvent && r.rageclick && (!((s = this.rageclicks) === null || s === void 0) && s.isRageClick(t.clientX, t.clientY, t.timeStamp || (/* @__PURE__ */ new Date()).getTime())) && xw(i, r.rageclick) && this.Oo(t, "$rageclick", n);
    const o = e === Jc, a = o ? R(R({}, r), {}, { dom_event_allowlist: void 0 }) : r;
    if (i && (function(d, h, f, p, v, g) {
      var m;
      if (!L || pf(d) || f?.url_allowlist && !og(f.url_allowlist, g) || f?.url_ignorelist && og(f.url_ignorelist, g)) return !1;
      if (f?.dom_event_allowlist) {
        const w = f.dom_event_allowlist;
        if (w && !w.some((T) => h.type === T)) return !1;
      }
      const { parentIsUsefulElement: y, targetElementList: k } = Sw(d, p);
      if (!(function(w, T) {
        const E = T?.element_allowlist;
        if (G(E)) return !0;
        for (const S of w) if (E.some((P) => S.tagName.toLowerCase() === P)) return !0;
        return !1;
      })(k, f) || !Ed(k, f?.css_selector_allowlist) || Ed(k, (m = f?.css_selector_ignorelist) !== null && m !== void 0 ? m : zc)) return !1;
      try {
        const w = L.getComputedStyle(d);
        if (w && w.getPropertyValue("cursor") === "pointer" && h.type === "click") return !0;
      } catch {
      }
      const _ = d.tagName.toLowerCase();
      switch (_) {
        case "html":
          return !1;
        case "form":
          return (v || ["submit"]).indexOf(h.type) >= 0;
        case "input":
        case "select":
        case "textarea":
          return (v || ["change", "click"]).indexOf(h.type) >= 0;
        default:
          return y ? (v || ["click"]).indexOf(h.type) >= 0 : (v || ["click"]).indexOf(h.type) >= 0 && (ff.indexOf(_) > -1 || d.getAttribute("contenteditable") === "true");
      }
    })(i, t, a, o, o ? ["copy", "cut", "paste"] : void 0, { config: { get_current_url: r.getCurrentUrl } })) {
      var l;
      const { props: d, explicitNoCapture: h, target: f } = nD(i, { e: t, maskAllElementAttributes: r.maskAllElementAttributes, maskAllText: r.maskAllText, elementAttributeIgnoreList: r.element_attribute_ignorelist, elementsChainAsString: this.To, disableCaptureUrlHashes: r.disableCaptureUrlHashes });
      if (h) return !1;
      const p = this.getElementSelectors(i, f);
      if (p && p.length > 0 && (d.$element_selectors = p), e === Jc) {
        const v = t.type || "clipboard";
        if (v !== "paste") {
          var c, u;
          const g = L == null || (c = L.getSelection()) === null || c === void 0 ? void 0 : c.toString(), m = _w(g);
          if (!m) return !1;
          d.$selected_content = m, d.$clipboard_text_length = (u = g?.length) !== null && u !== void 0 ? u : 0;
        }
        d.$copy_type = v;
      }
      return (l = this.wo) === null || l === void 0 || l.capture(e, d), !0;
    }
  }
  isBrowserSupported() {
    return ut(Y?.querySelectorAll);
  }
}, sD = class {
  constructor(t) {
    this._instance = t;
  }
  refresh(t) {
    const e = this._instance.config, n = Ee(e.autocapture) ? e.autocapture : void 0;
    t.enabled = !!e.autocapture, t.rageclick = e.rageclick, t.maskAllElementAttributes = e.mask_all_element_attributes, t.maskAllText = e.mask_all_text, t.disableCaptureUrlHashes = e.disable_capture_url_hashes, t.getCurrentUrl = e.get_current_url, t.remoteRequestsDisabled = this._instance.nl(), t.url_allowlist = n?.url_allowlist, t.url_ignorelist = n?.url_ignorelist, t.dom_event_allowlist = n?.dom_event_allowlist, t.element_allowlist = n?.element_allowlist, t.css_selector_allowlist = n?.css_selector_allowlist, t.css_selector_ignorelist = n?.css_selector_ignorelist, t.element_attribute_ignorelist = n?.element_attribute_ignorelist, t.capture_copied_text = n?.capture_copied_text;
  }
};
const xs = Ze("[ExceptionAutocapture]"), Fg = () => {
}, Lg = (t) => {
  var e;
  if (ut(t)) return (e = t.__posthog_layer__) !== null && e !== void 0 ? e : t.__rrweb_layer__;
};
function ao(t, e, n) {
  try {
    if (!(e in t)) return Fg;
    const i = { next: t[e] }, r = n(function(...s) {
      return i.next.apply(this, s);
    });
    return ut(r) && (r.prototype = r.prototype || {}, Object.defineProperties(r, { __posthog_wrapped__: { enumerable: !1, value: !0 }, __posthog_layer__: { enumerable: !1, value: i } })), t[e] = r, () => {
      if (t[e] === r) return void (t[e] = i.next);
      let s = t[e], o = Lg(s);
      for (; o; ) {
        if (o.next === r) return void (o.next = i.next);
        s = o.next, o = Lg(s);
      }
    };
  } catch {
    return Fg;
  }
}
const oD = Ze("[TracingHeaders]"), Rn = Ze("[Web Vitals]"), Ng = 9e5, Vg = ["CLS", "FCP", "INP", "LCP"], aD = ["INP", "LCP"], lD = ["interactionTarget", "interactionType", "inputDelay", "processingDuration", "presentationDelay", "loadState", "target", "url", "timeToFirstByte", "resourceLoadDelay", "resourceLoadDuration", "elementRenderDelay", "largestShiftTarget", "largestShiftTime", "largestShiftValue", "firstByteToFCP"], eu = "disabled", jg = "lazy_loading", Ri = Ze("[SessionRecording]"), cD = Ze("[Heatmaps]");
function tu(t) {
  return Ee(t) && "clientX" in t && "clientY" in t && Qe(t.clientX) && Qe(t.clientY);
}
const ca = Ze("[Product Tours]"), iu = (t) => {
  var e;
  return !t.config.disable_product_tours && !!(!((e = t.persistence) === null || e === void 0) && e.get_property(of));
}, uD = ["$set_once", "$set"], ui = Ze("[SiteApps]"), zg = "Error while initializing PostHog app with config id ", dk = (t, e) => t?.then ? t.then(e) : e(t), fr = "SDK is not enabled or survey functionality is not yet loaded", Bg = "Disabled. Not loading surveys.";
var dD = class {
  constructor(t, e) {
    this.So = t, this.Th = e, this.name = "surveys", this._surveyEventReceiver = null, this._surveyManager = null, this.Ih = !1, this.Mh = [], this.Eh = null, this.Ph = null, this.Io = !1, this.Rh = /* @__PURE__ */ new Set(), this.onRemoteConfig = (n) => {
      if (this.Io || this.Rr.disableSurveys) return;
      if (!n.ok) return De.warn("Remote config unavailable. Not loading surveys.");
      const i = n.config.surveys;
      if (ve(i)) return De.warn("Flags not loaded yet. Not loading surveys.");
      this.Ah = Tt(i) ? i : i.length > 0, De.info(`flags response received, isSurveysEnabled: ${this.Ah}`), this.loadIfEnabled();
    };
  }
  setup(t) {
    if (!this.Io) return this.Fh = t, dk(t.kv.initialize(), () => {
      if (this.Fh !== t || this.Io) return;
      this.Fh = void 0, this.wo = t;
      const e = t.onRemoteConfig(this.onRemoteConfig);
      this.Io ? e.dispose() : (this.Po = e, this.loadIfEnabled());
    });
  }
  dispose() {
    var t, e, n, i;
    this.Io || (this.Io = !0, this.Fh = void 0, this.wo = void 0, (t = this.Po) === null || t === void 0 || t.dispose(), this.Po = void 0, (e = this._surveyEventReceiver) === null || e === void 0 || e.dispose(), this._surveyEventReceiver = null, (n = this._surveyManager) === null || n === void 0 || (i = n.dispose) === null || i === void 0 || i.call(n), this._surveyManager = null, this.Mh = [], this.Eh = null, this.Rh.forEach((r) => clearTimeout(r)), this.Rh.clear());
  }
  get Rr() {
    return this.So.get();
  }
  initialize() {
    this.loadIfEnabled();
  }
  reset() {
    var t, e;
    (t = this._surveyManager) === null || t === void 0 || (e = t.clearInMemoryInProgressSurveyState) === null || e === void 0 || e.call(t);
    try {
      var n;
      (n = this._surveyEventReceiver) === null || n === void 0 || n.reset(), localStorage.removeItem("lastSeenSurveyDate");
      const i = [];
      for (let r = 0; r < localStorage.length; r++) {
        const s = localStorage.key(r);
        (s?.startsWith("seenSurvey_") || s?.startsWith("inProgressSurvey_")) && i.push(s);
      }
      i.forEach((r) => localStorage.removeItem(r));
    } catch {
    }
  }
  loadIfEnabled() {
    if (this.Io || !this.wo) return;
    const t = this.Rr;
    if (this._surveyManager) return;
    if (this.Ih) return void De.info("Already initializing surveys, skipping...");
    if (t.disableSurveys) return void De.info(Bg);
    if (t.cookielessMode && this.So.isOptedOut()) return void De.info("Not loading surveys in cookieless mode without consent.");
    const e = this.So.getExtensions();
    if (!e) return void De.error("PostHog Extensions not found.");
    if (G(this.Ah) && !t.advancedEnableSurveys) return;
    const n = this.Ah || t.advancedEnableSurveys;
    this.Ih = !0;
    try {
      const i = e.generateSurveys;
      if (i) return this.Oh(i, n), void (this.Ih = !1);
      const r = e.loadExternalDependency;
      if (!r) return this.Dh(lf), void (this.Ih = !1);
      r((s) => {
        try {
          if (this.Io) return;
          const o = this.So.getExtensions();
          s || !o?.generateSurveys ? this.Dh("Could not load surveys script", s) : this.Oh(o.generateSurveys, n);
        } finally {
          this.Ih = !1;
        }
      });
    } catch (i) {
      throw this.Ih = !1, this.Dh("Error initializing surveys", i), i;
    }
  }
  Oh(t, e) {
    this.Io || (this._surveyManager = t(e), this._surveyEventReceiver = this.So.createEventReceiver(), De.info("Surveys loaded successfully"), this.Lh({ isLoaded: !0 }));
  }
  Dh(t, e) {
    De.error(t, e), this.Lh({ isLoaded: !1, error: t });
  }
  onSurveysLoaded(t) {
    return this.Mh.push(t), this._surveyManager && this.Lh({ isLoaded: !0 }), () => {
      this.Mh = this.Mh.filter((e) => e !== t);
    };
  }
  getSurveys(t, e = !1) {
    var n;
    const i = (n = this.wo) !== null && n !== void 0 ? n : this.Th;
    if (!i || this.Io) return;
    if (this.Rr.disableSurveys) return De.info(Bg), t([]);
    const r = i.kv.get(bd);
    if (r && !e) return t(r, { isLoaded: !0 }), void (this.Nh() && this.getSurveys(() => {
    }, !0));
    if (this.Eh) return void this.Eh.then(({ surveys: a, context: l }) => {
      this.Io || t(a, l);
    }).catch((a) => De.error("Error in survey callback", a));
    const s = this.qh("/api/surveys/", { method: "GET", query: { token: i.projectToken }, sentAt: "query", timeoutMs: this.Rr.requestTimeoutMs }).then((a) => {
      try {
        return this.jh(i, a);
      } catch (l) {
        return De.error("Error processing surveys response", l), this.jh(i, { statusCode: 0, error: l });
      }
    }, (a) => this.jh(i, { statusCode: 0, error: a }));
    this.Eh = s;
    const o = () => {
      this.Eh === s && (this.Eh = null);
    };
    s.then((a) => {
      o(), this.Io || t(a.surveys, a.context);
    }, o).catch((a) => De.error("Error in survey callback", a));
  }
  qh(t, e) {
    const n = this.wo;
    return n ? n.sendRequest(t, e) : new Promise((i) => i({ statusCode: 0, error: new Error(fr) }));
  }
  jh(t, e) {
    if (this.Io) return { surveys: [], context: { isLoaded: !1, error: fr } };
    const n = e.statusCode;
    if (n !== 200 || !e.json) {
      const o = `Surveys API could not be loaded, status: ${n}`;
      return n !== 0 ? De.error(o) : e.error || De.warn(o), this.Ph = Date.now(), { surveys: [], context: { isLoaded: !1, error: o } };
    }
    this.Ph = null;
    const i = e.json.surveys || [], r = i.filter((o) => (function(a) {
      return !(!a.start_date || a.end_date);
    })(o) && (sk(o) || (function(a) {
      var l;
      return !!(!((l = a.conditions) === null || l === void 0 || (l = l.actions) === null || l === void 0 || (l = l.values) === null || l === void 0) && l.length);
    })(o)));
    var s;
    return r.length > 0 && ((s = this._surveyEventReceiver) === null || s === void 0 || s.register(r)), t.kv.set({ [bd]: i, [ll]: Date.now() }), { surveys: i, context: { isLoaded: !0 } };
  }
  Nh() {
    return this.Bh() && !this.Eh && !this.Hh();
  }
  Bh() {
    var t, e;
    const n = (t = (e = this.wo) !== null && e !== void 0 ? e : this.Th) === null || t === void 0 ? void 0 : t.kv.get(ll);
    return Qe(n) && Date.now() - n > 3e5;
  }
  Hh() {
    return Qe(this.Ph) && 3e5 > Date.now() - this.Ph;
  }
  markSurveyAsSeen(t, e) {
    var n;
    const i = { id: t, current_iteration: (n = e?.iteration) !== null && n !== void 0 ? n : null };
    lk(i);
    try {
      localStorage.setItem("lastSeenSurveyDate", (/* @__PURE__ */ new Date()).toISOString());
    } catch {
    }
  }
  Lh(t) {
    for (const e of this.Mh) try {
      if (!t.isLoaded) return e([], t);
      this.getSurveys(e);
    } catch (n) {
      De.error("Error in survey callback", n);
    }
  }
  getActiveMatchingSurveys(t, e = !1) {
    if (!ve(this._surveyManager)) return this._surveyManager.getActiveMatchingSurveys(t, e);
    De.warn("init was not called");
  }
  zh(t) {
    let e = null;
    return this.getSurveys((n) => {
      var i;
      e = (i = n.find((r) => r.id === t)) !== null && i !== void 0 ? i : null;
    }), e;
  }
  Uh(t) {
    if (ve(this._surveyManager)) return { eligible: !1, reason: fr };
    const e = typeof t == "string" ? this.zh(t) : t;
    return e ? this._surveyManager.checkSurveyEligibility(e) : { eligible: !1, reason: "Survey not found" };
  }
  Wh(t) {
    if (!this.So.isCapturing()) return { eligible: !1, reason: "PostHog is not capturing, so a survey response cannot be recorded" };
    if (ve(this._surveyManager)) return { eligible: !1, reason: fr };
    const e = typeof t == "string" ? this.zh(t) : t;
    return e ? this._surveyManager.checkSurveyRenderability(e) : { eligible: !1, reason: "Survey not found" };
  }
  canRenderSurvey(t) {
    if (ve(this._surveyManager)) return De.warn("init was not called"), { visible: !1, disabledReason: fr };
    const e = this.Wh(t);
    return { visible: e.eligible, disabledReason: e.reason };
  }
  canRenderSurveyAsync(t, e) {
    return ve(this._surveyManager) ? (De.warn("init was not called"), Promise.resolve({ visible: !1, disabledReason: fr })) : new Promise((n) => {
      this.getSurveys((i) => {
        var r;
        const s = (r = i.find((o) => o.id === t)) !== null && r !== void 0 ? r : null;
        if (s) {
          const o = this.Wh(s);
          n({ visible: o.eligible, disabledReason: o.reason });
        } else n({ visible: !1, disabledReason: "Survey not found" });
      }, e);
    });
  }
  renderSurvey(t, e, n) {
    var i;
    if (!this.So.isCapturing()) return;
    if (ve(this._surveyManager)) return void De.warn("init was not called");
    const r = typeof t == "string" ? this.zh(t) : t;
    if (!r?.id) return void De.warn("Survey not found");
    if (!H4.includes(r.type)) return void De.warn(`Surveys of type ${r.type} cannot be rendered in the app`);
    const s = Y?.querySelector(e);
    if (s) {
      if (!((i = r.appearance) === null || i === void 0) && i.surveyPopupDelaySeconds) {
        De.info(`Rendering survey ${r.id} with delay of ${r.appearance.surveyPopupDelaySeconds} seconds`);
        const o = setTimeout(() => {
          var a, l;
          this.Rh.delete(o), !this.Io && this.So.isCapturing() && (De.info(`Rendering survey ${r.id} with delay of ${(a = r.appearance) === null || a === void 0 ? void 0 : a.surveyPopupDelaySeconds} seconds`), (l = this._surveyManager) === null || l === void 0 || l.renderSurvey(r, s, n), De.info(`Survey ${r.id} rendered`));
        }, 1e3 * r.appearance.surveyPopupDelaySeconds);
        return void this.Rh.add(o);
      }
      this._surveyManager.renderSurvey(r, s, n);
    } else De.warn("Survey element not found");
  }
  displaySurvey(t, e) {
    var n;
    if (!this.So.isCapturing()) return;
    if (ve(this._surveyManager)) return void De.warn("init was not called");
    const i = this.zh(t);
    if (!i) return void De.warn("Survey not found");
    let r = i;
    if (!((n = i.appearance) === null || n === void 0) && n.surveyPopupDelaySeconds && e.ignoreDelay && (r = R(R({}, i), {}, { appearance: R(R({}, i.appearance), {}, { surveyPopupDelaySeconds: 0 }) })), e.displayType !== fl.Popover && e.initialResponses && De.warn("initialResponses is only supported for popover surveys. prefill will not be applied."), e.ignoreConditions === !1) {
      const s = this.Uh(i);
      if (!s.eligible) return void De.warn("Survey is not eligible to be displayed: ", s.reason);
    }
    e.displayType !== fl.Inline ? this._surveyManager.handlePopoverSurvey(r, e) : this.renderSurvey(r, e.selector, e.properties);
  }
  cancelPendingSurvey(t) {
    ve(this._surveyManager) ? De.warn("init was not called") : this._surveyManager.cancelSurvey(t);
  }
  handlePageUnload() {
    var t, e;
    (t = this._surveyManager) === null || t === void 0 || (e = t.handlePageUnload) === null || e === void 0 || e.call(t);
  }
};
function pr(t, e, n) {
  if (ve(t)) return !1;
  switch (n) {
    case "exact":
      return t === e;
    case "contains": {
      const i = e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/_/g, ".").replace(/%/g, ".*");
      return new RegExp(i, "i").test(t);
    }
    case "regex":
      try {
        return new RegExp(e).test(t);
      } catch {
        return !1;
      }
    default:
      return !1;
  }
}
var hD = class {
  constructor(t) {
    this._instance = t, this.Vh = /* @__PURE__ */ new Set(), this.Gh = /* @__PURE__ */ new Set(), this.Zh = new ml(), this.Qh = (e, n) => this.Jh(e, n) && this.Kh(e, n) && this.Xh(e, n) && this.Yh(e, n), this.Jh = (e, n) => !n?.event || e?.event === n?.event;
  }
  init() {
    var t, e;
    G((t = this._instance) === null || t === void 0 ? void 0 : t._addCaptureHook) || (this.tc = (e = this._instance) === null || e === void 0 ? void 0 : e._addCaptureHook((n, i) => {
      this.on(n, i);
    }));
  }
  dispose() {
    var t;
    (t = this.tc) === null || t === void 0 || t.call(this), this.tc = void 0, this.Zh = new ml();
  }
  register(t) {
    var e, n;
    if (!G((e = this._instance) === null || e === void 0 ? void 0 : e._addCaptureHook) && (t.forEach((i) => {
      var r;
      this.Vh.add(i), (r = i.steps) === null || r === void 0 || r.forEach((s) => {
        this.Gh.add(s?.event || "");
      });
    }), (n = this._instance) === null || n === void 0 ? void 0 : n.autocapture)) {
      const i = /* @__PURE__ */ new Set();
      this.Vh.forEach((r) => {
        var s;
        (s = r.steps) === null || s === void 0 || s.forEach((o) => {
          o?.selector && i.add(o.selector);
        });
      }), this._instance.autocapture.setElementSelectors(i);
    }
  }
  replace(t) {
    this.Vh.clear(), this.Gh.clear(), this.register(t);
  }
  on(t, e) {
    e != null && t.length != 0 && (this.Gh.has(t) || this.Gh.has(e.event)) && this.Vh.forEach((n) => {
      this.ec(e, n) && this.Zh.emit("actionCaptured", n.name);
    });
  }
  nc(t) {
    this.onAction("actionCaptured", (e) => t(e));
  }
  ec(t, e) {
    if (e?.steps == null) return !1;
    for (const n of e.steps) if (this.Qh(t, n)) return !0;
    return !1;
  }
  onAction(t, e) {
    return this.Zh.on(t, e);
  }
  Kh(t, e) {
    if (e?.url) {
      var n;
      const i = t == null || (n = t.properties) === null || n === void 0 ? void 0 : n.$current_url;
      if (!i || typeof i != "string" || !pr(i, e.url, e.url_matching || "contains")) return !1;
    }
    return !0;
  }
  Xh(t, e) {
    return !!this.sc(t, e) && !!this.rc(t, e) && !!this.oc(t, e);
  }
  sc(t, e) {
    var n;
    if (!e?.href) return !0;
    const i = this.ac(t);
    if (i.length > 0) return i.some((s) => pr(s.href, e.href, e.href_matching || "exact"));
    const r = (t == null || (n = t.properties) === null || n === void 0 ? void 0 : n.$elements_chain) || "";
    return !!r && pr((function(s) {
      const o = s.match(/(?::|")href="(.*?)"/);
      return o ? o[1] : "";
    })(r), e.href, e.href_matching || "exact");
  }
  rc(t, e) {
    var n;
    if (!e?.text) return !0;
    const i = this.ac(t);
    if (i.length > 0) return i.some((l) => pr(l.text, e.text, e.text_matching || "exact") || pr(l.$el_text, e.text, e.text_matching || "exact"));
    const r = (t == null || (n = t.properties) === null || n === void 0 ? void 0 : n.$elements_chain) || "";
    return !!r && (s = (function(l) {
      const c = [], u = /(?::|")text="(.*?)"/g;
      let d;
      for (; !ve(d = u.exec(l)); ) c.includes(d[1]) || c.push(d[1]);
      return c;
    })(r), o = e.text, a = e.text_matching || "exact", s.some((l) => pr(l, o, a)));
    var s, o, a;
  }
  oc(t, e) {
    var n, i;
    if (!e?.selector) return !0;
    const r = t == null || (n = t.properties) === null || n === void 0 ? void 0 : n.$element_selectors;
    if (r?.includes(e.selector)) return !0;
    const s = (t == null || (i = t.properties) === null || i === void 0 ? void 0 : i.$elements_chain) || "";
    if (e.selector_regex && s) try {
      return new RegExp(e.selector_regex).test(s);
    } catch {
      return !1;
    }
    return !1;
  }
  ac(t) {
    var e;
    return (t == null || (e = t.properties) === null || e === void 0 ? void 0 : e.$elements) == null ? [] : t?.properties.$elements;
  }
  Yh(t, e) {
    return !e?.properties || e.properties.length === 0 || ak(e.properties.reduce((n, i) => {
      const r = de(i.value) ? i.value.map(String) : i.value != null ? [String(i.value)] : [];
      return n[i.key] = { values: r, operator: i.operator || "exact" }, n;
    }, {}), t?.properties);
  }
}, fD = class {
  constructor(t) {
    var e, n;
    this.lc = [], this._instance = t, this.uc = /* @__PURE__ */ new Map(), this.hc = /* @__PURE__ */ new Map(), this.cc = /* @__PURE__ */ new Map(), this.dc = (e = this._instance) === null || e === void 0 || (n = e.onSessionId) === null || n === void 0 ? void 0 : n.call(e, (i) => this.vc(i));
  }
  fc(t) {
    return !1;
  }
  gc() {
    return null;
  }
  mc(t) {
  }
  yc() {
  }
  bc(t, e) {
    return !!t && ak(t.propertyFilters, e?.properties);
  }
  _c(t, e) {
    const n = /* @__PURE__ */ new Map();
    return t.forEach((i) => {
      var r;
      (r = i.conditions) === null || r === void 0 || (r = r[e]) === null || r === void 0 || (r = r.values) === null || r === void 0 || r.forEach((s) => {
        if (s?.name) {
          const o = n.get(s.name) || [];
          o.push(i.id), n.set(s.name, o);
        }
      });
    }), n;
  }
  wc(t, e, n) {
    const i = (n === vr.Activation ? this.uc : this.hc).get(t);
    let r = [];
    return this.kc((s) => {
      r = s.filter((o) => i?.includes(o.id));
    }), r.filter((s) => {
      var o;
      const a = (o = s.conditions) === null || o === void 0 || (o = o[n]) === null || o === void 0 || (o = o.values) === null || o === void 0 ? void 0 : o.find((l) => l.name === t);
      return this.bc(a, e);
    });
  }
  register(t) {
    this.Sc(t, !1);
  }
  replace(t) {
    this.Sc(t, !0);
  }
  Sc(t, e) {
    var n;
    G((n = this._instance) === null || n === void 0 ? void 0 : n._addCaptureHook) || (this.xc(t, e), this.Cc(t, e));
  }
  Cc(t, e) {
    const n = t.filter((s) => {
      var o;
      return (o = s.conditions) === null || o === void 0 || (o = o.actions) === null || o === void 0 || (o = o.values) === null || o === void 0 ? void 0 : o.length;
    });
    var i;
    if (e && this.cc.clear(), n.length === 0) return void (e && ((i = this.$c) === null || i === void 0 || i.replace([])));
    this.$c || (this.$c = new hD(this._instance), this.$c.init(), this.$c.nc((s) => this.onAction(s)));
    const r = [];
    n.forEach((s) => {
      var o;
      (o = s.conditions) === null || o === void 0 || (o = o.actions) === null || o === void 0 || o.values.forEach((a) => {
        if (r.push(a), a.name) {
          var l;
          const c = (l = this.cc.get(a.name)) !== null && l !== void 0 ? l : [];
          c.includes(s.id) || c.push(s.id), this.cc.set(a.name, c);
        }
      });
    }), e ? this.$c.replace(r) : this.$c.register(r);
  }
  Tc(t, e) {
    e.forEach((n, i) => {
      var r;
      const s = (r = t.get(i)) !== null && r !== void 0 ? r : [];
      n.forEach((o) => {
        s.includes(o) || s.push(o);
      }), t.set(i, s);
    });
  }
  xc(t, e) {
    var n, i;
    const r = t.filter((l) => {
      var c, u;
      return ((c = l.conditions) === null || c === void 0 ? void 0 : c.events) && ((u = l.conditions) === null || u === void 0 || (u = u.events) === null || u === void 0 || (u = u.values) === null || u === void 0 ? void 0 : u.length) > 0;
    }), s = t.filter((l) => {
      var c, u;
      return ((c = l.conditions) === null || c === void 0 ? void 0 : c.cancelEvents) && ((u = l.conditions) === null || u === void 0 || (u = u.cancelEvents) === null || u === void 0 || (u = u.values) === null || u === void 0 ? void 0 : u.length) > 0;
    }), o = this._c(t, vr.Activation), a = this._c(t, vr.Cancellation);
    e ? (this.uc = o, this.hc = a) : (this.Tc(this.uc, o), this.Tc(this.hc, a)), (r.length !== 0 || s.length !== 0) && ((n = this.tc) !== null && n !== void 0 || (this.tc = (i = this._instance) === null || i === void 0 ? void 0 : i._addCaptureHook((l, c) => {
      this.onEvent(l, c);
    })));
  }
  onEvent(t, e) {
    var n, i;
    const r = this.Ic(), s = (e == null || (n = e.properties) === null || n === void 0 ? void 0 : n.$survey_id) || (e == null || (i = e.properties) === null || i === void 0 ? void 0 : i.$product_tour_id);
    if (s && this.getActivatedIds().includes(s)) {
      const a = this.Mc(t, s);
      if (a === "consume") return r.info("event consumed activated item, removing it", { event: t, itemId: s }), void this.Ec([s]);
      if (a === "persist") return r.info("shown item promoted to persisted activation", { event: t, itemId: s }), this.Pc(s), void this.Rc([s]);
    }
    if (this.hc.has(t)) {
      const a = this.wc(t, e, vr.Cancellation);
      a.length > 0 && (r.info("cancel event matched, cancelling items", { event: t, itemsToCancel: a.map((l) => l.id) }), this.Ec(a.map((l) => l.id)), a.forEach((l) => this.Ac(l.id)));
    }
    if (!this.uc.has(t)) return;
    r.info("event name matched", { event: t, eventPayload: e, items: this.uc.get(t) });
    const o = this.wc(t, e, vr.Activation);
    this.Fc(o.map((a) => a.id));
  }
  onAction(t) {
    this.cc.has(t) && this.Fc(this.cc.get(t) || []);
  }
  Fc(t) {
    var e, n;
    if (t.length === 0) return;
    const i = !!(!((e = this._instance) === null || e === void 0 || (n = e.get_session_id) === null || n === void 0) && n.call(e)), r = [];
    for (const s of t) i && this.fc(s) ? this.Pc(s) && this.Oc(s) : r.push(s);
    r.length > 0 && (this.lc = [.../* @__PURE__ */ new Set([...this.lc, ...r])]), this.Ic().info("updating activated items", { activatedItems: this.getActivatedIds() });
  }
  Pc(t) {
    this.lc = this.lc.filter((n) => n !== t);
    const e = this.Dc();
    return !e.includes(t) && (this.Lc([...e, t]), this.Nc(), !0);
  }
  Ec(t) {
    const e = new Set(t);
    this.lc = this.lc.filter((r) => !e.has(r));
    const n = this.qc(), i = n.filter((r) => !e.has(r));
    i.length !== n.length && (this.Lc(i), i.length === 0 && this.jc()), this.Rc(t);
  }
  Bc() {
    var t;
    const e = this.gc();
    if (!e) return {};
    const n = (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 ? void 0 : t.props[e];
    return n && typeof n == "object" ? n : {};
  }
  Oc(t) {
    if (!this.gc()) return;
    const e = this.Bc();
    this.mc(R(R({}, e), {}, { [t]: Date.now() }));
  }
  Rc(t) {
    if (!this.gc()) return;
    const e = this.Bc(), n = {};
    let i = !1;
    for (const [r, s] of Object.entries(e)) t.includes(r) ? i = !0 : n[r] = s;
    i && (Ot(n) ? this.yc() : this.mc(n));
  }
  Hc() {
    this.gc() && this.yc();
  }
  getActivationTimestamp(t) {
    if (!this.Dc().includes(t)) return;
    const e = this.Bc()[t];
    return Qe(e) ? e : void 0;
  }
  qc() {
    var t;
    const e = this.zc();
    return ((t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 ? void 0 : t.props[e]) || [];
  }
  Dc() {
    var t, e, n;
    const i = this.qc();
    if (i.length === 0) return [];
    const r = (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 ? void 0 : t.props[this.Uc()], s = (e = this._instance) === null || e === void 0 || (n = e.get_session_id) === null || n === void 0 ? void 0 : n.call(e);
    return s && r === s ? i : [];
  }
  Nc() {
    var t, e;
    const n = (t = this._instance) === null || t === void 0 || (e = t.get_session_id) === null || e === void 0 ? void 0 : e.call(t);
    n && this.Wc(n);
  }
  jc() {
    this.Vc();
  }
  vc(t) {
    var e;
    const n = (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 ? void 0 : e.props[this.Uc()];
    if (n && n !== t) {
      const i = this.qc(), r = this.Bc();
      i.length > 0 && (this.Lc([]), i.filter((s) => Qe(r[s])).forEach((s) => this.Ac(s))), this.jc(), this.Hc();
    }
  }
  getActivatedIds() {
    return [.../* @__PURE__ */ new Set([...this.Dc(), ...this.lc])].filter((t) => !this.Gc(t));
  }
  dispose() {
    var t, e, n;
    (t = this.dc) === null || t === void 0 || t.call(this), this.dc = void 0, (e = this.tc) === null || e === void 0 || e.call(this), this.tc = void 0, (n = this.$c) === null || n === void 0 || n.dispose(), this.$c = void 0;
  }
  reset() {
    this.lc = [], this.qc().length > 0 && this.Lc([]), this.jc(), this.Hc();
  }
  getEventToItemsMap() {
    return this.uc;
  }
  Zc() {
    return this.$c;
  }
}, pD = class extends fD {
  constructor(t) {
    super(t);
  }
  zc() {
    return nw;
  }
  Uc() {
    return rw;
  }
  gc() {
    return sw;
  }
  mc(t) {
    var e;
    (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 || e.register({ $surveys_activated_timestamps: t });
  }
  yc() {
    var t;
    (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 || t.unregister("$surveys_activated_timestamps");
  }
  fc(t) {
    var e;
    let n;
    this.kc((r) => {
      n = r.find((s) => s.id === t);
    });
    const i = n == null || (e = n.appearance) === null || e === void 0 ? void 0 : e.surveyPopupDelaySeconds;
    return Qe(i) && i > 0;
  }
  Qc() {
    return gi.SHOWN;
  }
  kc(t) {
    var e;
    (e = this._instance) === null || e === void 0 || e.getSurveys(t);
  }
  Ac(t) {
    var e;
    (e = this._instance) === null || e === void 0 || e.cancelPendingSurvey(t);
  }
  Ic() {
    return De;
  }
  Lc(t) {
    var e;
    (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 || e.register({ $surveys_activated: t });
  }
  Wc(t) {
    var e;
    (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 || e.register({ $surveys_activated_session: t });
  }
  Vc() {
    var t;
    (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 || t.unregister("$surveys_activated_session");
  }
  Gc() {
    return !1;
  }
  Mc(t, e) {
    let n;
    return this.kc((i) => {
      n = i.find((r) => r.id === e);
    }), !n || (function(i) {
      var r;
      return sk(i) && !!(!((r = i.conditions) === null || r === void 0 || (r = r.events) === null || r === void 0) && r.repeatedActivation) || i.schedule === "always";
    })(n) ? t === gi.SHOWN ? "consume" : "ignore" : t === gi.SHOWN ? "persist" : t === gi.DISMISSED || t === gi.SENT ? "consume" : "ignore";
  }
  getSurveys() {
    return this.getActivatedIds();
  }
  getEventToSurveys() {
    return this.getEventToItemsMap();
  }
}, mD = class {
  constructor(e) {
    this._instance = e;
  }
  initialize() {
  }
  get(e) {
    if (typeof e == "string") return this._instance.get_property(e);
    const n = {};
    for (const i of e) {
      const r = this._instance.get_property(i);
      G(r) || (n[i] = r);
    }
    return n;
  }
  set(e, n) {
    this._instance.register(typeof e == "string" ? { [e]: n } : e);
  }
  remove(e) {
    typeof e != "string" ? e.forEach((n) => this._instance.unregister(n)) : this._instance.unregister(e);
  }
}, gD = class {
  constructor(t) {
    this._instance = t;
  }
  get() {
    const t = this._instance.config;
    return { disableSurveys: t.disable_surveys, cookielessMode: !!t.cookieless_mode, advancedEnableSurveys: t.advanced_enable_surveys, requestTimeoutMs: t.surveys_request_timeout_ms };
  }
  isOptedOut() {
    return this._instance.consent.isOptedOut();
  }
  isCapturing() {
    return this._instance.is_capturing();
  }
  getExtensions() {
    const t = le?.__PosthogExtensions__;
    if (!t) return;
    const { generateSurveys: e, loadExternalDependency: n } = t;
    return { generateSurveys: e ? (i) => e(this._instance, i) : void 0, loadExternalDependency: n ? (i) => n(this._instance, "surveys", i) : void 0 };
  }
  createEventReceiver() {
    return new pD(this._instance);
  }
};
const vD = L?.location ? dl(L.location.hash, "__posthog") || dl(location.hash, "state") : null, Hg = "_postHogToolbarParams", Ug = Ze("[Toolbar]"), Wg = Ze("[FeatureFlags]");
var yD = class {
  constructor(t, e = !1) {
    this.Jc = !1, this.update(t, e);
  }
  update(t, e) {
    this.Kc = ((n, i) => {
      var r, s, o, a, l, c, u, d;
      return { bootstrap: { featureFlags: (r = (s = n.bootstrap) === null || s === void 0 ? void 0 : s.featureFlags) !== null && r !== void 0 ? r : void 0, featureFlagPayloads: (o = (a = n.bootstrap) === null || a === void 0 ? void 0 : a.featureFlagPayloads) !== null && o !== void 0 ? o : void 0 }, remoteRequestsDisabled: i, featureFlagsDisabled: !!n.advanced_disable_feature_flags, onlyEvaluateSurveyFeatureFlags: !!n.advanced_only_evaluate_survey_feature_flags, deduplicateCallsPerSession: !!n.advanced_feature_flags_dedup_per_session, cacheTtlMs: n.feature_flag_cache_ttl_ms, refreshIntervalMs: (l = n.remote_config_refresh_interval_ms) !== null && l !== void 0 ? l : 3e5, idleRefreshBackoff: G(n.remote_config_refresh_interval_ms), requestTimeoutMs: n.feature_flag_request_timeout_ms, requestMaxRetries: Math.max(0, (c = n.feature_flag_request_max_retries) !== null && c !== void 0 ? c : 1), compression: n.disable_compression ? void 0 : "best-available", evaluationContexts: (u = (d = n.evaluation_contexts) !== null && d !== void 0 ? d : n.evaluation_environments) !== null && u !== void 0 ? u : [], flagKeys: de(n.flag_keys) ? n.flag_keys : void 0 };
    })(t, e), !t.evaluation_environments || t.evaluation_contexts || this.Jc || (Wg.warn("evaluation_environments is deprecated. Use evaluation_contexts instead. evaluation_environments will be removed in a future version."), this.Jc = !0), G(t.flag_keys) || de(t.flag_keys) || Wg.error("Invalid flag_keys found:", t.flag_keys, "Expected array of non-empty strings");
  }
  get() {
    return this.Kc;
  }
};
const qg = Ze("[FeatureFlags]"), Mn = Ze("[FeatureFlags]", { debugEnabled: !0 }), nu = `" failed. Feature flags didn't load in time.`, bD = [502, 504], Gg = ["click", "keydown", "wheel", "touchstart", "pointerdown"], Kg = "connection_error", Yg = (t) => {
  const e = {};
  for (let n = 0; t.length > n; n++) e[t[n]] = !0;
  return e;
}, Xg = (t) => {
  const e = {};
  for (const [n, i] of Aa(t || {})) i && (e[n] = i);
  return e;
}, Jg = (t) => as(t) && (t.name === "RangeError" && t.message.indexOf("Maximum call stack size exceeded") === 0 || t.name === "InternalError" && t.message === "too much recursion"), Qt = Ze("[Error tracking]"), Od = "webkit-masked-url:", _D = [{ value: "isolatedAPI.contexts.topHostname", exact: !1 }, { value: "No response from target", exact: !0 }], wD = ["chrome-extension://", "moz-extension://", "safari-extension:", "safari-web-extension:", Od], kD = ["__firefox__", "__gCrWeb"], Zg = "Refusing to render web experiment since the viewer is a likely bot", xD = { icontains: (t, e) => e.toLowerCase().indexOf(t.toLowerCase()) > -1, not_icontains: (t, e) => e.toLowerCase().indexOf(t.toLowerCase()) === -1, regex: (t, e) => gl(e, t), not_regex: (t, e) => !gl(e, t), exact: (t, e) => e === t, is_not: (t, e) => e !== t }, Ut = Ze("[Conversations]"), On = "Conversations not available yet.";
function Qg(t, e) {
  var n, i, r, s, o, a, l;
  const c = (n = t?.flushIntervalMs) !== null && n !== void 0 ? n : 3e3, u = (i = t?.maxBufferSize) !== null && i !== void 0 ? i : 100, d = e?.consoleCapture ? void 0 : (r = t?.maxLogsPerInterval) !== null && r !== void 0 ? r : 1e3, h = G(d) ? Math.max(u, 2048) : Math.max(u, d), f = R(R({}, (function() {
    let p = "", v = "";
    try {
      const g = dt?.userAgent;
      g && ([p, v] = C_(g));
    } catch {
    }
    return (function(g, m) {
      const y = (function(k) {
        if (k) return {}.hasOwnProperty.call(Km, k) ? Km[k] : k;
      })(g);
      return R(R({}, y ? { "os.name": y } : {}), m ? { "os.version": m } : {});
    })(p, v);
  })()), t?.resourceAttributes);
  return { serviceName: (s = (o = f?.["service.name"]) !== null && o !== void 0 ? o : t?.serviceName) !== null && s !== void 0 ? s : e?.serviceNameDefault, serviceVersion: (a = f?.["service.version"]) !== null && a !== void 0 ? a : t?.serviceVersion, environment: (l = f?.["deployment.environment"]) !== null && l !== void 0 ? l : t?.environment, resourceAttributes: f, beforeSend: t?.beforeSend, flushIntervalMs: c, maxBufferSize: u, maxQueueSize: h, maxBatchRecordsPerPost: 100, rateCapWindowMs: c, maxLogsPerInterval: d, backgroundFlushBudgetMs: 0, terminationFlushBudgetMs: 0 };
}
const SD = ["debug", "log", "warn", "error", "info"], PD = (t) => {
  for (; t?.__rrweb_original__; ) t = t.__rrweb_original__;
  return t;
}, ev = "console", hk = "__posthogHandledLogsRequestError", ru = (t, e) => {
  const n = t instanceof Error ? t : new Error(e);
  return n[hk] = !0, n;
}, tv = (t) => !!t && typeof t == "object" && t[hk] === !0, vl = Ze("[NetworkMetrics]"), vf = () => {
  var t;
  return !(L == null || (t = L.performance) === null || t === void 0) && t.now ? L.performance.now() : Date.now();
}, ED = { "http:": 80, "https:": 443 }, TD = /* @__PURE__ */ new Set(["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"]), fk = (t, e) => {
  var n;
  const i = String(e);
  return { method: String(t).toUpperCase(), url: ((n = Wi(i)) === null || n === void 0 ? void 0 : n.href) || i };
}, Id = (t, e, n, i, r, s, o = !1) => {
  try {
    var a, l;
    const c = r();
    if (!c) return;
    const u = n || void 0, d = vf() - i, h = Wi(e.url);
    if (h && h.protocol !== "http:" && h.protocol !== "https:") return;
    const f = { url: h?.href || e.url, method: e.method }, p = ut(c.name) ? c.name(f) : Pe(c.name) ? c.name : "http.client.request.duration";
    if (!p) return;
    const v = o && !u ? void 0 : ((m, y) => m ? 400 > m ? void 0 : String(m) : y?.name || "_OTHER")(u, s), g = R(R(R(R(R({}, ((m) => {
      const y = TD.has(m) ? m : "_OTHER";
      return R({ "http.request.method": y }, y === "_OTHER" && m !== y ? { "http.request.method_original": m } : {});
    })(f.method)), h ? ((m) => {
      return { "server.address": m.hostname.startsWith("[") && m.hostname.endsWith("]") ? m.hostname.slice(1, -1) : m.hostname, "server.port": Number(m.port) || ED[m.protocol], "url.scheme": m.protocol.slice(0, -1), "url.template": (y = m.pathname, y.split("/").map((k) => ((_) => /^\d+$/.test(_) || _.length >= 8 && /^[0-9a-f-]*\d[0-9a-f-]*$/i.test(_))(k) ? ":id" : k).join("/")) };
      var y;
    })(h) : {}), u ? { "http.response.status_code": u } : {}), v ? { "error.type": v } : {}), (a = c.attributes) === null || a === void 0 ? void 0 : a.call(c, f, { status: u, durationMs: d }));
    (l = t.metrics) === null || l === void 0 || l.histogram(p, d, { unit: "ms", attributes: g });
  } catch (c) {
    vl.error("Failed to record network metric", c);
  }
}, pk = () => {
}, CD = (t, e) => ut(L?.fetch) ? ao(L, "fetch", (n) => function(...i) {
  const r = vf(), s = n.apply(this, i);
  if (!e()) return s;
  try {
    var o, a, l;
    const [c, u] = i, d = fk((o = (a = u?.method) !== null && a !== void 0 ? a : c?.method) !== null && o !== void 0 ? o : "GET", (l = c?.url) !== null && l !== void 0 ? l : c);
    return s.then((h) => (Id(t, d, h?.status, r, e, void 0, !0), h), (h) => {
      throw Id(t, d, void 0, r, e, h), h;
    });
  } catch (c) {
    return vl.error("Failed to observe fetch", c), s;
  }
}) : pk, AD = (t, e) => {
  var n;
  const i = L == null || (n = L.XMLHttpRequest) === null || n === void 0 ? void 0 : n.prototype;
  if (!i) return pk;
  const r = /* @__PURE__ */ new WeakMap(), s = ao(i, "open", (a) => function(...l) {
    try {
      qw.has(this) || r.set(this, fk(l[0], l[1]));
    } catch (c) {
      vl.error("Failed to observe XHR open", c);
    }
    return a.apply(this, l);
  }), o = ao(i, "send", (a) => function(...l) {
    let c;
    try {
      const u = r.get(this);
      if (u && e()) {
        const d = vf();
        c = () => {
          this.removeEventListener("loadend", c), Id(t, u, this.status, d, e);
        }, Ie(this, "loadend", c);
      }
    } catch (u) {
      vl.error("Failed to observe XHR send", u);
    }
    try {
      return a.apply(this, l);
    } catch (u) {
      throw c && this.removeEventListener("loadend", c), u;
    }
  });
  return () => {
    s(), o();
  };
}, ec = { featureFlags: class {
  constructor(t) {
    this.name = "featureFlags", this.Xc = !1, this.featureFlagEventHandlers = [], this.$ = qg, this.Yc = {}, this.td = {}, this.ed = [], this.nd = !1, this.sd = !1, this.rd = 0, this.od = !1, this.ad = !1, this.ld = !1, this.ud = !1, this.hd = 0, this.dd = !1, this.an = () => {
      const e = this.vd();
      this.hd = 0, e && this.reloadFeatureFlags();
    }, this.fd = () => {
      var e, n;
      const i = this.pd, r = (e = this.gd) !== null && e !== void 0 ? e : i;
      G(i) || G(r) || this.Rr.remoteRequestsDisabled || !Y || Y.visibilityState === "hidden" || Date.now() - ((n = this.md) !== null && n !== void 0 ? n : 0) < r || (this.gd = this.dd || !this.Rr.idleRefreshBackoff ? i : Math.min(2 * r, 36e5), this.dd = !1, this.reloadFeatureFlags(), this.yd());
    }, this.bd = () => {
      this.dd && this.gd === this.pd || this._d();
    }, this.ln = () => {
      Y?.visibilityState === "visible" && this._d();
    }, "get" in t ? this.So = t : (this._instance = t, this.wd = new yD(t.config, t.nl()), this.So = this.wd);
  }
  updateConfig(t, e) {
    var n;
    (n = this.wd) === null || n === void 0 || n.update(t, e), this.wo && this.kd();
  }
  setup(t) {
    return this.Fh = t, this.$ = t.logger.createLogger("[FeatureFlags]"), dk(t.kv.initialize(), () => {
      this.Fh === t && (this.Fh = void 0, this.wo = t, this.Sd(t));
    });
  }
  Sd(t) {
    var e;
    if (this.wo === t) return L && Ie(L, "online", this.an), this.kd(), this.xd = t.registerDynamicEventProperties(() => this.Cd() ? this.Yc : this.td), this.$d = (e = this._instance) === null || e === void 0 || (e = e.persistence) === null || e === void 0 ? void 0 : e.onCrossTabFeatureFlagChange(() => {
      this.Td(), this.Id(), this.Md();
    }), this.Id(), this.initialize();
  }
  _d() {
    this.dd = !0, this.gd = this.pd, this.fd();
  }
  kd() {
    const t = this.Rr.refreshIntervalMs, e = !this.Rr.remoteRequestsDisabled && Y && !G(t) && t > 0 ? t : void 0;
    this.Rr.idleRefreshBackoff || (this.gd = e), e !== this.pd && (this.Ed(), G(e) || (this.pd = e, this.gd = e, this.yd(), Y?.addEventListener && (Ie(Y, io, this.ln), Tr(Gg, (n) => {
      Ie(Y, n, this.bd, { capture: !0 });
    }))));
  }
  yd() {
    G(this.pd) || (G(this.Pd) || clearInterval(this.Pd), this.md = Date.now(), this.Pd = setInterval(this.fd, this.pd));
  }
  Ed() {
    var t;
    G(this.Pd) || (clearInterval(this.Pd), this.Pd = void 0, Y == null || (t = Y.removeEventListener) === null || t === void 0 || t.call(Y, "visibilitychange", this.ln), Tr(Gg, (e) => {
      var n;
      Y == null || (n = Y.removeEventListener) === null || n === void 0 || n.call(Y, e, this.bd, { capture: !0 });
    })), this.pd = void 0, this.gd = void 0, this.dd = !1, this.md = void 0;
  }
  destroy() {
    this.Rd();
  }
  dispose() {
    this.Rd();
  }
  Rd() {
    var t, e;
    this.Ed(), this.rd++, this.ad = !1, this.Fh = void 0, this.wo && (this.Ad(), (t = this.xd) === null || t === void 0 || t.dispose(), this.xd = void 0, (e = this.$d) === null || e === void 0 || e.call(this), this.$d = void 0, this.ed = [], L?.removeEventListener("online", this.an), this.wo = void 0);
  }
  get Rr() {
    return this.So.get();
  }
  Fd(t) {
    var e;
    return this.Od && t in this.Od ? this.Od[t] : (e = this.wo) === null || e === void 0 ? void 0 : e.kv.get(t);
  }
  Td() {
    return !!this.Od && (this.Od = void 0, !0);
  }
  Dd() {
    var t;
    return !G((t = this.wo) === null || t === void 0 ? void 0 : t.kv.get("$enabled_feature_flags")) && this.Td();
  }
  At(t) {
    this.Ld(() => {
      var e;
      return (e = this.wo) === null || e === void 0 ? void 0 : e.kv.set(t);
    });
  }
  Nd(t, e, n) {
    var i;
    if (!(!((i = this._instance) === null || i === void 0) && i.persistence) || !t.$enabled_feature_flags) return;
    const r = this.Fd("$enabled_feature_flags") || {}, s = t.$enabled_feature_flags || {}, o = e.flags || e.featureFlags, a = e.flags ? Object.entries(e.flags).filter(([, m]) => !m?.failed).map(([m]) => m) : [], l = !!e.errorsWhileComputingFlags && !!e.flags, c = l ? a : n && !de(o) ? Object.keys(o || {}) : Array.from(/* @__PURE__ */ new Set([...Object.keys(r), ...Object.keys(s)])), u = this.Fd("$feature_flag_payloads") || {}, d = t.$feature_flag_payloads || {}, h = l || n ? c : Array.from(/* @__PURE__ */ new Set([...Object.keys(u), ...Object.keys(d)])), f = !l && !n, p = !!f || c, v = !!f || h, g = { [Li]: p, [ni]: p, [rn]: v };
    t.$feature_flag_details && (g[Kn] = p);
    for (const m of [Yn, hn, Ls]) G(t[m]) || (g[m] = !0);
    this._instance.persistence.markCrossTabFeatureFlagChanges(g);
  }
  Lt(t) {
    this.Ld(() => {
      var e;
      return (e = this.wo) === null || e === void 0 ? void 0 : e.kv.remove(t);
    });
  }
  Ld(t) {
    try {
      t();
    } catch (e) {
      this.$.error("Failed to update feature flag persistence", e);
    }
  }
  Id() {
    const t = {};
    for (const i of [Li, rn, Yn, di]) {
      const r = this.Fd(i);
      G(r) || (t[i] = r);
    }
    this.Yc = t;
    const e = R({}, t), n = this.Fd(ni);
    if (n) for (const [i, r] of Object.entries(n)) e[`$feature/${i}`] = r;
    this.td = e;
  }
  Cd() {
    const t = this.Rr.cacheTtlMs;
    if (!t || 0 >= t) return !1;
    const e = this.Fd(hn);
    return typeof e != "number" || Date.now() - e > t;
  }
  qd() {
    return !!this.Cd() && (this.ud || this.sd || (this.ud = !0, this.$.warn("Feature flag cache is stale, triggering refresh..."), this.reloadFeatureFlags()), !0);
  }
  jd() {
    const t = this.Rr.evaluationContexts;
    return t?.length ? t.filter((e) => {
      const n = e && typeof e == "string" && e.trim().length > 0;
      return n || this.$.error("Invalid evaluation context found:", e, "Expected non-empty string"), n;
    }) : [];
  }
  Bd() {
    const t = this.Rr.flagKeys;
    if (!G(t)) return t.filter((e) => {
      const n = e && typeof e == "string" && e.trim().length > 0;
      return n || this.$.error("Invalid flag key found:", e, "Expected non-empty string"), n;
    });
  }
  initialize() {
    var t, e;
    const n = this.Rr, i = (t = (e = n.bootstrap) === null || e === void 0 ? void 0 : e.featureFlags) !== null && t !== void 0 ? t : {};
    if (Object.keys(i).length) {
      var r, s;
      const o = (r = (s = n.bootstrap) === null || s === void 0 ? void 0 : s.featureFlagPayloads) !== null && r !== void 0 ? r : {}, a = Object.keys(i).filter((c) => !G(i[c])).reduce((c, u) => (c[u] = i[u], c), {}), l = Object.keys(o).filter((c) => a[c]).reduce((c, u) => (c[u] = o[u], c), {});
      return this.Hd({ featureFlags: a, featureFlagPayloads: l }, void 0, { persist: !1 });
    }
  }
  updateFlags(t, e, n) {
    var i, r;
    const s = n?.merge && (i = this.Fd("$enabled_feature_flags")) !== null && i !== void 0 ? i : {}, o = n?.merge && (r = this.Fd("$feature_flag_payloads")) !== null && r !== void 0 ? r : {}, a = R(R({}, s), t), l = R(R({}, o), e), c = {};
    for (const [u, d] of Object.entries(a)) c[u] = { key: u, enabled: Hm(d), variant: Um(d), reason: void 0, metadata: G(l?.[u]) ? void 0 : { id: 0, version: void 0, description: void 0, payload: l[u] } };
    this.Hd({ flags: c });
  }
  get hasLoadedFlags() {
    return this.nd;
  }
  getFlags() {
    return Object.keys(this.getFlagVariants());
  }
  getFlagsWithDetails() {
    const t = this.Fd(Kn), e = this.Fd(di), n = this.Fd(Fn);
    if (!n && !e) return t || {};
    const i = ze({}, t || {}), r = [.../* @__PURE__ */ new Set([...Object.keys(n || {}), ...Object.keys(e || {})])];
    for (const a of r) {
      var s;
      const l = i[a], c = e?.[a], u = G(c) ? (s = l?.enabled) !== null && s !== void 0 && s : !!c, d = G(c) ? l?.variant : typeof c == "string" ? c : void 0, h = n?.[a], f = R(R({}, l), {}, { enabled: u, variant: u ? d ?? l?.variant : void 0 });
      var o;
      u !== l?.enabled && (f.original_enabled = l?.enabled), d !== l?.variant && (f.original_variant = l?.variant), h && (f.metadata = R(R({}, l?.metadata), {}, { payload: h, original_payload: l == null || (o = l.metadata) === null || o === void 0 ? void 0 : o.payload })), i[a] = f;
    }
    return this.Xc || (this.$.warn(" Overriding feature flag details!", { flagDetails: t, overriddenPayloads: n, finalDetails: i }), this.Xc = !0), i;
  }
  getAllFeatureFlags() {
    const t = this.getFlagVariants(), e = this.getFlagPayloads();
    return Object.keys(t).map((n) => {
      const i = t[n];
      return { key: n, enabled: Hm(i), variant: Um(i), payload: Bm(e[n]) };
    });
  }
  getFlagVariants() {
    const t = this.Fd(ni), e = this.Fd(di);
    if (!e) return t || {};
    const n = ze({}, t || {}), i = Object.keys(e);
    for (let r = 0; i.length > r; r++) n[i[r]] = e[i[r]];
    return this.Xc || (this.$.warn(" Overriding feature flags!", { enabledFlags: t, overriddenFlags: e, finalFlags: n }), this.Xc = !0), n;
  }
  getFlagPayloads() {
    const t = this.Fd(rn), e = this.Fd(Fn);
    if (!e) return t || {};
    const n = ze({}, t || {}), i = Object.keys(e);
    for (let r = 0; i.length > r; r++) n[i[r]] = e[i[r]];
    return this.Xc || (this.$.warn(" Overriding feature flag payloads!", { flagPayloads: t, overriddenPayloads: e, finalPayloads: n }), this.Xc = !0), n;
  }
  reloadFeatureFlags() {
    this.od || this.Rr.featureFlagsDisabled || this.vd() || (this.sd && (this.ad = !0), this.zd || (this.ed.slice().forEach((t) => {
      try {
        t();
      } catch (e) {
        this.$.error("Error while running feature flags reloading callback", e);
      }
    }), this.zd = setTimeout(() => {
      this.Ud();
    }, 5)));
  }
  Ad() {
    clearTimeout(this.zd), this.zd = void 0;
  }
  onReloading(t) {
    return this.ed.push(t), () => {
      this.ed = this.ed.filter((e) => e !== t);
    };
  }
  ensureFlagsLoaded() {
    this.nd || this.sd || this.zd || this.reloadFeatureFlags();
  }
  setAnonymousDistinctId(t) {
    this.$anon_distinct_id = t;
  }
  setReloadingPaused(t) {
    this.od = t;
  }
  resetFlagCallReported() {
    this.Lt(an);
  }
  Ud(t) {
    this.Ad();
    const e = this.wo;
    if (!e || this.Rr.remoteRequestsDisabled || this.vd()) return;
    if (this.sd) return void (this.ad = !0);
    const n = { token: e.projectToken, distinct_id: e.distinctId, groups: e.groups, $anon_distinct_id: this.$anon_distinct_id, person_properties: R(R(R({}, e.initialPersonProperties), this.Fd("$stored_person_properties") || {}), {}, { $lib: e.library.name, $lib_version: e.library.version }), group_properties: this.Fd(on), timezone: Lw() };
    G(e.deviceId) || (n.$device_id = e.deviceId), (t?.disableFlags || this.Rr.featureFlagsDisabled) && (n.disable_flags = !0);
    const i = this.jd();
    i.length && (n.evaluation_contexts = i);
    const r = this.Bd();
    G(r) || (n.flag_keys = r);
    const s = this.Rr.onlyEvaluateSurveyFeatureFlags, o = "/flags/?v=2" + (s ? "&only_evaluate_survey_feature_flags=true" : ""), a = this.rd;
    this.sd = !0;
    const l = () => {
      this.ad && (this.ad = !1, this.Ud());
    }, c = (p) => {
      var v, g;
      const m = (v = p.json) !== null && v !== void 0 ? v : {}, y = p.statusCode !== 200;
      if (this.sd = !1, a !== this.rd) return void l();
      if (this.Wd(p.statusCode), y || this.ad || (this.$anon_distinct_id = void 0), n.disable_flags && !this.ad) return;
      this.ld = !y;
      const k = [];
      p.error ? k.push(p.error instanceof Error && p.error.name === "AbortError" ? "timeout" : p.error instanceof Error ? Kg : "unknown_error") : p.statusCode !== 200 && k.push(`api_error_${p.statusCode}`), m.errorsWhileComputingFlags && k.push("errors_while_computing_flags");
      const _ = !!(!((g = m.quotaLimited) === null || g === void 0) && g.includes("feature_flags"));
      _ && k.push("quota_limited"), this.At({ [to]: k }), _ ? this.$.warn("You have hit your feature flags quota limit, and will not be able to load feature flags until the quota is reset.  Please visit https://posthog.com/docs/billing/limits-alerts to learn more.") : n.disable_flags || this.Hd(m, y, { partialResponse: s }), l();
    }, u = (p) => {
      this.sd = !1, a === this.rd && (this.At({ [to]: [Kg] }), this.$.error("Feature flag request failed", p), this.Dd() && this.Md(!0)), l();
    };
    let d = this.Rr.requestMaxRetries;
    const h = () => d > 0 && a === this.rd, f = () => {
      if (a !== this.rd || !this.wo || this.Rr.remoteRequestsDisabled) return this.sd = !1, void l();
      try {
        e.sendRequest(o, { target: "flags", method: "POST", body: n, compression: this.Rr.compression, sentAt: "body", timeoutMs: this.Rr.requestTimeoutMs }).then((p) => {
          if (((v) => bD.includes(v.statusCode) || ((g) => g.statusCode === 0 && g.error instanceof Error && g.error.name === "AbortError")(v))(p) && h()) return d--, void setTimeout(f, 500);
          c(p);
        }).catch(u);
      } catch (p) {
        u(p);
      }
    };
    f();
  }
  vd() {
    return Cw(this.hd, 3);
  }
  Wd(t) {
    this.hd = Aw(t, this.hd, 3, () => this.$.warn("Feature flag requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped refreshing feature flags; will try again when connectivity changes."));
  }
  getFeatureFlag(t, e = {}) {
    var n;
    if (e.fresh && !this.ld) return;
    if (!(this.nd || this.getFlags() && this.getFlags().length > 0)) return void this.$.warn('getFeatureFlag for key "' + t + nu);
    if (this.qd()) return;
    const i = this.getFeatureFlagResult(t, e);
    return (n = i?.variant) !== null && n !== void 0 ? n : i?.enabled;
  }
  getFeatureFlagDetails(t) {
    return this.getFlagsWithDetails()[t];
  }
  getFeatureFlagPayload(t) {
    const e = this.getFeatureFlagResult(t, { send_event: !1 });
    return e?.payload;
  }
  getFeatureFlagResult(t, e = {}) {
    if (e.fresh && !this.ld) return;
    if (!(this.nd || this.getFlags() && this.getFlags().length > 0)) return void this.$.warn('getFeatureFlagResult for key "' + t + nu);
    if (this.qd()) return;
    const n = this.getFlagVariants(), i = t in n, r = n[t], s = this.getFlagPayloads()[t], o = String(r), a = this.Fd("$feature_flag_request_id") || void 0, l = this.Fd("$feature_flag_evaluated_at") || void 0;
    let c, u = this.Fd("$flag_call_reported") || {};
    if (this.Rr.deduplicateCallsPerSession) {
      var d;
      const P = (d = this.wo) === null || d === void 0 ? void 0 : d.session.sessionId, C = this.Fd(Cs);
      P && P !== C && (u = {}, c = P);
    }
    if (e.send_event || !("send_event" in e)) if (t in u && u[t].includes(o)) c && this.At({ [an]: u, [Cs]: c });
    else {
      var h, f, p, v, g, m, y, k, _, w, T, E;
      de(u[t]) ? u[t].push(o) : u[t] = [o], this.At(R({ [an]: u }, c ? { [Cs]: c } : {}));
      const P = this.getFeatureFlagDetails(t), C = [...(h = this.Fd("$feature_flag_errors")) !== null && h !== void 0 ? h : []];
      G(r) && C.push("flag_missing");
      const M = { $feature_flag: t, $feature_flag_response: r, $feature_flag_payload: s ?? null, $feature_flag_request_id: a, $feature_flag_evaluated_at: l, $feature_flag_bootstrapped_response: (f = (p = this.Rr.bootstrap) === null || p === void 0 || (p = p.featureFlags) === null || p === void 0 ? void 0 : p[t]) !== null && f !== void 0 ? f : null, $feature_flag_bootstrapped_payload: (v = (g = this.Rr.bootstrap) === null || g === void 0 || (g = g.featureFlagPayloads) === null || g === void 0 ? void 0 : g[t]) !== null && v !== void 0 ? v : null, $used_bootstrap_value: !this.ld };
      G(P == null || (m = P.metadata) === null || m === void 0 ? void 0 : m.has_experiment) || (M.$feature_flag_has_experiment = P.metadata.has_experiment), G(P == null || (y = P.metadata) === null || y === void 0 ? void 0 : y.version) || (M.$feature_flag_version = P.metadata.version);
      const O = (k = P == null || (_ = P.reason) === null || _ === void 0 ? void 0 : _.description) !== null && k !== void 0 ? k : P == null || (w = P.reason) === null || w === void 0 ? void 0 : w.code;
      var S;
      O && (M.$feature_flag_reason = O), !(P == null || (T = P.metadata) === null || T === void 0) && T.id && (M.$feature_flag_id = P.metadata.id), G(P?.original_variant) && G(P?.original_enabled) || (M.$feature_flag_original_response = G(P.original_variant) ? P.original_enabled : P.original_variant), !(P == null || (E = P.metadata) === null || E === void 0) && E.original_payload && (M.$feature_flag_original_payload = P == null || (S = P.metadata) === null || S === void 0 ? void 0 : S.original_payload), C.length && (M.$feature_flag_error = C.join(",")), this.Vd(M);
    }
    else c && this.At({ [an]: u, [Cs]: c });
    return i ? { key: t, enabled: !!r, variant: typeof r == "string" ? r : void 0, payload: Bm(s) } : void 0;
  }
  Vd(t) {
    try {
      var e;
      (e = this.wo) === null || e === void 0 || e.capture("$feature_flag_called", t);
    } catch (n) {
      this.$.error("Failed to capture feature flag call", n);
    }
  }
  getRemoteConfigPayload(t, e) {
    this.Gd(t, e);
  }
  Gd(t, e) {
    var n = this;
    return He(function* () {
      const i = n.wo;
      if (!i) return;
      const r = { distinct_id: i.distinctId, token: i.projectToken, person_properties: { $lib: i.library.name, $lib_version: i.library.version } }, s = n.jd();
      s.length && (r.evaluation_contexts = s);
      const o = n.Bd();
      let a;
      G(o) || (r.flag_keys = o);
      try {
        var l;
        const c = (l = (yield i.sendRequest("/flags/?v=2", { target: "flags", method: "POST", body: r, compression: n.Rr.compression, sentAt: "body", timeoutMs: n.Rr.requestTimeoutMs })).json) === null || l === void 0 ? void 0 : l.featureFlagPayloads;
        a = c?.[t] || void 0;
      } catch (c) {
        return void n.$.error("Remote config feature flag request failed", c);
      }
      try {
        e(a);
      } catch (c) {
        n.$.error("Remote config feature flag callback failed", c);
      }
    })();
  }
  isFeatureEnabled(t, e = {}) {
    if (e.fresh && !this.ld) return e.defaultValue;
    if (!(this.nd || this.getFlags() && this.getFlags().length > 0)) return this.$.warn('isFeatureEnabled for key "' + t + nu), e.defaultValue;
    const n = this.getFeatureFlag(t, e);
    return G(n) ? e.defaultValue : !!n;
  }
  addFeatureFlagsHandler(t) {
    this.featureFlagEventHandlers.push(t);
  }
  removeFeatureFlagsHandler(t) {
    this.featureFlagEventHandlers = this.featureFlagEventHandlers.filter((e) => e !== t);
  }
  receivedFeatureFlags(t, e, n) {
    this.Hd(t, e, n);
  }
  Hd(t, e, n) {
    if (!this.wo) return;
    this.nd = !0;
    const i = ((r, s = {}, o = {}, a = {}, l, c = qg) => {
      const u = ((k, _) => {
        const w = k.flags;
        if (w) {
          const T = Object.fromEntries(Object.keys(w).map((S) => {
            var P;
            return [S, (P = w[S].variant) !== null && P !== void 0 ? P : w[S].enabled];
          })), E = Object.fromEntries(Object.keys(w).filter((S) => w[S].enabled).filter((S) => {
            var P;
            return !G((P = w[S].metadata) === null || P === void 0 ? void 0 : P.payload);
          }).map((S) => {
            var P;
            return [S, (P = w[S].metadata) === null || P === void 0 ? void 0 : P.payload];
          }));
          return R(R({}, k), {}, { featureFlags: T, featureFlagPayloads: E });
        }
        return k.featureFlags && _.warn("Using an older version of the feature flags endpoint. Please upgrade your PostHog server to the latest version"), k;
      })(r, c), d = u.flags, h = u.featureFlags, f = u.featureFlagPayloads;
      if (!h) return;
      const p = r.requestId, v = r.evaluatedAt;
      if (de(h)) {
        c.warn("v1 of the feature flags endpoint is deprecated. Please use the latest version.");
        const k = {};
        if (h) for (let _ = 0; h.length > _; _++) k[h[_]] = !0;
        return { [Li]: h, [ni]: k, [Ls]: !1 };
      }
      let g = h, m = f, y = d;
      if (l?.partialResponse) {
        const k = Object.keys(g), _ = m || {};
        g = R(R({}, s), g), m = R(R({}, o), _), k.forEach((w) => {
          w in _ || m == null || delete m[w];
        }), y = R(R({}, a), y);
      } else if (r.errorsWhileComputingFlags) if (d) {
        const k = new Set(Object.keys(d).filter((w) => {
          var T;
          return !(!((T = d[w]) === null || T === void 0) && T.failed);
        }));
        g = R(R({}, s), Object.fromEntries(Object.entries(g).filter(([w]) => k.has(w))));
        const _ = Object.fromEntries(Object.entries(m || {}).filter(([w]) => k.has(w)));
        m = R(R({}, o), _), k.forEach((w) => {
          w in _ || m == null || delete m[w];
        }), y = R(R({}, a), Object.fromEntries(Object.entries(y || {}).filter(([w]) => k.has(w))));
      } else g = R(R({}, s), g), m = R(R({}, o), m), y = R(R({}, a), y);
      return R(R({ [Li]: Object.keys(Xg(g)), [ni]: g || {}, [rn]: m || {}, [Kn]: y || {}, [Ls]: r.minimalFlagCalledEvents === !0 }, p ? { [Yn]: p } : {}), v ? { [hn]: v } : {});
    })(t, this.getFlagVariants(), this.getFlagPayloads(), this.getFlagsWithDetails(), n, this.$);
    if (i) if (n?.persist === !1) {
      const r = !G(this.wo.kv.get(ni));
      this.Od = i, r || this.At(i);
    } else this.Td(), this.Nd(i, t, !!n?.partialResponse), this.At(i);
    else e && this.Dd();
    e || (this.ud = !1), this.Md(e);
  }
  override(t, e = !1) {
    this.$.warn("override is deprecated. Please use overrideFeatureFlags instead."), this.overrideFeatureFlags({ flags: t, suppressWarning: e });
  }
  overrideFeatureFlags(t) {
    this.Zd(t);
  }
  Zd(t) {
    if (this.wo) {
      if (t === !1) return this.Lt([di, Fn]), this.Md(), void Mn.info("All overrides cleared");
      if (de(t)) return this.At({ [di]: Yg(t) }), this.Md(), void Mn.info("Flag overrides set", { flags: t });
      if (t && typeof t == "object" && ("flags" in t || "payloads" in t)) {
        var e;
        const n = t;
        this.Xc = !!((e = n.suppressWarning) !== null && e !== void 0 && e);
        const i = {}, r = n.flags, s = n.payloads;
        return r && (i[di] = de(r) ? Yg(r) : r), s && (i[Fn] = s), Object.keys(i).length && this.At(i), r === !1 && s === !1 ? this.Lt([di, Fn]) : r === !1 ? this.Lt(di) : s === !1 && this.Lt(Fn), this.Md(), r === !1 ? Mn.info("Flag overrides cleared") : r && Mn.info("Flag overrides set", { flags: r }), void (s === !1 ? Mn.info("Payload overrides cleared") : s && Mn.info("Payload overrides set", { payloads: s }));
      }
      if (t && typeof t == "object") return this.At({ [di]: t }), this.Md(), void Mn.info("Flag overrides set", { flags: t });
      this.$.warn("Invalid overrideOptions provided to overrideFeatureFlags", { overrideOptions: t });
    } else this.$.warn("posthog.featureFlags.overrideFeatureFlags called before feature flags were ready");
  }
  onFeatureFlags(t) {
    if (this.addFeatureFlagsHandler(t), this.nd) {
      const { flags: e, flagVariants: n } = this.Qd();
      try {
        t(e, n);
      } catch (i) {
        this.$.error("Error while running feature flags callback", i);
      }
    }
    return () => this.removeFeatureFlagsHandler(t);
  }
  updateEarlyAccessFeatureEnrollment(t, e, n) {
    var i;
    const r = (this.Fd("$early_access_features") || []).find((c) => c.flagKey === t), s = { [`$feature_enrollment/${t}`]: e }, o = { $feature_flag: t, $feature_enrollment: e, $set: s };
    r && (o.$early_access_feature_name = r.name), n && (o.$feature_enrollment_stage = n);
    const a = R(R({}, this.getFlagVariants()), {}, { [t]: e });
    (i = this._instance) === null || i === void 0 || (i = i.persistence) === null || i === void 0 || i.markCrossTabFeatureFlagChanges({ $active_feature_flags: [t], $enabled_feature_flags: [t], $stored_person_properties: Object.keys(s) }), this.At({ [Li]: Object.keys(Xg(a)), [ni]: a, [sn]: R(R({}, this.Fd("$stored_person_properties") || {}), s) }), this.Md();
    try {
      var l;
      (l = this.wo) === null || l === void 0 || l.capture("$feature_enrollment_update", o);
    } catch (c) {
      this.$.error("Failed to capture early access feature enrollment", c);
    }
  }
  getEarlyAccessFeatures(t, e = !1, n) {
    const i = this.Fd(yd);
    !i || e ? this.Jd(t, n) : t(i);
  }
  Jd(t, e) {
    var n = this;
    return He(function* () {
      const i = n.wo;
      if (!i) return;
      const r = e ? `&${e.map((o) => `stage=${o}`).join("&")}` : "";
      let s;
      try {
        const o = yield i.sendRequest(`/api/early_access_features/?token=${i.projectToken}${r}`, { target: "api", method: "GET", sentAt: "query" });
        if (!o.json) return;
        s = o.json.earlyAccessFeatures, n.At({ [yd]: s });
      } catch (o) {
        return void n.$.error("Early access feature request failed", o);
      }
      try {
        t(s);
      } catch (o) {
        n.$.error("Early access feature callback failed", o);
      }
    })();
  }
  Qd() {
    const t = this.getFlags(), e = this.getFlagVariants();
    return { flags: t.filter((n) => e[n]), flagVariants: Object.keys(e).filter((n) => e[n]).reduce((n, i) => (n[i] = e[i], n), {}) };
  }
  Md(t) {
    this.Id();
    const { flags: e, flagVariants: n } = this.Qd();
    this.featureFlagEventHandlers.forEach((i) => {
      try {
        i(e, n, { errorsLoading: t });
      } catch (r) {
        this.$.error("Error while running feature flags callback", r);
      }
    });
  }
  setPersonPropertiesForFlags(t, e = !0) {
    this.Kd(t, e);
  }
  Kd(t, e = !0) {
    const n = this.Fd("$stored_person_properties") || {}, i = t?.$set || (t?.$set_once ? {} : t), r = t?.$set_once, s = {};
    if (r) for (const o in r) ({}).hasOwnProperty.call(r, o) && (o in n || (s[o] = r[o]));
    this.At({ [sn]: R(R(R({}, n), s), i) }), e && this.reloadFeatureFlags();
  }
  unsetPersonPropertiesForFlags(t, e = !0) {
    const n = R({}, this.Fd("$stored_person_properties") || {});
    t.forEach((i) => {
      delete n[i];
    }), this.At({ [sn]: n }), e && this.reloadFeatureFlags();
  }
  resetPersonPropertiesForFlags(t = !0) {
    this.Lt(sn), t && this.reloadFeatureFlags();
  }
  setGroupPropertiesForFlags(t, e = !0) {
    const n = this.Fd("$stored_group_properties") || {}, i = R({}, n);
    for (const r of Object.keys(t)) i[r] = R(R({}, n[r]), t[r]);
    this.At({ [on]: i }), e && this.reloadFeatureFlags();
  }
  resetGroupPropertiesForFlags(t) {
    if (t) {
      const e = this.Fd("$stored_group_properties") || {};
      this.At({ [on]: R(R({}, e), {}, { [t]: {} }) });
    } else this.Lt(on);
  }
  reset() {
    this.rd++, this.ad = !1, this.Yc = {}, this.td = {}, this.Od = void 0, this.nd = !1, this.od = !1, this.ld = !1, this.$anon_distinct_id = void 0, this.Ad(), this.Xc = !1, this.hd = 0;
  }
} }, $D = { sessionRecording: class {
  get Rr() {
    return this._instance.config;
  }
  get Ml() {
    return this._instance.persistence;
  }
  get started() {
    var t;
    return !!(!((t = this.Xd) === null || t === void 0) && t.isStarted);
  }
  get status() {
    var t, e;
    return this.Yd === "awaiting_config" || this.Yd === "missing_config" ? this.Yd : (t = (e = this.Xd) === null || e === void 0 ? void 0 : e.status) !== null && t !== void 0 ? t : this.Yd;
  }
  constructor(t) {
    if (this._instance = t, this._forceAllowLocalhostNetworkCapture = !1, this.Yd = eu, this.tv = void 0, this.ev = !1, this.Xe = (() => {
      var e, n;
      if (!Y?.visibilityState || Y.visibilityState === "visible") return !0;
      const i = L == null || (e = L.performance) === null || e === void 0 || (n = e.getEntriesByType) === null || n === void 0 ? void 0 : n.call(e, "visibility-state");
      return !i?.length || i.some((r) => r.name === "visible");
    })(), this.ln = () => {
      var e, n;
      Y?.visibilityState === "visible" && (this.Xe = !0, (e = this.Xd) === null || e === void 0 || (n = e.setDocumentWasEverVisible) === null || n === void 0 || n.call(e, !0));
    }, !this._instance.sessionManager) throw Ri.error("started without valid sessionManager"), new Error("[SessionRecording] started without valid sessionManager. This is a bug.");
    if (this.Rr.cookieless_mode === "always") throw new Error('[SessionRecording] cannot be used with cookieless_mode="always"');
    Y?.addEventListener && Ie(Y, "visibilitychange", this.ln);
  }
  initialize() {
    this.startIfEnabledOrStop();
  }
  dispose({ discardBufferedEvents: t = !1 } = {}) {
    var e;
    this.ev = !0, Y == null || (e = Y.removeEventListener) === null || e === void 0 || e.call(Y, "visibilitychange", this.ln), t ? this.iv(!0) : this.stopRecording();
  }
  get nv() {
    var t;
    const e = !!(!((t = this._instance.get_property("$session_recording_remote_config")) === null || t === void 0) && t.enabled), n = !this.Rr.disable_session_recording, i = this.Rr.disable_session_recording || this._instance.consent.isOptedOut();
    return L && e && n && !i;
  }
  startIfEnabledOrStop(t) {
    var e;
    if (this.ev || this.nv && (!((e = this.Xd) === null || e === void 0) && e.isStarted)) return;
    const n = !G(Object.assign) && !G(Array.from);
    this.nv && n ? (this.sv(t), Ri.info("starting")) : (this.Yd = eu, this.stopRecording());
  }
  sv(t) {
    var e, n;
    if (this.nv) if (this.Yd !== "awaiting_config" && this.Yd !== "missing_config" && (this.Yd = jg), (le == null || (e = le.__PosthogExtensions__) === null || e === void 0 || (e = e.rrweb) === null || e === void 0 ? void 0 : e.record) && ((n = le.__PosthogExtensions__) === null || n === void 0 ? void 0 : n.initSessionRecording)) this.rv(t);
    else {
      var i, r;
      const s = this._instance.sessionManager;
      (i = le.__PosthogExtensions__) === null || i === void 0 || (r = i.loadExternalDependency) === null || r === void 0 || r.call(i, this._instance, this.ov, (o) => {
        if (!this.ev && this.nv && this._instance.sessionManager === s) return o ? (this._instance.register_for_session({ $sdk_debug_recording_script_not_loaded: !0 }), Ri.error("could not load recorder", o)) : void this.rv(t);
        this.Yd = "disabled";
      });
    }
  }
  stopRecording() {
    var t, e;
    (t = this.tv) === null || t === void 0 || t.call(this), this.tv = void 0, (e = this.Xd) === null || e === void 0 || e.stop();
  }
  iv(t = !1) {
    var e, n;
    (e = this.tv) === null || e === void 0 || e.call(this), this.tv = void 0, (n = this.Xd) === null || n === void 0 || n.discard({ discardProducerEvents: t });
  }
  av() {
    var t, e;
    (t = this.Ml) === null || t === void 0 || t.unregister("$session_is_sampled"), (e = this.Ml) === null || e === void 0 || e.unregister("$replay_sample_rate");
  }
  lv(t, e) {
    if (ve(t)) return null;
    const n = Qe(t) ? t : parseFloat(t);
    return typeof (i = n) != "number" || !Number.isFinite(i) || 0 > i || i > 1 ? (Ri.warn(`${e} must be between 0 and 1. Ignoring invalid value:`, t), null) : n;
    var i;
  }
  uv(t) {
    if (this.Ml) {
      var e, n;
      const i = this.Ml, r = () => {
        var s;
        const o = t.sessionRecording === !1 ? void 0 : t.sessionRecording, a = this.lv((s = this.Rr.session_recording) === null || s === void 0 ? void 0 : s.sampleRate, "session_recording.sampleRate"), l = this.lv(o?.sampleRate, "remote config sampleRate"), c = a ?? l;
        ve(c) && this.av();
        const u = o?.minimumDurationMilliseconds;
        i.register({ [Fs]: R(R({ cache_timestamp: Date.now(), enabled: !!o }, o), {}, { networkPayloadCapture: R({ capturePerformance: t.capturePerformance }, o?.networkPayloadCapture), canvasRecording: { enabled: o?.recordCanvas, fps: o?.canvasFps, quality: o?.canvasQuality }, sampleRate: c, minimumDurationMilliseconds: G(u) ? null : u, endpoint: o?.endpoint, triggerMatchType: o?.triggerMatchType, masking: o?.masking, urlTriggers: o?.urlTriggers, version: o?.version, triggerGroups: o?.triggerGroups }) });
      };
      r(), (e = this.tv) === null || e === void 0 || e.call(this), this.tv = (n = this._instance.sessionManager) === null || n === void 0 ? void 0 : n.onSessionId(r);
    }
  }
  onRemoteConfig(t) {
    const e = t.ok ? t.config : void 0;
    return e && "sessionRecording" in e ? e.sessionRecording === !1 ? (this.uv(e), void this.iv()) : (this.uv(e), void this.startIfEnabledOrStop()) : (this.Yd === "awaiting_config" && (this.Yd = "missing_config", this._instance.register_for_session({ [hw]: !0 }), Ri.warn("config refresh failed, recording will not start until page reload")), void this.startIfEnabledOrStop());
  }
  log(t, e = "log") {
    var n;
    !((n = this.Xd) === null || n === void 0) && n.log ? this.Xd.log(t, e) : Ri.warn("log called before recorder was ready");
  }
  get ov() {
    var t, e;
    const n = (t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 ? void 0 : t.get_property(Fs);
    return (n == null || (e = n.scriptConfig) === null || e === void 0 ? void 0 : e.script) || "lazy-recorder";
  }
  hv() {
    const t = this._instance.get_property(Fs);
    if (!t) return !1;
    let e;
    try {
      e = typeof t == "object" ? t : JSON.parse(t);
    } catch (n) {
      return Ri.warn("persisted remote config for session recording is invalid and will be ignored", n), !1;
    }
    return !ve(e.cache_timestamp) && 36e5 >= Date.now() - e.cache_timestamp;
  }
  rv(t) {
    var e, n, i;
    if (!this.ev && this.nv && this._instance.sessionManager) {
      if (!(!((e = le.__PosthogExtensions__) === null || e === void 0) && e.initSessionRecording)) return Ri.warn("Called on script loaded before session recording is available. This can be caused by adblockers."), void this._instance.register_for_session({ [dw]: !0 });
      var r;
      if (this.Xd || (this.Xd = (r = le.__PosthogExtensions__) === null || r === void 0 ? void 0 : r.initSessionRecording(this._instance, this.Xe), this.Xd._forceAllowLocalhostNetworkCapture = this._forceAllowLocalhostNetworkCapture), !this.hv())
        return this.Yd === "missing_config" || this.Yd === "awaiting_config" ? void 0 : (this.Yd = "awaiting_config", Ri.info("persisted remote config is stale, requesting fresh config before starting"), void new jw(this._instance).load());
      this.Yd = jg, (n = (i = this.Xd).setDocumentWasEverVisible) === null || n === void 0 || n.call(i, this.Xe), this.Xd.start(t);
    } else this.Yd = eu;
  }
  onRRwebEmit(t) {
    var e, n;
    (e = this.Xd) === null || e === void 0 || (n = e.onRRwebEmit) === null || n === void 0 || n.call(e, t);
  }
  overrideLinkedFlag() {
    var t, e;
    this.Xd || (e = this.Ml) === null || e === void 0 || e.register({ $replay_override_linked_flag: !0 }), (t = this.Xd) === null || t === void 0 || t.overrideLinkedFlag();
  }
  overrideSampling() {
    var t, e;
    this.Xd || (e = this.Ml) === null || e === void 0 || e.register({ $replay_override_sampling: !0 }), (t = this.Xd) === null || t === void 0 || t.overrideSampling();
  }
  overrideTrigger(t) {
    var e, n;
    this.Xd || (n = this.Ml) === null || n === void 0 || n.register({ [t === "url" ? "$replay_override_url_trigger" : "$replay_override_event_trigger"]: !0 }), (e = this.Xd) === null || e === void 0 || e.overrideTrigger(t);
  }
  get sdkDebugProperties() {
    var t;
    return ((t = this.Xd) === null || t === void 0 ? void 0 : t.sdkDebugProperties) || { $recording_status: this.status };
  }
  tryAddCustomEvent(t, e) {
    var n;
    return !!(!((n = this.Xd) === null || n === void 0) && n.tryAddCustomEvent(t, e));
  }
  flushBeforeIdentityReset() {
    var t, e;
    (t = this.Xd) === null || t === void 0 || (e = t.flushBeforeIdentityReset) === null || e === void 0 || e.call(t);
  }
} }, RD = { autocapture: class extends rD {
  constructor(t) {
    super(new sD(t)), this.instance = t;
  }
}, historyAutocapture: class {
  constructor(t) {
    this.dv = !1, this._instance = t, this.vv = this.fv();
  }
  initialize() {
    this.startIfEnabled();
  }
  get isEnabled() {
    const t = this.pv();
    return !!(t.path || t.search || this.gv(t));
  }
  startIfEnabled() {
    this.isEnabled && (ee.info("History API monitoring enabled, starting..."), this.monitorHistoryChanges());
  }
  startIfEnabledOrStop() {
    this.stop(), this.vv = this.fv(), this.startIfEnabled();
  }
  stop() {
    this.mv && this.mv(), this.mv = void 0, this.yv && this.yv(), this.yv = void 0, ee.info("History API monitoring stopped");
  }
  monitorHistoryChanges() {
    L && L.history && (this.bv("pushState"), this.bv("replaceState"), this._v(), this.gv() && this.wv());
  }
  bv(t) {
    var e;
    if (!L || !((e = L.history[t]) === null || e === void 0) && e.__posthog_wrapped__) return;
    const n = this;
    ao(L.history, t, (i) => function(r, s, o) {
      var a;
      n.Sv(o) && n.xv(), i.call(this, r, s, o), n.Cv(t, !n.dv && (L == null || (a = L.event) === null || a === void 0 ? void 0 : a.type) !== "popstate");
    });
  }
  fv() {
    const t = L?.location;
    if (t?.pathname) return { pathname: t.pathname, search: t.search, hash: t.hash };
  }
  pv() {
    const t = this._instance.config.capture_pageview;
    return t === "history_change" ? { path: !0 } : Ee(t) ? t : {};
  }
  gv(t = this.pv()) {
    return !!t.hash && !this._instance.config.disable_capture_url_hashes;
  }
  $v(t) {
    const e = this.pv(), n = this.vv;
    return !(!n || !(e.path && t.pathname !== n.pathname || e.search && t.search !== n.search || this.gv(e) && t.hash !== n.hash));
  }
  Cv(t, e = !1) {
    try {
      e || this.xv();
      const n = this.fv();
      if (!n) return;
      if (this.$v(n)) {
        const i = () => this._instance.capture(cf, { navigation_type: t });
        e ? (this.Tv = i, Promise.resolve().then(() => this.xv())) : i();
      }
      this.vv = n;
    } catch (n) {
      ee.error(`Error capturing ${t} pageview`, n);
    }
  }
  Sv(t) {
    var e, n;
    return !(ve(t) || !L) && ((e = Wi(String(t))) === null || e === void 0 ? void 0 : e.href) !== ((n = L.location) === null || n === void 0 ? void 0 : n.href);
  }
  xv() {
    const t = this.Tv;
    if (t) {
      this.Tv = void 0, this.dv = !0;
      try {
        t();
      } catch (e) {
        ee.error("Error capturing deferred pageview", e);
      } finally {
        this.dv = !1;
      }
      this.vv = this.fv();
    }
  }
  _v() {
    if (this.mv) return;
    const t = () => {
      this.Cv("popstate");
    };
    Ie(L, "popstate", t), this.mv = () => {
      L && L.removeEventListener("popstate", t);
    };
  }
  wv() {
    if (this.yv) return;
    const t = () => {
      this.Cv("hashchange");
    };
    Ie(L, "hashchange", t), this.yv = () => {
      L && L.removeEventListener("hashchange", t);
    };
  }
}, heatmaps: class {
  get Rr() {
    return this.instance.config;
  }
  constructor(t) {
    var e;
    this.Iv = !1, this.xo = !1, this.Mv = null, this.instance = t, this.Iv = !!(!((e = this.instance.persistence) === null || e === void 0) && e.props[pd]), this.rageclicks = new uk(t.config.rageclick);
  }
  initialize() {
    this.startIfEnabled();
  }
  get flushIntervalMilliseconds() {
    let t = 5e3;
    return Ee(this.Rr.capture_heatmaps) && this.Rr.capture_heatmaps.flush_interval_milliseconds && (t = this.Rr.capture_heatmaps.flush_interval_milliseconds), t;
  }
  get isEnabled() {
    return ve(this.Rr.capture_heatmaps) ? ve(this.Rr.enable_heatmaps) ? this.Iv : this.Rr.enable_heatmaps : this.Rr.capture_heatmaps !== !1;
  }
  startIfEnabled() {
    if (this.isEnabled) {
      if (this.xo) return;
      cD.info("starting..."), this.Ev(), this.ln();
    } else {
      var t;
      clearInterval((t = this.Mv) !== null && t !== void 0 ? t : void 0), this.Pv(), this.getAndClearBuffer();
    }
  }
  onRemoteConfig(t) {
    if (!t.ok) return;
    const e = t.config;
    if (!("heatmaps" in e)) return;
    const n = !!e.heatmaps;
    this.instance.persistence && this.instance.persistence.register({ [pd]: n }), this.Iv = n, this.startIfEnabled();
  }
  getAndClearBuffer() {
    const t = this.Rt;
    return this.Rt = void 0, t;
  }
  Rv(t) {
    tu(t.originalEvent) && this.Tr(t.originalEvent, "deadclick");
  }
  ln() {
    this.Mv && clearInterval(this.Mv), this.Mv = Y?.visibilityState === "visible" ? setInterval(this.bl.bind(this), this.flushIntervalMilliseconds) : null;
  }
  Ev() {
    L && Y && (this.Av = this.bl.bind(this), Ie(L, cl, this.Av), this.Fv = (t) => this.Tr(t || L?.event), Ie(Y, "click", this.Fv, { capture: !0 }), this.Ov = (t) => this.Dv(t || L?.event), Ie(Y, "mousemove", this.Ov, { capture: !0 }), this.Lv = new mg(this.instance, s4, this.Rv.bind(this)), this.Lv.startIfEnabledOrStop(), this.Nv = this.ln.bind(this), Ie(Y, io, this.Nv), this.xo = !0);
  }
  Pv() {
    var t;
    L && Y && (this.Av && L.removeEventListener(cl, this.Av), this.Fv && Y.removeEventListener("click", this.Fv, { capture: !0 }), this.Ov && Y.removeEventListener("mousemove", this.Ov, { capture: !0 }), this.Nv && Y.removeEventListener(io, this.Nv), clearTimeout(this.qv), (t = this.Lv) === null || t === void 0 || t.stop(), this.xo = !1);
  }
  jv(t, e) {
    const n = this.instance.scrollManager.scrollY(), i = this.instance.scrollManager.scrollX(), r = this.instance.scrollManager.scrollElement(), s = (function(o, a, l) {
      let c = o;
      for (; c && ki(c) && !vt(c, "body"); ) {
        if (c === l) return !1;
        let f;
        try {
          var u, d, h;
          f = (u = (d = (h = c.ownerDocument) === null || h === void 0 ? void 0 : h.defaultView) !== null && d !== void 0 ? d : L) === null || u === void 0 ? void 0 : u.getComputedStyle(c).position;
        } catch {
          return !1;
        }
        if (pe(a, f)) return !0;
        c = ww(c);
      }
      return !1;
    })(Vs(t), ["fixed", "sticky"], r);
    return { x: t.clientX + (s ? 0 : i), y: t.clientY + (s ? 0 : n), target_fixed: s, type: e };
  }
  Tr(t, e = "click") {
    var n;
    if (sg(t.target) || !tu(t)) return;
    const i = this.jv(t, e);
    !((n = this.rageclicks) === null || n === void 0) && n.isRageClick(t.clientX, t.clientY, (/* @__PURE__ */ new Date()).getTime()) && xw(Vs(t), this.instance.config.rageclick) && this.Zs(R(R({}, i), {}, { type: "rageclick" })), this.Zs(i);
  }
  Dv(t) {
    !sg(t.target) && tu(t) && (clearTimeout(this.qv), this.qv = setTimeout(() => {
      this.Zs(this.jv(t, "mousemove"));
    }, 500));
  }
  Zs(t) {
    if (!L) return;
    const e = this.Rr.disable_capture_url_hashes ? gn(L.location.href) : L.location.href, n = this.Rr.custom_personal_data_properties, i = this.Rr.mask_personal_data_properties ? [...Zr, ...n || []] : [], r = so(e, i, oo);
    this.Rt = this.Rt || {}, this.Rt[r] || (this.Rt[r] = []), this.Rt[r].push(t);
  }
  bl() {
    this.Rt && !Ot(this.Rt) && this.instance.capture("$$heatmap", { $heatmap_data: this.getAndClearBuffer() });
  }
}, deadClicksAutocapture: mg, webVitalsAutocapture: class {
  constructor(t) {
    var e;
    this._instance = t, this.Iv = !1, this.xo = !1, this.Rt = { navigationKey: void 0, url: void 0, metrics: [], firstMetricTimestamp: void 0 }, this.Bv = () => {
      clearTimeout(this.Hv), this.Hv = void 0, this.Rt.metrics.length !== 0 && (this._instance.capture("$web_vitals", R({ $current_url: this.Rt.url }, this.Rt.metrics.reduce((n, i) => R(R({}, n), {}, { [`$web_vitals_${i.name}_event`]: R({}, i), [`$web_vitals_${i.name}_value`]: i.value }), {}))), this.Rt = { navigationKey: void 0, url: void 0, metrics: [], firstMetricTimestamp: void 0 });
    }, this.zv = (n) => {
      var i;
      if (this.Rt = this.Rt || { navigationKey: void 0, url: void 0, metrics: [], firstMetricTimestamp: void 0 }, ve(n?.name) || ve(n?.value)) return void Rn.error("Invalid metric received", n);
      const r = typeof n.navigationURL == "string" ? n.navigationURL : void 0, s = this.Uv(r);
      if (G(s)) return;
      const o = Qe(n.navigationId) || typeof n.navigationId == "string" ? `navigation:${n.navigationId}` : `url:${s}`;
      if (this.Wv && n.value >= this.Wv) return void Rn.error("Ignoring metric with value >= " + this.Wv, n);
      this.Rt.navigationKey !== o && (this.Bv(), this.Hv = setTimeout(this.Bv, this.flushToCaptureTimeoutMs)), G(this.Rt.navigationKey) && (this.Rt.navigationKey = o, this.Rt.url = s), this.Rt.firstMetricTimestamp = G(this.Rt.firstMetricTimestamp) ? Date.now() : this.Rt.firstMetricTimestamp;
      const a = (i = this._instance.sessionManager) === null || i === void 0 ? void 0 : i.checkAndGetSessionAndWindowId(!0), l = R(R(R({}, n), r ? { navigationURL: s } : {}), {}, { $current_url: s, timestamp: Date.now() });
      if (delete l.entries, Ee(n.attribution) && this.attributionMetrics.indexOf(n.name) > -1) {
        const c = {};
        for (const u of lD) {
          const d = u === "url" && typeof n.attribution[u] == "string" ? this.Uv(n.attribution[u]) : n.attribution[u];
          G(d) || (c[u] = d);
        }
        l.attribution = c;
      } else delete l.attribution;
      G(a) || (l.$session_id = a.sessionId, l.$window_id = a.windowId), this.Rt.metrics.push(l), this.Rt.metrics.length === this.allowedMetrics.length && this.Bv();
    }, this.Vv = () => {
      if (this.xo) return;
      let n, i, r, s, o = !1;
      const a = le.__PosthogExtensions__, l = a?.postHogWebVitalsCallbacksByFlavor, c = l?.[this.Gv] || (this.Gv === "web-vitals" && G(l) ? a?.postHogWebVitalsCallbacks : void 0);
      if (!G(c)) {
        const h = c.withoutAttribution, f = this.attributionMetrics;
        o = !G(h), n = f.indexOf("LCP") > -1 ? c.onLCP : h?.onLCP || c.onLCP, i = f.indexOf("CLS") > -1 ? c.onCLS : h?.onCLS || c.onCLS, r = f.indexOf("FCP") > -1 ? c.onFCP : h?.onFCP || c.onFCP, s = f.indexOf("INP") > -1 ? c.onINP : h?.onINP || c.onINP;
      }
      if (!(n && i && r && s)) return void Rn.error("web vitals callbacks not loaded - not starting");
      const u = { reportSoftNavs: this.useSoftNavs }, d = o && this.attributionMetrics.indexOf("INP") > -1 ? R(R({}, u), {}, { includeProcessedEventEntries: !1 }) : u;
      this.allowedMetrics.indexOf("LCP") > -1 && n(this.zv.bind(this), u), this.allowedMetrics.indexOf("CLS") > -1 && i(this.zv.bind(this), u), this.allowedMetrics.indexOf("FCP") > -1 && r(this.zv.bind(this), u), this.allowedMetrics.indexOf("INP") > -1 && s(this.zv.bind(this), d), this.xo = !0;
    }, this.Iv = !!(!((e = this._instance.persistence) === null || e === void 0) && e.props[vd]), this.startIfEnabled();
  }
  get Zv() {
    return this._instance.config.capture_performance;
  }
  get allowedMetrics() {
    var t, e;
    const n = Ee(this.Zv) ? (t = this.Zv) === null || t === void 0 ? void 0 : t.web_vitals_allowed_metrics : void 0;
    return ve(n) ? ((e = this._instance.persistence) === null || e === void 0 ? void 0 : e.props.$web_vitals_allowed_metrics) || Vg : n;
  }
  get flushToCaptureTimeoutMs() {
    return (Ee(this.Zv) ? this.Zv.web_vitals_delayed_flush_ms : void 0) || 5e3;
  }
  get attributionMetrics() {
    const t = Ee(this.Zv) ? this.Zv.web_vitals_attribution : void 0;
    return Tt(t) ? t ? Vg : [] : de(t) ? t : aD;
  }
  get useAttribution() {
    return this.attributionMetrics.length > 0;
  }
  get useSoftNavs() {
    const t = Ee(this.Zv) ? this.Zv.__preview_web_vitals_soft_navs : void 0;
    return t != null && t;
  }
  get Wv() {
    const t = Ee(this.Zv) && Qe(this.Zv.__web_vitals_max_value) ? this.Zv.__web_vitals_max_value : Ng;
    return t > 0 && 6e4 >= t ? Ng : t;
  }
  get isEnabled() {
    const t = Ke?.protocol;
    if (t !== "http:" && t !== "https:") return Rn.info("Web Vitals are disabled on non-http/https protocols"), !1;
    const e = Ee(this.Zv) ? this.Zv.web_vitals : Tt(this.Zv) ? this.Zv : void 0;
    return Tt(e) ? e : this.Iv;
  }
  startIfEnabled() {
    this.isEnabled && !this.xo && (Rn.info("enabled, starting..."), this.zo(this.Vv));
  }
  onRemoteConfig(t) {
    if (!t.ok) return;
    const e = t.config;
    if (!("capturePerformance" in e)) return;
    const n = Ee(e.capturePerformance) && !!e.capturePerformance.web_vitals, i = Ee(e.capturePerformance) ? e.capturePerformance.web_vitals_allowed_metrics : void 0;
    this._instance.persistence && (this._instance.persistence.register({ [vd]: n }), this._instance.persistence.register({ [ew]: i })), this.Iv = n, this.startIfEnabled();
  }
  get Gv() {
    return this.useSoftNavs ? this.useAttribution ? "web-vitals-with-attribution-soft-navs" : "web-vitals-soft-navs" : this.useAttribution ? "web-vitals-with-attribution" : "web-vitals";
  }
  zo(t) {
    var e;
    const n = le.__PosthogExtensions__, i = this.Gv, r = n?.postHogWebVitalsCallbacksByFlavor;
    r?.[i] || i === "web-vitals" && G(r) && n?.postHogWebVitalsCallbacks ? t() : n == null || (e = n.loadExternalDependency) === null || e === void 0 || e.call(n, this._instance, i, (s) => {
      s ? Rn.error("failed to load script", s) : t();
    });
  }
  Uv(t) {
    const e = t || L?.location.href;
    if (!e) return void Rn.error("Could not determine current URL");
    const n = this._instance.config.disable_capture_url_hashes ? gn(e) : e, i = this._instance.config.custom_personal_data_properties, r = this._instance.config.mask_personal_data_properties ? [...Zr, ...i || []] : [];
    return so(n, r, oo);
  }
} }, MD = { exceptionObserver: class {
  constructor(t) {
    var e;
    this.Vv = () => {
      var n;
      if (!L || !this.isEnabled || !(!((n = le.__PosthogExtensions__) === null || n === void 0) && n.errorWrappingFunctions)) return;
      const i = le.__PosthogExtensions__.errorWrappingFunctions.wrapOnError, r = le.__PosthogExtensions__.errorWrappingFunctions.wrapUnhandledRejection, s = le.__PosthogExtensions__.errorWrappingFunctions.wrapConsoleError;
      try {
        !this.Qv && this.Rr.capture_unhandled_errors && (this.Qv = i(this.captureException.bind(this))), !this.Jv && this.Rr.capture_unhandled_rejections && (this.Jv = r(this.captureException.bind(this))), !this.Kv && this.Rr.capture_console_errors && (this.Kv = s(this.captureException.bind(this)));
      } catch (o) {
        xs.error("failed to start", o), this.Xv();
      }
    }, this._instance = t, this.Yv = !!(!((e = this._instance.persistence) === null || e === void 0) && e.props[md]), this.wt = new y3(R(R({}, (function(n = {}) {
      var i, r, s, o;
      return { refillRate: (i = (r = n.exceptionRateLimiterRefillRate) !== null && r !== void 0 ? r : n.__exceptionRateLimiterRefillRate) !== null && i !== void 0 ? i : 1, bucketSize: (s = (o = n.exceptionRateLimiterBucketSize) !== null && o !== void 0 ? o : n.__exceptionRateLimiterBucketSize) !== null && s !== void 0 ? s : 10 };
    })(this._instance.config.error_tracking)), {}, { refillInterval: 1e4, $: xs })), this.Rr = this.tf(), this.startIfEnabledOrStop();
  }
  tf() {
    const t = this._instance.config.capture_exceptions;
    let e = { capture_unhandled_errors: !1, capture_unhandled_rejections: !1, capture_console_errors: !1 };
    return Ee(t) ? e = R(R({}, e), t) : (G(t) ? this.Yv : t) && (e = R(R({}, e), {}, { capture_unhandled_errors: !0, capture_unhandled_rejections: !0 })), e;
  }
  get isEnabled() {
    return this.Rr.capture_console_errors || this.Rr.capture_unhandled_errors || this.Rr.capture_unhandled_rejections;
  }
  startIfEnabledOrStop() {
    this.isEnabled ? (xs.info("enabled"), this.Xv(), this.zo(this.Vv)) : this.Xv();
  }
  zo(t) {
    var e, n, i;
    !((e = le.__PosthogExtensions__) === null || e === void 0) && e.errorWrappingFunctions ? t() : (n = le.__PosthogExtensions__) === null || n === void 0 || (i = n.loadExternalDependency) === null || i === void 0 || i.call(n, this._instance, "exception-autocapture", (r) => {
      if (r) return xs.error("failed to load script", r);
      t();
    });
  }
  Xv() {
    var t, e, n;
    (t = this.Qv) === null || t === void 0 || t.call(this), this.Qv = void 0, (e = this.Jv) === null || e === void 0 || e.call(this), this.Jv = void 0, (n = this.Kv) === null || n === void 0 || n.call(this), this.Kv = void 0;
  }
  onRemoteConfig(t) {
    if (!t.ok) return;
    const e = t.config;
    "autocaptureExceptions" in e && (this.Yv = !!e.autocaptureExceptions || !1, this._instance.persistence && this._instance.persistence.register({ [md]: this.Yv }), this.Rr = this.tf(), this.startIfEnabledOrStop());
  }
  onConfigChange() {
    this.Rr = this.tf();
  }
  captureException(t) {
    try {
      var e, n, i;
      const r = (e = t == null || (n = t.$exception_list) === null || n === void 0 || (n = n[0]) === null || n === void 0 ? void 0 : n.type) !== null && e !== void 0 ? e : "Exception";
      if (this.wt.consumeRateLimit(r)) return void xs.info("Skipping exception capture because of client rate limiting.", { exception: r });
      (i = this._instance.exceptions) === null || i === void 0 || i.sendExceptionEvent(t);
    } catch {
    }
  }
}, exceptions: class {
  constructor(t) {
    var e, n;
    this.ef = [], this.if = new $3([new W3(), new eI(), new G3(), new q3(), new Z3(), new J3(), new Y3(), new Q3()], /* @__PURE__ */ (function(i, ...r) {
      return (s, o = 0) => {
        const a = [], l = s.split(`
`), c = Math.min(l.length, o + 1e3), u = [];
        for (let f = o; c > f; f++) {
          const p = l[f];
          if (p.length > 1024) continue;
          const v = zm.test(p) ? p.replace(zm, "$1") : p;
          if (!v.match(/\S*Error: /)) {
            for (const g of r) {
              const m = g(v, i);
              if (m) {
                a.push(m);
                const y = z3(a);
                if (y) {
                  for (let k = u.length - 1; k >= 0; k--) {
                    const _ = u[k];
                    if (y.start >= _.start + _.length) break;
                    u.pop();
                  }
                  u.push(y);
                }
                break;
              }
            }
            if (H3(a, u) >= 50) break;
          }
        }
        const d = [...u].sort((f, p) => p.start - f.start), h = d[d.length - 1];
        if (h) {
          const f = F_(a, h);
          a.splice(h.start - f, f);
          for (const p of d) p.start -= f;
        }
        for (const f of d) B3(a, f);
        return u.some((f) => f.start === 0 && a.length === f.length) && (function(f) {
          const p = f.map((g) => `${g.function}|${g.filename}|${g.lineno}|${g.colno}|${g.module}`);
          let v = 0;
          for (let g = 1; p.length > g; g++) U3(p, g, v) && (v = g);
          f.push(...f.splice(0, v));
        })(a), (function(f) {
          if (!f.length) return [];
          const p = Array.from(f);
          return p.reverse(), p.slice(0, 50).map((v) => {
            return R(R({}, v), {}, { filename: v.filename || (g = p, g[g.length - 1] || {}).filename, function: v.function || "?" });
            var g;
          });
        })(a);
      };
    })("web:javascript", L3, j3)), this._instance = t, this.ef = (e = (n = this._instance.persistence) === null || n === void 0 ? void 0 : n.get_property("$error_tracking_suppression_rules")) !== null && e !== void 0 ? e : [], this.nf = rl(this.sf()), this.rf = new iI(this.nf);
  }
  onConfigChange() {
    this.nf = rl(this.sf()), this.rf.setConfig(this.nf);
  }
  onRemoteConfig(t) {
    var e, n, i;
    if (!t.ok) return;
    const r = t.config;
    if (!("errorTracking" in r)) return;
    const s = (e = (n = r.errorTracking) === null || n === void 0 ? void 0 : n.suppressionRules) !== null && e !== void 0 ? e : [], o = (i = r.errorTracking) === null || i === void 0 ? void 0 : i.captureExtensionExceptions;
    this.ef = s, this._instance.persistence && this._instance.persistence.register({ [Z_]: this.ef, [gd]: o });
  }
  get af() {
    var t;
    const e = !!this._instance.get_property(gd), n = this._instance.config.error_tracking.captureExtensionExceptions;
    return (t = n ?? e) !== null && t !== void 0 && t;
  }
  buildProperties(t, e) {
    return this.if.buildFromUnknown(t, { syntheticException: e?.syntheticException, mechanism: { handled: e?.handled } });
  }
  addExceptionStep(t, e) {
    if (this.nf.enabled) try {
      if (!Pe(t) || t.trim().length === 0) return void Qt.warn("Ignoring exception step because message must be a non-empty string");
      const { sanitizedProperties: n, droppedKeys: i } = (function(r) {
        if (!r) return { sanitizedProperties: {}, droppedKeys: [] };
        const s = [];
        return { sanitizedProperties: Object.keys(r).reduce((o, a) => tI.has(a) ? (s.push(a), o) : (o[a] = r[a], o), {}), droppedKeys: s };
      })(this.lf(e));
      i.length > 0 && Qt.warn("Ignoring reserved exception step fields", { droppedKeys: i }), this.rf.add(R({ [il]: t, [nl]: (/* @__PURE__ */ new Date()).toISOString() }, n));
    } catch (n) {
      Qt.error("Failed to add exception step. Ignoring breadcrumb.", n);
    }
  }
  sendExceptionEvent(t) {
    try {
      const e = t.$exception_list;
      if (this.uf(e)) {
        if (this.hf(e)) return this.cf("Exception dropped: matched a suppression rule"), void Qt.info("Skipping exception capture because a suppression rule matched");
        if (!this.af && this.df(e)) return this.cf("Exception dropped: thrown by a browser extension"), void Qt.info("Skipping exception capture because it was thrown by an extension");
        if (!this.af && this.vf(e)) return this.cf("Exception dropped: thrown by an injected browser script"), void Qt.info("Skipping exception capture because it was thrown by an injected browser script");
        if (!this._instance.config.error_tracking.__capturePostHogExceptions && this.ff(e)) return this.cf("Exception dropped: thrown by the PostHog SDK"), void Qt.info("Skipping exception capture because it was thrown by the PostHog SDK");
      }
      const n = this.nf.enabled && ve(t.$exception_steps) ? this.pf(t) : t, i = (function() {
        const r = globalThis._posthogReleaseId;
        return typeof r == "string" && r.length > 0 ? r : void 0;
      })();
      i && (n.$release_id = i);
      try {
        const r = this._instance.capture("$exception", n, { _noTruncate: !0, _batchKey: "exceptionEvent", fh: !0 });
        return r && this.rf.clear(), r;
      } catch (r) {
        return Jg(r) || Qt.error("Failed to capture exception event. Dropping this exception.", r), void this.rf.clear();
      }
    } catch (e) {
      return void (Jg(e) || Qt.error("Failed to process exception event. Ignoring this exception.", e));
    }
  }
  pf(t) {
    try {
      const e = this.rf.getAttachable();
      return e.length === 0 ? t : R(R({}, t), {}, { $exception_steps: e });
    } catch (e) {
      return Qt.error("Failed to read buffered exception steps. Capturing exception without steps.", e), t;
    }
  }
  cf(t) {
    this.nf.enabled && this.rf.add({ [il]: t, [nl]: (/* @__PURE__ */ new Date()).toISOString() });
  }
  lf(t) {
    return Ee(t) ? R({}, t) : {};
  }
  sf() {
    var t, e;
    return (t = (e = this._instance.config.error_tracking) === null || e === void 0 ? void 0 : e.exception_steps) !== null && t !== void 0 ? t : {};
  }
  hf(t) {
    if (t.length === 0) return !1;
    try {
      const e = t.reduce((n, { type: i, value: r }) => (Pe(i) && i.length > 0 && n.$exception_types.push(i), Pe(r) && r.length > 0 && n.$exception_values.push(r), n), { $exception_types: [], $exception_values: [] });
      return this.ef.some((n) => {
        const i = n.values.map((r) => {
          const s = ok[r.operator], o = e[r.key];
          if (!s || !o) return !1;
          const a = de(r.value) ? r.value : [r.value];
          return a.length > 0 && s(a, o);
        });
        return n.type === "OR" ? i.some(Boolean) : i.every(Boolean);
      });
    } catch (e) {
      return Qt.warn("Failed to evaluate suppression rules. Capturing the exception.", e), !1;
    }
  }
  df(t) {
    const e = t.flatMap((i) => {
      var r, s;
      return (r = (s = i.stacktrace) === null || s === void 0 ? void 0 : s.frames) !== null && r !== void 0 ? r : [];
    }), n = e.filter(({ filename: i }) => !!i && wD.some((r) => i.startsWith(r)));
    return n.length !== 0 && (!n.every(({ filename: i }) => !!i && i.startsWith(Od)) || t.some(({ type: i, value: r }) => i === "NoResponse" || Pe(r) && _D.some(({ value: s, exact: o }) => o ? r === s : r.includes(s))) && !e.some(({ in_app: i, filename: r }) => i && !r?.startsWith(Od)));
  }
  vf(t) {
    return t.some(({ value: e }) => Pe(e) && kD.some((n) => e.includes(n)));
  }
  ff(t) {
    if (t.length > 0) {
      var e, n, i, r;
      const s = (e = (n = t[0].stacktrace) === null || n === void 0 ? void 0 : n.frames) !== null && e !== void 0 ? e : [], o = s[s.length - 1];
      return (i = o == null || (r = o.filename) === null || r === void 0 ? void 0 : r.includes("posthog.com/static")) !== null && i !== void 0 && i;
    }
    return !1;
  }
  uf(t) {
    return !ve(t) && de(t);
  }
} }, OD = R({ productTours: class {
  get Ml() {
    return this._instance.persistence;
  }
  constructor(t) {
    this.gf = null, this.mf = null, this._instance = t;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(t) {
    if (!t.ok) return;
    const e = t.config;
    if ("productTours" in e) {
      var n, i;
      if (this.Ml && this.Ml.register({ [of]: !!e.productTours }), !iu(this._instance)) return !this.gf && ve((n = this.Ml) === null || n === void 0 ? void 0 : n.props.ph_product_tours) || ca.info("product tours disabled; stopping and clearing cached tours"), (i = this.gf) === null || i === void 0 || i.stop(), this.gf = null, void this.clearCache();
      this.loadIfEnabled();
    }
  }
  loadIfEnabled() {
    !this.gf && iu(this._instance) && this.zo(() => this.yf());
  }
  zo(t) {
    var e, n, i;
    !((e = le.__PosthogExtensions__) === null || e === void 0) && e.generateProductTours ? t() : (n = le.__PosthogExtensions__) === null || n === void 0 || (i = n.loadExternalDependency) === null || i === void 0 || i.call(n, this._instance, "product-tours", (r) => {
      r ? ca.error("Could not load product tours script", r) : t();
    });
  }
  yf() {
    var t;
    !this.gf && (!((t = le.__PosthogExtensions__) === null || t === void 0) && t.generateProductTours) && (this.gf = le.__PosthogExtensions__.generateProductTours(this._instance, !0));
  }
  getProductTours(t, e = !1) {
    if (de(this.mf) && !e) return void t(this.mf, { isLoaded: !0 });
    const n = this.Ml;
    if (n) {
      const i = n.props[_d];
      if (de(i) && !e) return this.mf = i, void t(i, { isLoaded: !0 });
    }
    this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", `/api/product_tours/?token=${this._instance.config.token}`), method: "GET", timestampMode: "query", callback: (i) => {
      if (!iu(this._instance)) return void t([], { isLoaded: !0 });
      const r = i.statusCode;
      if (r !== 200 || !i.json) {
        const o = `Product Tours API could not be loaded, status: ${r}`;
        return r === 0 ? i.error || ca.warn(o) : ca.error(o), void t([], { isLoaded: !1, error: o });
      }
      const s = de(i.json.product_tours) ? i.json.product_tours : [];
      this.mf = s, n && n.register({ [_d]: s }), t(s, { isLoaded: !0 });
    } });
  }
  getActiveProductTours(t) {
    ve(this.gf) ? t([], { isLoaded: !1, error: "Product tours not loaded" }) : this.gf.getActiveProductTours(t);
  }
  showProductTour(t) {
    var e;
    (e = this.gf) === null || e === void 0 || e.showTourById(t);
  }
  previewTour(t) {
    this.gf ? this.gf.previewTour(t) : this.zo(() => {
      var e;
      this.yf(), (e = this.gf) === null || e === void 0 || e.previewTour(t);
    });
  }
  dismissProductTour() {
    var t;
    (t = this.gf) === null || t === void 0 || t.dismissTour("user_clicked_skip");
  }
  nextStep() {
    var t;
    (t = this.gf) === null || t === void 0 || t.nextStep();
  }
  previousStep() {
    var t;
    (t = this.gf) === null || t === void 0 || t.previousStep();
  }
  clearCache() {
    var t;
    this.mf = null, (t = this.Ml) === null || t === void 0 || t.unregister("ph_product_tours");
  }
  resetTour(t) {
    var e;
    (e = this.gf) === null || e === void 0 || e.resetTour(t);
  }
  resetAllTours() {
    var t;
    (t = this.gf) === null || t === void 0 || t.resetAllTours();
  }
  cancelPendingTour(t) {
    var e;
    (e = this.gf) === null || e === void 0 || e.cancelPendingTour(t);
  }
} }, ec), ID = { siteApps: class {
  constructor(t) {
    this._instance = t, this.bf = 0, this._f = [], this.apps = {};
  }
  get isEnabled() {
    return !!this._instance.config.opt_in_site_apps;
  }
  wf(t, e) {
    if (!e) return;
    const n = this.globalsForEvent(e);
    this._f.push(n), this._f.length > 1e3 && (this._f = this._f.slice(10));
  }
  get siteAppLoaders() {
    var t;
    return (t = le._POSTHOG_REMOTE_CONFIG) === null || t === void 0 || (t = t[this._instance.config.token]) === null || t === void 0 ? void 0 : t.siteApps;
  }
  initialize() {
    if (this.isEnabled) {
      const t = this._instance._addCaptureHook(this.wf.bind(this));
      this.kf = () => {
        t(), this._f = [], this.kf = void 0;
      };
    }
  }
  globalsForEvent(t) {
    var e, n, i, r, s, o, a;
    if (!t) throw new Error("Event payload is required");
    const l = {}, c = this._instance.get_property("$groups") || [], u = this._instance.get_property("$stored_group_properties") || {};
    for (const [f, p] of Object.entries(u)) l[f] = { id: c[f], type: f, properties: p };
    const { $set_once: d, $set: h } = t;
    return { event: R(R({}, j_(t, uD)), {}, { properties: R(R(R({}, t.properties), h ? { $set: R(R({}, (e = (n = t.properties) === null || n === void 0 ? void 0 : n.$set) !== null && e !== void 0 ? e : {}), h) } : {}), d ? { $set_once: R(R({}, (i = (r = t.properties) === null || r === void 0 ? void 0 : r.$set_once) !== null && i !== void 0 ? i : {}), d) } : {}), elements_chain: (s = (o = t.properties) === null || o === void 0 ? void 0 : o.$elements_chain) !== null && s !== void 0 ? s : "", distinct_id: (a = t.properties) === null || a === void 0 ? void 0 : a.distinct_id }), person: { properties: this._instance.get_property("$stored_person_properties") }, groups: l };
  }
  Sf(t) {
    var e;
    const n = (e = t.tagName) === null || e === void 0 ? void 0 : e.toLowerCase();
    return n === "style" && this._instance.config.prepare_external_dependency_stylesheet ? this._instance.config.prepare_external_dependency_stylesheet(t) || (ui.error("prepare_external_dependency_stylesheet returned null"), null) : n === "script" && this._instance.config.prepare_external_dependency_script ? this._instance.config.prepare_external_dependency_script(t) || (ui.error("prepare_external_dependency_script returned null"), null) : t;
  }
  xf() {
    var t, e, n, i, r, s, o, a;
    if (!this._instance.config.prepare_external_dependency_stylesheet && !this._instance.config.prepare_external_dependency_script) return () => {
    };
    const l = Y?.defaultView, c = l == null || (t = l.Node) === null || t === void 0 ? void 0 : t.prototype;
    if (!l || !c) return () => {
    };
    if (this.bf++, this.Cf) return this.$f();
    const u = [], d = this, h = /* @__PURE__ */ new WeakSet(), f = (g, m, y) => {
      if (!g?.[m]) return;
      const k = g[m];
      g[m] = y(k), u.push(() => {
        g[m] = k;
      });
    }, p = (g) => {
      if (h.has(g)) return g;
      const m = d.Sf(g);
      return m && h.add(m), m;
    }, v = (g) => g.map((m) => typeof m == "string" ? m : p(m)).filter((m) => !Ye(m));
    return f(c, "appendChild", (g) => function(m) {
      const y = p(m);
      return y ? g.call(this, y) : m;
    }), f(c, "insertBefore", (g) => function(m, y) {
      const k = p(m);
      return k ? g.call(this, k, y) : m;
    }), f(c, "replaceChild", (g) => function(m, y) {
      const k = p(m);
      return k ? g.call(this, k, y) : y;
    }), [(e = l.Element) === null || e === void 0 ? void 0 : e.prototype, (n = l.Document) === null || n === void 0 ? void 0 : n.prototype, (i = l.DocumentFragment) === null || i === void 0 ? void 0 : i.prototype].forEach((g) => {
      f(g, "append", (m) => function(...y) {
        return m.apply(this, v(y));
      }), f(g, "prepend", (m) => function(...y) {
        return m.apply(this, v(y));
      });
    }), [(r = l.Element) === null || r === void 0 ? void 0 : r.prototype, (s = l.CharacterData) === null || s === void 0 ? void 0 : s.prototype, (o = l.DocumentType) === null || o === void 0 ? void 0 : o.prototype].forEach((g) => {
      f(g, "before", (m) => function(...y) {
        return m.apply(this, v(y));
      }), f(g, "after", (m) => function(...y) {
        return m.apply(this, v(y));
      }), f(g, "replaceWith", (m) => function(...y) {
        const k = v(y);
        return y.length && !k.length ? void 0 : m.apply(this, k);
      });
    }), f((a = l.Element) === null || a === void 0 ? void 0 : a.prototype, "insertAdjacentElement", (g) => function(m, y) {
      const k = p(y);
      return k ? g.call(this, m, k) : null;
    }), this.Cf = () => {
      u.forEach((g) => g()), this.Cf = void 0;
    }, this.$f();
  }
  $f() {
    let t = !1;
    return () => {
      var e;
      t || (t = !0, this.bf--, this.bf === 0 && ((e = this.Cf) === null || e === void 0 || e.call(this)));
    };
  }
  Tf(t, e = !0) {
    const n = this.xf();
    try {
      const i = t(n);
      return e && n(), i;
    } catch (i) {
      throw n(), i;
    }
  }
  setupSiteApp(t) {
    const e = this.apps[t.id], n = () => {
      var s;
      !e.errored && this._f.length && (ui.info(`Processing ${this._f.length} events for site app with id ${t.id}`), this._f.forEach((o) => this.Tf(() => {
        var a;
        return (a = e.processEvent) === null || a === void 0 ? void 0 : a.call(e, o);
      })), e.processedBuffer = !0), Object.values(this.apps).every((o) => o.processedBuffer || o.errored) && ((s = this.kf) === null || s === void 0 || s.call(this));
    };
    let i = !1;
    const r = (s) => {
      e.errored = !s, e.loaded = !0, ui.info(`Site app with id ${t.id} ${s ? "loaded" : "errored"}`), i && n();
    };
    try {
      const { processEvent: s } = this.Tf((o) => t.init({ posthog: this._instance, callback(a) {
        o(), r(a);
      } }), !1);
      s && (e.processEvent = s), i = !0;
    } catch (s) {
      ui.error(zg + t.id, s), r(!1);
    }
    if (i && e.loaded) try {
      n();
    } catch (s) {
      ui.error(`Error while processing buffered events PostHog app with config id ${t.id}`, s), e.errored = !0;
    }
  }
  If() {
    const t = this.siteAppLoaders || [];
    for (const e of t) this.apps[e.id] = { id: e.id, loaded: !1, errored: !1, processedBuffer: !1 };
    for (const e of t) this.setupSiteApp(e);
  }
  Mf(t) {
    if (Object.keys(this.apps).length === 0) return;
    const e = this.globalsForEvent(t);
    for (const n of Object.values(this.apps)) try {
      this.Tf(() => {
        var i;
        return (i = n.processEvent) === null || i === void 0 ? void 0 : i.call(n, e);
      });
    } catch (i) {
      ui.error(`Error while processing event ${t.event} for site app ${n.id}`, i);
    }
  }
  onRemoteConfig(t) {
    var e, n, i;
    if (!((e = this.siteAppLoaders) === null || e === void 0) && e.length) return this.isEnabled ? (this.If(), void this._instance.on("eventCaptured", (a) => this.Mf(a))) : void ui.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
    if ((n = this.kf) === null || n === void 0 || n.call(this), !t.ok) return;
    const r = t.config;
    if (!((i = r.siteApps) === null || i === void 0) && i.length) if (this.isEnabled) for (const { id: a, url: l } of r.siteApps) {
      var s, o;
      le[`__$$ph_site_app_${a}`] = this._instance, (s = le.__PosthogExtensions__) === null || s === void 0 || (o = s.loadSiteApp) === null || o === void 0 || o.call(s, this._instance, l, (c) => {
        if (c) return ui.error(zg + a, c);
      });
    }
    else ui.error('PostHog site apps are disabled. Enable the "opt_in_site_apps" config to proceed.');
  }
} }, DD = { tracingHeaders: class {
  constructor(t) {
    this._instance = t, this.Ef = void 0, this.Pf = void 0, this.Rf = void 0, this.Vv = () => {
      const e = this.Af();
      var n, i;
      e ? (G(this.Ef) && (this.Ef = (n = le.__PosthogExtensions__) === null || n === void 0 || (n = n.tracingHeadersPatchFns) === null || n === void 0 ? void 0 : n._patchXHR(e, () => this._instance.get_distinct_id(), this._instance.sessionManager)), G(this.Pf) && (this.Pf = (i = le.__PosthogExtensions__) === null || i === void 0 || (i = i.tracingHeadersPatchFns) === null || i === void 0 ? void 0 : i._patchFetch(e, () => this._instance.get_distinct_id(), this._instance.sessionManager))) : this.Xv();
    };
  }
  initialize() {
    this.startIfEnabledOrStop();
  }
  zo(t) {
    var e, n, i;
    !((e = le.__PosthogExtensions__) === null || e === void 0) && e.tracingHeadersPatchFns ? t() : (n = le.__PosthogExtensions__) === null || n === void 0 || (i = n.loadExternalDependency) === null || i === void 0 || i.call(n, this._instance, "tracing-headers", (r) => {
      if (r) return oD.error("failed to load script", r);
      t();
    });
  }
  Ff() {
    var t, e;
    return (t = (e = this._instance.config.tracing_headers) !== null && e !== void 0 ? e : this._instance.config.addTracingHeaders) !== null && t !== void 0 ? t : this._instance.config.__add_tracing_headers;
  }
  Af() {
    const t = this.Ff();
    return de(t) ? (de(this.Rf) ? this.Rf.splice(0, this.Rf.length, ...t) : this.Rf = [...t], t.length > 0 ? this.Rf : void 0) : (de(this.Rf) && this.Rf.splice(0), this.Rf = t || void 0, this.Rf);
  }
  Xv() {
    var t, e;
    (t = this.Ef) === null || t === void 0 || t.call(this), (e = this.Pf) === null || e === void 0 || e.call(this), this.Ef = void 0, this.Pf = void 0;
  }
  startIfEnabledOrStop() {
    this.Af() ? this.zo(this.Vv) : this.Xv();
  }
} }, FD = R({ surveys: class extends dD {
  constructor(t) {
    var e;
    super(new gD(t), (e = t, { get projectToken() {
      return e.config.token;
    }, kv: new mD(e) })), this._instance = t;
  }
  qh(t, e) {
    const n = e.query ? Co(t, e.query) : t;
    return new Promise((i) => {
      var r;
      this._instance._send_request({ method: e.method, url: this._instance.requestRouter.endpointFor((r = e.target) !== null && r !== void 0 ? r : "api", n), data: e.body, headers: e.headers, timeout: e.timeoutMs, fireCallbackOnDrop: !0, transport: e.transport, compression: e.compression, timestampMode: e.sentAt, callback: i });
    });
  }
} }, ec), LD = { toolbar: class {
  constructor(t) {
    this.instance = t;
  }
  Of(t) {
    le.ph_toolbar_state = t;
  }
  Df() {
    var t;
    return (t = le.ph_toolbar_state) !== null && t !== void 0 ? t : 0;
  }
  initialize() {
    return this.maybeLoadToolbar();
  }
  maybeLoadToolbar(t = void 0, e = void 0, n = void 0) {
    var i, r;
    if (kd(this.instance.config) || !L || !Y) return !1;
    t = (i = t) !== null && i !== void 0 ? i : L.location, n = (r = n) !== null && r !== void 0 ? r : L.history;
    try {
      if (!e) {
        try {
          L.localStorage.setItem("test", "test"), L.localStorage.removeItem("test");
        } catch {
          return !1;
        }
        e = L?.localStorage;
      }
      const s = vD || dl(t.hash, "__posthog") || dl(t.hash, "state");
      let o;
      const a = s ? Lm(() => JSON.parse(atob(decodeURIComponent(s)))) || Lm(() => JSON.parse(decodeURIComponent(s))) : null;
      return a && a.action === "ph_authorize" ? (o = a, o.source = "url", o && Object.keys(o).length > 0 && (a.desiredHash ? t.hash = a.desiredHash : n ? n.replaceState(n.state, "", t.pathname + t.search) : t.hash = "")) : (o = JSON.parse(e.getItem(Hg) || "{}"), o.source = "localstorage", delete o.userIntent), !(!o.token || this.instance.config.token !== o.token || (this.loadToolbar(o), 0));
    } catch {
      return !1;
    }
  }
  Lf(t) {
    const e = le.ph_load_toolbar || le.ph_load_editor;
    !ve(e) && ut(e) ? e(t, this.instance) : Ug.warn("No toolbar load function found");
  }
  loadToolbar(t) {
    const e = !!Y?.getElementById("__POSTHOG_TOOLBAR__");
    if (!L || e) return !1;
    const n = this.instance.requestRouter.region === "custom" && this.instance.config.advanced_disable_toolbar_metrics, i = R(R({ token: this.instance.config.token }, t), {}, { apiURL: this.instance.requestRouter.endpointFor("ui") }, n ? { instrument: !1 } : {});
    if (L.localStorage.setItem(Hg, JSON.stringify(R(R({}, i), {}, { source: void 0 }))), this.Df() === 2) this.Lf(i);
    else if (this.Df() === 0) {
      var r, s;
      this.Of(1), (r = le.__PosthogExtensions__) === null || r === void 0 || (s = r.loadExternalDependency) === null || s === void 0 || s.call(r, this.instance, "toolbar", (o) => {
        if (o) return Ug.error("[Toolbar] Failed to load", o), void this.Of(0);
        this.Of(2), this.Lf(i);
      }), Ie(L, "turbolinks:load", () => {
        this.Of(0), this.loadToolbar(i);
      });
    }
    return !0;
  }
  Nf(t) {
    return this.loadToolbar(t);
  }
  maybeLoadEditor(t = void 0, e = void 0, n = void 0) {
    return this.maybeLoadToolbar(t, e, n);
  }
} }, ND = R({ experiments: class St {
  get Rr() {
    return this._instance.config;
  }
  constructor(e) {
    this._instance = e, this.getWebExperimentsAndEvaluateDisplayLogic = (n = !1) => {
      this.getWebExperiments((i) => {
        St.qf("retrieved web experiments from the server"), this.jf = /* @__PURE__ */ new Map(), i.forEach((r) => {
          if (r.feature_flag_key) {
            var s;
            this.jf && (St.qf("setting flag key ", r.feature_flag_key, " to web experiment ", r), (s = this.jf) === null || s === void 0 || s.set(r.feature_flag_key, r));
            const o = this._instance.getFeatureFlag(r.feature_flag_key);
            Pe(o) && r.variants[o] && this.Bf(r.name, o, r.variants[o].transforms);
          } else if (r.variants) for (const o in r.variants) {
            const a = r.variants[o];
            St.Hf(a, this._instance) && this.Bf(r.name, o, a.transforms);
          }
        });
      }, n);
    }, this._instance.onFeatureFlags((n) => {
      this.onFeatureFlags(n);
    });
  }
  initialize() {
  }
  onFeatureFlags(e) {
    if (this._is_bot()) St.qf(Zg);
    else if (!this.Rr.disable_web_experiments) {
      if (ve(this.jf)) return this.jf = /* @__PURE__ */ new Map(), this.loadIfEnabled(), void this.previewWebExperiment();
      St.qf("applying feature flags", e), e.forEach((n) => {
        var i;
        if (this.jf && (!((i = this.jf) === null || i === void 0) && i.has(n))) {
          var r;
          const s = this._instance.getFeatureFlag(n), o = (r = this.jf) === null || r === void 0 ? void 0 : r.get(n);
          s && o?.variants[s] && this.Bf(o.name, s, o.variants[s].transforms);
        }
      });
    }
  }
  previewWebExperiment() {
    const e = St.getWindowLocation();
    if (e?.search) {
      const n = Jr(e?.search, "__experiment_id"), i = Jr(e?.search, "__experiment_variant");
      n && i && (St.qf(`previewing web experiments ${n} && ${i}`), this.getWebExperiments((r) => {
        this.zf(parseInt(n), i, r);
      }, !1, !0));
    }
  }
  loadIfEnabled() {
    this.Rr.disable_web_experiments || this.getWebExperimentsAndEvaluateDisplayLogic();
  }
  getWebExperiments(e, n, i) {
    if (this.Rr.disable_web_experiments && !i) return e([]);
    const r = this._instance.get_property("$web_experiments");
    if (r && !n) return e(r);
    this._instance._send_request({ url: this._instance.requestRouter.endpointFor("api", `/api/web_experiments/?token=${this.Rr.token}`), method: "GET", timestampMode: "query", callback: (s) => e(s.statusCode === 200 && s.json && s.json.experiments || []) });
  }
  zf(e, n, i) {
    const r = i.filter((s) => s.id === e);
    r && r.length > 0 && (St.qf(`Previewing web experiment [${r[0].name}] with variant [${n}]`), this.Bf(r[0].name, n, r[0].variants[n].transforms));
  }
  static Hf(e, n) {
    return !ve(e.conditions) && St.Uf(e, n) && St.Wf(e);
  }
  static Uf(e, n) {
    var i;
    if (ve(e.conditions) || ve((i = e.conditions) === null || i === void 0 ? void 0 : i.url)) return !0;
    const r = St.getWindowLocation();
    if (r) {
      var s, o, a;
      const l = yw(n, r.href);
      return !(!((s = e.conditions) === null || s === void 0) && s.url) || xD[(o = (a = e.conditions) === null || a === void 0 ? void 0 : a.urlMatchType) !== null && o !== void 0 ? o : "icontains"](e.conditions.url, l);
    }
    return !1;
  }
  static getWindowLocation() {
    return L?.location;
  }
  static Wf(e) {
    var n;
    if (ve(e.conditions) || ve((n = e.conditions) === null || n === void 0 ? void 0 : n.utm)) return !0;
    const i = $w();
    if (i.utm_source) {
      var r, s, o, a, l, c, u, d;
      const h = !(!((r = e.conditions) === null || r === void 0 || (r = r.utm) === null || r === void 0) && r.utm_campaign) || ((s = e.conditions) === null || s === void 0 || (s = s.utm) === null || s === void 0 ? void 0 : s.utm_campaign) == i.utm_campaign, f = !(!((o = e.conditions) === null || o === void 0 || (o = o.utm) === null || o === void 0) && o.utm_source) || ((a = e.conditions) === null || a === void 0 || (a = a.utm) === null || a === void 0 ? void 0 : a.utm_source) == i.utm_source, p = !(!((l = e.conditions) === null || l === void 0 || (l = l.utm) === null || l === void 0) && l.utm_medium) || ((c = e.conditions) === null || c === void 0 || (c = c.utm) === null || c === void 0 ? void 0 : c.utm_medium) == i.utm_medium, v = !(!((u = e.conditions) === null || u === void 0 || (u = u.utm) === null || u === void 0) && u.utm_term) || ((d = e.conditions) === null || d === void 0 || (d = d.utm) === null || d === void 0 ? void 0 : d.utm_term) == i.utm_term;
      return h && p && v && f;
    }
    return !1;
  }
  static qf(e, ...n) {
    ee.info(`[WebExperiments] ${e}`, n);
  }
  Bf(e, n, i) {
    this._is_bot() ? St.qf(Zg) : n !== "control" ? i.forEach((r) => {
      if (r.selector) {
        var s;
        St.qf(`applying transform of variant ${n} for experiment ${e} `, r);
        const o = (s = document) === null || s === void 0 ? void 0 : s.querySelectorAll(r.selector);
        o?.forEach((a) => {
          const l = a;
          r.html && (l.innerHTML = r.html), r.css && l.setAttribute("style", r.css);
        });
      }
    }) : St.qf("Control variants leave the page unmodified.");
  }
  _is_bot() {
    return dt && this._instance ? nk(dt, this.Rr.custom_blocked_useragents) : void 0;
  }
} }, ec), VD = { conversations: class {
  constructor(t) {
    this._instance = t, this.Vf = void 0, this._conversationsManager = null, this.Gf = !1, this.ne = null, this.Zf = !1;
  }
  initialize() {
    this.loadIfEnabled();
  }
  onRemoteConfig(t) {
    if (this._instance.config.disable_conversations || (this.Qf = t.ok, !t.ok)) return;
    const e = t.config.conversations;
    ve(e) || (Tt(e) ? this.Vf = e : (this.Vf = e.enabled, this.ne = e), this.loadIfEnabled());
  }
  reset() {
    var t;
    (t = this._conversationsManager) === null || t === void 0 || t.reset(), this._conversationsManager = null, this.Vf = void 0, this.ne = null, this.Qf = void 0, this.Zf = !1;
  }
  loadIfEnabled() {
    if (this._conversationsManager || this.Gf || this._instance.config.disable_conversations || kd(this._instance.config) || this._instance.config.cookieless_mode && this._instance.consent.isOptedOut()) return;
    const t = le?.__PosthogExtensions__;
    if (t && !G(this.Vf) && this.Vf) if (this.ne && this.ne.token) {
      this.Gf = !0;
      try {
        const e = t.initConversations;
        if (e) return this.Jf(e), void (this.Gf = !1);
        const n = t.loadExternalDependency;
        if (!n) return void this.Kf(lf);
        n(this._instance, "conversations", (i) => {
          i || !t.initConversations ? this.Kf("Could not load conversations script", i) : this.Jf(t.initConversations), this.Gf = !1;
        });
      } catch (e) {
        this.Kf("Error initializing conversations", e), this.Gf = !1;
      }
    } else Ut.error("Conversations enabled but missing token in remote config.");
  }
  Jf(t) {
    if (this.ne) try {
      this._conversationsManager = t(this.ne, this._instance), this.Zf = !1, Ut.info("Conversations loaded successfully");
    } catch (e) {
      this.Kf("Error completing conversations initialization", e);
    }
    else Ut.error("Cannot complete initialization: remote config is null");
  }
  Kf(t, e) {
    Ut.error(t, e), this._conversationsManager = null, this.Gf = !1, this.Zf = !0;
  }
  show() {
    this._conversationsManager ? this._conversationsManager.show() : Ut.warn("Conversations not loaded yet.");
  }
  hide() {
    this._conversationsManager && this._conversationsManager.hide();
  }
  isAvailable() {
    return this.Vf === !0 && !Ye(this._conversationsManager);
  }
  getUnavailableReason() {
    return this.isAvailable() ? null : this._instance.config.disable_conversations ? "disabled_by_config" : kd(this._instance.config) ? "disabled_for_toolbar" : this._instance.config.cookieless_mode && this._instance.consent.isOptedOut() ? "consent_opted_out" : this.Qf === !1 ? "remote_config_failed" : G(this.Vf) ? this.Qf ? "disabled_in_project" : "remote_config_pending" : this.Vf ? ve(this.ne) || !this.ne.token ? "missing_token" : le?.__PosthogExtensions__ ? this.Gf ? "initializing" : this.Zf ? "load_failed" : "not_loaded" : "extensions_unavailable" : "disabled_in_project";
  }
  isVisible() {
    var t, e;
    return (t = (e = this._conversationsManager) === null || e === void 0 ? void 0 : e.isVisible()) !== null && t !== void 0 && t;
  }
  sendMessage(t, e, n) {
    var i = this;
    return He(function* () {
      return i._conversationsManager ? i._conversationsManager.sendMessage(t, e, n) : (Ut.warn(On), null);
    })();
  }
  getMessages(t, e) {
    var n = this;
    return He(function* () {
      return n._conversationsManager ? n._conversationsManager.getMessages(t, e) : (Ut.warn(On), null);
    })();
  }
  markAsRead(t) {
    var e = this;
    return He(function* () {
      return e._conversationsManager ? e._conversationsManager.markAsRead(t) : (Ut.warn(On), null);
    })();
  }
  getTickets(t) {
    var e = this;
    return He(function* () {
      return e._conversationsManager ? e._conversationsManager.getTickets(t) : (Ut.warn(On), null);
    })();
  }
  requestRestoreLink(t) {
    var e = this;
    return He(function* () {
      return e._conversationsManager ? e._conversationsManager.requestRestoreLink(t) : (Ut.warn(On), null);
    })();
  }
  restoreFromToken(t) {
    var e = this;
    return He(function* () {
      return e._conversationsManager ? e._conversationsManager.restoreFromToken(t) : (Ut.warn(On), null);
    })();
  }
  restoreFromUrlToken() {
    var t = this;
    return He(function* () {
      return t._conversationsManager ? t._conversationsManager.restoreFromUrlToken() : (Ut.warn(On), null);
    })();
  }
  getCurrentTicketId() {
    var t, e;
    return (t = (e = this._conversationsManager) === null || e === void 0 ? void 0 : e.getCurrentTicketId()) !== null && t !== void 0 ? t : null;
  }
  getWidgetSessionId() {
    var t, e;
    return (t = (e = this._conversationsManager) === null || e === void 0 ? void 0 : e.getWidgetSessionId()) !== null && t !== void 0 ? t : null;
  }
  Sh() {
    var t;
    (t = this._conversationsManager) === null || t === void 0 || t.setIdentity();
  }
  xh() {
    var t;
    (t = this._conversationsManager) === null || t === void 0 || t.clearIdentity();
  }
} }, jD = { logs: class {
  constructor(t) {
    var e;
    this._instance = t, this.name = "logs", this.Xf = !1, this.Yf = !1, this.tp = !1, this.$ = Ze("[logs]"), this.ep = R(R({}, this.$), {}, { error: (...n) => {
      n.some(tv) || this.$.error(...n);
    } }), this.al = [], this.np = [], this.hd = 0, this.Io = !1, this.sp = [], this.rp = [], this.op = !1, this.ap = !1, this.lp = () => {
      var n, i;
      this.Io || (this.hd = 0, (n = this.up) === null || n === void 0 || n.onReconnect(), (i = this.hp) === null || i === void 0 || i.onReconnect());
    }, this._instance && (!((e = this._instance.config.logs) === null || e === void 0) && e.captureConsoleLogs) && (this.Xf = !0), L && Ie(L, "online", this.lp);
  }
  cp(t, e, n, i) {
    var r;
    const s = Qg((r = this._instance) === null || r === void 0 || (r = r.config) === null || r === void 0 ? void 0 : r.logs, n);
    return [new hI(this.dp(t, e), s, this.ep, () => this.vp(), (o) => o(), void 0, i), s];
  }
  fp() {
    var t;
    const e = (t = this._instance) === null || t === void 0 || (t = t.config) === null || t === void 0 ? void 0 : t.logs;
    var n;
    return this.up && this.pp === e || ((n = this.up) === null || n === void 0 || n.reset(), this.pp = e, [this.up, this.gp] = this.cp(() => this.al, (i) => {
      this.al = i;
    })), this.up;
  }
  mp() {
    var t;
    const e = (t = this._instance) === null || t === void 0 || (t = t.config) === null || t === void 0 ? void 0 : t.logs;
    var n;
    return this.hp && this.yp === e || ((n = this.hp) === null || n === void 0 || n.reset(), this.yp = e, [this.hp, this.bp] = this.cp(() => this.np, (i) => {
      this.np = i;
    }, { serviceNameDefault: "posthog-browser-logs", consoleCapture: !0 }, ev)), this.hp;
  }
  setup(t) {
    var e;
    if (this.Io) return;
    this.wo = t, !((e = this._instance) === null || e === void 0 || (e = e.config) === null || e === void 0 || (e = e.logs) === null || e === void 0) && e.captureConsoleLogs && (this.Xf = !0), (this.Xf || this._p() && this.wp()) && this.kp();
    let n = !1;
    const i = t.onRemoteConfig((r) => {
      var s;
      n = r.ok && ((s = r.config.logs) === null || s === void 0 ? void 0 : s.captureConsoleLogs) === !0, this.onRemoteConfig(r);
    });
    this.Io ? i.dispose() : (this.Po = i, n || this.loadIfEnabled());
  }
  dispose() {
    var t, e, n, i;
    this.Io || (this.Io = !0, this.Sp(), (t = this.Po) === null || t === void 0 || t.dispose(), this.Po = void 0, this.wo = void 0, this.tp = !1, L?.removeEventListener("online", this.lp), (e = this.xp) === null || e === void 0 || e.call(this), this.xp = void 0, (n = this.up) === null || n === void 0 || n.reset(), (i = this.hp) === null || i === void 0 || i.reset());
  }
  onRemoteConfig(t) {
    var e, n;
    if (this.Io) return;
    const i = t.ok ? (e = t.config.logs) === null || e === void 0 ? void 0 : e.captureConsoleLogs : void 0;
    ve(i) ? this.Cp() : ((n = this._instance) === null || n === void 0 || (n = n.persistence) === null || n === void 0 || n.register({ $logs_capture_enabled_server_side: !!i }), i ? (this.Xf = !0, this.Yf || this.kp(), this.loadIfEnabled()) : this.Cp());
  }
  reset() {
    var t, e, n, i;
    this.Sp(), (t = this.up) === null || t === void 0 || t.clearQueue(), this.al = [], (e = this.up) === null || e === void 0 || e.reset(), (n = this.hp) === null || n === void 0 || n.clearQueue(), this.np = [], (i = this.hp) === null || i === void 0 || i.reset(), this.hd = 0;
  }
  captureLog(t) {
    this.Io || this.fp().captureLog(t);
  }
  captureConsoleLog(t) {
    this.Io || this.mp().captureLog(t);
  }
  captureBufferedConsoleLog(t, e, n) {
    this.Io || this.mp().captureLog(t, { context: e, occurredAtMs: n });
  }
  wp() {
    var t;
    return !!(!((t = this._instance) === null || t === void 0 || (t = t.persistence) === null || t === void 0 || (t = t.props) === null || t === void 0) && t[Q_]);
  }
  _p() {
    var t, e, n;
    return !(!((t = this._instance) === null || t === void 0 || (e = t.nl) === null || e === void 0) && e.call(t)) || !!(!((n = le._POSTHOG_REMOTE_CONFIG) === null || n === void 0 || (n = n[this._instance.config.token]) === null || n === void 0) && n.config);
  }
  $h() {
    var t;
    this.Sp(), (t = this.hp) === null || t === void 0 || t.clearQueue(), this.np = [];
  }
  Cp() {
    this.Xf || this.Sp();
  }
  kp() {
    var t;
    if (this.op || !le?.console) return;
    const e = Qg((t = this._instance) === null || t === void 0 || (t = t.config) === null || t === void 0 ? void 0 : t.logs).maxBufferSize;
    let n = !0;
    this.rp.push(() => {
      n = !1;
    });
    for (const i of SD) {
      let r;
      try {
        r = PD(le.console[i]);
      } catch {
        continue;
      }
      r && this.rp.push(ao(le.console, i, (s) => {
        const o = (...a) => {
          try {
            n && this.$p(i, a, e);
          } catch {
          }
          return s.apply(le.console, a);
        };
        return o.__rrweb_original__ = r, o;
      }));
    }
    this.op = !0, this.Tp = setTimeout(() => {
      this.Sp();
    }, 3e4);
  }
  $p(t, e, n) {
    var i;
    if (this.op && !this.ap && e.length !== 0) if (!((i = this._instance) === null || i === void 0) && i.is_capturing()) {
      if (n > this.sp.length) {
        this.ap = !0;
        try {
          this.sp.push({ level: t, args: e, occurredAtMs: Date.now(), context: this.vp() });
        } finally {
          this.ap = !1;
        }
      }
    } else this.Sp();
  }
  Sp() {
    if (this.sp = [], this.op) {
      this.op = !1, this.Tp && (clearTimeout(this.Tp), this.Tp = void 0);
      for (const t of this.rp) t();
      this.rp = [];
    }
  }
  Ip() {
    const t = this.sp;
    return this.Sp(), t;
  }
  get logger() {
    return this.Mp || (this.Mp = { trace: (t, e) => this.captureLog({ body: t, level: "trace", attributes: e }), debug: (t, e) => this.captureLog({ body: t, level: "debug", attributes: e }), info: (t, e) => this.captureLog({ body: t, level: "info", attributes: e }), warn: (t, e) => this.captureLog({ body: t, level: "warn", attributes: e }), error: (t, e) => this.captureLog({ body: t, level: "error", attributes: e }), fatal: (t, e) => this.captureLog({ body: t, level: "fatal", attributes: e }) }), this.Mp;
  }
  flushLogs(t) {
    t ? this.Ep(t) : (this.up && this.up.flush().catch((e) => this.Pp(e)), this.hp && this.hp.flush().catch((e) => this.Pp(e)));
  }
  Pp(t) {
    tv(t) || this.$.error("PostHog logs flush failed:", t);
  }
  loadIfEnabled() {
    if (this.Io || !this.Xf || this.Yf || this.tp) return;
    const t = le?.__PosthogExtensions__;
    if (!t) return this.$.error("PostHog Extensions not found."), void this.Sp();
    const e = t.loadExternalDependency;
    if (!e) return this.$.error(lf), void this.Sp();
    this.tp = !0;
    try {
      e(this._instance, "logs", (n) => {
        if (this.tp = !1, this.Io || !this.Xf) return;
        const i = t.logs;
        if (n || !i?.initializeLogs) this.$.error("Could not load logs script", n), this.Sp();
        else {
          var r;
          const a = this.Ip();
          var s, o;
          this.xp = i.initializeLogs((r = this.wo) !== null && r !== void 0 ? r : this._instance), this.Yf = !0, a.length > 0 && ((s = i.replayConsoleBuffer) === null || s === void 0 || s.call(i, (o = this.wo) !== null && o !== void 0 ? o : this._instance, a));
        }
      });
    } catch (n) {
      throw this.tp = !1, n;
    }
  }
  dp(t, e) {
    const n = this._instance;
    return { get isDisabled() {
      return !1;
    }, get optedOut() {
      return !n.is_capturing();
    }, getPersistedProperty: (i) => i === hi.LogsQueue ? t() : void 0, setPersistedProperty(i, r) {
      var s;
      i === hi.LogsQueue && e((s = r) !== null && s !== void 0 ? s : []);
    }, js: (i) => this.js(i), getLibraryId: () => ot.LIB_NAME, getLibraryVersion: () => ot.LIB_VERSION };
  }
  js(t) {
    return new Promise((e) => {
      if (Cw(this.hd, 3)) return void e({ kind: "fatal", error: ru(void 0, "logs endpoint is unreachable, dropping batch") });
      let n = !1;
      const i = (s) => {
        n || (n = !0, clearTimeout(r), e(s));
      }, r = setTimeout(() => {
        this.$.warn("Logs request timed out before receiving a response"), i({ kind: "retry-later", error: ru(void 0, "logs request timed out") });
      }, 9e4);
      this._instance._send_request({ method: "POST", url: this.Rp(), data: t, compression: "best-available", batchKey: "logs", fireCallbackOnDrop: !0, callback: (s) => {
        const o = s.statusCode;
        if (this.Ap(o), o >= 200 && 300 > o) i({ kind: "ok" });
        else if (o === 413) i({ kind: "too-large" });
        else if (o !== 0 && o !== 408 && o !== 429 && 500 > o) i({ kind: "fatal", error: new Error(`logs request failed with status ${o}`) });
        else {
          var a;
          o === 0 ? (s.error || this.$.warn("Logs request failed before receiving an HTTP response"), i({ kind: "retry-later", error: ru(s.error, "logs request failed before receiving an HTTP response") })) : i({ kind: "retry-later", error: (a = s.error) !== null && a !== void 0 ? a : new Error(`logs request failed with status ${o}`) });
        }
      } });
    });
  }
  Ap(t) {
    (t !== 0 || this._instance.__loaded) && (this.hd = Aw(t, this.hd, 3, () => this.$.warn("Log requests are failing before receiving an HTTP response; this can happen due to network issues, CORS, browser blocking, or ad blockers. Stopped sending logs; will try again when connectivity changes.")));
  }
  Ep(t) {
    this.al.length > 0 && this.Fp(t, this.al, this.gp, ot.LIB_NAME, (e) => {
      this.al = e;
    }), this.np.length > 0 && this.Fp(t, this.np, this.bp, ev, (e) => {
      this.np = e;
    });
  }
  Fp(t, e, n, i, r) {
    if (e.length === 0) return;
    const s = e.map((a) => a.record);
    r([]);
    const o = q_(s, W_(n, ot.LIB_NAME, ot.LIB_VERSION), i, ot.LIB_VERSION);
    this._instance._send_request({ method: "POST", url: this.Rp(), data: o, compression: "best-available", batchKey: "logs", transport: t });
  }
  Rp() {
    return this._instance.requestRouter.endpointFor("api", "/i/v1/logs") + "?token=" + encodeURIComponent(this._instance.config.token);
  }
  vp() {
    var t;
    const e = {};
    if (e.distinctId = this._instance.get_distinct_id(), this._instance.sessionManager) {
      const { sessionId: n, windowId: i, sessionStartTimestamp: r, lastActivityTimestamp: s } = this._instance.sessionManager.checkAndGetSessionAndWindowId(!0);
      e.sessionId = n, e.windowId = i, ve(r) || (e.sessionStartTimestamp = r), ve(s) || (e.lastActivityTimestamp = s);
    }
    if (!(le == null || (t = le.location) === null || t === void 0) && t.href && (e.currentUrl = this._instance.config.disable_capture_url_hashes ? gn(le.location.href) : le.location.href), this._instance.featureFlags) {
      const n = this._instance.featureFlags.getFlags();
      n && n.length > 0 && (e.activeFeatureFlags = n);
    }
    return e;
  }
} }, zD = { metrics: class {
  constructor(t) {
    this._instance = t, this.$ = Ze("[metrics]"), this.Io = !1;
  }
  initialize() {
    this.onConfigChange();
  }
  onConfigChange() {
    var t;
    if (this.Io) return;
    const e = !!(!((t = this._instance.config.metrics) === null || t === void 0) && t.network);
    e && !this.Op ? this.Op = ((n) => {
      let i = !0;
      const r = () => i ? ((a) => {
        var l;
        const c = (l = a.config.metrics) === null || l === void 0 ? void 0 : l.network;
        return c === !0 ? {} : c || void 0;
      })(n) : void 0, s = CD(n, r), o = AD(n, r);
      return () => {
        i = !1, s(), o();
      };
    })(this._instance) : !e && this.Op && (this.Op(), this.Op = void 0);
  }
  fp() {
    var t;
    const e = (t = this._instance) === null || t === void 0 || (t = t.config) === null || t === void 0 ? void 0 : t.metrics;
    var n;
    return this.up && this.pp === e || ((n = this.up) === null || n === void 0 || n.reset(), this.pp = e, this.up = new fI(this.dp(), (function(i) {
      var r, s, o, a, l;
      const c = i?.resourceAttributes;
      return { serviceName: (r = c?.["service.name"]) !== null && r !== void 0 ? r : i?.serviceName, serviceVersion: (s = c?.["service.version"]) !== null && s !== void 0 ? s : i?.serviceVersion, environment: (o = c?.["deployment.environment"]) !== null && o !== void 0 ? o : i?.environment, resourceAttributes: c, beforeSend: i?.beforeSend, flushIntervalMs: (a = i?.flushIntervalMs) !== null && a !== void 0 ? a : 1e4, maxSeriesPerFlush: (l = i?.maxSeriesPerFlush) !== null && l !== void 0 ? l : 1e3 };
    })(e), this.$)), this.up;
  }
  count(t, e = 1, n) {
    this.fp().count(t, e, n);
  }
  gauge(t, e, n) {
    this.fp().gauge(t, e, n);
  }
  histogram(t, e, n) {
    this.fp().histogram(t, e, n);
  }
  flush(t) {
    if (!this.up) return Promise.resolve();
    if (t) {
      const e = this.up.drainWindow();
      return e && this.Ys(e, t), Promise.resolve();
    }
    return this.up.flush().catch((e) => this.$.error("PostHog metrics flush failed:", e));
  }
  reset() {
    var t;
    (t = this.up) === null || t === void 0 || t.reset();
  }
  dispose() {
    var t, e;
    this.Io = !0, (t = this.Op) === null || t === void 0 || t.call(this), this.Op = void 0, (e = this.up) === null || e === void 0 || e.reset();
  }
  dp() {
    const t = this._instance, e = this;
    return { get isDisabled() {
      return !1;
    }, get optedOut() {
      return !t.is_capturing();
    }, Ys: (n) => e.Ys(n), getLibraryId: () => ot.LIB_NAME, getLibraryVersion: () => ot.LIB_VERSION };
  }
  Ys(t, e) {
    return new Promise((n) => {
      let i = !1;
      const r = (o) => {
        i || (i = !0, clearTimeout(s), n(o));
      }, s = setTimeout(() => r({ kind: "retry-later", error: new Error("metrics request timed out") }), 9e4);
      this._instance._send_request(R(R({ method: "POST", url: this.Dp(), data: t, compression: "best-available", batchKey: "metrics" }, e && { transport: e }), {}, { fireCallbackOnDrop: !0, callback(o) {
        const a = o.statusCode;
        if (a >= 200 && 300 > a) r({ kind: "ok" });
        else if (a === 413) r({ kind: "too-large" });
        else if (a !== 0 && a !== 408 && a !== 429 && 500 > a) r({ kind: "fatal", error: new Error(`metrics request failed with status ${a}`) });
        else {
          var l;
          r({ kind: "retry-later", error: (l = o.error) !== null && l !== void 0 ? l : new Error(`metrics request failed with status ${a}`) });
        }
      } }));
    });
  }
  Dp() {
    return this._instance.requestRouter.endpointFor("api", "/i/v1/metrics") + "?token=" + encodeURIComponent(this._instance.config.token);
  }
} };
zr.__defaultExtensionClasses = R({}, R(R(R(R(R(R(R(R(R(R(R(R(R({}, ec), $D), RD), MD), OD), ID), FD), DD), LD), ND), VD), jD), zD));
const mk = (function() {
  ot.SDK_DIST_CHANNEL = "npm";
  const t = Bs[As] = new zr();
  return (function() {
    function e() {
      e.done || (e.done = !0, tk = !1, Fe(Bs, function(n) {
        n._dom_loaded();
      }));
    }
    Y?.addEventListener ? Y.readyState === "complete" ? e() : Ie(Y, "DOMContentLoaded", e, { capture: !1 }) : L && ee.error("Browser doesn't support `document.addEventListener` so PostHog couldn't be initialized");
  })(), t;
})();
var BD = mk;
const HD = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Compression: It,
  DEFAULT_PRODUCT_TOUR_APPEARANCE: k4,
  DisplaySurveyType: fl,
  PostHog: zr,
  ProductTourEventName: Vw,
  ProductTourEventProperties: Td,
  SurveyEventName: gi,
  SurveyEventProperties: Ra,
  SurveyEventType: vr,
  SurveyPosition: v4,
  SurveyQuestionBranchingType: _4,
  SurveyQuestionType: b4,
  SurveySchedule: w4,
  SurveyTabPosition: y4,
  SurveyType: $a,
  SurveyWidgetType: g4,
  default: BD,
  posthog: mk,
  severityLevels: S4
}, Symbol.toStringTag, { value: "Module" })), UD = /* @__PURE__ */ dT(HD);
var iv;
function WD() {
  if (iv) return ta;
  iv = 1, Object.defineProperty(ta, "__esModule", { value: !0 });
  const t = UD;
  let e = !1;
  function n(i) {
    return {
      name: "posthog",
      initialize: () => {
        i.enabled && t.default.init(i.token, Object.assign(Object.assign({}, i.options), { loaded: () => e = !0 }));
      },
      track: ({ payload: r }) => {
        t.default.capture(r.event, r.properties);
      },
      page: ({ payload: r }) => {
        t.default.capture("$pageview", r.properties);
      },
      identify: ({ payload: r }) => {
        var s, o;
        const { userId: a } = r, l = (s = r.traits.$set) !== null && s !== void 0 ? s : r.traits, c = (o = r.traits.$set_once) !== null && o !== void 0 ? o : {};
        a && t.default.identify(r.userId, l, c);
      },
      loaded: () => e,
      // Custom PostHog's functions to expose to analytics instance
      methods: {
        /** To avoid exposing every method one-by-one, lets exposed scoped instance of posthog itself */
        getPostHogInstance: () => t.default,
        /**
         * Method wrapper for PostHog "group" method - https://posthog.com/docs/product-analytics/group-analytics#setting-and-updating-group-properties
         */
        group: (r, s, o) => {
          t.default.group(r, s, o);
        },
        /**
         * Super Properties are properties associated with events that are set once and then sent with every capture call, be it a $pageview, an autocaptured button click, or anything else.
         * They are set using "posthog.register", which takes a properties object as a parameter, and they persist across sessions.
         */
        register: ({ payload: r }) => {
          t.default.register(r.properties);
        },
        /**
         * An object with properties to be set on the user that will be associated with the user who triggered the event.
         */
        trackAndSet: ({ payload: r }) => {
          t.default.capture(r.event, { $set: r.properties });
        },
        /**
         * An object with properties to be set on the user that will be associated with the user who triggered the event, except that it will only set the property if the user doesn't already have that property set.
         */
        trackAndSetOnce: ({ payload: r }) => {
          t.default.capture(r.event, { $set_once: r.properties });
        },
        /**
         * The argument callback(flags: string[]) will be called when the feature flags are loaded.
         * In case the flags are already loaded, it'll be called immediately. Additionally, it will also be called when the flags are re-loaded e.g. after calling identify or reloadFeatureFlags.
         * @param {function} callback
         */
        onFeatureFlags: (r) => {
          t.default.onFeatureFlags(r);
        },
        /**
         * Checks is the feature flag enabled
         * @param {string} flagName The name of the feature flag
         * @param {boolean} shouldSendEvent Whether to send an event when the flag is checked
         * @returns {boolean} Whether the flag is enabled
         */
        isFeatureEnabled: (r, s = !0) => t.default.isFeatureEnabled(r, { send_event: s }),
        /**
         * Checks multivariate feature flag value
         * @param {string} flagName The name of the feature flag
         * @param {boolean} shouldSendEvent Whether to send an event when the flag is checked
         * @returns {string | boolean | undefined} The flag variant, or undefined if not found
         */
        getFeatureFlag: (r, s = !0) => t.default.getFeatureFlag(r, { send_event: s }),
        reloadFeatureFlags: () => {
          t.default.reloadFeatureFlags();
        },
        /**
         * Returns the distinct id of the current user.
         * @returns {string}
         */
        getDistinctId: () => t.default.get_distinct_id(),
        startSessionRecording: () => {
          t.default.startSessionRecording();
        }
      }
    };
  }
  return ta.default = n, ta;
}
var qD = WD();
const nv = /* @__PURE__ */ uT(qD), GD = nv.default ?? nv, KD = "phc_cBP411kdDDml1o9oVGAf7dTlZmnDJGvKmjFWjSJLsOV";
let Ar = null;
function YD(t) {
  return Ar || (Ar = r3({
    app: "seeen-player",
    plugins: [
      l3({
        // TODO: move default ID to env variable
        measurementIds: ["G-GEBPC3HEZ2", t].filter(
          (e) => !!e
        )
      }),
      GD({
        token: KD,
        enabled: !0,
        options: {
          autocapture: !1,
          capture_pageview: !1,
          capture_pageleave: !1,
          capture_dead_clicks: !1,
          disable_surveys: !0
        }
      })
    ]
  }), Ar);
}
function XD() {
  return Ar;
}
function Ui(t, e) {
  Ar?.track(t, e);
}
var fn = /* @__PURE__ */ ((t) => (t.endCardShow = "endCardShow", t.endCardHide = "endCardHide", t.ctaClick1 = "ctaClick1", t.ctaClick2 = "ctaClick2", t.replay = "replay", t.promoCode = "promoCode", t.watchNextMoment = "watchNextMoment", t.watchFullVideo = "watchFullVideo", t.watchAgain = "watchAgain", t.share = "share", t.socialMedia = "socialMedia", t))(fn || {}), gk = /* @__PURE__ */ ((t) => (t.addView = "addView", t))(gk || {}), $s = /* @__PURE__ */ ((t) => (t.buttonCTAShow = "videoButtonCTAShow", t.buttonCTAClick = "videoButtonCTAClick", t.imageCTAShow = "videoImageCTAShow", t.imageCTAClick = "videoImageCTAClick", t))($s || {});
function JD(t) {
  const e = Se(null);
  return ye(() => {
    if (!e.current) return;
    const n = e.current.getRootNode(), i = [
      ...new Map(
        t.filter((l) => l != null).map((l) => [`${l.fontFamily}:${l.fontWeight}`, l])
      ).values()
    ];
    if (i.length === 0) return;
    const s = `https://fonts.googleapis.com/css2?family=${i.map((l) => `${l.fontFamily.replace(/ /g, "+")}:wght@${l.fontWeight}`).join("&family=")}&display=swap`, o = n.querySelector("link[data-gf]");
    if (o?.getAttribute("href") === s) return;
    o?.remove();
    const a = document.createElement("link");
    a.rel = "stylesheet", a.href = s, a.dataset.gf = "", n.appendChild(a);
  }, [
    t.map((n) => n ? `${n.fontFamily}:${n.fontWeight}` : "").join(",")
  ]), e;
}
function ZD() {
  const t = tt.usePlayer((s) => s.currentTime), e = tt.usePlayer((s) => s.duration), [n, i] = ue(!1), r = e > 0 && t > 0 && t >= e;
  return ye(() => {
    r || i(!1);
  }, [r]), { visible: r && !n, dismiss: () => i(!0) };
}
function vk({
  visible: t,
  onDismiss: e,
  background: n,
  backgroundImageUrl: i,
  children: r
}) {
  return /* @__PURE__ */ Z(
    "div",
    {
      style: {
        position: "absolute",
        inset: 0,
        zIndex: 20,
        transition: "opacity 500ms",
        opacity: t ? 1 : 0,
        pointerEvents: t ? "auto" : "none",
        background: i ? `url(${i}) center/cover no-repeat` : n ?? void 0
      },
      className: "flex flex-col items-center justify-center bg-black/80 backdrop-blur-sm",
      children: [
        /* @__PURE__ */ b(
          "button",
          {
            onClick: e,
            className: "absolute top-3 right-3 flex items-center justify-center w-7 h-7 rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white/70 hover:text-white",
            "aria-label": "Close",
            children: "✕"
          }
        ),
        r
      ]
    }
  );
}
function yk({
  endCard: t,
  visible: e,
  onDismiss: n,
  footer: i
}) {
  const {
    headline: r,
    subline: s,
    ctaButton1: o,
    ctaButton2: a,
    background: l,
    backgroundImageUrl: c
  } = t, u = JD([
    r?.fontFamily,
    s?.fontFamily,
    o?.text.fontFamily,
    a?.text.fontFamily
  ]);
  return ye(() => {
    e && Ui(fn.endCardShow, { end_card_id: t.id });
  }, [e]), /* @__PURE__ */ Z(
    vk,
    {
      visible: e,
      onDismiss: n,
      background: l,
      backgroundImageUrl: c,
      children: [
        /* @__PURE__ */ Z("div", { ref: u, children: [
          r && /* @__PURE__ */ b(
            "p",
            {
              className: "text-xl font-bold text-white mb-1 text-center px-6",
              style: {
                fontFamily: r.fontFamily?.fontFamily,
                fontWeight: r.fontFamily?.fontWeight,
                color: r.color,
                fontSize: r.fontSize
              },
              children: r.text
            }
          ),
          s && /* @__PURE__ */ b(
            "p",
            {
              className: "text-sm text-white/70 mb-5 text-center px-6",
              style: {
                fontFamily: s.fontFamily?.fontFamily,
                fontWeight: s.fontFamily?.fontWeight,
                color: s.color,
                fontSize: s.fontSize
              },
              children: s.text
            }
          ),
          /* @__PURE__ */ Z("div", { className: "flex gap-3", children: [
            o && /* @__PURE__ */ b(
              "a",
              {
                href: Wr(o.url),
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: () => Ui(fn.ctaClick1, {
                  end_card_id: t.id,
                  button: o.name,
                  url: o.url
                }),
                style: {
                  background: o.background.backgroundColor ?? "#fff",
                  border: `${o.border.borderWidth} solid ${o.border.borderColor ?? "transparent"}`,
                  borderRadius: o.border.borderRadius,
                  color: o.text.fontColor,
                  fontSize: o.text.fontSize,
                  fontFamily: o.text.fontFamily?.fontFamily,
                  fontWeight: o.text.fontFamily?.fontWeight,
                  opacity: o.background.backgroundOpacity
                },
                className: "px-5 py-2 text-sm font-semibold hover:opacity-90 transition-opacity",
                children: o.text.text
              }
            ),
            a && /* @__PURE__ */ b(
              "a",
              {
                href: Wr(a.url),
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: () => Ui(fn.ctaClick2, {
                  end_card_id: t.id,
                  button: a.name,
                  url: a.url
                }),
                style: {
                  background: a.background.backgroundColor ?? "transparent",
                  border: `${a.border.borderWidth} solid ${a.border.borderColor ?? "transparent"}`,
                  borderRadius: a.border.borderRadius,
                  color: a.text.fontColor,
                  fontSize: a.text.fontSize,
                  fontFamily: a.text.fontFamily?.fontFamily,
                  fontWeight: a.text.fontFamily?.fontWeight,
                  opacity: a.background.backgroundOpacity
                },
                className: "px-5 py-2 text-sm font-semibold hover:opacity-90 transition-opacity",
                children: a.text.text
              }
            )
          ] })
        ] }),
        i
      ]
    }
  );
}
function rv({
  endCard: t,
  sponsor: e
}) {
  const { visible: n, dismiss: i } = ZD();
  return t ? /* @__PURE__ */ b(yk, { endCard: t, visible: n, onDismiss: i }) : e ? /* @__PURE__ */ b(QD, { sponsor: e, visible: n, onDismiss: i }) : null;
}
function QD({
  sponsor: t,
  visible: e,
  onDismiss: n
}) {
  return ye(() => {
    e && Ui(fn.endCardShow, { sponsor: t.name });
  }, [e]), /* @__PURE__ */ Z(vk, { visible: e, onDismiss: n, children: [
    /* @__PURE__ */ b("p", { className: "text-xs font-semibold uppercase tracking-widest text-white/50 mb-4", children: "Sponsored by" }),
    t.logoImageUrl ? t.logoUrl ? /* @__PURE__ */ b(
      "a",
      {
        href: t.logoUrl ? Wr(t.logoUrl) : void 0,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "mb-4 hover:opacity-80 transition-opacity",
        children: /* @__PURE__ */ b(
          "img",
          {
            src: t.logoImageUrl,
            alt: t.name,
            className: "max-h-20 max-w-56"
          }
        )
      }
    ) : /* @__PURE__ */ b(
      "img",
      {
        src: t.logoImageUrl,
        alt: t.name,
        className: "max-h-20 max-w-56 mb-4"
      }
    ) : t.logoUrl ? /* @__PURE__ */ b(
      "a",
      {
        href: t.logoUrl ? Wr(t.logoUrl) : void 0,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "mb-4 text-2xl font-bold text-white hover:text-white/80 transition-colors",
        children: t.name
      }
    ) : /* @__PURE__ */ b("p", { className: "text-2xl font-bold text-white mb-4", children: t.name }),
    /* @__PURE__ */ Z("p", { className: "absolute bottom-3 text-xs text-white/30", children: [
      "Brought to you by",
      " ",
      /* @__PURE__ */ b("span", { className: "font-semibold text-white/50", children: "SEEEN" })
    ] })
  ] });
}
const bk = Le({});
function eF(t) {
  const e = Se(null);
  return e.current === null && (e.current = t()), e.current;
}
const tF = typeof window < "u", iF = tF ? $t : ye, yf = /* @__PURE__ */ Le(null);
function bf(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function yl(t, e) {
  const n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
const xi = (t, e, n) => n > e ? e : n < t ? t : n;
function Dd(t, e) {
  return e ? `${t}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${e}` : t;
}
let ls = () => {
}, Si = () => {
};
typeof process < "u" && process.env?.NODE_ENV !== "production" && (ls = (t, e, n) => {
  !t && typeof console < "u" && console.warn(Dd(e, n));
}, Si = (t, e, n) => {
  if (!t)
    throw new Error(Dd(e, n));
});
const vn = {}, _k = (t) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(t), wk = (t) => typeof t == "object" && t !== null, kk = (t) => /^0[^.\s]+$/u.test(t);
// @__NO_SIDE_EFFECTS__
function xk(t) {
  let e;
  return () => (e === void 0 && (e = t()), e);
}
const Yt = /* @__NO_SIDE_EFFECTS__ */ (t) => t, Ao = (...t) => t.reduce((e, n) => (i) => n(e(i))), lo = /* @__NO_SIDE_EFFECTS__ */ (t, e, n) => {
  const i = e - t;
  return i ? (n - t) / i : 1;
};
class _f {
  constructor() {
    this.subscriptions = [];
  }
  add(e) {
    return bf(this.subscriptions, e), () => yl(this.subscriptions, e);
  }
  notify(e, n, i) {
    const r = this.subscriptions.length;
    if (r)
      if (r === 1)
        this.subscriptions[0](e, n, i);
      else
        for (let s = 0; s < r; s++) {
          const o = this.subscriptions[s];
          o && o(e, n, i);
        }
  }
  getSize() {
    return this.subscriptions.length;
  }
  clear() {
    this.subscriptions.length = 0;
  }
}
const Ft = /* @__NO_SIDE_EFFECTS__ */ (t) => t * 1e3, qt = /* @__NO_SIDE_EFFECTS__ */ (t) => t / 1e3, Sk = /* @__NO_SIDE_EFFECTS__ */ (t, e) => e ? t * (1e3 / e) : 0, sv = /* @__PURE__ */ new Set();
function wf(t, e, n) {
  t || sv.has(e) || (console.warn(Dd(e, n)), sv.add(e));
}
const Pk = (t, e, n) => (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t, nF = 1e-7, rF = 12;
function sF(t, e, n, i, r) {
  let s, o, a = 0;
  do
    o = e + (n - e) / 2, s = Pk(o, i, r) - t, s > 0 ? n = o : e = o;
  while (Math.abs(s) > nF && ++a < rF);
  return o;
}
// @__NO_SIDE_EFFECTS__
function $o(t, e, n, i) {
  if (t === e && n === i)
    return Yt;
  const r = (s) => sF(s, 0, 1, t, n);
  return (s) => s === 0 || s === 1 ? s : Pk(r(s), e, i);
}
const Ek = /* @__NO_SIDE_EFFECTS__ */ (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, Tk = /* @__NO_SIDE_EFFECTS__ */ (t) => (e) => 1 - t(1 - e), Ck = /* @__PURE__ */ $o(0.33, 1.53, 0.69, 0.99), kf = /* @__PURE__ */ Tk(Ck), Ak = /* @__PURE__ */ Ek(kf), $k = (t) => t >= 1 ? 1 : (t *= 2) < 1 ? 0.5 * kf(t) : 0.5 * (2 - Math.pow(2, -10 * (t - 1))), xf = (t) => 1 - Math.sin(Math.acos(t)), Rk = /* @__PURE__ */ Tk(xf), Mk = /* @__PURE__ */ Ek(xf), oF = /* @__PURE__ */ $o(0.42, 0, 1, 1), aF = /* @__PURE__ */ $o(0, 0, 0.58, 1), Ok = /* @__PURE__ */ $o(0.42, 0, 0.58, 1), lF = /* @__NO_SIDE_EFFECTS__ */ (t) => Array.isArray(t) && typeof t[0] != "number", Ik = /* @__NO_SIDE_EFFECTS__ */ (t) => Array.isArray(t) && typeof t[0] == "number", ov = {
  linear: Yt,
  easeIn: oF,
  easeInOut: Ok,
  easeOut: aF,
  circIn: xf,
  circInOut: Mk,
  circOut: Rk,
  backIn: kf,
  backInOut: Ak,
  backOut: Ck,
  anticipate: $k
}, cF = (t) => typeof t == "string", av = (t) => {
  if (/* @__PURE__ */ Ik(t)) {
    Si(t.length === 4, "Cubic bezier arrays must contain four numerical values.", "cubic-bezier-length");
    const [e, n, i, r] = t;
    return /* @__PURE__ */ $o(e, n, i, r);
  } else if (cF(t))
    return Si(ov[t] !== void 0, `Invalid easing type '${t}'`, "invalid-easing-type"), ov[t];
  return t;
}, ua = [
  "setup",
  // Compute
  "read",
  // Read
  "resolveKeyframes",
  // Write/Read/Write/Read
  "preUpdate",
  // Compute
  "update",
  // Compute
  "preRender",
  // Compute
  "render",
  // Write
  "postRender"
  // Compute
];
function uF(t) {
  let e = /* @__PURE__ */ new Set(), n = /* @__PURE__ */ new Set(), i = !1, r = !1;
  const s = /* @__PURE__ */ new WeakSet();
  let o = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  };
  function a(c) {
    s.has(c) && (l.schedule(c), t()), c(o);
  }
  const l = {
    /**
     * Schedule a process to run on the next frame.
     */
    schedule: (c, u = !1, d = !1) => {
      const f = d && i ? e : n;
      return u && s.add(c), f.add(c), c;
    },
    /**
     * Cancel the provided callback from running on the next frame.
     */
    cancel: (c) => {
      n.delete(c), s.delete(c);
    },
    /**
     * Execute all schedule callbacks.
     */
    process: (c) => {
      if (o = c, i) {
        r = !0;
        return;
      }
      i = !0;
      const u = e;
      e = n, n = u, e.forEach(a), e.clear(), i = !1, r && (r = !1, l.process(c));
    }
  };
  return l;
}
const dF = 40;
function Dk(t, e) {
  let n = !1, i = !0;
  const r = {
    delta: 0,
    timestamp: 0,
    isProcessing: !1
  }, s = () => n = !0, o = ua.reduce((k, _) => (k[_] = uF(s), k), {}), { setup: a, read: l, resolveKeyframes: c, preUpdate: u, update: d, preRender: h, render: f, postRender: p } = o, v = () => {
    const k = vn.useManualTiming, _ = k ? r.timestamp : performance.now();
    n = !1, k || (r.delta = i ? 1e3 / 60 : Math.max(Math.min(_ - r.timestamp, dF), 1)), r.timestamp = _, r.isProcessing = !0, a.process(r), l.process(r), c.process(r), u.process(r), d.process(r), h.process(r), f.process(r), p.process(r), r.isProcessing = !1, n && e && (i = !1, t(v));
  }, g = () => {
    n = !0, i = !0, r.isProcessing || t(v);
  };
  return { schedule: ua.reduce((k, _) => {
    const w = o[_];
    return k[_] = (T, E = !1, S = !1) => (n || g(), w.schedule(T, E, S)), k;
  }, {}), cancel: (k) => {
    for (let _ = 0; _ < ua.length; _++)
      o[ua[_]].cancel(k);
  }, state: r, steps: o };
}
const { schedule: We, cancel: yn, state: gt, steps: su } = /* @__PURE__ */ Dk(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Yt, !0);
let Oa;
function hF() {
  Oa = void 0;
}
const Ct = {
  now: () => (Oa === void 0 && Ct.set(gt.isProcessing || vn.useManualTiming ? gt.timestamp : performance.now()), Oa),
  set: (t) => {
    Oa = t, queueMicrotask(hF);
  }
}, Fk = (t) => (e) => typeof e == "string" && e.startsWith(t), Lk = /* @__PURE__ */ Fk("--"), fF = /* @__PURE__ */ Fk("var(--"), Sf = (t) => fF(t) ? pF.test(t.split("/*")[0].trim()) : !1, pF = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
function lv(t) {
  return typeof t != "string" ? !1 : t.split("/*")[0].includes("var(--");
}
const cs = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, co = {
  ...cs,
  transform: (t) => xi(0, 1, t)
}, da = {
  ...cs,
  default: 1
}, Us = (t) => Math.round(t * 1e5) / 1e5, Pf = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;
function mF(t) {
  return t == null;
}
const gF = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu, Ef = (t, e) => (n) => !!(typeof n == "string" && gF.test(n) && n.startsWith(t) || e && !mF(n) && Object.prototype.hasOwnProperty.call(n, e)), Nk = (t, e, n) => (i) => {
  if (typeof i != "string")
    return i;
  const [r, s, o, a] = i.match(Pf);
  return {
    [t]: parseFloat(r),
    [e]: parseFloat(s),
    [n]: parseFloat(o),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, vF = (t) => xi(0, 255, t), ou = {
  ...cs,
  transform: (t) => Math.round(vF(t))
}, Bn = {
  test: /* @__PURE__ */ Ef("rgb", "red"),
  parse: /* @__PURE__ */ Nk("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: i = 1 }) => "rgba(" + ou.transform(t) + ", " + ou.transform(e) + ", " + ou.transform(n) + ", " + Us(co.transform(i)) + ")"
};
function yF(t) {
  let e = "", n = "", i = "", r = "";
  return t.length > 5 ? (e = t.substring(1, 3), n = t.substring(3, 5), i = t.substring(5, 7), r = t.substring(7, 9)) : (e = t.substring(1, 2), n = t.substring(2, 3), i = t.substring(3, 4), r = t.substring(4, 5), e += e, n += n, i += i, r += r), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(i, 16),
    alpha: r ? parseInt(r, 16) / 255 : 1
  };
}
const Fd = {
  test: /* @__PURE__ */ Ef("#"),
  parse: yF,
  transform: Bn.transform
}, Ro = /* @__NO_SIDE_EFFECTS__ */ (t) => ({
  test: (e) => typeof e == "string" && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), Ii = /* @__PURE__ */ Ro("deg"), _i = /* @__PURE__ */ Ro("%"), ce = /* @__PURE__ */ Ro("px"), bF = /* @__PURE__ */ Ro("vh"), _F = /* @__PURE__ */ Ro("vw"), cv = {
  ..._i,
  parse: (t) => _i.parse(t) / 100,
  transform: (t) => _i.transform(t * 100)
}, $r = {
  test: /* @__PURE__ */ Ef("hsl", "hue"),
  parse: /* @__PURE__ */ Nk("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: i = 1 }) => "hsla(" + Math.round(t) + ", " + _i.transform(Us(e)) + ", " + _i.transform(Us(n)) + ", " + Us(co.transform(i)) + ")"
}, st = {
  test: (t) => Bn.test(t) || Fd.test(t) || $r.test(t),
  parse: (t) => Bn.test(t) ? Bn.parse(t) : $r.test(t) ? $r.parse(t) : Fd.parse(t),
  transform: (t) => typeof t == "string" ? t : t.hasOwnProperty("red") ? Bn.transform(t) : $r.transform(t),
  getAnimatableNone: (t) => {
    const e = st.parse(t);
    return e.alpha = 0, st.transform(e);
  }
}, wF = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;
function kF(t) {
  return isNaN(t) && typeof t == "string" && (t.match(Pf)?.length || 0) + (t.match(wF)?.length || 0) > 0;
}
const Vk = "number", jk = "color", xF = "var", SF = "var(", uv = "${}", PF = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function es(t) {
  const e = t.toString(), n = [], i = {
    color: [],
    number: [],
    var: []
  }, r = [];
  let s = 0;
  const a = e.replace(PF, (l) => (st.test(l) ? (i.color.push(s), r.push(jk), n.push(st.parse(l))) : l.startsWith(SF) ? (i.var.push(s), r.push(xF), n.push(l)) : (i.number.push(s), r.push(Vk), n.push(parseFloat(l))), ++s, uv)).split(uv);
  return { values: n, split: a, indexes: i, types: r };
}
function EF(t) {
  return es(t).values;
}
function zk({ split: t, types: e }) {
  const n = t.length;
  return (i) => {
    let r = "";
    for (let s = 0; s < n; s++)
      if (r += t[s], i[s] !== void 0) {
        const o = e[s];
        o === Vk ? r += Us(i[s]) : o === jk ? r += st.transform(i[s]) : r += i[s];
      }
    return r;
  };
}
function TF(t) {
  return zk(es(t));
}
const CF = (t) => typeof t == "number" ? 0 : st.test(t) ? st.getAnimatableNone(t) : t, AF = (t, e) => typeof t == "number" ? e?.trim().endsWith("/") ? t : 0 : CF(t);
function $F(t) {
  const e = es(t);
  return zk(e)(e.values.map((i, r) => AF(i, e.split[r])));
}
const ai = {
  test: kF,
  parse: EF,
  createTransformer: TF,
  getAnimatableNone: $F
};
function au(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function RF({ hue: t, saturation: e, lightness: n, alpha: i }) {
  t /= 360, e /= 100, n /= 100;
  let r = 0, s = 0, o = 0;
  if (!e)
    r = s = o = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    r = au(l, a, t + 1 / 3), s = au(l, a, t), o = au(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: i
  };
}
function bl(t, e) {
  return (n) => n > 0 ? e : t;
}
const Ue = (t, e, n) => t + (e - t) * n, lu = (t, e, n) => {
  const i = t * t, r = n * (e * e - i) + i;
  return r < 0 ? 0 : Math.sqrt(r);
}, MF = [Fd, Bn, $r], OF = (t) => MF.find((e) => e.test(t));
function dv(t) {
  const e = OF(t);
  if (ls(!!e, `'${t}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable"), !e)
    return !1;
  let n = e.parse(t);
  return e === $r && (n = RF(n)), n;
}
const hv = (t, e) => {
  const n = dv(t), i = dv(e);
  if (!n || !i)
    return bl(t, e);
  const r = { ...n };
  return (s) => (r.red = lu(n.red, i.red, s), r.green = lu(n.green, i.green, s), r.blue = lu(n.blue, i.blue, s), r.alpha = Ue(n.alpha, i.alpha, s), Bn.transform(r));
}, Ld = /* @__PURE__ */ new Set(["none", "hidden"]);
function IF(t, e) {
  return Ld.has(t) ? (n) => n <= 0 ? t : e : (n) => n >= 1 ? e : t;
}
function DF(t, e) {
  return (n) => Ue(t, e, n);
}
function Tf(t) {
  return typeof t == "number" ? DF : typeof t == "string" ? Sf(t) ? bl : st.test(t) ? hv : NF : Array.isArray(t) ? Bk : typeof t == "object" ? st.test(t) ? hv : FF : bl;
}
function Bk(t, e) {
  const n = [...t], i = n.length, r = t.map((s, o) => Tf(s)(s, e[o]));
  return (s) => {
    for (let o = 0; o < i; o++)
      n[o] = r[o](s);
    return n;
  };
}
function FF(t, e) {
  const n = { ...t, ...e }, i = {};
  for (const r in n)
    t[r] !== void 0 && e[r] !== void 0 && (i[r] = Tf(t[r])(t[r], e[r]));
  return (r) => {
    for (const s in i)
      n[s] = i[s](r);
    return n;
  };
}
function LF(t, e) {
  const n = [], i = { color: 0, var: 0, number: 0 };
  for (let r = 0; r < e.values.length; r++) {
    const s = e.types[r], o = t.indexes[s][i[s]], a = t.values[o] ?? 0;
    n[r] = a, i[s]++;
  }
  return n;
}
const NF = (t, e) => {
  const n = ai.createTransformer(e), i = es(t), r = es(e);
  return i.indexes.var.length === r.indexes.var.length && i.indexes.color.length === r.indexes.color.length && i.indexes.number.length >= r.indexes.number.length ? Ld.has(t) && !r.values.length || Ld.has(e) && !i.values.length ? IF(t, e) : Ao(Bk(LF(i, r), r.values), n) : (ls(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different"), bl(t, e));
};
function Hk(t, e, n) {
  return typeof t == "number" && typeof e == "number" && typeof n == "number" ? Ue(t, e, n) : Tf(t)(t, e);
}
const VF = (t) => {
  const e = ({ timestamp: n }) => t(n);
  return {
    start: (n = !0) => We.update(e, n),
    stop: () => yn(e),
    /**
     * If we're processing this frame we can use the
     * framelocked timestamp to keep things in sync.
     */
    now: () => gt.isProcessing ? gt.timestamp : Ct.now()
  };
}, Uk = (t, e, n = 10) => {
  let i = "";
  const r = Math.max(Math.round(e / n), 2);
  for (let s = 0; s < r; s++)
    i += Math.round(t(s / (r - 1)) * 1e4) / 1e4 + ", ";
  return `linear(${i.substring(0, i.length - 2)})`;
}, _l = 2e4;
function Cf(t) {
  let e = 0;
  const n = 50;
  let i = t.next(e);
  for (; !i.done && e < _l; )
    e += n, i = t.next(e);
  return e >= _l ? 1 / 0 : e;
}
function jF(t, e = 100, n) {
  const i = n({ ...t, keyframes: [0, e] }), r = Math.min(Cf(i), _l);
  return {
    type: "keyframes",
    ease: (s) => i.next(r * s).value / e,
    duration: /* @__PURE__ */ qt(r)
  };
}
const et = {
  // Default spring physics
  stiffness: 100,
  damping: 10,
  mass: 1,
  velocity: 0,
  // Default duration/bounce-based options
  duration: 800,
  // in ms
  bounce: 0.3,
  visualDuration: 0.3,
  // in seconds
  // Rest thresholds
  restSpeed: {
    granular: 0.01,
    default: 2
  },
  restDelta: {
    granular: 5e-3,
    default: 0.5
  },
  // Limits
  minDuration: 0.01,
  // in seconds
  maxDuration: 10,
  // in seconds
  minDamping: 0.05,
  maxDamping: 1
};
function Nd(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const zF = 12;
function BF(t, e, n) {
  let i = n;
  for (let r = 1; r < zF; r++)
    i = i - t(i) / e(i);
  return i;
}
const cu = 1e-3;
function HF({ duration: t = et.duration, bounce: e = et.bounce, velocity: n = et.velocity, mass: i = et.mass }) {
  let r, s;
  ls(t <= /* @__PURE__ */ Ft(et.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
  let o = 1 - e;
  o = xi(et.minDamping, et.maxDamping, o), t = xi(et.minDuration, et.maxDuration, /* @__PURE__ */ qt(t)), o < 1 ? (r = (c) => {
    const u = c * o, d = u * t, h = u - n, f = Nd(c, o), p = Math.exp(-d);
    return cu - h / f * p;
  }, s = (c) => {
    const d = c * o * t, h = d * n + n, f = Math.pow(o, 2) * Math.pow(c, 2) * t, p = Math.exp(-d), v = Nd(Math.pow(c, 2), o);
    return (-r(c) + cu > 0 ? -1 : 1) * ((h - f) * p) / v;
  }) : (r = (c) => {
    const u = Math.exp(-c * t), d = (c - n) * t + 1;
    return -cu + u * d;
  }, s = (c) => {
    const u = Math.exp(-c * t), d = (n - c) * (t * t);
    return u * d;
  });
  const a = 5 / t, l = BF(r, s, a);
  if (t = /* @__PURE__ */ Ft(t), isNaN(l))
    return {
      stiffness: et.stiffness,
      damping: et.damping,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * i;
    return {
      stiffness: c,
      damping: o * 2 * Math.sqrt(i * c),
      duration: t
    };
  }
}
const UF = ["duration", "bounce"], WF = ["stiffness", "damping", "mass"];
function fv(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function qF(t) {
  let e = {
    velocity: et.velocity,
    stiffness: et.stiffness,
    damping: et.damping,
    mass: et.mass,
    isResolvedFromDuration: !1,
    ...t
  };
  if (!fv(t, WF) && fv(t, UF))
    if (e.velocity = 0, t.visualDuration) {
      const n = t.visualDuration, i = 2 * Math.PI / (n * 1.2), r = i * i, s = 2 * xi(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(r);
      e = {
        ...e,
        mass: et.mass,
        stiffness: r,
        damping: s
      };
    } else {
      const n = HF({ ...t, velocity: 0 });
      e = {
        ...e,
        ...n,
        mass: et.mass
      }, e.isResolvedFromDuration = !0;
    }
  return e;
}
function wl(t = et.visualDuration, e = et.bounce) {
  const n = typeof t != "object" ? {
    visualDuration: t,
    keyframes: [0, 1],
    bounce: e
  } : t;
  let { restSpeed: i, restDelta: r } = n;
  const s = n.keyframes[0], o = n.keyframes[n.keyframes.length - 1], a = { done: !1, value: s }, { stiffness: l, damping: c, mass: u, duration: d, velocity: h, isResolvedFromDuration: f } = qF({
    ...n,
    velocity: -/* @__PURE__ */ qt(n.velocity || 0)
  }), p = h || 0, v = c / (2 * Math.sqrt(l * u)), g = o - s, m = /* @__PURE__ */ qt(Math.sqrt(l / u)), y = Math.abs(g) < 5;
  i || (i = y ? et.restSpeed.granular : et.restSpeed.default), r || (r = y ? et.restDelta.granular : et.restDelta.default);
  let k, _, w, T, E, S;
  if (v < 1)
    w = Nd(m, v), T = (p + v * m * g) / w, k = (C) => {
      const M = Math.exp(-v * m * C);
      return o - M * (T * Math.sin(w * C) + g * Math.cos(w * C));
    }, E = v * m * T + g * w, S = v * m * g - T * w, _ = (C) => Math.exp(-v * m * C) * (E * Math.sin(w * C) + S * Math.cos(w * C));
  else if (v === 1) {
    k = (M) => o - Math.exp(-m * M) * (g + (p + m * g) * M);
    const C = p + m * g;
    _ = (M) => Math.exp(-m * M) * (m * C * M - p);
  } else {
    const C = m * Math.sqrt(v * v - 1);
    k = (H) => {
      const z = Math.exp(-v * m * H), F = Math.min(C * H, 300);
      return o - z * ((p + v * m * g) * Math.sinh(F) + C * g * Math.cosh(F)) / C;
    };
    const M = (p + v * m * g) / C, O = v * m * M - g * C, W = v * m * g - M * C;
    _ = (H) => {
      const z = Math.exp(-v * m * H), F = Math.min(C * H, 300);
      return z * (O * Math.sinh(F) + W * Math.cosh(F));
    };
  }
  const P = {
    calculatedDuration: f && d || null,
    velocity: (C) => /* @__PURE__ */ Ft(_(C)),
    next: (C) => {
      if (!f && v < 1) {
        const O = Math.exp(-v * m * C), W = Math.sin(w * C), H = Math.cos(w * C), z = o - O * (T * W + g * H), F = /* @__PURE__ */ Ft(O * (E * W + S * H));
        return a.done = Math.abs(F) <= i && Math.abs(o - z) <= r, a.value = a.done ? o : z, a;
      }
      const M = k(C);
      if (f)
        a.done = C >= d;
      else {
        const O = /* @__PURE__ */ Ft(_(C));
        a.done = Math.abs(O) <= i && Math.abs(o - M) <= r;
      }
      return a.value = a.done ? o : M, a;
    },
    toString: () => {
      const C = Math.min(Cf(P), _l), M = Uk((O) => P.next(C * O).value, C, 30);
      return C + "ms " + M;
    },
    toTransition: () => {
    }
  };
  return P;
}
wl.applyToOptions = (t) => {
  const e = jF(t, 100, wl);
  return t.ease = e.ease, t.duration = /* @__PURE__ */ Ft(e.duration), t.type = "keyframes", t;
};
const GF = 5;
function Wk(t, e, n) {
  const i = Math.max(e - GF, 0);
  return /* @__PURE__ */ Sk(n - t(i), e - i);
}
function Vd({ keyframes: t, velocity: e = 0, power: n = 0.8, timeConstant: i = 325, bounceDamping: r = 10, bounceStiffness: s = 500, modifyTarget: o, min: a, max: l, restDelta: c = 0.5, restSpeed: u }) {
  const d = t[0], h = {
    done: !1,
    value: d
  }, f = (S) => a !== void 0 && S < a || l !== void 0 && S > l, p = (S) => a === void 0 ? l : l === void 0 || Math.abs(a - S) < Math.abs(l - S) ? a : l;
  let v = n * e;
  const g = d + v, m = o === void 0 ? g : o(g);
  m !== g && (v = m - d);
  const y = (S) => -v * Math.exp(-S / i), k = (S) => m + y(S), _ = (S) => {
    const P = y(S), C = k(S);
    h.done = Math.abs(P) <= c, h.value = h.done ? m : C;
  };
  let w, T;
  const E = (S) => {
    f(h.value) && (w = S, T = wl({
      keyframes: [h.value, p(h.value)],
      velocity: Wk(k, S, h.value),
      // TODO: This should be passing * 1000
      damping: r,
      stiffness: s,
      restDelta: c,
      restSpeed: u
    }));
  };
  return E(0), {
    calculatedDuration: null,
    next: (S) => {
      let P = !1;
      return !T && w === void 0 && (P = !0, _(S), E(S)), w !== void 0 && S >= w ? T.next(S - w) : (!P && _(S), h);
    }
  };
}
function KF(t, e, n) {
  const i = [], r = n || vn.mix || Hk, s = t.length - 1;
  for (let o = 0; o < s; o++) {
    let a = r(t[o], t[o + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[o] || Yt : e;
      a = Ao(l, a);
    }
    i.push(a);
  }
  return i;
}
function YF(t, e, { clamp: n = !0, ease: i, mixer: r } = {}) {
  const s = t.length;
  if (Si(s === e.length, "Both input and output ranges must be the same length", "range-length"), s === 1)
    return () => e[0];
  if (s === 2 && e[0] === e[1])
    return () => e[1];
  const o = t[0] === t[1];
  t[0] > t[s - 1] && (t = [...t].reverse(), e = [...e].reverse());
  const a = KF(e, i, r), l = a.length, c = (u) => {
    if (o && u < t[0])
      return e[0];
    let d = 0;
    if (l > 1)
      for (; d < t.length - 2 && !(u < t[d + 1]); d++)
        ;
    const h = /* @__PURE__ */ lo(t[d], t[d + 1], u);
    return a[d](h);
  };
  return n ? (u) => c(xi(t[0], t[s - 1], u)) : c;
}
function XF(t, e) {
  const n = t[t.length - 1];
  for (let i = 1; i <= e; i++) {
    const r = /* @__PURE__ */ lo(0, e, i);
    t.push(Ue(n, 1, r));
  }
}
function JF(t) {
  const e = [0];
  return XF(e, t.length - 1), e;
}
function ZF(t, e) {
  return t.map((n) => n * e);
}
function QF(t, e) {
  return t.map(() => e || Ok).splice(0, t.length - 1);
}
function Rr({ duration: t = 300, keyframes: e, times: n, ease: i = "easeInOut" }) {
  const r = /* @__PURE__ */ lF(i) ? i.map(av) : av(i), s = {
    done: !1,
    value: e[0]
  }, o = ZF(
    // Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    n && n.length === e.length ? n : JF(e),
    t
  ), a = YF(o, e, {
    ease: Array.isArray(r) ? r : QF(e, r)
  });
  return {
    calculatedDuration: t,
    next: (l) => (s.value = a(l), s.done = l >= t, s)
  };
}
const eL = (t) => t !== null;
function tc(t, { repeat: e, repeatType: n = "loop" }, i, r = 1) {
  const s = t.filter(eL), a = r < 0 || e && n !== "loop" && e % 2 === 1 ? 0 : s.length - 1;
  return !a || i === void 0 ? s[a] : i;
}
const tL = {
  decay: Vd,
  inertia: Vd,
  tween: Rr,
  keyframes: Rr,
  spring: wl
};
function qk(t) {
  typeof t.type == "string" && (t.type = tL[t.type]);
}
class Af {
  constructor() {
    this.updateFinished();
  }
  get finished() {
    return this._finished;
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e;
    });
  }
  notifyFinished() {
    this.resolve();
  }
  /**
   * Allows the animation to be awaited.
   *
   * @deprecated Use `finished` instead.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
}
const iL = (t) => t / 100;
class kl extends Af {
  constructor(e) {
    super(), this.state = "idle", this.startTime = null, this.isStopped = !1, this.currentTime = 0, this.holdTime = null, this.playbackSpeed = 1, this.delayState = {
      done: !1,
      value: void 0
    }, this.stop = () => {
      const { motionValue: n } = this.options;
      n && n.updatedAt !== Ct.now() && this.tick(Ct.now()), this.isStopped = !0, this.state !== "idle" && (this.teardown(), this.options.onStop?.());
    }, this.options = e, this.initAnimation(), this.play(), e.autoplay === !1 && this.pause();
  }
  initAnimation() {
    const { options: e } = this;
    qk(e);
    const { type: n = Rr, repeat: i = 0, repeatDelay: r = 0, repeatType: s, velocity: o = 0 } = e;
    let { keyframes: a } = e;
    const l = n || Rr;
    process.env.NODE_ENV !== "production" && l !== Rr && Si(a.length <= 2, `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${a}`, "spring-two-frames"), l !== Rr && typeof a[0] != "number" && (this.mixKeyframes = Ao(iL, Hk(a[0], a[1])), a = [0, 100]);
    const c = l({ ...e, keyframes: a });
    s === "mirror" && (this.mirroredGenerator = l({
      ...e,
      keyframes: [...a].reverse(),
      velocity: -o
    })), c.calculatedDuration === null && (c.calculatedDuration = Cf(c));
    const { calculatedDuration: u } = c;
    this.calculatedDuration = u, this.resolvedDuration = u + r, this.totalDuration = this.resolvedDuration * (i + 1) - r, this.generator = c;
  }
  updateTime(e) {
    const n = Math.round(e - this.startTime) * this.playbackSpeed;
    this.holdTime !== null ? this.currentTime = this.holdTime : this.currentTime = n;
  }
  tick(e, n = !1) {
    const { generator: i, totalDuration: r, mixKeyframes: s, mirroredGenerator: o, resolvedDuration: a, calculatedDuration: l } = this;
    if (this.startTime === null)
      return i.next(0);
    const { delay: c = 0, keyframes: u, repeat: d, repeatType: h, repeatDelay: f, type: p, onUpdate: v, finalKeyframe: g } = this.options;
    this.speed > 0 ? this.startTime = Math.min(this.startTime, e) : this.speed < 0 && (this.startTime = Math.min(e - r / this.speed, this.startTime)), n ? this.currentTime = e : this.updateTime(e);
    const m = this.currentTime - c * (this.playbackSpeed >= 0 ? 1 : -1), y = this.playbackSpeed >= 0 ? m < 0 : m > r;
    this.currentTime = Math.max(m, 0), this.state === "finished" && this.holdTime === null && (this.currentTime = r);
    let k = this.currentTime, _ = i;
    if (d) {
      const S = Math.min(this.currentTime, r) / a;
      let P = Math.floor(S), C = S % 1;
      !C && S >= 1 && (C = 1), C === 1 && P--, P = Math.min(P, d + 1), P % 2 && (h === "reverse" ? (C = 1 - C, f && (C -= f / a)) : h === "mirror" && (_ = o)), k = xi(0, 1, C) * a;
    }
    let w;
    y ? (this.delayState.value = u[0], w = this.delayState) : w = _.next(k), s && !y && (w.value = s(w.value));
    let { done: T } = w;
    !y && l !== null && (T = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0);
    const E = this.holdTime === null && (this.state === "finished" || this.state === "running" && T);
    return E && p !== Vd && (w.value = tc(u, this.options, g, this.speed)), v && v(w.value), E && this.finish(), w;
  }
  /**
   * Allows the returned animation to be awaited or promise-chained. Currently
   * resolves when the animation finishes at all but in a future update could/should
   * reject if its cancels.
   */
  then(e, n) {
    return this.finished.then(e, n);
  }
  get duration() {
    return /* @__PURE__ */ qt(this.calculatedDuration);
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ qt(e);
  }
  get time() {
    return /* @__PURE__ */ qt(this.currentTime);
  }
  set time(e) {
    e = /* @__PURE__ */ Ft(e), this.currentTime = e, this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0 ? this.holdTime = e : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed), this.driver ? this.driver.start(!1) : (this.startTime = 0, this.state = "paused", this.holdTime = e, this.tick(e));
  }
  /**
   * Returns the generator's velocity at the current time in units/second.
   * Uses the analytical derivative when available (springs), avoiding
   * the MotionValue's frame-dependent velocity estimation.
   */
  getGeneratorVelocity() {
    const e = this.currentTime;
    if (e <= 0)
      return this.options.velocity || 0;
    if (this.generator.velocity)
      return this.generator.velocity(e);
    const n = this.generator.next(e).value;
    return Wk((i) => this.generator.next(i).value, e, n);
  }
  get speed() {
    return this.playbackSpeed;
  }
  set speed(e) {
    const n = this.playbackSpeed !== e;
    n && this.driver && this.updateTime(Ct.now()), this.playbackSpeed = e, n && this.driver && (this.time = /* @__PURE__ */ qt(this.currentTime));
  }
  play() {
    if (this.isStopped)
      return;
    const { driver: e = VF, startTime: n } = this.options;
    this.driver || (this.driver = e((r) => this.tick(r))), this.options.onPlay?.();
    const i = this.driver.now();
    this.state === "finished" ? (this.updateFinished(), this.startTime = i) : this.holdTime !== null ? this.startTime = i - this.holdTime : this.startTime || (this.startTime = n ?? i), this.state === "finished" && this.speed < 0 && (this.startTime += this.calculatedDuration), this.holdTime = null, this.state = "running", this.driver.start();
  }
  pause() {
    this.state = "paused", this.updateTime(Ct.now()), this.holdTime = this.currentTime;
  }
  complete() {
    this.state !== "running" && this.play(), this.state = "finished", this.holdTime = null;
  }
  finish() {
    this.notifyFinished(), this.teardown(), this.state = "finished", this.options.onComplete?.();
  }
  cancel() {
    this.holdTime = null, this.startTime = 0, this.tick(0), this.teardown(), this.options.onCancel?.();
  }
  teardown() {
    this.state = "idle", this.stopDriver(), this.startTime = this.holdTime = null;
  }
  stopDriver() {
    this.driver && (this.driver.stop(), this.driver = void 0);
  }
  sample(e) {
    return this.startTime = 0, this.tick(e, !0);
  }
  attachTimeline(e) {
    return this.options.allowFlatten && (this.options.type = "keyframes", this.options.ease = "linear", this.initAnimation()), this.driver?.stop(), e.observe(this);
  }
}
function nL(t) {
  for (let e = 1; e < t.length; e++)
    t[e] ?? (t[e] = t[e - 1]);
}
const Hn = (t) => t * 180 / Math.PI, jd = (t) => {
  const e = Hn(Math.atan2(t[1], t[0]));
  return zd(e);
}, rL = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: (t) => (Math.abs(t[0]) + Math.abs(t[3])) / 2,
  rotate: jd,
  rotateZ: jd,
  skewX: (t) => Hn(Math.atan(t[1])),
  skewY: (t) => Hn(Math.atan(t[2])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[2])) / 2
}, zd = (t) => (t = t % 360, t < 0 && (t += 360), t), pv = jd, mv = (t) => Math.sqrt(t[0] * t[0] + t[1] * t[1]), gv = (t) => Math.sqrt(t[4] * t[4] + t[5] * t[5]), sL = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: mv,
  scaleY: gv,
  scale: (t) => (mv(t) + gv(t)) / 2,
  rotateX: (t) => zd(Hn(Math.atan2(t[6], t[5]))),
  rotateY: (t) => zd(Hn(Math.atan2(-t[2], t[0]))),
  rotateZ: pv,
  rotate: pv,
  skewX: (t) => Hn(Math.atan(t[4])),
  skewY: (t) => Hn(Math.atan(t[1])),
  skew: (t) => (Math.abs(t[1]) + Math.abs(t[4])) / 2
};
function Bd(t) {
  return t.includes("scale") ? 1 : 0;
}
function Hd(t, e) {
  if (!t || t === "none")
    return Bd(e);
  const n = t.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
  let i, r;
  if (n)
    i = sL, r = n;
  else {
    const a = t.match(/^matrix\(([-\d.e\s,]+)\)$/u);
    i = rL, r = a;
  }
  if (!r)
    return Bd(e);
  const s = i[e], o = r[1].split(",").map(aL);
  return typeof s == "function" ? s(o) : o[s];
}
const oL = (t, e) => {
  const { transform: n = "none" } = getComputedStyle(t);
  return Hd(n, e);
};
function aL(t) {
  return parseFloat(t.trim());
}
const us = [
  "transformPerspective",
  "x",
  "y",
  "z",
  "translateX",
  "translateY",
  "translateZ",
  "scale",
  "scaleX",
  "scaleY",
  "rotate",
  "rotateX",
  "rotateY",
  "rotateZ",
  "skew",
  "skewX",
  "skewY"
], ds = /* @__PURE__ */ new Set([...us, "pathRotation"]), vv = (t) => t === cs || t === ce, lL = /* @__PURE__ */ new Set(["x", "y", "z"]), cL = us.filter((t) => !lL.has(t));
function uL(t) {
  const e = [];
  return cL.forEach((n) => {
    const i = t.getValue(n);
    i !== void 0 && (e.push([n, i.get()]), i.set(n.startsWith("scale") ? 1 : 0));
  }), e;
}
const ln = {
  // Dimensions
  width: ({ x: t }, { paddingLeft: e = "0", paddingRight: n = "0", boxSizing: i }) => {
    const r = t.max - t.min;
    return i === "border-box" ? r : r - parseFloat(e) - parseFloat(n);
  },
  height: ({ y: t }, { paddingTop: e = "0", paddingBottom: n = "0", boxSizing: i }) => {
    const r = t.max - t.min;
    return i === "border-box" ? r : r - parseFloat(e) - parseFloat(n);
  },
  top: (t, { top: e }) => parseFloat(e),
  left: (t, { left: e }) => parseFloat(e),
  bottom: ({ y: t }, { top: e }) => parseFloat(e) + (t.max - t.min),
  right: ({ x: t }, { left: e }) => parseFloat(e) + (t.max - t.min),
  // Transform
  x: (t, { transform: e }) => Hd(e, "x"),
  y: (t, { transform: e }) => Hd(e, "y")
};
ln.translateX = ln.x;
ln.translateY = ln.y;
const Xn = /* @__PURE__ */ new Set();
let Ud = !1, Wd = !1, qd = !1;
function Gk() {
  if (Wd) {
    const t = Array.from(Xn).filter((i) => i.needsMeasurement), e = new Set(t.map((i) => i.element)), n = /* @__PURE__ */ new Map();
    e.forEach((i) => {
      const r = uL(i);
      r.length && (n.set(i, r), i.render());
    }), t.forEach((i) => i.measureInitialState()), e.forEach((i) => {
      i.render();
      const r = n.get(i);
      r && r.forEach(([s, o]) => {
        i.getValue(s)?.set(o);
      });
    }), t.forEach((i) => i.measureEndState()), t.forEach((i) => {
      i.suspendedScrollY !== void 0 && window.scrollTo(0, i.suspendedScrollY);
    });
  }
  Wd = !1, Ud = !1, Xn.forEach((t) => t.complete(qd)), Xn.clear();
}
function Kk() {
  Xn.forEach((t) => {
    t.readKeyframes(), t.needsMeasurement && (Wd = !0);
  });
}
function dL() {
  qd = !0, Kk(), Gk(), qd = !1;
}
class $f {
  constructor(e, n, i, r, s, o = !1) {
    this.state = "pending", this.isAsync = !1, this.needsMeasurement = !1, this.unresolvedKeyframes = [...e], this.onComplete = n, this.name = i, this.motionValue = r, this.element = s, this.isAsync = o;
  }
  scheduleResolve() {
    this.state = "scheduled", this.isAsync ? (Xn.add(this), Ud || (Ud = !0, We.read(Kk), We.resolveKeyframes(Gk))) : (this.readKeyframes(), this.complete());
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: n, element: i, motionValue: r } = this;
    if (e[0] === null) {
      const s = r?.get(), o = e[e.length - 1];
      if (s !== void 0)
        e[0] = s;
      else if (i && n) {
        const a = i.readValue(n, o);
        a != null && (e[0] = a);
      }
      e[0] === void 0 && (e[0] = o), r && s === void 0 && r.set(e[0]);
    }
    nL(e);
  }
  setFinalKeyframe() {
  }
  measureInitialState() {
  }
  renderEndStyles() {
  }
  measureEndState() {
  }
  complete(e = !1) {
    this.state = "complete", this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e), Xn.delete(this);
  }
  cancel() {
    this.state === "scheduled" && (Xn.delete(this), this.state = "pending");
  }
  resume() {
    this.state === "pending" && this.scheduleResolve();
  }
}
const hL = (t) => t.startsWith("--");
function Yk(t, e, n) {
  hL(e) ? t.style.setProperty(e, n) : t.style[e] = n;
}
const fL = {};
function Xk(t, e) {
  const n = /* @__PURE__ */ xk(t);
  return () => fL[e] ?? n();
}
const pL = /* @__PURE__ */ Xk(() => window.ScrollTimeline !== void 0, "scrollTimeline"), Jk = /* @__PURE__ */ Xk(() => {
  try {
    document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
  } catch {
    return !1;
  }
  return !0;
}, "linearEasing"), Rs = ([t, e, n, i]) => `cubic-bezier(${t}, ${e}, ${n}, ${i})`, yv = {
  linear: "linear",
  ease: "ease",
  easeIn: "ease-in",
  easeOut: "ease-out",
  easeInOut: "ease-in-out",
  circIn: /* @__PURE__ */ Rs([0, 0.65, 0.55, 1]),
  circOut: /* @__PURE__ */ Rs([0.55, 0, 1, 0.45]),
  backIn: /* @__PURE__ */ Rs([0.31, 0.01, 0.66, -0.59]),
  backOut: /* @__PURE__ */ Rs([0.33, 1.53, 0.69, 0.99])
};
function Zk(t, e) {
  if (t)
    return typeof t == "function" ? Jk() ? Uk(t, e) : "ease-out" : /* @__PURE__ */ Ik(t) ? Rs(t) : Array.isArray(t) ? t.map((n) => Zk(n, e) || yv.easeOut) : yv[t];
}
function mL(t, e, n, { delay: i = 0, duration: r = 300, repeat: s = 0, repeatType: o = "loop", ease: a = "easeOut", times: l } = {}, c = void 0) {
  const u = {
    [e]: n
  };
  l && (u.offset = l);
  const d = Zk(a, r);
  Array.isArray(d) && (u.easing = d);
  const h = {
    delay: i,
    duration: r,
    easing: Array.isArray(d) ? "linear" : d,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal"
  };
  return c && (h.pseudoElement = c), t.animate(u, h);
}
function Qk(t) {
  return typeof t == "function" && "applyToOptions" in t;
}
function gL({ type: t, ...e }) {
  return Qk(t) && Jk() ? t.applyToOptions(e) : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e);
}
class ex extends Af {
  constructor(e) {
    if (super(), this.finishedTime = null, this.isStopped = !1, this.manualStartTime = null, !e)
      return;
    const { element: n, name: i, keyframes: r, pseudoElement: s, allowFlatten: o = !1, finalKeyframe: a, onComplete: l } = e;
    this.isPseudoElement = !!s, this.allowFlatten = o, this.options = e, Si(typeof e.type != "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
    const c = gL(e);
    this.animation = mL(n, i, r, c, s), c.autoplay === !1 && this.animation.pause(), this.animation.onfinish = () => {
      if (this.finishedTime = this.time, !s) {
        const u = tc(r, this.options, a, this.speed);
        this.updateMotionValue && this.updateMotionValue(u), Yk(n, i, u), this.animation.cancel();
      }
      l?.(), this.notifyFinished();
    };
  }
  play() {
    this.isStopped || (this.manualStartTime = null, this.animation.play(), this.state === "finished" && this.updateFinished());
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.finish?.();
  }
  cancel() {
    try {
      this.animation.cancel();
    } catch {
    }
  }
  stop() {
    if (this.isStopped)
      return;
    this.isStopped = !0;
    const { state: e } = this;
    e === "idle" || e === "finished" || (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(), this.isPseudoElement || this.cancel());
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * In this method, we commit styles back to the DOM before cancelling
   * the animation.
   *
   * This is designed to be overridden by NativeAnimationExtended, which
   * will create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to also correctly calculate velocity for any subsequent animation
   * while deferring the commit until the next animation frame.
   */
  commitStyles() {
    const e = this.options?.element;
    !this.isPseudoElement && e?.isConnected && this.animation.commitStyles?.();
  }
  get duration() {
    const e = this.animation.effect?.getComputedTiming?.().duration || 0;
    return /* @__PURE__ */ qt(Number(e));
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {};
    return this.duration + /* @__PURE__ */ qt(e);
  }
  get time() {
    return /* @__PURE__ */ qt(Number(this.animation.currentTime) || 0);
  }
  set time(e) {
    const n = this.finishedTime !== null;
    this.manualStartTime = null, this.finishedTime = null, this.animation.currentTime = /* @__PURE__ */ Ft(e), n && this.animation.pause();
  }
  /**
   * The playback speed of the animation.
   * 1 = normal speed, 2 = double speed, 0.5 = half speed.
   */
  get speed() {
    return this.animation.playbackRate;
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), this.animation.playbackRate = e;
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState;
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime);
  }
  set startTime(e) {
    this.manualStartTime = this.animation.startTime = e;
  }
  /**
   * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
   */
  attachTimeline({ timeline: e, rangeStart: n, rangeEnd: i, observe: r }) {
    return this.allowFlatten && this.animation.effect?.updateTiming({ easing: "linear" }), this.animation.onfinish = null, e && pL() ? (this.animation.timeline = e, n && (this.animation.rangeStart = n), i && (this.animation.rangeEnd = i), Yt) : r(this);
  }
}
const tx = {
  anticipate: $k,
  backInOut: Ak,
  circInOut: Mk
};
function vL(t) {
  return t in tx;
}
function yL(t) {
  typeof t.ease == "string" && vL(t.ease) && (t.ease = tx[t.ease]);
}
const uu = 10;
class bL extends ex {
  constructor(e) {
    yL(e), qk(e), super(e), e.startTime !== void 0 && e.autoplay !== !1 && (this.startTime = e.startTime), this.options = e;
  }
  /**
   * WAAPI doesn't natively have any interruption capabilities.
   *
   * Rather than read committed styles back out of the DOM, we can
   * create a renderless JS animation and sample it twice to calculate
   * its current value, "previous" value, and therefore allow
   * Motion to calculate velocity for any subsequent animation.
   */
  updateMotionValue(e) {
    const { motionValue: n, onUpdate: i, onComplete: r, element: s, ...o } = this.options;
    if (!n)
      return;
    if (e !== void 0) {
      n.set(e);
      return;
    }
    const a = new kl({
      ...o,
      autoplay: !1
    }), l = Math.max(uu, Ct.now() - this.startTime), c = xi(0, uu, l - uu), u = a.sample(l).value, { name: d } = this.options;
    s && d && Yk(s, d, u), n.setWithVelocity(a.sample(Math.max(0, l - c)).value, u, c), a.stop();
  }
}
const bv = (t, e) => e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
(ai.test(t) || t === "0") && // And it contains numbers and/or colors
!t.startsWith("url("));
function _L(t) {
  const e = t[0];
  if (t.length === 1)
    return !0;
  for (let n = 0; n < t.length; n++)
    if (t[n] !== e)
      return !0;
}
function wL(t, e, n, i) {
  const r = t[0];
  if (r === null)
    return !1;
  if (e === "display" || e === "visibility")
    return !0;
  const s = t[t.length - 1], o = bv(r, e), a = bv(s, e);
  return ls(o === a, `You are trying to animate ${e} from "${r}" to "${s}". "${o ? s : r}" is not an animatable value.`, "value-not-animatable"), !o || !a ? !1 : _L(t) || (n === "spring" || Qk(n)) && i;
}
function Gd(t) {
  t.duration = 0, t.type = "keyframes";
}
const ix = /* @__PURE__ */ new Set([
  "opacity",
  "clipPath",
  "filter",
  "transform",
  "backgroundColor"
]), kL = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function xL(t) {
  for (let e = 0; e < t.length; e++)
    if (typeof t[e] == "string" && kL.test(t[e]))
      return !0;
  return !1;
}
const SL = /* @__PURE__ */ new Set([
  "color",
  "backgroundColor",
  "outlineColor",
  "fill",
  "stroke",
  "borderColor",
  "borderTopColor",
  "borderRightColor",
  "borderBottomColor",
  "borderLeftColor"
]), PL = /* @__PURE__ */ xk(() => Object.hasOwnProperty.call(Element.prototype, "animate"));
function EL(t) {
  const { motionValue: e, name: n, repeatDelay: i, repeatType: r, damping: s, type: o, keyframes: a } = t, l = e?.owner?.current;
  if (!(l instanceof HTMLElement) && !(l instanceof SVGElement))
    return !1;
  const { onUpdate: c, transformTemplate: u } = e.owner.getProps();
  return PL() && n && /**
   * Force WAAPI for color properties with browser-only color formats
   * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
   */
  (ix.has(n) || SL.has(n) && xL(a)) && (n !== "transform" || !u) && /**
   * If we're outputting values to onUpdate then we can't use WAAPI as there's
   * no way to read the value from WAAPI every frame.
   */
  !c && !i && r !== "mirror" && s !== 0 && o !== "inertia";
}
const TL = 40;
class CL extends Af {
  constructor({ autoplay: e = !0, delay: n = 0, type: i = "keyframes", repeat: r = 0, repeatDelay: s = 0, repeatType: o = "loop", keyframes: a, name: l, motionValue: c, element: u, ...d }) {
    super(), this.stop = () => {
      this._animation && (this._animation.stop(), this.stopTimeline?.()), this.keyframeResolver?.cancel();
    }, this.createdAt = Ct.now();
    const h = {
      autoplay: e,
      delay: n,
      type: i,
      repeat: r,
      repeatDelay: s,
      repeatType: o,
      name: l,
      motionValue: c,
      element: u,
      ...d
    }, f = u?.KeyframeResolver || $f;
    this.keyframeResolver = new f(a, (p, v, g) => this.onKeyframesResolved(p, v, h, !g), l, c, u), this.keyframeResolver?.scheduleResolve();
  }
  onKeyframesResolved(e, n, i, r) {
    this.keyframeResolver = void 0;
    const { name: s, type: o, velocity: a, delay: l, isHandoff: c, onUpdate: u } = i;
    this.resolvedAt = Ct.now();
    let d = !0;
    wL(e, s, o, a) || (d = !1, (vn.instantAnimations || !l) && u?.(tc(e, i, n)), e[0] = e[e.length - 1], Gd(i), i.repeat = 0);
    const f = {
      startTime: r ? this.resolvedAt ? this.resolvedAt - this.createdAt > TL ? this.resolvedAt : this.createdAt : this.createdAt : void 0,
      finalKeyframe: n,
      ...i,
      keyframes: e
    }, p = d && !c && EL(f), v = f.motionValue?.owner?.current;
    let g;
    if (p)
      try {
        g = new bL({
          ...f,
          element: v
        });
      } catch {
        g = new kl(f);
      }
    else
      g = new kl(f);
    g.finished.then(() => {
      this.notifyFinished();
    }).catch(Yt), this.pendingTimeline && (this.stopTimeline = g.attachTimeline(this.pendingTimeline), this.pendingTimeline = void 0), this._animation = g;
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished;
  }
  then(e, n) {
    return this.finished.finally(e).then(() => {
    });
  }
  get animation() {
    return this._animation || (this.keyframeResolver?.resume(), dL()), this._animation;
  }
  get duration() {
    return this.animation.duration;
  }
  get iterationDuration() {
    return this.animation.iterationDuration;
  }
  get time() {
    return this.animation.time;
  }
  set time(e) {
    this.animation.time = e;
  }
  get speed() {
    return this.animation.speed;
  }
  get state() {
    return this.animation.state;
  }
  set speed(e) {
    this.animation.speed = e;
  }
  get startTime() {
    return this.animation.startTime;
  }
  attachTimeline(e) {
    return this._animation ? this.stopTimeline = this.animation.attachTimeline(e) : this.pendingTimeline = e, () => this.stop();
  }
  play() {
    this.animation.play();
  }
  pause() {
    this.animation.pause();
  }
  complete() {
    this.animation.complete();
  }
  cancel() {
    this._animation && this.animation.cancel(), this.keyframeResolver?.cancel();
  }
}
function nx(t, e, n, i = 0, r = 1) {
  const s = Array.from(t).sort((c, u) => c.sortNodePosition(u)).indexOf(e), o = t.size, a = (o - 1) * i;
  return typeof n == "function" ? n(s, o) : r === 1 ? s * i : a - s * i;
}
const _v = 30, AL = (t) => !isNaN(parseFloat(t));
class $L {
  /**
   * @param init - The initiating value
   * @param config - Optional configuration options
   *
   * -  `transformer`: A function to transform incoming values with.
   */
  constructor(e, n = {}) {
    this.canTrackVelocity = null, this.events = {}, this.updateAndNotify = (i) => {
      const r = Ct.now();
      if (this.updatedAt !== r && this.setPrevFrameValue(), this.prev = this.current, this.setCurrent(i), this.current !== this.prev && (this.events.change?.notify(this.current), this.dependents))
        for (const s of this.dependents)
          s.dirty();
    }, this.hasAnimated = !1, this.setCurrent(e), this.owner = n.owner;
  }
  setCurrent(e) {
    this.current = e, this.updatedAt = Ct.now(), this.canTrackVelocity === null && e !== void 0 && (this.canTrackVelocity = AL(this.current));
  }
  setPrevFrameValue(e = this.current) {
    this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt;
  }
  /**
   * Adds a function that will be notified when the `MotionValue` is updated.
   *
   * It returns a function that, when called, will cancel the subscription.
   *
   * When calling `onChange` inside a React component, it should be wrapped with the
   * `useEffect` hook. As it returns an unsubscribe function, this should be returned
   * from the `useEffect` function to ensure you don't add duplicate subscribers..
   *
   * ```jsx
   * export const MyComponent = () => {
   *   const x = useMotionValue(0)
   *   const y = useMotionValue(0)
   *   const opacity = useMotionValue(1)
   *
   *   useEffect(() => {
   *     function updateOpacity() {
   *       const maxXY = Math.max(x.get(), y.get())
   *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
   *       opacity.set(newOpacity)
   *     }
   *
   *     const unsubscribeX = x.on("change", updateOpacity)
   *     const unsubscribeY = y.on("change", updateOpacity)
   *
   *     return () => {
   *       unsubscribeX()
   *       unsubscribeY()
   *     }
   *   }, [])
   *
   *   return <motion.div style={{ x }} />
   * }
   * ```
   *
   * @param subscriber - A function that receives the latest value.
   * @returns A function that, when called, will cancel this subscription.
   *
   * @deprecated
   */
  onChange(e) {
    return process.env.NODE_ENV !== "production" && wf(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'), this.on("change", e);
  }
  on(e, n) {
    this.events[e] || (this.events[e] = new _f());
    const i = this.events[e].add(n);
    return e === "change" ? () => {
      i(), We.read(() => {
        this.events.change.getSize() || this.stop();
      });
    } : i;
  }
  clearListeners() {
    for (const e in this.events)
      this.events[e].clear();
  }
  /**
   * Attaches a passive effect to the `MotionValue`.
   */
  attach(e, n) {
    this.passiveEffect = e, this.stopPassiveEffect = n;
  }
  /**
   * Sets the state of the `MotionValue`.
   *
   * @remarks
   *
   * ```jsx
   * const x = useMotionValue(0)
   * x.set(10)
   * ```
   *
   * @param latest - Latest value to set.
   * @param render - Whether to notify render subscribers. Defaults to `true`
   *
   * @public
   */
  set(e) {
    this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e);
  }
  setWithVelocity(e, n, i) {
    this.set(n), this.prev = void 0, this.prevFrameValue = e, this.prevUpdatedAt = this.updatedAt - i;
  }
  /**
   * Set the state of the `MotionValue`, stopping any active animations,
   * effects, and resets velocity to `0`.
   */
  jump(e, n = !0) {
    this.updateAndNotify(e), this.prev = e, this.prevUpdatedAt = this.prevFrameValue = void 0, n && this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
  dirty() {
    this.events.change?.notify(this.current);
  }
  addDependent(e) {
    this.dependents || (this.dependents = /* @__PURE__ */ new Set()), this.dependents.add(e);
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e);
  }
  /**
   * Returns the latest state of `MotionValue`
   *
   * @returns - The latest state of `MotionValue`
   *
   * @public
   */
  get() {
    return this.current;
  }
  /**
   * @public
   */
  getPrevious() {
    return this.prev;
  }
  /**
   * Returns the latest velocity of `MotionValue`
   *
   * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
   *
   * @public
   */
  getVelocity() {
    const e = Ct.now();
    if (!this.canTrackVelocity || this.prevFrameValue === void 0 || e - this.updatedAt > _v)
      return 0;
    const n = Math.min(this.updatedAt - this.prevUpdatedAt, _v);
    return /* @__PURE__ */ Sk(parseFloat(this.current) - parseFloat(this.prevFrameValue), n);
  }
  /**
   * Registers a new animation to control this `MotionValue`. Only one
   * animation can drive a `MotionValue` at one time.
   *
   * ```jsx
   * value.start()
   * ```
   *
   * @param animation - A function that starts the provided animation
   */
  start(e) {
    return this.stop(), new Promise((n) => {
      this.hasAnimated = !0, this.animation = e(n), this.events.animationStart && this.events.animationStart.notify();
    }).then(() => {
      this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
    });
  }
  /**
   * Stop the currently active animation.
   *
   * @public
   */
  stop() {
    this.animation && (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()), this.clearAnimation();
  }
  /**
   * Returns `true` if this value is currently animating.
   *
   * @public
   */
  isAnimating() {
    return !!this.animation;
  }
  clearAnimation() {
    delete this.animation;
  }
  /**
   * Destroy and clean up subscribers to this `MotionValue`.
   *
   * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
   * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
   * created a `MotionValue` via the `motionValue` function.
   *
   * @public
   */
  destroy() {
    this.dependents?.clear(), this.events.destroy?.notify(), this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
  }
}
function ts(t, e) {
  return new $L(t, e);
}
function rx(t, e) {
  if (t?.inherit && e) {
    const { inherit: n, ...i } = t;
    return { ...e, ...i };
  }
  return t;
}
function Rf(t, e) {
  const n = t?.[e] ?? t?.default ?? t;
  return n !== t ? rx(n, t) : n;
}
const RL = {
  type: "spring",
  stiffness: 500,
  damping: 25,
  restSpeed: 10
}, ML = (t) => ({
  type: "spring",
  stiffness: 550,
  damping: t === 0 ? 2 * Math.sqrt(550) : 30,
  restSpeed: 10
}), OL = {
  type: "keyframes",
  duration: 0.8
}, IL = {
  type: "keyframes",
  ease: [0.25, 0.1, 0.35, 1],
  duration: 0.3
}, DL = (t, { keyframes: e }) => e.length > 2 ? OL : ds.has(t) ? t.startsWith("scale") ? ML(e[1]) : RL : IL, FL = /* @__PURE__ */ new Set([
  "when",
  "delay",
  "delayChildren",
  "staggerChildren",
  "staggerDirection",
  "repeat",
  "repeatType",
  "repeatDelay",
  "from",
  "elapsed"
]);
function LL(t) {
  for (const e in t)
    if (!FL.has(e))
      return !0;
  return !1;
}
const Mf = (t, e, n, i = {}, r, s) => (o) => {
  const a = Rf(i, t) || {}, l = a.delay || i.delay || 0;
  let { elapsed: c = 0 } = i;
  c = c - /* @__PURE__ */ Ft(l);
  const u = {
    keyframes: Array.isArray(n) ? n : [null, n],
    ease: "easeOut",
    velocity: e.getVelocity(),
    ...a,
    delay: -c,
    onUpdate: (h) => {
      e.set(h), a.onUpdate && a.onUpdate(h);
    },
    onComplete: () => {
      o(), a.onComplete && a.onComplete();
    },
    name: t,
    motionValue: e,
    element: s ? void 0 : r
  };
  LL(a) || Object.assign(u, DL(t, u)), u.duration && (u.duration = /* @__PURE__ */ Ft(u.duration)), u.repeatDelay && (u.repeatDelay = /* @__PURE__ */ Ft(u.repeatDelay)), u.from !== void 0 && (u.keyframes[0] = u.from);
  let d = !1;
  if ((u.type === !1 || u.duration === 0 && !u.repeatDelay) && (Gd(u), u.delay === 0 && (d = !0)), (vn.instantAnimations || vn.skipAnimations || r?.shouldSkipAnimations || a.skipAnimations) && (d = !0, Gd(u), u.delay = 0), u.allowFlatten = !a.type && !a.ease, d && !s && e.get() !== void 0) {
    const h = tc(u.keyframes, a);
    if (h !== void 0) {
      We.update(() => {
        u.onUpdate(h), u.onComplete();
      });
      return;
    }
  }
  return a.isSync ? new kl(u) : new CL(u);
}, NL = (
  // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
  /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
);
function VL(t) {
  const e = NL.exec(t);
  if (!e)
    return [,];
  const [, n, i, r] = e;
  return [`--${n ?? i}`, r];
}
const jL = 4;
function sx(t, e, n = 1) {
  Si(n <= jL, `Max CSS variable fallback depth detected in property "${t}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
  const [i, r] = VL(t);
  if (!i)
    return;
  const s = window.getComputedStyle(e).getPropertyValue(i);
  if (s) {
    const o = s.trim();
    return _k(o) ? parseFloat(o) : o;
  }
  return Sf(r) ? sx(r, e, n + 1) : r;
}
function wv(t) {
  const e = [{}, {}];
  return t?.values.forEach((n, i) => {
    e[0][i] = n.get(), e[1][i] = n.getVelocity();
  }), e;
}
function Of(t, e, n, i) {
  if (typeof e == "function") {
    const [r, s] = wv(i);
    e = e(n !== void 0 ? n : t.custom, r, s);
  }
  if (typeof e == "string" && (e = t.variants && t.variants[e]), typeof e == "function") {
    const [r, s] = wv(i);
    e = e(n !== void 0 ? n : t.custom, r, s);
  }
  return e;
}
function Jn(t, e, n) {
  const i = t.getProps();
  return Of(i, e, n !== void 0 ? n : i.custom, t);
}
const ox = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  ...us
]), Kd = (t) => Array.isArray(t);
function zL(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, ts(n));
}
function BL(t) {
  return Kd(t) ? t[t.length - 1] || 0 : t;
}
function HL(t, e) {
  const n = Jn(t, e);
  let { transitionEnd: i = {}, transition: r = {}, ...s } = n || {};
  s = { ...s, ...i };
  for (const o in s) {
    const a = BL(s[o]);
    zL(t, o, a);
  }
}
const yt = (t) => !!(t && t.getVelocity);
function UL(t) {
  return !!(yt(t) && t.add);
}
function Yd(t, e) {
  const n = t.getValue("willChange");
  if (UL(n))
    return n.add(e);
  if (!n && vn.WillChange) {
    const i = new vn.WillChange("auto");
    t.addValue("willChange", i), i.add(e);
  }
}
function If(t) {
  return t.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`);
}
const WL = "framerAppearId", ax = "data-" + If(WL);
function lx(t) {
  return t.props[ax];
}
function qL({ protectedKeys: t, needsAnimating: e }, n) {
  const i = t.hasOwnProperty(n) && e[n] !== !0;
  return e[n] = !1, i;
}
function cx(t, e, { delay: n = 0, transitionOverride: i, type: r } = {}) {
  let { transition: s, transitionEnd: o, ...a } = e;
  const l = t.getDefaultTransition();
  s = s ? rx(s, l) : l;
  const c = s?.reduceMotion, u = s?.skipAnimations;
  i && (s = i);
  const d = [], h = r && t.animationState && t.animationState.getState()[r], f = s?.path;
  f && f.animateVisualElement(t, a, s, n, d);
  for (const p in a) {
    const v = t.getValue(p, t.latestValues[p] ?? null), g = a[p];
    if (g === void 0 || h && qL(h, p))
      continue;
    const m = {
      delay: n,
      ...Rf(s || {}, p)
    };
    u && (m.skipAnimations = !0);
    const y = v.get();
    if (y !== void 0 && !v.isAnimating() && !Array.isArray(g) && g === y && !m.velocity) {
      We.update(() => v.set(g));
      continue;
    }
    let k = !1;
    if (window.MotionHandoffAnimation) {
      const T = lx(t);
      if (T) {
        const E = window.MotionHandoffAnimation(T, p, We);
        E !== null && (m.startTime = E, k = !0);
      }
    }
    Yd(t, p);
    const _ = c ?? t.shouldReduceMotion;
    v.start(Mf(p, v, g, _ && ox.has(p) ? { type: !1 } : m, t, k));
    const w = v.animation;
    w && d.push(w);
  }
  if (o) {
    const p = () => We.update(() => {
      o && HL(t, o);
    });
    d.length ? Promise.all(d).then(p) : p();
  }
  return d;
}
function Xd(t, e, n = {}) {
  const i = Jn(t, e, n.type === "exit" ? t.presenceContext?.custom : void 0);
  let { transition: r = t.getDefaultTransition() || {} } = i || {};
  n.transitionOverride && (r = n.transitionOverride);
  const s = i ? () => Promise.all(cx(t, i, n)) : () => Promise.resolve(), o = t.variantChildren && t.variantChildren.size ? (l = 0) => {
    const { delayChildren: c = 0, staggerChildren: u, staggerDirection: d } = r;
    return GL(t, e, l, c, u, d, n);
  } : () => Promise.resolve(), { when: a } = r;
  if (a) {
    const [l, c] = a === "beforeChildren" ? [s, o] : [o, s];
    return l().then(() => c());
  } else
    return Promise.all([s(), o(n.delay)]);
}
function GL(t, e, n = 0, i = 0, r = 0, s = 1, o) {
  const a = [];
  for (const l of t.variantChildren)
    l.notify("AnimationStart", e), a.push(Xd(l, e, {
      ...o,
      delay: n + (typeof i == "function" ? 0 : i) + nx(t.variantChildren, l, i, r, s)
    }).then(() => l.notify("AnimationComplete", e)));
  return Promise.all(a);
}
function KL(t, e, n = {}) {
  t.notify("AnimationStart", e);
  let i;
  if (Array.isArray(e)) {
    const r = e.map((s) => Xd(t, s, n));
    i = Promise.all(r);
  } else if (typeof e == "string")
    i = Xd(t, e, n);
  else {
    const r = typeof e == "function" ? Jn(t, e, n.custom) : e;
    i = Promise.all(cx(t, r, n));
  }
  return i.then(() => {
    t.notify("AnimationComplete", e);
  });
}
const YL = {
  test: (t) => t === "auto",
  parse: (t) => t
}, ux = (t) => (e) => e.test(t), dx = [cs, ce, _i, Ii, _F, bF, YL], kv = (t) => dx.find(ux(t));
function XL(t) {
  return typeof t == "number" ? t === 0 : t !== null ? t === "none" || t === "0" || kk(t) : !0;
}
const JL = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function ZL(t) {
  const [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [i] = n.match(Pf) || [];
  if (!i)
    return t;
  const r = n.replace(i, "");
  let s = JL.has(e) ? 1 : 0;
  return i !== n && (s *= 100), e + "(" + s + r + ")";
}
const QL = /\b([a-z-]*)\(.*?\)/gu, Jd = {
  ...ai,
  getAnimatableNone: (t) => {
    const e = t.match(QL);
    return e ? e.map(ZL).join(" ") : t;
  }
}, Zd = {
  ...ai,
  getAnimatableNone: (t) => {
    const e = ai.parse(t);
    return ai.createTransformer(t)(e.map((i) => typeof i == "number" ? 0 : typeof i == "object" ? { ...i, alpha: 1 } : i));
  }
}, xv = {
  ...cs,
  transform: Math.round
}, eN = {
  rotate: Ii,
  /**
   * Internal channel for `transition.path` orientToPath. Composed onto
   * `rotate` at the transform-build sites so the user's `rotate` is
   * never read or overwritten. Not part of `transformPropOrder`.
   */
  pathRotation: Ii,
  rotateX: Ii,
  rotateY: Ii,
  rotateZ: Ii,
  scale: da,
  scaleX: da,
  scaleY: da,
  scaleZ: da,
  skew: Ii,
  skewX: Ii,
  skewY: Ii,
  distance: ce,
  translateX: ce,
  translateY: ce,
  translateZ: ce,
  x: ce,
  y: ce,
  z: ce,
  perspective: ce,
  transformPerspective: ce,
  opacity: co,
  originX: cv,
  originY: cv,
  originZ: ce
}, xl = {
  // Border props
  borderWidth: ce,
  borderTopWidth: ce,
  borderRightWidth: ce,
  borderBottomWidth: ce,
  borderLeftWidth: ce,
  borderRadius: ce,
  borderTopLeftRadius: ce,
  borderTopRightRadius: ce,
  borderBottomRightRadius: ce,
  borderBottomLeftRadius: ce,
  // Positioning props
  width: ce,
  maxWidth: ce,
  height: ce,
  maxHeight: ce,
  top: ce,
  right: ce,
  bottom: ce,
  left: ce,
  inset: ce,
  insetBlock: ce,
  insetBlockStart: ce,
  insetBlockEnd: ce,
  insetInline: ce,
  insetInlineStart: ce,
  insetInlineEnd: ce,
  // Spacing props
  padding: ce,
  paddingTop: ce,
  paddingRight: ce,
  paddingBottom: ce,
  paddingLeft: ce,
  paddingBlock: ce,
  paddingBlockStart: ce,
  paddingBlockEnd: ce,
  paddingInline: ce,
  paddingInlineStart: ce,
  paddingInlineEnd: ce,
  margin: ce,
  marginTop: ce,
  marginRight: ce,
  marginBottom: ce,
  marginLeft: ce,
  marginBlock: ce,
  marginBlockStart: ce,
  marginBlockEnd: ce,
  marginInline: ce,
  marginInlineStart: ce,
  marginInlineEnd: ce,
  // Typography
  fontSize: ce,
  // Misc
  backgroundPositionX: ce,
  backgroundPositionY: ce,
  ...eN,
  zIndex: xv,
  // SVG
  fillOpacity: co,
  strokeOpacity: co,
  numOctaves: xv
}, tN = {
  ...xl,
  // Color props
  color: st,
  backgroundColor: st,
  outlineColor: st,
  fill: st,
  stroke: st,
  // Border props
  borderColor: st,
  borderTopColor: st,
  borderRightColor: st,
  borderBottomColor: st,
  borderLeftColor: st,
  filter: Jd,
  WebkitFilter: Jd,
  mask: Zd,
  WebkitMask: Zd
}, hx = (t) => tN[t], iN = /* @__PURE__ */ new Set([Jd, Zd]);
function fx(t, e) {
  let n = hx(t);
  return iN.has(n) || (n = ai), n.getAnimatableNone ? n.getAnimatableNone(e) : void 0;
}
const nN = /* @__PURE__ */ new Set(["auto", "none", "0"]);
function rN(t, e, n) {
  let i = 0, r;
  for (; i < t.length && !r; ) {
    const s = t[i];
    typeof s == "string" && !nN.has(s) && es(s).values.length && (r = t[i]), i++;
  }
  if (r && n)
    for (const s of e)
      t[s] = fx(n, r);
}
class sN extends $f {
  constructor(e, n, i, r, s) {
    super(e, n, i, r, s, !0);
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: n, name: i } = this;
    if (!n || !n.current)
      return;
    super.readKeyframes();
    for (let u = 0; u < e.length; u++) {
      let d = e[u];
      if (typeof d == "string" && (d = d.trim(), Sf(d))) {
        const h = sx(d, n.current);
        h !== void 0 && (e[u] = h), u === e.length - 1 && (this.finalKeyframe = d);
      }
    }
    if (this.resolveNoneKeyframes(), !ox.has(i) || e.length !== 2)
      return;
    const [r, s] = e, o = kv(r), a = kv(s), l = lv(r), c = lv(s);
    if (l !== c && ln[i]) {
      this.needsMeasurement = !0;
      return;
    }
    if (o !== a)
      if (vv(o) && vv(a))
        for (let u = 0; u < e.length; u++) {
          const d = e[u];
          typeof d == "string" && (e[u] = parseFloat(d));
        }
      else ln[i] && (this.needsMeasurement = !0);
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: n } = this, i = [];
    for (let r = 0; r < e.length; r++)
      (e[r] === null || XL(e[r])) && i.push(r);
    i.length && rN(e, i, n);
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: n, name: i } = this;
    if (!e || !e.current)
      return;
    i === "height" && (this.suspendedScrollY = window.pageYOffset), this.measuredOrigin = ln[i](e.measureViewportBox(), window.getComputedStyle(e.current)), n[0] = this.measuredOrigin;
    const r = n[n.length - 1];
    r !== void 0 && e.getValue(i, r).jump(r, !1);
  }
  measureEndState() {
    const { element: e, name: n, unresolvedKeyframes: i } = this;
    if (!e || !e.current)
      return;
    const r = e.getValue(n);
    r && r.jump(this.measuredOrigin, !1);
    const s = i.length - 1, o = i[s];
    i[s] = ln[n](e.measureViewportBox(), window.getComputedStyle(e.current)), o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o), this.removedTransforms?.length && this.removedTransforms.forEach(([a, l]) => {
      e.getValue(a).set(l);
    }), this.resolveNoneKeyframes();
  }
}
const Df = [
  "borderTopLeftRadius",
  "borderTopRightRadius",
  "borderBottomRightRadius",
  "borderBottomLeftRadius"
];
function px(t, e, n) {
  if (t == null)
    return [];
  if (t instanceof EventTarget)
    return [t];
  if (typeof t == "string") {
    let i = document;
    const r = n?.[t] ?? i.querySelectorAll(t);
    return r ? Array.from(r) : [];
  }
  return Array.from(t).filter((i) => i != null);
}
const Qd = (t, e) => e && typeof t == "number" ? e.transform(t) : t;
function oN(t) {
  return wk(t) && "offsetHeight" in t && !("ownerSVGElement" in t);
}
const { schedule: Ff } = /* @__PURE__ */ Dk(queueMicrotask, !1), ii = {
  x: !1,
  y: !1
};
function mx() {
  return ii.x || ii.y;
}
function aN(t) {
  return t === "x" || t === "y" ? ii[t] ? null : (ii[t] = !0, () => {
    ii[t] = !1;
  }) : ii.x || ii.y ? null : (ii.x = ii.y = !0, () => {
    ii.x = ii.y = !1;
  });
}
function gx(t, e) {
  const n = px(t), i = new AbortController(), r = {
    passive: !0,
    ...e,
    signal: i.signal
  };
  return [n, r, () => i.abort()];
}
function lN(t) {
  return !(t.pointerType === "touch" || mx());
}
function cN(t, e, n = {}) {
  const [i, r, s] = gx(t, n);
  return i.forEach((o) => {
    let a = !1, l = !1, c;
    const u = () => {
      o.removeEventListener("pointerleave", p);
    }, d = (g) => {
      c && (c(g), c = void 0), u();
    }, h = (g) => {
      a = !1, window.removeEventListener("pointerup", h), window.removeEventListener("pointercancel", h), l && (l = !1, d(g));
    }, f = () => {
      a = !0, window.addEventListener("pointerup", h, r), window.addEventListener("pointercancel", h, r);
    }, p = (g) => {
      if (g.pointerType !== "touch") {
        if (a) {
          l = !0;
          return;
        }
        d(g);
      }
    }, v = (g) => {
      if (!lN(g))
        return;
      l = !1;
      const m = e(o, g);
      typeof m == "function" && (c = m, o.addEventListener("pointerleave", p, r));
    };
    o.addEventListener("pointerenter", v, r), o.addEventListener("pointerdown", f, r);
  }), s;
}
const vx = (t, e) => e ? t === e ? !0 : vx(t, e.parentElement) : !1, Lf = (t) => t.pointerType === "mouse" ? typeof t.button != "number" || t.button <= 0 : t.isPrimary !== !1, uN = /* @__PURE__ */ new Set([
  "BUTTON",
  "INPUT",
  "SELECT",
  "TEXTAREA",
  "A"
]);
function dN(t) {
  return uN.has(t.tagName) || t.isContentEditable === !0;
}
const hN = /* @__PURE__ */ new Set(["INPUT", "SELECT", "TEXTAREA"]);
function fN(t) {
  return hN.has(t.tagName) || t.isContentEditable === !0;
}
const Ia = /* @__PURE__ */ new WeakSet();
function Sv(t) {
  return (e) => {
    e.key === "Enter" && t(e);
  };
}
function du(t, e) {
  t.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }));
}
const pN = (t, e) => {
  const n = t.currentTarget;
  if (!n)
    return;
  const i = Sv(() => {
    if (Ia.has(n))
      return;
    du(n, "down");
    const r = Sv(() => {
      du(n, "up");
    }), s = () => du(n, "cancel");
    n.addEventListener("keyup", r, e), n.addEventListener("blur", s, e);
  });
  n.addEventListener("keydown", i, e), n.addEventListener("blur", () => n.removeEventListener("keydown", i), e);
};
function Pv(t) {
  return Lf(t) && !mx();
}
const Ev = /* @__PURE__ */ new WeakSet();
function mN(t, e, n = {}) {
  const [i, r, s] = gx(t, n), o = (a) => {
    const l = a.currentTarget;
    if (!Pv(a) || Ev.has(a))
      return;
    Ia.add(l), n.stopPropagation && Ev.add(a);
    const c = e(l, a), u = { ...r, capture: !0 }, d = (p, v) => {
      window.removeEventListener("pointerup", h, u), window.removeEventListener("pointercancel", f, u), Ia.has(l) && Ia.delete(l), Pv(p) && typeof c == "function" && c(p, { success: v });
    }, h = (p) => {
      d(p, l === window || l === document || n.useGlobalTarget || vx(l, p.target));
    }, f = (p) => {
      d(p, !1);
    };
    window.addEventListener("pointerup", h, u), window.addEventListener("pointercancel", f, u);
  };
  return i.forEach((a) => {
    (n.useGlobalTarget ? window : a).addEventListener("pointerdown", o, r), oN(a) && (a.addEventListener("focus", (c) => pN(c, r)), !dN(a) && !a.hasAttribute("tabindex") && (a.tabIndex = 0));
  }), s;
}
function Nf(t) {
  return wk(t) && "ownerSVGElement" in t;
}
const Da = /* @__PURE__ */ new WeakMap();
let Fa;
const yx = (t, e, n) => (i, r) => r && r[0] ? r[0][t + "Size"] : Nf(i) && "getBBox" in i ? i.getBBox()[e] : i[n], gN = /* @__PURE__ */ yx("inline", "width", "offsetWidth"), vN = /* @__PURE__ */ yx("block", "height", "offsetHeight");
function yN({ target: t, borderBoxSize: e }) {
  Da.get(t)?.forEach((n) => {
    n(t, {
      get width() {
        return gN(t, e);
      },
      get height() {
        return vN(t, e);
      }
    });
  });
}
function bN(t) {
  t.forEach(yN);
}
function _N() {
  typeof ResizeObserver > "u" || (Fa = new ResizeObserver(bN));
}
function wN(t, e) {
  Fa || _N();
  const n = px(t);
  return n.forEach((i) => {
    let r = Da.get(i);
    r || (r = /* @__PURE__ */ new Set(), Da.set(i, r)), r.add(e), Fa?.observe(i);
  }), () => {
    n.forEach((i) => {
      const r = Da.get(i);
      r?.delete(e), r?.size || Fa?.unobserve(i);
    });
  };
}
const La = /* @__PURE__ */ new Set();
let Mr;
function kN() {
  Mr = () => {
    const t = {
      get width() {
        return window.innerWidth;
      },
      get height() {
        return window.innerHeight;
      }
    };
    La.forEach((e) => e(t));
  }, window.addEventListener("resize", Mr);
}
function xN(t) {
  return La.add(t), Mr || kN(), () => {
    La.delete(t), !La.size && typeof Mr == "function" && (window.removeEventListener("resize", Mr), Mr = void 0);
  };
}
function Tv(t, e) {
  return typeof t == "function" ? xN(t) : wN(t, e);
}
function SN(t) {
  return Nf(t) && t.tagName === "svg";
}
const PN = [...dx, st, ai], EN = (t) => PN.find(ux(t)), Cv = () => ({
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
}), Or = () => ({
  x: Cv(),
  y: Cv()
}), Av = () => ({ min: 0, max: 0 }), ct = () => ({
  x: Av(),
  y: Av()
}), TN = /* @__PURE__ */ new WeakMap();
function ic(t) {
  return t !== null && typeof t == "object" && typeof t.start == "function";
}
function uo(t) {
  return typeof t == "string" || Array.isArray(t);
}
const Vf = [
  "animate",
  "whileInView",
  "whileFocus",
  "whileHover",
  "whileTap",
  "whileDrag",
  "exit"
], jf = ["initial", ...Vf];
function nc(t) {
  return ic(t.animate) || jf.some((e) => uo(t[e]));
}
function bx(t) {
  return !!(nc(t) || t.variants);
}
function CN(t, e, n) {
  for (const i in e) {
    const r = e[i], s = n[i];
    if (yt(r))
      t.addValue(i, r);
    else if (yt(s))
      t.addValue(i, ts(r, { owner: t }));
    else if (s !== r)
      if (t.hasValue(i)) {
        const o = t.getValue(i);
        o.liveStyle === !0 ? o.jump(r) : o.hasAnimated || o.set(r);
      } else {
        const o = t.getStaticValue(i);
        t.addValue(i, ts(o !== void 0 ? o : r, { owner: t }));
      }
  }
  for (const i in n)
    e[i] === void 0 && t.removeValue(i);
  return e;
}
const eh = { current: null }, _x = { current: !1 }, AN = typeof window < "u";
function $N() {
  if (_x.current = !0, !!AN)
    if (window.matchMedia) {
      const t = window.matchMedia("(prefers-reduced-motion)"), e = () => eh.current = t.matches;
      t.addEventListener("change", e), e();
    } else
      eh.current = !1;
}
const $v = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete"
];
let Sl = {};
function wx(t) {
  Sl = t;
}
function RN() {
  return Sl;
}
class MN {
  /**
   * This method takes React props and returns found MotionValues. For example, HTML
   * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
   *
   * This isn't an abstract method as it needs calling in the constructor, but it is
   * intended to be one.
   */
  scrapeMotionValuesFromProps(e, n, i) {
    return {};
  }
  constructor({ parent: e, props: n, presenceContext: i, reducedMotionConfig: r, skipAnimations: s, blockInitialAnimation: o, visualState: a }, l = {}) {
    this.current = null, this.children = /* @__PURE__ */ new Set(), this.isVariantNode = !1, this.isControllingVariants = !1, this.shouldReduceMotion = null, this.shouldSkipAnimations = !1, this.values = /* @__PURE__ */ new Map(), this.KeyframeResolver = $f, this.features = {}, this.valueSubscriptions = /* @__PURE__ */ new Map(), this.prevMotionValues = {}, this.hasBeenMounted = !1, this.events = {}, this.propEventSubscriptions = {}, this.notifyUpdate = () => this.notify("Update", this.latestValues), this.render = () => {
      this.current && (this.triggerBuild(), this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
    }, this.renderScheduledAt = 0, this.scheduleRender = () => {
      const f = Ct.now();
      this.renderScheduledAt < f && (this.renderScheduledAt = f, We.render(this.render, !1, !0));
    };
    const { latestValues: c, renderState: u } = a;
    this.latestValues = c, this.baseTarget = { ...c }, this.initialValues = n.initial ? { ...c } : {}, this.renderState = u, this.parent = e, this.props = n, this.presenceContext = i, this.depth = e ? e.depth + 1 : 0, this.reducedMotionConfig = r, this.skipAnimationsConfig = s, this.options = l, this.blockInitialAnimation = !!o, this.isControllingVariants = nc(n), this.isVariantNode = bx(n), this.isVariantNode && (this.variantChildren = /* @__PURE__ */ new Set()), this.manuallyAnimateOnMount = !!(e && e.current);
    const { willChange: d, ...h } = this.scrapeMotionValuesFromProps(n, {}, this);
    for (const f in h) {
      const p = h[f];
      c[f] !== void 0 && yt(p) && p.set(c[f]);
    }
  }
  mount(e) {
    if (this.hasBeenMounted)
      for (const n in this.initialValues)
        this.values.get(n)?.jump(this.initialValues[n]), this.latestValues[n] = this.initialValues[n];
    this.current = e, TN.set(e, this), this.projection && !this.projection.instance && this.projection.mount(e), this.parent && this.isVariantNode && !this.isControllingVariants && (this.removeFromVariantTree = this.parent.addVariantChild(this)), this.values.forEach((n, i) => this.bindToMotionValue(i, n)), this.reducedMotionConfig === "never" ? this.shouldReduceMotion = !1 : this.reducedMotionConfig === "always" ? this.shouldReduceMotion = !0 : (_x.current || $N(), this.shouldReduceMotion = eh.current), process.env.NODE_ENV !== "production" && wf(this.shouldReduceMotion !== !0, "You have Reduced Motion enabled on your device. Animations may not appear as expected.", "reduced-motion-disabled"), this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1, this.parent?.addChild(this), this.update(this.props, this.presenceContext), this.hasBeenMounted = !0;
  }
  unmount() {
    this.projection && this.projection.unmount(), yn(this.notifyUpdate), yn(this.render), this.valueSubscriptions.forEach((e) => e()), this.valueSubscriptions.clear(), this.removeFromVariantTree && this.removeFromVariantTree(), this.parent?.removeChild(this);
    for (const e in this.events)
      this.events[e].clear();
    for (const e in this.features) {
      const n = this.features[e];
      n && (n.unmount(), n.isMounted = !1);
    }
    this.current = null;
  }
  addChild(e) {
    this.children.add(e), this.enteringChildren ?? (this.enteringChildren = /* @__PURE__ */ new Set()), this.enteringChildren.add(e);
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e);
  }
  bindToMotionValue(e, n) {
    if (this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)(), n.accelerate && ix.has(e) && this.current instanceof HTMLElement) {
      const { factory: o, keyframes: a, times: l, ease: c, duration: u } = n.accelerate, d = new ex({
        element: this.current,
        name: e,
        keyframes: a,
        times: l,
        ease: c,
        duration: /* @__PURE__ */ Ft(u)
      }), h = o(d);
      this.valueSubscriptions.set(e, () => {
        h(), d.cancel();
      });
      return;
    }
    const i = ds.has(e);
    i && this.onBindTransform && this.onBindTransform();
    const r = n.on("change", (o) => {
      this.latestValues[e] = o, this.props.onUpdate && We.preRender(this.notifyUpdate), i && this.projection && (this.projection.isTransformDirty = !0), this.scheduleRender();
    });
    let s;
    typeof window < "u" && window.MotionCheckAppearSync && (s = window.MotionCheckAppearSync(this, e, n)), this.valueSubscriptions.set(e, () => {
      r(), s && s();
    });
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type ? 0 : this.sortInstanceNodePosition(this.current, e.current);
  }
  updateFeatures() {
    let e = "animation";
    for (e in Sl) {
      const n = Sl[e];
      if (!n)
        continue;
      const { isEnabled: i, Feature: r } = n;
      if (!this.features[e] && r && i(this.props) && (this.features[e] = new r(this)), this.features[e]) {
        const s = this.features[e];
        s.isMounted ? s.update() : (s.mount(), s.isMounted = !0);
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props);
  }
  /**
   * Measure the current viewport box with or without transforms.
   * Only measures axis-aligned boxes, rotate and skew must be manually
   * removed with a re-render to work.
   */
  measureViewportBox() {
    return this.current ? this.measureInstanceViewportBox(this.current, this.props) : ct();
  }
  getStaticValue(e) {
    return this.latestValues[e];
  }
  setStaticValue(e, n) {
    this.latestValues[e] = n;
  }
  /**
   * Update the provided props. Ensure any newly-added motion values are
   * added to our map, old ones removed, and listeners updated.
   */
  update(e, n) {
    (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(), this.prevProps = this.props, this.props = e, this.prevPresenceContext = this.presenceContext, this.presenceContext = n;
    for (let i = 0; i < $v.length; i++) {
      const r = $v[i];
      this.propEventSubscriptions[r] && (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r]);
      const s = "on" + r, o = e[s];
      o && (this.propEventSubscriptions[r] = this.on(r, o));
    }
    this.prevMotionValues = CN(this, this.scrapeMotionValuesFromProps(e, this.prevProps || {}, this), this.prevMotionValues), this.handleChildMotionValue && this.handleChildMotionValue();
  }
  getProps() {
    return this.props;
  }
  /**
   * Returns the variant definition with a given name.
   */
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0;
  }
  /**
   * Returns the defined default transition on this component.
   */
  getDefaultTransition() {
    return this.props.transition;
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint;
  }
  getClosestVariantNode() {
    return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
  }
  /**
   * Add a child visual element to our set of children.
   */
  addVariantChild(e) {
    const n = this.getClosestVariantNode();
    if (n)
      return n.variantChildren && n.variantChildren.add(e), () => n.variantChildren.delete(e);
  }
  /**
   * Add a motion value and bind it to this visual element.
   */
  addValue(e, n) {
    const i = this.values.get(e);
    n !== i && (i && this.removeValue(e), this.bindToMotionValue(e, n), this.values.set(e, n), this.latestValues[e] = n.get());
  }
  /**
   * Remove a motion value and unbind any active subscriptions.
   */
  removeValue(e) {
    this.values.delete(e);
    const n = this.valueSubscriptions.get(e);
    n && (n(), this.valueSubscriptions.delete(e)), delete this.latestValues[e], this.removeValueFromRenderState(e, this.renderState);
  }
  /**
   * Check whether we have a motion value for this key
   */
  hasValue(e) {
    return this.values.has(e);
  }
  getValue(e, n) {
    if (this.props.values && this.props.values[e])
      return this.props.values[e];
    let i = this.values.get(e);
    return i === void 0 && n !== void 0 && (i = ts(n === null ? void 0 : n, { owner: this }), this.addValue(e, i)), i;
  }
  /**
   * If we're trying to animate to a previously unencountered value,
   * we need to check for it in our state and as a last resort read it
   * directly from the instance (which might have performance implications).
   */
  readValue(e, n) {
    let i = this.latestValues[e] !== void 0 || !this.current ? this.latestValues[e] : this.getBaseTargetFromProps(this.props, e) ?? this.readValueFromInstance(this.current, e, this.options);
    return i != null && (typeof i == "string" && (_k(i) || kk(i)) ? i = parseFloat(i) : !EN(i) && ai.test(n) && (i = fx(e, n)), this.setBaseTarget(e, yt(i) ? i.get() : i)), yt(i) ? i.get() : i;
  }
  /**
   * Set the base target to later animate back to. This is currently
   * only hydrated on creation and when we first read a value.
   */
  setBaseTarget(e, n) {
    this.baseTarget[e] = n;
  }
  /**
   * Find the base target for a value thats been removed from all animation
   * props.
   */
  getBaseTarget(e) {
    const { initial: n } = this.props;
    let i;
    if (typeof n == "string" || typeof n == "object") {
      const s = Of(this.props, n, this.presenceContext?.custom);
      s && (i = s[e]);
    }
    if (n && i !== void 0)
      return i;
    const r = this.getBaseTargetFromProps(this.props, e);
    return r !== void 0 && !yt(r) ? r : this.initialValues[e] !== void 0 && i === void 0 ? void 0 : this.baseTarget[e];
  }
  on(e, n) {
    return this.events[e] || (this.events[e] = new _f()), this.events[e].add(n);
  }
  notify(e, ...n) {
    this.events[e] && this.events[e].notify(...n);
  }
  scheduleRenderMicrotask() {
    Ff.render(this.render);
  }
}
class kx extends MN {
  constructor() {
    super(...arguments), this.KeyframeResolver = sN;
  }
  sortInstanceNodePosition(e, n) {
    return e.compareDocumentPosition(n) & 2 ? 1 : -1;
  }
  getBaseTargetFromProps(e, n) {
    const i = e.style;
    return i ? i[n] : void 0;
  }
  removeValueFromRenderState(e, { vars: n, style: i }) {
    delete n[e], delete i[e];
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription);
    const { children: e } = this.props;
    yt(e) && (this.childSubscription = e.on("change", (n) => {
      this.current && (this.current.textContent = `${n}`);
    }));
  }
}
class Pn {
  constructor(e) {
    this.isMounted = !1, this.node = e;
  }
  update() {
  }
}
function xx({ top: t, left: e, right: n, bottom: i }) {
  return {
    x: { min: e, max: n },
    y: { min: t, max: i }
  };
}
function ON({ x: t, y: e }) {
  return { top: e.min, right: t.max, bottom: e.max, left: t.min };
}
function IN(t, e) {
  if (!e)
    return t;
  const n = e({ x: t.left, y: t.top }), i = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: i.y,
    right: i.x
  };
}
function hu(t) {
  return t === void 0 || t === 1;
}
function th({ scale: t, scaleX: e, scaleY: n }) {
  return !hu(t) || !hu(e) || !hu(n);
}
function Nn(t) {
  return th(t) || Sx(t) || t.z || t.rotate || t.rotateX || t.rotateY || t.skewX || t.skewY;
}
function Sx(t) {
  return Rv(t.x) || Rv(t.y);
}
function Rv(t) {
  return t && t !== "0%";
}
function Pl(t, e, n) {
  const i = t - n, r = e * i;
  return n + r;
}
function Mv(t, e, n, i, r) {
  return r !== void 0 && (t = Pl(t, r, i)), Pl(t, n, i) + e;
}
function ih(t, e = 0, n = 1, i, r) {
  t.min = Mv(t.min, e, n, i, r), t.max = Mv(t.max, e, n, i, r);
}
function Px(t, { x: e, y: n }) {
  ih(t.x, e.translate, e.scale, e.originPoint), ih(t.y, n.translate, n.scale, n.originPoint);
}
const Ov = 0.999999999999, Iv = 1.0000000000001;
function DN(t, e, n, i = !1) {
  const r = n.length;
  if (!r)
    return;
  e.x = e.y = 1;
  let s, o;
  for (let a = 0; a < r; a++) {
    s = n[a], o = s.projectionDelta;
    const { visualElement: l } = s.options;
    l && l.props.style && l.props.style.display === "contents" || (i && s.options.layoutScroll && s.scroll && s !== s.root && (mi(t.x, -s.scroll.offset.x), mi(t.y, -s.scroll.offset.y)), o && (e.x *= o.x.scale, e.y *= o.y.scale, Px(t, o)), i && Nn(s.latestValues) && Na(t, s.latestValues, s.layout?.layoutBox));
  }
  e.x < Iv && e.x > Ov && (e.x = 1), e.y < Iv && e.y > Ov && (e.y = 1);
}
function mi(t, e) {
  t.min += e, t.max += e;
}
function Dv(t, e, n, i, r = 0.5) {
  const s = Ue(t.min, t.max, r);
  ih(t, e, n, s, i);
}
function Fv(t, e) {
  return typeof t == "string" ? parseFloat(t) / 100 * (e.max - e.min) : t;
}
function Na(t, e, n) {
  const i = n ?? t;
  Dv(t.x, Fv(e.x, i.x), e.scaleX, e.scale, e.originX), Dv(t.y, Fv(e.y, i.y), e.scaleY, e.scale, e.originY);
}
function Ex(t, e) {
  return xx(IN(t.getBoundingClientRect(), e));
}
function FN(t, e, n) {
  const i = Ex(t, n), { scroll: r } = e;
  return r && (mi(i.x, r.offset.x), mi(i.y, r.offset.y)), i;
}
const LN = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
}, NN = us.length;
function VN(t, e, n) {
  let i = "", r = !0;
  for (let o = 0; o < NN; o++) {
    const a = us[o], l = t[a];
    if (l === void 0)
      continue;
    let c = !0;
    if (typeof l == "number")
      c = l === (a.startsWith("scale") ? 1 : 0);
    else {
      const u = parseFloat(l);
      c = a.startsWith("scale") ? u === 1 : u === 0;
    }
    if (!c || n) {
      const u = Qd(l, xl[a]);
      if (!c) {
        r = !1;
        const d = LN[a] || a;
        i += `${d}(${u}) `;
      }
      n && (e[a] = u);
    }
  }
  const s = t.pathRotation;
  return s && (r = !1, i += `rotate(${Qd(s, xl.pathRotation)}) `), i = i.trim(), n ? i = n(e, r ? "" : i) : r && (i = "none"), i;
}
function zf(t, e, n) {
  const { style: i, vars: r, transformOrigin: s } = t;
  let o = !1, a = !1;
  for (const l in e) {
    const c = e[l];
    if (ds.has(l)) {
      o = !0;
      continue;
    } else if (Lk(l)) {
      r[l] = c;
      continue;
    } else {
      const u = Qd(c, xl[l]);
      l.startsWith("origin") ? (a = !0, s[l] = u) : i[l] = u;
    }
  }
  if (e.transform || (o || n ? i.transform = VN(e, t.transform, n) : i.transform && (i.transform = "none")), a) {
    const { originX: l = "50%", originY: c = "50%", originZ: u = 0 } = s;
    i.transformOrigin = `${l} ${c} ${u}`;
  }
}
function Tx(t, { style: e, vars: n }, i, r) {
  const s = t.style;
  let o;
  for (o in e)
    s[o] = e[o];
  r?.applyProjectionStyles(s, i);
  for (o in n)
    s.setProperty(o, n[o]);
}
function Lv(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
const Ss = {
  correct: (t, e) => {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (ce.test(t))
        t = parseFloat(t);
      else
        return t;
    const n = Lv(t, e.target.x), i = Lv(t, e.target.y);
    return `${n}% ${i}%`;
  }
}, jN = {
  correct: (t, { treeScale: e, projectionDelta: n }) => {
    const i = t, r = ai.parse(t);
    if (r.length > 5)
      return i;
    const s = ai.createTransformer(t), o = typeof r[0] != "number" ? 1 : 0, a = n.x.scale * e.x, l = n.y.scale * e.y;
    r[0 + o] /= a, r[1 + o] /= l;
    const c = Ue(a, l, 0.5);
    return typeof r[2 + o] == "number" && (r[2 + o] /= c), typeof r[3 + o] == "number" && (r[3 + o] /= c), s(r);
  }
}, nh = {
  borderRadius: {
    ...Ss,
    applyTo: [...Df]
  },
  borderTopLeftRadius: Ss,
  borderTopRightRadius: Ss,
  borderBottomLeftRadius: Ss,
  borderBottomRightRadius: Ss,
  boxShadow: jN
};
function Cx(t, { layout: e, layoutId: n }) {
  return ds.has(t) || t.startsWith("origin") || (e || n !== void 0) && (!!nh[t] || t === "opacity");
}
function Bf(t, e, n) {
  const i = t.style, r = e?.style, s = {};
  if (!i)
    return s;
  for (const o in i)
    (yt(i[o]) || r && yt(r[o]) || Cx(o, t) || n?.getValue(o)?.liveStyle !== void 0) && (s[o] = i[o]);
  return s;
}
function zN(t) {
  return window.getComputedStyle(t);
}
class BN extends kx {
  constructor() {
    super(...arguments), this.type = "html", this.renderInstance = Tx;
  }
  mount(e) {
    Si(!!e.style, "motion.create() components must forward their ref to a HTML or SVG element", "custom-component-ref"), super.mount(e);
  }
  readValueFromInstance(e, n) {
    if (ds.has(n))
      return this.projection?.isProjecting ? Bd(n) : oL(e, n);
    {
      const i = zN(e), r = (Lk(n) ? i.getPropertyValue(n) : i[n]) || 0;
      return typeof r == "string" ? r.trim() : r;
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: n }) {
    return Ex(e, n);
  }
  build(e, n, i) {
    zf(e, n, i.transformTemplate);
  }
  scrapeMotionValuesFromProps(e, n, i) {
    return Bf(e, n, i);
  }
}
const HN = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, UN = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function WN(t, e, n = 1, i = 0, r = !0) {
  t.pathLength = 1;
  const s = r ? HN : UN;
  t[s.offset] = `${-i}`, t[s.array] = `${e} ${n}`;
}
const qN = [
  "offsetDistance",
  "offsetPath",
  "offsetRotate",
  "offsetAnchor"
];
function Ax(t, {
  attrX: e,
  attrY: n,
  attrScale: i,
  pathLength: r,
  pathSpacing: s = 1,
  pathOffset: o = 0,
  // This is object creation, which we try to avoid per-frame.
  ...a
}, l, c, u) {
  if (zf(t, a, c), l) {
    t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
    return;
  }
  t.attrs = t.style, t.style = {};
  const { attrs: d, style: h } = t;
  d.transform && (h.transform = d.transform, delete d.transform), (h.transform || d.transformOrigin) && (h.transformOrigin = d.transformOrigin ?? "50% 50%", delete d.transformOrigin), h.transform && (h.transformBox = u?.transformBox ?? "fill-box", delete d.transformBox);
  for (const f of qN)
    d[f] !== void 0 && (h[f] = d[f], delete d[f]);
  e !== void 0 && (d.x = e), n !== void 0 && (d.y = n), i !== void 0 && (d.scale = i), r !== void 0 && WN(d, r, s, o, !1);
}
const $x = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength",
  "startOffset",
  "textLength",
  "lengthAdjust"
]), Rx = (t) => typeof t == "string" && t.toLowerCase() === "svg";
function GN(t, e, n, i) {
  Tx(t, e, void 0, i);
  for (const r in e.attrs)
    t.setAttribute($x.has(r) ? r : If(r), e.attrs[r]);
}
function Mx(t, e, n) {
  const i = Bf(t, e, n);
  for (const r in t)
    if (yt(t[r]) || yt(e[r])) {
      const s = us.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r;
      i[s] = t[r];
    }
  return i;
}
class KN extends kx {
  constructor() {
    super(...arguments), this.type = "svg", this.isSVGTag = !1, this.measureInstanceViewportBox = ct;
  }
  getBaseTargetFromProps(e, n) {
    return e[n];
  }
  readValueFromInstance(e, n) {
    if (ds.has(n)) {
      const i = hx(n);
      return i && i.default || 0;
    }
    return n = $x.has(n) ? n : If(n), e.getAttribute(n);
  }
  scrapeMotionValuesFromProps(e, n, i) {
    return Mx(e, n, i);
  }
  build(e, n, i) {
    Ax(e, n, this.isSVGTag, i.transformTemplate, i.style);
  }
  renderInstance(e, n, i, r) {
    GN(e, n, i, r);
  }
  mount(e) {
    this.isSVGTag = Rx(e.tagName), super.mount(e);
  }
}
const YN = jf.length;
function Ox(t) {
  if (!t)
    return;
  if (!t.isControllingVariants) {
    const n = t.parent ? Ox(t.parent) || {} : {};
    return t.props.initial !== void 0 && (n.initial = t.props.initial), n;
  }
  const e = {};
  for (let n = 0; n < YN; n++) {
    const i = jf[n], r = t.props[i];
    (uo(r) || r === !1) && (e[i] = r);
  }
  return e;
}
function Ix(t, e) {
  if (!Array.isArray(e))
    return !1;
  const n = e.length;
  if (n !== t.length)
    return !1;
  for (let i = 0; i < n; i++)
    if (e[i] !== t[i])
      return !1;
  return !0;
}
const XN = [...Vf].reverse(), JN = Vf.length;
function ZN(t) {
  return (e) => Promise.all(e.map(({ animation: n, options: i }) => KL(t, n, i)));
}
function QN(t) {
  let e = ZN(t), n = Nv(), i = !0, r = !1;
  const s = (c) => (u, d) => {
    const h = Jn(t, d, c === "exit" ? t.presenceContext?.custom : void 0);
    if (h) {
      const { transition: f, transitionEnd: p, ...v } = h;
      u = { ...u, ...v, ...p };
    }
    return u;
  };
  function o(c) {
    e = c(t);
  }
  function a(c) {
    const { props: u } = t, d = Ox(t.parent) || {}, h = [], f = /* @__PURE__ */ new Set();
    let p = {}, v = 1 / 0;
    for (let m = 0; m < JN; m++) {
      const y = XN[m], k = n[y], _ = u[y] !== void 0 ? u[y] : d[y], w = uo(_), T = y === c ? k.isActive : null;
      T === !1 && (v = m);
      let E = _ === d[y] && _ !== u[y] && w;
      if (E && (i || r) && t.manuallyAnimateOnMount && (E = !1), k.protectedKeys = { ...p }, // If it isn't active and hasn't *just* been set as inactive
      !k.isActive && T === null || // If we didn't and don't have any defined prop for this animation type
      !_ && !k.prevProp || // Or if the prop doesn't define an animation
      ic(_) || typeof _ == "boolean")
        continue;
      if (y === "exit" && k.isActive && T !== !0) {
        k.prevResolvedValues && (p = {
          ...p,
          ...k.prevResolvedValues
        });
        continue;
      }
      const S = e6(k.prevProp, _);
      let P = S || // If we're making this variant active, we want to always make it active
      y === c && k.isActive && !E && w || // If we removed a higher-priority variant (i is in reverse order)
      m > v && w, C = !1;
      const M = Array.isArray(_) ? _ : [_];
      let O = M.reduce(s(y), {});
      T === !1 && (O = {});
      const { prevResolvedValues: W = {} } = k, H = {
        ...W,
        ...O
      }, z = (B) => {
        P = !0, f.has(B) && (C = !0, f.delete(B)), k.needsAnimating[B] = !0;
        const $ = t.getValue(B);
        $ && ($.liveStyle = !1);
      };
      for (const B in H) {
        const $ = O[B], I = W[B];
        if (p.hasOwnProperty(B))
          continue;
        let q = !1;
        Kd($) && Kd(I) ? q = !Ix($, I) || S : q = $ !== I, q ? $ != null ? z(B) : f.add(B) : $ !== void 0 && f.has(B) ? z(B) : k.protectedKeys[B] = !0;
      }
      k.prevProp = _, k.prevResolvedValues = O, k.isActive && (p = { ...p, ...O }), (i || r) && t.blockInitialAnimation && (P = !1);
      const F = E && S;
      P && (!F || C) && h.push(...M.map((B) => {
        const $ = { type: y };
        if (typeof B == "string" && (i || r) && !F && t.manuallyAnimateOnMount && t.parent) {
          const { parent: I } = t, q = Jn(I, B);
          if (I.enteringChildren && q) {
            const { delayChildren: J } = q.transition || {};
            $.delay = nx(I.enteringChildren, t, J);
          }
        }
        return {
          animation: B,
          options: $
        };
      }));
    }
    if (f.size) {
      const m = {};
      if (typeof u.initial != "boolean") {
        const y = Jn(t, Array.isArray(u.initial) ? u.initial[0] : u.initial);
        y && y.transition && (m.transition = y.transition);
      }
      f.forEach((y) => {
        const k = t.getBaseTarget(y), _ = t.getValue(y);
        _ && (_.liveStyle = !0), m[y] = k ?? null;
      }), h.push({ animation: m });
    }
    let g = !!h.length;
    return i && (u.initial === !1 || u.initial === u.animate) && !t.manuallyAnimateOnMount && (g = !1), i = !1, r = !1, g ? e(h) : Promise.resolve();
  }
  function l(c, u) {
    if (n[c].isActive === u)
      return Promise.resolve();
    t.variantChildren?.forEach((h) => h.animationState?.setActive(c, u)), n[c].isActive = u;
    const d = a(c);
    for (const h in n)
      n[h].protectedKeys = {};
    return d;
  }
  return {
    animateChanges: a,
    setActive: l,
    setAnimateFunction: o,
    getState: () => n,
    reset: () => {
      n = Nv(), r = !0;
    }
  };
}
function e6(t, e) {
  return typeof e == "string" ? e !== t : Array.isArray(e) ? !Ix(e, t) : !1;
}
function In(t = !1) {
  return {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Nv() {
  return {
    animate: In(!0),
    whileInView: In(),
    whileHover: In(),
    whileTap: In(),
    whileDrag: In(),
    whileFocus: In(),
    exit: In()
  };
}
function rh(t, e) {
  t.min = e.min, t.max = e.max;
}
function ei(t, e) {
  rh(t.x, e.x), rh(t.y, e.y);
}
function Vv(t, e) {
  t.translate = e.translate, t.scale = e.scale, t.originPoint = e.originPoint, t.origin = e.origin;
}
const Dx = 1e-4, t6 = 1 - Dx, i6 = 1 + Dx, Fx = 0.01, n6 = 0 - Fx, r6 = 0 + Fx;
function At(t) {
  return t.max - t.min;
}
function s6(t, e, n) {
  return Math.abs(t - e) <= n;
}
function jv(t, e, n, i = 0.5) {
  t.origin = i, t.originPoint = Ue(e.min, e.max, t.origin), t.scale = At(n) / At(e), t.translate = Ue(n.min, n.max, t.origin) - t.originPoint, (t.scale >= t6 && t.scale <= i6 || isNaN(t.scale)) && (t.scale = 1), (t.translate >= n6 && t.translate <= r6 || isNaN(t.translate)) && (t.translate = 0);
}
function Ws(t, e, n, i) {
  jv(t.x, e.x, n.x, i ? i.originX : void 0), jv(t.y, e.y, n.y, i ? i.originY : void 0);
}
function zv(t, e, n, i = 0) {
  const r = i ? Ue(n.min, n.max, i) : n.min;
  t.min = r + e.min, t.max = t.min + At(e);
}
function o6(t, e, n, i) {
  zv(t.x, e.x, n.x, i?.x), zv(t.y, e.y, n.y, i?.y);
}
function Bv(t, e, n, i = 0) {
  const r = i ? Ue(n.min, n.max, i) : n.min;
  t.min = e.min - r, t.max = t.min + At(e);
}
function El(t, e, n, i) {
  Bv(t.x, e.x, n.x, i?.x), Bv(t.y, e.y, n.y, i?.y);
}
function Hv(t, e, n, i, r) {
  return t -= e, t = Pl(t, 1 / n, i), r !== void 0 && (t = Pl(t, 1 / r, i)), t;
}
function a6(t, e = 0, n = 1, i = 0.5, r, s = t, o = t) {
  if (_i.test(e) && (e = parseFloat(e), e = Ue(o.min, o.max, e / 100) - o.min), typeof e != "number")
    return;
  let a = Ue(s.min, s.max, i);
  t === s && (a -= e), t.min = Hv(t.min, e, n, a, r), t.max = Hv(t.max, e, n, a, r);
}
function Uv(t, e, [n, i, r], s, o) {
  a6(t, e[n], e[i], e[r], e.scale, s, o);
}
const l6 = ["x", "scaleX", "originX"], c6 = ["y", "scaleY", "originY"];
function Wv(t, e, n, i) {
  Uv(t.x, e, l6, n ? n.x : void 0, i ? i.x : void 0), Uv(t.y, e, c6, n ? n.y : void 0, i ? i.y : void 0);
}
function qv(t) {
  return t.translate === 0 && t.scale === 1;
}
function Lx(t) {
  return qv(t.x) && qv(t.y);
}
function Gv(t, e) {
  return t.min === e.min && t.max === e.max;
}
function u6(t, e) {
  return Gv(t.x, e.x) && Gv(t.y, e.y);
}
function Kv(t, e) {
  return Math.round(t.min) === Math.round(e.min) && Math.round(t.max) === Math.round(e.max);
}
function Nx(t, e) {
  return Kv(t.x, e.x) && Kv(t.y, e.y);
}
function Yv(t) {
  return At(t.x) / At(t.y);
}
function Xv(t, e) {
  return t.translate === e.translate && t.scale === e.scale && t.originPoint === e.originPoint;
}
function fi(t) {
  return [t("x"), t("y")];
}
function d6(t, e, n) {
  let i = "";
  const r = t.x.translate / e.x, s = t.y.translate / e.y, o = n?.z || 0;
  if ((r || s || o) && (i = `translate3d(${r}px, ${s}px, ${o}px) `), (e.x !== 1 || e.y !== 1) && (i += `scale(${1 / e.x}, ${1 / e.y}) `), n) {
    const { transformPerspective: c, rotate: u, pathRotation: d, rotateX: h, rotateY: f, skewX: p, skewY: v } = n;
    c && (i = `perspective(${c}px) ${i}`), u && (i += `rotate(${u}deg) `), d && (i += `rotate(${d}deg) `), h && (i += `rotateX(${h}deg) `), f && (i += `rotateY(${f}deg) `), p && (i += `skewX(${p}deg) `), v && (i += `skewY(${v}deg) `);
  }
  const a = t.x.scale * e.x, l = t.y.scale * e.y;
  return (a !== 1 || l !== 1) && (i += `scale(${a}, ${l})`), i || "none";
}
const h6 = Df.length, Jv = (t) => typeof t == "string" ? parseFloat(t) : t, Zv = (t) => typeof t == "number" || ce.test(t);
function f6(t, e, n, i, r, s) {
  r ? (t.opacity = Ue(0, n.opacity ?? 1, p6(i)), t.opacityExit = Ue(e.opacity ?? 1, 0, m6(i))) : s && (t.opacity = Ue(e.opacity ?? 1, n.opacity ?? 1, i));
  for (let o = 0; o < h6; o++) {
    const a = Df[o];
    let l = Qv(e, a), c = Qv(n, a);
    if (l === void 0 && c === void 0)
      continue;
    l || (l = 0), c || (c = 0), l === 0 || c === 0 || Zv(l) === Zv(c) ? (t[a] = Math.max(Ue(Jv(l), Jv(c), i), 0), (_i.test(c) || _i.test(l)) && (t[a] += "%")) : t[a] = c;
  }
  (e.rotate || n.rotate) && (t.rotate = Ue(e.rotate || 0, n.rotate || 0, i));
}
function Qv(t, e) {
  return t[e] !== void 0 ? t[e] : t.borderRadius;
}
const p6 = /* @__PURE__ */ Vx(0, 0.5, Rk), m6 = /* @__PURE__ */ Vx(0.5, 0.95, Yt);
function Vx(t, e, n) {
  return (i) => i < t ? 0 : i > e ? 1 : n(/* @__PURE__ */ lo(t, e, i));
}
function g6(t, e, n) {
  const i = yt(t) ? t : ts(t);
  return i.start(Mf("", i, e, n)), i.animation;
}
function ho(t, e, n, i = { passive: !0 }) {
  return t.addEventListener(e, n, i), () => t.removeEventListener(e, n, i);
}
const v6 = (t, e) => t.depth - e.depth;
class y6 {
  constructor() {
    this.children = [], this.isDirty = !1;
  }
  add(e) {
    bf(this.children, e), this.isDirty = !0;
  }
  remove(e) {
    yl(this.children, e), this.isDirty = !0;
  }
  forEach(e) {
    this.isDirty && this.children.sort(v6), this.isDirty = !1, this.children.forEach(e);
  }
}
function b6(t, e) {
  const n = Ct.now(), i = ({ timestamp: r }) => {
    const s = r - n;
    s >= e && (yn(i), t(s - e));
  };
  return We.setup(i, !0), () => yn(i);
}
function Va(t) {
  return yt(t) ? t.get() : t;
}
class _6 {
  constructor() {
    this.members = [];
  }
  add(e) {
    bf(this.members, e);
    for (let n = this.members.length - 1; n >= 0; n--) {
      const i = this.members[n];
      if (i === e || i === this.lead || i === this.prevLead)
        continue;
      const r = i.instance;
      (!r || r.isConnected === !1) && !i.snapshot && (yl(this.members, i), i.unmount());
    }
    e.scheduleRender();
  }
  remove(e) {
    if (yl(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
      const n = this.members[this.members.length - 1];
      n && this.promote(n);
    }
  }
  relegate(e) {
    for (let n = this.members.indexOf(e) - 1; n >= 0; n--) {
      const i = this.members[n];
      if (i.isPresent !== !1 && i.instance?.isConnected !== !1)
        return this.promote(i), !0;
    }
    return !1;
  }
  promote(e, n) {
    const i = this.lead;
    if (e !== i && (this.prevLead = i, this.lead = e, e.show(), i)) {
      i.updateSnapshot(), e.scheduleRender();
      const { layoutDependency: r } = i.options, { layoutDependency: s } = e.options;
      (r === void 0 || r !== s) && (e.resumeFrom = i, n && (i.preserveOpacity = !0), i.snapshot && (e.snapshot = i.snapshot, e.snapshot.latestValues = i.animationValues || i.latestValues), e.root?.isUpdating && (e.isLayoutDirty = !0)), e.options.crossfade === !1 && i.hide();
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      e.options.onExitComplete?.(), e.resumingFrom?.options.onExitComplete?.();
    });
  }
  scheduleRender() {
    this.members.forEach((e) => e.instance && e.scheduleRender(!1));
  }
  removeLeadSnapshot() {
    this.lead?.snapshot && (this.lead.snapshot = void 0);
  }
}
const ja = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, fu = ["", "X", "Y", "Z"], w6 = 1e3;
let k6 = 0;
function pu(t, e, n, i) {
  const { latestValues: r } = e;
  r[t] && (n[t] = r[t], e.setStaticValue(t, 0), i && (i[t] = 0));
}
function jx(t) {
  if (t.hasCheckedOptimisedAppear = !0, t.root === t)
    return;
  const { visualElement: e } = t.options;
  if (!e)
    return;
  const n = lx(e);
  if (window.MotionHasOptimisedAnimation(n, "transform")) {
    const { layout: r, layoutId: s } = t.options;
    window.MotionCancelOptimisedAnimation(n, "transform", We, !(r || s));
  }
  const { parent: i } = t;
  i && !i.hasCheckedOptimisedAppear && jx(i);
}
function zx({ attachResizeListener: t, defaultParent: e, measureScroll: n, checkIsScrollRoot: i, resetTransform: r }) {
  return class {
    constructor(o = {}, a = e?.()) {
      this.id = k6++, this.animationId = 0, this.animationCommitId = 0, this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.isProjectionDirty = !1, this.isSharedProjectionDirty = !1, this.isTransformDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.hasCheckedOptimisedAppear = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.hasTreeAnimated = !1, this.layoutVersion = 0, this.updateScheduled = !1, this.scheduleUpdate = () => this.update(), this.projectionUpdateScheduled = !1, this.checkUpdateFailed = () => {
        this.isUpdating && (this.isUpdating = !1, this.clearAllSnapshots());
      }, this.updateProjection = () => {
        this.projectionUpdateScheduled = !1, this.nodes.forEach(P6), this.nodes.forEach(R6), this.nodes.forEach(M6), this.nodes.forEach(E6);
      }, this.resolvedRelativeTargetAt = 0, this.linkedParentVersion = 0, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.latestValues = o, this.root = a ? a.root || a : this, this.path = a ? [...a.path, a] : [], this.parent = a, this.depth = a ? a.depth + 1 : 0;
      for (let l = 0; l < this.path.length; l++)
        this.path[l].shouldResetTransform = !0;
      this.root === this && (this.nodes = new y6());
    }
    addEventListener(o, a) {
      return this.eventHandlers.has(o) || this.eventHandlers.set(o, new _f()), this.eventHandlers.get(o).add(a);
    }
    notifyListeners(o, ...a) {
      const l = this.eventHandlers.get(o);
      l && l.notify(...a);
    }
    hasListeners(o) {
      return this.eventHandlers.has(o);
    }
    /**
     * Lifecycles
     */
    mount(o) {
      if (this.instance)
        return;
      this.isSVG = Nf(o) && !SN(o), this.instance = o;
      const { layoutId: a, layout: l, visualElement: c } = this.options;
      if (c && !c.current && c.mount(o), this.root.nodes.add(this), this.parent && this.parent.children.add(this), this.root.hasTreeAnimated && (l || a) && (this.isLayoutDirty = !0), t) {
        let u, d = 0;
        const h = () => this.root.updateBlockedByResize = !1;
        We.read(() => {
          d = window.innerWidth;
        }), t(o, () => {
          const f = window.innerWidth;
          f !== d && (d = f, this.root.updateBlockedByResize = !0, u && u(), u = b6(h, 250), ja.hasAnimatedSinceResize && (ja.hasAnimatedSinceResize = !1, this.nodes.forEach(i0)));
        });
      }
      a && this.root.registerSharedNode(a, this), this.options.animate !== !1 && c && (a || l) && this.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d, hasRelativeLayoutChanged: h, layout: f }) => {
        if (this.isTreeAnimationBlocked()) {
          this.target = void 0, this.relativeTarget = void 0;
          return;
        }
        const p = this.options.transition || c.getDefaultTransition() || L6, { onLayoutAnimationStart: v, onLayoutAnimationComplete: g } = c.getProps(), m = !this.targetLayout || !Nx(this.targetLayout, f), y = !d && h;
        if (this.options.layoutRoot || this.resumeFrom || y || d && (m || !this.currentAnimation)) {
          this.resumeFrom && (this.resumingFrom = this.resumeFrom, this.resumingFrom.resumingFrom = void 0);
          const k = {
            ...Rf(p, "layout"),
            onPlay: v,
            onComplete: g
          };
          (c.shouldReduceMotion || this.options.layoutRoot) && (k.delay = 0, k.type = !1), this.startAnimation(k), this.setAnimationOrigin(u, y, k.path);
        } else
          d || i0(this), this.isLead() && this.options.onExitComplete && this.options.onExitComplete();
        this.targetLayout = f;
      });
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this);
      const o = this.getStack();
      o && o.remove(this), this.parent && this.parent.children.delete(this), this.instance = void 0, this.eventHandlers.clear(), yn(this.updateProjection);
    }
    // only on the root
    blockUpdate() {
      this.updateManuallyBlocked = !0;
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1;
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize;
    }
    isTreeAnimationBlocked() {
      return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || !1;
    }
    // Note: currently only running on root node
    startUpdate() {
      this.isUpdateBlocked() || (this.isUpdating = !0, this.nodes && this.nodes.forEach(O6), this.animationId++);
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options;
      return o && o.getProps().transformTemplate;
    }
    willUpdate(o = !0) {
      if (this.root.hasTreeAnimated = !0, this.root.isUpdateBlocked()) {
        this.options.onExitComplete && this.options.onExitComplete();
        return;
      }
      if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear && jx(this), !this.root.isUpdating && this.root.startUpdate(), this.isLayoutDirty)
        return;
      this.isLayoutDirty = !0;
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        d.shouldResetTransform = !0, (typeof d.latestValues.x == "string" || typeof d.latestValues.y == "string") && (d.isLayoutDirty = !0), d.updateScroll("snapshot"), d.options.layoutRoot && d.willUpdate(!1);
      }
      const { layoutId: a, layout: l } = this.options;
      if (a === void 0 && !l)
        return;
      const c = this.getTransformTemplate();
      this.prevTransformTemplateValue = c ? c(this.latestValues, "") : void 0, this.updateSnapshot(), o && this.notifyListeners("willUpdate");
    }
    update() {
      if (this.updateScheduled = !1, this.isUpdateBlocked()) {
        const l = this.updateBlockedByResize;
        this.unblockUpdate(), this.updateBlockedByResize = !1, this.clearAllSnapshots(), l && this.nodes.forEach(C6), this.nodes.forEach(e0);
        return;
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(t0);
        return;
      }
      this.animationCommitId = this.animationId, this.isUpdating ? (this.isUpdating = !1, this.nodes.forEach(A6), this.nodes.forEach($6), this.nodes.forEach(x6), this.nodes.forEach(S6)) : this.nodes.forEach(t0), this.clearAllSnapshots();
      const a = Ct.now();
      gt.delta = xi(0, 1e3 / 60, a - gt.timestamp), gt.timestamp = a, gt.isProcessing = !0, su.update.process(gt), su.preRender.process(gt), su.render.process(gt), gt.isProcessing = !1;
    }
    didUpdate() {
      this.updateScheduled || (this.updateScheduled = !0, Ff.read(this.scheduleUpdate));
    }
    clearAllSnapshots() {
      this.nodes.forEach(T6), this.sharedNodes.forEach(I6);
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled || (this.projectionUpdateScheduled = !0, We.preRender(this.updateProjection, !1, !0));
    }
    scheduleCheckAfterUnmount() {
      We.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed();
      });
    }
    /**
     * Update measurements
     */
    updateSnapshot() {
      this.snapshot || !this.instance || (this.snapshot = this.measure(), this.snapshot && !At(this.snapshot.measuredBox.x) && !At(this.snapshot.measuredBox.y) && (this.snapshot = void 0));
    }
    updateLayout() {
      if (!this.instance || (this.updateScroll(), !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))
        return;
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let l = 0; l < this.path.length; l++)
          this.path[l].updateScroll();
      const o = this.layout;
      this.layout = this.measure(!1), this.layoutVersion++, this.layoutCorrected || (this.layoutCorrected = ct()), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.layoutBox);
      const { visualElement: a } = this.options;
      a && a.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0);
    }
    updateScroll(o = "measure") {
      let a = !!(this.options.layoutScroll && this.instance);
      if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === o && (a = !1), a && this.instance) {
        const l = i(this.instance);
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: l,
          offset: n(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : l
        };
      }
    }
    resetTransform() {
      if (!r)
        return;
      const o = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout, a = this.projectionDelta && !Lx(this.projectionDelta), l = this.getTransformTemplate(), c = l ? l(this.latestValues, "") : void 0, u = c !== this.prevTransformTemplateValue;
      o && this.instance && (a || Nn(this.latestValues) || u) && (r(this.instance, c), this.shouldResetTransform = !1, this.scheduleRender());
    }
    measure(o = !0) {
      const a = this.measurePageBox();
      let l = this.removeElementScroll(a);
      return o && (l = this.removeTransform(l)), N6(l), {
        animationId: this.root.animationId,
        measuredBox: a,
        layoutBox: l,
        latestValues: {},
        source: this.id
      };
    }
    measurePageBox() {
      const { visualElement: o } = this.options;
      if (!o)
        return ct();
      const a = o.measureViewportBox();
      if (!(this.scroll?.wasRoot || this.path.some(V6))) {
        const { scroll: c } = this.root;
        c && (mi(a.x, c.offset.x), mi(a.y, c.offset.y));
      }
      return a;
    }
    removeElementScroll(o) {
      const a = ct();
      if (ei(a, o), this.scroll?.wasRoot)
        return a;
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l], { scroll: u, options: d } = c;
        c !== this.root && u && d.layoutScroll && (u.wasRoot && ei(a, o), mi(a.x, u.offset.x), mi(a.y, u.offset.y));
      }
      return a;
    }
    applyTransform(o, a = !1, l) {
      const c = l || ct();
      ei(c, o);
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u];
        !a && d.options.layoutScroll && d.scroll && d !== d.root && (mi(c.x, -d.scroll.offset.x), mi(c.y, -d.scroll.offset.y)), Nn(d.latestValues) && Na(c, d.latestValues, d.layout?.layoutBox);
      }
      return Nn(this.latestValues) && Na(c, this.latestValues, this.layout?.layoutBox), c;
    }
    removeTransform(o) {
      const a = ct();
      ei(a, o);
      for (let l = 0; l < this.path.length; l++) {
        const c = this.path[l];
        if (!Nn(c.latestValues))
          continue;
        let u;
        c.instance && (th(c.latestValues) && c.updateSnapshot(), u = ct(), ei(u, c.measurePageBox())), Wv(a, c.latestValues, c.snapshot?.layoutBox, u);
      }
      return Nn(this.latestValues) && Wv(a, this.latestValues), a;
    }
    setTargetDelta(o) {
      this.targetDelta = o, this.root.scheduleUpdateProjection(), this.isProjectionDirty = !0;
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0
      };
    }
    clearMeasurements() {
      this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent && this.relativeParent.resolvedRelativeTargetAt !== gt.timestamp && this.relativeParent.resolveTargetDelta(!0);
    }
    resolveTargetDelta(o = !1) {
      const a = this.getLead();
      this.isProjectionDirty || (this.isProjectionDirty = a.isProjectionDirty), this.isTransformDirty || (this.isTransformDirty = a.isTransformDirty), this.isSharedProjectionDirty || (this.isSharedProjectionDirty = a.isSharedProjectionDirty);
      const l = !!this.resumingFrom || this !== a;
      if (!(o || l && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize))
        return;
      const { layout: u, layoutId: d } = this.options;
      if (!this.layout || !(u || d))
        return;
      this.resolvedRelativeTargetAt = gt.timestamp;
      const h = this.getClosestProjectingParent();
      h && this.linkedParentVersion !== h.layoutVersion && !h.options.layoutRoot && this.removeRelativeTarget(), !this.targetDelta && !this.relativeTarget && (this.options.layoutAnchor !== !1 && h && h.layout ? this.createRelativeTarget(h, this.layout.layoutBox, h.layout.layoutBox) : this.removeRelativeTarget()), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = ct(), this.targetWithTransforms = ct()), this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target ? (this.forceRelativeParentToResolveTarget(), o6(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || void 0)) : this.targetDelta ? (this.resumingFrom ? this.applyTransform(this.layout.layoutBox, !1, this.target) : ei(this.target, this.layout.layoutBox), Px(this.target, this.targetDelta)) : ei(this.target, this.layout.layoutBox), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.options.layoutAnchor !== !1 && h && !!h.resumingFrom == !!this.resumingFrom && !h.options.layoutScroll && h.target && this.animationProgress !== 1 ? this.createRelativeTarget(h, this.target, h.target) : this.relativeParent = this.relativeTarget = void 0));
    }
    getClosestProjectingParent() {
      if (!(!this.parent || th(this.parent.latestValues) || Sx(this.parent.latestValues)))
        return this.parent.isProjecting() ? this.parent : this.parent.getClosestProjectingParent();
    }
    isProjecting() {
      return !!((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
    }
    createRelativeTarget(o, a, l) {
      this.relativeParent = o, this.linkedParentVersion = o.layoutVersion, this.forceRelativeParentToResolveTarget(), this.relativeTarget = ct(), this.relativeTargetOrigin = ct(), El(this.relativeTargetOrigin, a, l, this.options.layoutAnchor || void 0), ei(this.relativeTarget, this.relativeTargetOrigin);
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0;
    }
    calcProjection() {
      const o = this.getLead(), a = !!this.resumingFrom || this !== o;
      let l = !0;
      if ((this.isProjectionDirty || this.parent?.isProjectionDirty) && (l = !1), a && (this.isSharedProjectionDirty || this.isTransformDirty) && (l = !1), this.resolvedRelativeTargetAt === gt.timestamp && (l = !1), l)
        return;
      const { layout: c, layoutId: u } = this.options;
      if (this.isTreeAnimating = !!(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !this.layout || !(c || u))
        return;
      ei(this.layoutCorrected, this.layout.layoutBox);
      const d = this.treeScale.x, h = this.treeScale.y;
      DN(this.layoutCorrected, this.treeScale, this.path, a), o.layout && !o.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1) && (o.target = o.layout.layoutBox, o.targetWithTransforms = ct());
      const { target: f } = o;
      if (!f) {
        this.prevProjectionDelta && (this.createProjectionDeltas(), this.scheduleRender());
        return;
      }
      !this.projectionDelta || !this.prevProjectionDelta ? this.createProjectionDeltas() : (Vv(this.prevProjectionDelta.x, this.projectionDelta.x), Vv(this.prevProjectionDelta.y, this.projectionDelta.y)), Ws(this.projectionDelta, this.layoutCorrected, f, this.latestValues), (this.treeScale.x !== d || this.treeScale.y !== h || !Xv(this.projectionDelta.x, this.prevProjectionDelta.x) || !Xv(this.projectionDelta.y, this.prevProjectionDelta.y)) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", f));
    }
    hide() {
      this.isVisible = !1;
    }
    show() {
      this.isVisible = !0;
    }
    scheduleRender(o = !0) {
      if (this.options.visualElement?.scheduleRender(), o) {
        const a = this.getStack();
        a && a.scheduleRender();
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
    }
    createProjectionDeltas() {
      this.prevProjectionDelta = Or(), this.projectionDelta = Or(), this.projectionDeltaWithTransform = Or();
    }
    setAnimationOrigin(o, a = !1, l) {
      const c = this.snapshot, u = c ? c.latestValues : {}, d = { ...this.latestValues }, h = Or();
      (!this.relativeParent || !this.relativeParent.options.layoutRoot) && (this.relativeTarget = this.relativeTargetOrigin = void 0), this.attemptToResolveRelativeTarget = !a;
      const f = ct(), p = c ? c.source : void 0, v = this.layout ? this.layout.source : void 0, g = p !== v, m = this.getStack(), y = !m || m.members.length <= 1, k = !!(g && !y && this.options.crossfade === !0 && !this.path.some(F6));
      this.animationProgress = 0;
      let _;
      const w = l?.interpolateProjection(o);
      this.mixTargetDelta = (T) => {
        const E = T / 1e3, S = w?.(E);
        S ? (h.x.translate = S.x, h.x.scale = Ue(o.x.scale, 1, E), h.x.origin = o.x.origin, h.x.originPoint = o.x.originPoint, h.y.translate = S.y, h.y.scale = Ue(o.y.scale, 1, E), h.y.origin = o.y.origin, h.y.originPoint = o.y.originPoint) : (n0(h.x, o.x, E), n0(h.y, o.y, E)), this.setTargetDelta(h), this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout && (El(f, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || void 0), D6(this.relativeTarget, this.relativeTargetOrigin, f, E), _ && u6(this.relativeTarget, _) && (this.isProjectionDirty = !1), _ || (_ = ct()), ei(_, this.relativeTarget)), g && (this.animationValues = d, f6(d, u, this.latestValues, E, k, y)), S && S.rotate !== void 0 && (this.animationValues || (this.animationValues = d), this.animationValues.pathRotation = S.rotate), this.root.scheduleUpdateProjection(), this.scheduleRender(), this.animationProgress = E;
      }, this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0);
    }
    startAnimation(o) {
      this.notifyListeners("animationStart"), this.currentAnimation?.stop(), this.resumingFrom?.currentAnimation?.stop(), this.pendingAnimation && (yn(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = We.update(() => {
        ja.hasAnimatedSinceResize = !0, this.motionValue || (this.motionValue = ts(0)), this.motionValue.jump(0, !1), this.currentAnimation = g6(this.motionValue, [0, 1e3], {
          ...o,
          velocity: 0,
          isSync: !0,
          onUpdate: (a) => {
            this.mixTargetDelta(a), o.onUpdate && o.onUpdate(a);
          },
          onComplete: () => {
            o.onComplete && o.onComplete(), this.completeAnimation();
          }
        }), this.resumingFrom && (this.resumingFrom.currentAnimation = this.currentAnimation), this.pendingAnimation = void 0;
      });
    }
    completeAnimation() {
      this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0);
      const o = this.getStack();
      o && o.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
    }
    finishAnimation() {
      this.currentAnimation && (this.mixTargetDelta && this.mixTargetDelta(w6), this.currentAnimation.stop()), this.completeAnimation();
    }
    applyTransformsToTarget() {
      const o = this.getLead();
      let { targetWithTransforms: a, target: l, layout: c, latestValues: u } = o;
      if (!(!a || !l || !c)) {
        if (this !== o && this.layout && c && Bx(this.options.animationType, this.layout.layoutBox, c.layoutBox)) {
          l = this.target || ct();
          const d = At(this.layout.layoutBox.x);
          l.x.min = o.target.x.min, l.x.max = l.x.min + d;
          const h = At(this.layout.layoutBox.y);
          l.y.min = o.target.y.min, l.y.max = l.y.min + h;
        }
        ei(a, l), Na(a, u), Ws(this.projectionDeltaWithTransform, this.layoutCorrected, a, u);
      }
    }
    registerSharedNode(o, a) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new _6()), this.sharedNodes.get(o).add(a);
      const c = a.options.initialPromotionConfig;
      a.promote({
        transition: c ? c.transition : void 0,
        preserveFollowOpacity: c && c.shouldPreserveFollowOpacity ? c.shouldPreserveFollowOpacity(a) : void 0
      });
    }
    isLead() {
      const o = this.getStack();
      return o ? o.lead === this : !0;
    }
    getLead() {
      const { layoutId: o } = this.options;
      return o ? this.getStack()?.lead || this : this;
    }
    getPrevLead() {
      const { layoutId: o } = this.options;
      return o ? this.getStack()?.prevLead : void 0;
    }
    getStack() {
      const { layoutId: o } = this.options;
      if (o)
        return this.root.sharedNodes.get(o);
    }
    promote({ needsReset: o, transition: a, preserveFollowOpacity: l } = {}) {
      const c = this.getStack();
      c && c.promote(this, l), o && (this.projectionDelta = void 0, this.needsReset = !0), a && this.setOptions({ transition: a });
    }
    relegate() {
      const o = this.getStack();
      return o ? o.relegate(this) : !1;
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options;
      if (!o)
        return;
      let a = !1;
      const { latestValues: l } = o;
      if ((l.z || l.rotate || l.rotateX || l.rotateY || l.rotateZ || l.skewX || l.skewY) && (a = !0), !a)
        return;
      const c = {};
      l.z && pu("z", o, c, this.animationValues);
      for (let u = 0; u < fu.length; u++)
        pu(`rotate${fu[u]}`, o, c, this.animationValues), pu(`skew${fu[u]}`, o, c, this.animationValues);
      o.render();
      for (const u in c)
        o.setStaticValue(u, c[u]), this.animationValues && (this.animationValues[u] = c[u]);
      o.scheduleRender();
    }
    applyProjectionStyles(o, a) {
      if (!this.instance || this.isSVG)
        return;
      if (!this.isVisible) {
        o.visibility = "hidden";
        return;
      }
      const l = this.getTransformTemplate();
      if (this.needsReset) {
        this.needsReset = !1, o.visibility = "", o.opacity = "", o.pointerEvents = Va(a?.pointerEvents) || "", o.transform = l ? l(this.latestValues, "") : "none";
        return;
      }
      const c = this.getLead();
      if (!this.projectionDelta || !this.layout || !c.target) {
        this.options.layoutId && (o.opacity = this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1, o.pointerEvents = Va(a?.pointerEvents) || ""), this.hasProjected && !Nn(this.latestValues) && (o.transform = l ? l({}, "") : "none", this.hasProjected = !1);
        return;
      }
      o.visibility = "";
      const u = c.animationValues || c.latestValues;
      this.applyTransformsToTarget();
      let d = d6(this.projectionDeltaWithTransform, this.treeScale, u);
      l && (d = l(u, d)), o.transform = d;
      const { x: h, y: f } = this.projectionDelta;
      o.transformOrigin = `${h.origin * 100}% ${f.origin * 100}% 0`, c.animationValues ? o.opacity = c === this ? u.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : u.opacityExit : o.opacity = c === this ? u.opacity !== void 0 ? u.opacity : "" : u.opacityExit !== void 0 ? u.opacityExit : 0;
      for (const p in nh) {
        if (u[p] === void 0)
          continue;
        const { correct: v, applyTo: g, isCSSVariable: m } = nh[p], y = d === "none" ? u[p] : v(u[p], c);
        if (g) {
          const k = g.length;
          for (let _ = 0; _ < k; _++)
            o[g[_]] = y;
        } else
          m ? this.options.visualElement.renderState.vars[p] = y : o[p] = y;
      }
      this.options.layoutId && (o.pointerEvents = c === this ? Va(a?.pointerEvents) || "" : "none");
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0;
    }
    // Only run on root
    resetTree() {
      this.root.nodes.forEach((o) => o.currentAnimation?.stop()), this.root.nodes.forEach(e0), this.root.sharedNodes.clear();
    }
  };
}
function x6(t) {
  t.updateLayout();
}
function S6(t) {
  const e = t.resumeFrom?.snapshot || t.snapshot;
  if (t.isLead() && t.layout && e && t.hasListeners("didUpdate")) {
    const { layoutBox: n, measuredBox: i } = t.layout, { animationType: r } = t.options, s = e.source !== t.layout.source;
    if (r === "size")
      fi((u) => {
        const d = s ? e.measuredBox[u] : e.layoutBox[u], h = At(d);
        d.min = n[u].min, d.max = d.min + h;
      });
    else if (r === "x" || r === "y") {
      const u = r === "x" ? "y" : "x";
      rh(s ? e.measuredBox[u] : e.layoutBox[u], n[u]);
    } else Bx(r, e.layoutBox, n) && fi((u) => {
      const d = s ? e.measuredBox[u] : e.layoutBox[u], h = At(n[u]);
      d.max = d.min + h, t.relativeTarget && !t.currentAnimation && (t.isProjectionDirty = !0, t.relativeTarget[u].max = t.relativeTarget[u].min + h);
    });
    const o = Or();
    Ws(o, n, e.layoutBox);
    const a = Or();
    s ? Ws(a, t.applyTransform(i, !0), e.measuredBox) : Ws(a, n, e.layoutBox);
    const l = !Lx(o);
    let c = !1;
    if (!t.resumeFrom) {
      const u = t.getClosestProjectingParent();
      if (u && !u.resumeFrom) {
        const { snapshot: d, layout: h } = u;
        if (d && h) {
          const f = t.options.layoutAnchor || void 0, p = ct();
          El(p, e.layoutBox, d.layoutBox, f);
          const v = ct();
          El(v, n, h.layoutBox, f), Nx(p, v) || (c = !0), u.options.layoutRoot && (t.relativeTarget = v, t.relativeTargetOrigin = p, t.relativeParent = u);
        }
      }
    }
    t.notifyListeners("didUpdate", {
      layout: n,
      snapshot: e,
      delta: a,
      layoutDelta: o,
      hasLayoutChanged: l,
      hasRelativeLayoutChanged: c
    });
  } else if (t.isLead()) {
    const { onExitComplete: n } = t.options;
    n && n();
  }
  t.options.transition = void 0;
}
function P6(t) {
  t.parent && (t.isProjecting() || (t.isProjectionDirty = t.parent.isProjectionDirty), t.isSharedProjectionDirty || (t.isSharedProjectionDirty = !!(t.isProjectionDirty || t.parent.isProjectionDirty || t.parent.isSharedProjectionDirty)), t.isTransformDirty || (t.isTransformDirty = t.parent.isTransformDirty));
}
function E6(t) {
  t.isProjectionDirty = t.isSharedProjectionDirty = t.isTransformDirty = !1;
}
function T6(t) {
  t.clearSnapshot();
}
function e0(t) {
  t.clearMeasurements();
}
function C6(t) {
  t.isLayoutDirty = !0, t.updateLayout();
}
function t0(t) {
  t.isLayoutDirty = !1;
}
function A6(t) {
  t.isAnimationBlocked && t.layout && !t.isLayoutDirty && (t.snapshot = t.layout, t.isLayoutDirty = !0);
}
function $6(t) {
  const { visualElement: e } = t.options;
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"), t.resetTransform();
}
function i0(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0, t.isProjectionDirty = !0;
}
function R6(t) {
  t.resolveTargetDelta();
}
function M6(t) {
  t.calcProjection();
}
function O6(t) {
  t.resetSkewAndRotation();
}
function I6(t) {
  t.removeLeadSnapshot();
}
function n0(t, e, n) {
  t.translate = Ue(e.translate, 0, n), t.scale = Ue(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function r0(t, e, n, i) {
  t.min = Ue(e.min, n.min, i), t.max = Ue(e.max, n.max, i);
}
function D6(t, e, n, i) {
  r0(t.x, e.x, n.x, i), r0(t.y, e.y, n.y, i);
}
function F6(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
const L6 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
}, s0 = (t) => typeof navigator < "u" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(t), o0 = s0("applewebkit/") && !s0("chrome/") ? Math.round : Yt;
function a0(t) {
  t.min = o0(t.min), t.max = o0(t.max);
}
function N6(t) {
  a0(t.x), a0(t.y);
}
function Bx(t, e, n) {
  return t === "position" || t === "preserve-aspect" && !s6(Yv(e), Yv(n), 0.2);
}
function V6(t) {
  return t !== t.root && t.scroll?.wasRoot;
}
const j6 = zx({
  attachResizeListener: (t, e) => ho(t, "resize", e),
  measureScroll: () => ({
    x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
    y: document.documentElement.scrollTop || document.body?.scrollTop || 0
  }),
  checkIsScrollRoot: () => !0
}), mu = {
  current: void 0
}, Hx = zx({
  measureScroll: (t) => ({
    x: t.scrollLeft,
    y: t.scrollTop
  }),
  defaultParent: () => {
    if (!mu.current) {
      const t = new j6({});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), mu.current = t;
    }
    return mu.current;
  },
  resetTransform: (t, e) => {
    t.style.transform = e !== void 0 ? e : "none";
  },
  checkIsScrollRoot: (t) => window.getComputedStyle(t).position === "fixed"
}), Ux = Le({
  transformPagePoint: (t) => t,
  isStatic: !1,
  reducedMotion: "never"
});
function z6(t = !0) {
  const e = we(yf);
  if (e === null)
    return [!0, null];
  const { isPresent: n, onExitComplete: i, register: r } = e, s = E0();
  ye(() => {
    if (t)
      return r(s);
  }, [t]);
  const o = pt(() => t && i && i(s), [s, i, t]);
  return !n && i ? [!1, o] : [!0];
}
const Wx = Le({ strict: !1 }), l0 = {
  animation: [
    "animate",
    "variants",
    "whileHover",
    "whileTap",
    "exit",
    "whileInView",
    "whileFocus",
    "whileDrag"
  ],
  exit: ["exit"],
  drag: ["drag", "dragControls"],
  focus: ["whileFocus"],
  hover: ["whileHover", "onHoverStart", "onHoverEnd"],
  tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
  pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
  inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
  layout: ["layout", "layoutId"]
};
let c0 = !1;
function B6() {
  if (c0)
    return;
  const t = {};
  for (const e in l0)
    t[e] = {
      isEnabled: (n) => l0[e].some((i) => !!n[i])
    };
  wx(t), c0 = !0;
}
function qx() {
  return B6(), RN();
}
function H6(t) {
  const e = qx();
  for (const n in t)
    e[n] = {
      ...e[n],
      ...t[n]
    };
  wx(e);
}
const U6 = /* @__PURE__ */ new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "propagate",
  "ignoreStrict",
  "viewport"
]);
function Tl(t) {
  return t.startsWith("while") || t.startsWith("drag") && t !== "draggable" || t.startsWith("layout") || t.startsWith("onTap") || t.startsWith("onPan") || t.startsWith("onLayout") || U6.has(t);
}
let Gx = (t) => !Tl(t);
function W6(t) {
  typeof t == "function" && (Gx = (e) => e.startsWith("on") ? !Tl(e) : t(e));
}
try {
  W6(require("@emotion/is-prop-valid").default);
} catch {
}
function q6(t, e, n) {
  const i = {};
  for (const r in t)
    r === "values" && typeof t.values == "object" || yt(t[r]) || (Gx(r) || n === !0 && Tl(r) || !e && !Tl(r) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && r.startsWith("onDrag")) && (i[r] = t[r]);
  return i;
}
const rc = /* @__PURE__ */ Le({});
function G6(t, e) {
  if (nc(t)) {
    const { initial: n, animate: i } = t;
    return {
      initial: n === !1 || uo(n) ? n : void 0,
      animate: uo(i) ? i : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function K6(t) {
  const { initial: e, animate: n } = G6(t, we(rc));
  return Gt(() => ({ initial: e, animate: n }), [u0(e), u0(n)]);
}
function u0(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
const Hf = () => ({
  style: {},
  transform: {},
  transformOrigin: {},
  vars: {}
});
function Kx(t, e, n) {
  for (const i in e)
    !yt(e[i]) && !Cx(i, n) && (t[i] = e[i]);
}
function Y6({ transformTemplate: t }, e) {
  return Gt(() => {
    const n = Hf();
    return zf(n, e, t), Object.assign({}, n.vars, n.style);
  }, [e]);
}
function X6(t, e) {
  const n = t.style || {}, i = {};
  return Kx(i, n, t), Object.assign(i, Y6(t, e)), i;
}
function J6(t, e) {
  const n = {}, i = X6(t, e);
  return t.drag && t.dragListener !== !1 && (n.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = t.drag === !0 ? "none" : `pan-${t.drag === "x" ? "y" : "x"}`), t.tabIndex === void 0 && (t.onTap || t.onTapStart || t.whileTap) && (n.tabIndex = 0), n.style = i, n;
}
const Yx = () => ({
  ...Hf(),
  attrs: {}
});
function Z6(t, e, n, i) {
  const r = Gt(() => {
    const s = Yx();
    return Ax(s, e, Rx(i), t.transformTemplate, t.style), {
      ...s.attrs,
      style: { ...s.style }
    };
  }, [e]);
  if (t.style) {
    const s = {};
    Kx(s, t.style, t), r.style = { ...s, ...r.style };
  }
  return r;
}
const Q6 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view"
];
function Uf(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(Q6.indexOf(t) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/u.test(t))
    )
  );
}
function e7(t, e, n, { latestValues: i }, r, s = !1, o) {
  const l = (o ?? Uf(t) ? Z6 : J6)(e, i, r, t), c = q6(e, typeof t == "string", s), u = t !== nr ? { ...c, ...l, ref: n } : {}, { children: d } = e, h = Gt(() => yt(d) ? d.get() : d, [d]);
  return ku(t, {
    ...u,
    children: h
  });
}
function t7({ scrapeMotionValuesFromProps: t, createRenderState: e }, n, i, r) {
  return {
    latestValues: i7(n, i, r, t),
    renderState: e()
  };
}
function i7(t, e, n, i) {
  const r = {}, s = i(t, {});
  for (const h in s)
    r[h] = Va(s[h]);
  let { initial: o, animate: a } = t;
  const l = nc(t), c = bx(t);
  e && c && !l && t.inherit !== !1 && (o === void 0 && (o = e.initial), a === void 0 && (a = e.animate));
  let u = n ? n.initial === !1 : !1;
  u = u || o === !1;
  const d = u ? a : o;
  if (d && typeof d != "boolean" && !ic(d)) {
    const h = Array.isArray(d) ? d : [d];
    for (let f = 0; f < h.length; f++) {
      const p = Of(t, h[f]);
      if (p) {
        const { transitionEnd: v, transition: g, ...m } = p;
        for (const y in m) {
          let k = m[y];
          if (Array.isArray(k)) {
            const _ = u ? k.length - 1 : 0;
            k = k[_];
          }
          k !== null && (r[y] = k);
        }
        for (const y in v)
          r[y] = v[y];
      }
    }
  }
  return r;
}
const Xx = (t) => (e, n) => {
  const i = we(rc), r = we(yf), s = () => t7(t, e, i, r);
  return n ? s() : eF(s);
}, n7 = /* @__PURE__ */ Xx({
  scrapeMotionValuesFromProps: Bf,
  createRenderState: Hf
}), r7 = /* @__PURE__ */ Xx({
  scrapeMotionValuesFromProps: Mx,
  createRenderState: Yx
}), s7 = /* @__PURE__ */ Symbol.for("motionComponentSymbol");
function o7(t, e, n) {
  const i = Se(n);
  T0(() => {
    i.current = n;
  });
  const r = Se(null);
  return pt((s) => {
    s && t.onMount?.(s), e && (s ? e.mount(s) : e.unmount());
    const o = i.current;
    if (typeof o == "function")
      if (s) {
        const a = o(s);
        typeof a == "function" && (r.current = a);
      } else r.current ? (r.current(), r.current = null) : o(s);
    else o && (o.current = s);
  }, [e]);
}
const Jx = Le({});
function yr(t) {
  return t && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function a7(t, e, n, i, r, s) {
  const { visualElement: o } = we(rc), a = we(Wx), l = we(yf), c = we(Ux), u = c.reducedMotion, d = c.skipAnimations, h = Se(null), f = Se(!1);
  i = i || a.renderer, !h.current && i && (h.current = i(t, {
    visualState: e,
    parent: o,
    props: n,
    presenceContext: l,
    blockInitialAnimation: l ? l.initial === !1 : !1,
    reducedMotionConfig: u,
    skipAnimations: d,
    isSVG: s
  }), f.current && h.current && (h.current.manuallyAnimateOnMount = !0));
  const p = h.current, v = we(Jx);
  p && !p.projection && r && (p.type === "html" || p.type === "svg") && l7(h.current, n, r, v);
  const g = Se(!1);
  T0(() => {
    p && g.current && p.update(n, l);
  });
  const m = n[ax], y = Se(!!m && typeof window < "u" && !window.MotionHandoffIsComplete?.(m) && window.MotionHasOptimisedAnimation?.(m));
  return iF(() => {
    f.current = !0, p && (g.current = !0, window.MotionIsMounted = !0, p.updateFeatures(), p.scheduleRenderMicrotask(), y.current && p.animationState && p.animationState.animateChanges());
  }), ye(() => {
    p && (!y.current && p.animationState && p.animationState.animateChanges(), y.current && (queueMicrotask(() => {
      window.MotionHandoffMarkAsComplete?.(m);
    }), y.current = !1), p.enteringChildren = void 0);
  }), p;
}
function l7(t, e, n, i) {
  const { layoutId: r, layout: s, drag: o, dragConstraints: a, layoutScroll: l, layoutRoot: c, layoutAnchor: u, layoutCrossfade: d } = e;
  t.projection = new n(t.latestValues, e["data-framer-portal-id"] ? void 0 : Zx(t.parent)), t.projection.setOptions({
    layoutId: r,
    layout: s,
    alwaysMeasureLayout: !!o || a && yr(a),
    visualElement: t,
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: i,
    crossfade: d,
    layoutScroll: l,
    layoutRoot: c,
    layoutAnchor: u
  });
}
function Zx(t) {
  if (t)
    return t.options.allowProjection !== !1 ? t.projection : Zx(t.parent);
}
function gu(t, { forwardMotionProps: e = !1, type: n } = {}, i, r) {
  i && H6(i);
  const s = n ? n === "svg" : Uf(t), o = s ? r7 : n7;
  function a(c, u) {
    let d;
    const h = {
      ...we(Ux),
      ...c,
      layoutId: c7(c)
    }, { isStatic: f } = h, p = K6(c), v = o(c, f);
    if (!f && typeof window < "u") {
      u7(h, i);
      const g = d7(h);
      d = g.MeasureLayout, p.visualElement = a7(t, v, h, r, g.ProjectionNode, s);
    }
    return Z(rc.Provider, { value: p, children: [d && p.visualElement ? b(d, { visualElement: p.visualElement, ...h }) : null, e7(t, c, o7(v, p.visualElement, u), v, f, e, s)] });
  }
  a.displayName = `motion.${typeof t == "string" ? t : `create(${t.displayName ?? t.name ?? ""})`}`;
  const l = se(a);
  return l[s7] = t, l;
}
function c7({ layoutId: t }) {
  const e = we(bk).id;
  return e && t !== void 0 ? e + "-" + t : t;
}
function u7(t, e) {
  const n = we(Wx).strict;
  if (process.env.NODE_ENV !== "production" && e && n) {
    const i = "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.";
    t.ignoreStrict ? ls(!1, i, "lazy-strict-mode") : Si(!1, i, "lazy-strict-mode");
  }
}
function d7(t) {
  const e = qx(), { drag: n, layout: i } = e;
  if (!n && !i)
    return {};
  const r = { ...n, ...i };
  return {
    MeasureLayout: n?.isEnabled(t) || i?.isEnabled(t) ? r.MeasureLayout : void 0,
    ProjectionNode: r.ProjectionNode
  };
}
function h7(t, e) {
  if (typeof Proxy > "u")
    return gu;
  const n = /* @__PURE__ */ new Map(), i = (s, o) => gu(s, o, t, e), r = (s, o) => (process.env.NODE_ENV !== "production" && wf(!1, "motion() is deprecated. Use motion.create() instead."), i(s, o));
  return new Proxy(r, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: (s, o) => o === "create" ? i : (n.has(o) || n.set(o, gu(o, void 0, t, e)), n.get(o))
  });
}
const f7 = (t, e) => e.isSVG ?? Uf(t) ? new KN(e) : new BN(e, {
  allowProjection: t !== nr
});
class p7 extends Pn {
  /**
   * We dynamically generate the AnimationState manager as it contains a reference
   * to the underlying animation library. We only want to load that if we load this,
   * so people can optionally code split it out using the `m` component.
   */
  constructor(e) {
    super(e), e.animationState || (e.animationState = QN(e));
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps();
    ic(e) && (this.unmountControls = e.subscribe(this.node));
  }
  /**
   * Subscribe any provided AnimationControls to the component's VisualElement
   */
  mount() {
    this.updateAnimationControlsSubscription();
  }
  update() {
    const { animate: e } = this.node.getProps(), { animate: n } = this.node.prevProps || {};
    e !== n && this.updateAnimationControlsSubscription();
  }
  unmount() {
    this.node.animationState.reset(), this.unmountControls?.();
  }
}
let m7 = 0;
class g7 extends Pn {
  constructor() {
    super(...arguments), this.id = m7++, this.isExitComplete = !1;
  }
  update() {
    if (!this.node.presenceContext)
      return;
    const { isPresent: e, onExitComplete: n } = this.node.presenceContext, { isPresent: i } = this.node.prevPresenceContext || {};
    if (!this.node.animationState || e === i)
      return;
    if (e && i === !1) {
      if (this.isExitComplete) {
        const { initial: s, custom: o } = this.node.getProps();
        if (typeof s == "string" || typeof s == "object" && s !== null && !Array.isArray(s)) {
          const a = Jn(this.node, s, o);
          if (a) {
            const { transition: l, transitionEnd: c, ...u } = a;
            for (const d in u)
              this.node.getValue(d)?.jump(u[d]);
          }
        }
        this.node.animationState.reset(), this.node.animationState.animateChanges();
      } else
        this.node.animationState.setActive("exit", !1);
      this.isExitComplete = !1;
      return;
    }
    const r = this.node.animationState.setActive("exit", !e);
    n && !e && r.then(() => {
      this.isExitComplete = !0, n(this.id);
    });
  }
  mount() {
    const { register: e, onExitComplete: n } = this.node.presenceContext || {};
    n && n(this.id), e && (this.unmount = e(this.id));
  }
  unmount() {
  }
}
const v7 = {
  animation: {
    Feature: p7
  },
  exit: {
    Feature: g7
  }
};
function Mo(t) {
  return {
    point: {
      x: t.pageX,
      y: t.pageY
    }
  };
}
const y7 = (t) => (e) => Lf(e) && t(e, Mo(e));
function qs(t, e, n, i) {
  return ho(t, e, y7(n), i);
}
const Qx = ({ current: t }) => t ? t.ownerDocument.defaultView : null, d0 = (t, e) => Math.abs(t - e);
function b7(t, e) {
  const n = d0(t.x, e.x), i = d0(t.y, e.y);
  return Math.sqrt(n ** 2 + i ** 2);
}
const h0 = /* @__PURE__ */ new Set(["auto", "scroll"]);
class eS {
  constructor(e, n, { transformPagePoint: i, contextWindow: r = window, dragSnapToOrigin: s = !1, distanceThreshold: o = 3, element: a } = {}) {
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.lastRawMoveEventInfo = null, this.handlers = {}, this.contextWindow = window, this.scrollPositions = /* @__PURE__ */ new Map(), this.removeScrollListeners = null, this.onElementScroll = (p) => {
      this.handleScroll(p.target);
    }, this.onWindowScroll = () => {
      this.handleScroll(window);
    }, this.updatePoint = () => {
      if (!(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      this.lastRawMoveEventInfo && (this.lastMoveEventInfo = ha(this.lastRawMoveEventInfo, this.transformPagePoint));
      const p = vu(this.lastMoveEventInfo, this.history), v = this.startEvent !== null, g = b7(p.offset, { x: 0, y: 0 }) >= this.distanceThreshold;
      if (!v && !g)
        return;
      const { point: m } = p, { timestamp: y } = gt;
      this.history.push({ ...m, timestamp: y });
      const { onStart: k, onMove: _ } = this.handlers;
      v || (k && k(this.lastMoveEvent, p), this.startEvent = this.lastMoveEvent), _ && _(this.lastMoveEvent, p);
    }, this.handlePointerMove = (p, v) => {
      this.lastMoveEvent = p, this.lastRawMoveEventInfo = v, this.lastMoveEventInfo = ha(v, this.transformPagePoint), We.update(this.updatePoint, !0);
    }, this.handlePointerUp = (p, v) => {
      this.end();
      const { onEnd: g, onSessionEnd: m, resumeAnimation: y } = this.handlers;
      if ((this.dragSnapToOrigin || !this.startEvent) && y && y(), !(this.lastMoveEvent && this.lastMoveEventInfo))
        return;
      const k = vu(p.type === "pointercancel" ? this.lastMoveEventInfo : ha(v, this.transformPagePoint), this.history);
      this.startEvent && g && g(p, k), m && m(p, k);
    }, !Lf(e))
      return;
    this.dragSnapToOrigin = s, this.handlers = n, this.transformPagePoint = i, this.distanceThreshold = o, this.contextWindow = r || window;
    const l = Mo(e), c = ha(l, this.transformPagePoint), { point: u } = c, { timestamp: d } = gt;
    this.history = [{ ...u, timestamp: d }];
    const { onSessionStart: h } = n;
    h && h(e, vu(c, this.history));
    const f = { passive: !0, capture: !0 };
    this.removeListeners = Ao(qs(this.contextWindow, "pointermove", this.handlePointerMove, f), qs(this.contextWindow, "pointerup", this.handlePointerUp, f), qs(this.contextWindow, "pointercancel", this.handlePointerUp, f)), a && this.startScrollTracking(a);
  }
  /**
   * Start tracking scroll on ancestors and window.
   */
  startScrollTracking(e) {
    let n = e.parentElement;
    for (; n; ) {
      const i = getComputedStyle(n);
      (h0.has(i.overflowX) || h0.has(i.overflowY)) && this.scrollPositions.set(n, {
        x: n.scrollLeft,
        y: n.scrollTop
      }), n = n.parentElement;
    }
    this.scrollPositions.set(window, {
      x: window.scrollX,
      y: window.scrollY
    }), window.addEventListener("scroll", this.onElementScroll, {
      capture: !0
    }), window.addEventListener("scroll", this.onWindowScroll), this.removeScrollListeners = () => {
      window.removeEventListener("scroll", this.onElementScroll, {
        capture: !0
      }), window.removeEventListener("scroll", this.onWindowScroll);
    };
  }
  /**
   * Handle scroll compensation during drag.
   *
   * For element scroll: adjusts history origin since pageX/pageY doesn't change.
   * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
   */
  handleScroll(e) {
    const n = this.scrollPositions.get(e);
    if (!n)
      return;
    const i = e === window, r = i ? { x: window.scrollX, y: window.scrollY } : {
      x: e.scrollLeft,
      y: e.scrollTop
    }, s = { x: r.x - n.x, y: r.y - n.y };
    s.x === 0 && s.y === 0 || (i ? this.lastMoveEventInfo && (this.lastMoveEventInfo.point.x += s.x, this.lastMoveEventInfo.point.y += s.y) : this.history.length > 0 && (this.history[0].x -= s.x, this.history[0].y -= s.y), this.scrollPositions.set(e, r), We.update(this.updatePoint, !0));
  }
  updateHandlers(e) {
    this.handlers = e;
  }
  end() {
    this.removeListeners && this.removeListeners(), this.removeScrollListeners && this.removeScrollListeners(), this.scrollPositions.clear(), yn(this.updatePoint);
  }
}
function ha(t, e) {
  return e ? { point: e(t.point) } : t;
}
function f0(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function vu({ point: t }, e) {
  return {
    point: t,
    delta: f0(t, tS(e)),
    offset: f0(t, _7(e)),
    velocity: w7(e, 0.1)
  };
}
function _7(t) {
  return t[0];
}
function tS(t) {
  return t[t.length - 1];
}
function w7(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  let n = t.length - 1, i = null;
  const r = tS(t);
  for (; n >= 0 && (i = t[n], !(r.timestamp - i.timestamp > /* @__PURE__ */ Ft(e))); )
    n--;
  if (!i)
    return { x: 0, y: 0 };
  i === t[0] && t.length > 2 && r.timestamp - i.timestamp > /* @__PURE__ */ Ft(e) * 2 && (i = t[1]);
  const s = /* @__PURE__ */ qt(r.timestamp - i.timestamp);
  if (s === 0)
    return { x: 0, y: 0 };
  const o = {
    x: (r.x - i.x) / s,
    y: (r.y - i.y) / s
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function k7(t, { min: e, max: n }, i) {
  return e !== void 0 && t < e ? t = i ? Ue(e, t, i.min) : Math.max(t, e) : n !== void 0 && t > n && (t = i ? Ue(n, t, i.max) : Math.min(t, n)), t;
}
function p0(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function x7(t, { top: e, left: n, bottom: i, right: r }) {
  return {
    x: p0(t.x, n, r),
    y: p0(t.y, e, i)
  };
}
function m0(t, e) {
  let n = e.min - t.min, i = e.max - t.max;
  return e.max - e.min < t.max - t.min && ([n, i] = [i, n]), { min: n, max: i };
}
function S7(t, e) {
  return {
    x: m0(t.x, e.x),
    y: m0(t.y, e.y)
  };
}
function P7(t, e) {
  let n = 0.5;
  const i = At(t), r = At(e);
  return r > i ? n = /* @__PURE__ */ lo(e.min, e.max - i, t.min) : i > r && (n = /* @__PURE__ */ lo(t.min, t.max - r, e.min)), xi(0, 1, n);
}
function E7(t, e) {
  const n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
const sh = 0.35;
function T7(t = sh) {
  return t === !1 ? t = 0 : t === !0 && (t = sh), {
    x: g0(t, "left", "right"),
    y: g0(t, "top", "bottom")
  };
}
function g0(t, e, n) {
  return {
    min: v0(t, e),
    max: v0(t, n)
  };
}
function v0(t, e) {
  return typeof t == "number" ? t : t[e] || 0;
}
const C7 = /* @__PURE__ */ new WeakMap();
class A7 {
  constructor(e) {
    this.openDragLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = ct(), this.latestPointerEvent = null, this.latestPanInfo = null, this.visualElement = e;
  }
  start(e, { snapToCursor: n = !1, distanceThreshold: i } = {}) {
    const { presenceContext: r } = this.visualElement;
    if (r && r.isPresent === !1)
      return;
    const s = (d) => {
      n && this.snapToCursor(Mo(d).point), this.stopAnimation();
    }, o = (d, h) => {
      const { drag: f, dragPropagation: p, onDragStart: v } = this.getProps();
      if (f && !p && (this.openDragLock && this.openDragLock(), this.openDragLock = aN(f), !this.openDragLock))
        return;
      this.latestPointerEvent = d, this.latestPanInfo = h, this.isDragging = !0, this.currentDirection = null, this.resolveConstraints(), this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !0, this.visualElement.projection.target = void 0), fi((m) => {
        let y = this.getAxisMotionValue(m).get() || 0;
        if (_i.test(y)) {
          const { projection: k } = this.visualElement;
          if (k && k.layout) {
            const _ = k.layout.layoutBox[m];
            _ && (y = At(_) * (parseFloat(y) / 100));
          }
        }
        this.originPoint[m] = y;
      }), v && We.update(() => v(d, h), !1, !0), Yd(this.visualElement, "transform");
      const { animationState: g } = this.visualElement;
      g && g.setActive("whileDrag", !0);
    }, a = (d, h) => {
      this.latestPointerEvent = d, this.latestPanInfo = h;
      const { dragPropagation: f, dragDirectionLock: p, onDirectionLock: v, onDrag: g } = this.getProps();
      if (!f && !this.openDragLock)
        return;
      const { offset: m } = h;
      if (p && this.currentDirection === null) {
        this.currentDirection = R7(m), this.currentDirection !== null && v && v(this.currentDirection);
        return;
      }
      this.updateAxis("x", h.point, m), this.updateAxis("y", h.point, m), this.visualElement.render(), g && We.update(() => g(d, h), !1, !0);
    }, l = (d, h) => {
      this.latestPointerEvent = d, this.latestPanInfo = h, this.stop(d, h), this.latestPointerEvent = null, this.latestPanInfo = null;
    }, c = () => {
      const { dragSnapToOrigin: d } = this.getProps();
      (d || this.constraints) && this.startAnimation({ x: 0, y: 0 });
    }, { dragSnapToOrigin: u } = this.getProps();
    this.panSession = new eS(e, {
      onSessionStart: s,
      onStart: o,
      onMove: a,
      onSessionEnd: l,
      resumeAnimation: c
    }, {
      transformPagePoint: this.visualElement.getTransformPagePoint(),
      dragSnapToOrigin: u,
      distanceThreshold: i,
      contextWindow: Qx(this.visualElement),
      element: this.visualElement.current
    });
  }
  /**
   * @internal
   */
  stop(e, n) {
    const i = e || this.latestPointerEvent, r = n || this.latestPanInfo, s = this.isDragging;
    if (this.cancel(), !s || !r || !i)
      return;
    const { velocity: o } = r;
    this.startAnimation(o);
    const { onDragEnd: a } = this.getProps();
    a && We.postRender(() => a(i, r));
  }
  /**
   * @internal
   */
  cancel() {
    this.isDragging = !1;
    const { projection: e, animationState: n } = this.visualElement;
    e && (e.isAnimationBlocked = !1), this.endPanSession();
    const { dragPropagation: i } = this.getProps();
    !i && this.openDragLock && (this.openDragLock(), this.openDragLock = null), n && n.setActive("whileDrag", !1);
  }
  /**
   * Clean up the pan session without modifying other drag state.
   * This is used during unmount to ensure event listeners are removed
   * without affecting projection animations or drag locks.
   * @internal
   */
  endPanSession() {
    this.panSession && this.panSession.end(), this.panSession = void 0;
  }
  updateAxis(e, n, i) {
    const { drag: r } = this.getProps();
    if (!i || !fa(e, r, this.currentDirection))
      return;
    const s = this.getAxisMotionValue(e);
    let o = this.originPoint[e] + i[e];
    this.constraints && this.constraints[e] && (o = k7(o, this.constraints[e], this.elastic[e])), s.set(o);
  }
  resolveConstraints() {
    const { dragConstraints: e, dragElastic: n } = this.getProps(), i = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(!1) : this.visualElement.projection?.layout, r = this.constraints;
    e && yr(e) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : e && i ? this.constraints = x7(i.layoutBox, e) : this.constraints = !1, this.elastic = T7(n), r !== this.constraints && !yr(e) && i && this.constraints && !this.hasMutatedConstraints && fi((s) => {
      this.constraints !== !1 && this.getAxisMotionValue(s) && (this.constraints[s] = E7(i.layoutBox[s], this.constraints[s]));
    });
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: n } = this.getProps();
    if (!e || !yr(e))
      return !1;
    const i = e.current;
    Si(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
    const { projection: r } = this.visualElement;
    if (!r || !r.layout)
      return !1;
    r.root && (r.root.scroll = void 0, r.root.updateScroll());
    const s = FN(i, r.root, this.visualElement.getTransformPagePoint());
    let o = S7(r.layout.layoutBox, s);
    if (n) {
      const a = n(ON(o));
      this.hasMutatedConstraints = !!a, a && (o = xx(a));
    }
    return o;
  }
  startAnimation(e) {
    const { drag: n, dragMomentum: i, dragElastic: r, dragTransition: s, dragSnapToOrigin: o, onDragTransitionEnd: a } = this.getProps(), l = this.constraints || {}, c = fi((u) => {
      if (!fa(u, n, this.currentDirection))
        return;
      let d = l && l[u] || {};
      (o === !0 || o === u) && (d = { min: 0, max: 0 });
      const h = r ? 200 : 1e6, f = r ? 40 : 1e7, p = {
        type: "inertia",
        velocity: i ? e[u] : 0,
        bounceStiffness: h,
        bounceDamping: f,
        timeConstant: 750,
        restDelta: 1,
        restSpeed: 10,
        ...s,
        ...d
      };
      return this.startAxisValueAnimation(u, p);
    });
    return Promise.all(c).then(a);
  }
  startAxisValueAnimation(e, n) {
    const i = this.getAxisMotionValue(e);
    return Yd(this.visualElement, e), i.start(Mf(e, i, 0, n, this.visualElement, !1));
  }
  stopAnimation() {
    fi((e) => this.getAxisMotionValue(e).stop());
  }
  /**
   * Drag works differently depending on which props are provided.
   *
   * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
   * - Otherwise, we apply the delta to the x/y motion values.
   */
  getAxisMotionValue(e) {
    const n = `_drag${e.toUpperCase()}`, r = this.visualElement.getProps()[n];
    return r || this.visualElement.getValue(e, this.visualElement.latestValues[e] ?? 0);
  }
  snapToCursor(e) {
    fi((n) => {
      const { drag: i } = this.getProps();
      if (!fa(n, i, this.currentDirection))
        return;
      const { projection: r } = this.visualElement, s = this.getAxisMotionValue(n);
      if (r && r.layout) {
        const { min: o, max: a } = r.layout.layoutBox[n], l = s.get() || 0;
        s.set(e[n] - Ue(o, a, 0.5) + l);
      }
    });
  }
  /**
   * When the viewport resizes we want to check if the measured constraints
   * have changed and, if so, reposition the element within those new constraints
   * relative to where it was before the resize.
   */
  scalePositionWithinConstraints() {
    if (!this.visualElement.current)
      return;
    const { drag: e, dragConstraints: n } = this.getProps(), { projection: i } = this.visualElement;
    if (!yr(n) || !i || !this.constraints)
      return;
    this.stopAnimation();
    const r = { x: 0, y: 0 };
    fi((o) => {
      const a = this.getAxisMotionValue(o);
      if (a && this.constraints !== !1) {
        const l = a.get();
        r[o] = P7({ min: l, max: l }, this.constraints[o]);
      }
    });
    const { transformTemplate: s } = this.visualElement.getProps();
    this.visualElement.current.style.transform = s ? s({}, "") : "none", i.root && i.root.updateScroll(), i.updateLayout(), this.constraints = !1, this.resolveConstraints(), fi((o) => {
      if (!fa(o, e, null))
        return;
      const a = this.getAxisMotionValue(o), { min: l, max: c } = this.constraints[o];
      a.set(Ue(l, c, r[o]));
    }), this.visualElement.render();
  }
  addListeners() {
    if (!this.visualElement.current)
      return;
    C7.set(this.visualElement, this);
    const e = this.visualElement.current, n = qs(e, "pointerdown", (c) => {
      const { drag: u, dragListener: d = !0 } = this.getProps(), h = c.target, f = h !== e && fN(h);
      u && d && !f && this.start(c);
    });
    let i;
    const r = () => {
      const { dragConstraints: c } = this.getProps();
      yr(c) && c.current && (this.constraints = this.resolveRefConstraints(), i || (i = $7(e, c.current, () => this.scalePositionWithinConstraints())));
    }, { projection: s } = this.visualElement, o = s.addEventListener("measure", r);
    s && !s.layout && (s.root && s.root.updateScroll(), s.updateLayout()), We.read(r);
    const a = ho(window, "resize", () => this.scalePositionWithinConstraints()), l = s.addEventListener("didUpdate", (({ delta: c, hasLayoutChanged: u }) => {
      this.isDragging && u && (fi((d) => {
        const h = this.getAxisMotionValue(d);
        h && (this.originPoint[d] += c[d].translate, h.set(h.get() + c[d].translate));
      }), this.visualElement.render());
    }));
    return () => {
      a(), n(), o(), l && l(), i && i();
    };
  }
  getProps() {
    const e = this.visualElement.getProps(), { drag: n = !1, dragDirectionLock: i = !1, dragPropagation: r = !1, dragConstraints: s = !1, dragElastic: o = sh, dragMomentum: a = !0 } = e;
    return {
      ...e,
      drag: n,
      dragDirectionLock: i,
      dragPropagation: r,
      dragConstraints: s,
      dragElastic: o,
      dragMomentum: a
    };
  }
}
function y0(t) {
  let e = !0;
  return () => {
    if (e) {
      e = !1;
      return;
    }
    t();
  };
}
function $7(t, e, n) {
  const i = Tv(t, y0(n)), r = Tv(e, y0(n));
  return () => {
    i(), r();
  };
}
function fa(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function R7(t, e = 10) {
  let n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
class M7 extends Pn {
  constructor(e) {
    super(e), this.removeGroupControls = Yt, this.removeListeners = Yt, this.controls = new A7(e);
  }
  mount() {
    const { dragControls: e } = this.node.getProps();
    e && (this.removeGroupControls = e.subscribe(this.controls)), this.removeListeners = this.controls.addListeners() || Yt;
  }
  update() {
    const { dragControls: e } = this.node.getProps(), { dragControls: n } = this.node.prevProps || {};
    e !== n && (this.removeGroupControls(), e && (this.removeGroupControls = e.subscribe(this.controls)));
  }
  unmount() {
    this.removeGroupControls(), this.removeListeners(), this.controls.isDragging || this.controls.endPanSession();
  }
}
const yu = (t) => (e, n) => {
  t && We.update(() => t(e, n), !1, !0);
};
class O7 extends Pn {
  constructor() {
    super(...arguments), this.removePointerDownListener = Yt;
  }
  onPointerDown(e) {
    this.session = new eS(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: Qx(this.node)
    });
  }
  createPanHandlers() {
    const { onPanSessionStart: e, onPanStart: n, onPan: i, onPanEnd: r } = this.node.getProps();
    return {
      onSessionStart: yu(e),
      onStart: yu(n),
      onMove: yu(i),
      onEnd: (s, o) => {
        delete this.session, r && We.postRender(() => r(s, o));
      }
    };
  }
  mount() {
    this.removePointerDownListener = qs(this.node.current, "pointerdown", (e) => this.onPointerDown(e));
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers());
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end();
  }
}
let bu = !1;
class I7 extends mS {
  /**
   * This only mounts projection nodes for components that
   * need measuring, we might want to do it for all components
   * in order to incorporate transforms
   */
  componentDidMount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: i, layoutId: r } = this.props, { projection: s } = e;
    s && (n.group && n.group.add(s), i && i.register && r && i.register(s), bu && s.root.didUpdate(), s.addEventListener("animationComplete", () => {
      this.safeToRemove();
    }), s.setOptions({
      ...s.options,
      layoutDependency: this.props.layoutDependency,
      onExitComplete: () => this.safeToRemove()
    })), ja.hasEverUpdated = !0;
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: n, visualElement: i, drag: r, isPresent: s } = this.props, { projection: o } = i;
    return o && (o.isPresent = s, e.layoutDependency !== n && o.setOptions({
      ...o.options,
      layoutDependency: n
    }), bu = !0, r || e.layoutDependency !== n || n === void 0 || e.isPresent !== s ? o.willUpdate() : this.safeToRemove(), e.isPresent !== s && (s ? o.promote() : o.relegate() || We.postRender(() => {
      const a = o.getStack();
      (!a || !a.members.length) && this.safeToRemove();
    }))), null;
  }
  componentDidUpdate() {
    const { visualElement: e, layoutAnchor: n } = this.props, { projection: i } = e;
    i && (i.options.layoutAnchor = n, i.root.didUpdate(), Ff.postRender(() => {
      !i.currentAnimation && i.isLead() && this.safeToRemove();
    }));
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: n, switchLayoutGroup: i } = this.props, { projection: r } = e;
    bu = !0, r && (r.scheduleCheckAfterUnmount(), n && n.group && n.group.remove(r), i && i.deregister && i.deregister(r));
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props;
    e && e();
  }
  render() {
    return null;
  }
}
function iS(t) {
  const [e, n] = z6(), i = we(bk);
  return b(I7, { ...t, layoutGroup: i, switchLayoutGroup: we(Jx), isPresent: e, safeToRemove: n });
}
const D7 = {
  pan: {
    Feature: O7
  },
  drag: {
    Feature: M7,
    ProjectionNode: Hx,
    MeasureLayout: iS
  }
};
function b0(t, e, n) {
  const { props: i } = t;
  t.animationState && i.whileHover && t.animationState.setActive("whileHover", n === "Start");
  const r = "onHover" + n, s = i[r];
  s && We.postRender(() => s(e, Mo(e)));
}
class F7 extends Pn {
  mount() {
    const { current: e } = this.node;
    e && (this.unmount = cN(e, (n, i) => (b0(this.node, i, "Start"), (r) => b0(this.node, r, "End"))));
  }
  unmount() {
  }
}
class L7 extends Pn {
  constructor() {
    super(...arguments), this.isActive = !1;
  }
  onFocus() {
    let e = !1;
    try {
      e = this.node.current.matches(":focus-visible");
    } catch {
      e = !0;
    }
    !e || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !0), this.isActive = !0);
  }
  onBlur() {
    !this.isActive || !this.node.animationState || (this.node.animationState.setActive("whileFocus", !1), this.isActive = !1);
  }
  mount() {
    this.unmount = Ao(ho(this.node.current, "focus", () => this.onFocus()), ho(this.node.current, "blur", () => this.onBlur()));
  }
  unmount() {
  }
}
function _0(t, e, n) {
  const { props: i } = t;
  if (t.current instanceof HTMLButtonElement && t.current.disabled)
    return;
  t.animationState && i.whileTap && t.animationState.setActive("whileTap", n === "Start");
  const r = "onTap" + (n === "End" ? "" : n), s = i[r];
  s && We.postRender(() => s(e, Mo(e)));
}
class N7 extends Pn {
  mount() {
    const { current: e } = this.node;
    if (!e)
      return;
    const { globalTapTarget: n, propagate: i } = this.node.props;
    this.unmount = mN(e, (r, s) => (_0(this.node, s, "Start"), (o, { success: a }) => _0(this.node, o, a ? "End" : "Cancel")), {
      useGlobalTarget: n,
      stopPropagation: i?.tap === !1
    });
  }
  unmount() {
  }
}
const oh = /* @__PURE__ */ new WeakMap(), _u = /* @__PURE__ */ new WeakMap(), V7 = (t) => {
  const e = oh.get(t.target);
  e && e(t);
}, j7 = (t) => {
  t.forEach(V7);
};
function z7({ root: t, ...e }) {
  const n = t || document;
  _u.has(n) || _u.set(n, {});
  const i = _u.get(n), r = JSON.stringify(e);
  return i[r] || (i[r] = new IntersectionObserver(j7, { root: t, ...e })), i[r];
}
function B7(t, e, n) {
  const i = z7(e);
  return oh.set(t, n), i.observe(t), () => {
    oh.delete(t), i.unobserve(t);
  };
}
const H7 = {
  some: 0,
  all: 1
};
class U7 extends Pn {
  constructor() {
    super(...arguments), this.hasEnteredView = !1, this.isInView = !1;
  }
  startObserver() {
    this.stopObserver?.();
    const { viewport: e = {} } = this.node.getProps(), { root: n, margin: i, amount: r = "some", once: s } = e, o = {
      root: n ? n.current : void 0,
      rootMargin: i,
      threshold: typeof r == "number" ? r : H7[r]
    }, a = (l) => {
      const { isIntersecting: c } = l;
      if (this.isInView === c || (this.isInView = c, s && !c && this.hasEnteredView))
        return;
      c && (this.hasEnteredView = !0), this.node.animationState && this.node.animationState.setActive("whileInView", c);
      const { onViewportEnter: u, onViewportLeave: d } = this.node.getProps(), h = c ? u : d;
      h && h(l);
    };
    this.stopObserver = B7(this.node.current, o, a);
  }
  mount() {
    this.startObserver();
  }
  update() {
    if (typeof IntersectionObserver > "u")
      return;
    const { props: e, prevProps: n } = this.node;
    ["amount", "margin", "root"].some(W7(e, n)) && this.startObserver();
  }
  unmount() {
    this.stopObserver?.(), this.hasEnteredView = !1, this.isInView = !1;
  }
}
function W7({ viewport: t = {} }, { viewport: e = {} } = {}) {
  return (n) => t[n] !== e[n];
}
const q7 = {
  inView: {
    Feature: U7
  },
  tap: {
    Feature: N7
  },
  focus: {
    Feature: L7
  },
  hover: {
    Feature: F7
  }
}, G7 = {
  layout: {
    ProjectionNode: Hx,
    MeasureLayout: iS
  }
}, K7 = {
  ...v7,
  ...q7,
  ...D7,
  ...G7
}, Y7 = /* @__PURE__ */ h7(K7, f7), nS = Y7, wu = {
  JIGGLE: {
    rotate: [0, 6, -6, 6, -6, 0]
  },
  BOUNCE: {
    y: [0, -10, 0, -10, 0]
  },
  ROTATE: {
    rotate: [0, 360]
  },
  VIBRATE: {
    x: [0, -1, 1, -1, 1, -1, 1, -1, 1, -1, 1, -1, 1, -1, 1, -1, 1, 0]
  },
  SHAKE: {
    x: [0, 8, -10, 10, -10, 10, -10, 10, -8, 8, 0]
  }
}, X7 = "4rem";
function J7({
  cta: t,
  paused: e,
  controlsVisible: n
}) {
  const { position: i, width: r, animation: s } = t.config, o = i.calculatedTop > 50, a = t.imageUrl ? $s.imageCTAShow : $s.buttonCTAShow, l = t.imageUrl ? $s.imageCTAClick : $s.buttonCTAClick;
  ye(() => {
    Ui(a, { cta_id: t.id, cta_href: t.href });
  }, [t.id]);
  function c() {
    Ui(l, { cta_id: t.id, cta_href: t.href });
  }
  const u = s?.name, d = s && wu[u];
  s && u && !d && console.warn(
    `Animation "${s.name}" not found for CTA with id ${t.id}`
  );
  const h = e || !d ? "none" : {
    ...wu[u],
    transition: {
      [Object.keys(wu[u])[0]]: {
        repeat: 1 / 0,
        duration: parseInt(s.duration),
        ease: "easeOut",
        repeatDelay: s.cycleTime,
        type: "keyframes"
      }
    }
  }, f = t.imageUrl ? /* @__PURE__ */ b(
    T1,
    {
      imageUrl: t.imageUrl,
      alt: t.imageAlt,
      href: t.href,
      onClick: c,
      imgClassName: "w-full block rounded-md"
    }
  ) : t.buttonText ? /* @__PURE__ */ b(
    C1,
    {
      text: t.buttonText,
      background: t.buttonBackground,
      border: t.buttonBorder,
      href: t.href,
      onClick: c
    }
  ) : null, p = o && n ? `calc(${i.calculatedTop}% - ${X7})` : `${i.calculatedTop}%`;
  return /* @__PURE__ */ b(bn, { children: /* @__PURE__ */ b(
    "div",
    {
      style: {
        position: "absolute",
        left: `${i.calculatedLeft}%`,
        top: p,
        width: r,
        zIndex: 15,
        transition: o ? "top 300ms" : void 0,
        transform: `translateX(calc(-1% * ${i.calculatedLeft})) translateY(calc(-1% * ${i.calculatedTop}))`
      },
      children: /* @__PURE__ */ b(nS.div, { animate: h, children: f })
    }
  ) });
}
function Z7({
  ctaTimestamps: t
}) {
  const e = tt.usePlayer((u) => u.currentTime), n = tt.usePlayer((u) => u.paused), i = tt.usePlayer(Ei), r = tt.usePlayer((u) => u.isFullscreen), [s, o] = ue(!1), a = (i?.controlsVisible ?? !0) && !r;
  ye(() => {
    n || o(!0);
  }, [n]);
  const l = e * 1e3, c = s ? t.flatMap((u) => l < u.startTimestamp || l > u.endTimestamp ? [] : u.ctas) : [];
  return c.length === 0 ? null : /* @__PURE__ */ b(bn, { children: c.map((u) => /* @__PURE__ */ b(
    J7,
    {
      cta: u,
      paused: n,
      controlsVisible: a
    },
    u.id
  )) });
}
function w0(t) {
  const e = t.closest(".media-skin");
  return e ? e.querySelector(
    '.media-slider-track[data-orientation="horizontal"]'
  ) : null;
}
function Q7({
  moments: t,
  hasTitle: e = !1
}) {
  const n = tt.usePlayer((d) => d.duration), i = tt.usePlayer((d) => d.currentTime), r = tt.usePlayer(Ei), s = Se(null), o = r?.controlsVisible ?? !0, a = (n ?? 0) * 1e3, l = (i ?? 0) * 1e3, c = a > 0 ? t.find(
    (d) => l >= d.startTimestamp && l <= d.endTimestamp
  ) : void 0;
  return ye(() => {
    const d = s.current;
    if (!d || !a || t.length === 0) return;
    const h = w0(d);
    if (h)
      return h.querySelectorAll("[data-moment-marker]").forEach((f) => f.remove()), t.forEach((f) => {
        const p = f.startTimestamp / a * 100, v = (f.endTimestamp - f.startTimestamp) / a * 100, g = document.createElement("div");
        g.setAttribute("data-moment-marker", f.id), g.title = f.title, g.style.cssText = `
        position: absolute;
        top: 0;
        bottom: 0;
        left: ${p}%;
        width: ${v}%;
        background: rgba(255,255,255,0.35);
        pointer-events: none;
        z-index: 2;
      `, h.appendChild(g);
      }), () => {
        h.querySelectorAll("[data-moment-marker]").forEach((f) => f.remove());
      };
  }, [a, t]), ye(() => {
    const d = s.current;
    if (!d || !a) return;
    const h = w0(d);
    h && t.forEach((f) => {
      const p = h.querySelector(
        `[data-moment-marker="${f.id}"]`
      );
      p && (p.style.background = f === c ? "rgba(255,255,255,0.75)" : "rgba(255,255,255,0.35)");
    });
  }, [c, a, t]), /* @__PURE__ */ b(
    "div",
    {
      ref: s,
      style: { position: "absolute", inset: 0, pointerEvents: "none" },
      children: c && /* @__PURE__ */ b(
        "div",
        {
          style: {
            position: "absolute",
            top: e ? "2.75rem" : "0.75rem",
            left: "0.75rem",
            zIndex: 10,
            transition: "opacity 300ms",
            opacity: o ? 1 : 0,
            background: "rgba(0,0,0,0.6)",
            color: "white",
            fontSize: "0.6875rem",
            fontWeight: 600,
            padding: "2px 8px",
            borderRadius: "0.375rem",
            whiteSpace: "nowrap",
            maxWidth: "70%",
            overflow: "hidden",
            textOverflow: "ellipsis"
          },
          children: c.title
        }
      )
    }
  );
}
const Br = 120, ah = 10, k0 = 3 * (Br + ah);
function e8() {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      "aria-hidden": "true",
      children: /* @__PURE__ */ b("path", { d: "M10.354 3.646a.5.5 0 0 1 0 .708L6.707 8l3.647 3.646a.5.5 0 0 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 0 1 .708 0z" })
    }
  );
}
function t8() {
  return /* @__PURE__ */ b(
    "svg",
    {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      "aria-hidden": "true",
      children: /* @__PURE__ */ b("path", { d: "M5.646 3.646a.5.5 0 0 0 0 .708L9.293 8 5.646 11.646a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708 0z" })
    }
  );
}
function i8({
  moment: t,
  isActive: e,
  onClick: n
}) {
  return /* @__PURE__ */ Z(
    nS.button,
    {
      onClick: n,
      whileHover: { scale: 1.04, filter: "brightness(1.12)" },
      transition: { duration: 0.15, ease: "easeOut" },
      style: {
        flex: `0 0 ${Br}px`,
        width: Br,
        background: "none",
        border: "none",
        padding: 0,
        cursor: "pointer",
        textAlign: "left",
        fontFamily: "inherit",
        borderRadius: "6px",
        // White outline on active card; transparent outline reserves the space so
        // cards don't shift when they become active.
        outline: `2px solid ${e ? "color-mix(in srgb, currentColor 85%, transparent)" : "transparent"}`,
        outlineOffset: "2px"
      },
      "aria-label": `Jump to ${t.title} at ${Qp(t.startTimestamp)}`,
      "aria-current": e ? "true" : void 0,
      children: [
        /* @__PURE__ */ Z(
          "div",
          {
            style: {
              width: "100%",
              aspectRatio: "16 / 9",
              borderRadius: "4px",
              overflow: "hidden",
              background: "color-mix(in srgb, currentColor 10%, transparent)",
              position: "relative"
            },
            children: [
              t.thumbnailUrl ? /* @__PURE__ */ b(
                "img",
                {
                  src: t.thumbnailUrl,
                  alt: "",
                  style: {
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block"
                  }
                }
              ) : (
                // Gradient placeholder when no thumbnail is available
                /* @__PURE__ */ b(
                  "div",
                  {
                    style: {
                      width: "100%",
                      height: "100%",
                      background: "linear-gradient(135deg, color-mix(in srgb, currentColor 10%, transparent) 0%, color-mix(in srgb, currentColor 16%, transparent) 50%, color-mix(in srgb, currentColor 8%, transparent) 100%)"
                    }
                  }
                )
              ),
              /* @__PURE__ */ b(
                "div",
                {
                  style: {
                    position: "absolute",
                    bottom: "4px",
                    left: "4px",
                    background: "rgba(0,0,0,0.75)",
                    color: "rgba(255,255,255,0.9)",
                    fontSize: "10px",
                    fontVariantNumeric: "tabular-nums",
                    padding: "1px 4px",
                    borderRadius: "3px",
                    lineHeight: "1.4",
                    pointerEvents: "none"
                  },
                  children: Qp(t.startTimestamp)
                }
              ),
              e && /* @__PURE__ */ b(
                "div",
                {
                  style: {
                    position: "absolute",
                    inset: 0,
                    background: "color-mix(in srgb, currentColor 8%, transparent)",
                    borderRadius: "inherit",
                    pointerEvents: "none"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ b(
          "div",
          {
            style: {
              marginTop: "5px",
              fontSize: "11.5px",
              fontWeight: e ? 600 : 400,
              color: e ? "currentColor" : "color-mix(in srgb, currentColor 65%, transparent)",
              lineHeight: 1.35,
              // Fixed height for exactly 2 lines so all cards stay the same height
              // regardless of whether the title wraps. 11.5px × 1.35 × 2 ≈ 31px.
              height: "31px",
              display: "-webkit-box",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
              overflow: "hidden",
              transition: "color 0.2s, font-weight 0.2s"
            },
            children: t.title
          }
        )
      ]
    }
  );
}
function x0({
  moments: t,
  onMomentSelect: e
}) {
  const n = Po(), i = tt.usePlayer((y) => y.currentTime), r = Se(null), [s, o] = ue(!1);
  ye(() => {
    r.current && o(OM(r.current) < 0.5);
  }, []);
  const a = (i ?? 0) * 1e3, l = Se(null), [c, u] = ue(!1), [d, h] = ue(!1), f = t.find(
    (y) => a >= y.startTimestamp && a <= y.endTimestamp
  ), p = pt(() => {
    const y = l.current;
    y && (u(y.scrollLeft > 2), h(y.scrollLeft + y.clientWidth < y.scrollWidth - 2));
  }, []);
  ye(() => {
    const y = l.current;
    if (!y) return;
    p(), y.addEventListener("scroll", p, { passive: !0 });
    const k = new ResizeObserver(p);
    return k.observe(y), () => {
      y.removeEventListener("scroll", p), k.disconnect();
    };
  }, [p, t]), ye(() => {
    if (!f || !l.current) return;
    const y = t.indexOf(f);
    if (y === -1) return;
    const k = l.current, _ = y * (Br + ah), w = _ + Br;
    if (_ < k.scrollLeft || w > k.scrollLeft + k.clientWidth) {
      const E = _ - k.clientWidth / 2 + Br / 2;
      k.scrollTo({ left: Math.max(0, E), behavior: "smooth" });
    }
  }, [f, t]);
  function v(y) {
    l.current?.scrollBy({
      left: y === "right" ? k0 : -k0,
      behavior: "smooth"
    });
  }
  function g(y) {
    n && (n.currentTime = y.startTimestamp / 1e3, n.paused && n.play(), e?.(y));
  }
  const m = (y) => ({
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    background: "color-mix(in srgb, currentColor 12%, transparent)",
    border: "1px solid color-mix(in srgb, currentColor 10%, transparent)",
    color: "inherit",
    cursor: "pointer",
    opacity: y ? 1 : 0,
    pointerEvents: y ? "auto" : "none",
    transition: "opacity 0.2s, background 0.15s",
    backdropFilter: "blur(4px)",
    flexShrink: 0
  });
  return /* @__PURE__ */ Z(
    "div",
    {
      ref: r,
      style: {
        fontFamily: "Inter Variable, Inter, ui-sans-serif, system-ui, sans-serif",
        color: s ? "#f0f0f0" : "#111827"
      },
      children: [
        /* @__PURE__ */ b("style", { children: `
        [data-moments-scroll]::-webkit-scrollbar { display: none; }
      ` }),
        /* @__PURE__ */ Z(
          "div",
          {
            style: {
              position: "relative",
              display: "flex",
              alignItems: "center",
              padding: "20px 0"
            },
            children: [
              /* @__PURE__ */ b(
                "button",
                {
                  onClick: () => v("left"),
                  "aria-label": "Scroll moments left",
                  style: { ...m(c), left: "4px" },
                  children: /* @__PURE__ */ b(e8, {})
                }
              ),
              /* @__PURE__ */ b(
                "div",
                {
                  ref: l,
                  "data-moments-scroll": "",
                  style: {
                    display: "flex",
                    gap: `${ah}px`,
                    overflowX: "auto",
                    scrollbarWidth: "none",
                    flex: 1,
                    // Horizontal padding reserves space so arrows don't overlap cards
                    padding: "10px 40px"
                  },
                  children: t.map((y) => /* @__PURE__ */ b(
                    i8,
                    {
                      moment: y,
                      isActive: y === f,
                      onClick: () => g(y)
                    },
                    y.id
                  ))
                }
              ),
              /* @__PURE__ */ b(
                "button",
                {
                  onClick: () => v("right"),
                  "aria-label": "Scroll moments right",
                  style: { ...m(d), right: "4px" },
                  children: /* @__PURE__ */ b(t8, {})
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function n8(t) {
  const e = tt.usePlayer((v) => v.currentTime), n = Po(), [i, r] = ue(!1), [s, o] = ue(!1), [a, l] = ue(!1), c = Se(!1), u = t.endTimestamp / 1e3, d = e > 0 && e >= u, h = s && d && !a;
  return ye(() => {
    h && !c.current && (n?.pause(), c.current = !0), d || (o(!0), c.current = !1, r(!1));
  }, [h, d, n]), { visible: h && !i, watchAgain: () => {
    n && (r(!0), n.currentTime = t.startTimestamp / 1e3, n.play(), Ui(fn.watchAgain, {
      moment_id: t.id,
      action: "watch_again"
    }));
  }, resumeVideo: () => {
    l(!0), n?.play(), Ui(fn.watchFullVideo, {
      moment_id: t.id,
      action: "resume_video"
    });
  } };
}
function S0({
  onWatchAgain: t,
  onResumeVideo: e
}) {
  return /* @__PURE__ */ Z("div", { className: "flex gap-3 mt-3", children: [
    /* @__PURE__ */ b(
      "button",
      {
        onClick: t,
        className: "px-5 py-2 text-sm font-semibold bg-white text-black rounded hover:opacity-90 transition-opacity",
        children: "Watch Again"
      }
    ),
    /* @__PURE__ */ b(
      "button",
      {
        onClick: e,
        className: "px-5 py-2 text-sm font-semibold bg-white/10 text-white rounded hover:bg-white/20 transition-colors",
        children: "Resume Video"
      }
    )
  ] });
}
function r8({
  moment: t,
  endCard: e
}) {
  const { visible: n, watchAgain: i, resumeVideo: r } = n8(t);
  return ye(() => {
    n && Ui(fn.endCardShow, { moment_id: t.id });
  }, [n, t.id]), e ? /* @__PURE__ */ b(
    yk,
    {
      endCard: e,
      visible: n,
      onDismiss: r,
      footer: /* @__PURE__ */ b(
        S0,
        {
          onWatchAgain: i,
          onResumeVideo: r
        }
      )
    }
  ) : /* @__PURE__ */ Z(
    "div",
    {
      "data-testid": "moment-end-splash",
      style: {
        position: "absolute",
        inset: 0,
        zIndex: 20,
        transition: "opacity 500ms",
        opacity: n ? 1 : 0,
        pointerEvents: n ? "auto" : "none"
      },
      className: "flex flex-col items-center justify-center bg-black/80 backdrop-blur-sm",
      children: [
        /* @__PURE__ */ b("p", { className: "text-white font-semibold text-lg mb-1 text-center px-6", children: t.title }),
        /* @__PURE__ */ b("p", { className: "text-white/60 text-sm mb-6 text-center", children: "You've finished watching this moment." }),
        /* @__PURE__ */ b(S0, { onWatchAgain: i, onResumeVideo: r })
      ]
    }
  );
}
function s8(t, e, n) {
  const i = encodeURIComponent(e), r = encodeURIComponent(n);
  switch (t) {
    case "FACEBOOK":
      return `https://www.facebook.com/sharer/sharer.php?u=${i}`;
    case "TWITTER":
      return `https://twitter.com/intent/tweet?url=${i}&text=${r}`;
    case "LINKEDIN":
      return `https://www.linkedin.com/sharing/share-offsite/?url=${i}`;
    case "WHATSAPP":
      return `https://wa.me/?text=${r}%20${i}`;
    case "REDDIT":
      return `https://www.reddit.com/submit?url=${i}&title=${r}`;
    case "MAIL":
      return `mailto:?subject=${r}&body=${i}`;
    default:
      return e;
  }
}
function o8({ platform: t }) {
  switch (t) {
    case "FACEBOOK":
      return /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: "18", height: "18", children: /* @__PURE__ */ b("path", { d: "M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073C0 18.1 4.388 23.094 10.125 24v-8.437H7.078v-3.49h3.047V9.413c0-3.025 1.792-4.697 4.533-4.697 1.312 0 2.686.235 2.686.235v2.97h-1.513c-1.491 0-1.956.93-1.956 1.883v2.27h3.328l-.532 3.49h-2.796V24C19.612 23.094 24 18.1 24 12.073z" }) });
    case "TWITTER":
      return /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: "18", height: "18", children: /* @__PURE__ */ b("path", { d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" }) });
    case "LINKEDIN":
      return /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: "18", height: "18", children: /* @__PURE__ */ b("path", { d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" }) });
    case "WHATSAPP":
      return /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: "18", height: "18", children: /* @__PURE__ */ b("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 00-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" }) });
    case "REDDIT":
      return /* @__PURE__ */ b("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: "18", height: "18", children: /* @__PURE__ */ b("path", { d: "M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" }) });
    case "MAIL":
      return /* @__PURE__ */ Z(
        "svg",
        {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          width: "18",
          height: "18",
          children: [
            /* @__PURE__ */ b("rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }),
            /* @__PURE__ */ b("path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" })
          ]
        }
      );
    default:
      return /* @__PURE__ */ Z(
        "svg",
        {
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          strokeWidth: "2",
          width: "18",
          height: "18",
          children: [
            /* @__PURE__ */ b("circle", { cx: "18", cy: "5", r: "3" }),
            /* @__PURE__ */ b("circle", { cx: "6", cy: "12", r: "3" }),
            /* @__PURE__ */ b("circle", { cx: "18", cy: "19", r: "3" }),
            /* @__PURE__ */ b("line", { x1: "8.59", y1: "13.51", x2: "15.42", y2: "17.49" }),
            /* @__PURE__ */ b("line", { x1: "15.41", y1: "6.51", x2: "8.59", y2: "10.49" })
          ]
        }
      );
  }
}
const a8 = {
  FACEBOOK: "Facebook",
  TWITTER: "X (Twitter)",
  LINKEDIN: "LinkedIn",
  WHATSAPP: "WhatsApp",
  REDDIT: "Reddit",
  MAIL: "Email"
};
function l8({
  icons: t,
  title: e = ""
}) {
  const i = tt.usePlayer(Ei)?.controlsVisible ?? !0, r = t.filter((o) => o.visible);
  if (r.length === 0) return null;
  const s = typeof window < "u" ? window.location.href : "";
  return /* @__PURE__ */ b(
    "div",
    {
      style: {
        position: "absolute",
        top: "0.75rem",
        right: "0.75rem",
        zIndex: 10,
        transition: "opacity 300ms",
        opacity: i ? 1 : 0,
        pointerEvents: i ? "auto" : "none"
      },
      children: /* @__PURE__ */ Z(vc.Root, { side: "bottom", align: "end", children: [
        /* @__PURE__ */ b(
          vc.Trigger,
          {
            "aria-label": "Share",
            style: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "2rem",
              height: "2rem",
              borderRadius: "0.5rem",
              background: "rgba(0,0,0,0.6)",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "rgba(255,255,255,0.85)",
              cursor: "pointer",
              backdropFilter: "blur(4px)"
            },
            children: /* @__PURE__ */ Z(
              "svg",
              {
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "2",
                width: "16",
                height: "16",
                children: [
                  /* @__PURE__ */ b("circle", { cx: "18", cy: "5", r: "3" }),
                  /* @__PURE__ */ b("circle", { cx: "6", cy: "12", r: "3" }),
                  /* @__PURE__ */ b("circle", { cx: "18", cy: "19", r: "3" }),
                  /* @__PURE__ */ b("line", { x1: "8.59", y1: "13.51", x2: "15.42", y2: "17.49" }),
                  /* @__PURE__ */ b("line", { x1: "15.41", y1: "6.51", x2: "8.59", y2: "10.49" })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ b(
          vc.Popup,
          {
            style: {
              background: "rgba(15,23,42,0.95)",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "0.75rem",
              padding: "0.5rem",
              display: "flex",
              flexDirection: "column",
              gap: "0.125rem",
              minWidth: "10rem",
              backdropFilter: "blur(8px)",
              boxShadow: "0 8px 24px rgba(0,0,0,0.5)"
            },
            children: r.map(({ platformName: o }) => /* @__PURE__ */ Z(
              "a",
              {
                href: s8(o, s, e),
                target: o === "MAIL" ? void 0 : "_blank",
                rel: "noopener noreferrer",
                style: {
                  display: "flex",
                  alignItems: "center",
                  gap: "0.625rem",
                  padding: "0.5rem 0.625rem",
                  borderRadius: "0.5rem",
                  color: "rgba(255,255,255,0.85)",
                  textDecoration: "none",
                  fontSize: "0.8rem",
                  fontWeight: 500,
                  transition: "background 150ms"
                },
                onMouseEnter: (a) => a.currentTarget.style.background = "rgba(255,255,255,0.08)",
                onMouseLeave: (a) => a.currentTarget.style.background = "transparent",
                children: [
                  /* @__PURE__ */ b(o8, { platform: o }),
                  a8[o] ?? o
                ]
              },
              o
            ))
          }
        )
      ] })
    }
  );
}
function c8(t, e) {
  const n = XD(), i = tt.usePlayer((f) => f.paused), r = tt.usePlayer((f) => f.currentTime), s = tt.usePlayer((f) => f.duration), o = Se(!1), a = Se(0), l = Se(!1), c = Se(!1), u = Se(0), d = Se(null), h = {
    videoId: e ?? "",
    videoTitle: t ?? "",
    videoDuration: s
  };
  ye(() => {
    n && (i ? o.current && (d.current = null, n.track("videoPause", {
      ...h,
      videoCurrentTime: Math.round(r)
    })) : o.current ? n.track("video_play", h) : (o.current = !0, n.track("video_start", h)));
  }, [i]), ye(() => {
    if (!n || !s || !o.current) return;
    const f = r / s;
    if (r >= s && !l.current) {
      l.current = !0, n.track("videoComplete", h);
      return;
    }
    if (!i) {
      if (d.current !== null) {
        const g = r - d.current;
        g > 0 && g < 2 && (u.current += g);
      }
      d.current = r;
    }
    if (!c.current) {
      const g = s >= 30 ? 30 : s * 0.9;
      u.current >= g && (c.current = !0, n.track(gk.addView, h));
    }
    const v = [0.25, 0.5, 0.75];
    for (const g of v)
      f >= g && a.current < g && (a.current = g, n.track("videoProgress", {
        ...h,
        videoPercent: Math.round(g * 100)
      }));
  }, [r]);
}
const rS = new CSSStyleSheet();
rS.replaceSync(EM);
const sS = new CSSStyleSheet();
sS.replaceSync(TM);
function u8({ children: t }) {
  const e = Se(null), [n, i] = ue(null);
  return ye(() => {
    const r = e.current;
    if (!r || r.shadowRoot) return;
    const s = r.attachShadow({ mode: "open" });
    s.adoptedStyleSheets = [rS, sS], i(s);
  }, []), /* @__PURE__ */ b("div", { ref: e, children: n && C0(t, n) });
}
function d8({
  title: t,
  videoId: e
}) {
  return c8(t, e), null;
}
function h8({
  structuredData: t,
  moments: e
}) {
  return ye(() => {
    const n = { ...t };
    if (e && e.length > 0) {
      const r = typeof window < "u" ? window.location.href : "";
      n.hasPart = e.map((s) => {
        const o = IM(r, { _seeen_moment: s.id });
        return {
          "@type": "Clip",
          "@id": `${r.split("?")[0]}#moment-${s.id}`,
          name: s.title,
          startOffset: Math.round(s.startTimestamp / 1e3),
          endOffset: Math.round(s.endTimestamp / 1e3),
          url: o
        };
      });
    }
    const i = document.createElement("script");
    return i.type = "application/ld+json", i.dataset.ccVideo = "1", i.textContent = JSON.stringify(n), document.head.appendChild(i), () => {
      i.remove();
    };
  }, [t, e]), null;
}
function f8({ moment: t }) {
  const e = Po();
  return ye(() => {
    if (!e) return;
    function n() {
      e.currentTime = t.startTimestamp / 1e3, e.removeEventListener("play", n);
    }
    return e.addEventListener("play", n), () => e.removeEventListener("play", n);
  }, [e, t.startTimestamp]), null;
}
function p8({ startTime: t }) {
  const e = Po();
  return ye(() => {
    if (!e) return;
    function n() {
      e.currentTime = t, e.removeEventListener("play", n);
    }
    return e.addEventListener("play", n), () => e.removeEventListener("play", n);
  }, [e, t]), null;
}
function m8(t) {
  return { width: "100%", aspectRatio: t ? t.replace(":", "/") : "16/9" };
}
function w8({
  src: t,
  poster: e,
  title: n,
  thumbnailStoryboardUrl: i,
  captions: r,
  overlays: s = [],
  sponsor: o,
  ctaTimestamps: a,
  endCard: l,
  autoplay: c = !1,
  muted: u = !1,
  shareSocialMediaIcons: d,
  moments: h,
  momentsNavPosition: f = "above",
  activeMoment: p,
  activeMomentId: v,
  structuredData: g,
  gaMeasurementId: m,
  videoId: y,
  startTime: k,
  momentEndSplash: _ = !0,
  momentNavBehavior: w = "moment",
  aspectRatio: T
}) {
  YD(m);
  const [E, S] = ue(null);
  ye(() => S(null), [t]);
  const P = E?.moment ?? p ?? h?.find((M) => M.id === v), C = w === "moment" ? (M) => S((O) => ({ moment: M, count: (O?.count ?? 0) + 1 })) : void 0;
  return /* @__PURE__ */ Z(tt.Player, { children: [
    /* @__PURE__ */ Z(u8, { children: [
      h && h.length > 0 && f === "above" && /* @__PURE__ */ b(x0, { moments: h, onMomentSelect: C }),
      /* @__PURE__ */ b(PM, { style: m8(T), children: /* @__PURE__ */ Z(ub, { className: "relative bg-black overflow-hidden w-full h-full", children: [
        /* @__PURE__ */ Z(
          sR,
          {
            className: "w-full h-full",
            playsInline: !0,
            preload: "metadata",
            poster: e,
            src: t,
            autoPlay: c,
            muted: u,
            children: [
              i && /* @__PURE__ */ b(
                "track",
                {
                  kind: "metadata",
                  src: i,
                  label: "thumbnails",
                  default: !0
                }
              ),
              r?.map((M) => /* @__PURE__ */ b(
                "track",
                {
                  kind: "captions",
                  src: M.captionFileUrl,
                  srcLang: M.languageCode,
                  label: M.language
                },
                M.languageCode
              ))
            ]
          }
        ),
        n && /* @__PURE__ */ b(CM, { title: n }),
        d && d.length > 0 && /* @__PURE__ */ b(l8, { icons: d, title: n }),
        s.map((M, O) => /* @__PURE__ */ b(JM, { ...M }, O)),
        a && a.length > 0 && /* @__PURE__ */ b(Z7, { ctaTimestamps: a }),
        h && h.length > 0 && /* @__PURE__ */ b(Q7, { moments: h, hasTitle: !!n }),
        l && /* @__PURE__ */ b(rv, { endCard: l }),
        !l && o && /* @__PURE__ */ b(rv, { sponsor: o }),
        P && _ && /* @__PURE__ */ b(
          r8,
          {
            moment: P,
            endCard: P.endCard ?? l
          },
          `${P.id}-${E?.count ?? 0}`
        ),
        P && /* @__PURE__ */ b(f8, { moment: P }),
        !P && k != null && /* @__PURE__ */ b(p8, { startTime: k }),
        /* @__PURE__ */ b(d8, { title: n, videoId: y })
      ] }) }),
      h && h.length > 0 && f === "below" && /* @__PURE__ */ b(x0, { moments: h, onMomentSelect: C })
    ] }),
    g && /* @__PURE__ */ b(
      h8,
      {
        structuredData: g,
        moments: h
      }
    )
  ] });
}
export {
  w8 as VideoPlayer
};
